
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("dHrmQ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => (parcelRequire("jIoqN")).VersionDetailSpa);
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports

var $jIoqN = parcelRequire("jIoqN");

});
parcelRegister("jIoqN", function(module, exports) {
$parcel$export(module.exports, "VersionDetailSpa", () => $ee3b828a2ff935f9$export$4232c14770c47725);

var $eJOHy = parcelRequire("eJOHy");

var $6T1wD = parcelRequire("6T1wD");

var $gFB4g = parcelRequire("gFB4g");

var $5vQ2T = parcelRequire("5vQ2T");

var $lRq8t = parcelRequire("lRq8t");

var $2aY2d = parcelRequire("2aY2d");

var $9FYIg = parcelRequire("9FYIg");

var $e8qID = parcelRequire("e8qID");

var $jaCSo = parcelRequire("jaCSo");

var $1HCHH = parcelRequire("1HCHH");

var $cZTMg = parcelRequire("cZTMg");

var $aV23b = parcelRequire("aV23b");

var $gCY1z = parcelRequire("gCY1z");

var $gXdnw = parcelRequire("gXdnw");

var $ggyTU = parcelRequire("ggyTU");
const $ee3b828a2ff935f9$export$4232c14770c47725 = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [{ match: match }] = (0, $gCY1z.useRouter)();
    const projectKey = match.params.projectKey ?? '';
    const { data: projectContext } = (0, $2aY2d.useProjectContext)();
    const onExperienceFail = (0, $jaCSo.useViewVersionDetailsPageExperienceFail)();
    const { queryReference: queryReference } = (0, $9FYIg.useRelayResource)((0, $e8qID.versionDetailsRelayResourceCustom));
    const releasesHomeUrl = `/projects/${projectKey}?selectedItem=com.atlassian.jira.jira-projects-plugin%3Arelease-page`;
    // Note: "the no Software license" case is handled by a redirect within `VersionDetailPage`
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jaCSo.VersionDetailsPageExperienceStart), {
        experienceId: projectKey
    }), queryReference === null ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aV23b.AuthenticationCheck), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        id: "pageContent",
        packageName: "jiraSpaAppsSoftwareReleasesVersionDetails",
        teamName: "jolt",
        extraEventData: {
            isSimplifiedProject: projectContext?.simplified ?? false
        },
        onError: (location, error)=>{
            onExperienceFail(location, error, {
                isNetworkError: (0, $ggyTU.isNetworkError)(error)
            });
        },
        attributes: (error)=>({
                isNetworkError: (0, $ggyTU.isNetworkError)(error),
                isSimplifiedProject: projectContext?.simplified ?? false
            })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cZTMg.SubProductUpdater), {
        subProduct: "software"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gFB4g.default), {
        projectKey: projectKey,
        projectName: projectContext?.projectName ?? ''
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6T1wD.default), {
        breadcrumb: {
            text: formatMessage((0, $gXdnw.default).releases),
            href: releasesHomeUrl
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1HCHH.VersionDetail), {
        queryReference: queryReference
    }))))));
};

});
parcelRegister("jaCSo", function(module, exports) {
$parcel$export(module.exports, "VersionDetailsPageExperienceStart", () => $8a400b776a5edce7$export$87a9bc4e7a50039a);
$parcel$export(module.exports, "useViewVersionDetailsPageExperienceFail", () => $8a400b776a5edce7$export$f9fb921f60393679);
$parcel$export(module.exports, "ViewVersionDetailsPageExpectedErrorExperienceSuccessTracker", () => $8a400b776a5edce7$export$c2bfafdc422ffc0a);

var $eJOHy = parcelRequire("eJOHy");

var $aqnJa = parcelRequire("aqnJa");

var $8Uqf3 = parcelRequire("8Uqf3");

var $4ctwv = parcelRequire("4ctwv");

var $lBYgs = parcelRequire("lBYgs");

var $1BZ8a = parcelRequire("1BZ8a");

var $kX3ON = parcelRequire("kX3ON");
const $8a400b776a5edce7$var$VIEW_VERSION_DETAILS_PAGE_EXPERIENCE_NAME = 'viewVersionDetailsPage';
const $8a400b776a5edce7$export$87a9bc4e7a50039a = ({ experienceId: experienceId })=>{
    const appEditions = (0, $1BZ8a.useAppEditions)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8Uqf3.ExperienceStart), {
        experienceId: experienceId,
        experience: $8a400b776a5edce7$var$VIEW_VERSION_DETAILS_PAGE_EXPERIENCE_NAME,
        analyticsSource: "versionDetails",
        edition: appEditions.software,
        application: (0, $lBYgs.JIRA_SOFTWARE)
    });
};
const $8a400b776a5edce7$export$f9fb921f60393679 = ()=>(0, $aqnJa.useExperienceFail)({
        experience: $8a400b776a5edce7$var$VIEW_VERSION_DETAILS_PAGE_EXPERIENCE_NAME
    });
const $8a400b776a5edce7$export$1a84e8ad118354e4 = ()=>(0, $4ctwv.useExperienceSuccess)({
        experience: $8a400b776a5edce7$var$VIEW_VERSION_DETAILS_PAGE_EXPERIENCE_NAME
    });
const $8a400b776a5edce7$export$c2bfafdc422ffc0a = ({ reason: reason })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4ctwv.ExperienceSuccess), {
        experience: $8a400b776a5edce7$var$VIEW_VERSION_DETAILS_PAGE_EXPERIENCE_NAME,
        attributes: {
            reason: reason
        }
    });
const $8a400b776a5edce7$export$ab0e4c71ad46eacd = ()=>{
    const projectInfo = (0, $kX3ON.useProjectAnalyticsAttributes)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4ctwv.ExperienceSuccess), {
        experience: $8a400b776a5edce7$var$VIEW_VERSION_DETAILS_PAGE_EXPERIENCE_NAME,
        attributes: {
            ...projectInfo
        }
    });
};

});
parcelRegister("kX3ON", function(module, exports) {
$parcel$export(module.exports, "useProjectContextResource", () => $1e961ceb8ea652aa$export$a3138047c831fa4e);
$parcel$export(module.exports, "useProjectContext", () => $1e961ceb8ea652aa$export$8f31c2503e1efa93);
$parcel$export(module.exports, "useProjectAnalyticsAttributes", () => $1e961ceb8ea652aa$export$b6a91b2d78273787);

var $6UU7v = parcelRequire("6UU7v");

var $dZRaT = parcelRequire("dZRaT");

var $2QZBX = parcelRequire("2QZBX");

var $eJrcF = parcelRequire("eJrcF");
const $1e961ceb8ea652aa$export$a3138047c831fa4e = (0, $6UU7v.withSuspense)(()=>// eslint-disable-next-line jira/react/no-usage-of-hooks-outside-components
    (0, $eJrcF.useResource)((0, $dZRaT.projectContextResource)));
const $1e961ceb8ea652aa$export$8f31c2503e1efa93 = ()=>{
    const { data: data, error: error } = $1e961ceb8ea652aa$export$a3138047c831fa4e();
    if (data == null) throw new Error(`data of useProjectContext via withSuspense shouldn't be null. If projectContext is null, this means an invalid project key was provided and the page should return a 404 and useProjectContext should never be called. error: ${error !== null ? error.message : 'null'}`);
    return {
        ...data,
        projectKey: (0, $2QZBX.toProjectKey)(data.projectKey),
        projectId: (0, $2QZBX.toProjectId)(data.projectId.toString())
    };
};
const $1e961ceb8ea652aa$export$b6a91b2d78273787 = ()=>{
    const { projectId: projectId, isProjectAdmin: isProjectAdmin, simplified: simplified } = $1e961ceb8ea652aa$export$8f31c2503e1efa93();
    return {
        isSimplified: simplified,
        isProjectAdmin: isProjectAdmin,
        projectId: projectId
    };
};

});
parcelRegister("6UU7v", function(module, exports) {
$parcel$export(module.exports, "withSuspense", () => $d591853152e8b41d$export$a3bce93d4fb4eda6);
const $d591853152e8b41d$var$isDataEmpty = (data)=>data == null;
function $d591853152e8b41d$export$a3bce93d4fb4eda6(theHook) {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (...args)=>{
        const result = theHook(...args);
        if (!false && $d591853152e8b41d$var$isDataEmpty(result.data) && result.loading) throw result.promise;
        return result;
    };
}

});



parcelRegister("1HCHH", function(module, exports) {
$parcel$export(module.exports, "VersionDetail", () => $1851276e0cb058bd$export$7ef104a5ca9287b8);

var $c6Tby = parcelRequire("c6Tby");

var $kK0gQ = parcelRequire("kK0gQ");

var $HhgrR = parcelRequire("HhgrR");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $j4oe4 = parcelRequire("j4oe4");

var $j1zBC = parcelRequire("j1zBC");

var $7XH79 = parcelRequire("7XH79");

var $dMpy6 = parcelRequire("dMpy6");

var $9pTd3 = parcelRequire("9pTd3");

var $3nL89 = parcelRequire("3nL89");

var $lRq8t = parcelRequire("lRq8t");

var $2imLM = parcelRequire("2imLM");

var $8oKDI = parcelRequire("8oKDI");

var $fwzaq = parcelRequire("fwzaq");

var $kGj4V = parcelRequire("kGj4V");
var $eS29z = parcelRequire("eS29z");

var $jom8W = parcelRequire("jom8W");

var $isHDA = parcelRequire("isHDA");

var $jISVN = parcelRequire("jISVN");

var $9pemI = parcelRequire("9pemI");

var $6IAqy = parcelRequire("6IAqy");

var $i6OEF = parcelRequire("i6OEF");

var $u9Pim = parcelRequire("u9Pim");

var $VZ8eB = parcelRequire("VZ8eB");

var $cpzb3 = parcelRequire("cpzb3");

var $lmneG = parcelRequire("lmneG");

var $liDzu = parcelRequire("liDzu");

var $8tQys = parcelRequire("8tQys");

var $1dvMC = parcelRequire("1dvMC");

var $f4zNE = parcelRequire("f4zNE");

var $jRFpu = parcelRequire("jRFpu");

var $iT6q7 = parcelRequire("iT6q7");

var $cHtIB = parcelRequire("cHtIB");

var $7vBTU = parcelRequire("7vBTU");

var $jcg48 = parcelRequire("jcg48");

var $k5ghM = parcelRequire("k5ghM");

var $kfvK2 = parcelRequire("kfvK2");
var $2FqDG = parcelRequire("2FqDG");

var $2UzA9 = parcelRequire("2UzA9");

var $bwxkU = parcelRequire("bwxkU");

var $SWGaF = parcelRequire("SWGaF");

var $b70fx = parcelRequire("b70fx");

var $jCfjG = parcelRequire("jCfjG");

var $baLOk = parcelRequire("baLOk");

var $jaCSo = parcelRequire("jaCSo");

var $kX3ON = parcelRequire("kX3ON");

var $liQFv = parcelRequire("liQFv");

var $4lF62 = parcelRequire("4lF62");

var $jNw3G = parcelRequire("jNw3G");

var $94bM3 = parcelRequire("94bM3");

var $8Qifh = parcelRequire("8Qifh");

var $82maw = parcelRequire("82maw");
const $1851276e0cb058bd$var$getVersionIdState = (versionId)=>{
    const correctedVersionId = versionId.replace(/\D/g, ''); // non-numeric version id is invalid
    if (correctedVersionId.length === 0) return {
        state: 'INVALID'
    };
     // numeric version id that has been pruned of non-numeric characters
    if (correctedVersionId.length !== versionId.length) return {
        state: 'CORRECTED',
        correctedVersionId: correctedVersionId
    };
    return {
        state: 'VALID'
    };
};
const $1851276e0cb058bd$export$d5910e6123a77411 = ({ jiraVersion: jiraVersion, devOps: devOps, userProjectPermissions: userProjectPermissions })=>{
    const [state] = (0, $i6OEF.useSidebarStore)();
    const cloudId = (0, $cHtIB.useCloudId)();
    const [designQueryRef, loadDesignQuery] = (0, $j4oe4.useQueryLoader)((0, $bwxkU.default));
    const [relatedWorkQueryRef, loadRelatedWorkQuery] = (0, $j4oe4.useQueryLoader)((0, $SWGaF.default));
    const [versionProgressQueryRef, loadVersionProgressQuery] = (0, $j4oe4.useQueryLoader)((0, $2UzA9.default));
    const onViewRelatedWorkExperienceFail = (0, $1dvMC.useViewVersionRelatedWorkExperienceFail)();
    const onLaunchCardExperienceFail = (0, $VZ8eB.useLaunchCardExperienceFail)();
    const onVersionApproversCardExperienceFail = (0, $9pemI.useVersionApproversCardExperienceFail)();
    const onIssueAssociatedDesignsExperienceFail = (0, $7vBTU.useIssueAssociatedDesignsExperienceFail)();
    const { currentTabId: currentTabId } = (0, $baLOk.useCurrentTab)();
    const devOpsData = (0, $j4oe4.useFragment)((0, $HhgrR.default), devOps);
    const [version, refetch] = (0, $j4oe4.useRefetchableFragment)((0, $kK0gQ.default), jiraVersion);
    (0, $j1zBC.useVersionChangedNudge)({
        versionId: version.id,
        source: 'software-version-details'
    });
    const designProviderLength = (devOpsData?.providers?.designProviders ?? []).length; // Designs and its associated issues query is expensive, so we load it lazily not as a part of initial query.
    // Likewise with related work items (which the progress section also accesses).
    (0, $eJOHy.useEffect)(()=>{
        if (designProviderLength > 0 && designQueryRef == null) {
            loadDesignQuery({
                versionAri: version.id,
                cloudAri: (0, $8oKDI.createAri)({
                    resourceOwner: 'jira',
                    resourceType: 'site',
                    resourceId: cloudId
                })
            });
            loadRelatedWorkQuery({
                versionAri: version.id,
                isDevopsFeatureDisabledInFedRamp: (0, $jom8W.isDevopsFeatureDisabledInFedRamp)()
            });
            loadVersionProgressQuery({
                versionAri: version.id,
                isDevopsFeatureDisabledInFedRamp: (0, $jom8W.isDevopsFeatureDisabledInFedRamp)()
            });
        }
    }, [
        cloudId,
        designProviderLength,
        designQueryRef,
        loadDesignQuery,
        loadRelatedWorkQuery,
        loadVersionProgressQuery,
        version.id
    ]);
    const { filters: filters, sortBy: sortBy } = (0, $lmneG.useVersionIssuesGraphQLVariables)();
    const [suspenselessRefetch, isRefetchLoading] = (0, $7XH79.useSuspenselessRefetch)((0, $4lF62.default), refetch, {
        fetchPolicy: 'network-only'
    });
    const [debouncedRefetchVersion] = (0, $fwzaq.default)(()=>{
        suspenselessRefetch({
            id: version.id,
            isDevopsFeatureDisabledInFedRamp: (0, $jom8W.isDevopsFeatureDisabledInFedRamp)(),
            shouldIncludeDevOpsFieldsViaAgs: !(0, $jom8W.isDevopsFeatureDisabledInFedRamp)(),
            ...(0, $jCfjG.convertTabToQueryVariables)(currentTabId),
            filters: filters,
            sortBy: sortBy
        });
    }, 500); // From spa-routes, cannot import the original const due to cyclical imports
    const ROUTE_NAMES_SOFTWARE_VERSION_DETAIL_EMBED = 'software-version-detail-embed';
    const isEmbedRoute = (0, $kfvK2.useIsActiveRoute)(ROUTE_NAMES_SOFTWARE_VERSION_DETAIL_EMBED);
    const isIssueClosed = state.status === 'CLOSED';
    const isIssueSectionCollapsed = (version.collapsedUis ?? []).includes('ISSUES');
    const issueListFooterRef = (0, $eJOHy.useRef)(null);
    const [isIssueListFooterPinned, setIsIssueListFooterPinned] = (0, $eJOHy.useState)(false);
    const handleScroll = ()=>{
        const issueListFooter = issueListFooterRef.current;
        if (issueListFooter) {
            const footerRect = issueListFooter.getBoundingClientRect(); // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            setIsIssueListFooterPinned(footerRect.top + footerRect.height >= window.innerHeight);
        }
    };
    const issueListContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($1851276e0cb058bd$var$IssueListMinHeightContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $liDzu.IssueListWithHeaderWithErrorBoundary), {
        jiraVersion: version
    }), !isIssueSectionCollapsed && version?.canAddAndRemoveIssues && version?.allIssues?.totalCount ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $b70fx.NonCriticalErrorBoundary), {
        fallback: "flag",
        eventLocation: "addIssuesToVersion"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($1851276e0cb058bd$var$IssueListFooterContentWrapper, {
        isPinned: isIssueListFooterPinned,
        ref: issueListFooterRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jISVN.AddIssuesToVersion), {
        appearance: "subtle",
        isIssueListFooterButton: true,
        jiraVersion: version,
        showIcon: true
    }))) : null);
    const shouldRenderDesignSection = !(0, $jom8W.isDevopsFeatureDisabledInFedRamp)() && designProviderLength > 0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($1851276e0cb058bd$var$VersionDetailsWrapper, {
        isIssueClosed: isIssueClosed,
        onScroll: handleScroll
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8tQys.RefetchContext).Provider, {
        value: {
            isLoading: isRefetchLoading,
            refetch: debouncedRefetchVersion
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $VZ8eB.LaunchCardExperienceStart), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($1851276e0cb058bd$var$ContainerWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        className: (0, $hcewu.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1osq _1ul9gktf _19bv1tcg _u5f31tcg _1reo15vq _18m91wug"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $94bM3.Header), {
        jiraVersion: version,
        shouldShowBreadcrumbs: !isEmbedRoute,
        shouldShowAutomationButton: !isEmbedRoute,
        shouldShowFeedbackButton: !isEmbedRoute,
        shouldShowGraphButton: !isEmbedRoute
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $b70fx.NonCriticalErrorBoundary), {
        fallback: "flag",
        eventLocation: "richTextSection"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iT6q7.AsyncVersionRichTextSection), {
        jiraVersion: version
    })), !(0, $jom8W.isDevopsFeatureDisabledInFedRamp)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $b70fx.NonCriticalErrorBoundary), {
        fallback: "flag",
        eventLocation: "relatedWork",
        onError: onViewRelatedWorkExperienceFail
    }, relatedWorkQueryRef == null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jRFpu.RelatedWorkLoadingSkeleton), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "jira-releases-version-details-related-work",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jRFpu.RelatedWorkLoadingSkeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $f4zNE.RelatedWork), {
        queryRef: relatedWorkQueryRef
    }))), shouldRenderDesignSection && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $b70fx.NonCriticalErrorBoundary), {
        fallback: "flag",
        eventLocation: "issueAssociatedDesigns",
        onError: onIssueAssociatedDesignsExperienceFail
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7vBTU.IssueAssociatedDesignsExperienceStart), null), designQueryRef == null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jcg48.DesignSectionSkeleton), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "jira-releases-version-details-designs",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jcg48.DesignSectionSkeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jcg48.IssueAssociatedDesigns), {
        queryRef: designQueryRef
    }))), issueListContent), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $82maw.RightSidebar), {
        jiraVersion: version
    }, isIssueClosed && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $b70fx.NonCriticalErrorBoundary), {
        fallback: "flag",
        eventLocation: "launchCard",
        onError: onLaunchCardExperienceFail
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($1851276e0cb058bd$var$SidebarCard, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cpzb3.LaunchCard), {
        jiraVersion: version
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $b70fx.NonCriticalErrorBoundary), {
        fallback: "flag",
        eventLocation: "approversCard",
        onError: onVersionApproversCardExperienceFail
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9pemI.VersionApproversCardExperienceStart), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($1851276e0cb058bd$var$SidebarCard, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6IAqy.Approvers), {
        jiraVersion: version,
        userProjectPermissions: userProjectPermissions
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $b70fx.NonCriticalErrorBoundary), {
        fallback: "flag",
        eventLocation: "progressCard"
    }, versionProgressQueryRef != null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($1851276e0cb058bd$var$SidebarCard, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "jira-releases-version-details-progress-indicator",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k5ghM.VersionProgress), {
        queryRef: versionProgressQueryRef
    }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $b70fx.NonCriticalErrorBoundary), {
        fallback: "flag",
        eventLocation: "issueSidebar"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $u9Pim.IssueSidebar), null))))));
};
const $1851276e0cb058bd$export$7ef104a5ca9287b8 = ({ queryReference: queryReference })=>{
    const hasFiredErrorAnalytics = (0, $eJOHy.useRef)(false);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { data: projectContext } = (0, $kX3ON.useProjectContextResource)();
    const { jira: jira, devOps: devOps } = (0, $j4oe4.usePreloadedQuery)((0, $c6Tby.default), queryReference);
    const [versionId, setVersionId] = (0, $2FqDG.usePathParam)('versionId'); // replaces invalid non-numeric version ids from the url params.
    // the query data is still valid as the same regex is applied in the versionDetailsResource.
    // if the version id is invalid then fire off an error analytic.
    (0, $eJOHy.useEffect)(()=>{
        if (versionId != null) {
            const versionIdState = $1851276e0cb058bd$var$getVersionIdState(versionId);
            if (versionIdState.state === 'CORRECTED') setVersionId(versionIdState.correctedVersionId, 'replace');
            if (versionIdState.state === 'INVALID' && !hasFiredErrorAnalytics.current) {
                (0, $9pTd3.fireErrorAnalytics)({
                    meta: {
                        id: 'jira.releases.version.detail.invalid.version.id',
                        packageName: 'jiraSoftwareReleasesVersionDetail',
                        teamName: 'jolt'
                    },
                    error: Error(`Invalid version id in path param. Version id: ${String(versionId)}`),
                    sendToPrivacyUnsafeSplunk: true
                });
                hasFiredErrorAnalytics.current = true;
            }
        }
    }, [
        setVersionId,
        versionId
    ]); // missing project context means invalid project key in path param
    if (projectContext == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dMpy6.NotFoundErrorPageAsync), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jaCSo.ViewVersionDetailsPageExpectedErrorExperienceSuccessTracker), {
        reason: "No Project found"
    }));
     // missing jira value due to invalid non-digit version id in path param
    // causing relay to skip query to avoid invalid ari error in AGG
    if (!jira && versionId != null && $1851276e0cb058bd$var$getVersionIdState(versionId).state === 'INVALID') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dMpy6.NotFoundErrorPageAsync), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jaCSo.ViewVersionDetailsPageExpectedErrorExperienceSuccessTracker), {
        reason: "No Version found"
    }));
     // unknown error
    if (!jira) throw Error("Relay: Missing @required value at path 'jira' in 'uiVersionDetailsQuery'"); // mimics the Relay @required directive
    const { version: version } = jira;
    const userProjectPermissions = {
        hasEditIssuesPermission: jira.hasEditIssuesPermission ?? false,
        hasResolveIssuesPermission: jira.hasResolveIssuesPermission ?? false
    }; // received query error graphql type
    // e.g. permissions error or version not found error
    if (version.__typename !== 'JiraVersion') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dMpy6.NotFoundErrorPageAsync), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jaCSo.ViewVersionDetailsPageExpectedErrorExperienceSuccessTracker), {
        reason: "No Version found"
    }));
    const { simplified: simplified, isProjectAdmin: isProjectAdmin, projectId: projectId, projectKey: projectKey, projectName: projectName } = projectContext;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jNw3G.AccessCheck), {
        jiraVersion: version
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kGj4V.ContextualAnalyticsData), {
        attributes: {
            simplified: simplified,
            isProjectAdmin: isProjectAdmin,
            projectId: projectId,
            versionStatus: version.status
        },
        sourceType: (0, $aa42ce8e355d58fa$export$f636b5b56f1d624a),
        sourceName: "versionDetails"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eS29z.FireScreenAnalytics), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $liQFv.PerformanceTracker), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1dvMC.VersionRelatedWorkExperienceStart), {
        experienceId: projectKey
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $isHDA.ViewFeatureFlagsEmptyStateExperienceExperienceStart), {
        experienceId: projectKey
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($1851276e0cb058bd$export$d5910e6123a77411, {
        jiraVersion: version,
        devOps: devOps ?? null,
        userProjectPermissions: userProjectPermissions
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3nL89.DocumentTitle), {
        title: formatMessage((0, $8Qifh.default).browserTitle, {
            projectName: projectName,
            versionName: version.name
        })
    })));
};
const $1851276e0cb058bd$var$ISSUE_HEADER_AND_FILTERS_SECTION_OFFSET = 118;
const $1851276e0cb058bd$var$LEFT_CONTAINER_MIN_WIDTH = 20; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1851276e0cb058bd$var$ContainerWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw _kqswh2mm _1reo15vq _c71l1osq _4t3i1osq _18m915vq",
            __cmplp.className
        ])
    });
});
const $1851276e0cb058bd$var$mainContentContainerStylesNew = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1851276e0cb058bd$var$IssueListMinHeightContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1tke1aj4",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1851276e0cb058bd$var$VersionDetailsWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isIssueClosed: isIssueClosed, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_c71l1osq _4t3i1osq _1e0c1txw _2lx21bp4",
            __cmplp.isIssueClosed ? "_1reo1wug _18m91wug" : "_1reoewfl _18m9ewfl",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1851276e0cb058bd$var$SidebarCard = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rkofajl _189ee4h9 _1dqonqa1 _1h6d1l7x",
            __cmplp.className
        ])
    });
});
const $1851276e0cb058bd$var$IssueListFooterContentWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isPinned: isPinned, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_bfhk5w2r _94n5idpf _1e0c1txw _2lx21bp4 _4t3it9kd _1bah1h6o _kqsw1if8 _1bsb1osq",
            __cmplp.isPinned ? "_x3doia51" : "_x3doglyw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("c6Tby", function(module, exports) {
$parcel$export(module.exports, "default", () => $499bdaaeaf4a391a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<49642df6204feef1093601327d0b867e>>
 * @relayHash a880580d17ea37c1ecf818a2e8b64373
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 272a4ac907ee41981af68e0c4a9bc140b3018d431ffc6ce53d40294d2a147114

var $37Ewn = parcelRequire("37Ewn");
const $499bdaaeaf4a391a$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudAri"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filters"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isDevopsFeatureDisabledInFedRamp"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isReleasesUpdateStatusPermissionFixEnabled"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKey"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldIncludeDevOpsFieldsViaAgs"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "skip"
    }, v8 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "sortBy"
    }, v9 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "versionAri"
    }, v10 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "versionAri"
        }
    ], v11 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v12 = {
        "kind": "ScalarField",
        "name": "name"
    }, v13 = {
        "kind": "ScalarField",
        "name": "status"
    }, v14 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v15 = {
        "kind": "Variable",
        "name": "projectKey",
        "variableName": "projectKey"
    }, v16 = {
        "condition": "isReleasesUpdateStatusPermissionFixEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "alias": "hasEditIssuesPermission",
                "args": [
                    v14 /*: any*/ ,
                    {
                        "kind": "Literal",
                        "name": "permission",
                        "value": "EDIT_ISSUES"
                    },
                    v15 /*: any*/ 
                ],
                "kind": "ScalarField",
                "name": "hasProjectPermission"
            },
            {
                "alias": "hasResolveIssuesPermission",
                "args": [
                    v14 /*: any*/ ,
                    {
                        "kind": "Literal",
                        "name": "permission",
                        "value": "RESOLVE_ISSUES"
                    },
                    v15 /*: any*/ 
                ],
                "kind": "ScalarField",
                "name": "hasProjectPermission"
            }
        ]
    }, v17 = {
        "kind": "ScalarField",
        "name": "id"
    }, v18 = {
        "kind": "ScalarField",
        "name": "collapsedUis"
    }, v19 = {
        "kind": "Literal",
        "name": "filter",
        "value": "ALL"
    }, v20 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v21 = [
        v20 /*: any*/ 
    ], v22 = {
        "kind": "ScalarField",
        "name": "canEdit"
    }, v23 = {
        "kind": "ScalarField",
        "name": "key"
    }, v24 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v25 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v26 = {
        "kind": "ScalarField",
        "name": "description"
    }, v27 = [
        v19 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "filters",
            "variableName": "filters"
        },
        {
            "kind": "Literal",
            "name": "first",
            "value": 20
        },
        {
            "kind": "Variable",
            "name": "sortBy",
            "variableName": "sortBy"
        }
    ], v28 = {
        "kind": "ScalarField",
        "name": "count"
    }, v29 = {
        "kind": "ScalarField",
        "name": "state"
    }, v30 = {
        "concreteType": "DevOpsSummarisedBuildState",
        "kind": "LinkedField",
        "name": "buildStates",
        "plural": true,
        "selections": [
            v29 /*: any*/ ,
            v28 /*: any*/ 
        ]
    }, v31 = [
        v28 /*: any*/ 
    ], v32 = {
        "kind": "ScalarField",
        "name": "title"
    }, v33 = [
        v28 /*: any*/ ,
        v17 /*: any*/ 
    ], v34 = {
        "concreteType": "DevOpsSummarisedDeployments",
        "kind": "LinkedField",
        "name": "summarisedDeployments",
        "plural": false,
        "selections": v33 /*: any*/ 
    }, v35 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v36 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "endCursor"
            },
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            }
        ]
    }, v37 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 100
        }
    ], v38 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "uiVersionDetailsQuery",
            "selections": [
                {
                    "concreteType": "DevOps",
                    "kind": "LinkedField",
                    "name": "devOps",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "ui_softwareReleasesVersionDetail_VersionDetailInner_devOps"
                        }
                    ]
                },
                {
                    "condition": "skip",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "concreteType": "JiraQuery",
                                "kind": "LinkedField",
                                "name": "jira",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "RequiredField",
                                        "field": {
                                            "args": v10 /*: any*/ ,
                                            "kind": "LinkedField",
                                            "name": "version",
                                            "plural": false,
                                            "selections": [
                                                v11 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v12 /*: any*/ ,
                                                        v13 /*: any*/ ,
                                                        {
                                                            "kind": "FragmentSpread",
                                                            "name": "ui_softwareReleasesVersionDetail_VersionDetailInner_jiraVersion"
                                                        },
                                                        {
                                                            "kind": "FragmentSpread",
                                                            "name": "accessCheck_softwareReleasesVersionDetail"
                                                        }
                                                    ],
                                                    "type": "JiraVersion"
                                                }
                                            ]
                                        },
                                        "action": "THROW",
                                        "path": "jira.version"
                                    },
                                    v16 /*: any*/ 
                                ]
                            },
                            "action": "THROW",
                            "path": "jira"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v9 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v6 /*: any*/ ,
                v1 /*: any*/ ,
                v5 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "uiVersionDetailsQuery",
            "selections": [
                {
                    "concreteType": "DevOps",
                    "kind": "LinkedField",
                    "name": "devOps",
                    "plural": false,
                    "selections": [
                        {
                            "condition": "isDevopsFeatureDisabledInFedRamp",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "id",
                                            "variableName": "cloudAri"
                                        },
                                        {
                                            "kind": "Literal",
                                            "name": "providerTypes",
                                            "value": [
                                                "DESIGN"
                                            ]
                                        }
                                    ],
                                    "concreteType": "DevOpsProviders",
                                    "kind": "LinkedField",
                                    "name": "providers",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "DevOpsDesignProvider",
                                            "kind": "LinkedField",
                                            "name": "designProviders",
                                            "plural": true,
                                            "selections": [
                                                v11 /*: any*/ ,
                                                v17 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "skip",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v10 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        v11 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v12 /*: any*/ ,
                                                v13 /*: any*/ ,
                                                v17 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "canAddAndRemoveIssues"
                                                },
                                                v18 /*: any*/ ,
                                                {
                                                    "alias": "allIssues",
                                                    "args": [
                                                        v19 /*: any*/ 
                                                    ],
                                                    "concreteType": "JiraIssueConnection",
                                                    "kind": "LinkedField",
                                                    "name": "issues",
                                                    "plural": false,
                                                    "selections": v21 /*: any*/ ,
                                                    "storageKey": "issues(filter:\"ALL\")"
                                                },
                                                v22 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "startDate"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "releaseDate"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "versionId"
                                                },
                                                {
                                                    "concreteType": "JiraProject",
                                                    "kind": "LinkedField",
                                                    "name": "project",
                                                    "plural": false,
                                                    "selections": [
                                                        v23 /*: any*/ ,
                                                        v17 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "projectId"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "cloudId"
                                                        },
                                                        {
                                                            "args": [
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "filter",
                                                                    "value": {
                                                                        "maxHierarchyLevel": 1,
                                                                        "minHierarchyLevel": 1
                                                                    }
                                                                }
                                                            ],
                                                            "concreteType": "JiraIssueTypeConnection",
                                                            "kind": "LinkedField",
                                                            "name": "issueTypes",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueTypeEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueType",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueTypeHierarchyLevel",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "hierarchy",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v12 /*: any*/ 
                                                                                    ]
                                                                                },
                                                                                v17 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "storageKey": "issueTypes(filter:{\"maxHierarchyLevel\":1,\"minHierarchyLevel\":1})"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "projectStyle"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "JiraVersionDriverResult",
                                                    "kind": "LinkedField",
                                                    "name": "driverData",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "driver",
                                                            "plural": false,
                                                            "selections": [
                                                                v11 /*: any*/ ,
                                                                v24 /*: any*/ ,
                                                                v12 /*: any*/ ,
                                                                v25 /*: any*/ ,
                                                                v17 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "QueryError",
                                                            "kind": "LinkedField",
                                                            "name": "queryError",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "message"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                v26 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraVersionWarningConfig",
                                                    "kind": "LinkedField",
                                                    "name": "warningConfig",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "openPullRequest"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "openReview"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "unreviewedCode"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "failingBuild"
                                                        },
                                                        v22 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "concreteType": "JiraVersionConnectAddonIframeData",
                                                    "kind": "LinkedField",
                                                    "name": "connectAddonIframeData",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "appKey"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "moduleKey"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "appName"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "location"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "options"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "canViewDevTools"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "versionIssueTableHiddenColumns"
                                                },
                                                {
                                                    "alias": "issuesForList",
                                                    "args": v27 /*: any*/ ,
                                                    "concreteType": "JiraIssueConnection",
                                                    "kind": "LinkedField",
                                                    "name": "issues",
                                                    "plural": false,
                                                    "selections": [
                                                        v20 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "jql"
                                                        },
                                                        {
                                                            "concreteType": "JiraIssueEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssue",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v23 /*: any*/ ,
                                                                        v17 /*: any*/ ,
                                                                        {
                                                                            "args": [
                                                                                {
                                                                                    "kind": "Literal",
                                                                                    "name": "ids",
                                                                                    "value": [
                                                                                        "priority",
                                                                                        "summary",
                                                                                        "assignee",
                                                                                        "status",
                                                                                        "issuetype"
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "concreteType": "JiraIssueFieldConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "fieldsById",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "edges",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "node",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v11 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "fieldId"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraStatus",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "status",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraStatusCategory",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "statusCategory",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "statusCategoryId"
                                                                                                                        },
                                                                                                                        v17 /*: any*/ 
                                                                                                                    ]
                                                                                                                },
                                                                                                                v17 /*: any*/ ,
                                                                                                                v12 /*: any*/ ,
                                                                                                                v26 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraStatusField"
                                                                                                },
                                                                                                v17 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "user",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v11 /*: any*/ ,
                                                                                                                v25 /*: any*/ ,
                                                                                                                v12 /*: any*/ ,
                                                                                                                v17 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraSingleSelectUserPickerField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "text"
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraSingleLineTextField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssueType",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issueType",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v12 /*: any*/ ,
                                                                                                                {
                                                                                                                    "concreteType": "JiraAvatar",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "avatar",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "xsmall"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                v17 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraIssueTypeField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraPriority",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "priority",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v12 /*: any*/ ,
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "iconUrl"
                                                                                                                },
                                                                                                                v17 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraPriorityField"
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "storageKey": "fieldsById(ids:[\"priority\",\"summary\",\"assignee\",\"status\",\"issuetype\"])"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "issueId"
                                                                        },
                                                                        {
                                                                            "concreteType": "DevOpsSummarisedFeatureFlags",
                                                                            "kind": "LinkedField",
                                                                            "name": "summarisedFeatureFlags",
                                                                            "plural": false,
                                                                            "selections": v21 /*: any*/ 
                                                                        },
                                                                        v11 /*: any*/ ,
                                                                        {
                                                                            "condition": "isDevopsFeatureDisabledInFedRamp",
                                                                            "kind": "Condition",
                                                                            "passingValue": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "DevOpsSummarisedEntities",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "devOpsSummarisedEntities",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "DevOpsSummarisedDeployments",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "summarisedDeployments",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v28 /*: any*/ ,
                                                                                                v17 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "deploymentState"
                                                                                                },
                                                                                                {
                                                                                                    "concreteType": "DevOpsEnvironment",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "deploymentEnvironment",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "category"
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "concreteType": "DevOpsSummarisedBuilds",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "summarisedBuilds",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v28 /*: any*/ ,
                                                                                                v17 /*: any*/ ,
                                                                                                v30 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "concreteType": "JiraIssueDevSummaryResult",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "devSummaryCache",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraIssueDevSummary",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "devSummary",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssuePullRequestDevSummaryContainer",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "pullrequest",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssuePullRequestDevSummary",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "overall",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v28 /*: any*/ ,
                                                                                                                v29 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                {
                                                                                                    "concreteType": "JiraIssueBranchDevSummaryContainer",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "branch",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssueBranchDevSummary",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "overall",
                                                                                                            "plural": false,
                                                                                                            "selections": v31 /*: any*/ 
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                {
                                                                                                    "concreteType": "JiraIssueReviewDevSummaryContainer",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "review",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssueReviewDevSummary",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "overall",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v28 /*: any*/ ,
                                                                                                                v29 /*: any*/ ,
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "lastUpdated"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "stateCount"
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        {
                                                                                                            "concreteType": "JiraIssueDevSummaryByProvider",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "summaryByProvider",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "providerId"
                                                                                                                },
                                                                                                                v12 /*: any*/ ,
                                                                                                                v28 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                {
                                                                                                    "concreteType": "JiraIssueCommitDevSummaryContainer",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "commit",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssueCommitDevSummary",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "overall",
                                                                                                            "plural": false,
                                                                                                            "selections": v31 /*: any*/ 
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                {
                                                                                                    "concreteType": "JiraIssueBuildDevSummaryContainer",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "build",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssueBuildDevSummary",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "overall",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v28 /*: any*/ ,
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "failedBuildCount"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "successfulBuildCount"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "unknownBuildCount"
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                {
                                                                                                    "concreteType": "JiraIssueDeploymentEnvironmentDevSummaryContainer",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "deploymentEnvironments",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssueDeploymentEnvironmentDevSummary",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "overall",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraIssueDeploymentEnvironment",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "topEnvironments",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        v13 /*: any*/ ,
                                                                                                                        v32 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "concreteType": "DevOpsSummarisedFeatureFlags",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "summarisedFeatureFlags",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "mostRelevantDisplayName"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "mostRelevantEnabled"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "mostRelevantRolloutPercentage"
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "condition": "shouldIncludeDevOpsFieldsViaAgs",
                                                                                    "kind": "Condition",
                                                                                    "passingValue": true,
                                                                                    "selections": [
                                                                                        v34 /*: any*/ ,
                                                                                        {
                                                                                            "concreteType": "DevOpsSummarisedBuilds",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "summarisedBuilds",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v30 /*: any*/ ,
                                                                                                v28 /*: any*/ ,
                                                                                                v17 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "condition": "shouldIncludeDevOpsFieldsViaAgs",
                                                                            "kind": "Condition",
                                                                            "passingValue": true,
                                                                            "selections": [
                                                                                v34 /*: any*/ ,
                                                                                {
                                                                                    "concreteType": "DevOpsSummarisedBuilds",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "summarisedBuilds",
                                                                                    "plural": false,
                                                                                    "selections": v33 /*: any*/ 
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                v35 /*: any*/ 
                                                            ]
                                                        },
                                                        v36 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "alias": "issuesForList",
                                                    "args": v27 /*: any*/ ,
                                                    "filters": [
                                                        "filter",
                                                        "sortBy",
                                                        "filters"
                                                    ],
                                                    "handle": "connection",
                                                    "key": "ListVersion_issuesForList",
                                                    "kind": "LinkedHandle",
                                                    "name": "issues"
                                                },
                                                {
                                                    "alias": "allIssuesRedesignTemp",
                                                    "concreteType": "JiraIssueConnection",
                                                    "kind": "LinkedField",
                                                    "name": "issues",
                                                    "plural": false,
                                                    "selections": v21 /*: any*/ 
                                                },
                                                v18 /*: any*/ ,
                                                {
                                                    "args": v37 /*: any*/ ,
                                                    "concreteType": "JiraVersionApproverConnection",
                                                    "kind": "LinkedField",
                                                    "name": "approvers",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraVersionApproverEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraVersionApprover",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v17 /*: any*/ ,
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "user",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v11 /*: any*/ ,
                                                                                v12 /*: any*/ ,
                                                                                v25 /*: any*/ ,
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "AtlassianAccountUserExtendedProfile",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "extendedProfile",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "jobTitle"
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "AtlassianAccountUser"
                                                                                },
                                                                                v17 /*: any*/ ,
                                                                                v24 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v13 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "declineReason"
                                                                        },
                                                                        v26 /*: any*/ ,
                                                                        v38 /*: any*/ ,
                                                                        v11 /*: any*/ 
                                                                    ]
                                                                },
                                                                v35 /*: any*/ 
                                                            ]
                                                        },
                                                        v36 /*: any*/ 
                                                    ],
                                                    "storageKey": "approvers(first:100)"
                                                },
                                                {
                                                    "args": v37 /*: any*/ ,
                                                    "handle": "connection",
                                                    "key": "version_approvers",
                                                    "kind": "LinkedHandle",
                                                    "name": "approvers"
                                                },
                                                {
                                                    "concreteType": "JiraVersionRichTextSection",
                                                    "kind": "LinkedField",
                                                    "name": "richTextSection",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraADF",
                                                            "kind": "LinkedField",
                                                            "name": "content",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "json"
                                                                }
                                                            ]
                                                        },
                                                        v32 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "canViewVersionDetailsPage"
                                                },
                                                {
                                                    "condition": "isDevopsFeatureDisabledInFedRamp",
                                                    "kind": "Condition",
                                                    "passingValue": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "DevOpsSummarisedEntities",
                                                            "kind": "LinkedField",
                                                            "name": "devOpsSummarisedEntities",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "DevOpsProviders",
                                                                    "kind": "LinkedField",
                                                                    "name": "providers",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "DevOpsFeatureFlagProvider",
                                                                            "kind": "LinkedField",
                                                                            "name": "featureFlagProviders",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                v11 /*: any*/ ,
                                                                                v17 /*: any*/ ,
                                                                                v12 /*: any*/ ,
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "createFeatureFlagTemplateUrl"
                                                                                },
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "connectFeatureFlagTemplateUrl"
                                                                                },
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "logoUrl"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                v38 /*: any*/ 
                                            ],
                                            "type": "JiraVersion"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v17 /*: any*/ 
                                            ],
                                            "type": "Node",
                                            "abstractKey": "__isNode"
                                        }
                                    ]
                                },
                                v16 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "272a4ac907ee41981af68e0c4a9bc140b3018d431ffc6ce53d40294d2a147114",
            "metadata": {},
            "name": "uiVersionDetailsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$499bdaaeaf4a391a$var$node.hash = "77c627037d68e8b8fcdd635aad1ada02";
(0, $37Ewn.PreloadableQueryRegistry).set($499bdaaeaf4a391a$var$node.params.id, $499bdaaeaf4a391a$var$node);
var $499bdaaeaf4a391a$export$2e2bcd8739ae039 = $499bdaaeaf4a391a$var$node;

});

parcelRegister("kK0gQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $6ac0e7aca077ee53$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a5b2271b293581a9e8bb11c08ccddb87>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck

var $4lF62 = parcelRequire("4lF62");
const $6ac0e7aca077ee53$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "filters"
        },
        {
            "kind": "RootArgument",
            "name": "isDevopsFeatureDisabledInFedRamp"
        },
        {
            "kind": "RootArgument",
            "name": "shouldIncludeDevOpsFieldsViaAgs"
        },
        {
            "kind": "RootArgument",
            "name": "sortBy"
        }
    ],
    "kind": "Fragment",
    "metadata": {
        "refetch": {
            "fragmentPathInResult": [
                "node"
            ],
            "operation": (0, $4lF62.default),
            "identifierInfo": {
                "identifierField": "id",
                "identifierQueryVariableName": "id"
            }
        }
    },
    "name": "ui_softwareReleasesVersionDetail_VersionDetailInner_jiraVersion",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "canAddAndRemoveIssues"
        },
        {
            "kind": "ScalarField",
            "name": "collapsedUis"
        },
        {
            "alias": "allIssues",
            "args": [
                {
                    "kind": "Literal",
                    "name": "filter",
                    "value": "ALL"
                }
            ],
            "concreteType": "JiraIssueConnection",
            "kind": "LinkedField",
            "name": "issues",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "totalCount"
                }
            ],
            "storageKey": "issues(filter:\"ALL\")"
        },
        {
            "kind": "FragmentSpread",
            "name": "async_softwareReleasesLaunchCard_LaunchCard"
        },
        {
            "kind": "FragmentSpread",
            "name": "header_softwareReleasesVersionDetail"
        },
        {
            "kind": "FragmentSpread",
            "name": "ui_softwareReleasesAddIssuesToVersion_AddIssuesToVersion"
        },
        {
            "kind": "FragmentSpread",
            "name": "ui_softwareReleasesVersionDetailIssueList_IssueListWithHeaderWithErrorBoundary_jiraVersion"
        },
        {
            "kind": "FragmentSpread",
            "name": "async_softwareReleasesApprovers_Approvers"
        },
        {
            "kind": "FragmentSpread",
            "name": "rightSidebar_softwareReleasesVersionDetail"
        },
        {
            "kind": "FragmentSpread",
            "name": "async_softwareReleasesVersionRichTextSection_AsyncVersionRichTextSection"
        }
    ],
    "type": "JiraVersion"
};
$6ac0e7aca077ee53$var$node.hash = "18efada2730a05c083b285addf6cb338";
var $6ac0e7aca077ee53$export$2e2bcd8739ae039 = $6ac0e7aca077ee53$var$node;

});
parcelRegister("4lF62", function(module, exports) {
$parcel$export(module.exports, "default", () => $8bce1e99a4378e50$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<dc04afb2ebee1b66ffe31f8b148311f3>>
 * @relayHash d9893edf8caf7d2d1b2b041b4885bd6d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7138bebed4e5923528c4c74087e0a2be85d0fcb4905c03b118ddd4d71d2ea482
const $8bce1e99a4378e50$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filters"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "id"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isDevopsFeatureDisabledInFedRamp"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldIncludeDevOpsFieldsViaAgs"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "sortBy"
    }, v5 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "id"
        }
    ], v6 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v7 = {
        "kind": "ScalarField",
        "name": "id"
    }, v8 = {
        "kind": "ScalarField",
        "name": "collapsedUis"
    }, v9 = {
        "kind": "Literal",
        "name": "filter",
        "value": "ALL"
    }, v10 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v11 = [
        v10 /*: any*/ 
    ], v12 = {
        "kind": "ScalarField",
        "name": "canEdit"
    }, v13 = {
        "kind": "ScalarField",
        "name": "status"
    }, v14 = {
        "kind": "ScalarField",
        "name": "key"
    }, v15 = {
        "kind": "ScalarField",
        "name": "name"
    }, v16 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v17 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v18 = {
        "kind": "ScalarField",
        "name": "description"
    }, v19 = [
        v9 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "filters",
            "variableName": "filters"
        },
        {
            "kind": "Literal",
            "name": "first",
            "value": 20
        },
        {
            "kind": "Variable",
            "name": "sortBy",
            "variableName": "sortBy"
        }
    ], v20 = {
        "kind": "ScalarField",
        "name": "count"
    }, v21 = {
        "kind": "ScalarField",
        "name": "state"
    }, v22 = {
        "concreteType": "DevOpsSummarisedBuildState",
        "kind": "LinkedField",
        "name": "buildStates",
        "plural": true,
        "selections": [
            v21 /*: any*/ ,
            v20 /*: any*/ 
        ]
    }, v23 = [
        v20 /*: any*/ 
    ], v24 = {
        "kind": "ScalarField",
        "name": "title"
    }, v25 = [
        v20 /*: any*/ ,
        v7 /*: any*/ 
    ], v26 = {
        "concreteType": "DevOpsSummarisedDeployments",
        "kind": "LinkedField",
        "name": "summarisedDeployments",
        "plural": false,
        "selections": v25 /*: any*/ 
    }, v27 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v28 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "endCursor"
            },
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            }
        ]
    }, v29 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 100
        }
    ], v30 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "versionDetailPageRefetchQuery",
            "selections": [
                {
                    "args": v5 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "ui_softwareReleasesVersionDetail_VersionDetailInner_jiraVersion"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "versionDetailPageRefetchQuery",
            "selections": [
                {
                    "args": v5 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v6 /*: any*/ ,
                        v7 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "canAddAndRemoveIssues"
                                },
                                v8 /*: any*/ ,
                                {
                                    "alias": "allIssues",
                                    "args": [
                                        v9 /*: any*/ 
                                    ],
                                    "concreteType": "JiraIssueConnection",
                                    "kind": "LinkedField",
                                    "name": "issues",
                                    "plural": false,
                                    "selections": v11 /*: any*/ ,
                                    "storageKey": "issues(filter:\"ALL\")"
                                },
                                v12 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "startDate"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "releaseDate"
                                },
                                v13 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "versionId"
                                },
                                {
                                    "concreteType": "JiraProject",
                                    "kind": "LinkedField",
                                    "name": "project",
                                    "plural": false,
                                    "selections": [
                                        v14 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "projectId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "cloudId"
                                        },
                                        {
                                            "args": [
                                                {
                                                    "kind": "Literal",
                                                    "name": "filter",
                                                    "value": {
                                                        "maxHierarchyLevel": 1,
                                                        "minHierarchyLevel": 1
                                                    }
                                                }
                                            ],
                                            "concreteType": "JiraIssueTypeConnection",
                                            "kind": "LinkedField",
                                            "name": "issueTypes",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssueTypeEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueType",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueTypeHierarchyLevel",
                                                                    "kind": "LinkedField",
                                                                    "name": "hierarchy",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v15 /*: any*/ 
                                                                    ]
                                                                },
                                                                v7 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ],
                                            "storageKey": "issueTypes(filter:{\"maxHierarchyLevel\":1,\"minHierarchyLevel\":1})"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "projectStyle"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "JiraVersionDriverResult",
                                    "kind": "LinkedField",
                                    "name": "driverData",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "driver",
                                            "plural": false,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                v16 /*: any*/ ,
                                                v15 /*: any*/ ,
                                                v17 /*: any*/ ,
                                                v7 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "concreteType": "QueryError",
                                            "kind": "LinkedField",
                                            "name": "queryError",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "message"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v18 /*: any*/ ,
                                v15 /*: any*/ ,
                                {
                                    "concreteType": "JiraVersionWarningConfig",
                                    "kind": "LinkedField",
                                    "name": "warningConfig",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "openPullRequest"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "openReview"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "unreviewedCode"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "failingBuild"
                                        },
                                        v12 /*: any*/ 
                                    ]
                                },
                                {
                                    "concreteType": "JiraVersionConnectAddonIframeData",
                                    "kind": "LinkedField",
                                    "name": "connectAddonIframeData",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "appKey"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "moduleKey"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "appName"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "location"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "options"
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canViewDevTools"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "versionIssueTableHiddenColumns"
                                },
                                {
                                    "alias": "issuesForList",
                                    "args": v19 /*: any*/ ,
                                    "concreteType": "JiraIssueConnection",
                                    "kind": "LinkedField",
                                    "name": "issues",
                                    "plural": false,
                                    "selections": [
                                        v10 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "jql"
                                        },
                                        {
                                            "concreteType": "JiraIssueEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssue",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v14 /*: any*/ ,
                                                        v7 /*: any*/ ,
                                                        {
                                                            "args": [
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "ids",
                                                                    "value": [
                                                                        "priority",
                                                                        "summary",
                                                                        "assignee",
                                                                        "status",
                                                                        "issuetype"
                                                                    ]
                                                                }
                                                            ],
                                                            "concreteType": "JiraIssueFieldConnection",
                                                            "kind": "LinkedField",
                                                            "name": "fieldsById",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v6 /*: any*/ ,
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "fieldId"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraStatus",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "status",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraStatusCategory",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "statusCategory",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "statusCategoryId"
                                                                                                        },
                                                                                                        v7 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                v7 /*: any*/ ,
                                                                                                v15 /*: any*/ ,
                                                                                                v18 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraStatusField"
                                                                                },
                                                                                v7 /*: any*/ ,
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "user",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v6 /*: any*/ ,
                                                                                                v17 /*: any*/ ,
                                                                                                v15 /*: any*/ ,
                                                                                                v7 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraSingleSelectUserPickerField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "text"
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraSingleLineTextField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraIssueType",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "issueType",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v15 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraAvatar",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "avatar",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "xsmall"
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v7 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraIssueTypeField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraPriority",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "priority",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v15 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "iconUrl"
                                                                                                },
                                                                                                v7 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraPriorityField"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "storageKey": "fieldsById(ids:[\"priority\",\"summary\",\"assignee\",\"status\",\"issuetype\"])"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "issueId"
                                                        },
                                                        {
                                                            "concreteType": "DevOpsSummarisedFeatureFlags",
                                                            "kind": "LinkedField",
                                                            "name": "summarisedFeatureFlags",
                                                            "plural": false,
                                                            "selections": v11 /*: any*/ 
                                                        },
                                                        v6 /*: any*/ ,
                                                        {
                                                            "condition": "isDevopsFeatureDisabledInFedRamp",
                                                            "kind": "Condition",
                                                            "passingValue": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "DevOpsSummarisedEntities",
                                                                    "kind": "LinkedField",
                                                                    "name": "devOpsSummarisedEntities",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "DevOpsSummarisedDeployments",
                                                                            "kind": "LinkedField",
                                                                            "name": "summarisedDeployments",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v20 /*: any*/ ,
                                                                                v7 /*: any*/ ,
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "deploymentState"
                                                                                },
                                                                                {
                                                                                    "concreteType": "DevOpsEnvironment",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "deploymentEnvironment",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "category"
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "concreteType": "DevOpsSummarisedBuilds",
                                                                            "kind": "LinkedField",
                                                                            "name": "summarisedBuilds",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v20 /*: any*/ ,
                                                                                v7 /*: any*/ ,
                                                                                v22 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "JiraIssueDevSummaryResult",
                                                                    "kind": "LinkedField",
                                                                    "name": "devSummaryCache",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueDevSummary",
                                                                            "kind": "LinkedField",
                                                                            "name": "devSummary",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssuePullRequestDevSummaryContainer",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "pullrequest",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraIssuePullRequestDevSummary",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "overall",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v20 /*: any*/ ,
                                                                                                v21 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "concreteType": "JiraIssueBranchDevSummaryContainer",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "branch",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraIssueBranchDevSummary",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "overall",
                                                                                            "plural": false,
                                                                                            "selections": v23 /*: any*/ 
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "concreteType": "JiraIssueReviewDevSummaryContainer",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "review",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraIssueReviewDevSummary",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "overall",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v20 /*: any*/ ,
                                                                                                v21 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "lastUpdated"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "stateCount"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "concreteType": "JiraIssueDevSummaryByProvider",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "summaryByProvider",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "providerId"
                                                                                                },
                                                                                                v15 /*: any*/ ,
                                                                                                v20 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "concreteType": "JiraIssueCommitDevSummaryContainer",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "commit",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraIssueCommitDevSummary",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "overall",
                                                                                            "plural": false,
                                                                                            "selections": v23 /*: any*/ 
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "concreteType": "JiraIssueBuildDevSummaryContainer",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "build",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraIssueBuildDevSummary",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "overall",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v20 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "failedBuildCount"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "successfulBuildCount"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "unknownBuildCount"
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "concreteType": "JiraIssueDeploymentEnvironmentDevSummaryContainer",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "deploymentEnvironments",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraIssueDeploymentEnvironmentDevSummary",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "overall",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssueDeploymentEnvironment",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "topEnvironments",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        v13 /*: any*/ ,
                                                                                                        v24 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "DevOpsSummarisedFeatureFlags",
                                                                    "kind": "LinkedField",
                                                                    "name": "summarisedFeatureFlags",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "mostRelevantDisplayName"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "mostRelevantEnabled"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "mostRelevantRolloutPercentage"
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "condition": "shouldIncludeDevOpsFieldsViaAgs",
                                                                    "kind": "Condition",
                                                                    "passingValue": true,
                                                                    "selections": [
                                                                        v26 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "DevOpsSummarisedBuilds",
                                                                            "kind": "LinkedField",
                                                                            "name": "summarisedBuilds",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v22 /*: any*/ ,
                                                                                v20 /*: any*/ ,
                                                                                v7 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "condition": "shouldIncludeDevOpsFieldsViaAgs",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": [
                                                                v26 /*: any*/ ,
                                                                {
                                                                    "concreteType": "DevOpsSummarisedBuilds",
                                                                    "kind": "LinkedField",
                                                                    "name": "summarisedBuilds",
                                                                    "plural": false,
                                                                    "selections": v25 /*: any*/ 
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                v27 /*: any*/ 
                                            ]
                                        },
                                        v28 /*: any*/ 
                                    ]
                                },
                                {
                                    "alias": "issuesForList",
                                    "args": v19 /*: any*/ ,
                                    "filters": [
                                        "filter",
                                        "sortBy",
                                        "filters"
                                    ],
                                    "handle": "connection",
                                    "key": "ListVersion_issuesForList",
                                    "kind": "LinkedHandle",
                                    "name": "issues"
                                },
                                {
                                    "alias": "allIssuesRedesignTemp",
                                    "concreteType": "JiraIssueConnection",
                                    "kind": "LinkedField",
                                    "name": "issues",
                                    "plural": false,
                                    "selections": v11 /*: any*/ 
                                },
                                v8 /*: any*/ ,
                                {
                                    "args": v29 /*: any*/ ,
                                    "concreteType": "JiraVersionApproverConnection",
                                    "kind": "LinkedField",
                                    "name": "approvers",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraVersionApproverEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraVersionApprover",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v7 /*: any*/ ,
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "user",
                                                            "plural": false,
                                                            "selections": [
                                                                v6 /*: any*/ ,
                                                                v15 /*: any*/ ,
                                                                v17 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "AtlassianAccountUserExtendedProfile",
                                                                            "kind": "LinkedField",
                                                                            "name": "extendedProfile",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "jobTitle"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "type": "AtlassianAccountUser"
                                                                },
                                                                v7 /*: any*/ ,
                                                                v16 /*: any*/ 
                                                            ]
                                                        },
                                                        v13 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "declineReason"
                                                        },
                                                        v18 /*: any*/ ,
                                                        v30 /*: any*/ ,
                                                        v6 /*: any*/ 
                                                    ]
                                                },
                                                v27 /*: any*/ 
                                            ]
                                        },
                                        v28 /*: any*/ 
                                    ],
                                    "storageKey": "approvers(first:100)"
                                },
                                {
                                    "args": v29 /*: any*/ ,
                                    "handle": "connection",
                                    "key": "version_approvers",
                                    "kind": "LinkedHandle",
                                    "name": "approvers"
                                },
                                {
                                    "concreteType": "JiraVersionRichTextSection",
                                    "kind": "LinkedField",
                                    "name": "richTextSection",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraADF",
                                            "kind": "LinkedField",
                                            "name": "content",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "json"
                                                }
                                            ]
                                        },
                                        v24 /*: any*/ 
                                    ]
                                },
                                {
                                    "condition": "isDevopsFeatureDisabledInFedRamp",
                                    "kind": "Condition",
                                    "passingValue": false,
                                    "selections": [
                                        {
                                            "concreteType": "DevOpsSummarisedEntities",
                                            "kind": "LinkedField",
                                            "name": "devOpsSummarisedEntities",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "DevOpsProviders",
                                                    "kind": "LinkedField",
                                                    "name": "providers",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "DevOpsFeatureFlagProvider",
                                                            "kind": "LinkedField",
                                                            "name": "featureFlagProviders",
                                                            "plural": true,
                                                            "selections": [
                                                                v6 /*: any*/ ,
                                                                v7 /*: any*/ ,
                                                                v15 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "createFeatureFlagTemplateUrl"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "connectFeatureFlagTemplateUrl"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "logoUrl"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v30 /*: any*/ 
                            ],
                            "type": "JiraVersion"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "7138bebed4e5923528c4c74087e0a2be85d0fcb4905c03b118ddd4d71d2ea482",
            "metadata": {},
            "name": "versionDetailPageRefetchQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$8bce1e99a4378e50$var$node.hash = "18efada2730a05c083b285addf6cb338";
var $8bce1e99a4378e50$export$2e2bcd8739ae039 = $8bce1e99a4378e50$var$node;

});


parcelRegister("HhgrR", function(module, exports) {
$parcel$export(module.exports, "default", () => $6f8ecf60d511a0cd$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<575aa0ac902f70ccf49448d3df147e43>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $6f8ecf60d511a0cd$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "cloudAri"
        },
        {
            "kind": "RootArgument",
            "name": "isDevopsFeatureDisabledInFedRamp"
        }
    ],
    "kind": "Fragment",
    "name": "ui_softwareReleasesVersionDetail_VersionDetailInner_devOps",
    "selections": [
        {
            "condition": "isDevopsFeatureDisabledInFedRamp",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "id",
                            "variableName": "cloudAri"
                        },
                        {
                            "kind": "Literal",
                            "name": "providerTypes",
                            "value": [
                                "DESIGN"
                            ]
                        }
                    ],
                    "concreteType": "DevOpsProviders",
                    "kind": "LinkedField",
                    "name": "providers",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "DevOpsDesignProvider",
                            "kind": "LinkedField",
                            "name": "designProviders",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    "type": "DevOps"
};
$6f8ecf60d511a0cd$var$node.hash = "72d5936bbd25e3ba21b829d9fbc1ac05";
var $6f8ecf60d511a0cd$export$2e2bcd8739ae039 = $6f8ecf60d511a0cd$var$node;

});

parcelRegister("j1zBC", function(module, exports) {
$parcel$export(module.exports, "useVersionChangedNudge", () => $d462e1ee2167c70f$export$1399a8ab1927f871);

var $eJOHy = parcelRequire("eJOHy");

var $7nQlS = parcelRequire("7nQlS");

var $5NRq4 = parcelRequire("5NRq4");

var $leNtV = parcelRequire("leNtV");

var $cHtIB = parcelRequire("cHtIB");

var $4cTDP = parcelRequire("4cTDP");

var $icfHo = parcelRequire("icfHo");
var $8QSAB = parcelRequire("8QSAB");
const $d462e1ee2167c70f$export$de10ba92e87488f9 = 'ROVO_BUTTON_NUDGE_JIRA_VERSION_VIEWED';
function $d462e1ee2167c70f$export$1399a8ab1927f871({ versionId: versionId, source: source }) {
    const cloudId = (0, $cHtIB.useCloudId)();
    const triggerDetails = (0, $eJOHy.useMemo)(()=>versionId ? {
            version_ari: versionId
        } : null, [
        versionId
    ]);
    const { recommendation: recommendation } = (0, $7nQlS.useProactiveNudgeRecommendation)($d462e1ee2167c70f$export$de10ba92e87488f9, triggerDetails);
    const { setNudges: setNudges } = (0, $icfHo.useSourceAIActions)('jira-ai-rovo-button');
    const { setSurfaceMetadata: setSurfaceMetadata } = (0, $8QSAB.useSurfaceAIActions)();
    const publish = (0, $leNtV.usePublish)('ai-mate');
    (0, $eJOHy.useEffect)(()=>{
        setSurfaceMetadata({
            siteId: cloudId,
            product: 'jira',
            contentType: source
        });
    }, [
        cloudId,
        setSurfaceMetadata,
        source
    ]);
    if (!(0, $4cTDP.fg)('jira_version_details_rovo_button_nudge')) return;
    if (!versionId || !recommendation || recommendation.length === 0) return;
    const nudges = recommendation.map((recommendationItem, index)=>{
        const iconNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5NRq4))), {
            size: "medium",
            label: recommendationItem.recommendation_details.cta.cta_label
        });
        const prompt = recommendationItem.recommendation_details.cta.cta_output ?? recommendationItem.recommendation_details.cta.cta_label;
        let promptWithAlias = prompt;
        if ((0, $4cTDP.fg)('jira_rovo_button_delivery_manager_alias')) promptWithAlias = `/release ${prompt}`;
        if ((0, $4cTDP.fg)('jira_rovo_delivery_manager_decomposed_skills_alias')) promptWithAlias = `/summarize-release ${prompt}`;
        return {
            id: `jira-releases-rovo-button-nudge-version-change-${recommendationItem.recommendation_details.context.context_id}`,
            title: recommendationItem.recommendation_details.cta.cta_label,
            description: recommendationItem.recommendation_details.cta.cta_label,
            icon: iconNode,
            nudgeIcon: ()=>iconNode,
            onClick: ()=>{
                publish({
                    type: 'chat-new',
                    product: 'jira',
                    source: source,
                    data: {
                        name: recommendationItem.recommendation_details.cta.cta_label,
                        dialogues: [],
                        prompt: promptWithAlias
                    }
                });
            },
            sourceId: `jira-releases-rovo-button-version-${index}`,
            status: 'beta'
        };
    });
    setNudges(nudges);
}

});
parcelRegister("7nQlS", function(module, exports) {
$parcel$export(module.exports, "useProactiveNudgeRecommendation", () => $4811057513d1df85$export$fb96fbac677cb6e1);

var $eJOHy = parcelRequire("eJOHy");

var $aXKmr = parcelRequire("aXKmr");

var $iLg3M = parcelRequire("iLg3M");
const $4811057513d1df85$export$fb96fbac677cb6e1 = (triggerType, triggerDetails = {})=>{
    const [recommendation, setRecommendation] = (0, $eJOHy.useState)(null);
    const [error, setError] = (0, $eJOHy.useState)(null);
    const fetchRecommendation = (0, $eJOHy.useCallback)(async ()=>{
        setError(null);
        const triggerId = (0, $aXKmr.v4)();
        try {
            const response = await (0, $iLg3M.fetchProactiveNudgeSuggestion)({
                triggerId: triggerId,
                triggerType: triggerType,
                triggerDetails: triggerDetails || {}
            });
            const triggers = response.ai_feature_output?.triggers ?? [];
            const matchingTrigger = triggers.find((trigger)=>trigger.trigger_id === triggerId);
            if (!matchingTrigger) {
                setRecommendation(null);
                return;
            }
            const recommendations = matchingTrigger.recommendations ?? [];
            if (recommendations.length === 0) {
                setRecommendation(null);
                return;
            }
            setRecommendation(recommendations);
        } catch (err) {
            const normalizedError = err instanceof Error ? err : new Error(String(err));
            setError(normalizedError);
            setRecommendation(null);
        }
    }, [
        triggerType,
        triggerDetails
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (triggerDetails) fetchRecommendation();
    }, [
        fetchRecommendation,
        triggerDetails
    ]);
    return {
        recommendation: recommendation,
        error: error
    };
};

});
parcelRegister("iLg3M", function(module, exports) {
$parcel$export(module.exports, "fetchProactiveNudgeSuggestion", () => $bcca3c1c49fb764a$export$d22f2c4dbd83457);

var $aXKmr = parcelRequire("aXKmr");
const $bcca3c1c49fb764a$export$d22f2c4dbd83457 = async (options)=>{
    const { triggerType: triggerType, triggerDetails: triggerDetails, triggerId: triggerId = (0, $aXKmr.v4)() } = options;
    const requestPayload = {
        ai_feature_input: {
            triggers: [
                {
                    trigger_id: triggerId,
                    trigger_type: triggerType,
                    trigger_details: triggerDetails
                }
            ]
        }
    };
    const response = await fetch('/gateway/api/assist/api/ai/v2/ai-feature/proactive', {
        method: 'POST',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'X-Product': 'jira',
            'X-Experience-Id': 'proactive-ai-rovo-button'
        },
        body: JSON.stringify(requestPayload)
    });
    if (!response.ok) {
        const errorResponse = await response.json();
        throw new Error(errorResponse.errorMessage || `HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    return data;
};

});


parcelRegister("5NRq4", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1d41a49be2d57b5fca92e1196d1fac8e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $439af754637b4cdc$var$_react = $439af754637b4cdc$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $439af754637b4cdc$var$_baseNew = $439af754637b4cdc$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $439af754637b4cdc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChartBarLine".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Known uses: Bar charts with trend lines
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $439af754637b4cdc$var$ChartBarLineIcon = (props)=>/*#__PURE__*/ $439af754637b4cdc$var$_react.default.createElement($439af754637b4cdc$var$_baseNew.default, Object.assign({
        name: "ChartBarLineIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M1 13V1h1.5v12a.5.5 0 0 0 .5.5h12V15H3a2 2 0 0 1-2-2"/><path fill="currentcolor" d="M14 2v1.5h-2.97L7.24 6.81a.75.75 0 0 1-.49.19H3.5V5.5h2.97l3.79-3.31.11-.08a.75.75 0 0 1 .38-.11zm-8.75 8h.08a.75.75 0 0 1 .67.75v1a.75.75 0 0 1-.75.75h-1a.75.75 0 0 1-.75-.75v-1a.75.75 0 0 1 .75-.75zm4-2h.08a.75.75 0 0 1 .67.75v3a.75.75 0 0 1-.75.75h-1a.75.75 0 0 1-.75-.75v-3A.75.75 0 0 1 8.25 8zm4-2a.75.75 0 0 1 .75.75v5a.75.75 0 0 1-.75.75h-1a.75.75 0 0 1-.75-.75v-5a.75.75 0 0 1 .75-.75z"/>`
    }, props));
$439af754637b4cdc$var$ChartBarLineIcon.displayName = 'ChartBarLineIcon';
var $439af754637b4cdc$var$_default = module.exports.default = $439af754637b4cdc$var$ChartBarLineIcon;

});

parcelRegister("8QSAB", function(module, exports) {
$parcel$export(module.exports, "useSurfaceAIActions", () => $a2d32da903204deb$export$75d7484b96e549ce);

var $eJOHy = parcelRequire("eJOHy");

var $kVM4h = parcelRequire("kVM4h");
const $a2d32da903204deb$export$75d7484b96e549ce = ()=>{
    const { setSelectors: setSelectors, setSurfaceMetadata: setSurfaceMetadata } = (0, $kVM4h.useAISmartButtonActions)();
    return (0, $eJOHy.useMemo)(()=>({
            setSelectors: /**
			 * Sets selectors for filtering actions, suggested actions, and nudges.
			 */ setSelectors,
            setSurfaceMetadata: /**
			 * Sets metadata about the surface where AI features are used.
			 */ setSurfaceMetadata
        }), [
        setSelectors,
        setSurfaceMetadata
    ]);
};

});


parcelRegister("7XH79", function(module, exports) {
$parcel$export(module.exports, "useSuspenselessRefetchStateless", () => $a5387c0f4da0e3f5$export$ae1adabf094b2244);
$parcel$export(module.exports, "useSuspenselessRefetch", () => $a5387c0f4da0e3f5$export$c7ce5f64dc007896);

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $4im1M = parcelRequire("4im1M");
const $a5387c0f4da0e3f5$var$useInFlightRequests = ({ setIsLoading: setIsLoading })=>{
    const inFlightRequestsRef = (0, $eJOHy.useRef)([]);
    return (0, $eJOHy.useMemo)(()=>({
            onNewRequest: (request)=>{
                inFlightRequestsRef.current.push(request);
            },
            onRequestFinish: (request, /**
				 * Called only if the request hasn't been superceded by a more recent request's success / failure
				 */ onIfRequestIsRelevant)=>{
                // find the first occurrence of this request
                const inFlightRequestIndex = inFlightRequestsRef.current.indexOf(request);
                // If the current request is still considered "in flight"
                if (inFlightRequestIndex !== -1) {
                    onIfRequestIsRelevant?.();
                    // Cut out the current and all proceeding requests from the in-flight queue
                    inFlightRequestsRef.current = inFlightRequestsRef.current.slice(inFlightRequestIndex + 1);
                    // Update isLoading to reflect the current number of in-flight requests
                    setIsLoading?.(!!inFlightRequestsRef.current.length);
                }
            }
        }), [
        setIsLoading
    ]);
};
const $a5387c0f4da0e3f5$export$ae1adabf094b2244 = (// Relay-generated query from the @refetchable annotation in a useRefetchableFragment
// or usePaginationFragment
query, // Refetch function from a useRefetchableFragment or usePaginationFragment
// (which ordinarily would trigger suspense)
refetch, { setIsLoading: setIsLoading, setLastFetchError: setLastFetchError, fetchPolicy: fetchPolicy = 'store-or-network', networkCacheConfig: networkCacheConfig } = {})=>{
    const environment = (0, $j4oe4.useRelayEnvironment)();
    const isMounted = (0, $4im1M.useIsMounted)();
    const { onNewRequest: onNewRequest, onRequestFinish: onRequestFinish } = $a5387c0f4da0e3f5$var$useInFlightRequests({
        setIsLoading: setIsLoading
    });
    const [_, startTransition] = (0, $eJOHy.useTransition)();
    return (0, $eJOHy.useCallback)((variables, options)=>{
        if (isMounted.current) setIsLoading?.(true);
        onNewRequest(variables);
        return (0, $j4oe4.fetchQuery)(environment, query, variables, {
            fetchPolicy: fetchPolicy,
            networkCacheConfig: networkCacheConfig
        }).subscribe({
            complete () {
                if (isMounted.current) {
                    if (startTransition) // we need concurrent mode for useTransition to work
                    startTransition(()=>{
                        setLastFetchError?.(null);
                        onRequestFinish(variables, ()=>{
                            refetch(variables, {
                                fetchPolicy: 'store-only'
                            });
                            options?.onComplete?.();
                        });
                    });
                    else {
                        setLastFetchError?.(null);
                        onRequestFinish(variables, ()=>{
                            refetch(variables, {
                                fetchPolicy: 'store-only'
                            });
                            options?.onComplete?.();
                        });
                    }
                }
            },
            error (e) {
                if (isMounted.current) onRequestFinish(variables, ()=>setLastFetchError?.(e));
            }
        });
    }, [
        environment,
        fetchPolicy,
        isMounted,
        networkCacheConfig,
        onNewRequest,
        onRequestFinish,
        query,
        refetch,
        setIsLoading,
        setLastFetchError,
        startTransition
    ]);
};
const $a5387c0f4da0e3f5$export$c7ce5f64dc007896 = (query, refetch, options)=>{
    const [isLoading, setIsLoading] = (0, $eJOHy.useState)(false);
    const [lastFetchError, setLastFetchError] = (0, $eJOHy.useState)(null);
    const refetchFunction = $a5387c0f4da0e3f5$export$ae1adabf094b2244(query, refetch, {
        ...options,
        setIsLoading: setIsLoading,
        setLastFetchError: setLastFetchError
    });
    return [
        refetchFunction,
        isLoading,
        lastFetchError
    ];
};

});
parcelRegister("4im1M", function(module, exports) {
$parcel$export(module.exports, "useIsMounted", () => $bb7ff1168b248128$export$80c2a3957bcb42ea);

var $eJOHy = parcelRequire("eJOHy");
const $bb7ff1168b248128$export$80c2a3957bcb42ea = ()=>{
    const isMounted = (0, $eJOHy.useRef)(true);
    (0, $eJOHy.useEffect)(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, [
        isMounted
    ]);
    return isMounted;
};

});


parcelRegister("3nL89", function(module, exports) {
$parcel$export(module.exports, "DocumentTitle", () => $8eb9deaadd9d6be8$export$dd5ad0b65cf665da);

var $19u1t = parcelRequire("19u1t");
const $8eb9deaadd9d6be8$export$dd5ad0b65cf665da = (0, $19u1t.DocumentTitleHelper);

});

// SCREENS
const $aa42ce8e355d58fa$export$f636b5b56f1d624a = 'Screen';
const $aa42ce8e355d58fa$export$9d2de6eebf7462b5 = 'Drawer';
const $aa42ce8e355d58fa$export$1171103ea9083ffa = 'Modal';
const $aa42ce8e355d58fa$export$cae2783c9279926 = 'InlineDialog';
const $aa42ce8e355d58fa$export$d1123261ca8831d2 = 'Dropdown';
const $aa42ce8e355d58fa$export$238d30785c4bca84 = 'Banner';
const $aa42ce8e355d58fa$export$a1562d08625f5d7e = 'UI';
const $aa42ce8e355d58fa$export$947dac6c72b26f81 = 'TRACK';
const $aa42ce8e355d58fa$export$f1d537d508d2945a = 'SCREEN';
const $aa42ce8e355d58fa$export$12346a674644c156 = 'OPERATIONAL';

parcelRegister("isHDA", function(module, exports) {
$parcel$export(module.exports, "ViewFeatureFlagsEmptyStateExperienceExperienceStart", () => $1b145896a74e2d71$export$dba6cce392699a2b);
$parcel$export(module.exports, "useViewFeatureFlagsEmptyStateExperienceExperienceFail", () => $1b145896a74e2d71$export$b0017a8c5a092f54);
$parcel$export(module.exports, "ViewFeatureFlagsEmptyStateExperienceExperienceSuccessTracker", () => $1b145896a74e2d71$export$c49eaa8e4e389a94);

var $eJOHy = parcelRequire("eJOHy");

var $aqnJa = parcelRequire("aqnJa");

var $8Uqf3 = parcelRequire("8Uqf3");

var $4ctwv = parcelRequire("4ctwv");

var $2aY2d = parcelRequire("2aY2d");

var $lBYgs = parcelRequire("lBYgs");

var $1BZ8a = parcelRequire("1BZ8a");
const $1b145896a74e2d71$var$EXPERIENCE_NAME = 'viewFeatureFlagsEmptyStateExperience';
const $1b145896a74e2d71$export$dba6cce392699a2b = ({ experienceId: experienceId })=>{
    const appEditions = (0, $1BZ8a.useAppEditions)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8Uqf3.ExperienceStart), {
        experienceId: experienceId,
        experience: $1b145896a74e2d71$var$EXPERIENCE_NAME,
        analyticsSource: "featureFlagsEmptyStateExperience",
        edition: appEditions.software,
        application: (0, $lBYgs.JIRA_SOFTWARE)
    });
};
const $1b145896a74e2d71$export$b0017a8c5a092f54 = ()=>(0, $aqnJa.useExperienceFail)({
        experience: $1b145896a74e2d71$var$EXPERIENCE_NAME
    });
const $1b145896a74e2d71$export$c49eaa8e4e389a94 = ()=>{
    const { data: projectContext } = (0, $2aY2d.useProjectContext)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4ctwv.ExperienceSuccess), {
        experience: $1b145896a74e2d71$var$EXPERIENCE_NAME,
        attributes: projectContext != null ? {
            projectId: projectContext.projectId,
            isProjectAdmin: projectContext.isProjectAdmin,
            simplified: projectContext.simplified
        } : undefined
    });
};

});

parcelRegister("jISVN", function(module, exports) {
$parcel$export(module.exports, "AddIssuesToVersion", () => $5a2da72f8a7d771c$export$bae9d11b7896e3f7);
/* async.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $goZPP = parcelRequire("goZPP");

var $dcLzM = parcelRequire("dcLzM");

var $4cTDP = parcelRequire("4cTDP");

var $lRq8t = parcelRequire("lRq8t");

var $2imLM = parcelRequire("2imLM");

var $bQWwW = parcelRequire("bQWwW");

var $86QDZ = parcelRequire("86QDZ");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $5a2da72f8a7d771c$var$LazyAddIssuesToVersion = (0, $bQWwW.lazy)(()=>(parcelRequire("3UPBX")).then((module)=>module.AddIssuesToVersion), {
    moduleId: "./src/packages/releases/add-issues-to-version/src/ui/index.tsx"
});
const $5a2da72f8a7d771c$export$bae9d11b7896e3f7 = (props)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const PlaceholderButton = props.isIssueListFooterButton ? $5a2da72f8a7d771c$var$IssueListFooterButton : (0, $goZPP.default);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "add-issues-to-version",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(PlaceholderButton, {
            onClick: undefined,
            appearance: props.appearance,
            type: "button",
            iconBefore: props.showIcon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dcLzM))), {
                label: ""
            }) : undefined
        }, formatMessage((0, $4cTDP.fg)('jira-issue-terminology-update-m4') ? (0, $86QDZ.default).addButtonIssueTerminologyRefreshM4 : (0, $86QDZ.default).addButton))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($5a2da72f8a7d771c$var$LazyAddIssuesToVersion, props));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5a2da72f8a7d771c$var$IssueListFooterButton = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = (0, $goZPP.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1kba1h6o _btpd1osq _1n7d1ylp _14741e5h",
            __cmplp.className
        ])
    });
});

});
parcelRegister("86QDZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $8c18b9cb1c911d5e$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $8c18b9cb1c911d5e$var$messages = (0, $7qGN1.defineMessages)({
    addButton: {
        "id": "software-releases-add-issues-to-version.add-button",
        "defaultMessage": "Add issues"
    },
    errorFlagTitle: {
        "id": "software-releases-add-issues-to-version.error-flag-title",
        "defaultMessage": "Can't add {totalCount, plural, one {issue} other {# issues}} to version"
    },
    errorFlagDescription: {
        "id": "software-releases-add-issues-to-version.error-flag-description",
        "defaultMessage": "Something went wrong. Please try again or contact your administrator if the problem persists."
    },
    successFlagDescription: {
        "id": "software-releases-add-issues-to-version.success-flag-description",
        "defaultMessage": "{issueCount, plural, one {# issue has been added} other {# issues have been added}}."
    },
    partialIssueFailureFlagTitle: {
        "id": "software-releases-add-issues-to-version.partial-issue-failure-flag-title",
        "defaultMessage": "{failedIssueCount} out of {totalCount} issues not added to version."
    },
    singleIssueMissingResolvePermFlagDescription: {
        "id": "software-releases-add-issues-to-version.single-issue-missing-resolve-perm-flag-description",
        "defaultMessage": "You don't have permission to resolve {issueKey}, so it wasn't added."
    },
    singleIssueMissingEditPermFlagDescription: {
        "id": "software-releases-add-issues-to-version.single-issue-missing-edit-perm-flag-description",
        "defaultMessage": "You don't have permission to edit {issueKey}, so it wasn't added."
    },
    singleIssueMissingPermsFlagDescription: {
        "id": "software-releases-add-issues-to-version.single-issue-missing-perms-flag-description",
        "defaultMessage": "You don't have permission to edit or resolve {issueKey}, so it wasn't added."
    },
    twoIssuesMissingResolvePermFlagDescription: {
        "id": "software-releases-add-issues-to-version.two-issues-missing-resolve-perm-flag-description",
        "defaultMessage": "You don't have permission to resolve {issueKey1} and {issueKey2}, so they weren't added."
    },
    twoIssuesMissingEditPermFlagDescription: {
        "id": "software-releases-add-issues-to-version.two-issues-missing-edit-perm-flag-description",
        "defaultMessage": "You don't have permission to edit {issueKey1} and {issueKey2}, so they weren't added."
    },
    twoIssuesMissingPermsFlagDescription: {
        "id": "software-releases-add-issues-to-version.two-issues-missing-perms-flag-description",
        "defaultMessage": "You don't have permission to edit or resolve {issueKey1} and {issueKey2}, so they weren't added."
    },
    multipleIssuesMissingResolvePermFlagDescription: {
        "id": "software-releases-add-issues-to-version.multiple-issues-missing-resolve-perm-flag-description",
        "defaultMessage": "You don't have permission to resolve {failedCount, plural, one {issue} other {# issues}}, so they weren't added."
    },
    multipleIssuesMissingEditPermFlagDescription: {
        "id": "software-releases-add-issues-to-version.multiple-issues-missing-edit-perm-flag-description",
        "defaultMessage": "You don't have permission to edit {failedCount, plural, one {issue} other {# issues}}, so they weren't added."
    },
    multipleIssuesMissingPermsFlagDescription: {
        "id": "software-releases-add-issues-to-version.multiple-issues-missing-perms-flag-description",
        "defaultMessage": "You don't have permission to edit or resolve {failedCount, plural, one {issue} other {# issues}}, so they weren't added."
    },
    addButtonIssueTerminologyRefreshM4: {
        "id": "software-releases-add-issues-to-version.add-button-issue-terminology-refresh-m4",
        "defaultMessage": "Add work items"
    },
    errorFlagTitleIssueTerminologyRefreshM4: {
        "id": "software-releases-add-issues-to-version.error-flag-title-issue-terminology-refresh-m4",
        "defaultMessage": "Can't add {totalCount, plural, one {work item} other {# work items}} to version"
    },
    successFlagDescriptionIssueTerminologyRefreshM4: {
        "id": "software-releases-add-issues-to-version.success-flag-description-issue-terminology-refresh-m4",
        "defaultMessage": "{issueCount, plural, one {# work item has been added} other {# work items have been added}}."
    },
    partialIssueFailureFlagTitleIssueTerminologyRefreshM4: {
        "id": "software-releases-add-issues-to-version.partial-issue-failure-flag-title-issue-terminology-refresh-m4",
        "defaultMessage": "{failedIssueCount} out of {totalCount} work items not added to version."
    },
    multipleIssuesMissingResolvePermFlagDescriptionIssueTerminologyRefreshM4: {
        "id": "software-releases-add-issues-to-version.multiple-issues-missing-resolve-perm-flag-description-issue-terminology-refresh-m4",
        "defaultMessage": "You don't have permission to resolve {failedCount, plural, one {work item} other {# work items}}, so they weren't added."
    },
    multipleIssuesMissingEditPermFlagDescriptionIssueTerminologyRefreshM4: {
        "id": "software-releases-add-issues-to-version.multiple-issues-missing-edit-perm-flag-description-issue-terminology-refresh-m4",
        "defaultMessage": "You don't have permission to edit {failedCount, plural, one {work item} other {# work items}}, so they weren't added."
    },
    multipleIssuesMissingPermsFlagDescriptionIssueTerminologyRefreshM4: {
        "id": "software-releases-add-issues-to-version.multiple-issues-missing-perms-flag-description-issue-terminology-refresh-m4",
        "defaultMessage": "You don't have permission to edit or resolve {failedCount, plural, one {work item} other {# work items}}, so they weren't added."
    }
});
var $8c18b9cb1c911d5e$export$2e2bcd8739ae039 = $8c18b9cb1c911d5e$var$messages;

});

parcelRegister("3UPBX", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("humlJ").then(()=>parcelRequire('kfHyZ'));

});


parcelRegister("9pemI", function(module, exports) {
$parcel$export(module.exports, "VersionApproversCardExperienceStart", () => $ad468ac588e1868d$export$e45410483a7f75f3);
$parcel$export(module.exports, "VersionApproversCardExperienceSuccess", () => $ad468ac588e1868d$export$664bc979971dec26);
$parcel$export(module.exports, "useVersionApproversCardExperienceFail", () => $ad468ac588e1868d$export$3edb8e7637e1d4cc);

var $eJOHy = parcelRequire("eJOHy");

var $aqnJa = parcelRequire("aqnJa");

var $8Uqf3 = parcelRequire("8Uqf3");

var $4ctwv = parcelRequire("4ctwv");

var $lBYgs = parcelRequire("lBYgs");

var $1BZ8a = parcelRequire("1BZ8a");
const $ad468ac588e1868d$export$52919046b94109dc = 'jiraVersionApproversCard';
const $ad468ac588e1868d$var$ANALYTICS_SOURCE = 'versionDetails';
const $ad468ac588e1868d$export$e45410483a7f75f3 = ()=>{
    const appEditions = (0, $1BZ8a.useAppEditions)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8Uqf3.ExperienceStart), {
        experienceId: `${Date.now()}`,
        experience: $ad468ac588e1868d$export$52919046b94109dc,
        analyticsSource: $ad468ac588e1868d$var$ANALYTICS_SOURCE,
        edition: appEditions.software,
        application: (0, $lBYgs.JIRA_SOFTWARE)
    });
};
const $ad468ac588e1868d$export$664bc979971dec26 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4ctwv.ExperienceSuccess), {
        experience: $ad468ac588e1868d$export$52919046b94109dc
    });
const $ad468ac588e1868d$export$3edb8e7637e1d4cc = ()=>(0, $aqnJa.useExperienceFail)({
        experience: $ad468ac588e1868d$export$52919046b94109dc
    });

});

parcelRegister("6IAqy", function(module, exports) {
$parcel$export(module.exports, "Approvers", () => $f1bc12442643e2d1$export$52f716ccfb37fc43);

var $cKjxj = parcelRequire("cKjxj");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $j4oe4 = parcelRequire("j4oe4");

var $goZPP = parcelRequire("goZPP");

var $dcLzM = parcelRequire("dcLzM");

var $2bMVP = parcelRequire("2bMVP");

var $lRq8t = parcelRequire("lRq8t");

var $2imLM = parcelRequire("2imLM");

var $bQWwW = parcelRequire("bQWwW");
var $8CQpJ = parcelRequire("8CQpJ");


var $3tCgf = parcelRequire("3tCgf");
const $f1bc12442643e2d1$var$PADDING_SIZE = 24;
const $f1bc12442643e2d1$var$BORDER_SIZE = 1;
const $f1bc12442643e2d1$var$WIDTH_OFFSET = ($f1bc12442643e2d1$var$PADDING_SIZE + $f1bc12442643e2d1$var$BORDER_SIZE) * 2;

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $f1bc12442643e2d1$var$LazyApprovers = (0, $bQWwW.lazyAfterPaint)(()=>(parcelRequire("hG280")).then((module)=>module.Approvers), {
    ssr: false,
    moduleId: "./src/packages/releases/approvers/src/ui/index.tsx"
});
const $f1bc12442643e2d1$export$52f716ccfb37fc43 = ({ jiraVersion: jiraVersion, userProjectPermissions: userProjectPermissions })=>{
    const { startNextPhase: startNextPhase } = (0, $8CQpJ.useLazyPhase)();
    (0, $eJOHy.useEffect)(()=>{
        startNextPhase();
    }, [
        startNextPhase
    ]);
    const version = (0, $j4oe4.useFragment)((0, $cKjxj.default), jiraVersion);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const numberOfApproversToShow = (0, $7e6f475fa286346e$export$ab69ec32c8e056d0);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "releases-approvers",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f1bc12442643e2d1$var$ApproversCardWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f1bc12442643e2d1$var$Header, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f1bc12442643e2d1$var$ApproversTitle, null, formatMessage((0, $3tCgf.default).approversTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dcLzM))), {
                label: ""
            }),
            appearance: "subtle"
        })), [
            ...Array(numberOfApproversToShow).keys()
        ].map((i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2bMVP.default), {
                key: i,
                isShimmering: true,
                hasAvatar: true
            })))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f1bc12442643e2d1$var$LazyApprovers, {
        jiraVersion: version,
        userProjectPermissions: userProjectPermissions
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $f1bc12442643e2d1$var$ApproversTitle = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_11c82smr _1e0c1txw _4cvr1h6o _k48p1pd9 _syazi7uo",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $f1bc12442643e2d1$var$Header = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _1bah1yb4",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $f1bc12442643e2d1$var$ApproversCardWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_zulppxbi _1reo1wug _18m91wug _p12fpjzf _c71l842n _ca0q1ejb _u5f31ejb _n3td1ejb _19bv1ejb",
            __cmplp.className
        ])
    });
});

});
parcelRegister("cKjxj", function(module, exports) {
$parcel$export(module.exports, "default", () => $460b0f283b5c5381$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d9002c0d697d345d76c64fe0f6d5cbf8>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $460b0f283b5c5381$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "async_softwareReleasesApprovers_Approvers",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "ui_softwareReleasesApprovers_Approvers"
        }
    ],
    "type": "JiraVersion"
};
$460b0f283b5c5381$var$node.hash = "b54447a983203e9751ad03d69a14f12e";
var $460b0f283b5c5381$export$2e2bcd8739ae039 = $460b0f283b5c5381$var$node;

});

const $7e6f475fa286346e$export$ab69ec32c8e056d0 = 5;

parcelRegister("3tCgf", function(module, exports) {
$parcel$export(module.exports, "default", () => $a78023d47befa559$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $a78023d47befa559$var$messages = (0, $7qGN1.defineMessages)({
    approversTitle: {
        "id": "software-releases-approvers.approvers-title",
        "defaultMessage": "Approvers"
    },
    noApproversMessage: {
        "id": "software-releases-approvers.no-approvers-message",
        "defaultMessage": "No approvers have been added"
    },
    showMore: {
        "id": "software-releases-approvers.show-more",
        "defaultMessage": "Show all approvers"
    },
    showLess: {
        "id": "software-releases-approvers.show-less",
        "defaultMessage": "Show less"
    },
    addApproversAriaLabel: {
        "id": "software-releases-approvers.add-approvers-aria-label",
        "defaultMessage": "Add approvers"
    }
});
var $a78023d47befa559$export$2e2bcd8739ae039 = $a78023d47befa559$var$messages;

});

parcelRegister("hG280", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("6Snnz").then(()=>parcelRequire('jGaYM'));

});


parcelRegister("i6OEF", function(module, exports) {
$parcel$export(module.exports, "useSidebarStore", () => $aa7c243affa8d7a0$export$118f45a8309a4356);
$parcel$export(module.exports, "useSidebarActions", () => $aa7c243affa8d7a0$export$685a45ff9d61633f);

var $9qgax = parcelRequire("9qgax");

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");
const { CLOSED: $aa7c243affa8d7a0$var$CLOSED, SHOWING_ISSUE: $aa7c243affa8d7a0$var$SHOWING_ISSUE } = (0, $9qgax.SidebarStatuses);
const $aa7c243affa8d7a0$var$initialState = {
    state: {
        status: $aa7c243affa8d7a0$var$CLOSED
    }
};
const $aa7c243affa8d7a0$export$e324594224ef24da = {
    close: ()=>({ setState: setState })=>setState({
                state: {
                    status: $aa7c243affa8d7a0$var$CLOSED
                }
            }),
    showIssue: (issueKey)=>({ setState: setState })=>setState({
                state: {
                    status: $aa7c243affa8d7a0$var$SHOWING_ISSUE,
                    issueKey: issueKey
                }
            })
};
const $aa7c243affa8d7a0$var$Store = (0, $GtRbT.createStore)({
    name: 'versionDetailsSidebarStore',
    initialState: $aa7c243affa8d7a0$var$initialState,
    actions: $aa7c243affa8d7a0$export$e324594224ef24da
});
const $aa7c243affa8d7a0$var$useStore = (0, $iJq0l.createHook)($aa7c243affa8d7a0$var$Store);
const $aa7c243affa8d7a0$export$118f45a8309a4356 = ()=>{
    const [{ state: state }, sidebarActions] = $aa7c243affa8d7a0$var$useStore();
    return [
        state,
        sidebarActions
    ];
};
const $aa7c243affa8d7a0$var$useSidebarWithoutState = (0, $iJq0l.createHook)($aa7c243affa8d7a0$var$Store, {
    selector: null
});
const $aa7c243affa8d7a0$export$685a45ff9d61633f = ()=>{
    const [, sidebarActions] = $aa7c243affa8d7a0$var$useSidebarWithoutState();
    return sidebarActions;
};

});
parcelRegister("9qgax", function(module, exports) {
$parcel$export(module.exports, "SidebarStatuses", () => $15e064b74956f236$export$a4b0bca2b71ad188);
const $15e064b74956f236$var$CLOSED = 'CLOSED';
const $15e064b74956f236$var$SHOWING_ISSUE = 'SHOWING_ISSUE';
const $15e064b74956f236$export$a4b0bca2b71ad188 = {
    CLOSED: $15e064b74956f236$var$CLOSED,
    SHOWING_ISSUE: $15e064b74956f236$var$SHOWING_ISSUE
};

});


parcelRegister("u9Pim", function(module, exports) {
$parcel$export(module.exports, "IssueSidebar", () => $4dade758710d5039$export$cd07ab049c87f027);
/* IssueSidebar.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $9qgax = parcelRequire("9qgax");

var $i6OEF = parcelRequire("i6OEF");

var $aFdXL = parcelRequire("aFdXL");
const $4dade758710d5039$export$cd07ab049c87f027 = ()=>{
    const [sidebarState] = (0, $i6OEF.useSidebarStore)();
    const isOpen = sidebarState.status !== (0, $9qgax.SidebarStatuses).CLOSED;
    return isOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($4dade758710d5039$var$IssueSidebarContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aFdXL.SidebarContent), null)) : null;
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4dade758710d5039$var$IssueSidebarContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_4t3i1osq _kqswh2mm _ca0qidpf _u5f3idpf _n3tdpxbi _19bvidpf _vchhusvi _bfhk1w7a _1bsblti4 _p12flti4",
            __cmplp.className
        ])
    });
});

});
parcelRegister("aFdXL", function(module, exports) {
$parcel$export(module.exports, "SidebarContent", () => $35351f91b7817838$export$49e8f7b58a4df4ea);

var $eJOHy = parcelRequire("eJOHy");

var $9qgax = parcelRequire("9qgax");

var $i6OEF = parcelRequire("i6OEF");

var $43hCz = parcelRequire("43hCz");
const $35351f91b7817838$export$49e8f7b58a4df4ea = ()=>{
    const [sidebarState, sidebarActions] = (0, $i6OEF.useSidebarStore)();
    const onClose = sidebarActions.close;
    switch(sidebarState.status){
        case (0, $9qgax.SidebarStatuses).CLOSED:
            return null;
        case (0, $9qgax.SidebarStatuses).SHOWING_ISSUE:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $43hCz.Issue), {
                issueKey: sidebarState.issueKey,
                onClose: onClose
            });
        default:
            // prettier-ignore
            // @ts-expect-error - TS2339 - Property 'status' does not exist on type 'never'.
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            sidebarState.status;
            throw Error('Unhandled sidebar status');
    }
};

});
parcelRegister("43hCz", function(module, exports) {
$parcel$export(module.exports, "Issue", () => $df09478f850a50ac$export$c175600e334513b4);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");


var $2imLM = parcelRequire("2imLM");

var $kGj4V = parcelRequire("kGj4V");

var $8tQys = parcelRequire("8tQys");

var $bQWwW = parcelRequire("bQWwW");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $df09478f850a50ac$var$IssueApp = (0, $bQWwW.lazy)(()=>(parcelRequire("5pAUa")), {
    moduleId: "./src/packages/issue/issue-view/src/views/issue-details/issue-app.tsx"
});
const $df09478f850a50ac$export$c175600e334513b4 = ({ issueKey: issueKey, onClose: onClose })=>{
    const { refetch: refetch } = (0, $8tQys.useRefetchContext)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kGj4V.ContextualAnalyticsData), {
        sourceType: (0, $aa42ce8e355d58fa$export$f636b5b56f1d624a),
        sourceName: "versionDetailsIssue"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($df09478f850a50ac$var$DetailsWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "issue-app",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($df09478f850a50ac$var$IssueApp, {
        viewModeOptions: {
            viewMode: 'SIDEBAR'
        },
        issueKey: issueKey,
        shouldSetInitialFocus: true,
        shouldShowCloseButton: true // TODO: Once all fields used in the issue link component and the version
        ,
        // details issue list have been migrated to use Relay, we should be able to
        // remove the onChange callback used here, since the data will sync to the
        // Relay store without having to call "refetch" here
        onChange: (event)=>{
            if (event.type === 'FIELD_CHANGED') refetch();
        },
        onIssueDeleteSuccess: refetch,
        onClose: onClose,
        isLoadedWithPage: false,
        isSpaEnabled: false,
        analyticsSource: (0, $1791521efc556332$export$5b73d694a6048002)
    }))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $df09478f850a50ac$var$DetailsWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1bsb1osq _4t3i1osq _1reo15vq",
            __cmplp.className
        ])
    });
});

});
const $1791521efc556332$export$53d41ff2666118e1 = 'agility-backlog';
const $1791521efc556332$export$7552fe2669628499 = 'bitbucket-issue';
const $1791521efc556332$export$41a718da0a8636f4 = 'connect-issue';
const $1791521efc556332$export$cebf0bc8b2ccaf57 = 'core-issue';
const $1791521efc556332$export$5e91e17726e54450 = 'jiraCalendar';
const $1791521efc556332$export$2dac1950892123f5 = 'jiraTimeline';
const $1791521efc556332$export$82540942fb014b0a = 'business-calendar';
const $1791521efc556332$export$7ca28938a07e0c33 = 'business-list';
const $1791521efc556332$export$f6cf06aaaeb58a54 = 'business-timeline';
const $1791521efc556332$export$b2c0462ff17aa26e = 'business-board';
const $1791521efc556332$export$a607850ebccd28ac = 'business-approvals';
const $1791521efc556332$export$1da6cede3561048f = 'business-files';
const $1791521efc556332$export$b19f949fb9713614 = 'full-issue';
const $1791521efc556332$export$a5132300c5214280 = 'embed-issue';
const $1791521efc556332$export$710114090a811b37 = 'global-issue-navigator-issue';
const $1791521efc556332$export$ce88447986394f2d = 'mobile-issue';
const $1791521efc556332$export$6a90d9196d330040 = 'project-issue-navigator';
const $1791521efc556332$export$2247c9059c171db1 = 'roadmap-issue';
const $1791521efc556332$export$cd16d39c55c569d0 = 'simple-software-board';
const $1791521efc556332$export$f72626bf0d75dfad = 'software-backlog-issue';
const $1791521efc556332$export$778b4609e784cb27 = 'software-deployments-issue';
const $1791521efc556332$export$5b73d694a6048002 = 'version-detail-issue';
const $1791521efc556332$export$accce97178e4e049 = 'software-cycle-time-report-issue';
const $1791521efc556332$export$21b5b7189add7861 = 'software-incidents-issue';
const $1791521efc556332$export$9c5d81b901471b27 = 'software-issue';
const $1791521efc556332$export$1735f6ad917dc411 = 'change-calendar';
const $1791521efc556332$export$7063ee6d0035a982 = 'queues-issue-view';
const $1791521efc556332$export$5bd5011b6596a0e7 = 'reports-issue-view';
const $1791521efc556332$export$9dfa9e993d3e0520 = 'forge-full-page-extension';
const $1791521efc556332$export$14a8072f422804fd = 'issue-navigator-next';
const $1791521efc556332$export$cd2e8394c029507b = 'issue-navigator-detail-view';
const $1791521efc556332$export$5f3c20fe2ff6c0a2 = 'staffing-issue';
const $1791521efc556332$export$9dac02c804d7acd8 = 'classic-software-board';

parcelRegister("8tQys", function(module, exports) {
$parcel$export(module.exports, "RefetchContext", () => $c61e187323549176$export$9943e630ea9ac16a);
$parcel$export(module.exports, "useRefetchContext", () => $c61e187323549176$export$947d5554caab689a);

var $eJOHy = parcelRequire("eJOHy");
const $c61e187323549176$export$9943e630ea9ac16a = /*#__PURE__*/ (0, $eJOHy.createContext)(null);
const $c61e187323549176$export$947d5554caab689a = ()=>{
    const refetchContext = (0, $eJOHy.useContext)($c61e187323549176$export$9943e630ea9ac16a);
    if (refetchContext == null) throw new Error('Version details refetch provider was not found');
    return refetchContext;
};

});

parcelRegister("5pAUa", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");













module.exports = Promise.all([
    (parcelRequire("g81qY"))('thor_add_taskabort_events_for_core_experiences', function() {
        return Promise.all([
            (parcelRequire("g81qY"))('smart_access_unified_deadend', function() {
                return Promise.all([
                    $ewTvA("116M9")
                ]);
            }, function() {
                return Promise.all([
                    $ewTvA("dZIaf")
                ]);
            }),
            $ewTvA("gVlCg")
        ]);
    }, function() {
        return Promise.all([
            (parcelRequire("g81qY"))('smart_access_unified_deadend', function() {
                return Promise.all([
                    $ewTvA("116M9")
                ]);
            }, function() {
                return Promise.all([
                    $ewTvA("dZIaf")
                ]);
            }),
            $ewTvA("c687B")
        ]);
    }),
    (parcelRequire("g81qY"))('smart_access_unified_deadend', function() {
        return Promise.all([
            $ewTvA("116M9")
        ]);
    }, function() {
        return Promise.all([
            $ewTvA("dZIaf")
        ]);
    }),
    (parcelRequire("g81qY"))('jiv-20591-renderer-rerenders-fix-refactor', function() {
        return Promise.all([
            $ewTvA("fo1Iu"),
            $ewTvA("kvRbA"),
            $ewTvA("ffQaD"),
            $ewTvA("l253H"),
            $ewTvA("76n7a"),
            $ewTvA("fliVL"),
            $ewTvA("kNFvF")
        ]);
    }, function() {
        return Promise.all([
            $ewTvA("2tXQt"),
            $ewTvA("kvRbA"),
            $ewTvA("ffQaD"),
            $ewTvA("l253H"),
            $ewTvA("76n7a"),
            $ewTvA("fliVL"),
            $ewTvA("kNFvF")
        ]);
    }),
    (parcelRequire("g81qY"))('jira_amplitude_sr', function() {
        return Promise.all([
            $ewTvA("5g4nt"),
            $ewTvA("kVX56")
        ]);
    }, function() {
        return Promise.all([
            $ewTvA("j3b6X")
        ]);
    }),
    (parcelRequire("g81qY"))('ssring_affected_services_in_issue_view', function() {
        return Promise.all([
            (parcelRequire("g81qY"))('empanada_profilecard_sync_trigger_import_final', function() {
                return Promise.all([
                    $ewTvA("4yYgJ")
                ]);
            }, function() {
                return Promise.all([
                    $ewTvA("6Z32B")
                ]);
            }),
            $ewTvA("72RZh"),
            $ewTvA("kvRbA"),
            $ewTvA("ffQaD"),
            $ewTvA("l253H"),
            $ewTvA("76n7a"),
            $ewTvA("kNFvF")
        ]);
    }, function() {
        return Promise.all([
            $ewTvA("a1MLa")
        ]);
    }),
    (parcelRequire("g81qY"))('jiv-20508-remove-height-animation-dev-panel', function() {
        return Promise.all([
            $ewTvA("iQLT5")
        ]);
    }, function() {
        return Promise.all([]);
    }),
    (parcelRequire("g81qY"))('jira_assignable_agent_session_experience', function() {
        return Promise.all([
            $ewTvA("8IUG7"),
            $ewTvA("l253H"),
            $ewTvA("76n7a"),
            $ewTvA("kNFvF"),
            $ewTvA("kvRbA"),
            $ewTvA("ffQaD")
        ]);
    }, function() {
        return Promise.all([
            $ewTvA("k0W2A")
        ]);
    }),
    (parcelRequire("g81qY"))('jira_issue_next_best_actions_fg', function() {
        return Promise.all([
            $ewTvA("9nhJS")
        ]);
    }, function() {
        return Promise.all([
            $ewTvA("asI48")
        ]);
    }),
    (parcelRequire("g81qY"))('fy26_nike_box_bundle_decrease_project', function() {
        return Promise.all([
            $ewTvA("8LUjY")
        ]);
    }, function() {
        return Promise.all([
            (parcelRequire("g81qY"))('fy26_nike_box_bundle_decrease_project', function() {
                return Promise.all([
                    $ewTvA("lpg1K"),
                    $ewTvA("kvRbA"),
                    $ewTvA("ffQaD")
                ]);
            }, function() {
                return Promise.all([
                    $ewTvA("8D3kc"),
                    $ewTvA("kvRbA"),
                    $ewTvA("ffQaD"),
                    $ewTvA("kVX56")
                ]);
            }),
            $ewTvA("jbyHU")
        ]);
    }),
    $ewTvA("isfJL"),
    $ewTvA("b3QiB"),
    $ewTvA("3yAl4"),
    $ewTvA("jbxE1"),
    $ewTvA("7imUH"),
    $ewTvA("fliVL"),
    $ewTvA("kVX56"),
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("kNFvF"),
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("lDuOD")
]).then(()=>parcelRequire('kq6nk'));

});
parcelRegister("g81qY", function(module, exports) {
"use strict";

var $9VDxJ = parcelRequire("9VDxJ");
var $bbde81794392820b$require$getBundleURL = $9VDxJ.getBundleURL;

var $iTG8W = parcelRequire("iTG8W");
var $bbde81794392820b$require$resolve = $iTG8W.resolve;
module.exports = function loadCond(cond, ifTrue, ifFalse, fallback) {
    let result = globalThis.__MCOND(cond);
    try {
        return result ? ifTrue() : ifFalse();
    } catch (err) {
        if (fallback) {
            globalThis.__ATLASPACK_ERRORS = globalThis.__ATLASPACK_ERRORS || [];
            globalThis.__ATLASPACK_ERRORS.push(new Error(`Sync dependency fallback triggered for condition "${cond}": ${err.message}`));
            for (const id of fallback.i)fallback.l(new URL($bbde81794392820b$require$resolve(id), $bbde81794392820b$require$getBundleURL(id)).toString());
            return result ? ifTrue() : ifFalse();
        } else throw err;
    }
};

});
parcelRegister("9VDxJ", function(module, exports) {
$parcel$export(module.exports, "getBundleURL", () => $73a81c5f1e1fde26$export$bdfd709ae4826697, (v) => $73a81c5f1e1fde26$export$bdfd709ae4826697 = v);
// TODO: convert this file to ESM once HMR issues are resolved
var $73a81c5f1e1fde26$export$5a759dc7a1cfb72a;
var $73a81c5f1e1fde26$export$bdfd709ae4826697;
var $73a81c5f1e1fde26$export$c9e73fbda7da57b6;
"use strict";
const $73a81c5f1e1fde26$var$stackTraceUrlRegexp = /(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g;
const $73a81c5f1e1fde26$var$bundleURL = {};
/**
 * Retrieves the cached bundle URL for a given identifier.
 * If the URL is not cached, it computes and stores it in the cache.
 *
 * @param {string} id - The identifier for the bundle.
 * @param {Error?} inputError - An error object to extract the stack trace from
 * (for testing purposes).
 * @returns {string} The URL of the bundle, without file name.
 */ function $73a81c5f1e1fde26$var$getBundleURLCached(id, inputError) {
    let value = $73a81c5f1e1fde26$var$bundleURL[id];
    if (!value) {
        value = $73a81c5f1e1fde26$var$getBundleURL(inputError);
        $73a81c5f1e1fde26$var$bundleURL[id] = value;
    }
    return value;
}
/** Get the URL without the filename (last / segment)
 *
 * @param {string} url
 * @returns {string} The URL with the file name removed
 */ function $73a81c5f1e1fde26$var$getBaseURL(url) {
    return url.slice(0, url.lastIndexOf('/')) + '/';
}
function $73a81c5f1e1fde26$var$getBundleURL(inputError) {
    try {
        throw inputError ?? new Error();
    } catch (err) {
        var matches = ('' + err.stack).match($73a81c5f1e1fde26$var$stackTraceUrlRegexp);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $73a81c5f1e1fde26$var$getBaseURL(matches[2]);
    }
    return '/';
}
/**
 * @param {string} url
 * @returns {string}
 */ function $73a81c5f1e1fde26$var$getOrigin(url) {
    return new URL(url).origin;
}
$73a81c5f1e1fde26$export$5a759dc7a1cfb72a = $73a81c5f1e1fde26$var$getOrigin;
$73a81c5f1e1fde26$export$bdfd709ae4826697 = $73a81c5f1e1fde26$var$getBundleURLCached;
$73a81c5f1e1fde26$export$c9e73fbda7da57b6 = $73a81c5f1e1fde26$var$getBaseURL;

});






parcelRegister("VZ8eB", function(module, exports) {
$parcel$export(module.exports, "LaunchCardExperienceStart", () => $38e27ac782d2e0de$export$5715f82a8f696e44);
$parcel$export(module.exports, "LaunchCardExperienceSuccess", () => $38e27ac782d2e0de$export$8e01269c24812c16);
$parcel$export(module.exports, "useLaunchCardExperienceFail", () => $38e27ac782d2e0de$export$207918c16c60fcae);

var $eJOHy = parcelRequire("eJOHy");

var $aqnJa = parcelRequire("aqnJa");

var $8Uqf3 = parcelRequire("8Uqf3");

var $4ctwv = parcelRequire("4ctwv");

var $lBYgs = parcelRequire("lBYgs");

var $1BZ8a = parcelRequire("1BZ8a");
const $38e27ac782d2e0de$export$52919046b94109dc = 'launchCard';
const $38e27ac782d2e0de$var$ANALYTICS_SOURCE = 'versionDetails';
const $38e27ac782d2e0de$export$5715f82a8f696e44 = ()=>{
    const appEditions = (0, $1BZ8a.useAppEditions)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8Uqf3.ExperienceStart), {
        experienceId: `${Date.now()}`,
        experience: $38e27ac782d2e0de$export$52919046b94109dc,
        analyticsSource: $38e27ac782d2e0de$var$ANALYTICS_SOURCE,
        edition: appEditions.software,
        application: (0, $lBYgs.JIRA_SOFTWARE)
    });
};
const $38e27ac782d2e0de$export$8e01269c24812c16 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4ctwv.ExperienceSuccess), {
        experience: $38e27ac782d2e0de$export$52919046b94109dc
    });
const $38e27ac782d2e0de$export$207918c16c60fcae = ()=>(0, $aqnJa.useExperienceFail)({
        experience: $38e27ac782d2e0de$export$52919046b94109dc
    });

});

parcelRegister("cpzb3", function(module, exports) {
$parcel$export(module.exports, "LaunchCard", () => $13b08a105ef2ee95$export$1c9fa03e23146e86);

var $lQrIt = parcelRequire("lQrIt");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $2imLM = parcelRequire("2imLM");

var $bQWwW = parcelRequire("bQWwW");
var $8CQpJ = parcelRequire("8CQpJ");

var $lRlwf = parcelRequire("lRlwf");

var $4Ji46 = parcelRequire("4Ji46");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $13b08a105ef2ee95$var$LazyLaunchCard = (0, $bQWwW.lazyAfterPaint)(()=>Promise.resolve((parcelRequire("lRlwf"))).then((module)=>module.LaunchCard), {
    ssr: false,
    moduleId: "./src/packages/releases/launch-card/src/ui/index.tsx"
});
const $13b08a105ef2ee95$export$669f6ea7d267feaf = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4Ji46.LoadingWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lRlwf.BaseWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lRlwf.MainContentWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4Ji46.StatusLoading), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4Ji46.TwoColumnFieldWrapper), {
        height: 63
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4Ji46.FieldLoadingWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4Ji46.FieldLabelLoading), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4Ji46.FieldContentLoading), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4Ji46.FieldLoadingWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4Ji46.FieldLabelLoading), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4Ji46.FieldContentLoading), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4Ji46.TwoColumnFieldWrapper), {
        height: 52
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4Ji46.FieldLoadingWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4Ji46.FieldLabelLoading), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4Ji46.FieldContentLoading), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4Ji46.FieldLoadingWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4Ji46.FieldLabelLoading), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4Ji46.FieldContentLoading), null))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4Ji46.LatestDeploymentLoading), null));
const $13b08a105ef2ee95$export$1c9fa03e23146e86 = ({ jiraVersion: jiraVersion })=>{
    const { startNextPhase: startNextPhase } = (0, $8CQpJ.useLazyPhase)();
    (0, $eJOHy.useEffect)(()=>{
        startNextPhase();
    }, [
        startNextPhase
    ]);
    const version = (0, $j4oe4.useFragment)((0, $lQrIt.default), jiraVersion);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "version-detail-launch-card",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($13b08a105ef2ee95$export$669f6ea7d267feaf, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($13b08a105ef2ee95$var$LazyLaunchCard, {
        jiraVersion: version
    }));
};

});
parcelRegister("lQrIt", function(module, exports) {
$parcel$export(module.exports, "default", () => $618b10ae6304b5cf$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f0fe1a4283ec3216e0228279fe31b9ed>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $618b10ae6304b5cf$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "async_softwareReleasesLaunchCard_LaunchCard",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "ui_softwareReleasesLaunchCard_LaunchCard"
        }
    ],
    "type": "JiraVersion"
};
$618b10ae6304b5cf$var$node.hash = "ed744d145282aafc0de30b038a930975";
var $618b10ae6304b5cf$export$2e2bcd8739ae039 = $618b10ae6304b5cf$var$node;

});

parcelRegister("lRlwf", function(module, exports) {
$parcel$export(module.exports, "LaunchCard", () => $df70a3f77749606b$export$1c9fa03e23146e86);
$parcel$export(module.exports, "BaseWrapper", () => $df70a3f77749606b$export$c07bd9612bb2b971);
$parcel$export(module.exports, "MainContentWrapper", () => $df70a3f77749606b$export$7f55214bcae58e5d);

var $iQqYR = parcelRequire("iQqYR");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $j4oe4 = parcelRequire("j4oe4");

var $2imLM = parcelRequire("2imLM");

var $kGj4V = parcelRequire("kGj4V");
var $eS29z = parcelRequire("eS29z");

var $jom8W = parcelRequire("jom8W");

var $756De = parcelRequire("756De");

var $l1SLp = parcelRequire("l1SLp");

var $30pmy = parcelRequire("30pmy");

var $VZ8eB = parcelRequire("VZ8eB");

var $6rYRI = parcelRequire("6rYRI");

var $b0nGU = parcelRequire("b0nGU");

var $aPeIb = parcelRequire("aPeIb");

var $eJ7OA = parcelRequire("eJ7OA");

var $6FPEi = parcelRequire("6FPEi");

var $e1cyj = parcelRequire("e1cyj");
const $df70a3f77749606b$export$1c9fa03e23146e86 = ({ jiraVersion: jiraVersion })=>{
    const version = (0, $j4oe4.useFragment)((0, $iQqYR.default), jiraVersion);
    const [contributorsQueryRef, loadContributorsQuery] = (0, $j4oe4.useQueryLoader)((0, $b0nGU.default));
    const [preconditionQueryRef, loadPreconditionQuery] = (0, $j4oe4.useQueryLoader)((0, $6rYRI.default));
    (0, $eJOHy.useEffect)(()=>{
        if (!(0, $jom8W.isDevopsFeatureDisabledInFedRamp)()) {
            loadContributorsQuery({
                versionId: version.id
            });
            loadPreconditionQuery({
                cloudId: version.project.cloudId,
                projectKey: version.project.key
            });
        }
    }, [
        loadPreconditionQuery,
        loadContributorsQuery,
        version.project.cloudId,
        version.project.key,
        version.id
    ]);
    const hasDriver = version.driverData?.driver?.id;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kGj4V.ContextualAnalyticsData), {
        sourceType: (0, $aa42ce8e355d58fa$export$f636b5b56f1d624a),
        sourceName: "launchCard"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eS29z.FireScreenAnalytics), {
        attributes: {
            hasDriver: Boolean(hasDriver),
            versionAri: version.id
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($df70a3f77749606b$export$c07bd9612bb2b971, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $VZ8eB.LaunchCardExperienceSuccess), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($df70a3f77749606b$export$7f55214bcae58e5d, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $e1cyj.AsyncVersionStatus), {
        jiraVersion: version
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6FPEi.VersionDates), {
        jiraVersion: version
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($df70a3f77749606b$var$UserFieldsContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($df70a3f77749606b$var$FieldWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $30pmy.NonCriticalErrorBoundary), {
        eventLocation: "launchCardDriverField",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $756De.DriverField), {
        id: "jira-version-driver-field",
        jiraVersion: version,
        isDisabled: !version.canEdit
    }))), !(0, $jom8W.isDevopsFeatureDisabledInFedRamp)() && contributorsQueryRef && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $30pmy.NonCriticalErrorBoundary), {
        eventLocation: "launchCardContributorsField",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "version-contributors-section",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJ7OA.VersionContributorsSectionSkeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJ7OA.AsyncVersionContributors), {
        queryRef: contributorsQueryRef
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $l1SLp.VersionSummaryDescription), {
        jiraVersion: version
    })), !(0, $jom8W.isDevopsFeatureDisabledInFedRamp)() && preconditionQueryRef && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $30pmy.NonCriticalErrorBoundary), {
        eventLocation: "launchCardLatestDeployment",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "latest-deployment",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aPeIb.LatestDeployment), {
        jiraVersion: version,
        preconditionQueryRef: preconditionQueryRef
    })))));
};
const $df70a3f77749606b$export$c07bd9612bb2b971 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _2lx21bp4 _1tke18pt",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $df70a3f77749606b$export$7f55214bcae58e5d = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_zulppxbi _1e0c1txw _2lx21bp4 _ca0q1ejb _u5f31ejb _n3td1ejb _19bv1ejb",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $df70a3f77749606b$var$UserFieldsContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_zulpu2gc _1e0c1txw _1bah1yb4",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $df70a3f77749606b$var$FieldWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _prventd2",
            __cmplp.className
        ])
    });
});

});
parcelRegister("iQqYR", function(module, exports) {
$parcel$export(module.exports, "default", () => $cd489f9b464388fe$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f96eb60322e20c3737f125a0da9e9580>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $cd489f9b464388fe$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "isDevopsFeatureDisabledInFedRamp"
            }
        ],
        "kind": "Fragment",
        "name": "ui_softwareReleasesLaunchCard_LaunchCard",
        "selections": [
            {
                "condition": "isDevopsFeatureDisabledInFedRamp",
                "kind": "Condition",
                "passingValue": false,
                "selections": [
                    {
                        "kind": "FragmentSpread",
                        "name": "latestDeployment_softwareReleasesLaunchCard_jiraVersion"
                    }
                ]
            },
            {
                "kind": "FragmentSpread",
                "name": "versionDates_softwareReleasesLaunchCard"
            },
            {
                "kind": "FragmentSpread",
                "name": "async_softwareReleasesLaunchCard_AsyncVersionStatus"
            },
            {
                "kind": "FragmentSpread",
                "name": "ui_softwareReleasesVersionDriverField_DriverField"
            },
            {
                "kind": "FragmentSpread",
                "name": "ui_softwareReleasesVersionSummaryDescription_VersionSummaryDescription"
            },
            {
                "kind": "RequiredField",
                "field": v0 /*: any*/ ,
                "action": "THROW",
                "path": "id"
            },
            {
                "concreteType": "JiraVersionDriverResult",
                "kind": "LinkedField",
                "name": "driverData",
                "plural": false,
                "selections": [
                    {
                        "kind": "LinkedField",
                        "name": "driver",
                        "plural": false,
                        "selections": [
                            v0 /*: any*/ 
                        ]
                    }
                ]
            },
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "ScalarField",
                    "name": "canEdit"
                },
                "action": "THROW",
                "path": "canEdit"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "concreteType": "JiraProject",
                    "kind": "LinkedField",
                    "name": "project",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "kind": "ScalarField",
                                "name": "cloudId"
                            },
                            "action": "THROW",
                            "path": "project.cloudId"
                        },
                        {
                            "kind": "RequiredField",
                            "field": {
                                "kind": "ScalarField",
                                "name": "key"
                            },
                            "action": "THROW",
                            "path": "project.key"
                        }
                    ]
                },
                "action": "THROW",
                "path": "project"
            }
        ],
        "type": "JiraVersion"
    };
}();
$cd489f9b464388fe$var$node.hash = "d06ed52a13ffedc171f425ef28503077";
var $cd489f9b464388fe$export$2e2bcd8739ae039 = $cd489f9b464388fe$var$node;

});

parcelRegister("756De", function(module, exports) {
$parcel$export(module.exports, "DriverFieldStateless", () => $67f922ef03441a34$export$9ede53742ae13d69);
$parcel$export(module.exports, "DriverField", () => $67f922ef03441a34$export$4de1488fc0a2d937);

var $2DKyN = parcelRequire("2DKyN");

var $hw20x = parcelRequire("hw20x");

var $ahwgx = parcelRequire("ahwgx");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $j4oe4 = parcelRequire("j4oe4");

var $3cMgR = parcelRequire("3cMgR");

var $ewHZ5 = parcelRequire("ewHZ5");

var $9pTd3 = parcelRequire("9pTd3");

var $cSXp8 = parcelRequire("cSXp8");

var $lRq8t = parcelRequire("lRq8t");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $cHtIB = parcelRequire("cHtIB");

var $7YvOT = parcelRequire("7YvOT");

var $djnMS = parcelRequire("djnMS");
const $67f922ef03441a34$var$isOptionData = (val)=>val != null && typeof val.name === 'string' && typeof val.id === 'string';
const $67f922ef03441a34$var$createLoadQueryFunc = (environment, cloudId, projectAri)=>(searchText)=>(0, $j4oe4.fetchQuery)(environment, (0, $ahwgx.default), {
            projectAri: projectAri,
            searchText: searchText
        }, {
            fetchPolicy: 'store-or-network'
        }).toPromise().then(// @ts-expect-error - TS2345 - Argument of type '(response: Response) => void' is not assignable to parameter of type '(value: unknown) => void | PromiseLike<void>'.
        (response)=>{
            const edges = response.jira.jiraProject.suggestedDriversForJiraVersion?.edges ?? [];
            return edges.filter(Boolean).map((edge)=>edge?.node).map((user)=>user == null ? null : // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                {
                    avatarUrl: user.picture,
                    name: user.name,
                    id: user.accountId,
                    byline: user?.extendedProfile?.jobTitle ?? '',
                    type: 'user'
                }).filter($67f922ef03441a34$var$isOptionData);
        }).catch((error)=>{
            (0, $9pTd3.fireErrorAnalytics)({
                meta: {
                    id: 'ui_versionDriverFieldQuery',
                    packageName: 'jiraSoftwareReleasesVersionDriverField'
                },
                error: error
            }); // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return [];
        });
const $67f922ef03441a34$export$9ede53742ae13d69 = ({ width: width, id: id, projectId: projectId, initialDriverValue: initialDriverValue, onChange: onChange, isDisplayLabel: isDisplayLabel = true, isRenderedInModal: isRenderedInModal = false, menuPortalTargetRef: menuPortalTargetRef, isDisabled: isDisabled = false, isDisplayBorder: isDisplayBorder = false, ariaLabelledBy: ariaLabelledBy })=>{
    const environment = (0, $j4oe4.useRelayEnvironment)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const cloudId = (0, $cHtIB.useCloudId)();
    const menuPortalTarget = menuPortalTargetRef && menuPortalTargetRef.current;
    const loadOptions = $67f922ef03441a34$var$createLoadQueryFunc(environment, cloudId, `ari:cloud:jira:${cloudId}:project/${projectId}`);
    const experienceStart = (0, $7YvOT.useUpdateDriverExperienceStart)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($67f922ef03441a34$var$Wrapper, null, isDisplayLabel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
        size: "UNSAFE_small",
        weight: "bold",
        color: "color.text.subtle",
        as: "p"
    }, formatMessage((0, $djnMS.default).fieldLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($67f922ef03441a34$var$PlacholderStyleOverrider, {
        isDisplayBorder: isDisplayBorder
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ewHZ5.UserPicker), {
        fieldId: "jiraVersionDriver",
        inputId: id,
        ariaLabelledBy: ariaLabelledBy,
        loadOptions: loadOptions,
        isDisabled: isDisabled,
        width: width,
        menuPortalTarget: isRenderedInModal ? menuPortalTarget || document.body : undefined,
        styles: isRenderedInModal && !menuPortalTarget ? {
            menuPortal: (base)=>({
                    ...base,
                    zIndex: 9999
                })
        } : undefined,
        menuMinWidth: 264,
        defaultValue: initialDriverValue,
        placeholder: formatMessage((0, $djnMS.default).unassigned),
        onChange: (value)=>{
            // it is single select, so it should never be an array
            if (Array.isArray(value)) return;
            onChange?.(value == null ? null : value);
        },
        onFocus: ()=>experienceStart(),
        onClear: ()=>experienceStart()
    })));
};
const $67f922ef03441a34$export$4de1488fc0a2d937 = ({ jiraVersion: jiraVersion, width: width, onChange: onChange, isDisplayLabel: isDisplayLabel = true, isRenderedInModal: isRenderedInModal = false, isDisabled: isDisabled = false, isDisplayBorder: isDisplayBorder = false, ariaLabelledBy: ariaLabelledBy, id: id })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { showFlag: showFlag } = (0, $cSXp8.useFlagsService)();
    const experienceFail = (0, $7YvOT.useUpdateDriverExperienceFail)();
    const experienceSuccess = (0, $7YvOT.useUpdateDriverExperienceSuccess)();
    const version = (0, $j4oe4.useFragment)((0, $hw20x.default), jiraVersion);
    const versionAri = version.id;
    const { projectId: projectId } = version.project;
    const onMutationError = (error)=>{
        experienceFail('graphql error', error);
        (0, $9pTd3.fireErrorAnalytics)({
            meta: {
                id: 'jira.releases.release-modals-relay.create-release-modal',
                packageName: 'jiraSoftwareReleasesVersionDriverField',
                teamName: 'jolt'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        showFlag({
            title: formatMessage((0, $djnMS.default).genericErrorFlagTitle),
            description: formatMessage((0, $djnMS.default).genericErrorFlagDescription),
            type: 'error',
            messageId: 'software-releases-version-driver-field.ui.show-flag.error',
            messageType: 'transactional'
        });
    };
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const analyticEvent = createAnalyticsEvent({
        action: 'updated',
        actionSubject: 'versionDriver'
    }); // eslint-disable-next-line jira/graphql/restrict-graphql-in-unnamed-files
    const [updateDriverOnVersion] = (0, $j4oe4.useMutation)((0, $2DKyN.default));
    const driverError = version.driverData?.queryError?.message;
    if (driverError != null) throw new Error('Received QueryError when fetching driver');
    const driver = version?.driverData?.driver;
    const currentlySetDriver = driver == null ? undefined : {
        avatarUrl: driver.picture,
        name: driver.name,
        id: driver.accountId
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($67f922ef03441a34$export$9ede53742ae13d69, {
        id: id,
        width: width,
        ariaLabelledBy: ariaLabelledBy,
        projectId: projectId,
        initialDriverValue: currentlySetDriver,
        isDisplayLabel: isDisplayLabel,
        isRenderedInModal: isRenderedInModal,
        isDisabled: isDisabled,
        isDisplayBorder: isDisplayBorder,
        onChange: (newDriver)=>{
            updateDriverOnVersion({
                variables: {
                    input: {
                        id: versionAri,
                        driver: newDriver?.id
                    }
                },
                onCompleted: (data)=>{
                    if (data.jira?.updateJiraVersionDriver?.success !== true) {
                        const responseErrors = data?.jira?.updateJiraVersionDriver?.errors;
                        const errorMessage = responseErrors?.[0]?.message ?? 'updateJiraVersionDriver graphql mutation failed';
                        onMutationError(new Error(errorMessage));
                        return;
                    }
                    experienceSuccess();
                    (0, $kRgKj.fireTrackAnalytics)(analyticEvent, 'versionDriver updated', {
                        isDriverSet: Boolean(newDriver?.id)
                    });
                },
                onError: (error)=>{
                    onMutationError(error);
                }
            });
            onChange?.(newDriver);
        }
    });
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $67f922ef03441a34$var$Wrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1bsb1osq _1e0c1txw _2lx21bp4 _4cvr1fhb",
            __cmplp.className
        ])
    });
});
const $67f922ef03441a34$var$PlacholderStyleOverrider = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isDisplayBorder: isDisplayBorder, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1owr16oo _1q5411p5 _16vph2mm _14od1wug _1etn1wug _1ospglyw _djrp1mxx",
            !__cmplp.isDisplayBorder && "_18u0196n _hfmuglyw _16daglyw _wadhl4ek",
            __cmplp.className
        ])
    });
});

});
parcelRegister("2DKyN", function(module, exports) {
$parcel$export(module.exports, "default", () => $e94b32cfb9cef303$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ba9e18fc7e4b7dc6d70a6d3ca1bcf0ee>>
 * @relayHash 1f0e21f625d813fb1281d39baff3148c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3cad693b4ea2b82d83662a6f0beed697af820a42940984a0b7163b2529d57855
const $e94b32cfb9cef303$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v4 = {
        "kind": "ScalarField",
        "name": "errorType"
    }, v5 = {
        "kind": "ScalarField",
        "name": "message"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ui_updateDriverMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraUpdateVersionPayload",
                            "kind": "LinkedField",
                            "name": "updateJiraVersionDriver",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                v3 /*: any*/ ,
                                                v4 /*: any*/ 
                                            ]
                                        },
                                        v5 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ui_updateDriverMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraUpdateVersionPayload",
                            "kind": "LinkedField",
                            "name": "updateJiraVersionDriver",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v3 /*: any*/ ,
                                                v4 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "id"
                                                        }
                                                    ],
                                                    "type": "BulkMutationErrorExtension"
                                                }
                                            ]
                                        },
                                        v5 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "3cad693b4ea2b82d83662a6f0beed697af820a42940984a0b7163b2529d57855",
            "metadata": {},
            "name": "ui_updateDriverMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$e94b32cfb9cef303$var$node.hash = "08128527381c648c0856caf35f97d544";
var $e94b32cfb9cef303$export$2e2bcd8739ae039 = $e94b32cfb9cef303$var$node;

});

parcelRegister("hw20x", function(module, exports) {
$parcel$export(module.exports, "default", () => $a77d3407b2ba0bc1$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b301f0c56f2e8ec78c0ba5c963f8e2bd>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $a77d3407b2ba0bc1$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "ui_softwareReleasesVersionDriverField_DriverField",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "id"
            },
            "action": "THROW",
            "path": "id"
        },
        {
            "kind": "RequiredField",
            "field": {
                "concreteType": "JiraProject",
                "kind": "LinkedField",
                "name": "project",
                "plural": false,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "kind": "ScalarField",
                            "name": "projectId"
                        },
                        "action": "THROW",
                        "path": "project.projectId"
                    }
                ]
            },
            "action": "THROW",
            "path": "project"
        },
        {
            "concreteType": "JiraVersionDriverResult",
            "kind": "LinkedField",
            "name": "driverData",
            "plural": false,
            "selections": [
                {
                    "kind": "LinkedField",
                    "name": "driver",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "kind": "ScalarField",
                                "name": "accountId"
                            },
                            "action": "THROW",
                            "path": "driverData.driver.accountId"
                        },
                        {
                            "kind": "RequiredField",
                            "field": {
                                "kind": "ScalarField",
                                "name": "name"
                            },
                            "action": "THROW",
                            "path": "driverData.driver.name"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "picture"
                        }
                    ]
                },
                {
                    "concreteType": "QueryError",
                    "kind": "LinkedField",
                    "name": "queryError",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "message"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraVersion"
};
$a77d3407b2ba0bc1$var$node.hash = "699193bd41c7f6c4d596a3dd505592df";
var $a77d3407b2ba0bc1$export$2e2bcd8739ae039 = $a77d3407b2ba0bc1$var$node;

});

parcelRegister("ahwgx", function(module, exports) {
$parcel$export(module.exports, "default", () => $0214cbff9e968e73$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4ce245015522b195c8b0a32bd953b6ff>>
 * @relayHash 1cc363ec0a8878a3883c74210aec4e75
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5e4bfaa8a1dd598e42c24a483ee126347ef0d95303b3b6ad086a329116bc4bfc
const $0214cbff9e968e73$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectAri"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "searchText"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "projectAri"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "searchText",
            "variableName": "searchText"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v4 = {
        "kind": "ScalarField",
        "name": "name"
    }, v5 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v6 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "AtlassianAccountUserExtendedProfile",
                "kind": "LinkedField",
                "name": "extendedProfile",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "jobTitle"
                    }
                ]
            }
        ],
        "type": "AtlassianAccountUser"
    }, v7 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ui_versionDriverFieldQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v1 /*: any*/ ,
                                    "concreteType": "JiraProject",
                                    "kind": "LinkedField",
                                    "name": "jiraProject",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "args": v2 /*: any*/ ,
                                            "concreteType": "JiraVersionDriverConnection",
                                            "kind": "LinkedField",
                                            "name": "suggestedDriversForJiraVersion",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraVersionDriverEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "RequiredField",
                                                            "field": {
                                                                "kind": "LinkedField",
                                                                "name": "node",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "kind": "RequiredField",
                                                                        "field": v3 /*: any*/ ,
                                                                        "action": "THROW",
                                                                        "path": "jira.jiraProject.suggestedDriversForJiraVersion.edges.node.accountId"
                                                                    },
                                                                    {
                                                                        "kind": "RequiredField",
                                                                        "field": v4 /*: any*/ ,
                                                                        "action": "THROW",
                                                                        "path": "jira.jiraProject.suggestedDriversForJiraVersion.edges.node.name"
                                                                    },
                                                                    v5 /*: any*/ ,
                                                                    v6 /*: any*/ 
                                                                ]
                                                            },
                                                            "action": "THROW",
                                                            "path": "jira.jiraProject.suggestedDriversForJiraVersion.edges.node"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.jiraProject"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ui_versionDriverFieldQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jiraProject",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v2 /*: any*/ ,
                                    "concreteType": "JiraVersionDriverConnection",
                                    "kind": "LinkedField",
                                    "name": "suggestedDriversForJiraVersion",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraVersionDriverEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "__typename"
                                                        },
                                                        v3 /*: any*/ ,
                                                        v4 /*: any*/ ,
                                                        v5 /*: any*/ ,
                                                        v6 /*: any*/ ,
                                                        v7 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v7 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "5e4bfaa8a1dd598e42c24a483ee126347ef0d95303b3b6ad086a329116bc4bfc",
            "metadata": {},
            "name": "ui_versionDriverFieldQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$0214cbff9e968e73$var$node.hash = "43d45f30b77d193c46e6ddd3e1cb725a";
var $0214cbff9e968e73$export$2e2bcd8739ae039 = $0214cbff9e968e73$var$node;

});

parcelRegister("ewHZ5", function(module, exports) {
$parcel$export(module.exports, "UserPicker", () => $1e85aa7b9e874556$export$83e0c73b09b3a9cd);
/* UserPicker.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $4J0ad = parcelRequire("4J0ad");

var $kVcjU = parcelRequire("kVcjU");
var $c4OV1 = parcelRequire("c4OV1");

var $g0oDq = parcelRequire("g0oDq");

var $eJOHy = parcelRequire("eJOHy");

var $1icyy = parcelRequire("1icyy");

var $7Vnqr = parcelRequire("7Vnqr");

var $6jfsf = parcelRequire("6jfsf");

var $lLpLo = parcelRequire("lLpLo");

var $f9tKr = parcelRequire("f9tKr");

var $61zL7 = parcelRequire("61zL7");

var $48bcP = parcelRequire("48bcP");

var $1FdfR = parcelRequire("1FdfR");

var $aXKmr = parcelRequire("aXKmr");

var $eGOwo = parcelRequire("eGOwo");
class $1e85aa7b9e874556$export$164f4d95e5d7e2f5 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    constructor(props){
        super(props);
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        this.ufoId = (0, $aXKmr.v4)();
        const experienceForId = (0, $1FdfR.userPickerRenderedUfoExperience).getInstance(this.ufoId);
        if (![
            (0, $g0oDq.UFOExperienceState).IN_PROGRESS.id,
            (0, $g0oDq.UFOExperienceState).STARTED.id
        ].includes(experienceForId.state.id)) experienceForId.start();
    }
    static{
        this.defaultProps = {
            width: 350,
            isMulti: false
        };
    }
    componentDidMount() {
        const experienceForId = (0, $1FdfR.userPickerRenderedUfoExperience).getInstance(this.ufoId);
        // Send UFO success if the experience is still in progress i.e. hasn't failed
        if ([
            (0, $g0oDq.UFOExperienceState).IN_PROGRESS.id,
            (0, $g0oDq.UFOExperienceState).STARTED.id
        ].includes(experienceForId.state.id)) experienceForId.success();
    }
    render() {
        const { emailLabel: emailLabel, allowEmail: allowEmail, suggestEmailsForDomain: suggestEmailsForDomain, isMulti: isMulti, isValidEmail: isValidEmail, anchor: anchor, menuPortalTarget: menuPortalTarget, menuPosition: menuPosition, menuShouldBlockScroll: menuShouldBlockScroll, captureMenuScroll: captureMenuScroll, closeMenuOnScroll: closeMenuOnScroll, loadUserSource: loadUserSource, required: required = false, showClearIndicator: showClearIndicator = false } = this.props;
        const width = this.props.width;
        const SelectComponent = allowEmail ? (0, $kVcjU.default) : (0, $c4OV1.default);
        const creatableProps = suggestEmailsForDomain ? (0, $f9tKr.getCreatableSuggestedEmailProps)(suggestEmailsForDomain, isValidEmail) : (0, $lLpLo.getCreatableProps)(isValidEmail);
        const defaultPickerProps = {
            closeMenuOnScroll: closeMenuOnScroll,
            menuPortalTarget: menuPortalTarget,
            menuPosition: menuPosition,
            menuShouldBlockScroll: menuShouldBlockScroll,
            captureMenuScroll: captureMenuScroll,
            required: required
        };
        const pickerProps = allowEmail ? {
            ...defaultPickerProps,
            ...creatableProps,
            emailLabel: emailLabel
        } : {
            ...defaultPickerProps
        };
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1FdfR.UfoErrorBoundary), {
            id: this.ufoId,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $61zL7.default), {
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $48bcP.ExusUserSourceProvider), {
                    fetchUserSource: loadUserSource,
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1icyy.BaseUserPickerWithoutAnalytics), {
                        ...this.props,
                        forwardedRef: this.props.forwardedRef,
                        width: width,
                        SelectComponent: SelectComponent,
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                        styles: (0, $7Vnqr.getStyles)(width, isMulti, this.props.appearance === 'compact', this.props.styles, (0, $eGOwo.fg)('platform-component-visual-refresh'), false, (0, $eGOwo.fg)('jifjam_bulk_operations') ? this.props.height : undefined),
                        components: (0, $6jfsf.getComponents)(isMulti, anchor, showClearIndicator, this.props?.components ? this.props.components : {}),
                        pickerProps: pickerProps
                    })
                })
            })
        });
    }
}
const $1e85aa7b9e874556$export$83e0c73b09b3a9cd = (0, $4J0ad.default)()($1e85aa7b9e874556$export$164f4d95e5d7e2f5);

});
parcelRegister("kVcjU", function(module, exports) {
$parcel$export(module.exports, "default", () => $a77c87292d58cd15$export$2e2bcd8739ae039);

var $dSBuj = parcelRequire("dSBuj");

var $dDv66 = parcelRequire("dDv66");
const $a77c87292d58cd15$var$CreatableSelect = (0, $dDv66.default)((0, $dSBuj.default));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$a77c87292d58cd15$export$2e2bcd8739ae039 = $a77c87292d58cd15$var$CreatableSelect;

});
parcelRegister("dSBuj", function(module, exports) {
$parcel$export(module.exports, "default", () => $bfa75c11ff37aa8b$export$2e2bcd8739ae039);
$parcel$export(module.exports, "useCreatable", () => (parcelRequire("9gNEN")).default);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $5tlgh = parcelRequire("5tlgh");

var $9gNEN = parcelRequire("9gNEN");

var $gVVTN = parcelRequire("gVVTN");
const $bfa75c11ff37aa8b$var$CreatableSelect = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>{
    const creatableProps = (0, $gVVTN.default)(props);
    const selectProps = (0, $9gNEN.default)(creatableProps);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5tlgh.default), {
        ref: ref,
        ...selectProps
    });
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$bfa75c11ff37aa8b$export$2e2bcd8739ae039 = $bfa75c11ff37aa8b$var$CreatableSelect;

});
parcelRegister("9gNEN", function(module, exports) {
$parcel$export(module.exports, "default", () => $59d3993c69e6bf3a$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $20dEN = parcelRequire("20dEN");

var $gNnQq = parcelRequire("gNnQq");
const $59d3993c69e6bf3a$var$compareOption = (inputValue = '', option, accessors)=>{
    const candidate = String(inputValue).toLowerCase();
    const optionValue = String(accessors.getOptionValue(option)).toLowerCase();
    const optionLabel = String(accessors.getOptionLabel(option)).toLowerCase();
    return optionValue === candidate || optionLabel === candidate;
};
const $59d3993c69e6bf3a$var$builtins = {
    formatCreateLabel: (inputValue)=>`Create "${inputValue}"`,
    isValidNewOption: (inputValue, selectValue, selectOptions, accessors)=>!(!inputValue || selectValue.some((option)=>$59d3993c69e6bf3a$var$compareOption(inputValue, option, accessors)) || selectOptions.some((option)=>$59d3993c69e6bf3a$var$compareOption(inputValue, option, accessors))),
    getNewOptionData: (inputValue, optionLabel)=>({
            label: optionLabel,
            value: inputValue,
            __isNew__: true
        })
};
function $59d3993c69e6bf3a$export$2e2bcd8739ae039({ allowCreateWhileLoading: allowCreateWhileLoading = false, createOptionPosition: createOptionPosition = 'last', formatCreateLabel: formatCreateLabel = $59d3993c69e6bf3a$var$builtins.formatCreateLabel, isValidNewOption: isValidNewOption = $59d3993c69e6bf3a$var$builtins.isValidNewOption, getNewOptionData: //@ts-ignore
getNewOptionData = $59d3993c69e6bf3a$var$builtins.getNewOptionData, onCreateOption: onCreateOption, options: propsOptions = [], onChange: propsOnChange, ...restSelectProps }) {
    const { getOptionValue: getOptionValue = (0, $20dEN.getOptionValue), getOptionLabel: getOptionLabel = (0, $20dEN.getOptionLabel), inputValue: inputValue, isLoading: isLoading, isMulti: isMulti, value: value, name: name } = restSelectProps;
    const newOption = (0, $eJOHy.useMemo)(()=>isValidNewOption(inputValue, (0, $gNnQq.cleanValue)(value), propsOptions, {
            getOptionValue: getOptionValue,
            getOptionLabel: getOptionLabel
        }) ? getNewOptionData(inputValue, formatCreateLabel(inputValue)) : undefined, [
        formatCreateLabel,
        getNewOptionData,
        getOptionLabel,
        getOptionValue,
        inputValue,
        isValidNewOption,
        propsOptions,
        value
    ]);
    const options = (0, $eJOHy.useMemo)(()=>(allowCreateWhileLoading || !isLoading) && newOption ? createOptionPosition === 'first' ? [
            newOption,
            ...propsOptions
        ] : [
            ...propsOptions,
            newOption
        ] : propsOptions, [
        allowCreateWhileLoading,
        createOptionPosition,
        isLoading,
        newOption,
        propsOptions
    ]);
    const onChange = (0, $eJOHy.useCallback)((newValue, actionMeta)=>{
        if (actionMeta.action !== 'select-option') return propsOnChange(newValue, actionMeta);
        const valueArray = Array.isArray(newValue) ? newValue : [
            newValue
        ];
        if (valueArray[valueArray.length - 1] === newOption) {
            if (onCreateOption) onCreateOption(inputValue);
            else {
                const newOptionData = getNewOptionData(inputValue, inputValue);
                const newActionMeta = {
                    action: 'create-option',
                    name: name,
                    option: newOptionData
                };
                propsOnChange((0, $gNnQq.valueTernary)(isMulti, [
                    ...(0, $gNnQq.cleanValue)(value),
                    newOptionData
                ], newOptionData), newActionMeta);
            }
            return;
        }
        propsOnChange(newValue, actionMeta);
    }, [
        getNewOptionData,
        inputValue,
        isMulti,
        name,
        newOption,
        onCreateOption,
        propsOnChange,
        value
    ]);
    return {
        ...restSelectProps,
        options: options,
        onChange: onChange
    };
}

});



parcelRegister("g0oDq", function(module, exports) {
$parcel$export(module.exports, "UFOExperienceState", () => $7c8f0df3a7880bc0$export$81b70111112841a0);
const $7c8f0df3a7880bc0$export$81b70111112841a0 = {
    NOT_STARTED: {
        id: 'NOT_STARTED',
        final: true
    },
    STARTED: {
        id: 'STARTED'
    },
    IN_PROGRESS: {
        id: 'IN_PROGRESS'
    },
    BLOCKED: {
        id: 'BLOCKED'
    },
    RECOVERED: {
        id: 'RECOVERED'
    },
    SUCCEEDED: {
        id: 'SUCCEEDED',
        final: true,
        success: true
    },
    SUCCEEDED_WAITING_FOR_DEPS: {
        id: 'SUCCEEDED_WAITING_FOR_DEPS'
    },
    FAILED: {
        id: 'FAILED',
        final: true
    },
    ABORTED: {
        id: 'ABORTED',
        final: true
    }
};

});

parcelRegister("1icyy", function(module, exports) {
$parcel$export(module.exports, "BaseUserPickerWithoutAnalytics", () => $35423b4ef08403b2$export$b4ff48c8d43b18c3);

var $gt9Am = parcelRequire("gt9Am");

var $4J0ad = parcelRequire("4J0ad");

var $g0oDq = parcelRequire("g0oDq");

var $3s8bj = parcelRequire("3s8bj");

var $eJOHy = parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $aXKmr = parcelRequire("aXKmr");

var $lyKnh = parcelRequire("lyKnh");

var $4yPQa = parcelRequire("4yPQa");

var $aemwP = parcelRequire("aemwP");

var $bp6ad = parcelRequire("bp6ad");

var $ersOA = parcelRequire("ersOA");

var $1FdfR = parcelRequire("1FdfR");

var $eGOwo = parcelRequire("eGOwo");
const $35423b4ef08403b2$var$loadingMessage = ()=>null;
const $35423b4ef08403b2$var$classNamePrefix = 'fabric-user-picker';
class $35423b4ef08403b2$export$b4ff48c8d43b18c3 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    static{
        this.defaultProps = {
            isMulti: false,
            subtle: false,
            noBorder: false,
            textFieldBackgroundColor: false,
            isClearable: true,
            loadOptionsErrorMessage: ()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                    ...(0, $aemwP.messages).errorMessage
                }),
            openMenuOnClick: false
        };
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        const derivedState = {};
        if (nextProps.isDisabled || nextProps.disableInput) derivedState.menuIsOpen = false;
        if (nextProps.open !== undefined) derivedState.menuIsOpen = nextProps.open;
        if (nextProps.value !== undefined) derivedState.value = (0, $bp6ad.optionToSelectableOptions)(nextProps.value);
        else if ((0, $bp6ad.isDefaultValuePopulated)(nextProps.defaultValue) && !prevState.isDefaultSet) {
            derivedState.value = (0, $bp6ad.optionToSelectableOptions)(nextProps.defaultValue);
            derivedState.isDefaultSet = true;
        }
        if (nextProps.search !== undefined && nextProps.search !== prevState.inputValue) derivedState.inputValue = nextProps.search;
        if (nextProps.options !== undefined) derivedState.options = nextProps.options;
        return derivedState;
    }
    constructor(props){
        super(props), this.getSessionId = ()=>this.session && this.session.id ? this.session.id : undefined, this.withSelectRef = (callback)=>()=>{
                if (this.selectRef) callback(this.selectRef);
            }, this.nextOption = this.withSelectRef((select)=>select.focusOption('down')), this.previousOption = this.withSelectRef((select)=>select.focusOption('up')), this.focus = ()=>{
            if (this.selectRef && this.selectRef.focus) this.selectRef.focus();
        }, this.blur = ()=>{
            if (this.selectRef && this.selectRef.blur) this.selectRef.blur();
        }, this.selectOption = this.withSelectRef((select)=>{
            const focusedOption = select.state.focusedOption;
            select.selectOption(focusedOption);
        }), // value = null if user deletes the last item in the user picker
        this.handleChange = (value, { action: action, removedValue: removedValue, option: option })=>{
            if (removedValue && removedValue.data.fixed) return;
            this.resetInputState();
            const { onChange: onChange, onSelection: onSelection, onClear: onClear, isMulti: isMulti } = this.props;
            (0, $bp6ad.callCallback)(onChange, (0, $bp6ad.extractOptionValue)(value), action);
            switch(action){
                case 'select-option':
                    if (value) (0, $bp6ad.callCallback)(onSelection, (0, $bp6ad.extractOptionValue)(value), this.getSessionId(), this);
                    this.fireEvent((0, $lyKnh.selectEvent), isMulti ? option : value);
                    this.session = isMulti ? (0, $lyKnh.startSession)() : undefined;
                    break;
                case 'clear':
                    (0, $bp6ad.callCallback)(onClear);
                    this.fireEvent((0, $lyKnh.clearEvent));
                    break;
                case 'remove-value':
                case 'pop-value':
                    if (removedValue) this.fireEvent((0, $lyKnh.deleteEvent), removedValue.data);
                    break;
            }
            this.fireEvent((0, $lyKnh.searchedEvent));
            if (removedValue && this.state.value && Array.isArray(this.state.value)) {
                const remainingValues = this.state.value.filter((val)=>val.data.id !== removedValue.data.id);
                this.setState({
                    value: remainingValues ? remainingValues : [],
                    menuIsOpen: true
                });
            }
            if (!this.props.value) this.setState({
                value: value ? value : []
            });
        }, this.handleSelectRef = (ref)=>{
            this.selectRef = ref;
        }, this.addOptions = (0, $4yPQa.batchByKey)((request, newOptions)=>{
            const { resolving: resolving } = this.state;
            this.setState(({ inflightRequest: inflightRequest, options: options, count: count })=>{
                if (inflightRequest.toString() === request) return {
                    options: (resolving ? options : []).concat(newOptions.reduce((nextOptions, item)=>Array.isArray(item) ? nextOptions.concat(item[0]) : nextOptions.concat(item), [])),
                    count: count - newOptions.length,
                    resolving: count - newOptions.length !== 0
                };
                return null;
            });
        }), this.handleLoadOptionsError = ()=>{
            const { count: count } = this.state;
            const newCount = count - 1;
            const resolving = newCount !== 0;
            let showError = false;
            if (!resolving) showError = true;
            this.setState({
                count: newCount,
                resolving: resolving,
                showError: showError
            });
            this.fireEvent((0, $lyKnh.failedEvent));
        }, this.debouncedLoadOptions = (0, (/*@__PURE__*/$parcel$interopDefault($3s8bj)))((search)=>{
            const { loadOptions: loadOptions } = this.props;
            if (loadOptions) {
                const inflightRequest = this.state.inflightRequest + 1;
                const result = this.session && this.session.id ? loadOptions(search, this.session.id) : loadOptions(search);
                const addOptions = this.addOptions.bind(this, inflightRequest.toString());
                let count = 0;
                if ((0, $bp6ad.isIterable)(result)) for (const value of result){
                    Promise.resolve(value).then(addOptions).catch(this.handleLoadOptionsError);
                    count++;
                }
                else {
                    Promise.resolve(result).then(addOptions).catch(this.handleLoadOptionsError);
                    count++;
                }
                this.setState({
                    inflightRequest: inflightRequest,
                    count: count,
                    resolving: count !== 0,
                    options: []
                });
            }
        }, 200), this.abortOptionsShownUfoExperience = ()=>{
            if (this.optionsShownUfoExperienceInstance.state.id === (0, $g0oDq.UFOExperienceState).STARTED.id) // There may be an existing UFO timing running from previous key entry or focus,
            // so abort it and restart it just in case.
            this.optionsShownUfoExperienceInstance.abort();
        }, this.startOptionsShownUfoExperience = ()=>{
            this.abortOptionsShownUfoExperience();
            this.optionsShownUfoExperienceInstance.start();
        }, this.executeLoadOptions = (search)=>{
            const { loadOptions: loadOptions } = this.props;
            if (loadOptions) this.setState({
                resolving: true,
                showError: false
            }, ()=>this.debouncedLoadOptions(search));
        }, this.handleFocus = (event)=>{
            const { value: value, menuIsOpen: menuIsOpen } = this.state;
            if (!menuIsOpen || !this.session) this.startSession();
            this.startOptionsShownUfoExperience();
            (0, $bp6ad.callCallback)(this.props.onFocus, this.getSessionId());
            if (!this.isMenuOpenOnClickForSingleSelect) {
                this.setState({
                    menuIsOpen: true
                });
                if (!this.props.isMulti && (0, $bp6ad.isSingleValue)(value)) {
                    const input = event.target;
                    this.setState({
                        inputValue: value.label
                    }, ()=>{
                        if (input instanceof HTMLInputElement) input.setSelectionRange(0, value.label.length);
                    });
                }
            }
        }, this.resetInputState = ()=>{
            // Prevent filter if query typed, then blurred with no selection
            this.setState({
                inputValue: ''
            });
            (0, $bp6ad.callCallback)(this.props.onInputChange, '', this.getSessionId());
        }, this.handleBlur = ()=>{
            (0, $bp6ad.callCallback)(this.props.onBlur, this.getSessionId());
            if ((0, $bp6ad.isPopupUserPickerByComponent)(this.props.SelectComponent)) return;
            this.resetInputState();
            this.abortOptionsShownUfoExperience();
            this.setState({
                menuIsOpen: false,
                initialFocusHandled: false,
                options: []
            });
        }, this.handleOpen = ()=>{
            (0, $bp6ad.callCallback)(this.props.onOpen, this.getSessionId());
            this.setState({
                menuIsOpen: true
            });
        }, this.handleClose = ()=>{
            this.resetInputState();
            (0, $bp6ad.callCallback)(this.props.onClose, this.getSessionId());
            this.setState({
                menuIsOpen: false,
                options: []
            });
        }, this.handleInputChange = (search, { action: action })=>{
            if (action === 'input-change' || action === 'set-value') {
                (0, $bp6ad.callCallback)(this.props.onInputChange, search, this.getSessionId());
                this.setState({
                    inputValue: search
                });
                this.startOptionsShownUfoExperience();
            }
        }, this.fireEvent = (eventCreator, ...args)=>{
            const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
            if (createAnalyticsEvent) (0, $lyKnh.createAndFireEventInElementsChannel)(eventCreator(this.props, this.state, this.session, this.journeyId, ...args))(createAnalyticsEvent);
        }, this.startSession = ()=>{
            this.session = (0, $lyKnh.startSession)();
            this.journeyId = this.getSessionId();
            this.fireEvent((0, $lyKnh.focusEvent));
        }, this.handleKeyDown = (event)=>{
            if (!this.isMenuOpenOnClickForSingleSelect) {
                // Escape
                if (event.keyCode === 27) this.blur();
                // Space
                if (event.keyCode === 32 && !this.state.inputValue) {
                    event.preventDefault();
                    !this.props.disableInput && this.setState({
                        inputValue: ' '
                    });
                }
            }
            if (this.session) {
                this.session.lastKey = event.keyCode;
                switch(event.keyCode){
                    // KeyUp 38
                    case 38:
                        this.session.upCount++;
                        break;
                    // KeyDown 40
                    case 40:
                        this.session.downCount++;
                        break;
                }
            }
            this.props.onKeyDown && this.props.onKeyDown(event);
        }, this.handleClearIndicatorHover = (hoveringClearIndicator)=>{
            this.setState({
                hoveringClearIndicator: hoveringClearIndicator
            });
        }, this.getOptions = ()=>{
            const options = (0, $bp6ad.getOptions)(this.state.options) || [];
            const { maxOptions: maxOptions, isMulti: isMulti, groupByTypeOrder: groupByTypeOrder } = this.props;
            if (maxOptions === 0) return [];
            if (maxOptions && maxOptions > 0 && maxOptions < options.length) {
                const { value: value } = this.state;
                let filteredOptions = options;
                // Filter out previously selected options
                if (isMulti && Array.isArray(value)) {
                    const valueIds = value.map((item)=>item.data.id);
                    filteredOptions = options.filter((option)=>valueIds.indexOf(option.data.id) === -1);
                }
                return groupByTypeOrder ? (0, $ersOA.groupOptionsByType)(filteredOptions.slice(0, maxOptions), groupByTypeOrder) : filteredOptions.slice(0, maxOptions);
            }
            return groupByTypeOrder ? (0, $ersOA.groupOptionsByType)(options, groupByTypeOrder) : options;
        }, this.getAppearance = ()=>this.props.appearance ? this.props.appearance : 'normal', this.handleClickDraggableParentComponent = ()=>{
            if (this.state.initialFocusHandled) {
                // As <Select /> is already focused, calling this.selectRef.current.focus() again no longer triggers its own handlers (i.e. onMenuOpen, onMenuClose)
                // We have to manually handle the open and close states of the dropdown menu based on a user's click from this point onwards to prevent the bug
                if (this.state.menuIsOpen) this.handleClose();
                else this.handleOpen();
            } else if (!this.state.menuIsOpen && !this.isMenuOpenOnClickForSingleSelect) {
                // Trigger focus state when ValueContainer is clicked for the first time
                // The focused state will then invoke <Select /> instance's own handlers (e.g. onMenuOpen, onMenuClose)
                // to manage the state of the dropdown menu
                this.focus();
                this.setState(()=>({
                        initialFocusHandled: true
                    }));
            }
        };
        this.state = {
            options: [],
            isDefaultSet: false,
            inflightRequest: 0,
            count: 0,
            hoveringClearIndicator: false,
            menuIsOpen: !!this.props.open,
            inputValue: props.search || '',
            resolving: false,
            showError: false,
            initialFocusHandled: false
        };
        this.optionsShownUfoExperienceInstance = // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        (0, $1FdfR.userPickerOptionsShownUfoExperience).getInstance((0, $aXKmr.v4)());
        if (this.props.forwardedRef) {
            const refValue = {
                focus: this.focus,
                blur: this.blur
            };
            if (typeof this.props.forwardedRef === 'function') this.props.forwardedRef(refValue);
            else this.props.forwardedRef.current = refValue;
        }
    }
    get isMenuOpenOnClickForSingleSelect() {
        return this.props.openMenuOnClick && !this.props.isMulti;
    }
    componentDidMount() {
        const { open: open, search: search } = this.props;
        // load options when the picker open
        if (open) {
            if (!this.session) this.startSession();
            this.executeLoadOptions(search);
        }
    }
    componentDidUpdate(_, prevState) {
        const { menuIsOpen: menuIsOpen, options: options, resolving: resolving, count: count, inputValue: inputValue } = this.state;
        // Create a new session when the menu is opened and there is no session
        if (menuIsOpen && !prevState.menuIsOpen && !this.session) this.startSession();
        // Load options when user picker opens or when input value changes
        if (menuIsOpen && !prevState.menuIsOpen || inputValue !== prevState.inputValue) this.executeLoadOptions(inputValue);
        if (!menuIsOpen && prevState.menuIsOpen && this.session) {
            this.fireEvent((0, $lyKnh.cancelEvent), prevState);
            this.session = undefined;
        }
        if (menuIsOpen && (!prevState.menuIsOpen && options.length > 0 || options.length !== prevState.options.length)) this.fireEvent((0, $lyKnh.searchedEvent));
        if (this.state.inputValue !== prevState.inputValue) {
            if (this.session) this.session.inputChangeTime = Date.now();
        }
        if (menuIsOpen && (!_.loadOptions || prevState.menuIsOpen) && count === 0 && !resolving && [
            (0, $g0oDq.UFOExperienceState).STARTED.id,
            (0, $g0oDq.UFOExperienceState).IN_PROGRESS.id
        ].includes(this.optionsShownUfoExperienceInstance.state.id)) this.optionsShownUfoExperienceInstance.success();
    }
    get ariaProps() {
        const ariaLabels = Object.keys(this.props).filter((key)=>key.startsWith('aria-'));
        const props = {
            ...this.props
        };
        return ariaLabels.reduce((obj, key)=>({
                ...obj,
                [key]: props[key]
            }), {});
    }
    render() {
        const { isMulti: isMulti, isLoading: isLoading, subtle: subtle, noBorder: noBorder, placeholder: placeholder, isClearable: isClearable, isDisabled: isDisabled, isInvalid: isInvalid, clearValueLabel: clearValueLabel, menuMinWidth: menuMinWidth, menuPortalTarget: menuPortalTarget, loadOptionsErrorMessage: loadOptionsErrorMessage, addMoreMessage: addMoreMessage, noOptionsMessage: noOptionsMessage, footer: footer, disableInput: disableInput, components: components, pickerProps: pickerProps, SelectComponent: SelectComponent, styles: styles, autoFocus: autoFocus, fieldId: fieldId, inputId: inputId, maxPickerHeight: maxPickerHeight, textFieldBackgroundColor: textFieldBackgroundColor, ariaLabelledBy: ariaLabelledBy, ariaDescribedBy: ariaDescribedBy, ariaLive: ariaLive, ariaLabel: ariaLabel, name: name, header: header, required: required, UNSAFE_hasDraggableParentComponent: UNSAFE_hasDraggableParentComponent, placeholderAvatar: placeholderAvatar } = this.props;
        const { count: count, hoveringClearIndicator: hoveringClearIndicator, menuIsOpen: menuIsOpen, value: value, inputValue: inputValue, resolving: resolving, showError: showError } = this.state;
        const appearance = this.getAppearance();
        // these props override the default select menu open and close
        const menuOpenDeciderProps = {
            ...!this.isMenuOpenOnClickForSingleSelect && {
                menuIsOpen: menuIsOpen,
                blurInputOnSelect: !isMulti,
                openMenuOnFocus: true
            }
        };
        const { 'aria-labelledby': ariaLabelledByStandard, 'aria-describedby': ariaDescribedByStandard, ...restAriaProps } = this.ariaProps;
        return /*#__PURE__*/ (0, $gt9Am.jsx)(SelectComponent, {
            name: name,
            value: value,
            autoFocus: autoFocus !== undefined ? autoFocus : menuIsOpen,
            labelId: (0, $eGOwo.fg)('user_picker_migrate_aria_label_description') ? ariaLabelledBy ?? ariaLabelledByStandard : undefined,
            "aria-labelledby": (0, $eGOwo.fg)('user_picker_migrate_aria_label_description') ? undefined : ariaLabelledBy,
            descriptionId: (0, $eGOwo.fg)('user_picker_migrate_aria_label_description') ? ariaDescribedBy ?? ariaDescribedByStandard : undefined,
            "aria-describedby": (0, $eGOwo.fg)('user_picker_migrate_aria_label_description') ? undefined : ariaDescribedBy,
            "aria-live": ariaLive,
            "aria-required": required,
            required: required,
            ref: this.handleSelectRef,
            isMulti: isMulti,
            options: this.getOptions(),
            styles: styles,
            enableAnimation: isMulti,
            components: components,
            inputValue: inputValue,
            isLoading: count > 0 || resolving || isLoading,
            loadingMessage: $35423b4ef08403b2$var$loadingMessage,
            menuPlacement: "auto",
            placeholder: placeholder ?? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                ...(0, $aemwP.messages).placeholder
            }),
            label: ariaLabel,
            addMoreMessage: addMoreMessage,
            classNamePrefix: $35423b4ef08403b2$var$classNamePrefix,
            hoveringClearIndicator: hoveringClearIndicator,
            appearance: appearance,
            isClearable: isClearable,
            noBorder: noBorder,
            subtle: subtle,
            closeMenuOnSelect: !isMulti,
            noOptionsMessage: showError ? loadOptionsErrorMessage : typeof noOptionsMessage === 'function' ? noOptionsMessage : ()=>noOptionsMessage,
            footer: footer,
            isDisabled: isDisabled,
            isInvalid: isInvalid,
            isFocused: menuIsOpen,
            backspaceRemovesValue: isMulti,
            filterOption: null,
            clearValueLabel: clearValueLabel,
            menuMinWidth: menuMinWidth,
            menuPortalTarget: menuPortalTarget,
            disableInput: disableInput || isDisabled,
            instanceId: fieldId,
            inputId: inputId,
            onChange: this.handleChange,
            onMenuOpen: this.handleOpen,
            onFocus: this.handleFocus,
            onBlur: this.handleBlur,
            onMenuClose: this.handleClose,
            onInputChange: this.handleInputChange,
            onClearIndicatorHover: this.handleClearIndicatorHover,
            onKeyDown: this.handleKeyDown,
            maxPickerHeight: maxPickerHeight,
            textFieldBackgroundColor: textFieldBackgroundColor,
            header: header,
            placeholderAvatar: placeholderAvatar,
            ...(0, $eGOwo.fg)('user_picker_migrate_aria_label_description') ? restAriaProps : this.ariaProps,
            ...pickerProps,
            ...UNSAFE_hasDraggableParentComponent && {
                onValueContainerClick: this.handleClickDraggableParentComponent
            },
            ...menuOpenDeciderProps
        });
    }
}
const $35423b4ef08403b2$export$d099ade7b4f4d2a4 = (0, $4J0ad.default)()($35423b4ef08403b2$export$b4ff48c8d43b18c3);

});
parcelRegister("lyKnh", function(module, exports) {
$parcel$export(module.exports, "startSession", () => $90f09ed730154930$export$c0d84948cecf78d8);
$parcel$export(module.exports, "createAndFireEventInElementsChannel", () => $90f09ed730154930$export$53eef0dcd9611650);
$parcel$export(module.exports, "focusEvent", () => $90f09ed730154930$export$e7818c470f37c4bd);
$parcel$export(module.exports, "clearEvent", () => $90f09ed730154930$export$7b5800e732182efb);
$parcel$export(module.exports, "deleteEvent", () => $90f09ed730154930$export$95711ec6c6227e9a);
$parcel$export(module.exports, "cancelEvent", () => $90f09ed730154930$export$e9caaaecfee38128);
$parcel$export(module.exports, "selectEvent", () => $90f09ed730154930$export$48143d759475d90f);
$parcel$export(module.exports, "searchedEvent", () => $90f09ed730154930$export$911fb7184b6037eb);
$parcel$export(module.exports, "failedEvent", () => $90f09ed730154930$export$c2aec355fef65c9c);
$parcel$export(module.exports, "userInfoEvent", () => $90f09ed730154930$export$f541f04954b0c11e);

var $5fWw9 = parcelRequire("5fWw9");

var $aXKmr = parcelRequire("aXKmr");

var $bp6ad = parcelRequire("bp6ad");
const $90f09ed730154930$var$packageName = "platform-pkg";
const $90f09ed730154930$var$packageVersion = "0.0.0-use.local";
const $90f09ed730154930$var$UUID_REGEXP_TEAMS_GROUPS = /^[a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12}$/;
const $90f09ed730154930$var$UUID_REGEXP_OLD_AAID = /^[a-fA-F0-9]{1,8}:[a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12}$/;
const $90f09ed730154930$var$UUID_REGEXP_NEW_AAID = /^[a-fA-F0-9]{24,24}$/;
const $90f09ed730154930$export$c0d84948cecf78d8 = ()=>({
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        id: (0, $aXKmr.v4)(),
        start: Date.now(),
        inputChangeTime: Date.now(),
        upCount: 0,
        downCount: 0,
        lastKey: undefined
    });
const $90f09ed730154930$export$53eef0dcd9611650 = (0, $5fWw9.default)('fabric-elements');
const $90f09ed730154930$var$createEvent = (eventType, action, actionSubject, attributes = {})=>({
        eventType: eventType,
        action: action,
        actionSubject: actionSubject,
        attributes: {
            packageName: $90f09ed730154930$var$packageName,
            packageVersion: $90f09ed730154930$var$packageVersion,
            ...attributes
        }
    });
const $90f09ed730154930$var$checkValidId = (id)=>{
    return $90f09ed730154930$var$UUID_REGEXP_NEW_AAID.test(id) || $90f09ed730154930$var$UUID_REGEXP_OLD_AAID.test(id) || $90f09ed730154930$var$UUID_REGEXP_TEAMS_GROUPS.test(id);
};
const $90f09ed730154930$var$optionData2Analytics = (option)=>{
    const { id: id, type: type } = option;
    // id's of email types are emails which is PII
    const validatedData = {
        id: $90f09ed730154930$var$checkValidId(id) ? id : null,
        type: type || null
    };
    if ((0, $bp6ad.isExternalUser)(option)) return {
        ...validatedData,
        type: 'external_user',
        sources: option.sources,
        externalUserType: option.externalUserType
    };
    if ((0, $bp6ad.isCustom)(option) && option.analyticsType) return {
        ...validatedData,
        type: option.analyticsType
    };
    return validatedData;
};
const $90f09ed730154930$var$buildValueForAnalytics = (value)=>{
    if (value) {
        const valueToConvert = Array.isArray(value) ? value : [
            value
        ];
        return valueToConvert.map(({ data: data })=>$90f09ed730154930$var$optionData2Analytics(data));
    }
    return [];
};
const $90f09ed730154930$var$createDefaultPickerAttributes = (props, session, journeyId)=>({
        context: props.fieldId,
        sessionId: $90f09ed730154930$var$sessionId(session),
        pickerType: $90f09ed730154930$var$pickerType(props),
        journeyId: journeyId
    });
const $90f09ed730154930$export$e7818c470f37c4bd = (props, state, session, journeyId)=>$90f09ed730154930$var$createEvent('ui', 'focused', 'userPicker', {
        ...$90f09ed730154930$var$createDefaultPickerAttributes(props, session, journeyId),
        values: $90f09ed730154930$var$buildValueForAnalytics(state.value)
    });
const $90f09ed730154930$export$7b5800e732182efb = (props, state, session, journeyId)=>$90f09ed730154930$var$createEvent('ui', 'cleared', 'userPicker', {
        ...$90f09ed730154930$var$createDefaultPickerAttributes(props, session, journeyId),
        pickerOpen: state.menuIsOpen,
        values: $90f09ed730154930$var$values(state)
    });
const $90f09ed730154930$export$95711ec6c6227e9a = (props, state, session, journeyId, ...args)=>$90f09ed730154930$var$createEvent('ui', 'deleted', 'userPickerItem', {
        context: props.fieldId,
        sessionId: $90f09ed730154930$var$sessionId(session),
        journeyId: journeyId,
        value: $90f09ed730154930$var$optionData2Analytics(args[0]),
        pickerOpen: state.menuIsOpen
    });
const $90f09ed730154930$export$e9caaaecfee38128 = (props, _, session, journeyId, ...args)=>$90f09ed730154930$var$createEvent('ui', 'cancelled', 'userPicker', {
        ...$90f09ed730154930$var$createDefaultPickerAttributes(props, session, journeyId),
        sessionDuration: $90f09ed730154930$var$sessionDuration(session),
        queryLength: $90f09ed730154930$var$queryLength(args[0]),
        spaceInQuery: $90f09ed730154930$var$spaceInQuery(args[0]),
        upKeyCount: $90f09ed730154930$var$upKeyCount(session),
        downKeyCount: $90f09ed730154930$var$downKeyCount(session)
    });
const $90f09ed730154930$export$48143d759475d90f = (props, state, session, journeyId, ...args)=>{
    return $90f09ed730154930$var$createEvent('ui', $90f09ed730154930$var$selectEventType(session), 'userPicker', {
        ...$90f09ed730154930$var$createDefaultPickerAttributes(props, session, journeyId),
        sessionDuration: $90f09ed730154930$var$sessionDuration(session),
        position: $90f09ed730154930$var$position(state, args[0]),
        queryLength: $90f09ed730154930$var$queryLength(state),
        spaceInQuery: $90f09ed730154930$var$spaceInQuery(state),
        upKeyCount: $90f09ed730154930$var$upKeyCount(session),
        downKeyCount: $90f09ed730154930$var$downKeyCount(session),
        result: $90f09ed730154930$var$result(args[0]),
        numberOfResults: $90f09ed730154930$var$numberOfResults(state)
    });
};
const $90f09ed730154930$export$911fb7184b6037eb = (props, state, session, journeyId)=>{
    const searchResults = $90f09ed730154930$var$results(state);
    return $90f09ed730154930$var$createEvent('operational', 'searched', 'userPicker', {
        ...$90f09ed730154930$var$createDefaultPickerAttributes(props, session, journeyId),
        sessionDuration: $90f09ed730154930$var$sessionDuration(session),
        durationSinceInputChange: $90f09ed730154930$var$durationSinceInputChange(session),
        queryLength: $90f09ed730154930$var$queryLength(state),
        isLoading: $90f09ed730154930$var$isLoading(props, state),
        results: searchResults,
        numberOfResults: searchResults.length
    });
};
const $90f09ed730154930$export$c2aec355fef65c9c = (props, _, session, journeyId)=>$90f09ed730154930$var$createEvent('operational', 'failed', 'userPicker', {
        ...$90f09ed730154930$var$createDefaultPickerAttributes(props, session, journeyId)
    });
const $90f09ed730154930$export$f541f04954b0c11e = (sources, accountId)=>$90f09ed730154930$var$createEvent('ui', 'displayed', 'userInfo', {
        sources: sources,
        // accountId can be PII if it is an email so check that it's an AAID first
        accountId: $90f09ed730154930$var$checkValidId(accountId) ? accountId : null
    });
function $90f09ed730154930$var$queryLength(state) {
    return state.inputValue.length;
}
function $90f09ed730154930$var$selectEventType(session) {
    return session && session.lastKey === 13 ? 'pressed' : 'clicked';
}
function $90f09ed730154930$var$upKeyCount(session) {
    return session ? session.upCount : null;
}
function $90f09ed730154930$var$downKeyCount(session) {
    return session ? session.downCount : null;
}
function $90f09ed730154930$var$spaceInQuery(state) {
    return state.inputValue.indexOf(' ') !== -1;
}
function $90f09ed730154930$var$sessionDuration(session) {
    return session ? Date.now() - session.start : null;
}
function $90f09ed730154930$var$durationSinceInputChange(session) {
    return session ? Date.now() - session.inputChangeTime : null;
}
function $90f09ed730154930$var$sessionId(session) {
    return session && session.id;
}
function $90f09ed730154930$var$position(state, value) {
    return value ? state.options.findIndex((option)=>option === value.data) : -1;
}
function $90f09ed730154930$var$pickerType(props) {
    return props.isMulti ? 'multi' : 'single';
}
function $90f09ed730154930$var$result(option) {
    return option ? $90f09ed730154930$var$optionData2Analytics(option.data) : null;
}
function $90f09ed730154930$var$results(state) {
    return (state.options || []).map($90f09ed730154930$var$optionData2Analytics);
}
function $90f09ed730154930$var$isLoading(props, state) {
    return state.count > 0 || props.isLoading;
}
function $90f09ed730154930$var$values(state) {
    return state.value ? Array.isArray(state.value) ? state.value.map((option)=>$90f09ed730154930$var$optionData2Analytics(option.data)) : [
        $90f09ed730154930$var$optionData2Analytics(state.value.data)
    ] : [];
}
function $90f09ed730154930$var$numberOfResults(state) {
    return (state.options || []).length;
}

});
parcelRegister("bp6ad", function(module, exports) {
$parcel$export(module.exports, "isExternalUser", () => $144d288a5555e012$export$f6058dbcb5980cb);
$parcel$export(module.exports, "isUser", () => $144d288a5555e012$export$2e44165f1da65304);
$parcel$export(module.exports, "isTeam", () => $144d288a5555e012$export$f8c4277cb588611f);
$parcel$export(module.exports, "isGroup", () => $144d288a5555e012$export$d7976824e9f55785);
$parcel$export(module.exports, "isEmail", () => $144d288a5555e012$export$7fbbfbca30081d0);
$parcel$export(module.exports, "isCustom", () => $144d288a5555e012$export$d3a8f0b77e9737fc);
$parcel$export(module.exports, "isDefaultValuePopulated", () => $144d288a5555e012$export$d6978985a41b0c8);
$parcel$export(module.exports, "extractOptionValue", () => $144d288a5555e012$export$7ae97131df521bff);
$parcel$export(module.exports, "isIterable", () => $144d288a5555e012$export$9652023d9040757);
$parcel$export(module.exports, "getOptions", () => $144d288a5555e012$export$d2312e68e1f5ad00);
$parcel$export(module.exports, "optionToSelectableOptions", () => $144d288a5555e012$export$e6fda14a194bcbcc);
$parcel$export(module.exports, "getAvatarSize", () => $144d288a5555e012$export$695fb564e621339a);
$parcel$export(module.exports, "isChildInput", () => $144d288a5555e012$export$3c62cf9a01367f27);
$parcel$export(module.exports, "isSingleValue", () => $144d288a5555e012$export$203c2bd2662d1ca2);
$parcel$export(module.exports, "hasValue", () => $144d288a5555e012$export$96bdbc84526f3739);
$parcel$export(module.exports, "callCallback", () => $144d288a5555e012$export$df325aa844b03c31);
$parcel$export(module.exports, "getAvatarUrl", () => $144d288a5555e012$export$b4f8f1f54acec99b);
$parcel$export(module.exports, "isPopupUserPickerByComponent", () => $144d288a5555e012$export$4f60a74234178416);
$parcel$export(module.exports, "isLozengeText", () => $144d288a5555e012$export$5419897287f5f1c7);

var $LFmXM = parcelRequire("LFmXM");


var $sl8jM = parcelRequire("sl8jM");
const $144d288a5555e012$export$f6058dbcb5980cb = (option)=>option.type === (0, $f4e041c5b2b1b75c$export$50042ec1d2e00e63) || Boolean(option.isExternal);
const $144d288a5555e012$export$2e44165f1da65304 = (option)=>option.type === undefined || option.type === (0, $f4e041c5b2b1b75c$export$8436e53e45ffe15b);
const $144d288a5555e012$export$f8c4277cb588611f = (option)=>option.type === (0, $f4e041c5b2b1b75c$export$26bc40b960693765);
const $144d288a5555e012$export$d7976824e9f55785 = (option)=>option.type === (0, $f4e041c5b2b1b75c$export$d460f747b73abb10);
const $144d288a5555e012$export$7fbbfbca30081d0 = (option)=>option.type === (0, $f4e041c5b2b1b75c$export$6662b3461398ef8c);
const $144d288a5555e012$export$d3a8f0b77e9737fc = (option)=>option.type === (0, $f4e041c5b2b1b75c$export$eafd0979afa5b224);
const $144d288a5555e012$export$d6978985a41b0c8 = (value)=>value && !Array.isArray(value) || Array.isArray(value) && value.length > 0;
const $144d288a5555e012$var$isOptionData = (option)=>option.name !== undefined;
const $144d288a5555e012$export$3f993c492bd6c728 = (option)=>{
    if ($144d288a5555e012$var$isOptionData(option)) return {
        data: option,
        isDisabled: option.isDisabled,
        label: option.name,
        value: option.id
    };
    else return {
        data: {
            ...option,
            name: option.id
        },
        isDisabled: option.isDisabled,
        label: option.id,
        value: option.id
    };
};
const $144d288a5555e012$export$7ae97131df521bff = (value)=>{
    if (!value) return undefined;
    if (Array.isArray(value)) return value.map(({ data: option })=>option);
    return value.data;
};
const $144d288a5555e012$export$9652023d9040757 = (a)=>typeof a?.[Symbol.iterator] === 'function';
const $144d288a5555e012$export$d2312e68e1f5ad00 = (0, $LFmXM.default)((options)=>options.map($144d288a5555e012$export$3f993c492bd6c728));
const $144d288a5555e012$export$e6fda14a194bcbcc = (0, $LFmXM.default)((defaultValue)=>{
    if (!defaultValue) return null;
    if (Array.isArray(defaultValue)) return defaultValue.map($144d288a5555e012$export$3f993c492bd6c728);
    return $144d288a5555e012$export$3f993c492bd6c728(defaultValue);
});
const $144d288a5555e012$export$695fb564e621339a = (appearance)=>appearance === 'big' ? 'medium' : appearance === 'multi' ? 'xsmall' : 'small';
const $144d288a5555e012$export$3c62cf9a01367f27 = (child)=>child && typeof child === 'object' && child.props && child.props.type === 'text';
const $144d288a5555e012$export$203c2bd2662d1ca2 = (value)=>!!value && !Array.isArray(value);
const $144d288a5555e012$export$96bdbc84526f3739 = (value)=>!!value && value.trim().length > 0;
const $144d288a5555e012$export$df325aa844b03c31 = (callback, ...args)=>{
    if (typeof callback === 'function') try {
        //  there is mystery error in IE 11, so we need this try-catch
        return callback(...args);
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error('@atlassian/user-select: an error happening in `callCallback`: ', error);
    }
    return undefined;
};
const $144d288a5555e012$export$b4f8f1f54acec99b = (optionData)=>{
    if ($144d288a5555e012$export$2e44165f1da65304(optionData) || $144d288a5555e012$export$f8c4277cb588611f(optionData) || $144d288a5555e012$export$d3a8f0b77e9737fc(optionData) || $144d288a5555e012$export$f6058dbcb5980cb(optionData)) return optionData.avatarUrl;
    return undefined;
};
const $144d288a5555e012$export$4f60a74234178416 = (SelectComponent)=>SelectComponent === (0, $sl8jM.default);
const $144d288a5555e012$export$7add003953ca6733 = (selectProps)=>selectProps.searchThreshold === -1;
const $144d288a5555e012$export$5419897287f5f1c7 = (lozengeProp)=>{
    return lozengeProp?.hasOwnProperty('text') || false;
};

});
const $f4e041c5b2b1b75c$export$8436e53e45ffe15b = 'user';
const $f4e041c5b2b1b75c$export$50042ec1d2e00e63 = 'external_user';
const $f4e041c5b2b1b75c$export$26bc40b960693765 = 'team';
const $f4e041c5b2b1b75c$export$d460f747b73abb10 = 'group';
const $f4e041c5b2b1b75c$export$6662b3461398ef8c = 'email';
const $f4e041c5b2b1b75c$export$eafd0979afa5b224 = 'custom';



parcelRegister("4yPQa", function(module, exports) {
$parcel$export(module.exports, "batchByKey", () => $0defaf7e1ec76e58$export$da86c38211c1c0a8);
function $0defaf7e1ec76e58$export$da86c38211c1c0a8(callback) {
    const calls = {};
    return (key, ...args)=>{
        if (!calls[key]) {
            window.setTimeout(()=>{
                callback(key, calls[key]);
                delete calls[key];
            });
            calls[key] = [];
        }
        calls[key].push(args);
    };
}

});

parcelRegister("aemwP", function(module, exports) {
$parcel$export(module.exports, "messages", () => $909cb0f93070a370$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $909cb0f93070a370$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    placeholder: {
        id: 'fabric.elements.user-picker.placeholder',
        defaultMessage: 'Enter people or teams...',
        description: 'Placeholder description for empty user/team/email select field.'
    },
    addMore: {
        id: 'fabric.elements.user-picker.placeholder.add-more',
        defaultMessage: 'add more people...',
        description: 'Placeholder for multi user picker when the field is not empty.'
    },
    remove: {
        id: 'fabric.elements.user-picker.multi.remove-item',
        defaultMessage: 'Remove',
        description: 'Tooltip for the single item remove button in a multi user select field.'
    },
    clear: {
        id: 'fabric.elements.user-picker.single.clear',
        defaultMessage: 'Clear',
        description: 'Tooltip for clear button in the single user select field.'
    },
    errorMessage: {
        id: 'fabric.elements.user-picker.error.message',
        defaultMessage: 'Something went wrong',
        description: 'Error message to display when options fail to load.'
    },
    memberCountWithoutYou: {
        id: 'fabric.elements.user-picker.team.member.count',
        defaultMessage: "Team \u2022 {count} {count, plural, one {member} other {members}}",
        description: 'Byline to show the number of members in the team when the current user is not a member of the team'
    },
    memberCountWithYou: {
        id: 'fabric.elements.user-picker.team.member.count.including.you',
        defaultMessage: "Team \u2022 {count} {count, plural, one {member} other {members}}, including you",
        description: 'Byline to show the number of members in the team when the current user is also a member of the team'
    },
    plus50MembersWithoutYou: {
        id: 'fabric.elements.user-picker.team.member.50plus',
        defaultMessage: "Team \u2022 50+ members",
        description: 'Byline to show the number of members in the team when the number exceeds 50'
    },
    plus50MembersWithYou: {
        id: 'fabric.elements.user-picker.team.member.50plus.including.you',
        defaultMessage: "Team \u2022 50+ members, including you",
        description: 'Byline to show the number of members in the team when the number exceeds 50 and also includes the current user'
    },
    addEmail: {
        id: 'fabric.elements.user-picker.email.add',
        defaultMessage: 'Add user',
        description: 'Byline for valid email option.'
    },
    selectToAddEmail: {
        id: 'fabric.elements.user-picker.email.select.to.add',
        defaultMessage: 'Select an email address',
        description: 'Byline for valid email option.'
    },
    continueToAddEmail: {
        id: 'fabric.elements.user-picker.email.add.potential',
        defaultMessage: 'Enter an email address',
        description: 'Byline for a potentially valid email option.'
    },
    groupByline: {
        id: 'fabric.elements.user-picker.group.byline',
        defaultMessage: 'Admin-managed group',
        description: 'Byline for admin-managed groups'
    },
    externalUserSourcesHeading: {
        id: 'fabric.elements.user-picker.external.sourced.from',
        defaultMessage: 'Found in:',
        description: 'From where the external user is coming'
    },
    externalUserSourcesError: {
        id: 'fabric.elements.user-picker.external.sourced.error',
        defaultMessage: "We can't connect you right now.",
        description: "Error message when we can't fetch a user's import sources"
    },
    slackProvider: {
        id: 'fabric.elements.user-picker.slack.provider',
        defaultMessage: 'Slack',
        description: 'This external user is sourced from Slack provider'
    },
    googleProvider: {
        id: 'fabric.elements.user-picker.google.provider',
        defaultMessage: 'Google',
        description: 'This external user is sourced from Google provider'
    },
    microsoftProvider: {
        id: 'fabric.elements.user-picker.microsoft.provider',
        defaultMessage: 'Microsoft',
        description: 'This external user is sourced from Microsoft provider'
    },
    gitHubProvider: {
        id: 'fabric.elements.user-picker.github.provider',
        defaultMessage: 'GitHub',
        description: 'This external user is sourced from GitHub provider'
    },
    jiraSource: {
        id: 'fabric.elements.user-picker.source.jira',
        defaultMessage: 'Jira',
        description: 'This external user is sourced from Jira'
    },
    confluenceSource: {
        id: 'fabric.elements.user-picker.source.confluence',
        defaultMessage: 'Confluence',
        description: 'This external user is sourced from Confluence'
    },
    otherAtlassianSource: {
        id: 'fabric.elements.user-picker.source.other-atlassian',
        defaultMessage: 'Other Atlassian products',
        description: 'This external user is sourced from Atlassian products other than Jira and Confluence'
    },
    otherAtlassianSourceAppify: {
        id: 'fabric.elements.user-picker.source.other-atlassian-appify',
        defaultMessage: 'Other Atlassian apps',
        description: 'This external user is sourced from Atlassian products other than Jira and Confluence'
    },
    memberLozengeText: {
        id: 'fabric.elements.user-picker.member.lozenge.text',
        defaultMessage: 'MEMBER',
        description: 'Text within the Lozenge when the user is a workspace member'
    },
    guestLozengeText: {
        id: 'fabric.elements.user-picker.guest.lozenge.text',
        defaultMessage: 'GUEST',
        description: 'Text within the lozenge when the user is a guest of confluence'
    },
    guestUserLozengeTooltip: {
        id: 'fabric.elements.user-picker.guest.lozenge.tooltip.user',
        defaultMessage: 'Guests can only access certain spaces and have limited access to user info.',
        description: 'Tooltip text for guest lozenge showing that a user is a guest in Confluence'
    },
    guestGroupLozengeTooltip: {
        id: 'fabric.elements.user-picker.guest.lozenge.tooltip.group',
        defaultMessage: 'Guest groups can only access certain spaces and have limited access to user info.',
        description: 'Tooltip text for lozenge showing that a group is for guests in Confluence'
    },
    userTypeLabel: {
        id: 'fabric.elements.user-picker.user.type.label',
        defaultMessage: 'People',
        description: 'Label for user type'
    },
    teamTypeLabel: {
        id: 'fabric.elements.user-picker.team.type.label',
        defaultMessage: 'Teams',
        description: 'Label for team type'
    },
    emailTypeLabel: {
        id: 'fabric.elements.user-picker.email.type.label',
        defaultMessage: 'Emails',
        description: 'Label for email type'
    },
    groupTypeLabel: {
        id: 'fabric.elements.user-picker.group.type.label',
        defaultMessage: 'Groups',
        description: 'Label for group type'
    },
    externalUserTypeLabel: {
        id: 'fabric.elements.user-picker.external.user.type.label',
        defaultMessage: 'External Users',
        description: 'Label for external user type'
    },
    customTypeLabel: {
        id: 'fabric.elements.user-picker.custom.type.label',
        defaultMessage: 'Customs',
        description: 'Label for custom type'
    },
    otherTypeLabel: {
        id: 'fabric.elements.user-picker.other.type.label',
        defaultMessage: 'Others',
        description: 'Label for other type'
    }
});

});

parcelRegister("ersOA", function(module, exports) {
$parcel$export(module.exports, "groupOptionsByType", () => $b84ef595e65cee7a$export$393a985f7dd07cfe);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $LFmXM = parcelRequire("LFmXM");

var $aemwP = parcelRequire("aemwP");
const $b84ef595e65cee7a$var$getLabelForType = (type)=>{
    switch(type){
        case 'user':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                ...(0, $aemwP.messages).userTypeLabel
            });
        case 'team':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                ...(0, $aemwP.messages).teamTypeLabel
            });
        case 'group':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                ...(0, $aemwP.messages).groupTypeLabel
            });
        case 'custom':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                ...(0, $aemwP.messages).customTypeLabel
            });
        case 'external_user':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                ...(0, $aemwP.messages).externalUserTypeLabel
            });
        default:
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                ...(0, $aemwP.messages).otherTypeLabel
            });
    }
};
const $b84ef595e65cee7a$export$393a985f7dd07cfe = (0, $LFmXM.default)((options, groupByTypeOrder)=>{
    // If groupByTypeOrder is empty, just return the original options
    if (groupByTypeOrder.length === 0) return options;
    const groupedMap = new Map();
    options.forEach((option)=>{
        const type = option.data.type || 'other';
        if (!groupedMap.has(type)) groupedMap.set(type, []);
        groupedMap.get(type).push(option);
    });
    const result = [];
    // add groups in the specified order
    // type is not in groupByTypeOrder, don't add it to the result
    groupByTypeOrder.forEach((type)=>{
        if (groupedMap.has(type)) {
            result.push({
                label: $b84ef595e65cee7a$var$getLabelForType(type),
                options: groupedMap.get(type)
            });
            groupedMap.delete(type);
        }
    });
    return result;
});

});

parcelRegister("1FdfR", function(module, exports) {
$parcel$export(module.exports, "userPickerRenderedUfoExperience", () => $7336f83ae434c834$export$b49757166e1acfc2);
$parcel$export(module.exports, "userPickerOptionsShownUfoExperience", () => $7336f83ae434c834$export$135a264e0da507ae);
$parcel$export(module.exports, "UfoErrorBoundary", () => $7336f83ae434c834$export$5ef1c2550074a375);

var $eJOHy = parcelRequire("eJOHy");

var $9iIu4 = parcelRequire("9iIu4");
var $aRnO1 = parcelRequire("aRnO1");
var $g0oDq = parcelRequire("g0oDq");
const $7336f83ae434c834$export$b49757166e1acfc2 = new (0, $9iIu4.ConcurrentExperience)('user-picker-rendered', {
    platform: {
        component: 'user-picker'
    },
    type: (0, $aRnO1.ExperienceTypes).Load,
    performanceType: (0, $aRnO1.ExperiencePerformanceTypes).PageSegmentLoad
});
const $7336f83ae434c834$export$135a264e0da507ae = new (0, $9iIu4.ConcurrentExperience)('user-picker-options-shown', {
    platform: {
        component: 'user-picker'
    },
    type: (0, $aRnO1.ExperienceTypes).Operation,
    performanceType: (0, $aRnO1.ExperiencePerformanceTypes).InlineResult
});
class $7336f83ae434c834$export$5ef1c2550074a375 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    componentDidCatch() {
        const instance = $7336f83ae434c834$export$b49757166e1acfc2.getInstance(this.props.id);
        if (instance.state.id !== (0, $g0oDq.UFOExperienceState).FAILED.id) instance.failure();
    }
    render() {
        return this.props.children;
    }
}

});
parcelRegister("9iIu4", function(module, exports) {
$parcel$export(module.exports, "ConcurrentExperience", () => $a5bd41df052e3fc6$export$ac1cddfee07ba6ac);

var $jJiQE = parcelRequire("jJiQE");

var $2pMzV = parcelRequire("2pMzV");
class $a5bd41df052e3fc6$export$ac1cddfee07ba6ac {
    constructor(experienceId, config){
        this.instances = {};
        this.experienceId = experienceId;
        this.config = config;
    }
    getInstance(instanceId) {
        if (!this.instances[instanceId]) this.instances[instanceId] = new (0, $2pMzV.UFOExperience)(this.experienceId, this.config, instanceId);
        return this.instances[instanceId];
    }
    release(instanceId) {
        (0, $jJiQE.ufolog)('instanceId', instanceId);
        if (this.instances[instanceId]) this.instances[instanceId].abort();
        delete this.instances[instanceId];
    }
}

});
parcelRegister("jJiQE", function(module, exports) {
$parcel$export(module.exports, "ufolog", () => $3c943c12e74b5b78$export$b4958caff08a0960);
$parcel$export(module.exports, "ufowarn", () => $3c943c12e74b5b78$export$d53d07b6034c4560);
class $3c943c12e74b5b78$var$UFOLogger {
    static{
        this.UFOprefix = "[ufo\uD83D\uDEF8]";
    }
    log(...args) {
        // eslint-disable-next-line no-console
        this.enabled && console.log($3c943c12e74b5b78$var$UFOLogger.UFOprefix, ...args);
    }
    warn(...args) {
        // eslint-disable-next-line no-console
        this.enabled && console.warn($3c943c12e74b5b78$var$UFOLogger.UFOprefix, ...args);
    }
    enable() {
        this.enabled = true;
    }
    disable() {
        this.enabled = false;
    }
    constructor(){
        this.enabled = false;
    }
}
const $3c943c12e74b5b78$export$4ab84f6f04f6566d = new $3c943c12e74b5b78$var$UFOLogger();
const $3c943c12e74b5b78$export$b4958caff08a0960 = (...args)=>{
    $3c943c12e74b5b78$export$4ab84f6f04f6566d.log(...args);
};
const $3c943c12e74b5b78$export$d53d07b6034c4560 = (...args)=>{
    $3c943c12e74b5b78$export$4ab84f6f04f6566d.warn(...args);
};

});

parcelRegister("2pMzV", function(module, exports) {
$parcel$export(module.exports, "UFOExperience", () => $eb40b99b73192801$export$c00d22927c60484a);

var $aSYAD = parcelRequire("aSYAD");
class $eb40b99b73192801$export$c00d22927c60484a extends (0, $aSYAD.UFOAbstractExperience) {
}

});
parcelRegister("aSYAD", function(module, exports) {
$parcel$export(module.exports, "UFOAbstractExperience", () => $fb5df3e7e01c2259$export$d31c89db257648c);
// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead

var $aXKmr = parcelRequire("aXKmr");


var $6uX6b = parcelRequire("6uX6b");

var $jJiQE = parcelRequire("jJiQE");

var $5hbWe = parcelRequire("5hbWe");

var $ccWvh = parcelRequire("ccWvh");

var $aP4V0 = parcelRequire("aP4V0");

var $2Ilzg = parcelRequire("2Ilzg");

var $g0oDq = parcelRequire("g0oDq");

var $8OSL8 = parcelRequire("8OSL8");

var $aRnO1 = parcelRequire("aRnO1");
const $fb5df3e7e01c2259$var$getPageVisibleState = ()=>{
    return !(0, $2Ilzg.isWindowObjectAvailable)() || !window.document || window.document.visibilityState === 'visible' ? (0, $ccWvh.PageVisibleState).VISIBLE : (0, $ccWvh.PageVisibleState).HIDDEN;
};
const $fb5df3e7e01c2259$export$c753e8669d30c8ad = (timestamp)=>{
    if (timestamp !== undefined) return ~~timestamp;
    return (0, $aP4V0.roundPerfNow)();
};
class $fb5df3e7e01c2259$export$d31c89db257648c {
    constructor(id, config, instanceId = null){
        this.state = (0, $g0oDq.UFOExperienceState).NOT_STARTED;
        this.instanceId = null // for concurrent
        ;
        this.parent = null;
        this.category = null;
        this.metadata = {};
        this.onDoneCallbacks = [];
        this.childExperiences = [];
        this.explicitTimings = {};
        // @todo move to page load experience when proper classes/inheritance prepared
        this.isSSROutputAsFMP = false;
        this.uuid = null;
        this._until = null;
        this.metrics = {
            startTime: null,
            endTime: null,
            marks: []
        };
        this.performanceConfig = {};
        this.setPageVisibleStateToMixed = ()=>{
            this.pageVisibleState = (0, $ccWvh.PageVisibleState).MIXED;
            (0, $5hbWe.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
        };
        this.id = id;
        this.category = config?.category || null;
        this.until = config?.until || null;
        this.instanceId = instanceId;
        this.handleDoneBind = this._handleDoneExperience.bind(this);
        this.type = config.type;
        this.performanceType = config.performanceType;
        this.performanceConfig = config.performanceConfig || {};
        this.config = config;
        this.pageVisibleState = $fb5df3e7e01c2259$var$getPageVisibleState();
        this.featureFlags = config.featureFlags || [];
        this.timings = config.timings || [];
        if (config.performanceType === (0, $aRnO1.ExperiencePerformanceTypes).PageLoad || config.performanceType === (0, $aRnO1.ExperiencePerformanceTypes).PageSegmentLoad) this.isSSROutputAsFMP = config.isSSROutputAsFMP || false;
    }
    async transition(newState, timestamp) {
        (0, $jJiQE.ufolog)('async transition', this.id, this.state.id, newState.id);
        if ((0, $8OSL8.canTransition)(this.state, newState)) {
            (0, $jJiQE.ufolog)(`TRANSITION: ${this.id} from ${this.state.id} to ${newState.id} successful`, this.state.final, !newState.final);
            if (newState === (0, $g0oDq.UFOExperienceState).STARTED) this._reset();
            if (this.state.final && !newState.final) {
                this.metrics.startTime = $fb5df3e7e01c2259$export$c753e8669d30c8ad(timestamp);
                // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
                this.uuid = (0, $aXKmr.v4)();
            }
            this.state = newState;
            if (newState.final) {
                this.metrics.endTime = $fb5df3e7e01c2259$export$c753e8669d30c8ad(timestamp);
                if (!this._isManualStateEnabled()) (0, $6uX6b.getGlobalEventStream)().push((0, $6uX6b.unsubscribeEvent)((0, $ccWvh.SUBSCRIBE_ALL), this.handleDoneBind));
                const data = await this.exportData();
                (0, $jJiQE.ufolog)('this.parent', this.parent);
                (0, $6uX6b.getGlobalEventStream)().push((0, $6uX6b.experiencePayloadEvent)(data));
            }
            return true;
        }
        (0, $jJiQE.ufolog)(`TRANSITION: ${this.id} from ${this.state.id} to ${newState.id} unsuccessful`);
        (0, $jJiQE.ufowarn)(`transition of ${this.id} from ${this.state} to ${newState} is not possible`);
        return false;
    }
    async start(startTime) {
        const transitionSuccessful = await this.transition((0, $g0oDq.UFOExperienceState).STARTED, startTime);
        if (transitionSuccessful) {
            this.pageVisibleState = $fb5df3e7e01c2259$var$getPageVisibleState();
            (0, $5hbWe.visibilityChangeObserver).subscribe(this.setPageVisibleStateToMixed);
            if (!this._isManualStateEnabled()) {
                (0, $jJiQE.ufolog)('subscribed', this.id);
                (0, $6uX6b.getGlobalEventStream)().push((0, $6uX6b.subscribeEvent)((0, $ccWvh.SUBSCRIBE_ALL), this.handleDoneBind));
            }
        }
    }
    mark(name, timestamp) {
        if (name !== (0, $ccWvh.FMP_MARK) && name !== (0, $ccWvh.INLINE_RESPONSE_MARK)) this._mark(name, timestamp);
        else (0, $jJiQE.ufowarn)('please use markFMP or markInlineResponse for specialised marks');
    }
    _mark(name, timestamp) {
        this.metrics.marks.push({
            name: name,
            time: $fb5df3e7e01c2259$export$c753e8669d30c8ad(timestamp)
        });
        this.transition((0, $g0oDq.UFOExperienceState).IN_PROGRESS);
    }
    markFMP(timestamp) {
        this._mark((0, $ccWvh.FMP_MARK), timestamp);
    }
    markInlineResponse(timestamp) {
        this._mark((0, $ccWvh.INLINE_RESPONSE_MARK), timestamp);
    }
    _isManualStateEnabled() {
        return this.until === null;
    }
    _validateManualState() {
        if (!this._isManualStateEnabled()) {
            (0, $jJiQE.ufowarn)('manual change of state not allowed as "until" is defined');
            return false;
        }
        return true;
    }
    switchToEndState(state, config) {
        if (!config?.force && !this._validateManualState()) return null;
        if (config?.metadata) this.addMetadata(config.metadata);
        (0, $5hbWe.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
        return this.transition(state);
    }
    async success(config) {
        return this.switchToEndState((0, $g0oDq.UFOExperienceState).SUCCEEDED, config);
    }
    async failure(config) {
        return this.switchToEndState((0, $g0oDq.UFOExperienceState).FAILED, config);
    }
    async abort(config) {
        return this.switchToEndState((0, $g0oDq.UFOExperienceState).ABORTED, config);
    }
    addMetadata(data) {
        Object.assign(this.metadata, data);
    }
    _handleDoneExperience(data) {
        (0, $jJiQE.ufolog)('_handleDoneExperience in', this.id, data.state, data, this._until);
        if (data.state.final) {
            if (this._until !== null) {
                const { done: done, state: state } = this._until(data);
                if (done && !this.state.final) this.transition(state);
            }
        }
    }
    async getId() {
        return this.id;
    }
    async exportData() {
        return {
            id: await this.getId(),
            uuid: this.uuid,
            type: this.type,
            schemaVersion: (0, $4e1f4772088a5f3c$export$2295b861f318254a) || 'unknown',
            performanceType: this.performanceType,
            category: this.category,
            state: this.state,
            metadata: {
                ...this.metadata
            },
            metrics: {
                ...this.metrics
            },
            children: [
                ...this.childExperiences
            ],
            result: {
                success: !!this.state.success,
                startTime: this.metrics.startTime,
                duration: (this.metrics.endTime || 0) - (this.metrics.startTime || 0)
            },
            platform: this.config.platform || null,
            pageVisibleState: this.pageVisibleState,
            featureFlags: this.featureFlags,
            isSSROutputAsFMP: this.isSSROutputAsFMP,
            timings: this.timings,
            explicitTimings: this.explicitTimings,
            performanceConfig: this.performanceConfig
        };
    }
    _reset() {
        this.parent = null;
        this.metadata = {};
        this.onDoneCallbacks = [];
        this.childExperiences = [];
        this.metrics = {
            startTime: null,
            endTime: null,
            marks: []
        };
        this._until = this.until ? this.until() : null;
    }
}

});
// temp solution until we can get it automated
const $4e1f4772088a5f3c$export$2295b861f318254a = '0.1.5';

parcelRegister("6uX6b", function(module, exports) {
$parcel$export(module.exports, "getGlobalEventStream", () => $aa71c8960fce0a9f$export$6123a44dc2384540);
$parcel$export(module.exports, "subscribeEvent", () => $aa71c8960fce0a9f$export$37863216db4b714d);
$parcel$export(module.exports, "unsubscribeEvent", () => $aa71c8960fce0a9f$export$ee1a7bd1fc9ea85e);
$parcel$export(module.exports, "experiencePayloadEvent", () => $aa71c8960fce0a9f$export$7c957416596ca127);

var $jJiQE = parcelRequire("jJiQE");

var $ccWvh = parcelRequire("ccWvh");
const $aa71c8960fce0a9f$var$MAX_EARLY_QUEUE_LENGTH = 250;
const $aa71c8960fce0a9f$export$6123a44dc2384540 = ()=>{
    if (!globalThis.__UFO_GLOBAL_EVENT_STREAM__) {
        const earlyStream = (()=>{
            const stream = [];
            return {
                __buffer_only__: true,
                push: (event)=>{
                    if (stream.length < $aa71c8960fce0a9f$var$MAX_EARLY_QUEUE_LENGTH) stream.push(event);
                },
                getStream: ()=>stream
            };
        })();
        globalThis.__UFO_GLOBAL_EVENT_STREAM__ = earlyStream;
    }
    return globalThis.__UFO_GLOBAL_EVENT_STREAM__;
};
const $aa71c8960fce0a9f$export$c1522520b417b066 = (eventStream)=>{
    if (globalThis.__UFO_GLOBAL_EVENT_STREAM__ && !globalThis.__UFO_GLOBAL_EVENT_STREAM__?.__buffer_only__) {
        (0, $jJiQE.ufowarn)('Global Event Stream already initialised. Ignoring new event stream setup');
        return;
    }
    if (globalThis.__UFO_GLOBAL_EVENT_STREAM__?.__buffer_only__) globalThis.__UFO_GLOBAL_EVENT_STREAM__.getStream().forEach(eventStream.push.bind(eventStream));
    globalThis.__UFO_GLOBAL_EVENT_STREAM__ = eventStream;
};
const $aa71c8960fce0a9f$export$37863216db4b714d = (experienceId, callback)=>{
    return {
        type: (0, $ccWvh.UFOGlobalEventStreamEventType).SUBSCRIBE,
        payload: {
            experienceId: experienceId,
            callback: callback
        }
    };
};
const $aa71c8960fce0a9f$export$ee1a7bd1fc9ea85e = (experienceId, callback)=>{
    return {
        type: (0, $ccWvh.UFOGlobalEventStreamEventType).UNSUBSCRIBE,
        payload: {
            experienceId: experienceId,
            callback: callback
        }
    };
};
const $aa71c8960fce0a9f$export$7c957416596ca127 = (data)=>{
    return {
        type: (0, $ccWvh.UFOGlobalEventStreamEventType).EXPERIENCE_PAYLOAD,
        payload: data
    };
};

});
parcelRegister("ccWvh", function(module, exports) {
$parcel$export(module.exports, "UFOGlobalEventStreamEventType", () => $eeff76e3a75af2a8$export$96253c35c37cf96b);
$parcel$export(module.exports, "PageVisibleState", () => $eeff76e3a75af2a8$export$a12c67b37a306b13);
$parcel$export(module.exports, "SUBSCRIBE_ALL", () => $eeff76e3a75af2a8$export$79bf131685ad41d7);
$parcel$export(module.exports, "FMP_MARK", () => $eeff76e3a75af2a8$export$9f2bf58999404c75);
$parcel$export(module.exports, "INLINE_RESPONSE_MARK", () => $eeff76e3a75af2a8$export$837e0f79a8056912);
var $eeff76e3a75af2a8$export$96253c35c37cf96b = /*#__PURE__*/ function(UFOGlobalEventStreamEventType) {
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["EXPERIENCE_PAYLOAD"] = 0] = "EXPERIENCE_PAYLOAD";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["SUBSCRIBE"] = 1] = "SUBSCRIBE";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["UNSUBSCRIBE"] = 2] = "UNSUBSCRIBE";
    return UFOGlobalEventStreamEventType;
}({});
var $eeff76e3a75af2a8$export$a12c67b37a306b13 = /*#__PURE__*/ function(PageVisibleState) {
    PageVisibleState["VISIBLE"] = "visible";
    PageVisibleState["HIDDEN"] = "hidden";
    PageVisibleState["MIXED"] = "mixed";
    return PageVisibleState;
}({});
var $eeff76e3a75af2a8$export$66b33c055cbb625e = /*#__PURE__*/ function(PageLoadMetrics) {
    PageLoadMetrics["fmp"] = "fmp";
    PageLoadMetrics["tti"] = "tti";
    return PageLoadMetrics;
}({});
var $eeff76e3a75af2a8$export$3ce489cbe02dc21b = /*#__PURE__*/ function(PageSegmentLoadMetrics) {
    PageSegmentLoadMetrics["fmp"] = "fmp";
    PageSegmentLoadMetrics["tti"] = "tti";
    return PageSegmentLoadMetrics;
}({});
var $eeff76e3a75af2a8$export$341b330828bd3906 = /*#__PURE__*/ function(InteractionMetrics) {
    InteractionMetrics["response"] = "response";
    InteractionMetrics["result"] = "result";
    return InteractionMetrics;
}({});
var $eeff76e3a75af2a8$export$b9b20160f581e4f8 = /*#__PURE__*/ function(CustomMetrics) {
    CustomMetrics["duration"] = "duration";
    return CustomMetrics;
}({});
const $eeff76e3a75af2a8$export$79bf131685ad41d7 = '__SUBSCRIBE_ALL__';
const $eeff76e3a75af2a8$export$9f2bf58999404c75 = 'fmp';
const $eeff76e3a75af2a8$export$837e0f79a8056912 = 'inline-response';

});


parcelRegister("5hbWe", function(module, exports) {
$parcel$export(module.exports, "visibilityChangeObserver", () => $d460cc96d513760c$export$13e680397ec8f3eb);

var $2Ilzg = parcelRequire("2Ilzg");
class $d460cc96d513760c$var$VisibilityChangeObserver {
    start() {
        if (this.started) return;
        this.started = true;
        document.addEventListener('visibilitychange', this.broadcast);
        /**
		 * According to https://developer.mozilla.org/en-US/docs/Web/API/Document/visibilitychange_event
		 * Safari doesn’t fire visibilitychange as expected when the value of the visibilityState property transitions to hidden;
		 * so for that case, you need to also include code to listen for the pagehide event.
		 */ if ((0, $2Ilzg.isWindowObjectAvailable)()) window.addEventListener('pagehide', this.broadcast);
    }
    subscribe(callback) {
        this.observers.push(callback);
    }
    unsubscribe(callback) {
        this.observers = this.observers.filter((fn)=>fn !== callback);
    }
    constructor(){
        this.started = false;
        this.observers = [];
        this.broadcast = ()=>{
            this.observers.forEach((fn)=>fn());
            this.observers = [];
        };
    }
}
const $d460cc96d513760c$export$13e680397ec8f3eb = new $d460cc96d513760c$var$VisibilityChangeObserver();

});
parcelRegister("2Ilzg", function(module, exports) {
$parcel$export(module.exports, "isWindowObjectAvailable", () => $5b8b2c70c6400f35$export$15e172712955e18f);
const $5b8b2c70c6400f35$export$15e172712955e18f = ()=>{
    return typeof window !== 'undefined';
};

});


parcelRegister("aP4V0", function(module, exports) {
$parcel$export(module.exports, "roundPerfNow", () => $53acaf7fbb090f6e$export$5f490af6b2b115cf);
const $53acaf7fbb090f6e$export$5f490af6b2b115cf = ()=>~~performance.now();

});

parcelRegister("8OSL8", function(module, exports) {
$parcel$export(module.exports, "canTransition", () => $ac48b2b50e1c5998$export$178881f329fdb81f);

var $g0oDq = parcelRequire("g0oDq");
const $ac48b2b50e1c5998$var$UFOStateAvailableTransitions = {
    [(0, $g0oDq.UFOExperienceState).NOT_STARTED.id]: [
        (0, $g0oDq.UFOExperienceState).STARTED.id
    ],
    [(0, $g0oDq.UFOExperienceState).STARTED.id]: [
        (0, $g0oDq.UFOExperienceState).IN_PROGRESS.id,
        (0, $g0oDq.UFOExperienceState).BLOCKED.id,
        (0, $g0oDq.UFOExperienceState).SUCCEEDED.id,
        (0, $g0oDq.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $g0oDq.UFOExperienceState).FAILED.id,
        (0, $g0oDq.UFOExperienceState).ABORTED.id
    ],
    [(0, $g0oDq.UFOExperienceState).IN_PROGRESS.id]: [
        (0, $g0oDq.UFOExperienceState).BLOCKED.id,
        (0, $g0oDq.UFOExperienceState).SUCCEEDED.id,
        (0, $g0oDq.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $g0oDq.UFOExperienceState).FAILED.id,
        (0, $g0oDq.UFOExperienceState).ABORTED.id
    ],
    [(0, $g0oDq.UFOExperienceState).BLOCKED.id]: [
        (0, $g0oDq.UFOExperienceState).RECOVERED.id,
        (0, $g0oDq.UFOExperienceState).ABORTED.id
    ],
    [(0, $g0oDq.UFOExperienceState).RECOVERED.id]: [
        (0, $g0oDq.UFOExperienceState).STARTED.id,
        (0, $g0oDq.UFOExperienceState).SUCCEEDED.id,
        (0, $g0oDq.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $g0oDq.UFOExperienceState).FAILED.id,
        (0, $g0oDq.UFOExperienceState).ABORTED.id
    ],
    [(0, $g0oDq.UFOExperienceState).SUCCEEDED.id]: [
        (0, $g0oDq.UFOExperienceState).STARTED.id
    ],
    [(0, $g0oDq.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id]: [
        (0, $g0oDq.UFOExperienceState).SUCCEEDED.id,
        (0, $g0oDq.UFOExperienceState).FAILED.id,
        (0, $g0oDq.UFOExperienceState).ABORTED.id
    ],
    [(0, $g0oDq.UFOExperienceState).FAILED.id]: [
        (0, $g0oDq.UFOExperienceState).STARTED.id
    ],
    [(0, $g0oDq.UFOExperienceState).ABORTED.id]: [
        (0, $g0oDq.UFOExperienceState).STARTED.id
    ]
};
const $ac48b2b50e1c5998$export$178881f329fdb81f = (state1, state2)=>{
    return $ac48b2b50e1c5998$var$UFOStateAvailableTransitions[state1.id] && $ac48b2b50e1c5998$var$UFOStateAvailableTransitions[state1.id].includes(state2.id);
};

});

parcelRegister("aRnO1", function(module, exports) {
$parcel$export(module.exports, "ExperienceTypes", () => $a0f874ab7df0b90c$export$994164cf3ae1cc9a);
$parcel$export(module.exports, "ExperiencePerformanceTypes", () => $a0f874ab7df0b90c$export$cc26007c03242fff);
var $a0f874ab7df0b90c$export$994164cf3ae1cc9a = /*#__PURE__*/ function(ExperienceTypes) {
    ExperienceTypes["Load"] = "load";
    ExperienceTypes["Experience"] = "experience";
    ExperienceTypes["Operation"] = "operation";
    return ExperienceTypes;
}({});
var $a0f874ab7df0b90c$export$cc26007c03242fff = /*#__PURE__*/ function(ExperiencePerformanceTypes) {
    ExperiencePerformanceTypes["PageLoad"] = "page-load";
    ExperiencePerformanceTypes["PageSegmentLoad"] = "page-segment-load";
    ExperiencePerformanceTypes["InlineResult"] = "inline-result";
    ExperiencePerformanceTypes["Custom"] = "custom";
    return ExperiencePerformanceTypes;
}({});

});






parcelRegister("7Vnqr", function(module, exports) {
$parcel$export(module.exports, "getStyles", () => $b204074a529ee29d$export$ffd58b7f6f099a57);
$parcel$export(module.exports, "getPopupStyles", () => $b204074a529ee29d$export$4e983f376ad8a3af);


var $LFmXM = parcelRequire("LFmXM");

var $e9zKl = parcelRequire("e9zKl");

var $eGOwo = parcelRequire("eGOwo");
const $b204074a529ee29d$export$59c188914e58c94b = "var(--ds-space-075, 6px)";
const $b204074a529ee29d$export$53937c04f7dfc2ae = 6;
const $b204074a529ee29d$export$2c62ba763e976c54 = 39;
const $b204074a529ee29d$export$ffd58b7f6f099a57 = (0, $LFmXM.default)((width, isMulti, isCompact, overrideStyles, isVisualRefresh, isPopupStyles, height)=>{
    let styles = {
        menu: (css, state)=>({
                ...css,
                width: width,
                minWidth: state.selectProps.menuMinWidth,
                zIndex: '400'
            }),
        menuList: (css)=>({
                ...css,
                zIndex: '400'
            }),
        control: (css, state)=>{
            const isMulti = state.selectProps.isMulti;
            return {
                ...css,
                width: width,
                borderColor: state.isFocused ? `var(--ds-border-focused, ${css.borderColor})` : state.isInvalid ? `var(--ds-border-danger, ${0, $7bb4c1736002a04a$export$2010d0fb4295b346})` : state.selectProps.subtle || state.selectProps.noBorder ? 'transparent' : `var(--ds-border-input, ${0, $7bb4c1736002a04a$export$7c87d337fb91a97d})`,
                backgroundColor: state.isFocused ? `var(--ds-background-input, ${css['backgroundColor']})` : state.selectProps.subtle ? 'transparent' : state.selectProps.textFieldBackgroundColor ? `var(--ds-background-input, ${0, $7bb4c1736002a04a$export$e655ef011c4aa1a2})` : `var(--ds-background-input, ${0, $7bb4c1736002a04a$export$9fdfb749e33cdf97})`,
                '&:hover .fabric-user-picker__clear-indicator': {
                    opacity: 1
                },
                ':hover': {
                    ...css[':hover'],
                    borderColor: state.isFocused ? css[':hover'] ? `var(--ds-border-focused, ${css[':hover'].borderColor})` : `var(--ds-border-focused, ${0, $7bb4c1736002a04a$export$ecfc1dff386a3e7a})` : state.isInvalid ? `var(--ds-border-danger, ${0, $7bb4c1736002a04a$export$2010d0fb4295b346})` : state.selectProps.subtle ? 'transparent' : `var(--ds-border-input, ${0, $7bb4c1736002a04a$export$7c87d337fb91a97d})`,
                    backgroundColor: state.selectProps.subtle && state.selectProps.hoveringClearIndicator ? `var(--ds-background-danger, ${0, $7bb4c1736002a04a$export$4b84fd0e2c617bd})` : state.isFocused ? css[':hover'] ? `var(--ds-background-input, ${css[':hover'].backgroundColor})` : `var(--ds-background-input, ${0, $7bb4c1736002a04a$export$29a4f05edc054374})` : state.isDisabled ? `var(--ds-background-disabled, ${0, $7bb4c1736002a04a$export$e655ef011c4aa1a2})` : `var(--ds-background-input-hovered, ${0, $7bb4c1736002a04a$export$3e51e8f1440314ba})`
                },
                padding: 0,
                minHeight: height && (0, $eGOwo.fg)('jifjam_bulk_operations') || isCompact ? 'none' : 44,
                /* IE 11 needs to set height explicitly to be vertical align when being in not compact mode */ height: height && (0, $eGOwo.fg)('jifjam_bulk_operations') ? height : isCompact || isMulti ? '100%' : 44,
                maxWidth: '100%'
            };
        },
        clearIndicator: ({ paddingTop: paddingTop, paddingBottom: paddingBottom, paddingLeft: paddingLeft, paddingRight: paddingRight, ...css })=>({
                ...css,
                // By default show clear indicator, except for on devices where "hover" is supported.
                // This means mobile devices (which do not support hover) will be able to see the clear indicator.
                opacity: 1,
                '@media (hover: hover) and (pointer: fine)': {
                    opacity: 0
                },
                transition: css.transition + ', opacity 150ms',
                paddingTop: 0,
                padding: 0,
                ':hover': {
                    color: `var(--ds-icon-danger, ${0, $7bb4c1736002a04a$export$2010d0fb4295b346})`
                }
            }),
        indicatorsContainer: (css)=>({
                ...css,
                paddingRight: "var(--ds-space-050, 4px)"
            }),
        valueContainer: ({ paddingTop: paddingTop, paddingBottom: paddingBottom, position: position, ...css }, state)=>{
            const isMulti = state.selectProps.isMulti;
            return {
                ...css,
                gridTemplateColumns: 'auto 1fr',
                paddingTop: isCompact ? 0 : $b204074a529ee29d$export$59c188914e58c94b,
                paddingBottom: isCompact ? 0 : $b204074a529ee29d$export$59c188914e58c94b,
                paddingLeft: isMulti ? $b204074a529ee29d$export$59c188914e58c94b : 0,
                overflowX: 'hidden',
                overflowY: 'auto',
                scrollbarWidth: 'none',
                maxHeight: state.selectProps.maxPickerHeight || '100%',
                '::-webkit-scrollbar': {
                    width: 0,
                    background: 'transparent'
                }
            };
        },
        multiValue: (css)=>({
                ...css,
                borderRadius: 24,
                cursor: 'default'
            }),
        multiValueLabel: (css)=>({
                ...css,
                display: 'flex'
            }),
        multiValueRemove: (css)=>({
                ...css,
                borderRadius: 24,
                cursor: 'pointer'
            }),
        placeholder: (css, state)=>{
            // fix styling in IE 11: when the position is absolute and `left` prop is not defined,
            // IE and other browsers auto calculate value of "left" prop differently,
            // so we want to explicitly set value for the `left` property
            if (css.position === 'absolute' && !css.left) css.left = `${$b204074a529ee29d$export$59c188914e58c94b}px`;
            return {
                ...css,
                gridArea: '1/2/2/3',
                paddingLeft: state.selectProps.isMulti ? 0 : $b204074a529ee29d$export$59c188914e58c94b,
                /* Margin left right of 2px set by default */ // margin: `0 ${BORDER_PADDING}px`,
                margin: 0,
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis'
            };
        },
        option: (css)=>{
            if (isVisualRefresh) return {
                ...css,
                overflow: 'hidden',
                paddingLeft: isPopupStyles ? "var(--ds-space-200, 16px)" : "var(--ds-space-100, 8px)",
                paddingRight: isPopupStyles ? "var(--ds-space-200, 16px)" : "var(--ds-space-100, 8px)"
            };
            return {
                ...css,
                overflow: 'hidden'
            };
        },
        input: (css, state)=>({
                ...css,
                gridArea: '1/2/2/3',
                gridTemplateColumns: isMulti && state.placeholder ? '0 123px' : css.gridTemplateColumns,
                /* Necessary to make input height and tag height the same. */ margin: `${"var(--ds-space-050, 4px)"} 0`,
                /* Padding top and bottom of 2 is set by default. */ paddingTop: 0,
                paddingBottom: 0,
                paddingLeft: state.selectProps.isMulti ? 0 : $b204074a529ee29d$export$59c188914e58c94b,
                '& input::placeholder': {
                    /* Chrome, Firefox, Opera, Safari 10.1+ */ color: `var(--ds-text-subtlest, ${0, $7bb4c1736002a04a$export$d6447c357493214f})`,
                    opacity: 1 /* Firefox */ 
                },
                '& input:-ms-input-placeholder': {
                    /* Internet Explorer 10-11 */ color: `var(--ds-text-subtlest, ${0, $7bb4c1736002a04a$export$d6447c357493214f})`
                }
            }),
        singleValue: (css)=>({
                ...css,
                margin: 0,
                gridArea: '1/2/2/3'
            })
    };
    return overrideStyles ? (0, $e9zKl.mergeStyles)(styles, overrideStyles) : styles;
});
const $b204074a529ee29d$export$4e983f376ad8a3af = (0, $LFmXM.default)((width, isMulti, overrideStyles, isVisualRefresh)=>({
        ...$b204074a529ee29d$export$ffd58b7f6f099a57(width, isMulti, false, overrideStyles, isVisualRefresh, true)
    }));

});
var $7bb4c1736002a04a$exports = {};
$parcel$export($7bb4c1736002a04a$exports, "R50", () => $7bb4c1736002a04a$export$4b84fd0e2c617bd);
$parcel$export($7bb4c1736002a04a$exports, "R75", () => $7bb4c1736002a04a$export$b34b069eff244586);
$parcel$export($7bb4c1736002a04a$exports, "R100", () => $7bb4c1736002a04a$export$be802dd0d8b57f35);
$parcel$export($7bb4c1736002a04a$exports, "R200", () => $7bb4c1736002a04a$export$60847d42f9da92a6);
$parcel$export($7bb4c1736002a04a$exports, "R300", () => $7bb4c1736002a04a$export$4a7404f376229999);
$parcel$export($7bb4c1736002a04a$exports, "R400", () => $7bb4c1736002a04a$export$2010d0fb4295b346);
$parcel$export($7bb4c1736002a04a$exports, "R500", () => $7bb4c1736002a04a$export$2837b5a1a71d5c02);
$parcel$export($7bb4c1736002a04a$exports, "Y50", () => $7bb4c1736002a04a$export$8d9596b529bbb9cf);
$parcel$export($7bb4c1736002a04a$exports, "Y75", () => $7bb4c1736002a04a$export$41060a744ab0b7ae);
$parcel$export($7bb4c1736002a04a$exports, "Y100", () => $7bb4c1736002a04a$export$1cc05bbbf340e559);
$parcel$export($7bb4c1736002a04a$exports, "Y200", () => $7bb4c1736002a04a$export$5aae31392d72caaa);
$parcel$export($7bb4c1736002a04a$exports, "Y300", () => $7bb4c1736002a04a$export$c6930421db9fa514);
$parcel$export($7bb4c1736002a04a$exports, "Y400", () => $7bb4c1736002a04a$export$59619663aa6500fb);
$parcel$export($7bb4c1736002a04a$exports, "Y500", () => $7bb4c1736002a04a$export$874739ea9e379ab6);
$parcel$export($7bb4c1736002a04a$exports, "G50", () => $7bb4c1736002a04a$export$8a6341c32b6a3ee6);
$parcel$export($7bb4c1736002a04a$exports, "G75", () => $7bb4c1736002a04a$export$69a3bf21b9686c2b);
$parcel$export($7bb4c1736002a04a$exports, "G100", () => $7bb4c1736002a04a$export$afbce1382ec95f73);
$parcel$export($7bb4c1736002a04a$exports, "G200", () => $7bb4c1736002a04a$export$747d86715d4175de);
$parcel$export($7bb4c1736002a04a$exports, "G300", () => $7bb4c1736002a04a$export$940e1f69e873f202);
$parcel$export($7bb4c1736002a04a$exports, "G400", () => $7bb4c1736002a04a$export$a49394138f7b8e85);
$parcel$export($7bb4c1736002a04a$exports, "G500", () => $7bb4c1736002a04a$export$6fa04827ac68a4fb);
$parcel$export($7bb4c1736002a04a$exports, "B50", () => $7bb4c1736002a04a$export$226de0355ed012f8);
$parcel$export($7bb4c1736002a04a$exports, "B75", () => $7bb4c1736002a04a$export$8c13c2ee36917869);
$parcel$export($7bb4c1736002a04a$exports, "B100", () => $7bb4c1736002a04a$export$ecfc1dff386a3e7a);
$parcel$export($7bb4c1736002a04a$exports, "B200", () => $7bb4c1736002a04a$export$215b7063051591f1);
$parcel$export($7bb4c1736002a04a$exports, "B300", () => $7bb4c1736002a04a$export$e62e8919cca44969);
$parcel$export($7bb4c1736002a04a$exports, "B400", () => $7bb4c1736002a04a$export$b3de0ae08da2ce64);
$parcel$export($7bb4c1736002a04a$exports, "B500", () => $7bb4c1736002a04a$export$a6ee3d71bc067634);
$parcel$export($7bb4c1736002a04a$exports, "B600", () => $7bb4c1736002a04a$export$67f15409e87642a1);
$parcel$export($7bb4c1736002a04a$exports, "B700", () => $7bb4c1736002a04a$export$f0539dbc42dbb067);
$parcel$export($7bb4c1736002a04a$exports, "P50", () => $7bb4c1736002a04a$export$363e4475840015bb);
$parcel$export($7bb4c1736002a04a$exports, "P75", () => $7bb4c1736002a04a$export$4b0a4417ed59760f);
$parcel$export($7bb4c1736002a04a$exports, "P100", () => $7bb4c1736002a04a$export$6011520a64d9a187);
$parcel$export($7bb4c1736002a04a$exports, "P200", () => $7bb4c1736002a04a$export$a7175d4e9206bc80);
$parcel$export($7bb4c1736002a04a$exports, "P300", () => $7bb4c1736002a04a$export$b48405b95304b5a1);
$parcel$export($7bb4c1736002a04a$exports, "P400", () => $7bb4c1736002a04a$export$c71e4279dd54a18d);
$parcel$export($7bb4c1736002a04a$exports, "P500", () => $7bb4c1736002a04a$export$147899de772240ec);
$parcel$export($7bb4c1736002a04a$exports, "T50", () => $7bb4c1736002a04a$export$2cf711fe14c66f06);
$parcel$export($7bb4c1736002a04a$exports, "T75", () => $7bb4c1736002a04a$export$7a8f4d33f6f9772c);
$parcel$export($7bb4c1736002a04a$exports, "T100", () => $7bb4c1736002a04a$export$776c9c497ef08533);
$parcel$export($7bb4c1736002a04a$exports, "T200", () => $7bb4c1736002a04a$export$69cb3ca10c1e330e);
$parcel$export($7bb4c1736002a04a$exports, "T300", () => $7bb4c1736002a04a$export$9dc1ef0f3f48059b);
$parcel$export($7bb4c1736002a04a$exports, "T400", () => $7bb4c1736002a04a$export$7c835c78b6fcdef8);
$parcel$export($7bb4c1736002a04a$exports, "T500", () => $7bb4c1736002a04a$export$6036577f95c3877e);
$parcel$export($7bb4c1736002a04a$exports, "N0", () => $7bb4c1736002a04a$export$29a4f05edc054374);
$parcel$export($7bb4c1736002a04a$exports, "N10", () => $7bb4c1736002a04a$export$e655ef011c4aa1a2);
$parcel$export($7bb4c1736002a04a$exports, "N20", () => $7bb4c1736002a04a$export$9fdfb749e33cdf97);
$parcel$export($7bb4c1736002a04a$exports, "N30", () => $7bb4c1736002a04a$export$3e51e8f1440314ba);
$parcel$export($7bb4c1736002a04a$exports, "N40", () => $7bb4c1736002a04a$export$1ce2d1575d444ceb);
$parcel$export($7bb4c1736002a04a$exports, "N50", () => $7bb4c1736002a04a$export$8754fc7e6d8b3000);
$parcel$export($7bb4c1736002a04a$exports, "N60", () => $7bb4c1736002a04a$export$c2e91cbeada39b8b);
$parcel$export($7bb4c1736002a04a$exports, "N70", () => $7bb4c1736002a04a$export$5f71e19f3a7ad9de);
$parcel$export($7bb4c1736002a04a$exports, "N80", () => $7bb4c1736002a04a$export$eaa8c8a70ac22806);
$parcel$export($7bb4c1736002a04a$exports, "N90", () => $7bb4c1736002a04a$export$7c87d337fb91a97d);
$parcel$export($7bb4c1736002a04a$exports, "N100", () => $7bb4c1736002a04a$export$d6447c357493214f);
$parcel$export($7bb4c1736002a04a$exports, "N200", () => $7bb4c1736002a04a$export$f563ee71e9ee74cd);
$parcel$export($7bb4c1736002a04a$exports, "N300", () => $7bb4c1736002a04a$export$e2ef2124cf4024b1);
$parcel$export($7bb4c1736002a04a$exports, "N400", () => $7bb4c1736002a04a$export$eece5f492e429f08);
$parcel$export($7bb4c1736002a04a$exports, "N500", () => $7bb4c1736002a04a$export$c39c0fe0f26207ae);
$parcel$export($7bb4c1736002a04a$exports, "N600", () => $7bb4c1736002a04a$export$7090862dc3038a9f);
$parcel$export($7bb4c1736002a04a$exports, "N700", () => $7bb4c1736002a04a$export$ad0bacf983b7ddaa);
$parcel$export($7bb4c1736002a04a$exports, "N800", () => $7bb4c1736002a04a$export$7d61b15e0da132af);
$parcel$export($7bb4c1736002a04a$exports, "N900", () => $7bb4c1736002a04a$export$fbda843f0a27fe96);
$parcel$export($7bb4c1736002a04a$exports, "N10A", () => $7bb4c1736002a04a$export$791e57b27ca738ef);
$parcel$export($7bb4c1736002a04a$exports, "N20A", () => $7bb4c1736002a04a$export$8d43898f60b96a82);
$parcel$export($7bb4c1736002a04a$exports, "N30A", () => $7bb4c1736002a04a$export$920c0d5c49070351);
$parcel$export($7bb4c1736002a04a$exports, "N40A", () => $7bb4c1736002a04a$export$46987b49aab6d1a8);
$parcel$export($7bb4c1736002a04a$exports, "N50A", () => $7bb4c1736002a04a$export$7d3359664e8bb0e5);
$parcel$export($7bb4c1736002a04a$exports, "N60A", () => $7bb4c1736002a04a$export$d2d3bedfb276cac0);
$parcel$export($7bb4c1736002a04a$exports, "N70A", () => $7bb4c1736002a04a$export$6e5e7499ff054f6d);
$parcel$export($7bb4c1736002a04a$exports, "N80A", () => $7bb4c1736002a04a$export$59264b346c877fa7);
$parcel$export($7bb4c1736002a04a$exports, "N90A", () => $7bb4c1736002a04a$export$d092757d7c64925c);
$parcel$export($7bb4c1736002a04a$exports, "N100A", () => $7bb4c1736002a04a$export$486ab785e4bac3c6);
$parcel$export($7bb4c1736002a04a$exports, "N200A", () => $7bb4c1736002a04a$export$fba592bbc6419fea);
$parcel$export($7bb4c1736002a04a$exports, "N300A", () => $7bb4c1736002a04a$export$13609db0e6812ab8);
$parcel$export($7bb4c1736002a04a$exports, "N400A", () => $7bb4c1736002a04a$export$fbae4efaa892d883);
$parcel$export($7bb4c1736002a04a$exports, "N500A", () => $7bb4c1736002a04a$export$f13946d26f440ce6);
$parcel$export($7bb4c1736002a04a$exports, "N600A", () => $7bb4c1736002a04a$export$19f58225ac52a306);
$parcel$export($7bb4c1736002a04a$exports, "N700A", () => $7bb4c1736002a04a$export$6384f09da70e7b62);
$parcel$export($7bb4c1736002a04a$exports, "N800A", () => $7bb4c1736002a04a$export$d0dccc730683edc2);
$parcel$export($7bb4c1736002a04a$exports, "DN900", () => $7bb4c1736002a04a$export$2f6319cf7d736c2a);
$parcel$export($7bb4c1736002a04a$exports, "DN800", () => $7bb4c1736002a04a$export$95126bc8884d6634);
$parcel$export($7bb4c1736002a04a$exports, "DN700", () => $7bb4c1736002a04a$export$8338d8c35d44ff1);
$parcel$export($7bb4c1736002a04a$exports, "DN600", () => $7bb4c1736002a04a$export$5368d76ae4fbbda7);
$parcel$export($7bb4c1736002a04a$exports, "DN500", () => $7bb4c1736002a04a$export$9f0a771d16ec8d36);
$parcel$export($7bb4c1736002a04a$exports, "DN400", () => $7bb4c1736002a04a$export$abcf8c38338b4aa5);
$parcel$export($7bb4c1736002a04a$exports, "DN300", () => $7bb4c1736002a04a$export$97e81faa16a182c7);
$parcel$export($7bb4c1736002a04a$exports, "DN200", () => $7bb4c1736002a04a$export$bfe21c59123ecf33);
$parcel$export($7bb4c1736002a04a$exports, "DN100", () => $7bb4c1736002a04a$export$ee82aa2ea6a1558);
$parcel$export($7bb4c1736002a04a$exports, "DN90", () => $7bb4c1736002a04a$export$682927c6ed76be02);
$parcel$export($7bb4c1736002a04a$exports, "DN80", () => $7bb4c1736002a04a$export$91fd9994c5be9757);
$parcel$export($7bb4c1736002a04a$exports, "DN70", () => $7bb4c1736002a04a$export$d281fbfe3cff2df6);
$parcel$export($7bb4c1736002a04a$exports, "DN60", () => $7bb4c1736002a04a$export$3902c91d8b98a753);
$parcel$export($7bb4c1736002a04a$exports, "DN50", () => $7bb4c1736002a04a$export$8e8133c1ba5845b5);
$parcel$export($7bb4c1736002a04a$exports, "DN40", () => $7bb4c1736002a04a$export$33ff357f6620b39);
$parcel$export($7bb4c1736002a04a$exports, "DN30", () => $7bb4c1736002a04a$export$633847cf062b69e0);
$parcel$export($7bb4c1736002a04a$exports, "DN20", () => $7bb4c1736002a04a$export$9776a6e503bdbf76);
$parcel$export($7bb4c1736002a04a$exports, "DN10", () => $7bb4c1736002a04a$export$6c813d5160dff5db);
$parcel$export($7bb4c1736002a04a$exports, "DN0", () => $7bb4c1736002a04a$export$3d4f271a500072a);
$parcel$export($7bb4c1736002a04a$exports, "DN800A", () => $7bb4c1736002a04a$export$fe151285c22759ec);
$parcel$export($7bb4c1736002a04a$exports, "DN700A", () => $7bb4c1736002a04a$export$a101c6190d0da34);
$parcel$export($7bb4c1736002a04a$exports, "DN600A", () => $7bb4c1736002a04a$export$4b16f52932fda51);
$parcel$export($7bb4c1736002a04a$exports, "DN500A", () => $7bb4c1736002a04a$export$a74bcd7b9845b0d8);
$parcel$export($7bb4c1736002a04a$exports, "DN400A", () => $7bb4c1736002a04a$export$9209c179316d1751);
$parcel$export($7bb4c1736002a04a$exports, "DN300A", () => $7bb4c1736002a04a$export$88f55133f636c8dd);
$parcel$export($7bb4c1736002a04a$exports, "DN200A", () => $7bb4c1736002a04a$export$51126f85d1009512);
$parcel$export($7bb4c1736002a04a$exports, "DN100A", () => $7bb4c1736002a04a$export$a069b547bd23af78);
$parcel$export($7bb4c1736002a04a$exports, "DN90A", () => $7bb4c1736002a04a$export$40cce05af3b2600a);
$parcel$export($7bb4c1736002a04a$exports, "DN80A", () => $7bb4c1736002a04a$export$b78942185925a0d);
$parcel$export($7bb4c1736002a04a$exports, "DN70A", () => $7bb4c1736002a04a$export$e058fb44b8eaafca);
$parcel$export($7bb4c1736002a04a$exports, "DN60A", () => $7bb4c1736002a04a$export$92b0b8de26920c18);
$parcel$export($7bb4c1736002a04a$exports, "DN50A", () => $7bb4c1736002a04a$export$67564f7459d3fc9e);
$parcel$export($7bb4c1736002a04a$exports, "DN40A", () => $7bb4c1736002a04a$export$77868e1ca884ffa3);
$parcel$export($7bb4c1736002a04a$exports, "DN30A", () => $7bb4c1736002a04a$export$2afd71d7d3ea2cd5);
$parcel$export($7bb4c1736002a04a$exports, "DN20A", () => $7bb4c1736002a04a$export$f2a0acaab9972c70);
$parcel$export($7bb4c1736002a04a$exports, "DN10A", () => $7bb4c1736002a04a$export$9ab70e67d6475361);
$parcel$export($7bb4c1736002a04a$exports, "T30", () => $7bb4c1736002a04a$export$d2adc5dedf09fced);
$parcel$export($7bb4c1736002a04a$exports, "L50", () => $7bb4c1736002a04a$export$f51762073d2bb381);
$parcel$export($7bb4c1736002a04a$exports, "L75", () => $7bb4c1736002a04a$export$95e26d54def96891);
// Reds
const $7bb4c1736002a04a$export$4b84fd0e2c617bd = '#FFEBE6';
const $7bb4c1736002a04a$export$b34b069eff244586 = '#FFBDAD';
const $7bb4c1736002a04a$export$be802dd0d8b57f35 = '#FF8F73';
const $7bb4c1736002a04a$export$60847d42f9da92a6 = '#FF7452';
const $7bb4c1736002a04a$export$4a7404f376229999 = '#FF5630';
const $7bb4c1736002a04a$export$2010d0fb4295b346 = '#DE350B';
const $7bb4c1736002a04a$export$2837b5a1a71d5c02 = '#BF2600';
const $7bb4c1736002a04a$export$8d9596b529bbb9cf = '#FFFAE6';
const $7bb4c1736002a04a$export$41060a744ab0b7ae = '#FFF0B3';
const $7bb4c1736002a04a$export$1cc05bbbf340e559 = '#FFE380';
const $7bb4c1736002a04a$export$5aae31392d72caaa = '#FFC400';
const $7bb4c1736002a04a$export$c6930421db9fa514 = '#FFAB00';
const $7bb4c1736002a04a$export$59619663aa6500fb = '#FF991F';
const $7bb4c1736002a04a$export$874739ea9e379ab6 = '#FF8B00';
const $7bb4c1736002a04a$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $7bb4c1736002a04a$export$69a3bf21b9686c2b = '#ABF5D1';
const $7bb4c1736002a04a$export$afbce1382ec95f73 = '#79F2C0';
const $7bb4c1736002a04a$export$747d86715d4175de = '#57D9A3';
const $7bb4c1736002a04a$export$940e1f69e873f202 = '#36B37E';
const $7bb4c1736002a04a$export$a49394138f7b8e85 = '#00875A';
const $7bb4c1736002a04a$export$6fa04827ac68a4fb = '#006644';
const $7bb4c1736002a04a$export$226de0355ed012f8 = '#DEEBFF';
const $7bb4c1736002a04a$export$8c13c2ee36917869 = '#B3D4FF';
const $7bb4c1736002a04a$export$ecfc1dff386a3e7a = '#4C9AFF';
const $7bb4c1736002a04a$export$215b7063051591f1 = '#2684FF';
const $7bb4c1736002a04a$export$e62e8919cca44969 = '#0065FF';
const $7bb4c1736002a04a$export$b3de0ae08da2ce64 = '#0052CC';
const $7bb4c1736002a04a$export$a6ee3d71bc067634 = '#0747A6';
const $7bb4c1736002a04a$export$67f15409e87642a1 = '#669DF1';
const $7bb4c1736002a04a$export$f0539dbc42dbb067 = '#8FB8F6';
const $7bb4c1736002a04a$export$363e4475840015bb = '#EAE6FF';
const $7bb4c1736002a04a$export$4b0a4417ed59760f = '#C0B6F2';
const $7bb4c1736002a04a$export$6011520a64d9a187 = '#998DD9';
const $7bb4c1736002a04a$export$a7175d4e9206bc80 = '#8777D9';
const $7bb4c1736002a04a$export$b48405b95304b5a1 = '#6554C0';
const $7bb4c1736002a04a$export$c71e4279dd54a18d = '#5243AA';
const $7bb4c1736002a04a$export$147899de772240ec = '#403294';
const $7bb4c1736002a04a$export$2cf711fe14c66f06 = '#E6FCFF';
const $7bb4c1736002a04a$export$7a8f4d33f6f9772c = '#B3F5FF';
const $7bb4c1736002a04a$export$776c9c497ef08533 = '#79E2F2';
const $7bb4c1736002a04a$export$69cb3ca10c1e330e = '#00C7E6';
const $7bb4c1736002a04a$export$9dc1ef0f3f48059b = '#00B8D9';
const $7bb4c1736002a04a$export$7c835c78b6fcdef8 = '#00A3BF';
const $7bb4c1736002a04a$export$6036577f95c3877e = '#008DA6';
const $7bb4c1736002a04a$export$29a4f05edc054374 = '#FFFFFF';
const $7bb4c1736002a04a$export$e655ef011c4aa1a2 = '#FAFBFC';
const $7bb4c1736002a04a$export$9fdfb749e33cdf97 = '#F4F5F7';
const $7bb4c1736002a04a$export$3e51e8f1440314ba = '#EBECF0';
const $7bb4c1736002a04a$export$1ce2d1575d444ceb = '#DFE1E6';
const $7bb4c1736002a04a$export$8754fc7e6d8b3000 = '#C1C7D0';
const $7bb4c1736002a04a$export$c2e91cbeada39b8b = '#B3BAC5';
const $7bb4c1736002a04a$export$5f71e19f3a7ad9de = '#A5ADBA';
const $7bb4c1736002a04a$export$eaa8c8a70ac22806 = '#97A0AF';
const $7bb4c1736002a04a$export$7c87d337fb91a97d = '#8993A4';
const $7bb4c1736002a04a$export$d6447c357493214f = '#7A869A';
const $7bb4c1736002a04a$export$f563ee71e9ee74cd = '#6B778C';
const $7bb4c1736002a04a$export$e2ef2124cf4024b1 = '#5E6C84';
const $7bb4c1736002a04a$export$eece5f492e429f08 = '#505F79';
const $7bb4c1736002a04a$export$c39c0fe0f26207ae = '#42526E';
const $7bb4c1736002a04a$export$7090862dc3038a9f = '#344563';
const $7bb4c1736002a04a$export$ad0bacf983b7ddaa = '#253858';
const $7bb4c1736002a04a$export$7d61b15e0da132af = '#172B4D';
const $7bb4c1736002a04a$export$fbda843f0a27fe96 = '#091E42';
const $7bb4c1736002a04a$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $7bb4c1736002a04a$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $7bb4c1736002a04a$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $7bb4c1736002a04a$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $7bb4c1736002a04a$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $7bb4c1736002a04a$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $7bb4c1736002a04a$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $7bb4c1736002a04a$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $7bb4c1736002a04a$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $7bb4c1736002a04a$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $7bb4c1736002a04a$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $7bb4c1736002a04a$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $7bb4c1736002a04a$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $7bb4c1736002a04a$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $7bb4c1736002a04a$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $7bb4c1736002a04a$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $7bb4c1736002a04a$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $7bb4c1736002a04a$export$2f6319cf7d736c2a = '#E6EDFA';
const $7bb4c1736002a04a$export$95126bc8884d6634 = '#DCE5F5';
const $7bb4c1736002a04a$export$8338d8c35d44ff1 = '#CED9EB';
const $7bb4c1736002a04a$export$5368d76ae4fbbda7 = '#B8C7E0';
const $7bb4c1736002a04a$export$9f0a771d16ec8d36 = '#ABBBD6';
const $7bb4c1736002a04a$export$abcf8c38338b4aa5 = '#9FB0CC';
const $7bb4c1736002a04a$export$97e81faa16a182c7 = '#8C9CB8';
const $7bb4c1736002a04a$export$bfe21c59123ecf33 = '#7988A3';
const $7bb4c1736002a04a$export$ee82aa2ea6a1558 = '#67758F';
const $7bb4c1736002a04a$export$682927c6ed76be02 = '#56637A';
const $7bb4c1736002a04a$export$91fd9994c5be9757 = '#455166';
const $7bb4c1736002a04a$export$d281fbfe3cff2df6 = '#3B475C';
const $7bb4c1736002a04a$export$3902c91d8b98a753 = '#313D52';
const $7bb4c1736002a04a$export$8e8133c1ba5845b5 = '#283447';
const $7bb4c1736002a04a$export$33ff357f6620b39 = '#202B3D';
const $7bb4c1736002a04a$export$633847cf062b69e0 = '#1B2638';
const $7bb4c1736002a04a$export$9776a6e503bdbf76 = '#121A29';
const $7bb4c1736002a04a$export$6c813d5160dff5db = '#0E1624';
const $7bb4c1736002a04a$export$3d4f271a500072a = '#0D1424';
const $7bb4c1736002a04a$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $7bb4c1736002a04a$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $7bb4c1736002a04a$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $7bb4c1736002a04a$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $7bb4c1736002a04a$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $7bb4c1736002a04a$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $7bb4c1736002a04a$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $7bb4c1736002a04a$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $7bb4c1736002a04a$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $7bb4c1736002a04a$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $7bb4c1736002a04a$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $7bb4c1736002a04a$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $7bb4c1736002a04a$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $7bb4c1736002a04a$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $7bb4c1736002a04a$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $7bb4c1736002a04a$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $7bb4c1736002a04a$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $7bb4c1736002a04a$export$d2adc5dedf09fced = '#292A2E';
const $7bb4c1736002a04a$export$f51762073d2bb381 = '#94C748';
const $7bb4c1736002a04a$export$95e26d54def96891 = '#B3DF72';


parcelRegister("6jfsf", function(module, exports) {
$parcel$export(module.exports, "getComponents", () => $3d7d6756f5b5a2a8$export$4e811121b221213b);
$parcel$export(module.exports, "getPopupComponents", () => $3d7d6756f5b5a2a8$export$19205fd341a6bb08);

var $LFmXM = parcelRequire("LFmXM");

var $7voaJ = parcelRequire("7voaJ");

var $1vhOe = parcelRequire("1vhOe");

var $1dESj = parcelRequire("1dESj");

var $bOZ4r = parcelRequire("bOZ4r");

var $dY5oB = parcelRequire("dY5oB");

var $3uumP = parcelRequire("3uumP");

var $bVfPa = parcelRequire("bVfPa");

var $6FUJ9 = parcelRequire("6FUJ9");

var $gIhcD = parcelRequire("gIhcD");

var $75q59 = parcelRequire("75q59");

var $716IA = parcelRequire("716IA");
const $3d7d6756f5b5a2a8$export$4e811121b221213b = (0, $LFmXM.default)((multi, anchor, showClearIndicator, customComponents)=>{
    if (anchor) return {
        Control: anchor,
        Option: $bOZ4r.Option
    };
    else return {
        MultiValue: $1vhOe.MultiValue,
        DropdownIndicator: null,
        SingleValue: $dY5oB.SingleValue,
        ClearIndicator: showClearIndicator || !multi ? (0, $7voaJ.ClearIndicator) : null,
        Option: $bOZ4r.Option,
        ValueContainer: multi ? (0, $1dESj.MultiValueContainer) : (0, $bVfPa.SingleValueContainer),
        Input: $3uumP.Input,
        Menu: $75q59.Menu,
        Control: $716IA.default,
        ...customComponents ? customComponents : {}
    };
});
const $3d7d6756f5b5a2a8$export$19205fd341a6bb08 = (0, $LFmXM.default)((hasPopupTitle)=>{
    const baseProps = {
        DropdownIndicator: null,
        SingleValue: $dY5oB.SingleValue,
        ClearIndicator: $7voaJ.ClearIndicator,
        Option: $bOZ4r.Option,
        ValueContainer: (0, $bVfPa.SingleValueContainer),
        Input: (0, $6FUJ9.PopupInput)
    };
    if (hasPopupTitle) return {
        ...baseProps,
        Control: (0, $gIhcD.PopupControl)
    };
    return baseProps;
});

});
parcelRegister("7voaJ", function(module, exports) {
$parcel$export(module.exports, "ClearIndicator", () => $c06818ca522ce9a4$export$ecf9cf59142dd54a);
/* ClearIndicator.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $6XEne = parcelRequire("6XEne");

const $c06818ca522ce9a4$var$AsyncTooltip = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).lazy(()=>(parcelRequire("kMzLg")).then((module)=>{
        return {
            default: module.default
        };
    }));
const $c06818ca522ce9a4$var$clearIndicatorStyles = {
    root: "_v5641ppt _tzy4kb7n _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _30l3s4qr _1mhjgrf3"
};
class $c06818ca522ce9a4$export$ecf9cf59142dd54a extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).PureComponent {
    render() {
        const { //@ts-ignore react-select unsupported props
        selectProps: { clearValueLabel: clearValueLabel } } = this.props;
        const Indicator = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6XEne.components).ClearIndicator, {
            ...this.props,
            innerProps: {
                ...this.props.innerProps,
                onMouseDown: this.handleMouseDown
            },
            xcss: $c06818ca522ce9a4$var$clearIndicatorStyles.root
        });
        return clearValueLabel ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Suspense, {
            fallback: Indicator,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)($c06818ca522ce9a4$var$AsyncTooltip, {
                content: clearValueLabel,
                children: Indicator
            })
        }) : Indicator;
    }
    constructor(...args){
        super(...args), this.handleMouseDown = (event)=>{
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            // Prevent focus when clear on blurred state
            const { clearValue: clearValue, selectProps: selectProps } = this.props;
            clearValue();
            //@ts-ignore react-select unsupported props
            if (selectProps && !selectProps.isFocused) event.stopPropagation();
        };
    }
}

});
parcelRegister("kMzLg", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("1sNWi").then(()=>parcelRequire('jJiSi'));

});


parcelRegister("1vhOe", function(module, exports) {
$parcel$export(module.exports, "MultiValue", () => $340817c48ea29dd5$export$419cdf50db8b579);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $3Wh6p = parcelRequire("3Wh6p");
var $1DXK0 = parcelRequire("1DXK0");

var $6XEne = parcelRequire("6XEne");

var $1NIU8 = parcelRequire("1NIU8");

var $8FxQe = parcelRequire("8FxQe");

var $k7nMY = parcelRequire("k7nMY");

var $bp6ad = parcelRequire("bp6ad");

var $hMpZ8 = parcelRequire("hMpZ8");

var $lXcOw = parcelRequire("lXcOw");
function $340817c48ea29dd5$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $340817c48ea29dd5$export$118122ebc1e626fa = (valueContainer, control)=>{
    const { top: top, height: height } = valueContainer.getBoundingClientRect();
    const { height: controlHeight } = control.getBoundingClientRect();
    if (top - height < 0) valueContainer.scrollIntoView();
    if (top + height > controlHeight) valueContainer.scrollIntoView(false);
};
const $340817c48ea29dd5$var$groupTagContainer = (0, $1DXK0.xcss)({
    paddingLeft: 'space.025',
    marginTop: 'space.025'
});
const $340817c48ea29dd5$var$nameWrapper = {
    name: "1ebbz80",
    styles: "font:var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);padding-left:var(--ds-space-050, 4px)"
};
class $340817c48ea29dd5$export$419cdf50db8b579 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    constructor(props){
        super(props), this.getElemBefore = ()=>{
            const { data: { data: data } } = this.props;
            if ((0, $bp6ad.isEmail)(data)) // This element is a decorative icon and does not require a label
            return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $8FxQe.AddOptionAvatar), {
                isLozenge: true,
                isPendingAction: data.isPendingAction
            });
            if ((0, $bp6ad.isGroup)(data)) return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $8nu6j.default), {
                xcss: $340817c48ea29dd5$var$groupTagContainer
            }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hMpZ8))), {
                LEGACY_margin: "-2px 0 0 0",
                color: "currentColor",
                label: "" // This element is a decorative icon and does not require a label
                ,
                LEGACY_size: "small"
            }));
            return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $k7nMY.SizeableAvatar), {
                appearance: "multi",
                src: (0, $bp6ad.getAvatarUrl)(data),
                type: (0, $bp6ad.isTeam)(data) ? 'team' : 'person'
            });
        }, this.getElemAfter = ()=>{
            const { data: { data: data } } = this.props;
            if ((0, $bp6ad.isTeam)(data) && data.verified) return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $lXcOw.VerifiedTeamIcon), null);
            return null;
        };
        this.containerRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createRef();
    }
    componentDidUpdate() {
        const { isFocused: isFocused } = this.props;
        if (isFocused && this.containerRef.current && this.containerRef.current.parentElement && this.containerRef.current.parentElement.parentElement) $340817c48ea29dd5$export$118122ebc1e626fa(this.containerRef.current, this.containerRef.current.parentElement.parentElement);
    }
    shouldComponentUpdate(nextProps) {
        const { data: { label: label, data: data }, innerProps: innerProps, isFocused: isFocused } = this.props;
        const { data: { label: nextLabel, data: nextData }, innerProps: nextInnerProps, isFocused: nextIsFocused } = nextProps;
        // We can ignore onRemove here because it is an anonymous function
        // that will be recreated every time but with the same implementation.
        return data !== nextData || label !== nextLabel || innerProps !== nextInnerProps || isFocused !== nextIsFocused;
    }
    render() {
        const { children: children, innerProps: innerProps, ...rest } = this.props;
        return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $6XEne.components).MultiValue, {
            ...rest,
            innerProps: {
                ref: this.containerRef
            },
            cropWithEllipsis: false
        }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $3Wh6p.default), {
            alignBlock: "center"
        }, this.getElemBefore(), " ", /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
            css: $340817c48ea29dd5$var$nameWrapper
        }, children), this.getElemAfter()));
    }
}

});
parcelRegister("8FxQe", function(module, exports) {
$parcel$export(module.exports, "AddOptionAvatar", () => $b392ae2eb4910fe7$export$df396db45e491922);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $dNLHm = parcelRequire("dNLHm");


var $1NIU8 = parcelRequire("1NIU8");
parcelRequire("eJOHy");

var $eGOwo = parcelRequire("eGOwo");
const $b392ae2eb4910fe7$var$getEmailAvatarWrapperStyle = (isLozenge, isPendingAction)=>{
    const padding = isLozenge ? `${"var(--ds-space-0, 0px)"}` : `${"var(--ds-space-050, 4px)"}`;
    const backgroundColor = isPendingAction && (0, $eGOwo.fg)('twcg-444-invite-usd-improvements-m2-gate') ? "var(--ds-background-warning, #FFF5DB)" : `var(--ds-background-neutral, ${0, $7bb4c1736002a04a$export$1ce2d1575d444ceb})`;
    return /*#__PURE__*/ (0, $1NIU8.css)({
        padding: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        padding,
        backgroundColor: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        backgroundColor,
        borderRadius: "var(--ds-radius-full, 9999px)",
        display: 'flex',
        alignItems: 'center',
        marginLeft: "var(--ds-space-025, 2px)"
    });
};
const $b392ae2eb4910fe7$export$df396db45e491922 = ({ isLozenge: isLozenge, label: label, isPendingAction: isPendingAction })=>{
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: $b392ae2eb4910fe7$var$getEmailAvatarWrapperStyle(isLozenge, isPendingAction)
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dNLHm))), {
        testId: "add-option-avatar-email-icon",
        label: label || '',
        LEGACY_size: isLozenge ? 'small' : 'medium',
        LEGACY_margin: "0 0 0 -2px",
        color: isPendingAction && (0, $eGOwo.fg)('twcg-444-invite-usd-improvements-m2-gate') ? "var(--ds-text-warning, #9E4C00)" : `var(--ds-text-subtle, ${0, $7bb4c1736002a04a$export$c39c0fe0f26207ae})`
    })));
};

});
parcelRegister("dNLHm", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5776dc85eb34bd4bbf9313d62b1b5459>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a0c4d9df726ba45c$var$_react = $a0c4d9df726ba45c$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $a0c4d9df726ba45c$var$_email = $a0c4d9df726ba45c$var$_interopRequireDefault((parcelRequire("hluWa")));

var $a0c4d9df726ba45c$var$_email2 = $a0c4d9df726ba45c$var$_interopRequireDefault((parcelRequire("4ZN93")));
function $a0c4d9df726ba45c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for EmailIcon.
 * This component is EmailIcon, with `UNSAFE_fallbackIcon` set to "EmailIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for when an email-related things.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a0c4d9df726ba45c$var$EmailIcon = (props)=>/*#__PURE__*/ $a0c4d9df726ba45c$var$_react.default.createElement($a0c4d9df726ba45c$var$_email.default, Object.assign({
        name: "EmailIcon",
        LEGACY_fallbackIcon: $a0c4d9df726ba45c$var$_email2.default
    }, props));
$a0c4d9df726ba45c$var$EmailIcon.displayName = 'EmailIconMigration';
var $a0c4d9df726ba45c$var$_default = module.exports.default = $a0c4d9df726ba45c$var$EmailIcon;

});
parcelRegister("hluWa", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::11cac724462839f30810a0cf708cc3d1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ca0c654a3a0a1b61$var$_react = $ca0c654a3a0a1b61$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $ca0c654a3a0a1b61$var$_baseNew = $ca0c654a3a0a1b61$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $ca0c654a3a0a1b61$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Email".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for when an email-related things.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ca0c654a3a0a1b61$var$EmailIcon = (props)=>/*#__PURE__*/ $ca0c654a3a0a1b61$var$_react.default.createElement($ca0c654a3a0a1b61$var$_baseNew.default, Object.assign({
        name: "EmailIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v.529L8 8.128l6.5-3.6V4a.5.5 0 0 0-.5-.5zm12.5 2.743L8.363 9.641a.75.75 0 0 1-.726 0L1.5 6.243V12a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5z" clip-rule="evenodd"/>`
    }, props));
$ca0c654a3a0a1b61$var$EmailIcon.displayName = 'EmailIcon';
var $ca0c654a3a0a1b61$var$_default = module.exports.default = $ca0c654a3a0a1b61$var$EmailIcon;

});

parcelRegister("4ZN93", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3a32fb20eb7dd93a$var$_react = $3a32fb20eb7dd93a$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $3a32fb20eb7dd93a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $3a32fb20eb7dd93a$var$EmailIcon = (props)=>/*#__PURE__*/ $3a32fb20eb7dd93a$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M5 7v10h14V7zm14-2c1.1 0 2 .9 2 2v10c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2V7c0-1.1.9-2 2-2z"/><path d="M5.498 6.5H3.124c.149.44.399.854.75 1.205l5.882 5.881a3.117 3.117 0 0 0 4.41 0l5.882-5.881c.35-.351.6-.765.749-1.205h-2.373l-5.672 5.672a1.12 1.12 0 0 1-1.583 0z"/></g></svg>`
    }, props));
$3a32fb20eb7dd93a$var$EmailIcon.displayName = 'EmailIcon';
var $3a32fb20eb7dd93a$var$_default = module.exports.default = $3a32fb20eb7dd93a$var$EmailIcon;

});



parcelRegister("k7nMY", function(module, exports) {
$parcel$export(module.exports, "SizeableAvatar", () => $d0269580cbf343f0$export$44d81a88129649da);

var $gt9Am = parcelRequire("gt9Am");

var $5DgXR = parcelRequire("5DgXR");

var $6qS8z = parcelRequire("6qS8z");

var $eJOHy = parcelRequire("eJOHy");

var $bp6ad = parcelRequire("bp6ad");
class $d0269580cbf343f0$export$44d81a88129649da extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).PureComponent {
    render() {
        const { src: src, presence: presence, appearance: appearance, type: type = 'person', avatarAppearanceShape: avatarAppearanceShape } = this.props;
        const props = {
            size: (0, $bp6ad.getAvatarSize)(appearance),
            src: src,
            borderColor: 'transparent',
            presence: presence,
            ...avatarAppearanceShape && {
                appearance: avatarAppearanceShape
            }
        };
        return type === 'team' ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6qS8z.default), {
            ...props
        }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5DgXR.default), {
            ...props
        });
    }
}

});
parcelRegister("6qS8z", function(module, exports) {
$parcel$export(module.exports, "default", () => $502b93618fdc9c00$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5DgXR = parcelRequire("5DgXR");


var $6qfsx = parcelRequire("6qfsx");
const $502b93618fdc9c00$export$ebe0b8fe8b6acbfd = `var(--ds-icon-inverse, ${(0, $7bb4c1736002a04a$export$29a4f05edc054374)})`;
const $502b93618fdc9c00$export$72502e51aebdd94e = `var(--ds-icon-subtle, ${(0, $7bb4c1736002a04a$export$7c87d337fb91a97d)})`;
function $502b93618fdc9c00$export$2e2bcd8739ae039({ testId: testId, src: src, size: size = 'medium', teamId: teamId = '', compact: compact = false, ...props }) {
    // Strip ARI in case the teamId was given in that format
    teamId = teamId.replace('ari:cloud:identity::team/', '');
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5DgXR.default), {
        appearance: "square",
        ...props,
        size: size,
        src: src,
        testId: `${testId}-team-avatar`,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6qfsx.TeamAvatarImage), {
            src: src,
            size: size,
            testId: testId,
            teamId: teamId,
            compact: compact
        })
    });
}

});
parcelRegister("6qfsx", function(module, exports) {
$parcel$export(module.exports, "TeamAvatarImage", () => $deb06dadb11ac687$export$ac3673635a5387be);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $efgFx = parcelRequire("efgFx");

var $aYBsz = parcelRequire("aYBsz");
const $deb06dadb11ac687$var$boxShadowCssVar = '--avatar-box-shadow';
const $deb06dadb11ac687$var$bgColorCssVar = '--avatar-bg-color';
/**
 * We need to maintan the container styles manually until Avatar provides the correct border radius.
 * After that we can return to wrapping in <AvatarContent> rather than span
 */ const $deb06dadb11ac687$var$containerStyles = {
    root: "_19itglyw _12ji1r31 _1qu2glyw _12y31o36 _1reo15vq _18m915vq _v564ieh6 _1e0c1txw _kqswpfqs _4cvr1fhb _1bah1h6o _2lx21bp4 _80om1kw7 _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t _t9ec1aqe _9v7aze3t _qc5o1p41 _z0ai1osq _18postnw _1hfk18uv _aetrf705 _1peqidpf _11fnglyw",
    nonCompactSpacing: "_6rthv77o _1pfhv77o _12l2v77o _ahbqv77o",
    compactSpacing: "_6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t",
    circle: "_2rko1qll _14mj1qll",
    positionRelative: "_kqswh2mm",
    disabled: "_80om13gf _1hfkvuon _1peqs237"
};
const $deb06dadb11ac687$var$unboundStyles = {
    root: "_vchh18uv _bfhkcxp3 _16qs1nhn",
    interactive: "_80omtlke _4tpuw83z _ez1ykb7n _gcm11et6 _eeh8kb7n _jlxit94y"
};
const $deb06dadb11ac687$var$avatarImageStyles = {
    image: "_16jlkb7n _1o9zkb7n _i0dl1osq _1e0c1txw _1bsb1osq _4t3i1osq"
};
const $deb06dadb11ac687$var$SIZES = {
    xsmall: 16,
    small: 24,
    medium: 32,
    large: 40,
    xlarge: 96,
    xxlarge: 128
};
const $deb06dadb11ac687$var$borderRadiusMap = {
    xsmall: "_2rkol0p1",
    small: "_2rkol0p1",
    medium: "_2rkol0p1",
    large: "_2rkol0p1",
    xlarge: "_2rkol0p1",
    xxlarge: "_2rkol0p1"
};
const $deb06dadb11ac687$var$widthHeightMap = {
    xsmall: "_1bsb7vkz _4t3i7vkz",
    small: "_1bsb1tcg _4t3i1tcg",
    medium: "_1bsbzwfg _4t3izwfg",
    large: "_1bsb1ylp _4t3i1ylp",
    xlarge: "_1bsb16xz _4t3i16xz",
    xxlarge: "_1bsb1qr7 _4t3i1qr7"
};
const $deb06dadb11ac687$export$ac3673635a5387be = ({ alt: alt = '', src: src, size: size, testId: testId, teamId: teamId, compact: compact = false })=>{
    const [hasImageErrored, setHasImageErrored] = (0, $eJOHy.useState)(false);
    const avatarSrc = (0, $aYBsz.getTeamAvatarSrc)(src, teamId);
    // If src changes, reset state
    (0, $eJOHy.useEffect)(()=>{
        setHasImageErrored(false);
    }, [
        avatarSrc
    ]);
    if (!avatarSrc || hasImageErrored) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $efgFx.FallbackAvatar), {
        "aria-label": alt,
        width: $deb06dadb11ac687$var$SIZES[size],
        height: $deb06dadb11ac687$var$SIZES[size],
        "data-testid": testId,
        compact: compact
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        "data-testid": testId,
        "aria-label": alt,
        className: (0, $hcewu.default)([
            $deb06dadb11ac687$var$unboundStyles.root,
            $deb06dadb11ac687$var$containerStyles.root,
            $deb06dadb11ac687$var$borderRadiusMap[size],
            $deb06dadb11ac687$var$widthHeightMap[size],
            compact ? $deb06dadb11ac687$var$containerStyles.compactSpacing : $deb06dadb11ac687$var$containerStyles.nonCompactSpacing
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("img", {
            src: avatarSrc,
            alt: alt,
            "data-testid": testId && `${testId}--image`,
            onError: ()=>setHasImageErrored(true),
            className: (0, $hcewu.default)([
                $deb06dadb11ac687$var$avatarImageStyles.image
            ])
        })
    });
};

});
parcelRegister("efgFx", function(module, exports) {
$parcel$export(module.exports, "FallbackAvatar", () => $9a97cfaf5fcee5b8$export$eb63dcc490f6bbcd);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $6qaBj = parcelRequire("6qaBj");

var $8IeH1 = parcelRequire("8IeH1");
const $9a97cfaf5fcee5b8$var$styles = {
    wrapper: "_1e0c1txw",
    wrapperSpacing: "_19pkv77o _2hwxv77o _otyrv77o _18u0v77o",
    compactWrapperSpacing: "_19pkze3t _2hwxze3t _otyrze3t _18u0ze3t"
};
function $9a97cfaf5fcee5b8$export$eb63dcc490f6bbcd(props) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        xcss: (0, $6qaBj.cx)($9a97cfaf5fcee5b8$var$styles.wrapper, props.compact ? $9a97cfaf5fcee5b8$var$styles.compactWrapperSpacing : $9a97cfaf5fcee5b8$var$styles.wrapperSpacing),
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)("svg", {
            width: "32",
            height: "32",
            viewBox: "0 0 32 32",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            ...props,
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsxs)("g", {
                    clipPath: "url(#clip0_2032_552)",
                    children: [
                        /*#__PURE__*/ (0, $gt9Am.jsx)("rect", {
                            width: "32",
                            height: "32",
                            rx: "4",
                            fill: "#DCDFE4"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M10.6666 12.6666C11.7712 12.6666 12.6666 11.7712 12.6666 10.6666C12.6666 9.56206 11.7712 8.66663 10.6666 8.66663C9.56202 8.66663 8.66658 9.56206 8.66658 10.6666C8.66658 11.7712 9.56202 12.6666 10.6666 12.6666ZM10.6666 14.6666C12.8757 14.6666 14.6666 12.8758 14.6666 10.6666C14.6666 8.45749 12.8757 6.66663 10.6666 6.66663C8.45745 6.66663 6.66658 8.45749 6.66658 10.6666C6.66658 12.8758 8.45745 14.6666 10.6666 14.6666Z",
                            fill: "#44546F"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M21.3333 12.6666C22.4378 12.6666 23.3333 11.7712 23.3333 10.6666C23.3333 9.56206 22.4378 8.66663 21.3333 8.66663C20.2287 8.66663 19.3333 9.56206 19.3333 10.6666C19.3333 11.7712 20.2287 12.6666 21.3333 12.6666ZM21.3333 14.6666C23.5424 14.6666 25.3333 12.8758 25.3333 10.6666C25.3333 8.45749 23.5424 6.66663 21.3333 6.66663C19.1241 6.66663 17.3333 8.45749 17.3333 10.6666C17.3333 12.8758 19.1241 14.6666 21.3333 14.6666Z",
                            fill: "#44546F"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            d: "M21.6666 16C24.4273 16.0004 26.6666 18.2385 26.6666 21V22.6666C26.6666 24.1394 25.4727 25.3333 23.9999 25.3333H20.135C18.0324 25.3333 16.1545 24.018 15.436 22.042L14.6843 19.9747C14.2531 18.7892 13.1264 18 11.8649 18H10.3333C8.6764 18 7.33325 19.3431 7.33325 21V22.6666C7.33325 23.0348 7.63173 23.3333 7.99992 23.3333H13.3333V25.3333H7.99992C6.52716 25.3333 5.33325 24.1394 5.33325 22.6666V21C5.33325 18.2385 7.57183 16 10.3333 16H11.8649C13.9674 16 15.8453 17.3153 16.5638 19.2913L17.3156 21.3585C17.7467 22.5441 18.8734 23.3333 20.135 23.3333H23.9999C24.3681 23.3333 24.6666 23.0348 24.6666 22.6666V21C24.6666 19.3437 23.3233 18.0004 21.6666 18H20.135V16H21.6666Z",
                            fill: "#44546F"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            d: "M20.135 16C19.5972 16 18.7183 16.1407 18.0518 16.4564L18.908 18.2639C19.064 18.19 19.288 18.1205 19.537 18.0703C19.785 18.0203 20.0045 18 20.135 18V16Z",
                            fill: "#44546F"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)("defs", {
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)("clipPath", {
                        id: "clip0_2032_552",
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)("rect", {
                            width: "32",
                            height: "32",
                            rx: "4",
                            fill: "white"
                        })
                    })
                })
            ]
        })
    });
}

});

parcelRegister("aYBsz", function(module, exports) {
$parcel$export(module.exports, "getTeamAvatarSrc", () => $70cc3a7a823af077$export$59ff7d19feb890b6);
/**
 * If a src value is given, we'll use that directly.
 * Otherwise we'll generate a static URL from the teamId.
 * If neither are provided, return undefined so that the fallback will be used.
 */ function $70cc3a7a823af077$export$59ff7d19feb890b6(src, teamId) {
    if (src) return src;
    else if (teamId) return `/gateway/api/v4/teams/${teamId}/avatar`;
    return undefined;
}

});




parcelRegister("hMpZ8", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::77421a4093efbe74a1bbe8da5d5c5bff>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cf1b13700915d1ca$var$_react = $cf1b13700915d1ca$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $cf1b13700915d1ca$var$_peopleGroup = $cf1b13700915d1ca$var$_interopRequireDefault((parcelRequire("hxN6p")));

var $cf1b13700915d1ca$var$_people = $cf1b13700915d1ca$var$_interopRequireDefault((parcelRequire("9HVF4")));
function $cf1b13700915d1ca$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for PeopleGroupIcon.
 * This component is PeopleGroupIcon, with `UNSAFE_fallbackIcon` set to "PeopleIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: representing a group or collection of people or users.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $cf1b13700915d1ca$var$PeopleGroupIcon = (props)=>/*#__PURE__*/ $cf1b13700915d1ca$var$_react.default.createElement($cf1b13700915d1ca$var$_peopleGroup.default, Object.assign({
        name: "PeopleGroupIcon",
        LEGACY_fallbackIcon: $cf1b13700915d1ca$var$_people.default
    }, props));
$cf1b13700915d1ca$var$PeopleGroupIcon.displayName = 'PeopleGroupIconMigration';
var $cf1b13700915d1ca$var$_default = module.exports.default = $cf1b13700915d1ca$var$PeopleGroupIcon;

});
parcelRegister("9HVF4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7114db95708449c8$var$_react = $7114db95708449c8$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $7114db95708449c8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $7114db95708449c8$var$PeopleIcon = (props)=>/*#__PURE__*/ $7114db95708449c8$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><circle cx="16" cy="9" r="3"/><circle cx="8" cy="6" r="3"/><path d="M11 15c0-1.105.887-2 2-2h6c1.105 0 2 .885 2 2v3.73c0 3.027-10 3.027-10 0z"/><path d="M13 12a1.997 1.997 0 0 0-2-2H5c-1.113 0-2 .897-2 2.003v3.826c0 1.921 4.054 2.518 7 1.984v-2.807A3 3 0 0 1 12.997 12z"/></g></svg>`
    }, props));
$7114db95708449c8$var$PeopleIcon.displayName = 'PeopleIcon';
var $7114db95708449c8$var$_default = module.exports.default = $7114db95708449c8$var$PeopleIcon;

});


parcelRegister("lXcOw", function(module, exports) {
$parcel$export(module.exports, "VerifiedTeamIcon", () => $c2242de582b8e66d$export$d7949f68d31e5edd);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $acRfo = parcelRequire("acRfo");

var $k71qx = parcelRequire("k71qx");

var $6dApG = parcelRequire("6dApG");
const $c2242de582b8e66d$export$d7949f68d31e5edd = ({ label: label = 'Verified Team', showTooltip: showTooltip, customTooltipContent: customTooltipContent, size: size = 'medium' })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const tooltipContent = showTooltip ? customTooltipContent || formatMessage((0, $6dApG.messages).verifiedIconDefaultTooltip) : undefined;
    return tooltipContent ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k71qx.default), {
        content: tooltipContent,
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)("span", {
            tabIndex: 0,
            role: "button",
            "data-testid": "verified-team-icon",
            children: [
                ' ',
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acRfo))), {
                    color: "var(--ds-icon-accent-blue, #357DE8)",
                    size: size,
                    label: tooltipContent,
                    spacing: "spacious"
                })
            ]
        })
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acRfo))), {
        color: "var(--ds-icon-accent-blue, #357DE8)",
        size: size,
        spacing: "spacious",
        label: label
    });
};

});
parcelRegister("acRfo", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b50a6e4dd8b62d7d7bf2cfae0d8c6979>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $76e454285004b3dd$var$_react = $76e454285004b3dd$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $76e454285004b3dd$var$_baseNew = $76e454285004b3dd$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $76e454285004b3dd$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusVerified".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for representing verified content.
Filled status icons provide higher visual contrast draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $76e454285004b3dd$var$StatusVerifiedIcon = (props)=>/*#__PURE__*/ $76e454285004b3dd$var$_react.default.createElement($76e454285004b3dd$var$_baseNew.default, Object.assign({
        name: "StatusVerifiedIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.85.444a1.713 1.713 0 0 1 2.301 0L10.3 1.486a.2.2 0 0 0 .15.055L12 1.48a1.71 1.71 0 0 1 1.762 1.479l.21 1.537a.2.2 0 0 0 .081.139l1.226.95c.696.54.87 1.52.4 2.266l-.828 1.312a.2.2 0 0 0-.027.158l.328 1.516a1.713 1.713 0 0 1-1.151 1.993l-1.477.474a.2.2 0 0 0-.123.103l-.723 1.372a1.713 1.713 0 0 1-2.162.787l-1.435-.587a.2.2 0 0 0-.161 0l-1.436.587a1.713 1.713 0 0 1-2.162-.787l-.723-1.372a.22.22 0 0 0-.124-.103L2 12.83a1.713 1.713 0 0 1-1.15-1.993l.327-1.516a.2.2 0 0 0-.027-.158L.322 7.852a1.713 1.713 0 0 1 .4-2.266l1.225-.95a.2.2 0 0 0 .081-.14l.21-1.536a1.71 1.71 0 0 1 1.763-1.48l1.55.06a.2.2 0 0 0 .15-.055zm-.1 9.384L4.826 7.519l-1.152.961 2.5 3a.75.75 0 0 0 1.152 0l5-6-1.152-.96z" clip-rule="evenodd"/>`
    }, props));
$76e454285004b3dd$var$StatusVerifiedIcon.displayName = 'StatusVerifiedIcon';
var $76e454285004b3dd$var$_default = module.exports.default = $76e454285004b3dd$var$StatusVerifiedIcon;

});

parcelRegister("6dApG", function(module, exports) {
$parcel$export(module.exports, "messages", () => $369d053bcf2cee48$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $369d053bcf2cee48$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    verifiedIconDefaultTooltip: {
        id: 'ptc-directory.team-profile-page.team-name.verified-team.icon.tooltip',
        defaultMessage: 'Managed teams are verified because they can only be changed by an admin.',
        description: 'Tooltip text for the verified team icon'
    }
});

});



parcelRegister("1dESj", function(module, exports) {
$parcel$export(module.exports, "MultiValueContainer", () => $d3c7ccc28b39ddcc$export$cf9cf2a30a59265c);
/* MultiValueContainer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $6XEne = parcelRequire("6XEne");

var $eJOHy = parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $aemwP = parcelRequire("aemwP");

var $bp6ad = parcelRequire("bp6ad");

var $bM37l = parcelRequire("bM37l");
const $d3c7ccc28b39ddcc$var$valueContainerStyles = {
    root: "_yv0e5bpd _ca0q12x7 _n3td12x7 _19bv12x7 _1reo15vq _18m91wug _1fjgglyw _c71l1osq _1suq18uv _1ke8idpf"
};
class $d3c7ccc28b39ddcc$export$cf9cf2a30a59265c extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).PureComponent {
    static getDerivedStateFromProps(nextProps, prevState) {
        return {
            valueSize: nextProps.getValue ? nextProps.getValue().length : 0,
            previousValueSize: prevState.valueSize
        };
    }
    constructor(props){
        super(props), this.timeoutId = null, this.scrollToBottom = ()=>{
            this.timeoutId = window.setTimeout(()=>{
                const { ref: { current: current } } = this.valueContainerInnerProps;
                if (current !== null) current.scrollTop = current.scrollHeight;
                this.timeoutId = null;
            });
        }, this.showPlaceholder = ()=>{
            const { selectProps: { value: value } } = this.props;
            return value && value.length > 0;
        }, this.addPlaceholder = (placeholder)=>{
            const children = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.map(this.props.children, (child)=>(0, $bp6ad.isChildInput)(child) && this.showPlaceholder() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).cloneElement(child, {
                    placeholder: placeholder
                }) : child);
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJOHy.Fragment), {
                children: children
            });
        }, this.renderChildren = ()=>{
            const { //@ts-ignore react-select unsupported props
            selectProps: { addMoreMessage: addMoreMessage, isDisabled: isDisabled } } = this.props;
            // Do not render "Add more..." message if picker is disabled
            if (isDisabled) return this.props.children;
            if (addMoreMessage === undefined) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                ...(0, $aemwP.messages).addMore,
                children: (addMore)=>{
                    let addMoreMessages = addMore;
                    if (addMore && typeof addMore === 'string') addMoreMessages = [
                        addMore
                    ];
                    const placeholder = addMoreMessages?.join('') ?? '';
                    return this.addPlaceholder(placeholder);
                }
            });
            return this.addPlaceholder(addMoreMessage);
        }, //@ts-ignore react-select unsupported props
        this.onValueContainerClick = this.props.selectProps.onValueContainerClick;
        this.state = {
            valueSize: 0,
            previousValueSize: 0
        };
        this.valueContainerInnerProps = {
            ref: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createRef()
        };
    }
    componentDidUpdate() {
        const { previousValueSize: previousValueSize, valueSize: valueSize } = this.state;
        //@ts-ignore react-select unsupported props
        const { isFocused: isFocused } = this.props.selectProps;
        if (valueSize > previousValueSize && isFocused) {
            if (this.timeoutId) {
                window.clearTimeout(this.timeoutId);
                this.timeoutId = null;
            }
            this.scrollToBottom();
        }
    }
    componentWillUnmount() {
        if (this.timeoutId) window.clearTimeout(this.timeoutId);
    }
    render() {
        const { children: children, innerProps: innerProps, ...valueContainerProps } = this.props;
        const props = {
            ...valueContainerProps,
            innerProps: this.valueContainerInnerProps
        };
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bM37l.default), {
            isEnabled: this.onValueContainerClick,
            onMouseDown: this.onValueContainerClick,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6XEne.components).ValueContainer, {
                ...props,
                xcss: $d3c7ccc28b39ddcc$var$valueContainerStyles.root,
                children: this.renderChildren()
            })
        });
    }
}

});
parcelRegister("bM37l", function(module, exports) {
$parcel$export(module.exports, "default", () => $892064a436200311$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");
function $892064a436200311$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
/**
 * Conditional wrapper for the ValueContainer in Select. Provides a workaround
 * for issues using react-select on react-beautiful-dnd Draggable elements.
 * @returns
 */ var $892064a436200311$var$_ref = {
    name: "1ff36h2",
    styles: "flex-grow:1"
};
const $892064a436200311$var$ValueContainerWrapper = ({ children: children, isEnabled: isEnabled, onMouseDown: onMouseDown })=>{
    return isEnabled ? // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlassian/a11y/no-static-element-interactions -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: $892064a436200311$var$_ref,
        onMouseDown: onMouseDown
    }, children) : children;
};
var $892064a436200311$export$2e2bcd8739ae039 = $892064a436200311$var$ValueContainerWrapper;

});


parcelRegister("bOZ4r", function(module, exports) {
$parcel$export(module.exports, "Option", () => $07ff0c926ef0e179$export$36d18380658d5d20);

var $gt9Am = parcelRequire("gt9Am");

var $8IeH1 = parcelRequire("8IeH1");

var $6XEne = parcelRequire("6XEne");

var $k71qx = parcelRequire("k71qx");

var $eJOHy = parcelRequire("eJOHy");

var $b5om0 = parcelRequire("b5om0");

var $9efgr = parcelRequire("9efgr");

var $k0Plf = parcelRequire("k0Plf");

var $2tKwH = parcelRequire("2tKwH");

var $4A9Tu = parcelRequire("4A9Tu");

var $5wrPY = parcelRequire("5wrPY");

var $bp6ad = parcelRequire("bp6ad");

var $2lvD5 = parcelRequire("2lvD5");
const $07ff0c926ef0e179$var$defaultOption = ({ data: { data: data }, isSelected: isSelected, status: status })=>// @ts-expect-error - <UserOption> expects `data` to be of User interface, but data is OptionData interface by default. Check if the `user` props in UserOption should also accept OptionData or refactor this file to accept generics
    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $b5om0.UserOption), {
        user: data,
        status: status,
        isSelected: isSelected
    });
const $07ff0c926ef0e179$var$dataOption = ({ data: { data: data }, isSelected: isSelected, status: status, selectProps: selectProps })=>{
    if ((0, $bp6ad.isExternalUser)(data)) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9efgr.default), {
        user: data,
        status: status,
        isSelected: isSelected
    });
    if ((0, $bp6ad.isUser)(data)) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $b5om0.UserOption), {
        user: data,
        status: status,
        isSelected: isSelected
    });
    if ((0, $bp6ad.isEmail)(data)) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4A9Tu.default), {
        email: data,
        emailValidity: (0, $2lvD5.isValidEmail)(data.id),
        isSelected: isSelected,
        label: selectProps.emailLabel
    });
    if ((0, $bp6ad.isTeam)(data)) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k0Plf.default), {
        team: data,
        isSelected: isSelected
    });
    if ((0, $bp6ad.isGroup)(data)) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2tKwH.default), {
        group: data,
        isSelected: isSelected
    });
    if ((0, $bp6ad.isCustom)(data)) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5wrPY.default), {
        data: data,
        isSelected: isSelected
    });
    return null;
};
const $07ff0c926ef0e179$var$dataOptionWithTooltip = (props)=>{
    if (props.data?.data?.tooltip) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k71qx.default), {
        content: props.data?.data?.tooltip,
        children: (tooltipProps)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                ...tooltipProps,
                children: $07ff0c926ef0e179$var$dataOption(props)
            })
    });
    return $07ff0c926ef0e179$var$dataOption(props);
};
const $07ff0c926ef0e179$export$36d18380658d5d20 = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $6XEne.components).Option, {
        ...props,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Suspense, {
            fallback: $07ff0c926ef0e179$var$defaultOption(props),
            children: $07ff0c926ef0e179$var$dataOptionWithTooltip(props)
        })
    });

});
parcelRegister("b5om0", function(module, exports) {
$parcel$export(module.exports, "UserOption", () => $0453b1bfd2244edc$export$8e59f78010871662);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $j8kj1 = parcelRequire("j8kj1");


var $1NIU8 = parcelRequire("1NIU8");

var $eJOHy = parcelRequire("eJOHy");

var $6pxNU = parcelRequire("6pxNU");

var $55xVv = parcelRequire("55xVv");

var $k7nMY = parcelRequire("k7nMY");

var $bp6ad = parcelRequire("bp6ad");

var $eGOwo = parcelRequire("eGOwo");
const $0453b1bfd2244edc$var$styles = (color)=>/*#__PURE__*/ (0, $1NIU8.css)({
        display: 'inline',
        verticalAlign: 'top',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        color: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        color
    });
class $0453b1bfd2244edc$export$8e59f78010871662 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).PureComponent {
    render() {
        return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $6pxNU.AvatarItemOption), {
            avatar: this.renderAvatar(),
            lozenge: this.getLozengeProps(),
            isDisabled: this.props.user.isDisabled,
            primaryText: this.getPrimaryText(),
            secondaryText: this.renderSecondaryText()
        });
    }
    constructor(...args){
        super(...args), this.getPrimaryText = ()=>{
            const { user: { name: name, publicName: publicName, highlight: highlight } } = this.props;
            const result = [
                /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
                    key: "name",
                    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                    css: (0, $6pxNU.textWrapper)(this.props.isSelected ? `var(--ds-text-selected, ${0, $7bb4c1736002a04a$export$b3de0ae08da2ce64})` : `var(--ds-text, ${0, $7bb4c1736002a04a$export$7d61b15e0da132af})`)
                }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $55xVv.HighlightText), {
                    highlights: highlight && highlight.name
                }, name))
            ];
            if ((0, $bp6ad.hasValue)(publicName) && name.trim() !== publicName.trim()) {
                const color = this.props.isSelected ? `var(--ds-text-selected, ${0, $7bb4c1736002a04a$export$b3de0ae08da2ce64})` : `var(--ds-text-subtlest, ${0, $7bb4c1736002a04a$export$f563ee71e9ee74cd})`;
                result.push(/*#__PURE__*/ (0, $1NIU8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, {
                    key: "publicName"
                }, ' ', /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
                    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                    css: (0, $eGOwo.fg)('platform_user_picker_firefox_tab_fix') ? $0453b1bfd2244edc$var$styles(color) : (0, $6pxNU.textWrapper)(color)
                }, "(", /*#__PURE__*/ (0, $1NIU8.jsx)((0, $55xVv.HighlightText), {
                    highlights: highlight && highlight.publicName
                }, publicName), ")")));
            }
            return result;
        }, this.renderSecondaryText = ()=>this.props.user.byline ? /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
                // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                css: (0, $6pxNU.textWrapper)(this.props.isSelected ? `var(--ds-text-selected, ${0, $7bb4c1736002a04a$export$b3de0ae08da2ce64})` : `var(--ds-text-subtlest, ${0, $7bb4c1736002a04a$export$f563ee71e9ee74cd})`)
            }, this.props.user.byline) : undefined, this.renderAvatar = ()=>{
            const { user: { avatarUrl: avatarUrl, appType: appType }, status: status } = this.props;
            return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $k7nMY.SizeableAvatar), {
                appearance: (0, $eGOwo.fg)('platform-component-visual-refresh') ? 'medium' : 'big',
                src: avatarUrl,
                presence: status,
                avatarAppearanceShape: (0, $eGOwo.fg)('jira_ai_agent_avatar_user_picker_user_option') ? (0, $j8kj1.getAppearanceForAppType)(appType) : undefined
            });
        }, this.getLozengeProps = ()=>typeof this.props.user.lozenge === 'string' ? {
                text: this.props.user.lozenge
            } : this.props.user.lozenge;
    }
}

});
parcelRegister("6pxNU", function(module, exports) {
$parcel$export(module.exports, "textWrapper", () => $8382733eea54494c$export$aa6223da92b253dd);
$parcel$export(module.exports, "AvatarItemOption", () => $8382733eea54494c$export$164a9d9b3b86dd0c);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $jdqdp = parcelRequire("jdqdp");

var $bp6ad = parcelRequire("bp6ad");

var $eGOwo = parcelRequire("eGOwo");
function $8382733eea54494c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

const $8382733eea54494c$var$AsyncTooltip = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).lazy(()=>(parcelRequire("kMzLg")).then((module)=>{
        return {
            default: module.default
        };
    }));
const $8382733eea54494c$var$wrapper = (isDisabled)=>{
    if ((0, $eGOwo.fg)('platform_user_picker_firefox_tab_fix')) return /*#__PURE__*/ (0, $1NIU8.css)({
        alignItems: 'center',
        boxSizing: 'border-box',
        display: 'flex',
        outline: 'none',
        margin: 0,
        width: '100%',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        cursor: isDisabled ? 'not-allowed' : 'pointer',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        opacity: isDisabled ? "var(--ds-opacity-disabled, 0.4)" : undefined
    });
    return /*#__PURE__*/ (0, $1NIU8.css)({
        alignItems: 'center',
        boxSizing: 'border-box',
        display: 'flex',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 1,
        outline: 'none',
        margin: 0,
        width: '100%',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        cursor: isDisabled ? 'not-allowed' : 'pointer',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        opacity: isDisabled ? "var(--ds-opacity-disabled, 0.4)" : undefined
    });
};
const $8382733eea54494c$var$optionWrapper = {
    name: "13552d7",
    styles: "max-width:100%;min-width:0;line-height:1.4;padding-left:var(--ds-space-100, 8px)"
};
const $8382733eea54494c$var$optionWrapperFix = {
    name: "18gxn58",
    styles: "display:inline-block;overflow:hidden;min-width:0;max-width:100%;padding-left:var(--ds-space-100, 8px)"
};
const $8382733eea54494c$var$getTextStyle = (isSecondary)=>{
    const secondaryCssArgs = isSecondary ? {
        font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
    } : {};
    if ((0, $eGOwo.fg)('platform_user_picker_firefox_tab_fix')) return /*#__PURE__*/ (0, $1NIU8.css)({
        margin: 0,
        maxWidth: '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        ...secondaryCssArgs
    });
    return /*#__PURE__*/ (0, $1NIU8.css)({
        margin: 0,
        overflowX: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        ...secondaryCssArgs
    });
};
const $8382733eea54494c$var$additionalInfo = {
    name: "1hvgowa",
    styles: "float:right;margin-left:var(--ds-space-100, 8px)"
};
const $8382733eea54494c$export$aa6223da92b253dd = (color)=>{
    if ((0, $eGOwo.fg)('platform_user_picker_firefox_tab_fix')) return /*#__PURE__*/ (0, $1NIU8.css)({
        display: 'inline-block',
        verticalAlign: 'bottom',
        maxWidth: '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        color: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color
    });
    return /*#__PURE__*/ (0, $1NIU8.css)({
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        display: 'inline',
        color: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color
    });
};
const $8382733eea54494c$export$164a9d9b3b86dd0c = ({ avatar: avatar, isDisabled: isDisabled, lozenge: lozenge, primaryText: primaryText, secondaryText: secondaryText })=>{
    const renderLozenge = ()=>{
        if ((0, $bp6ad.isLozengeText)(lozenge)) {
            if (lozenge?.tooltip) // Note that entire Lozenge must be wrapped in the Tooltip (rather than just the
            // Lozenge text) or tooltip won't work
            return /*#__PURE__*/ (0, $1NIU8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Suspense, {
                fallback: /*#__PURE__*/ (0, $1NIU8.jsx)((0, $jdqdp.default), lozenge, lozenge.text)
            }, /*#__PURE__*/ (0, $1NIU8.jsx)($8382733eea54494c$var$AsyncTooltip, {
                content: lozenge.tooltip
            }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $jdqdp.default), lozenge, lozenge.text)));
            return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $jdqdp.default), lozenge, lozenge.text);
        }
        return lozenge;
    };
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
        css: $8382733eea54494c$var$wrapper(isDisabled)
    }, avatar, /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: (0, $eGOwo.fg)('platform_user_picker_firefox_tab_fix') ? $8382733eea54494c$var$optionWrapperFix : $8382733eea54494c$var$optionWrapper
    }, /*#__PURE__*/ (0, $1NIU8.jsx)("div", null, /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: $8382733eea54494c$var$getTextStyle()
    }, primaryText), secondaryText && /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: $8382733eea54494c$var$getTextStyle(true)
    }, secondaryText))), lozenge && /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: $8382733eea54494c$var$additionalInfo
    }, renderLozenge())));
};

});

parcelRegister("55xVv", function(module, exports) {
$parcel$export(module.exports, "HighlightText", () => $9cb1b36ba7348cca$export$bb02e7bc6e1a7119);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");
class $9cb1b36ba7348cca$export$bb02e7bc6e1a7119 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).PureComponent {
    render() {
        const { children: children, highlights: highlights } = this.props;
        const parts = [];
        let lastIndex = 0;
        if (highlights) highlights.sort((a, b)=>a.start - b.start).reduce((highlights, highlight)=>{
            const lastHighlight = highlights[highlights.length - 1];
            if (!lastHighlight || highlight.start > lastHighlight.end + 1) return highlights.concat(highlight);
            if (highlight.end > lastHighlight.end) lastHighlight.end = highlight.end;
            return highlights;
        }, []).forEach((highlight)=>{
            const { start: start, end: end } = highlight;
            if (start >= end) return;
            if (start > lastIndex) parts.push({
                value: children.substring(lastIndex, start),
                matches: false
            });
            parts.push({
                value: children.substring(start, end + 1),
                matches: true
            });
            lastIndex = end + 1;
        });
        if (lastIndex < children.length) parts.push({
            value: children.substring(lastIndex, children.length),
            matches: false
        });
        return parts.map((part, index)=>{
            if (part.matches) return /*#__PURE__*/ (0, $gt9Am.jsx)("b", {
                children: part.value
            }, index);
            return part.value;
        });
    }
}

});


parcelRegister("9efgr", function(module, exports) {
$parcel$export(module.exports, "default", () => $980dbe247ee3b37d$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

const $980dbe247ee3b37d$var$AsyncExternalUserOption = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).lazy(()=>(parcelRequire("zvTks")).then((module)=>{
        return {
            default: module.ExternalUserOption
        };
    }));
var $980dbe247ee3b37d$export$2e2bcd8739ae039 = $980dbe247ee3b37d$var$AsyncExternalUserOption;

});
parcelRegister("zvTks", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("cm3wZ")
]).then(()=>parcelRequire('4cxzb'));

});


parcelRegister("k0Plf", function(module, exports) {
$parcel$export(module.exports, "default", () => $95d6477fc9cb5ac2$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

const $95d6477fc9cb5ac2$var$AsyncTeamOption = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).lazy(()=>(parcelRequire("ampxd")).then((module)=>{
        return {
            default: module.TeamOption
        };
    }));
var $95d6477fc9cb5ac2$export$2e2bcd8739ae039 = $95d6477fc9cb5ac2$var$AsyncTeamOption;

});
parcelRegister("ampxd", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("dVG7s").then(()=>parcelRequire('1S96L'));

});


parcelRegister("2tKwH", function(module, exports) {
$parcel$export(module.exports, "default", () => $0aaf40607abeee08$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

const $0aaf40607abeee08$var$AsyncGroupOption = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).lazy(()=>(parcelRequire("8Gji4")).then((module)=>{
        return {
            default: module.GroupOption
        };
    }));
var $0aaf40607abeee08$export$2e2bcd8739ae039 = $0aaf40607abeee08$var$AsyncGroupOption;

});
parcelRegister("8Gji4", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("bwgIM").then(()=>parcelRequire('kSMc2'));

});


parcelRegister("4A9Tu", function(module, exports) {
$parcel$export(module.exports, "default", () => $eed72ec3262bf21d$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

const $eed72ec3262bf21d$var$AsyncEmailOption = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).lazy(()=>(parcelRequire("dyBmT")).then((module)=>{
        return {
            default: module.EmailOption
        };
    }));
var $eed72ec3262bf21d$export$2e2bcd8739ae039 = $eed72ec3262bf21d$var$AsyncEmailOption;

});
parcelRegister("dyBmT", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("8aLon").then(()=>parcelRequire('hpXeN'));

});


parcelRegister("5wrPY", function(module, exports) {
$parcel$export(module.exports, "default", () => $6711e764ffd94797$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

const $6711e764ffd94797$var$AsyncCustomOption = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).lazy(()=>(parcelRequire("riO7J")).then((module)=>{
        return {
            default: module.CustomOption
        };
    }));
var $6711e764ffd94797$export$2e2bcd8739ae039 = $6711e764ffd94797$var$AsyncCustomOption;

});
parcelRegister("riO7J", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("4SKbF").then(()=>parcelRequire('hVJCF'));

});


parcelRegister("2lvD5", function(module, exports) {
$parcel$export(module.exports, "isValidEmail", () => $f55e7fe2bf1c50c8$export$371e338370561054);
const $f55e7fe2bf1c50c8$var$validRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/i;
const $f55e7fe2bf1c50c8$var$potentialRegex = /^[^\s@]+@[^\s@]*$/i;
const $f55e7fe2bf1c50c8$export$371e338370561054 = (inputText)=>{
    if (inputText.match($f55e7fe2bf1c50c8$var$validRegex)) return 'VALID';
    if (inputText.match($f55e7fe2bf1c50c8$var$potentialRegex)) return 'POTENTIAL';
    return 'INVALID';
};

});


parcelRegister("dY5oB", function(module, exports) {
$parcel$export(module.exports, "SingleValue", () => $dd81b53dbb8a3847$export$1949dac661ba6e3a);
/* SingleValue.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $6XEne = parcelRequire("6XEne");

var $k7nMY = parcelRequire("k7nMY");

var $bp6ad = parcelRequire("bp6ad");

var $lXcOw = parcelRequire("lXcOw");

var $8IeH1 = parcelRequire("8IeH1");
var $2sLVw = parcelRequire("2sLVw");
var $6djmC = parcelRequire("6djmC");
const $dd81b53dbb8a3847$var$styles = {
    avatarItem: "_1reo15vq _18m915vq _4cvr1h6o _1ul953f4",
    avatarItemTextWrapper: "_16jlkb7n _1o9zkb7n _i0dl1osq _1ul9idpf _p12f1osq _bozgu2gc _vwz419ii",
    avatarItemText: "_syazi7uo _1reo15vq _1bto1l2s _o5721q9c"
};
const $dd81b53dbb8a3847$var$ElementAfter = (props)=>{
    const { data: { data: data } } = props;
    if ((0, $bp6ad.isTeam)(data) && data.verified) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lXcOw.VerifiedTeamIcon), {});
    return null;
};
const $dd81b53dbb8a3847$export$1949dac661ba6e3a = (props)=>{
    const { data: { label: label, data: data }, //@ts-ignore react-select unsupported props
    selectProps: { appearance: appearance, isFocused: isFocused } } = props;
    return !isFocused ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6XEne.components).SingleValue, {
        ...props,
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $2sLVw.default), {
            xcss: $dd81b53dbb8a3847$var$styles.avatarItem,
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k7nMY.SizeableAvatar), {
                    src: (0, $bp6ad.getAvatarUrl)(data),
                    appearance: appearance,
                    type: (0, $bp6ad.isTeam)(data) ? 'team' : 'person'
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                    xcss: $dd81b53dbb8a3847$var$styles.avatarItem,
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                        className: (0, $hcewu.default)([
                            $dd81b53dbb8a3847$var$styles.avatarItemTextWrapper
                        ]),
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                            xcss: $dd81b53dbb8a3847$var$styles.avatarItemText,
                            children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $6djmC.default), {
                                alignBlock: "center",
                                children: [
                                    label,
                                    /*#__PURE__*/ (0, $gt9Am.jsx)($dd81b53dbb8a3847$var$ElementAfter, {
                                        ...props
                                    })
                                ]
                            })
                        })
                    })
                })
            ]
        })
    }) : null;
};

});

parcelRegister("3uumP", function(module, exports) {
$parcel$export(module.exports, "Input", () => $52276fbb29701503$export$f5b8910cec6cf069);
/* Input.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $6XEne = parcelRequire("6XEne");
const $52276fbb29701503$var$inputStyles = {
    root: "_5ce61rpy _1ir3kb7n _h5gq1rpy"
};
class $52276fbb29701503$export$f5b8910cec6cf069 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    /**
   * Overrides the default behaviour of react-select lib
   *
   * The getter is a workaround for original behaviour of the react-select lib.
   * Placeholder and Input are linked not via label, aria-label or aria-labeledby, but through aria-describedby.
   * Basically in the getter we reassign Placeholder ID from aria-describedby to aria-labelledby
   * {@link https://github.com/JedWatson/react-select/issues/5651#issue-1731353197 GitHub}
   */ get ariaLabelledBy() {
        return this.props['aria-labelledby'] ?? this.props['aria-describedby'];
    }
    get ariaDescribedBy() {
        return this.props.selectProps?.['aria-describedby'] ?? this.props['aria-describedby'];
    }
    render() {
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6XEne.components).Input, {
            ...this.props,
            "aria-labelledby": this.ariaLabelledBy,
            "aria-describedby": this.ariaDescribedBy,
            innerRef: this.props.innerRef,
            onKeyPress: this.handleKeyPress,
            xcss: $52276fbb29701503$var$inputStyles.root
        });
    }
    constructor(...args){
        super(...args), // onKeyPress is used instead as
        // react-select is using onKeyDown for capturing keyboard input
        this.handleKeyPress = (e)=>{
            if (e.key === 'Enter') e.preventDefault();
            //@ts-ignore react-select unsupported props
            if (this.props.selectProps?.disableInput) e.preventDefault();
        };
    }
}

});

parcelRegister("bVfPa", function(module, exports) {
$parcel$export(module.exports, "SingleValueContainer", () => $5b6f667c12b37e80$export$afa5f855316c6a48);
/* SingleValueContainer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $6XEne = parcelRequire("6XEne");

var $k7nMY = parcelRequire("k7nMY");

var $bM37l = parcelRequire("bM37l");
const $5b6f667c12b37e80$var$valueContainerStyles = {
    root: "_yv0e5bpd _ca0q12x7 _n3td12x7 _19bvze3t _1reo15vq _18m91wug _1fjgglyw _c71l1osq _1suq18uv _1ke8idpf"
};
const $5b6f667c12b37e80$var$placeholderIconContainer = null;
const $5b6f667c12b37e80$var$wrapperStyle = null;
const $5b6f667c12b37e80$var$showUserAvatar = (inputValue, value)=>value && value.data && inputValue === value.label;
class $5b6f667c12b37e80$export$afa5f855316c6a48 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    render() {
        const { children: children, ...valueContainerProps } = this.props;
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bM37l.default), {
            isEnabled: this.onValueContainerClick,
            onMouseDown: this.onValueContainerClick,
            children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $6XEne.components).ValueContainer, {
                ...valueContainerProps,
                xcss: $5b6f667c12b37e80$var$valueContainerStyles.root,
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                        className: (0, $hcewu.default)([
                            "_nd5l1kqh _19bv12x7 _vwz4idpf"
                        ]),
                        children: this.renderAvatar()
                    }),
                    children
                ]
            })
        });
    }
    constructor(...args){
        super(...args), this.renderAvatar = ()=>{
            const { hasValue: hasValue, //@ts-ignore react-select unsupported props
            selectProps: { appearance: appearance, isFocused: isFocused, inputValue: inputValue, value: value, placeholderAvatar: placeholderAvatar } } = this.props;
            if (isFocused || !hasValue) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k7nMY.SizeableAvatar), {
                appearance: appearance,
                type: placeholderAvatar,
                src: $5b6f667c12b37e80$var$showUserAvatar(inputValue, value) ? value.data.avatarUrl : undefined
            });
            return null;
        }, //@ts-ignore react-select unsupported props
        this.onValueContainerClick = this.props.selectProps.onValueContainerClick, this.Wrapper = ({ children: children })=>{
            return this.onValueContainerClick ? /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                onMouseDown: this.onValueContainerClick,
                className: (0, $hcewu.default)([
                    "_16jlkb7n"
                ]),
                children: children
            }) : children;
        };
    }
}

});

parcelRegister("6FUJ9", function(module, exports) {
$parcel$export(module.exports, "PopupInput", () => $cd9d7ed309b03307$export$d8edbfd510a7db82);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $3uumP = parcelRequire("3uumP");
class $cd9d7ed309b03307$export$d8edbfd510a7db82 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    componentDidMount() {
        if (this.ref) // @ts-ignore
        this.ref.select();
    }
    render() {
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3uumP.Input), {
            ...this.props,
            innerRef: this.handleInnerRef
        });
    }
    constructor(...args){
        super(...args), this.ref = null, this.handleInnerRef = (ref)=>{
            this.ref = ref;
            if (this.props.innerRef) this.props.innerRef(ref);
        };
    }
}

});

parcelRegister("gIhcD", function(module, exports) {
$parcel$export(module.exports, "PopupControl", () => $d6cc2469d7e5c609$export$a0cb1b4352357fcc);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");


var $716IA = parcelRequire("716IA");
const $d6cc2469d7e5c609$var$controlWrapper = /*#__PURE__*/ (0, $1NIU8.css)({
    display: 'flex',
    flexDirection: 'column',
    padding: `0px ${"var(--ds-space-100, 8px)"} ${"var(--ds-space-100, 8px)"}`
});
const $d6cc2469d7e5c609$var$labelStyle = /*#__PURE__*/ (0, $1NIU8.css)({
    color: `var(--ds-text-subtlest, ${(0, $7bb4c1736002a04a$export$f563ee71e9ee74cd)})`,
    font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-semibold, 600)",
    paddingBottom: "var(--ds-space-050, 4px)",
    paddingLeft: "var(--ds-space-0, 0px)",
    paddingRight: "var(--ds-space-0, 0px)",
    paddingTop: "var(--ds-space-250, 20px)"
});
class $d6cc2469d7e5c609$export$a0cb1b4352357fcc extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).PureComponent {
    render() {
        const { //@ts-ignore react-select unsupported props
        selectProps: { popupTitle: popupTitle } } = this.props;
        return /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
            css: $d6cc2469d7e5c609$var$controlWrapper
        }, /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
            css: $d6cc2469d7e5c609$var$labelStyle
        }, popupTitle), /*#__PURE__*/ (0, $1NIU8.jsx)((0, $716IA.default), this.props));
    }
}

});
parcelRegister("716IA", function(module, exports) {
$parcel$export(module.exports, "default", () => $3518ae22f57ffbfc$export$2e2bcd8739ae039);
/* Control.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $6XEne = parcelRequire("6XEne");

var $k0ahr = parcelRequire("k0ahr");
const $3518ae22f57ffbfc$var$controlStyles = {
    invalid: "_1h6d1bqt _4cvx1bqt",
    focused: "_1h6d1v1w _bfhk1j9a _4cvx1v1w _irr31j9a",
    disabled: "_irr3by5v",
    subtle: "_1h6d3acm _bfhk18uv _4cvx3acm _irr31gly",
    root: "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1h6drsbi _bfhk1j9a _p12f1osq _14regrf3 _4cvxrsbi _irr3l4ek _1a98zg3v",
    compact: "_1tke1wug"
};
const $3518ae22f57ffbfc$var$Control = (props)=>{
    const isCompact = props.appearance === 'compact';
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6XEne.components).Control, {
        ...props,
        xcss: (0, $k0ahr.cx)($3518ae22f57ffbfc$var$controlStyles.root, isCompact && $3518ae22f57ffbfc$var$controlStyles.compact, (props.selectProps.subtle || props.selectProps.noBorder) && $3518ae22f57ffbfc$var$controlStyles.subtle, props.isFocused && $3518ae22f57ffbfc$var$controlStyles.focused, props.isInvalid && $3518ae22f57ffbfc$var$controlStyles.invalid, props.isDisabled && $3518ae22f57ffbfc$var$controlStyles.disabled)
    });
};
var $3518ae22f57ffbfc$export$2e2bcd8739ae039 = $3518ae22f57ffbfc$var$Control;

});


parcelRegister("75q59", function(module, exports) {
$parcel$export(module.exports, "Menu", () => $71e9f791cbbda468$export$d9b273488cd8ce6f);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $6XEne = parcelRequire("6XEne");

var $1NIU8 = parcelRequire("1NIU8");
const $71e9f791cbbda468$var$getFooterStyle = ()=>{
    return /*#__PURE__*/ (0, $1NIU8.css)({
        padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-200, 16px)"}`
    });
};
class $71e9f791cbbda468$export$d9b273488cd8ce6f extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    render() {
        return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $6XEne.components).Menu, this.props, this.props.selectProps.header, this.props.children, this.props.selectProps.footer && // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
            css: $71e9f791cbbda468$var$getFooterStyle()
        }, this.props.selectProps.footer));
    }
}

});


parcelRegister("lLpLo", function(module, exports) {
$parcel$export(module.exports, "getCreatableProps", () => $03d6b2df141c86e7$export$36f97d8afa97203d);

var $LFmXM = parcelRequire("LFmXM");


var $2lvD5 = parcelRequire("2lvD5");

var $bp6ad = parcelRequire("bp6ad");
const $03d6b2df141c86e7$var$validOption = [
    'VALID',
    'POTENTIAL'
];
const $03d6b2df141c86e7$var$isValidNewOption = (isValidEmail = (0, $2lvD5.isValidEmail))=>(inputValue)=>inputValue && $03d6b2df141c86e7$var$validOption.includes(isValidEmail(inputValue));
const $03d6b2df141c86e7$var$getNewOptionData = (inputValue)=>({
        label: inputValue,
        value: inputValue,
        data: {
            id: inputValue,
            name: inputValue,
            type: (0, $f4e041c5b2b1b75c$export$6662b3461398ef8c)
        }
    });
const $03d6b2df141c86e7$var$formatCreateLabel = (inputText)=>{
    if (inputText) return inputText.trim();
    return '';
};
const $03d6b2df141c86e7$var$isOptionDisabled = (isValidEmail = (0, $2lvD5.isValidEmail))=>(option)=>{
        if ((0, $bp6ad.isEmail)(option.data)) return isValidEmail(option.data.id) !== 'VALID';
        return !!option.isDisabled;
    };
function $03d6b2df141c86e7$var$creatableProps(isValidEmail) {
    return {
        allowCreateWhileLoading: true,
        createOptionPosition: 'first',
        isValidNewOption: $03d6b2df141c86e7$var$isValidNewOption(isValidEmail),
        getNewOptionData: $03d6b2df141c86e7$var$getNewOptionData,
        formatCreateLabel: $03d6b2df141c86e7$var$formatCreateLabel,
        isOptionDisabled: $03d6b2df141c86e7$var$isOptionDisabled(isValidEmail)
    };
}
const $03d6b2df141c86e7$export$36f97d8afa97203d = (0, $LFmXM.default)($03d6b2df141c86e7$var$creatableProps);

});

parcelRegister("f9tKr", function(module, exports) {
$parcel$export(module.exports, "getCreatableSuggestedEmailProps", () => $dfbcb54d733de433$export$34b9dd2dd6a225e5);

var $LFmXM = parcelRequire("LFmXM");


var $2lvD5 = parcelRequire("2lvD5");

var $bp6ad = parcelRequire("bp6ad");
const $dfbcb54d733de433$var$validOption = [
    'VALID',
    'POTENTIAL'
];
const $dfbcb54d733de433$var$isValidNewOption = (inputValue)=>inputValue && inputValue.length > 0;
// Generates suggested option data based on user input and validity of the input (if it is an email or not);
const $dfbcb54d733de433$var$getNewOptionData = (isValidEmail = (0, $2lvD5.isValidEmail), emailDomain)=>(inputValue)=>{
        if (!inputValue) return null;
        const isEmail = inputValue && $dfbcb54d733de433$var$validOption.includes(isValidEmail(inputValue));
        const value = isEmail ? inputValue : `${inputValue.replace(/\s+/g, '.').toLocaleLowerCase()}@${emailDomain}`;
        return {
            label: value,
            value: value,
            data: {
                id: value,
                name: value,
                type: (0, $f4e041c5b2b1b75c$export$6662b3461398ef8c),
                suggestion: true
            }
        };
    };
const $dfbcb54d733de433$var$formatCreateLabel = (inputText)=>{
    if (inputText) return inputText.trim();
    return '';
};
// Option will not be selectable until the email value is valid and can actually be invited
const $dfbcb54d733de433$var$isOptionDisabled = (isValidEmail = (0, $2lvD5.isValidEmail))=>(option)=>{
        if ((0, $bp6ad.isEmail)(option.data)) return isValidEmail(option.data.id) !== 'VALID';
        return !!option.isDisabled;
    };
const $dfbcb54d733de433$export$34b9dd2dd6a225e5 = (0, $LFmXM.default)((emailDomain, isValidEmail)=>({
        allowCreateWhileLoading: true,
        createOptionPosition: 'last',
        isValidNewOption: $dfbcb54d733de433$var$isValidNewOption,
        getNewOptionData: $dfbcb54d733de433$var$getNewOptionData(isValidEmail, emailDomain),
        formatCreateLabel: $dfbcb54d733de433$var$formatCreateLabel,
        isOptionDisabled: $dfbcb54d733de433$var$isOptionDisabled(isValidEmail)
    }));

});

parcelRegister("61zL7", function(module, exports) {
$parcel$export(module.exports, "default", () => $5315f7e1f1805a55$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $4nehu = parcelRequire("4nehu");
var $lRq8t = parcelRequire("lRq8t");

var $3VTWQ = parcelRequire("3VTWQ");
const $5315f7e1f1805a55$var$EMPTY = {};
const $5315f7e1f1805a55$var$useI18n = (locale)=>{
    const [messages, setMessages] = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useState($5315f7e1f1805a55$var$EMPTY);
    (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useEffect(()=>{
        let aborted = false;
        setMessages($5315f7e1f1805a55$var$EMPTY);
        (0, $3VTWQ.getMessagesForLocale)(locale).then((messages)=>{
            if (!aborted) setMessages(messages);
        }).catch((error)=>{
            // eslint-disable-next-line no-console
            console.error(error);
        });
        return ()=>{
            aborted = true;
        };
    }, [
        locale
    ]);
    return messages;
};
const $5315f7e1f1805a55$var$MessagesIntlProvider = (props)=>{
    const intl = (0, $lRq8t.default)();
    const { children: children } = props;
    const messages = $5315f7e1f1805a55$var$useI18n(intl.locale);
    const mergedMessages = (0, $eJOHy.useMemo)(()=>{
        return {
            ...intl.messages,
            ...messages
        };
    }, [
        intl.messages,
        messages
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4nehu.default), {
        locale: intl.locale,
        messages: mergedMessages,
        children: children
    });
};
var $5315f7e1f1805a55$export$2e2bcd8739ae039 = $5315f7e1f1805a55$var$MessagesIntlProvider;

});
parcelRegister("3VTWQ", function(module, exports) {
$parcel$export(module.exports, "getMessagesForLocale", () => $10ce0748906381fc$export$d0a3169680473b6c);
/**
 * Tries to get the most specific messages bundle for a given locale.
 *
 * Strategy:
 * 1. Try to find messages with the exact string (i.e. 'fr_FR')
 * 2. If that doesn't work, try to find messages for the country locale (i.e. 'fr')
 * 3. If that doesn't work, return english messages as a fallback.
 *
 * @param locale string specifying the locale like 'en_GB', or 'fr'.
 */ 






























const $10ce0748906381fc$export$d0a3169680473b6c = async (locale)=>{
    switch(locale){
        case 'cs':
            return (parcelRequire("ekiI8")).then((mod)=>mod.default);
        case 'da':
            return (parcelRequire("fgm4J")).then((mod)=>mod.default);
        case 'de':
            return (parcelRequire("drBO7")).then((mod)=>mod.default);
        case 'en':
            return (parcelRequire("33qfR")).then((mod)=>mod.default);
        case 'en_GB':
            return (parcelRequire("b8fOo")).then((mod)=>mod.default);
        case 'en_ZZ':
            return (parcelRequire("bWIrP")).then((mod)=>mod.default);
        case 'es':
            return (parcelRequire("3sK4f")).then((mod)=>mod.default);
        case 'et':
            return (parcelRequire("0YUKd")).then((mod)=>mod.default);
        case 'fi':
            return (parcelRequire("cQwBF")).then((mod)=>mod.default);
        case 'fr':
            return (parcelRequire("lAFFG")).then((mod)=>mod.default);
        case 'hu':
            return (parcelRequire("gk7oQ")).then((mod)=>mod.default);
        case 'is':
            return (parcelRequire("i90HO")).then((mod)=>mod.default);
        case 'it':
            return (parcelRequire("c2jzR")).then((mod)=>mod.default);
        case 'ja':
            return (parcelRequire("5EpIH")).then((mod)=>mod.default);
        case 'ko':
            return (parcelRequire("2AW9v")).then((mod)=>mod.default);
        case 'nb':
            return (parcelRequire("3NUXI")).then((mod)=>mod.default);
        case 'nl':
            return (parcelRequire("fU2cZ")).then((mod)=>mod.default);
        case 'pl':
            return (parcelRequire("cpPSG")).then((mod)=>mod.default);
        case 'pt_BR':
        case 'pt-BR':
            return (parcelRequire("2yNwc")).then((mod)=>mod.default);
        case 'pt_PT':
        case 'pt-PT':
            return (parcelRequire("9fIis")).then((mod)=>mod.default);
        case 'ro':
            return (parcelRequire("iGZEx")).then((mod)=>mod.default);
        case 'ru':
            return (parcelRequire("35ZX7")).then((mod)=>mod.default);
        case 'sk':
            return (parcelRequire("5V9Ev")).then((mod)=>mod.default);
        case 'sv':
            return (parcelRequire("a3nUu")).then((mod)=>mod.default);
        case 'th':
            return (parcelRequire("fQJx5")).then((mod)=>mod.default);
        case 'tr':
            return (parcelRequire("5YgKO")).then((mod)=>mod.default);
        case 'uk':
            return (parcelRequire("1WOBW")).then((mod)=>mod.default);
        case 'vi':
            return (parcelRequire("17hu4")).then((mod)=>mod.default);
        case 'zh_TW':
            return (parcelRequire("2nKr7")).then((mod)=>mod.default);
        case 'zh':
            return (parcelRequire("240nm")).then((mod)=>mod.default);
        default:
            {
                const fragments = locale.split(/[_-]/);
                if (fragments.length === 2) return $10ce0748906381fc$export$d0a3169680473b6c(fragments[0]);
                else return (parcelRequire("33qfR")).then((mod)=>mod.default);
            }
    }
};

});
parcelRegister("ekiI8", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("3Rau7").then(()=>parcelRequire('daQ47'));

});

parcelRegister("fgm4J", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("5088Q").then(()=>parcelRequire('3gwUr'));

});

parcelRegister("drBO7", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("jYDLH").then(()=>parcelRequire('4TktE'));

});

parcelRegister("33qfR", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("5cN1A").then(()=>parcelRequire('9UkW6'));

});

parcelRegister("b8fOo", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("6KBLY").then(()=>parcelRequire('keQOQ'));

});

parcelRegister("bWIrP", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("22pZ8").then(()=>parcelRequire('j96ER'));

});

parcelRegister("3sK4f", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("l8VWt").then(()=>parcelRequire('lJB7m'));

});

parcelRegister("0YUKd", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("8pdE4").then(()=>parcelRequire('lrhH1'));

});

parcelRegister("cQwBF", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("cTgaJ").then(()=>parcelRequire('9bXg4'));

});

parcelRegister("lAFFG", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("fW1As").then(()=>parcelRequire('ghDtB'));

});

parcelRegister("gk7oQ", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("31wTJ").then(()=>parcelRequire('fBK8V'));

});

parcelRegister("i90HO", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("8zZ5r").then(()=>parcelRequire('fOaod'));

});

parcelRegister("c2jzR", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("gB4Se").then(()=>parcelRequire('55LdR'));

});

parcelRegister("5EpIH", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("6jN77").then(()=>parcelRequire('4Wmwb'));

});

parcelRegister("2AW9v", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("7uPiT").then(()=>parcelRequire('hHM7Q'));

});

parcelRegister("3NUXI", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("2BwB1").then(()=>parcelRequire('btRta'));

});

parcelRegister("fU2cZ", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("joqnM").then(()=>parcelRequire('deJm0'));

});

parcelRegister("cpPSG", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("80ngU").then(()=>parcelRequire('eWFII'));

});

parcelRegister("2yNwc", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("gZaei").then(()=>parcelRequire('73cSD'));

});

parcelRegister("9fIis", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("hjmdM").then(()=>parcelRequire('a0Otm'));

});

parcelRegister("iGZEx", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("jRFFA").then(()=>parcelRequire('hTW3c'));

});

parcelRegister("35ZX7", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("bngha").then(()=>parcelRequire('bO1y4'));

});

parcelRegister("5V9Ev", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("iHx0h").then(()=>parcelRequire('h8Ntk'));

});

parcelRegister("a3nUu", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("7LPdQ").then(()=>parcelRequire('7UfC0'));

});

parcelRegister("fQJx5", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("2miED").then(()=>parcelRequire('aHlPd'));

});

parcelRegister("5YgKO", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("6Clan").then(()=>parcelRequire('gEBJz'));

});

parcelRegister("1WOBW", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("b01pn").then(()=>parcelRequire('js5pv'));

});

parcelRegister("17hu4", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("fhoQ2").then(()=>parcelRequire('5Pm4u'));

});

parcelRegister("2nKr7", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("i7U3b").then(()=>parcelRequire('cVDSh'));

});

parcelRegister("240nm", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("5JnGw").then(()=>parcelRequire('kzp7K'));

});



parcelRegister("48bcP", function(module, exports) {
$parcel$export(module.exports, "ExusUserSourceProvider", () => $8b385761409405b0$export$bcd5c65b586ee3c3);
$parcel$export(module.exports, "useUserSource", () => $8b385761409405b0$export$c6c0c1a2bac363f);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");
const $8b385761409405b0$var$ExusUserSourceContext = /*#__PURE__*/ (0, $eJOHy.createContext)({});
const $8b385761409405b0$export$bcd5c65b586ee3c3 = ({ fetchUserSource: fetchUserSource, children: children })=>/*#__PURE__*/ (0, $gt9Am.jsx)($8b385761409405b0$var$ExusUserSourceContext.Provider, {
        value: {
            fetchUserSource: fetchUserSource
        },
        children: children
    });
const $8b385761409405b0$export$c6c0c1a2bac363f = (accountId, shouldFetchSources, existingSources)=>{
    const { fetchUserSource: fetchUserSource } = (0, $eJOHy.useContext)($8b385761409405b0$var$ExusUserSourceContext);
    const [externalSources, setExternalSources] = (0, $eJOHy.useState)([]);
    const [loading, setLoading] = (0, $eJOHy.useState)(true);
    const [error, setError] = (0, $eJOHy.useState)(null);
    const abortController = (0, $eJOHy.useMemo)(()=>{
        if (typeof AbortController === 'undefined') return;
        return new AbortController();
    }, []);
    (0, $eJOHy.useEffect)(()=>{
        let isMounted = true;
        const cleanup = ()=>{
            abortController?.abort();
            isMounted = false;
        };
        if (!fetchUserSource || !shouldFetchSources) {
            setLoading(false);
            return cleanup;
        }
        fetchUserSource(accountId, abortController?.signal).then((externalSources)=>{
            if (!isMounted) return;
            setLoading(false);
            const externalSourceTypes = externalSources.map((source)=>source.sourceType);
            setExternalSources(externalSourceTypes);
        }).catch((error)=>{
            if (!isMounted) return;
            setLoading(false);
            setError(error);
        });
        return cleanup;
    }, [
        fetchUserSource,
        accountId,
        abortController,
        shouldFetchSources
    ]);
    return (0, $eJOHy.useMemo)(()=>({
            sources: Array.from(new Set([
                ...existingSources ?? [],
                ...externalSources
            ])),
            loading: loading,
            error: error
        }), [
        error,
        existingSources,
        externalSources,
        loading
    ]);
};

});


parcelRegister("7YvOT", function(module, exports) {
$parcel$export(module.exports, "useUpdateDriverExperienceStart", () => $1cebebf2c1e2b43d$export$6e6b386771ff8a93);
$parcel$export(module.exports, "useUpdateDriverExperienceFail", () => $1cebebf2c1e2b43d$export$a86702725d24ceba);
$parcel$export(module.exports, "useUpdateDriverExperienceSuccess", () => $1cebebf2c1e2b43d$export$ce389ea9709547fd);

var $aqnJa = parcelRequire("aqnJa");

var $8Uqf3 = parcelRequire("8Uqf3");

var $4ctwv = parcelRequire("4ctwv");

var $lBYgs = parcelRequire("lBYgs");

var $1BZ8a = parcelRequire("1BZ8a");
const $1cebebf2c1e2b43d$var$EXPERIENCE_NAME = 'updateJiraVersionDriver';
const $1cebebf2c1e2b43d$var$SOURCE = 'versionDetails';
const $1cebebf2c1e2b43d$export$6e6b386771ff8a93 = ()=>{
    const appEditions = (0, $1BZ8a.useAppEditions)();
    return (0, $8Uqf3.useExperienceStart)({
        experience: $1cebebf2c1e2b43d$var$EXPERIENCE_NAME,
        experienceId: `${Date.now()}`,
        analyticsSource: $1cebebf2c1e2b43d$var$SOURCE,
        application: (0, $lBYgs.JIRA_SOFTWARE),
        edition: appEditions.software
    });
};
const $1cebebf2c1e2b43d$export$a86702725d24ceba = ()=>(0, $aqnJa.useExperienceFail)({
        experience: $1cebebf2c1e2b43d$var$EXPERIENCE_NAME
    });
const $1cebebf2c1e2b43d$export$ce389ea9709547fd = ()=>(0, $4ctwv.useExperienceSuccess)({
        experience: $1cebebf2c1e2b43d$var$EXPERIENCE_NAME
    });

});

parcelRegister("djnMS", function(module, exports) {
$parcel$export(module.exports, "default", () => $429975f5bb4eea8e$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $429975f5bb4eea8e$var$messages = (0, $7qGN1.defineMessages)({
    unassigned: {
        "id": "software-releases-version-driver-field.unassigned",
        "defaultMessage": "Unassigned"
    },
    fieldLabel: {
        "id": "software-releases-version-driver-field.field-label",
        "defaultMessage": "Driver"
    },
    genericErrorFlagTitle: {
        "id": "software-releases-version-driver-field.generic-error-flag-title",
        "defaultMessage": "We couldn't update the version driver."
    },
    genericErrorFlagDescription: {
        "id": "software-releases-version-driver-field.generic-error-flag-description",
        "defaultMessage": "Something went wrong. Please try again or contact your administrator if the problem persists."
    }
});
var $429975f5bb4eea8e$export$2e2bcd8739ae039 = $429975f5bb4eea8e$var$messages;

});


parcelRegister("l1SLp", function(module, exports) {
$parcel$export(module.exports, "VersionSummaryDescription", () => $00e96dde55a27bbd$export$e4174f5e9c00a5fc);

var $7cKU2 = parcelRequire("7cKU2");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $j4oe4 = parcelRequire("j4oe4");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $lRq8t = parcelRequire("lRq8t");

var $b5t4x = parcelRequire("b5t4x");

var $5t2C4 = parcelRequire("5t2C4");
const $00e96dde55a27bbd$export$e4174f5e9c00a5fc = ({ jiraVersion: jiraVersion })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const version = (0, $j4oe4.useFragment)((0, $7cKU2.default), jiraVersion);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($00e96dde55a27bbd$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $00e96dde55a27bbd$var$headingStyles,
        as: "h2"
    }, formatMessage((0, $5t2C4.default).descriptionHeader)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($00e96dde55a27bbd$var$DescriptionContainer, {
        "data-testid": "software-releases-version-summary-description.ui.description-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $00e96dde55a27bbd$var$inlinedEditOffsetStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $b5t4x.AsyncEditableVersionSummaryDescription), {
        jiraVersion: version,
        shouldTruncateText: true
    }))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $00e96dde55a27bbd$var$Container = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
});
const $00e96dde55a27bbd$var$DescriptionContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
});
const $00e96dde55a27bbd$var$inlinedEditOffsetStyles = (0, $1DXK0.xcss)({
    marginTop: 'space.negative.100',
    marginLeft: 'space.negative.100'
});
const $00e96dde55a27bbd$var$headingStyles = (0, $1DXK0.xcss)({
    color: 'color.text.subtle',
    font: 'font.body.small',
    fontWeight: 'font.weight.bold'
});

});
parcelRegister("7cKU2", function(module, exports) {
$parcel$export(module.exports, "default", () => $4e48a6e6a8f51ad4$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<590483254f3e5ae0689c5da4f6f780a8>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $4e48a6e6a8f51ad4$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "ui_softwareReleasesVersionSummaryDescription_VersionSummaryDescription",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "async_softwareReleasesVersionSummaryDescription_AsyncEditableVersionSummaryDescription"
        }
    ],
    "type": "JiraVersion"
};
$4e48a6e6a8f51ad4$var$node.hash = "ed1e590e92f538e88d28c5f6bba7c77c";
var $4e48a6e6a8f51ad4$export$2e2bcd8739ae039 = $4e48a6e6a8f51ad4$var$node;

});

parcelRegister("b5t4x", function(module, exports) {
$parcel$export(module.exports, "AsyncEditableVersionSummaryDescription", () => $3bd913f07e2b0ac7$export$6da629078e9c0cf3);

var $jJsg9 = parcelRequire("jJsg9");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $j4oe4 = parcelRequire("j4oe4");

var $lRq8t = parcelRequire("lRq8t");

var $2imLM = parcelRequire("2imLM");

var $bQWwW = parcelRequire("bQWwW");

var $57mXZ = parcelRequire("57mXZ");

var $bdCmn = parcelRequire("bdCmn");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $3bd913f07e2b0ac7$var$LazyEditableSummaryDescription = (0, $bQWwW.lazy)(()=>(parcelRequire("1AigI")).then((module)=>module.EditableVersionSummaryDescription), {
    moduleId: "./src/packages/releases/version-summary-description/src/ui/editable-version-summary-description/index.tsx"
});
const $3bd913f07e2b0ac7$export$6da629078e9c0cf3 = ({ jiraVersion: jiraVersion, shouldTruncateText: shouldTruncateText })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const version = (0, $j4oe4.useFragment)((0, $jJsg9.default), jiraVersion);
    const descriptionText = version.description !== '' ? version.description : formatMessage((0, $bdCmn.default).descriptionPlaceholder);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "editable-description",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3bd913f07e2b0ac7$var$InlineEditReadViewContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $57mXZ.DescriptionContent), {
            descriptionText: descriptionText || '',
            isNonEmpty: !!version.description,
            shouldTruncateText: shouldTruncateText
        }))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3bd913f07e2b0ac7$var$LazyEditableSummaryDescription, {
        jiraVersion: version,
        shouldTruncateText: shouldTruncateText
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3bd913f07e2b0ac7$var$InlineEditReadViewContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_189e1dm9 _1dqonqa1 _1h6d3acm _vwz4kb7n",
            __cmplp.className
        ])
    });
});

});
parcelRegister("jJsg9", function(module, exports) {
$parcel$export(module.exports, "default", () => $9789f319c82a51bc$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<61c524636ae7c6db90724329336f57a9>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $9789f319c82a51bc$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "async_softwareReleasesVersionSummaryDescription_AsyncEditableVersionSummaryDescription",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "description"
        },
        {
            "kind": "FragmentSpread",
            "name": "editableVersionSummaryDescription_softwareReleasesVersionSummaryDescription"
        }
    ],
    "type": "JiraVersion"
};
$9789f319c82a51bc$var$node.hash = "2a90bb83f1ef52be3fdf77ad96c33404";
var $9789f319c82a51bc$export$2e2bcd8739ae039 = $9789f319c82a51bc$var$node;

});

parcelRegister("57mXZ", function(module, exports) {
$parcel$export(module.exports, "DescriptionContent", () => $44a6e0105a2ec3f0$export$afe6a96ed909bf0f);
/* DescriptionContent.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $2nlj2 = parcelRequire("2nlj2");
const $44a6e0105a2ec3f0$var$TRUNCATE_TEXT_LENGTH = 300;
const $44a6e0105a2ec3f0$export$afe6a96ed909bf0f = ({ isNonEmpty: isNonEmpty, shouldTruncateText: shouldTruncateText, descriptionText: descriptionText })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($44a6e0105a2ec3f0$var$DescriptionContentContainer, {
        isNonEmpty: isNonEmpty
    }, shouldTruncateText ? (0, (/*@__PURE__*/$parcel$interopDefault($2nlj2)))(descriptionText, {
        length: $44a6e0105a2ec3f0$var$TRUNCATE_TEXT_LENGTH,
        separator: ' '
    }) : descriptionText);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $44a6e0105a2ec3f0$var$DescriptionContentContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isNonEmpty: isNonEmpty, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_ca0qu2gc _u5f312x7 _n3tdu2gc _19bv12x7 _slp31hna _o5726vc6 _vwz4cjiy",
            __cmplp.isNonEmpty ? "_syaz1kw7" : "_syaz1rpy",
            __cmplp.className
        ])
    });
});

});
parcelRegister("2nlj2", function(module, exports) {

var $wkcOI = parcelRequire("wkcOI");

var $j4Djm = parcelRequire("j4Djm");

var $beeZR = parcelRequire("beeZR");

var $546O5 = parcelRequire("546O5");

var $5jnGi = parcelRequire("5jnGi");

var $esCHN = parcelRequire("esCHN");

var $gsm7J = parcelRequire("gsm7J");

var $c9FP3 = parcelRequire("c9FP3");

var $cz1WF = parcelRequire("cz1WF");
/** Used as default options for `_.truncate`. */ var $1bae41afc01471ee$var$DEFAULT_TRUNC_LENGTH = 30, $1bae41afc01471ee$var$DEFAULT_TRUNC_OMISSION = '...';
/** Used to match `RegExp` flags from their coerced string values. */ var $1bae41afc01471ee$var$reFlags = /\w*$/;
/**
 * Truncates `string` if it's longer than the given maximum string length.
 * The last characters of the truncated string are replaced with the omission
 * string which defaults to "...".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to truncate.
 * @param {Object} [options={}] The options object.
 * @param {number} [options.length=30] The maximum string length.
 * @param {string} [options.omission='...'] The string to indicate text is omitted.
 * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
 * @returns {string} Returns the truncated string.
 * @example
 *
 * _.truncate('hi-diddly-ho there, neighborino');
 * // => 'hi-diddly-ho there, neighbo...'
 *
 * _.truncate('hi-diddly-ho there, neighborino', {
 *   'length': 24,
 *   'separator': ' '
 * });
 * // => 'hi-diddly-ho there,...'
 *
 * _.truncate('hi-diddly-ho there, neighborino', {
 *   'length': 24,
 *   'separator': /,? +/
 * });
 * // => 'hi-diddly-ho there...'
 *
 * _.truncate('hi-diddly-ho there, neighborino', {
 *   'omission': ' [...]'
 * });
 * // => 'hi-diddly-ho there, neig [...]'
 */ function $1bae41afc01471ee$var$truncate(string, options) {
    var length = $1bae41afc01471ee$var$DEFAULT_TRUNC_LENGTH, omission = $1bae41afc01471ee$var$DEFAULT_TRUNC_OMISSION;
    if ($546O5(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? $c9FP3(options.length) : length;
        omission = 'omission' in options ? $wkcOI(options.omission) : omission;
    }
    string = $cz1WF(string);
    var strLength = string.length;
    if ($beeZR(string)) {
        var strSymbols = $gsm7J(string);
        strLength = strSymbols.length;
    }
    if (length >= strLength) return string;
    var end = length - $esCHN(omission);
    if (end < 1) return omission;
    var result = strSymbols ? $j4Djm(strSymbols, 0, end).join('') : string.slice(0, end);
    if (separator === undefined) return result + omission;
    if (strSymbols) end += result.length - end;
    if ($5jnGi(separator)) {
        if (string.slice(end).search(separator)) {
            var match, substring = result;
            if (!separator.global) separator = RegExp(separator.source, $cz1WF($1bae41afc01471ee$var$reFlags.exec(separator)) + 'g');
            separator.lastIndex = 0;
            while(match = separator.exec(substring))var newEnd = match.index;
            result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
    } else if (string.indexOf($wkcOI(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) result = result.slice(0, index);
    }
    return result + omission;
}
module.exports = $1bae41afc01471ee$var$truncate;

});
parcelRegister("5jnGi", function(module, exports) {

var $1o86I = parcelRequire("1o86I");

var $cUaWv = parcelRequire("cUaWv");

var $bLZOH = parcelRequire("bLZOH");
/* Node.js helper references. */ var $3de118ac07a326fa$var$nodeIsRegExp = $bLZOH && $bLZOH.isRegExp;
/**
 * Checks if `value` is classified as a `RegExp` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
 * @example
 *
 * _.isRegExp(/abc/);
 * // => true
 *
 * _.isRegExp('/abc/');
 * // => false
 */ var $3de118ac07a326fa$var$isRegExp = $3de118ac07a326fa$var$nodeIsRegExp ? $cUaWv($3de118ac07a326fa$var$nodeIsRegExp) : $1o86I;
module.exports = $3de118ac07a326fa$var$isRegExp;

});
parcelRegister("1o86I", function(module, exports) {

var $1O9y6 = parcelRequire("1O9y6");

var $7gKgM = parcelRequire("7gKgM");
/** `Object#toString` result references. */ var $102e5245e8b75589$var$regexpTag = '[object RegExp]';
/**
 * The base implementation of `_.isRegExp` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
 */ function $102e5245e8b75589$var$baseIsRegExp(value) {
    return $7gKgM(value) && $1O9y6(value) == $102e5245e8b75589$var$regexpTag;
}
module.exports = $102e5245e8b75589$var$baseIsRegExp;

});


parcelRegister("esCHN", function(module, exports) {

var $cVaIZ = parcelRequire("cVaIZ");

var $beeZR = parcelRequire("beeZR");

var $dsEqJ = parcelRequire("dsEqJ");
/**
 * Gets the number of symbols in `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the string size.
 */ function $a871b4482705c524$var$stringSize(string) {
    return $beeZR(string) ? $dsEqJ(string) : $cVaIZ(string);
}
module.exports = $a871b4482705c524$var$stringSize;

});
parcelRegister("cVaIZ", function(module, exports) {

var $9U1Ux = parcelRequire("9U1Ux");
/**
 * Gets the size of an ASCII `string`.
 *
 * @private
 * @param {string} string The string inspect.
 * @returns {number} Returns the string size.
 */ var $9683209b72c5c382$var$asciiSize = $9U1Ux('length');
module.exports = $9683209b72c5c382$var$asciiSize;

});

parcelRegister("dsEqJ", function(module, exports) {
/** Used to compose unicode character classes. */ var $9ccd4073599dd88e$var$rsAstralRange = '\\ud800-\\udfff', $9ccd4073599dd88e$var$rsComboMarksRange = '\\u0300-\\u036f', $9ccd4073599dd88e$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $9ccd4073599dd88e$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $9ccd4073599dd88e$var$rsComboRange = $9ccd4073599dd88e$var$rsComboMarksRange + $9ccd4073599dd88e$var$reComboHalfMarksRange + $9ccd4073599dd88e$var$rsComboSymbolsRange, $9ccd4073599dd88e$var$rsVarRange = '\\ufe0e\\ufe0f';
/** Used to compose unicode capture groups. */ var $9ccd4073599dd88e$var$rsAstral = '[' + $9ccd4073599dd88e$var$rsAstralRange + ']', $9ccd4073599dd88e$var$rsCombo = '[' + $9ccd4073599dd88e$var$rsComboRange + ']', $9ccd4073599dd88e$var$rsFitz = '\\ud83c[\\udffb-\\udfff]', $9ccd4073599dd88e$var$rsModifier = '(?:' + $9ccd4073599dd88e$var$rsCombo + '|' + $9ccd4073599dd88e$var$rsFitz + ')', $9ccd4073599dd88e$var$rsNonAstral = '[^' + $9ccd4073599dd88e$var$rsAstralRange + ']', $9ccd4073599dd88e$var$rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', $9ccd4073599dd88e$var$rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', $9ccd4073599dd88e$var$rsZWJ = '\\u200d';
/** Used to compose unicode regexes. */ var $9ccd4073599dd88e$var$reOptMod = $9ccd4073599dd88e$var$rsModifier + '?', $9ccd4073599dd88e$var$rsOptVar = '[' + $9ccd4073599dd88e$var$rsVarRange + ']?', $9ccd4073599dd88e$var$rsOptJoin = '(?:' + $9ccd4073599dd88e$var$rsZWJ + '(?:' + [
    $9ccd4073599dd88e$var$rsNonAstral,
    $9ccd4073599dd88e$var$rsRegional,
    $9ccd4073599dd88e$var$rsSurrPair
].join('|') + ')' + $9ccd4073599dd88e$var$rsOptVar + $9ccd4073599dd88e$var$reOptMod + ')*', $9ccd4073599dd88e$var$rsSeq = $9ccd4073599dd88e$var$rsOptVar + $9ccd4073599dd88e$var$reOptMod + $9ccd4073599dd88e$var$rsOptJoin, $9ccd4073599dd88e$var$rsSymbol = '(?:' + [
    $9ccd4073599dd88e$var$rsNonAstral + $9ccd4073599dd88e$var$rsCombo + '?',
    $9ccd4073599dd88e$var$rsCombo,
    $9ccd4073599dd88e$var$rsRegional,
    $9ccd4073599dd88e$var$rsSurrPair,
    $9ccd4073599dd88e$var$rsAstral
].join('|') + ')';
/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var $9ccd4073599dd88e$var$reUnicode = RegExp($9ccd4073599dd88e$var$rsFitz + '(?=' + $9ccd4073599dd88e$var$rsFitz + ')|' + $9ccd4073599dd88e$var$rsSymbol + $9ccd4073599dd88e$var$rsSeq, 'g');
/**
 * Gets the size of a Unicode `string`.
 *
 * @private
 * @param {string} string The string inspect.
 * @returns {number} Returns the string size.
 */ function $9ccd4073599dd88e$var$unicodeSize(string) {
    var result = $9ccd4073599dd88e$var$reUnicode.lastIndex = 0;
    while($9ccd4073599dd88e$var$reUnicode.test(string))++result;
    return result;
}
module.exports = $9ccd4073599dd88e$var$unicodeSize;

});




parcelRegister("bdCmn", function(module, exports) {
$parcel$export(module.exports, "default", () => $2506c129edb577ba$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $2506c129edb577ba$var$messages = (0, $7qGN1.defineMessages)({
    descriptionPlaceholder: {
        "id": "software-releases-version-summary-description.editable-version-summary-description.description-placeholder",
        "defaultMessage": "No description added yet."
    },
    errorFlagTitle: {
        "id": "software-releases-version-summary-description.editable-version-summary-description.error-flag-title",
        "defaultMessage": "We couldn't update the description"
    },
    errorFlagDescription: {
        "id": "software-releases-version-summary-description.editable-version-summary-description.error-flag-description",
        "defaultMessage": "Something went wrong. Please try again or contact your administrator if the problem persists."
    },
    maxDescriptionSizeExceededErrorMessage: {
        "id": "software-releases-version-summary-description.editable-version-summary-description.max-description-size-exceeded-error-message",
        "defaultMessage": "Maximum description size exceeded"
    }
});
var $2506c129edb577ba$export$2e2bcd8739ae039 = $2506c129edb577ba$var$messages;

});

parcelRegister("1AigI", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("6QS6n").then(()=>parcelRequire('jfJw2'));

});


parcelRegister("5t2C4", function(module, exports) {
$parcel$export(module.exports, "default", () => $9864076313e15c54$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $9864076313e15c54$var$messages = (0, $7qGN1.defineMessages)({
    descriptionHeader: {
        "id": "software-releases-version-summary-description.description-header",
        "defaultMessage": "Description"
    }
});
var $9864076313e15c54$export$2e2bcd8739ae039 = $9864076313e15c54$var$messages;

});


parcelRegister("30pmy", function(module, exports) {
$parcel$export(module.exports, "NonCriticalErrorBoundary", () => $c63a1e9e1ee6d7f2$export$1625b7ea4c7a5a23);

var $eJOHy = parcelRequire("eJOHy");

var $5vQ2T = parcelRequire("5vQ2T");
const $c63a1e9e1ee6d7f2$export$1625b7ea4c7a5a23 = ({ fallback: fallback, eventLocation: eventLocation, children: children, onError: onError })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        fallback: fallback,
        packageName: "jiraSoftwareReleasesLaunchCard",
        teamName: "jolt",
        id: eventLocation,
        onError: onError
    }, children);

});

parcelRegister("6rYRI", function(module, exports) {
$parcel$export(module.exports, "default", () => $69dd5e39987d95ca$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<404f0936c589f2bac5fc9b25c6f0c25c>>
 * @relayHash 6139c5ac9eede3cb4cb45119f82b6c42
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 73bb0607fa286f014e98ee150a452d0808aff2ce4aa135ef04b8f21d5ea34326
const $69dd5e39987d95ca$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKey"
        }
    ], v1 = {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "cloudId",
                        "variableName": "cloudId"
                    },
                    {
                        "kind": "Variable",
                        "name": "projectKey",
                        "variableName": "projectKey"
                    }
                ],
                "kind": "ScalarField",
                "name": "deploymentsFeaturePreconditionByProjectKey"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "latestDeploymentForVersionPreconditionQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": v1 /*: any*/ ,
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "latestDeploymentForVersionPreconditionQuery",
            "selections": [
                v1 /*: any*/ 
            ]
        },
        "params": {
            "id": "73bb0607fa286f014e98ee150a452d0808aff2ce4aa135ef04b8f21d5ea34326",
            "metadata": {},
            "name": "latestDeploymentForVersionPreconditionQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$69dd5e39987d95ca$var$node.hash = "af15b08c11e01f89f1bd0ec84b873d12";
var $69dd5e39987d95ca$export$2e2bcd8739ae039 = $69dd5e39987d95ca$var$node;

});

parcelRegister("b0nGU", function(module, exports) {
$parcel$export(module.exports, "default", () => $b2fba93d9a25a4a5$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c60b4cdcb35ffcf99e9dac7ab120eb4d>>
 * @relayHash 25bb212fb9dcb165ca802d31818fab42
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b199f8523e8b333f650adf93ec0ebc73c3b0927f50a3fec2c9c3769918fbeb9b
const $b2fba93d9a25a4a5$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "versionId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "versionId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v3 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "async_softwareReleasesVersionContributorsQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v1 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "async_softwareReleasesLaunchCard_AsyncVersionContributors"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.version"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "async_softwareReleasesVersionContributorsQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "version",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "concreteType": "JiraVersionContributorConnection",
                                            "kind": "LinkedField",
                                            "name": "contributors",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraVersionContributorEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v2 /*: any*/ ,
                                                                v3 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "name"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "picture"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "AtlassianAccountUserExtendedProfile",
                                                                            "kind": "LinkedField",
                                                                            "name": "extendedProfile",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "jobTitle"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "type": "AtlassianAccountUser"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "JiraVersion"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v3 /*: any*/ 
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "b199f8523e8b333f650adf93ec0ebc73c3b0927f50a3fec2c9c3769918fbeb9b",
            "metadata": {},
            "name": "async_softwareReleasesVersionContributorsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$b2fba93d9a25a4a5$var$node.hash = "0dd2c9bd66e5b70949d165995607196b";
var $b2fba93d9a25a4a5$export$2e2bcd8739ae039 = $b2fba93d9a25a4a5$var$node;

});

parcelRegister("aPeIb", function(module, exports) {
$parcel$export(module.exports, "LatestDeployment", () => $8ed53c467f0ceccb$export$4c54e4ee90dcb7e7);

var $6rYRI = parcelRequire("6rYRI");

var $9Weig = parcelRequire("9Weig");

var $1YYAr = parcelRequire("1YYAr");

var $54xP2 = parcelRequire("54xP2");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $e8XBu = parcelRequire("e8XBu");
var $5fuQp = parcelRequire("5fuQp");

var $j4oe4 = parcelRequire("j4oe4");

var $k71qx = parcelRequire("k71qx");
var $7AseU = parcelRequire("7AseU");

var $lRq8t = parcelRequire("lRq8t");

var $2imLM = parcelRequire("2imLM");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $c9uTK = parcelRequire("c9uTK");

var $iATGh = parcelRequire("iATGh");

var $aMdVM = parcelRequire("aMdVM");

var $4c6Bn = parcelRequire("4c6Bn");

var $4Tl6R = parcelRequire("4Tl6R");

var $8KwqL = parcelRequire("8KwqL");

var $47xQB = parcelRequire("47xQB");
const $8ed53c467f0ceccb$export$9fbf3675ff70ff0 = ({ jiraVersion: jiraVersion, queryReference: queryReference })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const deploymentsRoute = (0, $aMdVM.useDeploymentsRoute)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const version = (0, $j4oe4.useFragment)((0, $54xP2.default), jiraVersion);
    const isMoreThanAWeekApart = (a, b)=>{
        const oneWeekInMilliseconds = 604800000;
        return (0, $e8XBu.default)(a, b) > oneWeekInMilliseconds;
    };
    const data = (0, $j4oe4.usePreloadedQuery)((0, $1YYAr.default), queryReference);
    const deploymentNodes = data.devOps.ariGraph.relationships.edges.filter(Boolean).map((edge)=>edge.node);
    const renderLink = (content, hasNoRecentDeployments)=>hasNoRecentDeployments ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8ed53c467f0ceccb$var$StyledLink, {
            href: (0, $iATGh.SUPPORT_DOCS_LINK_URL),
            onClick: ()=>{
                (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({
                    action: 'clicked',
                    actionSubject: 'link'
                }), 'latestDeploymentInVersion');
            },
            target: "_blank"
        }, content) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8ed53c467f0ceccb$var$StyledLink, {
            onClick: ()=>{
                (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({
                    action: 'clicked',
                    actionSubject: 'link'
                }), 'latestDeploymentInVersion');
            },
            prefetch: "hover",
            params: {
                projectKey: version.project.key
            },
            query: {
                startDate: '-3m',
                endDate: 'now',
                fixVersions: version.name
            },
            to: deploymentsRoute
        }, content);
    const latestDeployment = deploymentNodes[0]?.to.data;
    const hasNoDeploymentInLastWeek = latestDeployment?.lastUpdated ? isMoreThanAWeekApart(new Date(), new Date(latestDeployment.lastUpdated)) : true;
    let linkContent = null;
    if (latestDeployment == null) linkContent = formatMessage((0, $8KwqL.default).noDeployments);
    else if (latestDeployment.lastUpdated !== undefined) {
        if (hasNoDeploymentInLastWeek) linkContent = formatMessage((0, $8KwqL.default).noDeployments);
        else linkContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, formatMessage((0, $8KwqL.default).lastDeployment), (0, $5fuQp.default)(new Date(latestDeployment.lastUpdated), new Date(), {
            addSuffix: true,
            roundingMethod: 'floor'
        }));
    }
    const [providersListQuery, loadProvidersListQuery] = (0, $47xQB.useLoadProvidersListQuery)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default // @ts-expect-error - TS3233 - unsure why it doesn't like my tooltip :|
    ), {
        component: $8ed53c467f0ceccb$var$CustomTooltip,
        content: hasNoDeploymentInLastWeek && providersListQuery ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $47xQB.ProvidersList), {
            queryReference: providersListQuery
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4c6Bn.DeploymentTooltipContent), {
            jiraVersion: version,
            deployment: latestDeployment
        }),
        onShow: (analyticsEvent)=>{
            (0, $kRgKj.fireUIAnalytics)(analyticsEvent, hasNoDeploymentInLastWeek && providersListQuery ? 'latestDeploymentInVersionProvidersTooltip' : 'latestDeploymentInVersionDetailsTooltip');
        }
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8ed53c467f0ceccb$var$Wrapper, {
            ...tooltipProps,
            onMouseOver: (event)=>{
                tooltipProps.onMouseOver(event);
                if (hasNoDeploymentInLastWeek) loadProvidersListQuery();
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4Tl6R.PulseIcon), null), linkContent && renderLink(linkContent, latestDeployment == null || hasNoDeploymentInLastWeek)));
};
const $8ed53c467f0ceccb$export$4c54e4ee90dcb7e7 = ({ jiraVersion: jiraVersion, preconditionQueryRef: preconditionQueryRef })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const version = (0, $j4oe4.useFragment)((0, $9Weig.default), jiraVersion);
    const { jira: { deploymentsFeaturePreconditionByProjectKey: deploymentsFeaturePreconditionByProjectKey } } = (0, $j4oe4.usePreloadedQuery)((0, $6rYRI.default), preconditionQueryRef);
    const [queryRef, loadQuery] = (0, $j4oe4.useQueryLoader)((0, $1YYAr.default));
    (0, $eJOHy.useEffect)(()=>{
        if (deploymentsFeaturePreconditionByProjectKey === 'ALL_SATISFIED') loadQuery({
            from: version.id
        });
    }, [
        deploymentsFeaturePreconditionByProjectKey,
        version.id,
        loadQuery
    ]);
    return deploymentsFeaturePreconditionByProjectKey === 'ALL_SATISFIED' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "latest-deployment-content",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8ed53c467f0ceccb$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4Tl6R.PulseIcon), null), formatMessage((0, $8KwqL.default).loading))
    }, queryRef && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8ed53c467f0ceccb$export$9fbf3675ff70ff0, {
        jiraVersion: version,
        queryReference: queryRef
    })) : null;
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8ed53c467f0ceccb$var$StyledLink = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = (0, $c9uTK.Link), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_syazi7uo _9h8hi7uo _f8pji7uo _v0vwi7uo _30l3i7uo",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8ed53c467f0ceccb$var$Wrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_11q7i8nm _zulpu2gc _4cvr1h6o _1e0c1txw _ca0qpxbi _u5f31ejb _n3tdpxbi _19bv1ejb",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8ed53c467f0ceccb$var$CustomTooltip = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = (0, $7AseU.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rkofajl _16qsjdvv _vchh18uv _bfhkvuon",
            __cmplp.className
        ])
    });
});

});
parcelRegister("9Weig", function(module, exports) {
$parcel$export(module.exports, "default", () => $3c99d5b8d50f5dab$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<77f1e70ec27936e5cf3f69a6a6c7a721>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $3c99d5b8d50f5dab$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "latestDeployment_softwareReleasesLaunchCard_jiraVersion",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "id"
            },
            "action": "THROW",
            "path": "id"
        },
        {
            "kind": "FragmentSpread",
            "name": "latestDeployment_softwareReleasesLaunchCard_LatestDeploymentContent_jiraVersion"
        }
    ],
    "type": "JiraVersion"
};
$3c99d5b8d50f5dab$var$node.hash = "9635192fd480eb66a7ef3d1c281498c0";
var $3c99d5b8d50f5dab$export$2e2bcd8739ae039 = $3c99d5b8d50f5dab$var$node;

});

parcelRegister("1YYAr", function(module, exports) {
$parcel$export(module.exports, "default", () => $3c528c8ed15f0576$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a7f9c2f1ea316f7e75734d4856388ce4>>
 * @relayHash 4f907308c1893ca60c7291b087e6c39e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8a1ba70765de1a703c18b75e8458f6e0f02368ed62a9ae447ac07f43649ee583
const $3c528c8ed15f0576$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "from"
        }
    ], v1 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1
        },
        {
            "kind": "Variable",
            "name": "from",
            "variableName": "from"
        },
        {
            "kind": "Literal",
            "name": "sort",
            "value": {
                "lastUpdatedSortDirection": "DESC"
            }
        },
        {
            "kind": "Literal",
            "name": "type",
            "value": "version-associated-deployment"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "lastUpdated"
    }, v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = [
        v3 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "latestDeploymentForVersionQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "DevOps",
                        "kind": "LinkedField",
                        "name": "devOps",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "concreteType": "AriGraph",
                                    "kind": "LinkedField",
                                    "name": "ariGraph",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "args": v1 /*: any*/ ,
                                                "concreteType": "AriGraphRelationshipConnection",
                                                "kind": "LinkedField",
                                                "name": "relationships",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "concreteType": "AriGraphRelationshipEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": {
                                                                        "concreteType": "AriGraphRelationship",
                                                                        "kind": "LinkedField",
                                                                        "name": "node",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": {
                                                                                    "concreteType": "AriGraphRelationshipNode",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "to",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "RequiredField",
                                                                                            "field": {
                                                                                                "kind": "LinkedField",
                                                                                                "name": "data",
                                                                                                "plural": false,
                                                                                                "selections": [
                                                                                                    {
                                                                                                        "kind": "InlineFragment",
                                                                                                        "selections": [
                                                                                                            {
                                                                                                                "kind": "RequiredField",
                                                                                                                "field": v2 /*: any*/ ,
                                                                                                                "action": "THROW",
                                                                                                                "path": "devOps.ariGraph.relationships.edges.node.to.data.lastUpdated"
                                                                                                            },
                                                                                                            {
                                                                                                                "kind": "FragmentSpread",
                                                                                                                "name": "deploymentTooltipContent_softwareReleasesLaunchCard_deployment"
                                                                                                            }
                                                                                                        ],
                                                                                                        "type": "DeploymentSummary"
                                                                                                    }
                                                                                                ]
                                                                                            },
                                                                                            "action": "THROW",
                                                                                            "path": "devOps.ariGraph.relationships.edges.node.to.data"
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                "action": "THROW",
                                                                                "path": "devOps.ariGraph.relationships.edges.node.to"
                                                                            }
                                                                        ]
                                                                    },
                                                                    "action": "THROW",
                                                                    "path": "devOps.ariGraph.relationships.edges.node"
                                                                }
                                                            ]
                                                        },
                                                        "action": "THROW",
                                                        "path": "devOps.ariGraph.relationships.edges"
                                                    }
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "devOps.ariGraph.relationships"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "devOps.ariGraph"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "devOps"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "latestDeploymentForVersionQuery",
            "selections": [
                {
                    "concreteType": "DevOps",
                    "kind": "LinkedField",
                    "name": "devOps",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "AriGraph",
                            "kind": "LinkedField",
                            "name": "ariGraph",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v1 /*: any*/ ,
                                    "concreteType": "AriGraphRelationshipConnection",
                                    "kind": "LinkedField",
                                    "name": "relationships",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "AriGraphRelationshipEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "AriGraphRelationship",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "AriGraphRelationshipNode",
                                                            "kind": "LinkedField",
                                                            "name": "to",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "data",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "__typename"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v2 /*: any*/ ,
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "state"
                                                                                },
                                                                                {
                                                                                    "concreteType": "DevOpsEnvironment",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "environment",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "displayName"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "category"
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "issueIds"
                                                                                }
                                                                            ],
                                                                            "type": "DeploymentSummary"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v4 /*: any*/ ,
                                                                            "type": "Node",
                                                                            "abstractKey": "__isNode"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v4 /*: any*/ ,
                                                                            "type": "DevOpsFeatureFlag"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v4 /*: any*/ ,
                                                                            "type": "DevOpsOperationsComponentDetails"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v4 /*: any*/ ,
                                                                            "type": "DevOpsOperationsIncidentDetails"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v4 /*: any*/ ,
                                                                            "type": "DevOpsOperationsPostIncidentReviewDetails"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v4 /*: any*/ ,
                                                                            "type": "DevOpsPullRequestDetails"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v4 /*: any*/ ,
                                                                            "type": "DevOpsRepository"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v4 /*: any*/ ,
                                                                            "type": "DevOpsSecurityVulnerabilityDetails"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v4 /*: any*/ ,
                                                                            "type": "JiraAutodevJob"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v4 /*: any*/ ,
                                                                            "type": "JiraConfluenceRemoteIssueLink"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v4 /*: any*/ ,
                                                                            "type": "JiraCustomRemoteIssueLink"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v4 /*: any*/ ,
                                                                            "type": "JiraIssueRemoteIssueLink"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v4 /*: any*/ ,
                                                                            "type": "JiraWebRemoteIssueLink"
                                                                        }
                                                                    ]
                                                                },
                                                                v3 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "8a1ba70765de1a703c18b75e8458f6e0f02368ed62a9ae447ac07f43649ee583",
            "metadata": {},
            "name": "latestDeploymentForVersionQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$3c528c8ed15f0576$var$node.hash = "804051e6b542c6dc7bf401419bdfe7f9";
var $3c528c8ed15f0576$export$2e2bcd8739ae039 = $3c528c8ed15f0576$var$node;

});

parcelRegister("54xP2", function(module, exports) {
$parcel$export(module.exports, "default", () => $b3f2cce2e0df8254$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ebfd8958a9f620c0b5965b0317d16e8c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $b3f2cce2e0df8254$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "latestDeployment_softwareReleasesLaunchCard_LatestDeploymentContent_jiraVersion",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "id"
            },
            "action": "THROW",
            "path": "id"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "name"
            },
            "action": "THROW",
            "path": "name"
        },
        {
            "kind": "RequiredField",
            "field": {
                "concreteType": "JiraProject",
                "kind": "LinkedField",
                "name": "project",
                "plural": false,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "kind": "ScalarField",
                            "name": "key"
                        },
                        "action": "THROW",
                        "path": "project.key"
                    }
                ]
            },
            "action": "THROW",
            "path": "project"
        },
        {
            "kind": "FragmentSpread",
            "name": "deploymentTooltipContent_softwareReleasesLaunchCard_jiraVersion"
        }
    ],
    "type": "JiraVersion"
};
$b3f2cce2e0df8254$var$node.hash = "636e16e48d5710e3c9d238bef208f75d";
var $b3f2cce2e0df8254$export$2e2bcd8739ae039 = $b3f2cce2e0df8254$var$node;

});

parcelRegister("iATGh", function(module, exports) {
$parcel$export(module.exports, "ARCHIVED", () => $e42fced7b7481320$export$c936349447a77fe0);
$parcel$export(module.exports, "RELEASED", () => $e42fced7b7481320$export$b983f2cb1f658a55);
$parcel$export(module.exports, "UNARCHIVED", () => $e42fced7b7481320$export$5813036ca984d7f3);
$parcel$export(module.exports, "UNRELEASED", () => $e42fced7b7481320$export$cb459d726a8530a5);
$parcel$export(module.exports, "FIRST_COLUMN_MIN_WIDTH", () => $e42fced7b7481320$export$f6fe47beb5520aca);
$parcel$export(module.exports, "SUPPORT_DOCS_LINK_URL", () => $e42fced7b7481320$export$cfcb17c409b4e552);
const $e42fced7b7481320$export$c936349447a77fe0 = 'ARCHIVED';
const $e42fced7b7481320$export$b983f2cb1f658a55 = 'RELEASED';
const $e42fced7b7481320$export$5813036ca984d7f3 = 'UNARCHIVED';
const $e42fced7b7481320$export$cb459d726a8530a5 = 'UNRELEASED';
const $e42fced7b7481320$export$f6fe47beb5520aca = 184;
const $e42fced7b7481320$export$cfcb17c409b4e552 = 'https://support.atlassian.com/jira-software-cloud/docs/reference-issues-in-your-development-work/';
const $e42fced7b7481320$var$statuses = [
    $e42fced7b7481320$export$c936349447a77fe0,
    $e42fced7b7481320$export$b983f2cb1f658a55,
    $e42fced7b7481320$export$cb459d726a8530a5,
    $e42fced7b7481320$export$5813036ca984d7f3
];
var $e42fced7b7481320$export$2e2bcd8739ae039 = $e42fced7b7481320$var$statuses;

});

parcelRegister("aMdVM", function(module, exports) {
$parcel$export(module.exports, "useDeploymentsRoute", () => $590ebebe71290eed$export$7a17d870b2f984df);

var $hih5V = parcelRequire("hih5V");

var $2aY2d = parcelRequire("2aY2d");
const $590ebebe71290eed$export$7a17d870b2f984df = ()=>{
    const { data: project } = (0, $2aY2d.useProjectContext)();
    const routeName = project?.simplified ? 'software-deployments' : 'software-deployments-classic';
    return (0, $hih5V.useRouteByName)(routeName) ?? routeName;
};

});

parcelRegister("4c6Bn", function(module, exports) {
$parcel$export(module.exports, "DeploymentTooltipContent", () => $5f63d6fd87d8ee63$export$c36a118f96728a11);

var $gS7F9 = parcelRequire("gS7F9");

var $7qb5G = parcelRequire("7qb5G");

var $eJOHy = parcelRequire("eJOHy");

var $5fuQp = parcelRequire("5fuQp");

var $j4oe4 = parcelRequire("j4oe4");

var $jdqdp = parcelRequire("jdqdp");

var $8nu6j = parcelRequire("8nu6j");
var $3Wh6p = parcelRequire("3Wh6p");
var $5qJVF = parcelRequire("5qJVF");
var $1DXK0 = parcelRequire("1DXK0");

var $4cTDP = parcelRequire("4cTDP");

var $assJw = parcelRequire("assJw");

var $lRq8t = parcelRequire("lRq8t");

var $kRgKj = parcelRequire("kRgKj");

var $2ztQs = parcelRequire("2ztQs");

var $c9uTK = parcelRequire("c9uTK");

var $aMdVM = parcelRequire("aMdVM");

var $b09G4 = parcelRequire("b09G4");

var $5l7IC = parcelRequire("5l7IC");
const $5f63d6fd87d8ee63$export$c36a118f96728a11 = ({ deployment: deployment, jiraVersion: jiraVersion })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const version = (0, $j4oe4.useFragment)((0, $7qb5G.default), jiraVersion);
    const { lastUpdated: lastUpdated, environment: environment, state: state, issueIds: issueIds } = (0, $j4oe4.useFragment)((0, $gS7F9.default), deployment);
    const deploymentsRoute = (0, $aMdVM.useDeploymentsRoute)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $assJw.PopupContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $assJw.PopupHeader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $assJw.PopupTitle), null, formatMessage((0, $b09G4.default).deploymentPopupTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        xcss: $5f63d6fd87d8ee63$var$headerStatusIconAndLozengeStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        xcss: $5f63d6fd87d8ee63$var$headerStatusIconStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2ztQs.DeploymentIcons), {
        deploymentState: (0, $5l7IC.mapDeploymentState)(state, environment.category),
        size: "medium"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jdqdp.default), {
        appearance: (0, $5l7IC.mapStateToLozengeProp)(state)
    }, state))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $assJw.LinkContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $5f63d6fd87d8ee63$var$environmentStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), {
        as: "p",
        weight: "bold"
    }, (0, $5l7IC.capitalizeOnlyFirstLetter)(environment.category), environment.displayName ? ` (${environment.displayName})` : ''))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        xcss: $5f63d6fd87d8ee63$var$environmentDetailStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), {
        as: "p",
        size: "small"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("span", null, (0, $5fuQp.default)(new Date(lastUpdated), new Date(), {
        addSuffix: true,
        roundingMethod: 'floor'
    })), issueIds == null ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        as: "span",
        xcss: $5f63d6fd87d8ee63$var$environmentDetailBetweenMarginStyles
    }, "\u2022"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        as: "span",
        xcss: $5f63d6fd87d8ee63$var$environmentDetailBetweenMarginStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), {
        size: "small"
    }, formatMessage((0, $4cTDP.fg)('jira-issue-terminology-update-m4') ? (0, $b09G4.default).issuesDeployedIssueTerminologyRefreshM4 : (0, $b09G4.default).issuesDeployed, {
        issueCount: issueIds.length
    })))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $assJw.PopupOverflowSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $assJw.PopupKeyline), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $assJw.PopupOverflowButton), {
        component: (0, $c9uTK.Link),
        appearance: "link",
        // @ts-expect-error - TS2322 - Problem with `Button` types, in practice this gets forwarded to the `Link`
        prefetch: "hover",
        params: {
            projectKey: version.project.key
        },
        query: {
            startDate: '-3m',
            endDate: 'now',
            fixVersions: version.name
        },
        to: deploymentsRoute,
        onClick: (_, analyticsEvent)=>{
            (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'latestDeploymentInVersionDetailsTooltipLink');
        }
    }, formatMessage((0, $b09G4.default).viewAllDeployments))));
};
const $5f63d6fd87d8ee63$var$headerStatusIconAndLozengeStyles = (0, $1DXK0.xcss)({
    flex: 1,
    justifyContent: 'end',
    alignItems: 'center'
});
const $5f63d6fd87d8ee63$var$headerStatusIconStyles = (0, $1DXK0.xcss)({
    marginRight: 'space.100',
    justifyContent: 'center',
    alignItems: 'center'
});
const $5f63d6fd87d8ee63$var$environmentStyles = (0, $1DXK0.xcss)({
    marginBottom: 'space.100'
});
const $5f63d6fd87d8ee63$var$environmentDetailStyles = (0, $1DXK0.xcss)({
    height: '16px',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '16px',
    marginBottom: 'space.100',
    marginTop: 'space.0'
});
const $5f63d6fd87d8ee63$var$environmentDetailBetweenMarginStyles = (0, $1DXK0.xcss)({
    marginLeft: 'space.050'
});

});
parcelRegister("gS7F9", function(module, exports) {
$parcel$export(module.exports, "default", () => $a8f5f37a00e6cb4e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<10c719c98390f5498900124b91a968f6>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $a8f5f37a00e6cb4e$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "deploymentTooltipContent_softwareReleasesLaunchCard_deployment",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "state"
            },
            "action": "THROW",
            "path": "state"
        },
        {
            "kind": "RequiredField",
            "field": {
                "concreteType": "DevOpsEnvironment",
                "kind": "LinkedField",
                "name": "environment",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "displayName"
                    },
                    {
                        "kind": "RequiredField",
                        "field": {
                            "kind": "ScalarField",
                            "name": "category"
                        },
                        "action": "THROW",
                        "path": "environment.category"
                    }
                ]
            },
            "action": "THROW",
            "path": "environment"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "lastUpdated"
            },
            "action": "THROW",
            "path": "lastUpdated"
        },
        {
            "kind": "ScalarField",
            "name": "issueIds"
        }
    ],
    "type": "DeploymentSummary"
};
$a8f5f37a00e6cb4e$var$node.hash = "f474689f31fc91d3dfb760e1b811618d";
var $a8f5f37a00e6cb4e$export$2e2bcd8739ae039 = $a8f5f37a00e6cb4e$var$node;

});

parcelRegister("7qb5G", function(module, exports) {
$parcel$export(module.exports, "default", () => $ab476ee926fd7e0a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b2ef2fde713507dbf018acf99cdd24e5>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $ab476ee926fd7e0a$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "deploymentTooltipContent_softwareReleasesLaunchCard_jiraVersion",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "name"
            },
            "action": "THROW",
            "path": "name"
        },
        {
            "kind": "RequiredField",
            "field": {
                "concreteType": "JiraProject",
                "kind": "LinkedField",
                "name": "project",
                "plural": false,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "kind": "ScalarField",
                            "name": "key"
                        },
                        "action": "THROW",
                        "path": "project.key"
                    }
                ]
            },
            "action": "THROW",
            "path": "project"
        }
    ],
    "type": "JiraVersion"
};
$ab476ee926fd7e0a$var$node.hash = "fc05ee90d6c0521ade9b87e6185e0b92";
var $ab476ee926fd7e0a$export$2e2bcd8739ae039 = $ab476ee926fd7e0a$var$node;

});

parcelRegister("assJw", function(module, exports) {
$parcel$export(module.exports, "PopupContainer", () => $482a2cb72e2d23c6$export$cca08eed9de89ba9);
$parcel$export(module.exports, "LinkContainer", () => $482a2cb72e2d23c6$export$af2ec3aa21d10ab7);
$parcel$export(module.exports, "PopupHeader", () => $482a2cb72e2d23c6$export$b11ea9d6e8111404);
$parcel$export(module.exports, "StyledDate", () => $482a2cb72e2d23c6$export$30301703d55848e7);
$parcel$export(module.exports, "RepositoryInfo", () => $482a2cb72e2d23c6$export$fde5e3d077213a6f);
$parcel$export(module.exports, "PopupTitle", () => $482a2cb72e2d23c6$export$b834616c6081368f);
$parcel$export(module.exports, "StyledLink", () => $482a2cb72e2d23c6$export$9048d548939551ee);
$parcel$export(module.exports, "PopupOverflowSection", () => $482a2cb72e2d23c6$export$9e3158dc6a3a0f92);
$parcel$export(module.exports, "PopupKeyline", () => $482a2cb72e2d23c6$export$a0765d4427758c62);
$parcel$export(module.exports, "PopupOverflowButton", () => $482a2cb72e2d23c6$export$aeb11758c9d29e5c);
$parcel$export(module.exports, "TimeDisplay", () => $482a2cb72e2d23c6$export$9b3df3d60caed5f9);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $gYvT9 = parcelRequire("gYvT9");

var $goZPP = parcelRequire("goZPP");

var $806LH = parcelRequire("806LH");
const $482a2cb72e2d23c6$export$cca08eed9de89ba9 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi _1bsbnklw _1tkeys9h _vchhusvi",
            __cmplp.className
        ])
    });
});
const $482a2cb72e2d23c6$export$af2ec3aa21d10ab7 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _1bto1l2s _o5721q9c _otyr1b66",
            __cmplp.className
        ])
    });
});
const $482a2cb72e2d23c6$export$b11ea9d6e8111404 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _1bah1yb4 _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $482a2cb72e2d23c6$export$30301703d55848e7 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_syaz1rpy _otyridpf _1e0c1txw _o5724jg8",
            __cmplp.className
        ])
    });
});
const $482a2cb72e2d23c6$export$fde5e3d077213a6f = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _syaz1rpy _o5724jg8",
            __cmplp.className
        ])
    });
});
const $482a2cb72e2d23c6$export$80b51772092eddc0 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_syaz1rpy _1p1dangw _otyr1b66",
            __cmplp.className
        ])
    });
});
const $482a2cb72e2d23c6$export$b834616c6081368f = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $806LH.default), {
        size: "xxsmall",
        as: "div"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($482a2cb72e2d23c6$export$80b51772092eddc0, props));
const $482a2cb72e2d23c6$export$9048d548939551ee = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = (0, $gYvT9.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_11c81ixg _k48pmoej _syaz13af _otyru2gc",
            __cmplp.className
        ])
    });
});
const $482a2cb72e2d23c6$export$9e3158dc6a3a0f92 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19pkpxbi",
            __cmplp.className
        ])
    });
});
const $482a2cb72e2d23c6$export$a0765d4427758c62 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_4t3it94y _bfhk1l7x _otyrutpp",
            __cmplp.className
        ])
    });
});
const $482a2cb72e2d23c6$export$aeb11758c9d29e5c = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = (0, $goZPP.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1ytiidpf _7yhbidpf _1bdkidpf _24rcidpf _1yxxidpf _12r2i7a9",
            __cmplp.className
        ])
    });
});
const $482a2cb72e2d23c6$export$9b3df3d60caed5f9 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_18u01b66 _80omtlke",
            __cmplp.className
        ])
    });
});

});

parcelRegister("2ztQs", function(module, exports) {
$parcel$export(module.exports, "DeploymentIcons", () => $fe4b1c5b30af425c$export$5202eabf0ef214b4);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $8BPc2 = parcelRequire("8BPc2");

var $11Cqu = parcelRequire("11Cqu");

var $kJZp0 = parcelRequire("kJZp0");

var $jxHVa = parcelRequire("jxHVa");

var $4TzOM = parcelRequire("4TzOM");

var $dg5yR = parcelRequire("dg5yR");

var $duNah = parcelRequire("duNah");

var $jBmfi = parcelRequire("jBmfi");

var $f0KmE = parcelRequire("f0KmE");
const $fe4b1c5b30af425c$export$16b26cd5e98d9100 = (state)=>{
    switch(state){
        case (0, $jBmfi.DeploymentStateOptions).PENDING:
            return 0, $jxHVa.default;
        case (0, $jBmfi.DeploymentStateOptions).IN_PROGRESS:
            return 0, $kJZp0.default;
        case (0, $jBmfi.DeploymentStateOptions).SUCCESSFUL:
            return 0, $duNah.default;
        case (0, $jBmfi.DeploymentStateOptions).SUCCESSFULNONPRODUCTION:
            return 0, $dg5yR.default;
        case (0, $jBmfi.DeploymentStateOptions).CANCELLED:
            return 0, $8BPc2.default;
        case (0, $jBmfi.DeploymentStateOptions).FAILED:
            return 0, $11Cqu.default;
        case (0, $jBmfi.DeploymentStateOptions).ROLLED_BACK:
            return 0, $4TzOM.default;
        case (0, $jBmfi.DeploymentStateOptions).UNKNOWN:
            return 0, $f0KmE.default;
        default:
            throw Error(`Unhandled deployment state - ${state}`);
    }
};
const $fe4b1c5b30af425c$export$c7835fd8b8ca1d68 = {
    width: '20',
    height: '20',
    padding: '2'
};
const $fe4b1c5b30af425c$export$148e312beb132853 = {
    width: '16',
    height: '16',
    padding: '0'
};
const $fe4b1c5b30af425c$export$31b21d0167753bb4 = (state)=>{
    switch(state){
        case 'small':
            return $fe4b1c5b30af425c$export$148e312beb132853;
        case 'medium':
            return $fe4b1c5b30af425c$export$c7835fd8b8ca1d68;
        default:
            return $fe4b1c5b30af425c$export$148e312beb132853;
    }
};
const $fe4b1c5b30af425c$export$5202eabf0ef214b4 = ({ deploymentState: deploymentState, size: size })=>{
    const Icon = $fe4b1c5b30af425c$export$16b26cd5e98d9100(deploymentState);
    const iconSize = $fe4b1c5b30af425c$export$31b21d0167753bb4(size);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fe4b1c5b30af425c$var$Wrapper, {
        "data-testid": `software-deployments-icons-common.ui.wrapper-${deploymentState}`,
        width: iconSize.width,
        height: iconSize.height,
        padding: iconSize.padding
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Icon, null));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $fe4b1c5b30af425c$var$Wrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { padding: padding, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1gljcou": (0, $awdRS.default)(__cmplp.width, "px"),
            "--_8jvb0j": (0, $awdRS.default)(__cmplp.height, "px"),
            "--_fl6vf6": (0, $awdRS.default)(__cmplp.padding, "px")
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19pk1wug _2hwxidpf _otyr1wug _18u0idpf _1yt4gesh _1bsb1rkg _4t3i1474 _1e0c1txw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("8BPc2", function(module, exports) {
$parcel$export(module.exports, "default", () => $91900875bb235e62$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");
const $91900875bb235e62$var$cancelledIcon = "var(--ds-icon-warning, #E06C00)";
const $91900875bb235e62$var$backgroundColor = "var(--ds-icon-inverse, #FFFFFF)";
const $91900875bb235e62$var$CancelledIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "100%",
        height: "100%",
        fill: "none",
        viewBox: "0 0 16 16"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("circle", {
        r: "7",
        cx: "8",
        cy: "8",
        fill: $91900875bb235e62$var$backgroundColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M4.184 9h8V7h-8v2zm11.367-4.102a8.039 8.039 0 0 0-1.703-2.546A8.122 8.122 0 0 0 11.293.641 7.769 7.769 0 0 0 8.184 0a7.789 7.789 0 0 0-3.102.633 8.043 8.043 0 0 0-2.547 1.703A8.11 8.11 0 0 0 .824 4.891 7.747 7.747 0 0 0 .184 8c0 1.083.211 2.117.632 3.102.422.984.99 1.833 1.704 2.546a8.084 8.084 0 0 0 2.554 1.711 7.766 7.766 0 0 0 3.11.641 7.788 7.788 0 0 0 3.101-.633 8.043 8.043 0 0 0 2.547-1.703 8.133 8.133 0 0 0 1.711-2.555A7.765 7.765 0 0 0 16.184 8a7.796 7.796 0 0 0-.633-3.102z",
        fill: $91900875bb235e62$var$cancelledIcon,
        fillRule: "evenodd"
    }));
$91900875bb235e62$var$CancelledIcon.displayName = 'CancelledIcon';
var $91900875bb235e62$export$2e2bcd8739ae039 = $91900875bb235e62$var$CancelledIcon;

});

parcelRegister("11Cqu", function(module, exports) {
$parcel$export(module.exports, "default", () => $e481e8306bde5b04$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");
const $e481e8306bde5b04$var$failedColor = "var(--ds-icon-danger, #C9372C)";
const $e481e8306bde5b04$var$backgroundColor = "var(--ds-icon-inverse, #FFFFFF)";
const $e481e8306bde5b04$var$FailedIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "100%",
        height: "100%",
        fill: "none",
        viewBox: "0 0 16 16"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("circle", {
        r: "6",
        cx: "8",
        cy: "8",
        fill: $e481e8306bde5b04$var$backgroundColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        fill: $e481e8306bde5b04$var$failedColor,
        fillRule: "evenodd",
        d: "M.768 9.768a2.5 2.5 0 010-3.536L6.232.768a2.5 2.5 0 013.536 0l5.464 5.464a2.5 2.5 0 010 3.536l-5.464 5.464a2.5 2.5 0 01-3.536 0L.768 9.768zM7 4a1 1 0 112 0v4a1 1 0 01-2 0V4zm1 8a1 1 0 100-2 1 1 0 000 2z",
        clipRule: "evenodd"
    }));
$e481e8306bde5b04$var$FailedIcon.displayName = 'FailedIcon';
var $e481e8306bde5b04$export$2e2bcd8739ae039 = $e481e8306bde5b04$var$FailedIcon;

});

parcelRegister("kJZp0", function(module, exports) {
$parcel$export(module.exports, "default", () => $4b148fae506ba12e$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");
const $4b148fae506ba12e$var$inProgressColor = "var(--ds-icon-information, #357DE8)";
const $4b148fae506ba12e$var$backgroundColor = "var(--ds-icon-inverse, #FFFFFF)";
const $4b148fae506ba12e$var$InProgressIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($4b148fae506ba12e$var$SpinningSvg, {
        xmlns: "http://www.w3.org/2000/svg",
        width: "100%",
        height: "100%",
        fill: "none",
        viewBox: "0 0 16 16"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("circle", {
        r: "7",
        cx: "8",
        cy: "8",
        fill: $4b148fae506ba12e$var$backgroundColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        fill: $4b148fae506ba12e$var$inProgressColor,
        d: "M8 0a8 8 0 100 16A8 8 0 008 0zm0 12.444A4.445 4.445 0 013.556 8a.889.889 0 111.777 0A2.667 2.667 0 008 10.667a.888.888 0 110 1.777zm3.556-3.555a.889.889 0 01-.89-.889A2.667 2.667 0 008 5.333a.889.889 0 010-1.777A4.445 4.445 0 0112.444 8a.888.888 0 01-.888.889z"
    }));
$4b148fae506ba12e$var$InProgressIcon.displayName = 'InProgressIcon';
var $4b148fae506ba12e$export$2e2bcd8739ae039 = $4b148fae506ba12e$var$InProgressIcon;
const $4b148fae506ba12e$var$spin = null;
// 1.5s matches the same animation on bitbucket for builds
const $4b148fae506ba12e$var$spinAnimation = `${$4b148fae506ba12e$var$spin} 1.5s linear infinite`;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4b148fae506ba12e$var$SpinningSvg = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "svg", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1xz6pnn": (0, $awdRS.default)($4b148fae506ba12e$var$spinAnimation)
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_y44v1wf2",
            __cmplp.className
        ])
    });
});

});

parcelRegister("jxHVa", function(module, exports) {
$parcel$export(module.exports, "default", () => $fa74c7f7de84948d$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");
const $fa74c7f7de84948d$var$pendingColor = "var(--ds-icon-information, #357DE8)";
const $fa74c7f7de84948d$var$backgroundColor = "var(--ds-icon-inverse, #FFFFFF)";
const $fa74c7f7de84948d$var$PendingIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "100%",
        height: "100%",
        fill: "none",
        viewBox: "0 0 16 16"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("circle", {
        r: "7",
        cx: "8",
        cy: "8",
        fill: $fa74c7f7de84948d$var$backgroundColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        fill: $fa74c7f7de84948d$var$pendingColor,
        d: "M13.657 2.343A8 8 0 102.343 13.657 8 8 0 0013.657 2.343zm-2.308 9.006a1 1 0 01-1.389.024L7.294 8.707a.988.988 0 01-.217-.325l.002.007-.005-.013.003.006A.993.993 0 017 8V4a1 1 0 012 0v3.587l2.373 2.373a1 1 0 01-.024 1.389z"
    }));
$fa74c7f7de84948d$var$PendingIcon.displayName = 'PendingIcon';
var $fa74c7f7de84948d$export$2e2bcd8739ae039 = $fa74c7f7de84948d$var$PendingIcon;

});

parcelRegister("4TzOM", function(module, exports) {
$parcel$export(module.exports, "default", () => $486ffc0b2b0f8e3c$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");
const $486ffc0b2b0f8e3c$var$rolledBackColor = "var(--ds-icon-warning, #E06C00)";
const $486ffc0b2b0f8e3c$var$backgroundColor = "var(--ds-icon-inverse, #FFFFFF)";
const $486ffc0b2b0f8e3c$var$RolledBackIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "100%",
        height: "100%",
        fill: "none",
        viewBox: "0 0 16 16"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("circle", {
        r: "7",
        cx: "8",
        cy: "8",
        fill: $486ffc0b2b0f8e3c$var$backgroundColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        fill: $486ffc0b2b0f8e3c$var$rolledBackColor,
        fillRule: "evenodd",
        d: "M16 8A8 8 0 110 8a8 8 0 0116 0zM7.707 3.293a1 1 0 010 1.414L7.414 5H8.6C10.516 5 12 6.606 12 8.5S10.516 12 8.6 12H7a1 1 0 110-2h1.6c.735 0 1.4-.633 1.4-1.5S9.335 7 8.6 7H7.414l.293.293a1 1 0 01-1.414 1.414l-2-2a1 1 0 010-1.414l2-2a1 1 0 011.414 0z",
        clipRule: "evenodd"
    }));
$486ffc0b2b0f8e3c$var$RolledBackIcon.displayName = 'RolledBackIcon';
var $486ffc0b2b0f8e3c$export$2e2bcd8739ae039 = $486ffc0b2b0f8e3c$var$RolledBackIcon;

});

parcelRegister("dg5yR", function(module, exports) {
$parcel$export(module.exports, "default", () => $0fa8897174cd0a6d$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");
const $0fa8897174cd0a6d$var$successColor = "var(--ds-icon-success, #6A9A23)";
const $0fa8897174cd0a6d$var$backgroundColor = "var(--ds-icon-inverse, #FFFFFF)";
const $0fa8897174cd0a6d$var$SuccessNonProductionIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "100%",
        height: "100%",
        fill: "none",
        viewBox: "0 0 16 16"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("circle", {
        r: "7",
        cx: "8",
        cy: "8",
        fill: $0fa8897174cd0a6d$var$backgroundColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        fill: $0fa8897174cd0a6d$var$successColor,
        fillRule: "evenodd",
        d: "M14 8A6 6 0 112 8a6 6 0 0112 0zm2 0A8 8 0 110 8a8 8 0 0116 0zm-4.293-1.293a1 1 0 00-1.414-1.414L7 8.586 5.707 7.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z",
        clipRule: "evenodd"
    }));
$0fa8897174cd0a6d$var$SuccessNonProductionIcon.displayName = 'SuccessNonProductionIcon';
var $0fa8897174cd0a6d$export$2e2bcd8739ae039 = $0fa8897174cd0a6d$var$SuccessNonProductionIcon;

});

parcelRegister("duNah", function(module, exports) {
$parcel$export(module.exports, "default", () => $f3fa39a0fe6baa4a$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");
const $f3fa39a0fe6baa4a$var$successColor = "var(--ds-icon-success, #6A9A23)";
const $f3fa39a0fe6baa4a$var$backgroundColor = "var(--ds-icon-inverse, #FFFFFF)";
const $f3fa39a0fe6baa4a$var$SuccessProductionIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "100%",
        height: "100%",
        fill: "none",
        viewBox: "0 0 16 16"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("circle", {
        r: "7",
        cx: "8",
        cy: "8",
        fill: $f3fa39a0fe6baa4a$var$backgroundColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        fill: $f3fa39a0fe6baa4a$var$successColor,
        fillRule: "evenodd",
        d: "M8 16A8 8 0 108 0a8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L7 8.586 5.707 7.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z",
        clipRule: "evenodd"
    }));
$f3fa39a0fe6baa4a$var$SuccessProductionIcon.displayName = 'SuccessProductionIcon';
var $f3fa39a0fe6baa4a$export$2e2bcd8739ae039 = $f3fa39a0fe6baa4a$var$SuccessProductionIcon;

});

parcelRegister("jBmfi", function(module, exports) {
$parcel$export(module.exports, "DeploymentStateOptions", () => $408de98c27446daa$export$a761da6c19e008f6);
const $408de98c27446daa$var$PENDING = 'PENDING';
const $408de98c27446daa$var$IN_PROGRESS = 'IN_PROGRESS';
const $408de98c27446daa$var$SUCCESSFUL = 'SUCCESSFUL';
const $408de98c27446daa$var$SUCCESSFULNONPRODUCTION = 'SUCCESSFULNONPRODUCTION';
const $408de98c27446daa$var$CANCELLED = 'CANCELLED';
const $408de98c27446daa$var$FAILED = 'FAILED';
const $408de98c27446daa$var$ROLLED_BACK = 'ROLLED_BACK';
const $408de98c27446daa$var$UNKNOWN = 'UNKNOWN';
const $408de98c27446daa$export$a761da6c19e008f6 = {
    PENDING: $408de98c27446daa$var$PENDING,
    IN_PROGRESS: $408de98c27446daa$var$IN_PROGRESS,
    SUCCESSFUL: $408de98c27446daa$var$SUCCESSFUL,
    SUCCESSFULNONPRODUCTION: $408de98c27446daa$var$SUCCESSFULNONPRODUCTION,
    CANCELLED: $408de98c27446daa$var$CANCELLED,
    FAILED: $408de98c27446daa$var$FAILED,
    ROLLED_BACK: $408de98c27446daa$var$ROLLED_BACK,
    UNKNOWN: $408de98c27446daa$var$UNKNOWN
};

});

parcelRegister("f0KmE", function(module, exports) {
$parcel$export(module.exports, "default", () => $edc46ed8bf002358$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");
const $edc46ed8bf002358$var$unknownColor = "var(--ds-icon-success, #6A9A23)";
const $edc46ed8bf002358$var$backgroundColor = "var(--ds-icon-inverse, #FFFFFF)";
const $edc46ed8bf002358$export$c8e691818f5132e2 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "100%",
        height: "100%",
        fill: "none",
        viewBox: "0 0 16 16"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("circle", {
        cx: "8",
        cy: "8",
        r: "7",
        fill: $edc46ed8bf002358$var$backgroundColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("mask", {
        id: "a",
        fill: $edc46ed8bf002358$var$backgroundColor
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M15.4 4.9a8 8 0 0 0-1.7-2.5A8.1 8.1 0 0 0 11 .6 7.8 7.8 0 0 0 8 0a7.8 7.8 0 0 0-3.1.6 8 8 0 0 0-2.5 1.7A8.1 8.1 0 0 0 .6 5 7.7 7.7 0 0 0 0 8c0 1 .2 2.1.6 3.1a8 8 0 0 0 1.7 2.5A8.1 8.1 0 0 0 5 15.4 7.8 7.8 0 0 0 8 16a7.8 7.8 0 0 0 3.1-.6 8 8 0 0 0 2.5-1.7 8.2 8.2 0 0 0 1.8-2.6c.4-1 .6-2 .6-3.1a7.8 7.8 0 0 0-.6-3.1z",
        clipRule: "evenodd",
        fillRule: "evenodd"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        fill: $edc46ed8bf002358$var$unknownColor,
        d: "m11.1.6.8-1.8-.8 1.8zM5 .6l.8 1.9L4.9.6zM.6 5l1.9.8-1.9-.8zm0 6.2-1.8.8L.6 11zm1.7 2.5 1.5-1.4-1.5 1.4zM5 15.4l.8-1.9-.8 1.9zm6.2 0 .8 1.8-.8-1.8zm2.5-1.7 1.5 1.4-1.5-1.4zm1.8-2.6 1.8.8-1.8-.8zm1.8-7A10 10 0 0 0 15.1 1l-2.8 2.9a6 6 0 0 1 1.2 1.9L17.2 4zM15.1 1a10.1 10.1 0 0 0-3.2-2l-1.6 3.6a6.1 6.1 0 0 1 2 1.3L15 .9zm-3.2-2A9.8 9.8 0 0 0 8-2v4c.8 0 1.6.2 2.3.5L12-1.2zM8-2a9.8 9.8 0 0 0-3.9.8l1.6 3.7A5.8 5.8 0 0 1 8 2v-4zm-3.9.8A10 10 0 0 0 1 .9l2.9 2.9a6 6 0 0 1 1.9-1.3L4-1.2zM1 .9a10.1 10.1 0 0 0-2.1 3.2l3.7 1.6a6.1 6.1 0 0 1 1.3-2L.9 1zm-2 3.2A9.7 9.7 0 0 0-2 8h4c0-.8.2-1.6.5-2.3L-1.2 4zM-2 8c0 1.4.3 2.7.8 3.9l3.7-1.6A5.8 5.8 0 0 1 2 8h-4zm.8 3.9A10 10 0 0 0 .9 15l2.8-2.9a6 6 0 0 1-1.2-1.9L-1.2 12zM.9 15a10.1 10.1 0 0 0 3.2 2.1l1.6-3.7a6.1 6.1 0 0 1-2-1.3L1 15.1zm3.2 2.1A9.8 9.8 0 0 0 8 18v-4a5.8 5.8 0 0 1-2.3-.5L4 17.2zM8 18c1.4 0 2.7-.3 3.9-.8l-1.6-3.7c-.7.3-1.5.5-2.3.5v4zm3.9-.8a10 10 0 0 0 3.2-2.1l-2.9-2.9a6 6 0 0 1-1.9 1.3l1.6 3.7zm3.2-2.1c.9-1 1.6-2 2.1-3.2l-3.7-1.6a6.2 6.2 0 0 1-1.3 2l2.9 2.8zm2.1-3.2A9.8 9.8 0 0 0 18 8h-4c0 .8-.2 1.6-.5 2.3l3.7 1.6zM18 8c0-1.4-.3-2.7-.8-3.9l-3.7 1.6c.3.7.5 1.5.5 2.3h4z",
        mask: "url(#a)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        fill: $edc46ed8bf002358$var$unknownColor,
        d: "M5.4 6.4H7c0-.6.4-1 1-1s1 .4 1 1c0 .4-.2.7-.8 1-.8.5-1 1-1 1.9v.3h1.4v-.3c0-.5.2-.8 1-1.2.7-.5 1-1 1-1.8 0-1.3-1-2.1-2.5-2.1-1.6 0-2.6.9-2.6 2.2zM8 12.2c.6 0 1-.4 1-1 0-.5-.4-.8-1-.8s-1 .3-1 .9c0 .5.4.9 1 .9z"
    }));
$edc46ed8bf002358$export$c8e691818f5132e2.displayName = 'Unknown';
var $edc46ed8bf002358$export$2e2bcd8739ae039 = $edc46ed8bf002358$export$c8e691818f5132e2;

});


parcelRegister("b09G4", function(module, exports) {
$parcel$export(module.exports, "default", () => $a163907271077e35$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $a163907271077e35$var$messages = (0, $7qGN1.defineMessages)({
    deploymentPopupTitle: {
        "id": "software-releases-launch-card.latest-deployment.deployment-tooltip-content.deployment-popup-title",
        "defaultMessage": "Deployment"
    },
    viewAllDeployments: {
        "id": "software-releases-launch-card.latest-deployment.deployment-tooltip-content.view-all-deployments",
        "defaultMessage": "View all deployments"
    },
    issuesDeployed: {
        "id": "software-releases-launch-card.latest-deployment.deployment-tooltip-content.issues-deployed",
        "defaultMessage": "{issueCount} {issueCount, plural, one {issue} other {issues}} deployed"
    },
    issuesDeployedIssueTerminologyRefreshM4: {
        "id": "software-releases-launch-card.latest-deployment.deployment-tooltip-content.issues-deployed-issue-terminology-refresh-m4",
        "defaultMessage": "{issueCount} {issueCount, plural, one {work item} other {work items}} deployed"
    }
});
var $a163907271077e35$export$2e2bcd8739ae039 = $a163907271077e35$var$messages;

});

parcelRegister("5l7IC", function(module, exports) {
$parcel$export(module.exports, "capitalizeOnlyFirstLetter", () => $95668f9d0b19b6be$export$1f9f0c721cdd6cac);
$parcel$export(module.exports, "mapDeploymentState", () => $95668f9d0b19b6be$export$e46eedc73b6bf584);
$parcel$export(module.exports, "mapStateToLozengeProp", () => $95668f9d0b19b6be$export$bb72fc1de2630393);

var $3zbCo = parcelRequire("3zbCo");

var $6NDp7 = parcelRequire("6NDp7");

var $jBmfi = parcelRequire("jBmfi");
const $95668f9d0b19b6be$export$1f9f0c721cdd6cac = (str)=>(0, (/*@__PURE__*/$parcel$interopDefault($6NDp7)))((0, (/*@__PURE__*/$parcel$interopDefault($3zbCo)))(str));
const $95668f9d0b19b6be$export$e46eedc73b6bf584 = (state, environmentCategory)=>{
    switch(state){
        case 'IN_PROGRESS':
        case 'PENDING':
        case 'ROLLED_BACK':
        case 'CANCELLED':
        case 'FAILED':
            return state;
        case 'SUCCESSFUL':
            if (environmentCategory !== 'PRODUCTION') return (0, $jBmfi.DeploymentStateOptions).SUCCESSFULNONPRODUCTION;
            return state;
        default:
            return (0, $jBmfi.DeploymentStateOptions).UNKNOWN;
    }
};
const $95668f9d0b19b6be$export$bb72fc1de2630393 = (state)=>{
    switch(state){
        case 'IN_PROGRESS':
        case 'PENDING':
            return 'inprogress';
        case 'ROLLED_BACK':
        case 'CANCELLED':
            return 'moved';
        case 'FAILED':
            return 'removed';
        case 'SUCCESSFUL':
        default:
            return 'success';
    }
};

});
parcelRegister("3zbCo", function(module, exports) {

var $auNny = parcelRequire("auNny");
/**
 * Converts `string`, as space separated words, to lower case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the lower cased string.
 * @example
 *
 * _.lowerCase('--Foo-Bar--');
 * // => 'foo bar'
 *
 * _.lowerCase('fooBar');
 * // => 'foo bar'
 *
 * _.lowerCase('__FOO_BAR__');
 * // => 'foo bar'
 */ var $298da71a6a9c70d9$var$lowerCase = $auNny(function(result, word, index) {
    return result + (index ? ' ' : '') + word.toLowerCase();
});
module.exports = $298da71a6a9c70d9$var$lowerCase;

});



parcelRegister("4Tl6R", function(module, exports) {
$parcel$export(module.exports, "PulseIcon", () => $47afd03fcb583845$export$821b06bbcfc0bc3c);
/* PulseIcon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $fL0In = parcelRequire("fL0In");
const $47afd03fcb583845$export$f27fc5fc552d177d = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        width: 16,
        height: 16,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M2 8.70457H5.81067L7.7095 4L8.7403 12L10.5306 7.07724H14",
        stroke: "var(--ds-icon-subtle, #505258)",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }));
const $47afd03fcb583845$export$821b06bbcfc0bc3c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($47afd03fcb583845$export$be58b4326e23250f, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fL0In.default), {
        glyph: $47afd03fcb583845$export$f27fc5fc552d177d,
        size: "medium",
        label: ""
    }));
const $47afd03fcb583845$export$be58b4326e23250f = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});

});

parcelRegister("8KwqL", function(module, exports) {
$parcel$export(module.exports, "default", () => $28d9692fb33157fe$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $28d9692fb33157fe$var$messages = (0, $7qGN1.defineMessages)({
    noDeployments: {
        "id": "software-releases-launch-card.latest-deployment.no-deployments",
        "defaultMessage": "No deployments for the last week"
    },
    lastDeployment: {
        "id": "software-releases-launch-card.latest-deployment.last-deployment",
        "defaultMessage": "Last deployment: "
    },
    loading: {
        "id": "software-releases-launch-card.latest-deployment.loading",
        "defaultMessage": "Loading..."
    }
});
var $28d9692fb33157fe$export$2e2bcd8739ae039 = $28d9692fb33157fe$var$messages;

});

parcelRegister("47xQB", function(module, exports) {
$parcel$export(module.exports, "useLoadProvidersListQuery", () => $8b31d8f053c9c5ce$export$8544c7d4cd7544c3);
$parcel$export(module.exports, "ProvidersList", () => $8b31d8f053c9c5ce$export$82486456ea9f13cc);

var $GfMqp = parcelRequire("GfMqp");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $j4oe4 = parcelRequire("j4oe4");

var $806LH = parcelRequire("806LH");

var $3wl9L = parcelRequire("3wl9L");

var $7ep4S = parcelRequire("7ep4S");

var $cxKOj = parcelRequire("cxKOj");

var $4cTDP = parcelRequire("4cTDP");

var $lRq8t = parcelRequire("lRq8t");

var $2imLM = parcelRequire("2imLM");

var $8oKDI = parcelRequire("8oKDI");

var $cHtIB = parcelRequire("cHtIB");

var $iATGh = parcelRequire("iATGh");

var $71SM2 = parcelRequire("71SM2");

var $dFEvZ = parcelRequire("dFEvZ");
const $8b31d8f053c9c5ce$export$8544c7d4cd7544c3 = ()=>{
    const [queryReference, loadQuery] = (0, $j4oe4.useQueryLoader)((0, $GfMqp.default));
    const cloudId = (0, $cHtIB.useCloudId)();
    const loadProvidersListQuery = ()=>{
        if (queryReference == null) loadQuery({
            cloudId: (0, $8oKDI.createAri)({
                resourceOwner: 'jira',
                resourceType: 'site',
                resourceId: cloudId
            })
        });
    };
    return [
        queryReference,
        loadProvidersListQuery
    ];
};
const $8b31d8f053c9c5ce$export$6bc5a3de56260df3 = ({ queryReference: queryReference })=>{
    const { devOps: devOps } = (0, $j4oe4.usePreloadedQuery)((0, $GfMqp.default), queryReference);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { deploymentProviders: deploymentProviders } = devOps.providers;
    const renderProvidersConnectedMessage = ()=>{
        switch(deploymentProviders.length){
            case 1:
                return formatMessage((0, $71SM2.default).oneProviderIsConnected, {
                    providerName: deploymentProviders[0]?.name
                });
            case 2:
                return formatMessage((0, $71SM2.default).twoProvidersAreConnected);
            default:
                return formatMessage((0, $71SM2.default).threeOrMoreProvidersAreConnected);
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8b31d8f053c9c5ce$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8b31d8f053c9c5ce$var$ProviderList, null, deploymentProviders.filter(Boolean).slice(0, 3).map((provider)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8b31d8f053c9c5ce$var$LogoContainer, {
            key: provider.id
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dFEvZ.ProviderLogo), {
            provider: provider
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8b31d8f053c9c5ce$var$CheckIconContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3wl9L))), {
        spacing: "spacious",
        color: "var(--ds-icon-success, #6A9A23)",
        label: ""
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $806LH.default), {
        size: "xsmall"
    }, renderProvidersConnectedMessage()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8b31d8f053c9c5ce$var$DetailText, null, formatMessage((0, $cxKOj.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $71SM2.default).setUpDeploymentsDetailIssueTerminologyRefreshM4Galaxia : (0, $71SM2.default).setUpDeploymentsDetailIssueTerminologyRefreshM4)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8b31d8f053c9c5ce$var$LinkText, {
        href: (0, $iATGh.SUPPORT_DOCS_LINK_URL),
        target: "_blank"
    }, formatMessage((0, $4cTDP.fg)('jira-issue-terminology-update-m4') ? (0, $71SM2.default).supportLinkTextIssueTerminologyRefreshM4 : (0, $71SM2.default).supportLinkText)));
};
const $8b31d8f053c9c5ce$export$82486456ea9f13cc = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "providers-list-inner",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8b31d8f053c9c5ce$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7ep4S.default), null))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8b31d8f053c9c5ce$export$6bc5a3de56260df3, {
        queryReference: props.queryReference
    })); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8b31d8f053c9c5ce$var$Container = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _2lx21bp4 _4cvr1h6o _1bsb1lze _vchhusvi _ca0qxy5q _u5f3xy5q _n3tdxy5q _19bvxy5q _y3gn1h6o _syaz1rpy",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8b31d8f053c9c5ce$var$ProviderList = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "ul", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _2mzuglyw _otyrutpp _kqswh2mm",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8b31d8f053c9c5ce$var$LogoContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "li", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1o8l _79apxmi2",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8b31d8f053c9c5ce$var$DetailText = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_ca0qu2gc _u5f3idpf _n3td1ejb _19bvidpf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8b31d8f053c9c5ce$var$CheckIconContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "li", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rko1rr0 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1e0c1txw _4cvr1h6o _1bah1h6o _kqswstnw _1bsb1tcg _4t3i1tcg _bfhkvuon _154ir5cr _1xi2r5cr",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8b31d8f053c9c5ce$var$LinkText = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_syaz13af",
            __cmplp.className
        ])
    });
});

});
parcelRegister("GfMqp", function(module, exports) {
$parcel$export(module.exports, "default", () => $31136033cb496469$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<484fd7fef369b6ade30fe6cb89abc829>>
 * @relayHash efe9f1db11e6de328e9f1549d3bf2dda
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 615b7ed663144eb1919951d271557951faf2fdb21681d222dc88fedad6aa9908
const $31136033cb496469$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "cloudId"
        },
        {
            "kind": "Literal",
            "name": "providerTypes",
            "value": [
                "DEPLOYMENT"
            ]
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "providersListTooltipContentQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "DevOps",
                        "kind": "LinkedField",
                        "name": "devOps",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v1 /*: any*/ ,
                                    "concreteType": "DevOpsProviders",
                                    "kind": "LinkedField",
                                    "name": "providers",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "concreteType": "DevOpsDeploymentProvider",
                                                "kind": "LinkedField",
                                                "name": "deploymentProviders",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v2 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "devOps.providers.deploymentProviders.id"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v3 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "devOps.providers.deploymentProviders.name"
                                                    },
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "providerLogo_softwareReleasesLaunchCard"
                                                    }
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "devOps.providers.deploymentProviders"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "devOps.providers"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "devOps"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "providersListTooltipContentQuery",
            "selections": [
                {
                    "concreteType": "DevOps",
                    "kind": "LinkedField",
                    "name": "devOps",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "DevOpsProviders",
                            "kind": "LinkedField",
                            "name": "providers",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "DevOpsDeploymentProvider",
                                    "kind": "LinkedField",
                                    "name": "deploymentProviders",
                                    "plural": true,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "logoUrl"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "615b7ed663144eb1919951d271557951faf2fdb21681d222dc88fedad6aa9908",
            "metadata": {},
            "name": "providersListTooltipContentQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$31136033cb496469$var$node.hash = "2fb2dcefa503b43df945cc594382beab";
var $31136033cb496469$export$2e2bcd8739ae039 = $31136033cb496469$var$node;

});

parcelRegister("71SM2", function(module, exports) {
$parcel$export(module.exports, "default", () => $5949e0e034dbe48e$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $5949e0e034dbe48e$var$messages = (0, $7qGN1.defineMessages)({
    oneProviderIsConnected: {
        "id": "software-releases-launch-card.latest-deployment.providers-list-tooltip-content.one-provider-is-connected",
        "defaultMessage": "{providerName} is installed"
    },
    twoProvidersAreConnected: {
        "id": "software-releases-launch-card.latest-deployment.providers-list-tooltip-content.two-providers-are-connected",
        "defaultMessage": "2 deployment tools installed"
    },
    threeOrMoreProvidersAreConnected: {
        "id": "software-releases-launch-card.latest-deployment.providers-list-tooltip-content.three-or-more-providers-are-connected",
        "defaultMessage": "3+ deployment tools installed"
    },
    supportLinkText: {
        "id": "software-releases-launch-card.latest-deployment.providers-list-tooltip-content.support-link-text",
        "defaultMessage": "Learn how to link development work to issues"
    },
    setUpDeploymentsDetailIssueTerminologyRefreshM4: {
        "id": "software-releases-launch-card.latest-deployment.providers-list-tooltip-content.set-up-deployments-detail-issue-terminology-refresh-m4",
        "defaultMessage": "To track deployments in Jira, start linking your work to work items in this project."
    },
    setUpDeploymentsDetailIssueTerminologyRefreshM4Galaxia: {
        "id": "software-releases-launch-card.latest-deployment.providers-list-tooltip-content.set-up-deployments-detail-issue-terminology-refresh-m4-galaxia",
        "defaultMessage": "To track deployments in Jira, start linking your work to work items in this space."
    },
    supportLinkTextIssueTerminologyRefreshM4: {
        "id": "software-releases-launch-card.latest-deployment.providers-list-tooltip-content.support-link-text-issue-terminology-refresh-m4",
        "defaultMessage": "Learn how to link development work to work items"
    }
});
var $5949e0e034dbe48e$export$2e2bcd8739ae039 = $5949e0e034dbe48e$var$messages;

});

parcelRegister("dFEvZ", function(module, exports) {
$parcel$export(module.exports, "ProviderLogo", () => $e28339467b159cf9$export$a48c0a0510fd5b7a);

var $2Ub1q = parcelRequire("2Ub1q");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $j4oe4 = parcelRequire("j4oe4");

var $iP1IM = parcelRequire("iP1IM");
const $e28339467b159cf9$export$a48c0a0510fd5b7a = ({ provider: provider })=>{
    const { name: name, logoUrl: logoUrl } = (0, $j4oe4.useFragment)((0, $2Ub1q.default), provider);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e28339467b159cf9$export$e464f89b9068f431, {
        src: logoUrl ?? '',
        alt: name ?? '',
        title: name ?? '',
        onError: (e)=>{
            if (e.target instanceof HTMLImageElement) e.target.src = (0, (/*@__PURE__*/$parcel$interopDefault($iP1IM)));
        }
    });
};
const $e28339467b159cf9$export$e464f89b9068f431 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rko1rr0 _1bsbzwfg _4t3izwfg _ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvu2gc _16qsvjj6 _bfhku67f",
            __cmplp.className
        ])
    });
});

});
parcelRegister("2Ub1q", function(module, exports) {
$parcel$export(module.exports, "default", () => $e71e21331e049409$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7752b05a0a8bdae34a7f01febb9a6714>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $e71e21331e049409$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "providerLogo_softwareReleasesLaunchCard",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "kind": "ScalarField",
            "name": "logoUrl"
        }
    ],
    "type": "DevOpsDeploymentProvider"
};
$e71e21331e049409$var$node.hash = "a69ed29281953f2d0dd2061c60855b1f";
var $e71e21331e049409$export$2e2bcd8739ae039 = $e71e21331e049409$var$node;

});

parcelRegister("iP1IM", function(module, exports) {
module.exports = new URL("addon.840ab9ef.svg", import.meta.url).toString();

});




parcelRegister("eJ7OA", function(module, exports) {
$parcel$export(module.exports, "VersionContributorsSectionSkeleton", () => $aa5a4af87be3b077$export$9ffa065263e020b9);
$parcel$export(module.exports, "AsyncVersionContributors", () => $aa5a4af87be3b077$export$c80cf9cb5de0170f);

var $hOJkS = parcelRequire("hOJkS");

var $b0nGU = parcelRequire("b0nGU");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $j4oe4 = parcelRequire("j4oe4");

var $3cMgR = parcelRequire("3cMgR");

var $lRq8t = parcelRequire("lRq8t");

var $2imLM = parcelRequire("2imLM");

var $bQWwW = parcelRequire("bQWwW");

var $e49oQ = parcelRequire("e49oQ");

var $8qcAb = parcelRequire("8qcAb");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $aa5a4af87be3b077$var$LazyVersionContributors = (0, $bQWwW.lazy)(()=>(parcelRequire("diEfR")).then((module)=>module.VersionContributors), {
    moduleId: "./src/packages/releases/launch-card/src/ui/version-contributors/index.tsx"
});
const $aa5a4af87be3b077$export$9ffa065263e020b9 = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($aa5a4af87be3b077$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
        size: "UNSAFE_small",
        weight: "bold",
        color: "color.text.subtle",
        as: "p"
    }, formatMessage((0, $8qcAb.default).contributorsLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $e49oQ.ContributorsSkeleton), {
        contributorCount: 4
    }));
};
const $aa5a4af87be3b077$export$c80cf9cb5de0170f = ({ queryRef: queryRef })=>{
    const { jira: jira } = (0, $j4oe4.usePreloadedQuery)((0, $b0nGU.default), queryRef);
    const versionFrag = jira.version;
    const version = (0, $j4oe4.useFragment)((0, $hOJkS.default), versionFrag);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "version-contributors",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($aa5a4af87be3b077$export$9ffa065263e020b9, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($aa5a4af87be3b077$var$LazyVersionContributors, {
        jiraVersionContributors: version.contributors.edges.filter(Boolean)
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $aa5a4af87be3b077$var$Container = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_zulpu2gc _16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw _2lx21bp4 _1ul9ntd2",
            __cmplp.className
        ])
    });
});

});
parcelRegister("hOJkS", function(module, exports) {
$parcel$export(module.exports, "default", () => $d01a78874d57740d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<df1174cc15a058925e75406b6d0ec4e2>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $d01a78874d57740d$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "async_softwareReleasesLaunchCard_AsyncVersionContributors",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "concreteType": "JiraVersionContributorConnection",
                "kind": "LinkedField",
                "name": "contributors",
                "plural": false,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "concreteType": "JiraVersionContributorEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": "versionContributors_softwareReleasesLaunchCard"
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "contributors.edges"
                    }
                ]
            },
            "action": "THROW",
            "path": "contributors"
        }
    ],
    "type": "JiraVersion"
};
$d01a78874d57740d$var$node.hash = "1c2f7736ef0703bba0e1b3081509e3ee";
var $d01a78874d57740d$export$2e2bcd8739ae039 = $d01a78874d57740d$var$node;

});

parcelRegister("e49oQ", function(module, exports) {
$parcel$export(module.exports, "ContributorsSkeleton", () => $8ede51223616dee7$export$bd943a9e5a9521c);
/* ContributorsSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $8ede51223616dee7$export$bd943a9e5a9521c = ({ contributorCount: contributorCount })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8ede51223616dee7$var$Container, null, [
        ...Array(contributorCount)
    ].map((_, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8ede51223616dee7$var$SkeletonGroup, {
            key: i
        })));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8ede51223616dee7$var$Container = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "ul", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1p5aglyw _kqswh2mm",
            __cmplp.className
        ])
    });
});
const $8ede51223616dee7$var$SkeletonGroup = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "li", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rko1rr0 _189e1dm9 _1dqonqa1 _1h6du67f _1bsb1tcg _4t3i1tcg _bfhkizff _1e0c1o8l _79apxmi2",
            __cmplp.className
        ])
    });
});

});

parcelRegister("8qcAb", function(module, exports) {
$parcel$export(module.exports, "default", () => $d296ef5af818568d$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $d296ef5af818568d$var$messages = (0, $7qGN1.defineMessages)({
    contributorsLabel: {
        "id": "software-releases-launch-card.version-contributors.contributors-label",
        "defaultMessage": "Contributors"
    }
});
var $d296ef5af818568d$export$2e2bcd8739ae039 = $d296ef5af818568d$var$messages;

});

parcelRegister("diEfR", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("d4a7k").then(()=>parcelRequire('l2pGG'));

});


parcelRegister("6FPEi", function(module, exports) {
$parcel$export(module.exports, "VersionDates", () => $b69fe5e5c265eaff$export$2f6a5887195e56f4);

var $bGrG0 = parcelRequire("bGrG0");

var $jjSgL = parcelRequire("jjSgL");

var $box3j = parcelRequire("box3j");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $j4oe4 = parcelRequire("j4oe4");

var $cSXp8 = parcelRequire("cSXp8");

var $lRq8t = parcelRequire("lRq8t");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $e4t5W = parcelRequire("e4t5W");

var $bapaL = parcelRequire("bapaL");

var $arJwk = parcelRequire("arJwk");

var $3ZZ8H = parcelRequire("3ZZ8H");

var $bQYVq = parcelRequire("bQYVq");
const $b69fe5e5c265eaff$var$BAD_START_RELEASE_DATE_ORDER_ERROR = 'BAD_START_RELEASE_DATE_ORDER';
const $b69fe5e5c265eaff$var$useFormattedDates = (startDate, releaseDate)=>{
    const { formatMessage: formatMessage, formatDate: formatDate } = (0, $lRq8t.default)();
    return {
        formattedStartDate: startDate === null ? formatMessage((0, $bQYVq.default).startDateNotSet) : formatDate(new Date(startDate), {
            timeZone: (0, $e4t5W.VERSION_DATE_FORMAT_OPTION).timeZone,
            dateStyle: 'long'
        }),
        formattedReleaseDate: releaseDate === null ? formatMessage((0, $bQYVq.default).releaseDateNotSet) : formatDate(new Date(releaseDate), {
            timeZone: (0, $e4t5W.VERSION_DATE_FORMAT_OPTION).timeZone,
            dateStyle: 'long'
        })
    };
};
const $b69fe5e5c265eaff$export$2f6a5887195e56f4 = ({ jiraVersion: jiraVersion })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { showFlag: showFlag } = (0, $cSXp8.useFlagsService)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const version = (0, $j4oe4.useFragment)((0, $box3j.default), jiraVersion); // eslint-disable-next-line jira/graphql/restrict-graphql-in-unnamed-files
    const [updateVersionStartDate] = (0, $j4oe4.useMutation)((0, $jjSgL.default));
    // eslint-disable-next-line jira/graphql/restrict-graphql-in-unnamed-files
    const [updateVersionReleaseDate] = (0, $j4oe4.useMutation)((0, $bGrG0.default));
    const handleStartDateMutationError = (data)=>{
        const flagText = {
            title: (0, $bQYVq.default).startDateGenericErrorFlagTitle,
            description: (0, $bQYVq.default).genericErrorFlagDescription
        };
        if (data.jira?.updateVersionStartDate?.errors) {
            const { extensions: extensions } = data.jira.updateVersionStartDate.errors[0];
            if (extensions?.errorType === $b69fe5e5c265eaff$var$BAD_START_RELEASE_DATE_ORDER_ERROR) {
                flagText.title = (0, $bQYVq.default).badReleaseStartDateOrderErrorFlagTitle;
                flagText.description = (0, $bQYVq.default).badReleaseStartDateOrderErrorFlagDescription;
            }
        }
        showFlag({
            type: 'warning',
            ...flagText,
            messageId: 'software-releases-launch-card.ui.version-dates.show-flag.warning.handle-start-date-mutation-error.show-flag.warning',
            messageType: 'transactional'
        });
    };
    const handleStartDateChange = (startDate)=>{
        updateVersionStartDate({
            variables: {
                input: {
                    id: version.id,
                    startDate: startDate
                }
            },
            onCompleted: (data)=>{
                if (!data.jira?.updateVersionStartDate?.success) handleStartDateMutationError(data);
                else (0, $kRgKj.fireTrackAnalytics)(createAnalyticsEvent({
                    action: 'updated',
                    actionSubject: 'versionStartDate'
                }), 'versionStartDate updated');
            },
            onError: ()=>{
                (0, $bapaL.fireFieldUpdateErrorAnalytics)();
                showFlag({
                    type: 'error',
                    title: (0, $bQYVq.default).startDateGenericErrorFlagTitle,
                    description: (0, $bQYVq.default).genericErrorFlagDescription,
                    messageId: 'software-releases-launch-card.ui.version-dates.show-flag.error.on-error.show-flag.error',
                    messageType: 'transactional'
                });
            },
            optimisticResponse: {
                jira: {
                    updateVersionStartDate: {
                        success: true,
                        errors: [],
                        version: {
                            id: version.id,
                            startDate: startDate
                        }
                    }
                }
            }
        });
    };
    const handleReleaseDateChange = (releaseDate)=>{
        updateVersionReleaseDate({
            variables: {
                input: {
                    id: version.id,
                    releaseDate: releaseDate
                }
            },
            onCompleted: (data)=>{
                if (!data.jira?.updateVersionReleaseDate?.success) showFlag({
                    type: 'warning',
                    title: (0, $bQYVq.default).releaseDateErrorFlagTitle,
                    description: (0, $bQYVq.default).genericErrorFlagDescription,
                    messageId: 'software-releases-launch-card.ui.version-dates.show-flag.warning.on-completed.show-flag.warning',
                    messageType: 'transactional'
                });
                else (0, $kRgKj.fireTrackAnalytics)(createAnalyticsEvent({
                    action: 'updated',
                    actionSubject: 'versionReleaseDate'
                }), 'versionReleaseDate updated');
            },
            onError: ()=>{
                (0, $bapaL.fireFieldUpdateErrorAnalytics)();
                showFlag({
                    type: 'error',
                    title: (0, $bQYVq.default).releaseDateErrorFlagTitle,
                    description: (0, $bQYVq.default).genericErrorFlagDescription,
                    messageId: 'software-releases-launch-card.ui.version-dates.show-flag.error.on-error.show-flag.error.1',
                    messageType: 'transactional'
                });
            },
            optimisticResponse: {
                jira: {
                    updateVersionReleaseDate: {
                        success: true,
                        version: {
                            id: version.id,
                            releaseDate: releaseDate
                        }
                    }
                }
            }
        });
    };
    const { formattedStartDate: formattedStartDate, formattedReleaseDate: formattedReleaseDate } = $b69fe5e5c265eaff$var$useFormattedDates(// @ts-expect-error - Argument of type 'string | null | undefined' is not assignable to parameter of type 'string | null'.
    version.startDate, version.releaseDate);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b69fe5e5c265eaff$var$DateContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $arJwk.AsyncEditableDatePicker), {
        analyticsEventName: "versionStartDate" // @ts-expect-error - Type 'boolean | null | undefined' is not assignable to type 'boolean | null'.
        ,
        canEdit: version.canEdit,
        currentDate: version.startDate,
        displayDate: formattedStartDate,
        label: formatMessage((0, $bQYVq.default).startDateFieldLabel),
        maxDate: (0, $3ZZ8H.convertDatetimeToDate)(version.releaseDate),
        onUpdateDate: handleStartDateChange,
        testId: "software-releases-launch-card.ui.version-dates.start-date-editable-date-picker"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $arJwk.AsyncEditableDatePicker), {
        analyticsEventName: "versionReleaseDate" // @ts-expect-error - Type 'boolean | null | undefined' is not assignable to type 'boolean | null'.
        ,
        canEdit: version.canEdit,
        currentDate: version.releaseDate,
        displayDate: formattedReleaseDate,
        label: formatMessage((0, $bQYVq.default).releaseDateFieldLabel),
        minDate: (0, $3ZZ8H.convertDatetimeToDate)(version.startDate),
        onUpdateDate: handleReleaseDateChange,
        testId: "software-releases-launch-card.ui.version-dates.release-date-editable-date-picker"
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b69fe5e5c265eaff$var$DateContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_zulpu2gc _1e0c1txw _1bah1yb4",
            __cmplp.className
        ])
    });
});

});
parcelRegister("bGrG0", function(module, exports) {
$parcel$export(module.exports, "default", () => $b0f1d9ce1fd77536$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<8537225dbdb3f656ce85fc0d4ec98947>>
 * @relayHash 76fcdda26d5cebfbc0bdbfc7500aaba8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 77cad9e713773fc9731f7546654bb6829a888de63c65c65ad0484a7d7526abb5
const $b0f1d9ce1fd77536$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "kind": "ScalarField",
        "name": "releaseDate"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "versionDates_updateVersionReleaseDateMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraUpdateVersionPayload",
                            "kind": "LinkedField",
                            "name": "updateVersionReleaseDate",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "concreteType": "JiraVersion",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "versionDates_updateVersionReleaseDateMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraUpdateVersionPayload",
                            "kind": "LinkedField",
                            "name": "updateVersionReleaseDate",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "concreteType": "JiraVersion",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "77cad9e713773fc9731f7546654bb6829a888de63c65c65ad0484a7d7526abb5",
            "metadata": {},
            "name": "versionDates_updateVersionReleaseDateMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$b0f1d9ce1fd77536$var$node.hash = "0404a02cdc80d06adbaaf61ada39552b";
var $b0f1d9ce1fd77536$export$2e2bcd8739ae039 = $b0f1d9ce1fd77536$var$node;

});

parcelRegister("jjSgL", function(module, exports) {
$parcel$export(module.exports, "default", () => $26e5a35c054d9ff1$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<dc667416605c45f4e9fb29c8594b350e>>
 * @relayHash 0f9f8a79d54b7bf69bd4ddc3c65a57b2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3c21a1f19ee00080fdbd0fc4853475b9e944bd3f18e9b98d9d5314b5ca267906
const $26e5a35c054d9ff1$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v4 = {
        "kind": "ScalarField",
        "name": "errorType"
    }, v5 = {
        "kind": "ScalarField",
        "name": "startDate"
    }, v6 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "versionDates_updateVersionStartDateMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraUpdateVersionPayload",
                            "kind": "LinkedField",
                            "name": "updateVersionStartDate",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                v3 /*: any*/ ,
                                                v4 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "JiraVersion",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "versionDates_updateVersionStartDateMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraUpdateVersionPayload",
                            "kind": "LinkedField",
                            "name": "updateVersionStartDate",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v3 /*: any*/ ,
                                                v4 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v6 /*: any*/ 
                                                    ],
                                                    "type": "BulkMutationErrorExtension"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "JiraVersion",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "3c21a1f19ee00080fdbd0fc4853475b9e944bd3f18e9b98d9d5314b5ca267906",
            "metadata": {},
            "name": "versionDates_updateVersionStartDateMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$26e5a35c054d9ff1$var$node.hash = "9222866e01fe4d9b93a39fe2c827a3b0";
var $26e5a35c054d9ff1$export$2e2bcd8739ae039 = $26e5a35c054d9ff1$var$node;

});

parcelRegister("box3j", function(module, exports) {
$parcel$export(module.exports, "default", () => $9aae079858de65ef$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a7c6c5dbd8eb08f103adecc53342a48c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $9aae079858de65ef$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "versionDates_softwareReleasesLaunchCard",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "canEdit"
        },
        {
            "kind": "ScalarField",
            "name": "startDate"
        },
        {
            "kind": "ScalarField",
            "name": "releaseDate"
        }
    ],
    "type": "JiraVersion"
};
$9aae079858de65ef$var$node.hash = "4dcf74d53cdeafe5bdc663fa3f4c36e4";
var $9aae079858de65ef$export$2e2bcd8739ae039 = $9aae079858de65ef$var$node;

});

parcelRegister("bapaL", function(module, exports) {
$parcel$export(module.exports, "fireFieldUpdateErrorAnalytics", () => $d6f03f0ee7b9f5f9$export$f84dee30e0e69629);

var $9pTd3 = parcelRequire("9pTd3");
const $d6f03f0ee7b9f5f9$export$f84dee30e0e69629 = ()=>{
    (0, $9pTd3.fireErrorAnalytics)({
        meta: {
            id: 'jira.releases.launch.card.update.version.field.mutation.error.id',
            packageName: 'jiraSoftwareReleasesLaunchCard',
            teamName: 'jolt'
        },
        error: Error('Unable to update version'),
        sendToPrivacyUnsafeSplunk: true
    });
};

});

parcelRegister("arJwk", function(module, exports) {
$parcel$export(module.exports, "AsyncEditableDatePicker", () => $3c30f903a2d75c61$export$e5d82c99aef790b1);
/* async.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $cDJ0f = parcelRequire("cDJ0f");

var $2imLM = parcelRequire("2imLM");

var $bQWwW = parcelRequire("bQWwW");

var $2WeRR = parcelRequire("2WeRR");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $3c30f903a2d75c61$var$LazyEditableDatePicker = (0, $bQWwW.lazy)(()=>(parcelRequire("bRtIa")).then((module)=>module.EditableDatePicker), {
    moduleId: "./src/packages/releases/launch-card/src/ui/version-dates/editable-date-picker/EditableDatePicker.tsx"
});
const $3c30f903a2d75c61$export$e5d82c99aef790b1 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "editable-date-picker",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3c30f903a2d75c61$export$66b8cea0c448285, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cDJ0f.Label), {
            htmlFor: "version-details-editable-date-picker"
        }, props.label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3c30f903a2d75c61$var$InlineEditReadViewContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2WeRR.DatePickerReadView), {
            displayDate: props.displayDate
        })))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3c30f903a2d75c61$var$LazyEditableDatePicker, props));
const $3c30f903a2d75c61$export$66b8cea0c448285 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1ul91lit _otyru2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $3c30f903a2d75c61$var$InlineEditReadViewContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_189e1dm9 _1dqonqa1 _1h6d3acm _vwz4kb7n",
            __cmplp.className
        ])
    });
});

});
parcelRegister("2WeRR", function(module, exports) {
$parcel$export(module.exports, "DatePickerReadView", () => $7677a6703ffdcd60$export$e9b589e36300c388);
/* DatePickerReadView.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $7677a6703ffdcd60$export$e9b589e36300c388 = ({ displayDate: displayDate, testId: testId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($7677a6703ffdcd60$var$ReadViewContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($7677a6703ffdcd60$var$ReadViewItem, {
        "data-testid": testId
    }, displayDate));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7677a6703ffdcd60$var$ReadViewContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _2lx21bp4 _1ul91qr7 _ca0qu2gc _u5f3idpf _n3tdu2gc _19bvidpf",
            __cmplp.className
        ])
    });
});
const $7677a6703ffdcd60$var$ReadViewItem = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_u5f31b66",
            __cmplp.className
        ])
    });
});

});

parcelRegister("bRtIa", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("fmJlE").then(()=>parcelRequire('ccSvD'));

});


parcelRegister("3ZZ8H", function(module, exports) {
$parcel$export(module.exports, "convertDatetimeToDate", () => $a355c188fcb5beb0$export$f2eb3c0da1d3f89e);

var $57raR = parcelRequire("57raR");
var $dBLX0 = parcelRequire("dBLX0");
const $a355c188fcb5beb0$export$f2eb3c0da1d3f89e = (startDate)=>startDate != null && (0, $dBLX0.default)(new Date(startDate)) ? (0, $57raR.default)(new Date(startDate), 'yyyy-MM-dd') : '';

});

parcelRegister("bQYVq", function(module, exports) {
$parcel$export(module.exports, "default", () => $ee6478813e16871a$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $ee6478813e16871a$var$messages = (0, $7qGN1.defineMessages)({
    startDateNotSet: {
        "id": "software-releases-launch-card.version-dates.start-date-not-set",
        "defaultMessage": "Start date not set"
    },
    releaseDateNotSet: {
        "id": "software-releases-launch-card.version-dates.release-date-not-set",
        "defaultMessage": "Release date not set"
    },
    startDateFieldLabel: {
        "id": "software-releases-launch-card.version-dates.start-date-field-label",
        "defaultMessage": "Start date"
    },
    startDateGenericErrorFlagTitle: {
        "id": "software-releases-launch-card.version-dates.start-date-generic-error-flag-title",
        "defaultMessage": "We couldn't update the start date"
    },
    badReleaseStartDateOrderErrorFlagTitle: {
        "id": "software-releases-launch-card.version-dates.bad-release-start-date-order-error-flag-title",
        "defaultMessage": "The start date cannot be after the release date"
    },
    badReleaseStartDateOrderErrorFlagDescription: {
        "id": "software-releases-launch-card.version-dates.bad-release-start-date-order-error-flag-description",
        "defaultMessage": "Please select a different start date."
    },
    releaseDateFieldLabel: {
        "id": "software-releases-launch-card.version-dates.release-date-field-label",
        "defaultMessage": "Release date"
    },
    releaseDateErrorFlagTitle: {
        "id": "software-releases-launch-card.version-dates.release-date-error-flag-title",
        "defaultMessage": "We couldn't update the release date"
    },
    genericErrorFlagDescription: {
        "id": "software-releases-launch-card.version-dates.generic-error-flag-description",
        "defaultMessage": "Something went wrong. Please try again or contact your administrator if the problem persists."
    }
});
var $ee6478813e16871a$export$2e2bcd8739ae039 = $ee6478813e16871a$var$messages;

});


parcelRegister("e1cyj", function(module, exports) {
$parcel$export(module.exports, "AsyncVersionStatus", () => $c133dc39d9775869$export$f6bcf9d2a3221dfb);

var $ePzAf = parcelRequire("ePzAf");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $j4oe4 = parcelRequire("j4oe4");

var $goZPP = parcelRequire("goZPP");

var $2imLM = parcelRequire("2imLM");

var $bQWwW = parcelRequire("bQWwW");

var $kfKi1 = parcelRequire("kfKi1");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $c133dc39d9775869$var$LazyVersionStatus = (0, $bQWwW.lazy)(()=>Promise.resolve((parcelRequire("kfKi1"))).then((module)=>module.VersionStatus), {
    moduleId: "./src/packages/releases/launch-card/src/ui/version-status/index.tsx"
});
const $c133dc39d9775869$export$f6bcf9d2a3221dfb = ({ jiraVersion: jiraVersion })=>{
    const version = (0, $j4oe4.useFragment)((0, $ePzAf.default), jiraVersion);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "version-status",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c133dc39d9775869$var$SkeletonContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), null, (0, $kfKi1.GetCurrentStatusLabel)(version.status)))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c133dc39d9775869$var$LazyVersionStatus, {
        jiraVersion: version
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c133dc39d9775869$var$SkeletonContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _1bsb1osq _4t3i1ylp",
            __cmplp.className
        ])
    });
});

});
parcelRegister("ePzAf", function(module, exports) {
$parcel$export(module.exports, "default", () => $ca2d9df743bdf912$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5ef6fed889609df73bcc4587dc5f0110>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $ca2d9df743bdf912$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "async_softwareReleasesLaunchCard_AsyncVersionStatus",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "status"
            },
            "action": "THROW",
            "path": "status"
        },
        {
            "kind": "FragmentSpread",
            "name": "versionStatus_softwareReleasesLaunchCard"
        }
    ],
    "type": "JiraVersion"
};
$ca2d9df743bdf912$var$node.hash = "bbfb4743758d7a0f5d5885118b67b179";
var $ca2d9df743bdf912$export$2e2bcd8739ae039 = $ca2d9df743bdf912$var$node;

});

parcelRegister("kfKi1", function(module, exports) {
$parcel$export(module.exports, "GetCurrentStatusLabel", () => $d4553222fff33491$export$3e6be0c31593f3c4);
$parcel$export(module.exports, "VersionStatus", () => $d4553222fff33491$export$8c6e0f93bfb5c6a4);

var $95TBp = parcelRequire("95TBp");

var $h3WMA = parcelRequire("h3WMA");

var $lQ64b = parcelRequire("lQ64b");

var $c7LiM = parcelRequire("c7LiM");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $12DRg = parcelRequire("12DRg");

var $j4oe4 = parcelRequire("j4oe4");

var $1OQKp = parcelRequire("1OQKp");

var $cA0Y2 = parcelRequire("cA0Y2");

var $lwpci = parcelRequire("lwpci");

var $956it = parcelRequire("956it");

var $6XEne = parcelRequire("6XEne");
var $sl8jM = parcelRequire("sl8jM");

var $9pTd3 = parcelRequire("9pTd3");

var $cSXp8 = parcelRequire("cSXp8");

var $lRq8t = parcelRequire("lRq8t");

var $2imLM = parcelRequire("2imLM");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $jom8W = parcelRequire("jom8W");

var $e8cgA = parcelRequire("e8cgA");

var $8tQys = parcelRequire("8tQys");

var $1M2hR = parcelRequire("1M2hR");

var $8sQb9 = parcelRequire("8sQb9");

var $gVv7l = parcelRequire("gVv7l");

var $iATGh = parcelRequire("iATGh");

var $30pmy = parcelRequire("30pmy");

var $hmF8e = parcelRequire("hmF8e");
const $d4553222fff33491$var$overrideComponents = {
    Option: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6XEne.components).Option, {
            ...props,
            className: (0, $hcewu.default)([
                "_1695idpf _1pnsidpf _vktqidpf _1byqidpf"
            ])
        })
};
const $d4553222fff33491$var$CustomOptionLabel = ({ label: label, value: value })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d4553222fff33491$var$VersionStatusOptionLabel, {
        isArchiveOption: value === (0, $iATGh.ARCHIVED)
    }, label);
const $d4553222fff33491$export$3e6be0c31593f3c4 = (currentStatusValue)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    switch(currentStatusValue){
        case 0, $iATGh.ARCHIVED:
            return formatMessage((0, $hmF8e.default).archivedLabel);
        case 0, $iATGh.RELEASED:
            return formatMessage((0, $hmF8e.default).releasedLabel);
        case 0, $iATGh.UNRELEASED:
            return formatMessage((0, $hmF8e.default).unreleasedLabel);
        default:
            return formatMessage((0, $hmF8e.default).unreleasedLabel);
    }
};
const $d4553222fff33491$var$getHasReleaseNote = async (versionId, environment)=>{
    try {
        const data = await (0, $j4oe4.fetchQuery)(environment, (0, $c7LiM.default), {
            versionId: versionId
        }).toPromise();
        return data?.jira?.version?.hasReleaseNote ?? false;
    } catch (error) {
        (0, $9pTd3.fireErrorAnalytics)({
            meta: {
                id: 'jiraLaunchCardHasReleaseNoteQuery',
                packageName: 'jiraVersionLaunchCard',
                teamName: 'jolt'
            },
            error: new Error('Unable to get "hasReleaseNote" for "release version" modal')
        });
        return false;
    }
};
const $d4553222fff33491$var$useHasReleaseNote = (versionId, shouldLoadHasReleaseNote)=>{
    const [hasReleaseNote, setHasReleaseNote] = (0, $eJOHy.useState)(null);
    const environment = (0, $j4oe4.useRelayEnvironment)();
    (0, $eJOHy.useEffect)(()=>{
        if (shouldLoadHasReleaseNote) $d4553222fff33491$var$getHasReleaseNote(versionId, environment).then(setHasReleaseNote);
    }, [
        versionId,
        environment,
        shouldLoadHasReleaseNote
    ]);
    return hasReleaseNote;
};
const $d4553222fff33491$export$8c6e0f93bfb5c6a4 = ({ jiraVersion: jiraVersion })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [isReleasedModalOpen, setIsReleaseModalOpen] = (0, $eJOHy.useState)(false);
    const { refetch: refetch, isLoading: isRefetchLoading } = (0, $8tQys.useRefetchContext)();
    const locale = (0, $1M2hR.useLocale)();
    const { showFlag: showFlag } = (0, $cSXp8.useFlagsService)();
    const [selectWidth, setSelectWidth] = (0, $eJOHy.useState)(undefined); // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const selectRef = (0, $eJOHy.useRef)();
    const [isReleaseNotesModalOpen, setIsReleaseNotesModalOpen] = (0, $eJOHy.useState)(false);
    (0, $eJOHy.useEffect)(()=>{
        if (selectRef.current) // eslint-disable-next-line react-you-might-not-need-an-effect/no-initialize-state
        setSelectWidth(selectRef.current.offsetWidth);
    }, []);
    const version = (0, $j4oe4.useFragment)((0, $lQ64b.default), jiraVersion);
    const hasReleaseNote = $d4553222fff33491$var$useHasReleaseNote(version.id, !(0, $jom8W.isDevopsFeatureDisabledInFedRamp)());
    const isVersionReleased = version.status === (0, $iATGh.RELEASED); // eslint-disable-next-line jira/graphql/restrict-graphql-in-unnamed-files
    const [updateVersionReleased] = (0, $j4oe4.useMutation)((0, $h3WMA.default));
    const [updateVersionArchived, isUpdateArchivedLoading] = // eslint-disable-next-line jira/graphql/restrict-graphql-in-unnamed-files
    (0, $j4oe4.useMutation)((0, $95TBp.default));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const [releaseNotesQueryReference, loadReleaseNotesQuery] = (0, $j4oe4.useQueryLoader)((0, $gVv7l.default));
    const loadReleaseNoteModalResource = ()=>{
        loadReleaseNotesQuery({
            versionAri: version.id
        }, {
            fetchPolicy: 'store-and-network'
        });
    };
    const isLoading = isUpdateArchivedLoading || isRefetchLoading;
    const releaseOptions = [
        {
            label: formatMessage((0, $hmF8e.default).releaseOptionLabel),
            value: (0, $iATGh.RELEASED)
        },
        {
            label: formatMessage((0, $hmF8e.default).unreleaseOptionLabel),
            value: (0, $iATGh.UNRELEASED)
        },
        {
            label: formatMessage((0, $hmF8e.default).archiveOptionLabel),
            value: (0, $iATGh.ARCHIVED)
        }
    ];
    const archiveOptions = [
        {
            label: formatMessage((0, $hmF8e.default).unarchiveOptionLabel),
            value: (0, $iATGh.UNARCHIVED)
        }
    ];
    const currentOptions = version.status === (0, $iATGh.ARCHIVED) ? archiveOptions : releaseOptions;
    const getCurrentValue = (currentStatusValue)=>[
            ...releaseOptions,
            ...archiveOptions
        ].find((option)=>option.value === currentStatusValue);
    const handleChange = (option)=>{
        if (option === null) return;
        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({
            action: 'selected',
            actionSubject: 'option'
        }), option.value);
        switch(option.value){
            case 0, $iATGh.RELEASED:
                setIsReleaseModalOpen(true);
                if (!(0, $jom8W.isDevopsFeatureDisabledInFedRamp)()) loadReleaseNoteModalResource();
                break;
            case 0, $iATGh.UNRELEASED:
                updateVersionReleased({
                    variables: {
                        input: {
                            id: version.id,
                            isReleased: false
                        }
                    },
                    onError: ()=>{
                        (0, $9pTd3.fireErrorAnalytics)({
                            meta: {
                                id: 'jira.releases.launch.card.update.released.mutation.error.id',
                                packageName: 'jiraSoftwareReleasesLaunchCard',
                                teamName: 'jolt'
                            },
                            error: new Error('Unable to update version released status'),
                            sendToPrivacyUnsafeSplunk: true
                        });
                        showFlag({
                            type: 'error',
                            title: (0, $hmF8e.default).genericUpdateFailedFlagTitle,
                            description: (0, $hmF8e.default).releaseFailedFlagDescription,
                            messageId: 'software-releases-launch-card.ui.version-status.show-flag.error.unreleased.on-error.show-flag.error',
                            messageType: 'transactional'
                        });
                    },
                    optimisticResponse: {
                        jira: {
                            updateVersionReleasedStatus: {
                                success: true,
                                version: {
                                    id: version.id,
                                    status: option.value
                                }
                            }
                        }
                    }
                });
                break;
            case 0, $iATGh.ARCHIVED:
            case 0, $iATGh.UNARCHIVED:
                updateVersionArchived({
                    variables: {
                        input: {
                            id: version.id,
                            isArchived: option.value === (0, $iATGh.ARCHIVED)
                        }
                    },
                    onError: ()=>{
                        (0, $9pTd3.fireErrorAnalytics)({
                            meta: {
                                id: 'jira.releases.launch.card.update.archived.mutation.error.id',
                                packageName: 'jiraSoftwareReleasesLaunchCard',
                                teamName: 'jolt'
                            },
                            error: new Error('Unable to update version archived status'),
                            sendToPrivacyUnsafeSplunk: true
                        });
                        showFlag({
                            type: 'error',
                            title: (0, $hmF8e.default).genericUpdateFailedFlagTitle,
                            description: (0, $hmF8e.default).archiveFailedFlagDescription,
                            messageId: 'software-releases-launch-card.ui.version-status.show-flag.error.unarchived.on-errorshow-flag.error',
                            messageType: 'transactional'
                        });
                    }
                });
                break;
            default:
                break;
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d4553222fff33491$var$Container, {
        ref: selectRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $sl8jM.default), {
        hideSelectedOptions: true,
        components: $d4553222fff33491$var$overrideComponents,
        formatOptionLabel: $d4553222fff33491$var$CustomOptionLabel,
        minMenuWidth: `${selectWidth}px`,
        onChange: handleChange,
        options: currentOptions,
        target: ({ isOpen: isOpen, ref: ref, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d4553222fff33491$var$StyledLoadingButton, {
                ...triggerProps,
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1OQKp))), {
                    spacing: "spacious",
                    label: formatMessage((0, $hmF8e.default).buttonLabel),
                    size: "small"
                }),
                isDisabled: !version.canEdit,
                isLoading: isLoading,
                isSelected: isOpen,
                ref: ref,
                released: isVersionReleased && !isOpen ? 1 : 0,
                shouldFitContainer: true,
                onClick: (_, analyticsEvent)=>(0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'versionStatusDropdown')
            }, isVersionReleased ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d4553222fff33491$var$ReleasedContentWrapper, null, $d4553222fff33491$export$3e6be0c31593f3c4(version.status), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d4553222fff33491$var$ReleaseSucceededIcon, null)) : $d4553222fff33491$export$3e6be0c31593f3c4(version.status)),
        value: getCurrentValue(version.status)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $30pmy.NonCriticalErrorBoundary), {
        eventLocation: "releaseNotesModal",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $956it.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "release-notes-modal",
        fallback: null
    }, isReleaseNotesModalOpen && releaseNotesQueryReference && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $e8cgA.ReleaseNotesModal), {
        queryReference: releaseNotesQueryReference,
        onClose: ()=>setIsReleaseNotesModalOpen(false)
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $956it.default), null, isReleasedModalOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8sQb9.default // @ts-expect-error - TS2322 - Type '{ locale: Locale; projectKey: string; versionId: string; onOpened: (...args: any[]) => void; onCancel: () => void; onSuccess: () => void; onError: () => void; }' is not assignable to type 'IntrinsicAttributes & StateProps & Handlers & { children?: ReactNode; }'.
    ), {
        locale: locale,
        projectKey: version.project.key,
        versionId: version.versionId,
        onOpened: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
        onCancel: ()=>{
            setIsReleaseModalOpen(false);
        },
        onSuccess: (_updatedVersion, params)=>{
            refetch();
            setIsReleaseModalOpen(false);
            if (params && params.shouldRedirectToCreateReleaseNotes) setIsReleaseNotesModalOpen(true);
        },
        onError: ()=>{
            showFlag({
                type: 'error',
                title: formatMessage((0, $hmF8e.default).genericUpdateFailedFlagTitle),
                description: formatMessage((0, $hmF8e.default).releaseFailedFlagDescription),
                messageId: 'software-releases-launch-card.ui.version-status.show-flag.error.release-modal.on-error.show-flag.error',
                messageType: 'transactional'
            });
            (0, $9pTd3.fireErrorAnalytics)({
                error: new Error('Failed to release the version'),
                meta: {
                    id: 'versionDetailsLaunchCardReleaseModal',
                    packageName: 'jiraSoftwareReleasesLaunchCard',
                    teamName: 'jolt'
                },
                sendToPrivacyUnsafeSplunk: true
            });
        },
        shouldShowCreateReleaseNotesOption: !(0, $jom8W.isDevopsFeatureDisabledInFedRamp)(),
        hasReleaseNote: hasReleaseNote ?? false
    })));
};
const $d4553222fff33491$var$ReleaseSucceededIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lwpci))), {
        label: "",
        color: $d4553222fff33491$export$a7643b841a7da7eb
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
const $d4553222fff33491$var$styles = null;
const $d4553222fff33491$var$RELEASED_BACKGROUND_COLOR = "var(--ds-background-success, #EFFFD6)"; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d4553222fff33491$var$Container = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _1bsb1osq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d4553222fff33491$var$ReleasedContentWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_zulp1b66 _4cvr1h6o _1e0c1txw _1bah1h6o",
            __cmplp.className
        ])
    });
});
const $d4553222fff33491$export$a7643b841a7da7eb = "var(--ds-text, #292A2E)"; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d4553222fff33491$var$StyledLoadingButton = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = (0, $cA0Y2.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_15s31ylp _1ilx1txw _ubnr1h6o",
            __cmplp.released && "_bikl1y9u",
            __cmplp.released && "_1gtyi7uo",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d4553222fff33491$var$VersionStatusOptionLabel = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isArchiveOption: isArchiveOption, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_4cvr1h6o _80omtlke _1e0c1txw _ca0qu2gc _u5f31ejb _n3tdu2gc _19bv1ejb",
            __cmplp.isArchiveOption ? "_x3do1uh4" : "_x3doglyw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("95TBp", function(module, exports) {
$parcel$export(module.exports, "default", () => $279ba6c496dc858a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f27e7443d050ab4137264e6846e36fe6>>
 * @relayHash 340d4f5f070919a0755dcf2816c6e362
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c6513ea034d4c8ea62a2e9887bcaa685c8b2fcb46147be3044a62ff69effec49
const $279ba6c496dc858a$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "kind": "ScalarField",
        "name": "status"
    }, v4 = {
        "kind": "ScalarField",
        "name": "canAddAndRemoveIssues"
    }, v5 = {
        "kind": "ScalarField",
        "name": "canEditRelatedWork"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "versionStatus_updateVersionArchivedMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraUpdateVersionPayload",
                            "kind": "LinkedField",
                            "name": "updateVersionArchivedStatus",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "concreteType": "JiraVersion",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "versionStatus_updateVersionArchivedMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraUpdateVersionPayload",
                            "kind": "LinkedField",
                            "name": "updateVersionArchivedStatus",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "concreteType": "JiraVersion",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "c6513ea034d4c8ea62a2e9887bcaa685c8b2fcb46147be3044a62ff69effec49",
            "metadata": {},
            "name": "versionStatus_updateVersionArchivedMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$279ba6c496dc858a$var$node.hash = "3e4bee8708d54a5a32d8530c63b327c7";
var $279ba6c496dc858a$export$2e2bcd8739ae039 = $279ba6c496dc858a$var$node;

});

parcelRegister("h3WMA", function(module, exports) {
$parcel$export(module.exports, "default", () => $a663688a128d7b50$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d39098cd4aca8ffd1c5445682305611d>>
 * @relayHash 08bc9d2a69bd2c858ab39655b3facfa0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 71ceeb655014e9c61184f72a862fcc1e2ce71afe4bf7f9accabc37395bc9d079
const $a663688a128d7b50$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "kind": "ScalarField",
        "name": "status"
    }, v4 = {
        "kind": "ScalarField",
        "name": "canAddAndRemoveIssues"
    }, v5 = {
        "kind": "ScalarField",
        "name": "canEditRelatedWork"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "versionStatus_updateVersionReleasedMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraUpdateVersionPayload",
                            "kind": "LinkedField",
                            "name": "updateVersionReleasedStatus",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "concreteType": "JiraVersion",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "versionStatus_updateVersionReleasedMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraUpdateVersionPayload",
                            "kind": "LinkedField",
                            "name": "updateVersionReleasedStatus",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "concreteType": "JiraVersion",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "71ceeb655014e9c61184f72a862fcc1e2ce71afe4bf7f9accabc37395bc9d079",
            "metadata": {},
            "name": "versionStatus_updateVersionReleasedMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$a663688a128d7b50$var$node.hash = "0608e97fa861a9ec4da08bc961c0e4d0";
var $a663688a128d7b50$export$2e2bcd8739ae039 = $a663688a128d7b50$var$node;

});

parcelRegister("lQ64b", function(module, exports) {
$parcel$export(module.exports, "default", () => $0957bc405dbbc3b4$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<992a2c0fb5f90375a2f7cabfc8fc6822>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $0957bc405dbbc3b4$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "versionStatus_softwareReleasesLaunchCard",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "id"
            },
            "action": "THROW",
            "path": "id"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "versionId"
            },
            "action": "THROW",
            "path": "versionId"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "status"
            },
            "action": "THROW",
            "path": "status"
        },
        {
            "kind": "RequiredField",
            "field": {
                "concreteType": "JiraProject",
                "kind": "LinkedField",
                "name": "project",
                "plural": false,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "kind": "ScalarField",
                            "name": "key"
                        },
                        "action": "THROW",
                        "path": "project.key"
                    }
                ]
            },
            "action": "THROW",
            "path": "project"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "canEdit"
            },
            "action": "THROW",
            "path": "canEdit"
        }
    ],
    "type": "JiraVersion"
};
$0957bc405dbbc3b4$var$node.hash = "7085e7fbc51810607ae42a94bf5c14e4";
var $0957bc405dbbc3b4$export$2e2bcd8739ae039 = $0957bc405dbbc3b4$var$node;

});

parcelRegister("c7LiM", function(module, exports) {
$parcel$export(module.exports, "default", () => $eee4c8b50bd497f7$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<458c3aa9108b357d04885dae908b4e3e>>
 * @relayHash c82d4bc74d3968b5677f2b4e7e151b40
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8d8191dfb21f183308ae9bfac528d60fcd67480a7ca1b48be8e339480044e138
const $eee4c8b50bd497f7$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "versionId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "versionId"
        }
    ], v2 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasReleaseNote"
            }
        ],
        "type": "JiraVersion"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "versionStatus_versionHasReleaseNoteQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "version",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "versionStatus_versionHasReleaseNoteQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "version",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                },
                                v2 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "8d8191dfb21f183308ae9bfac528d60fcd67480a7ca1b48be8e339480044e138",
            "metadata": {},
            "name": "versionStatus_versionHasReleaseNoteQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$eee4c8b50bd497f7$var$node.hash = "ac12222b76ff5150d612ed35c9605c2c";
var $eee4c8b50bd497f7$export$2e2bcd8739ae039 = $eee4c8b50bd497f7$var$node;

});

parcelRegister("lwpci", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bcf60af7e41b379d3a36d6fe455c57ca>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fab021c59a8f6419$var$_react = $fab021c59a8f6419$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fab021c59a8f6419$var$_baseNew = $fab021c59a8f6419$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $fab021c59a8f6419$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CheckMark".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: table cells, checkboxes.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fab021c59a8f6419$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $fab021c59a8f6419$var$_react.default.createElement($fab021c59a8f6419$var$_baseNew.default, Object.assign({
        name: "CheckMarkIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m13.959 3.97-7.25 9a.75.75 0 0 1-1.163.007l-3.5-4.25 1.158-.954 2.914 3.539 6.673-8.283z"/>`
    }, props));
$fab021c59a8f6419$var$CheckMarkIcon.displayName = 'CheckMarkIcon';
var $fab021c59a8f6419$var$_default = module.exports.default = $fab021c59a8f6419$var$CheckMarkIcon;

});

parcelRegister("e8cgA", function(module, exports) {
$parcel$export(module.exports, "ReleaseNotesModal", () => $6e88c6a4ef39b384$export$d334132901e7fcb2);
/* async.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $ik0CA = parcelRequire("ik0CA");

var $7ep4S = parcelRequire("7ep4S");

var $4B7rn = parcelRequire("4B7rn");

var $lJKII = parcelRequire("lJKII");

var $2imLM = parcelRequire("2imLM");

var $bQWwW = parcelRequire("bQWwW");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $6e88c6a4ef39b384$var$LazyReleaseNotesModalContent = (0, $bQWwW.lazy)(()=>(parcelRequire("hrMIC")).then((module)=>module.ReleaseNotesModalContent), {
    moduleId: "./src/packages/releases/release-notes-modal/src/ui/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $6e88c6a4ef39b384$var$LazyEmbeddedPageReleaseNotesEditorModal = (0, $bQWwW.lazy)(()=>(parcelRequire("2bWrJ")).then((module)=>module.EmbeddedPageReleaseNotesEditorModal), {
    moduleId: "./src/packages/releases/release-notes-modal/src/ui/embedded-page-release-notes-editor-modal/EmbeddedPageReleaseNotesEditorModal.tsx"
});
const $6e88c6a4ef39b384$var$LoadingModalBody = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ik0CA.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($6e88c6a4ef39b384$export$43a792a870d28db2, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7ep4S.default), {
        size: "large"
    })));
const $6e88c6a4ef39b384$export$d334132901e7fcb2 = (props)=>{
    const [confluenceReleaseNotesDraftUrl, setConfluenceReleaseNotesDraftUrl] = (0, $eJOHy.useState)(null);
    const { onClose: onClose } = props;
    const onCreateConfluenceReleaseNotes = (0, $eJOHy.useCallback)((draftUrl)=>{
        setConfluenceReleaseNotesDraftUrl(draftUrl);
    }, []);
    const onCloseConfluenceReleaseNotes = (0, $eJOHy.useCallback)(()=>{
        setConfluenceReleaseNotesDraftUrl(null);
        onClose();
    }, [
        onClose
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4B7rn.default), null, confluenceReleaseNotesDraftUrl ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($6e88c6a4ef39b384$var$LazyEmbeddedPageReleaseNotesEditorModal, {
        draftUrl: confluenceReleaseNotesDraftUrl,
        onClose: onCloseConfluenceReleaseNotes
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lJKII.JiraModal), {
        width: "x-large",
        autoFocus: false,
        onClose: onClose,
        messageId: "software-releases-add-release-notes-modal.ui.modal-dialog",
        messageType: "transactional"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "release-notes-modal",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($6e88c6a4ef39b384$var$LoadingModalBody, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($6e88c6a4ef39b384$var$LazyReleaseNotesModalContent, {
        ...props,
        onCreateConfluenceReleaseNotes: onCreateConfluenceReleaseNotes
    }))));
};
const $6e88c6a4ef39b384$export$43a792a870d28db2 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _1bah1h6o _4cvr1h6o _4t3i1kdj",
            __cmplp.className
        ])
    });
});

});
parcelRegister("hrMIC", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("l5M0H").then(()=>parcelRequire('fOGtY'));

});

parcelRegister("2bWrJ", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("dVu8o").then(()=>parcelRequire('4OIqI'));

});


parcelRegister("8sQb9", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $4297691ddd51e7cf$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $dFg4o = parcelRequire("dFg4o");

var $7iHUq = parcelRequire("7iHUq");

var $j5V5L = parcelRequire("j5V5L");

var $vZJ04 = parcelRequire("vZJ04");

var $1j2EU = parcelRequire("1j2EU");

var $8qLnW = parcelRequire("8qLnW");

var $55VVW = parcelRequire("55VVW");
class $4297691ddd51e7cf$export$2e2bcd8739ae039 extends (0, $eJOHy.Component) {
    constructor(props){
        super(props);
        this.store = (0, $8qLnW.default)((0, $vZJ04.default));
        this.setAppProps(this.props);
        this.store.dispatch((0, $1j2EU.initialRequest)(this.props.versionId));
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if ((0, $j5V5L.default)(nextProps, this.props)) return;
        this.setAppProps(this.props);
    }
    setAppProps(props) {
        const { projectKey: projectKey, onOpened: onOpened, onError: onError, onSuccess: onSuccess, onCancel: onCancel, shouldShowCreateReleaseNotesOption: shouldShowCreateReleaseNotesOption = false, hasReleaseNote: hasReleaseNote = false } = props;
        this.store.dispatch((0, $dFg4o.batchActions)([
            (0, $1j2EU.setContext)({
                projectKey: projectKey
            }),
            (0, $1j2EU.setHandlers)({
                onOpened: onOpened,
                onError: onError,
                onSuccess: onSuccess,
                onCancel: onCancel
            }),
            (0, $1j2EU.setCreateReleaseNotesOptionConfig)({
                shouldShowCreateReleaseNotesOption: shouldShowCreateReleaseNotesOption,
                hasReleaseNote: hasReleaseNote
            })
        ]));
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7iHUq.default), {
            store: this.store,
            id: "versionReleaseModal"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $55VVW.default), null));
    }
}

});
parcelRegister("vZJ04", function(module, exports) {
$parcel$export(module.exports, "default", () => $bf7ae6bc664c708d$export$2e2bcd8739ae039);

var $4tM8k = parcelRequire("4tM8k");

var $ibYAQ = parcelRequire("ibYAQ");

var $55jCe = parcelRequire("55jCe");
var $bf7ae6bc664c708d$export$2e2bcd8739ae039 = (0, $4tM8k.combineEpics)((0, $ibYAQ.initialRequestEpic), (0, $ibYAQ.fetchUnresolvedIssues), (0, $55jCe.initialRequestSuccessEpic), (0, $ibYAQ.releaseVersionRequestEpic), (0, $55jCe.releaseVersionRequestFailureEpic), (0, $55jCe.releaseVersionRequestSuccessEpic));

});
parcelRegister("ibYAQ", function(module, exports) {
$parcel$export(module.exports, "initialRequestEpic", () => $5fe985a361418a84$export$73dafa621a3e5eba);
$parcel$export(module.exports, "fetchUnresolvedIssues", () => $5fe985a361418a84$export$5f5c175d78772606);
$parcel$export(module.exports, "releaseVersionRequestEpic", () => $5fe985a361418a84$export$b327638b0f58ac49);
parcelRequire("9BkTq");
parcelRequire("cBiei");
parcelRequire("c1D7V");
parcelRequire("6cJUr");

var $8dH3d = parcelRequire("8dH3d");

var $jFHCE = parcelRequire("jFHCE");

var $8sbs2 = parcelRequire("8sbs2");

var $7kixv = parcelRequire("7kixv");

var $eSnSE = parcelRequire("eSnSE");

var $6a5Bv = parcelRequire("6a5Bv");

var $1j2EU = parcelRequire("1j2EU");

var $gLW5o = parcelRequire("gLW5o");
const $5fe985a361418a84$export$73dafa621a3e5eba = (action$, _store)=>action$.ofType((0, $1j2EU.INITIAL_REQUEST)).mergeMap(({ payload: versionId })=>{
        return (0, $7kixv.Observable).fromPromise((0, $6a5Bv.getVersion)(versionId)).mergeMap((version)=>(0, $7kixv.Observable).of((0, $1j2EU.initialRequestSuccess)(version))).catch((error)=>{
            (0, $eSnSE.default).safeErrorWithoutCustomerData('project-directories.versions.release.ops.get.version', error.message, error);
            return (0, $7kixv.Observable).of((0, $1j2EU.releaseVersionFailure)({
                id: versionId
            }));
        });
    });
const $5fe985a361418a84$export$5f5c175d78772606 = (action$, _store)=>action$.ofType((0, $1j2EU.INITIAL_REQUEST)).mergeMap(({ payload: versionId })=>{
        return (0, $7kixv.Observable).fromPromise((0, $6a5Bv.getUnresolvedIssues)(versionId)).mergeMap((unresolvedIssuesCount)=>(0, $7kixv.Observable).of((0, $1j2EU.setUnreleasedIssuesCount)(unresolvedIssuesCount))).catch((error)=>{
            (0, $eSnSE.default).safeErrorWithoutCustomerData('project-directories.versions.release.ops.get.getUnresolvedIssues', error.message, error);
            return (0, $7kixv.Observable).empty();
        });
    });
const $5fe985a361418a84$export$b327638b0f58ac49 = (action$, store)=>action$.ofType((0, $1j2EU.RELEASE_VERSION_REQUEST)).mergeMap(()=>{
        const state = store.getState();
        const keepIssues = (0, $gLW5o.isKeepingIssues)(state);
        const version = (0, $gLW5o.getVersion)(state);
        const versionToRelease = keepIssues ? (0, (/*@__PURE__*/$parcel$interopDefault($jFHCE)))(version, 'moveUnfixedIssuesTo') : version;
        return (0, $7kixv.Observable).fromPromise((0, $6a5Bv.releaseVersion)(versionToRelease)).mergeMap((releasedVersion)=>(0, $7kixv.Observable).of((0, $1j2EU.releaseVersionSuccess)(releasedVersion)))// @ts-expect-error - TS2345 - Argument of type '(error: FetchError) => Observable<ReleaseVersionFailureAction> | Observable<ReleaseVersionValidationFailureAction>' is not assignable to parameter of type '(err: any, caught: Observable<ReleaseVersionSuccessAction>) => ObservableInput<ReleaseVersionFailureAction>'.
        .catch((error)=>{
            try {
                const errors = (0, (/*@__PURE__*/$parcel$interopDefault($8sbs2)))(JSON.parse(error.message).errors, [
                    'releaseDate',
                    'moveUnfixedIssuesTo'
                ]);
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(errors)) return (0, $7kixv.Observable).of((0, $1j2EU.releaseVersionValidationFailure)(errors));
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (e) {
            /**/ }
            (0, $eSnSE.default).safeErrorWithoutCustomerData('project-directories.versions.release.ops.release.version', error.message, error);
            // @ts-expect-error - TS2554 - Expected 1 arguments, but got 0.
            return (0, $7kixv.Observable).of((0, $1j2EU.releaseVersionFailure)());
        });
    });

});
parcelRegister("6a5Bv", function(module, exports) {
$parcel$export(module.exports, "getVersion", () => $3bcc2cb8286a4087$export$c506eb22e615ba4a);
$parcel$export(module.exports, "getUnresolvedIssues", () => $3bcc2cb8286a4087$export$d98ed0fcfb679bfe);
$parcel$export(module.exports, "releaseVersion", () => $3bcc2cb8286a4087$export$b8e3d145af76ef26);
$parcel$export(module.exports, "useReleaseAutomationBanner", () => $3bcc2cb8286a4087$export$d9a4a1588da51f7c);

var $eJOHy = parcelRequire("eJOHy");

var $e6YEs = parcelRequire("e6YEs");

var $2aY2d = parcelRequire("2aY2d");

var $f5OzW = parcelRequire("f5OzW");

var $4cTDP = parcelRequire("4cTDP");

var $9lIhr = parcelRequire("9lIhr");

var $dcQQu = parcelRequire("dcQQu");

var $j1zq0 = parcelRequire("j1zq0");

var $4y5Q3 = parcelRequire("4y5Q3");

var $b89ZB = parcelRequire("b89ZB");
const $3bcc2cb8286a4087$export$c506eb22e615ba4a = (versionId)=>(0, $9lIhr.getVersion)(versionId).then((0, $dcQQu.transformVersion)).then((0, $4y5Q3.addDefaultReleaseDate));
const $3bcc2cb8286a4087$export$d98ed0fcfb679bfe = (versionId)=>(0, $9lIhr.getUnresolvedIssuesCount)(versionId).then((0, $dcQQu.transformUnresolvedIssuesCount));
const $3bcc2cb8286a4087$export$b8e3d145af76ef26 = (version)=>(0, $j1zq0.releaseVersion)((0, $4y5Q3.transformReleasableToRestVersion)(version)).then((0, $dcQQu.transformVersion));
const $3bcc2cb8286a4087$export$d9a4a1588da51f7c = ()=>{
    const [showBanner, setShowBanner] = (0, $eJOHy.useState)(false);
    const accountId = (0, $e6YEs.useAccountId)();
    const { data: projectContext } = (0, $2aY2d.useProjectContext)();
    const safeProjectKey = projectContext?.projectKey ?? '';
    const isJiraAdmin = (0, $f5OzW.useCanAdministerJira)(safeProjectKey);
    const isProjectAdmin = (0, $f5OzW.useCanAdministerProject)(safeProjectKey);
    (0, $eJOHy.useEffect)(()=>{
        if (accountId != null) (0, $b89ZB.getHasDismissedReleaseAutomationBanner)(accountId).then((hasDismissed)=>{
            const canSee = !(0, $4cTDP.fg)('vmc-48-hide-automation-link-for-da') || isJiraAdmin || isProjectAdmin;
            setShowBanner(!hasDismissed && canSee);
        }).catch((0, $b89ZB.fireReleaseAutomationBannerError));
    }, [
        accountId,
        isJiraAdmin,
        isProjectAdmin
    ]);
    const dismissBanner = async ()=>{
        setShowBanner(false);
        if (accountId != null) await (0, $b89ZB.dismissReleaseAutomationBanner)(accountId).catch((0, $b89ZB.fireReleaseAutomationBannerError));
    };
    return {
        showBanner: showBanner,
        dismissBanner: dismissBanner
    };
};

});
parcelRegister("f5OzW", function(module, exports) {
$parcel$export(module.exports, "useProjectPermissions", () => $9392c16d11e1d8d6$export$c6c6b35628cf47a8);
$parcel$export(module.exports, "useCanAdministerProject", () => $9392c16d11e1d8d6$export$f39ed5a161efa614);
$parcel$export(module.exports, "useCanAdministerJira", () => $9392c16d11e1d8d6$export$ec12ddafd19b95ac);
$parcel$export(module.exports, "useCanConfigureIssue", () => $9392c16d11e1d8d6$export$e7267b8a084eadb3);
$parcel$export(module.exports, "useCanUseServiceDeskAgentFeatures", () => $9392c16d11e1d8d6$export$756d7c97077a2f76);
$parcel$export(module.exports, "useCanUseCustomerServiceAgentFeatures", () => $9392c16d11e1d8d6$export$a9aa002e3fe96518);
$parcel$export(module.exports, "useCanDownloadAttachments", () => $9392c16d11e1d8d6$export$d47dad3a7e3265ea);
$parcel$export(module.exports, "useProjectPermissionsActions", () => $9392c16d11e1d8d6$export$86c656cdb87052cd);

var $eJOHy = parcelRequire("eJOHy");

var $koAZ4 = parcelRequire("koAZ4");

var $6PAED = parcelRequire("6PAED");

var $cmy2V = parcelRequire("cmy2V");
const $9392c16d11e1d8d6$export$c6c6b35628cf47a8 = (projectKey)=>{
    const [permissions, { setProjectPermissions: setProjectPermissions }] = (0, $cmy2V.useProjectPermissionsStore)({
        projectKey: projectKey
    });
    const actions = (0, $eJOHy.useMemo)(()=>({
            setProjectPermissions: setProjectPermissions
        }), [
        setProjectPermissions
    ]);
    return [
        permissions,
        actions
    ];
};
const $9392c16d11e1d8d6$export$f39ed5a161efa614 = (projectKey)=>{
    const [permissions] = (0, $cmy2V.useProjectPermissionsStore)({
        projectKey: projectKey
    });
    return permissions.canAdministerProject;
};
const $9392c16d11e1d8d6$export$ec12ddafd19b95ac = (projectKey)=>{
    const [permissions] = (0, $cmy2V.useProjectPermissionsStore)({
        projectKey: projectKey
    });
    return permissions.canAdministerJira;
};
const $9392c16d11e1d8d6$export$e7267b8a084eadb3 = (projectKey)=>{
    const canConfigureAdministerProject = $9392c16d11e1d8d6$export$f39ed5a161efa614(projectKey);
    const canAdministerJira = $9392c16d11e1d8d6$export$ec12ddafd19b95ac(projectKey);
    return canConfigureAdministerProject || canAdministerJira;
};
const $9392c16d11e1d8d6$export$756d7c97077a2f76 = (projectKey)=>{
    const [permissions] = (0, $cmy2V.useProjectPermissionsStore)({
        projectKey: projectKey
    });
    const { appPermissions: appPermissions } = (0, $koAZ4.useTenantContext)();
    return permissions.canUseServiceDeskAgentFeatures && appPermissions?.hasServiceDeskAccess;
};
const $9392c16d11e1d8d6$export$a9aa002e3fe96518 = (projectKey)=>{
    const [permissions] = (0, $cmy2V.useProjectPermissionsStore)({
        projectKey: projectKey
    });
    const { hasCustomerServiceAccess: hasCustomerServiceAccess } = (0, $6PAED.useApplicationPermissions)();
    return permissions.canUseServiceDeskAgentFeatures && hasCustomerServiceAccess;
};
const $9392c16d11e1d8d6$export$d47dad3a7e3265ea = (projectKey)=>{
    const [permissions] = (0, $cmy2V.useProjectPermissionsStore)({
        projectKey: projectKey
    });
    return permissions.canExportIssue;
};
const $9392c16d11e1d8d6$export$86c656cdb87052cd = ()=>{
    const [, { setProjectPermissions: setProjectPermissions }] = (0, $cmy2V.useProjectPermissionsStoreActions)();
    const actions = (0, $eJOHy.useMemo)(()=>({
            setProjectPermissions: setProjectPermissions
        }), [
        setProjectPermissions
    ]);
    return [
        null,
        actions
    ];
};

});
parcelRegister("cmy2V", function(module, exports) {
$parcel$export(module.exports, "defaultPermissions", () => $872d4887d895f20d$export$ccfee65526b322ca);
$parcel$export(module.exports, "useProjectPermissionsStore", () => $872d4887d895f20d$export$4919fa09a3d81224);
$parcel$export(module.exports, "useProjectPermissionsStoreActions", () => $872d4887d895f20d$export$e8436ef485b33bdb);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $g2Hwr = parcelRequire("g2Hwr");
const $872d4887d895f20d$export$ccfee65526b322ca = {
    canAddComments: false,
    canAdministerJira: false,
    canAdministerProject: false,
    canAssignIssues: false,
    canBeAssignedToIssues: false,
    canCloneIssue: false,
    canCreateAttachments: false,
    canCreateChildren: false,
    canCreateSubtask: false,
    canDeleteAllAttachments: false,
    canDeleteAllComments: false,
    canDeleteAllWorklogs: false,
    canDeleteIssue: false,
    canDeleteOwnAttachments: false,
    canDeleteOwnComments: false,
    canDeleteOwnWorklogs: false,
    canEditAllComments: false,
    canEditAllWorklogs: false,
    canEditIssues: false,
    canEditOwnComments: false,
    canEditOwnWorklogs: false,
    canLinkIssues: false,
    canLogWork: false,
    canManageWatchers: false,
    canMoveIssue: false,
    canModifyReporter: false,
    canScheduleIssues: false,
    canUseServiceDeskAgentFeatures: false,
    canBrowseUsers: false,
    canViewDevTools: false,
    canViewWatchers: false,
    canViewVoters: false,
    canCreateIssuesInClassicProjectEpic: false,
    canResolveIssues: false,
    canExportIssue: false,
    canArchiveIssue: false,
    canUnarchiveIssue: false
};
const $872d4887d895f20d$var$store = (0, $GtRbT.createStore)({
    name: 'project-permissions',
    initialState: {},
    actions: $g2Hwr
});
const $872d4887d895f20d$var$getProjectPermissionSelector = (state, { projectKey: projectKey })=>state[projectKey] || $872d4887d895f20d$export$ccfee65526b322ca;
const $872d4887d895f20d$export$4919fa09a3d81224 = (0, $iJq0l.createHook)($872d4887d895f20d$var$store, {
    selector: $872d4887d895f20d$var$getProjectPermissionSelector
});
const $872d4887d895f20d$export$e8436ef485b33bdb = (0, $iJq0l.createHook)($872d4887d895f20d$var$store, {
    selector: null
});

});
parcelRegister("g2Hwr", function(module, exports) {
$parcel$export(module.exports, "setProjectPermissions", () => $d904843c11c916e5$export$53f5cc27627e5fe3);
const $d904843c11c916e5$export$53f5cc27627e5fe3 = (projectKey, permissions)=>({ setState: setState })=>{
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [projectKey]: permissions
        });
    };

});



parcelRegister("9lIhr", function(module, exports) {
$parcel$export(module.exports, "getVersionEndpointUrl", () => $a9d69a1bff2a7354$export$9513b66f34c81f7d);
$parcel$export(module.exports, "getVersion", () => $a9d69a1bff2a7354$export$c506eb22e615ba4a);
$parcel$export(module.exports, "getUnresolvedIssuesCount", () => $a9d69a1bff2a7354$export$b7679bf23524baba);

var $hgi0g = parcelRequire("hgi0g");
const $a9d69a1bff2a7354$export$9513b66f34c81f7d = (versionId)=>`/rest/api/2/version/${versionId}`;
const $a9d69a1bff2a7354$export$18ba274da71f4912 = (versionId)=>`${$a9d69a1bff2a7354$export$9513b66f34c81f7d(versionId)}?expand=issuesstatus`;
const $a9d69a1bff2a7354$export$fdc7e642e6597237 = (versionId)=>`${$a9d69a1bff2a7354$export$9513b66f34c81f7d(versionId)}/unresolvedIssueCount`;
const $a9d69a1bff2a7354$export$c506eb22e615ba4a = (versionId)=>(0, $hgi0g.default)($a9d69a1bff2a7354$export$18ba274da71f4912(versionId));
const $a9d69a1bff2a7354$export$b7679bf23524baba = (versionId)=>(0, $hgi0g.default)($a9d69a1bff2a7354$export$fdc7e642e6597237(versionId));

});

parcelRegister("dcQQu", function(module, exports) {
$parcel$export(module.exports, "transformVersion", () => $31eca736f49fc223$export$390ab7123357e756);
$parcel$export(module.exports, "transformUnresolvedIssuesCount", () => $31eca736f49fc223$export$9c917bd1ad6cfd7f);

var $frPES = parcelRequire("frPES");
const $31eca736f49fc223$var$transformStatus = (archived, released)=>{
    if (archived) return 0, $frPES.ARCHIVED;
    if (released) return 0, $frPES.RELEASED;
    return 0, $frPES.UNRELEASED;
};
const $31eca736f49fc223$var$transformIssuesStatus = ({ toDo: toDo, inProgress: inProgress, done: done })=>({
        toDo: toDo,
        inProgress: inProgress,
        done: done
    });
const $31eca736f49fc223$export$390ab7123357e756 = (restVersion)=>{
    const version = {
        id: restVersion.id,
        name: restVersion.name,
        description: restVersion.description ? restVersion.description : '',
        status: $31eca736f49fc223$var$transformStatus(restVersion.archived, restVersion.released),
        startDate: restVersion.startDate,
        releaseDate: restVersion.releaseDate,
        overdue: !!restVersion.overdue,
        projectId: restVersion.projectId
    };
    if (restVersion.issuesStatusForFixVersion) version.issuesStatus = $31eca736f49fc223$var$transformIssuesStatus(restVersion.issuesStatusForFixVersion);
    return version;
};
const $31eca736f49fc223$export$9c917bd1ad6cfd7f = (rest)=>rest.issuesUnresolvedCount;

});
parcelRegister("frPES", function(module, exports) {
$parcel$export(module.exports, "RELEASED", () => $8aa2131c0941c313$export$b983f2cb1f658a55);
$parcel$export(module.exports, "UNRELEASED", () => $8aa2131c0941c313$export$cb459d726a8530a5);
$parcel$export(module.exports, "ARCHIVED", () => $8aa2131c0941c313$export$c936349447a77fe0);
const $8aa2131c0941c313$export$b983f2cb1f658a55 = 'RELEASED';
const $8aa2131c0941c313$export$cb459d726a8530a5 = 'UNRELEASED';
const $8aa2131c0941c313$export$c936349447a77fe0 = 'ARCHIVED';
const $8aa2131c0941c313$var$statuses = [
    $8aa2131c0941c313$export$b983f2cb1f658a55,
    $8aa2131c0941c313$export$cb459d726a8530a5,
    $8aa2131c0941c313$export$c936349447a77fe0
];
var $8aa2131c0941c313$export$2e2bcd8739ae039 = $8aa2131c0941c313$var$statuses;

});


parcelRegister("j1zq0", function(module, exports) {
$parcel$export(module.exports, "releaseVersion", () => $d806689819f2ce8e$export$b8e3d145af76ef26);

var $l6f8u = parcelRequire("l6f8u");

var $9lIhr = parcelRequire("9lIhr");
const $d806689819f2ce8e$export$b8e3d145af76ef26 = (version)=>{
    const url = (0, $9lIhr.getVersionEndpointUrl)(version.id);
    return (0, $l6f8u.default)(url, {
        method: 'put',
        body: JSON.stringify({
            ...version
        })
    });
};

});
parcelRegister("l6f8u", function(module, exports) {
$parcel$export(module.exports, "default", () => $7cc1e57cde3e9822$export$2e2bcd8739ae039);

var $14RSn = parcelRequire("14RSn");

var $eBhI6 = parcelRequire("eBhI6");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $7cc1e57cde3e9822$var$fetchJson = (url, options = {})=>{
    const option = {
        ...(0, $eBhI6.getDefaultOptions)(url),
        ...options
    };
    return fetch(url, option).then((response)=>{
        if (!response.ok) {
            const { status: status } = response;
            return response.text().then((str)=>{
                throw new (0, $14RSn.default)(status, str);
            });
        }
        return response.json();
    });
};
var $7cc1e57cde3e9822$export$2e2bcd8739ae039 = $7cc1e57cde3e9822$var$fetchJson;

});


parcelRegister("4y5Q3", function(module, exports) {
$parcel$export(module.exports, "transformReleasableToRestVersion", () => $810f38dae917f803$export$6c7ef87ae81a803f);
$parcel$export(module.exports, "addDefaultReleaseDate", () => $810f38dae917f803$export$a3871b8272282d64);

var $jFHCE = parcelRequire("jFHCE");

var $2M9u3 = parcelRequire("2M9u3");
const $810f38dae917f803$export$6c7ef87ae81a803f = (version)=>{
    const restVersion = (0, (/*@__PURE__*/$parcel$interopDefault($jFHCE)))(version, [
        'issuesStatus'
    ]);
    return {
        ...restVersion,
        released: true,
        // @ts-expect-error - TS2322 - Type 'string | null' is not assignable to type 'string | undefined'.
        releaseDate: (0, $2M9u3.atlasKitToServerDateFormat)(version.releaseDate)
    };
};
const $810f38dae917f803$export$a3871b8272282d64 = (version)=>{
    const { id: id, name: name, releaseDate: releaseDate, issuesStatus: issuesStatus } = version;
    return {
        id: id,
        name: name,
        issuesStatus: issuesStatus,
        moveUnfixedIssuesTo: '',
        releaseDate: releaseDate ? (0, $2M9u3.ISOToAtlasKitDateFormat)(releaseDate) : (0, $2M9u3.todayToAtlasKitDateFormat)()
    };
};

});
parcelRegister("2M9u3", function(module, exports) {
$parcel$export(module.exports, "ISOToAtlasKitDateFormat", () => $fb23e6c1d2768f48$export$4df2a4adbb0e5391);
$parcel$export(module.exports, "todayToAtlasKitDateFormat", () => $fb23e6c1d2768f48$export$d9939b5b983bc908);
$parcel$export(module.exports, "atlasKitToServerDateFormat", () => $fb23e6c1d2768f48$export$bcd9d8ad44970e94);
// GOOD TO KNOW
// ------------
// Atlaskit DatePicker has two date formats:
// 1. YYYY/MM/DD which user sees on the screen
// 2. YYYY-MM-DD which DatePicker passes to the onChange callback (ISO format)
//
// Sometimes Atlaskit doesn't convert user-input date (YYYY/MM/DD) to the ISO format.
// It happens when some action gets dispatched before DatePicker receives blur event.
// So we fix it here by replacing `/` with `-`.

var $57raR = parcelRequire("57raR");

var $guEFH = parcelRequire("guEFH");

var $dBLX0 = parcelRequire("dBLX0");

var $kQ82p = parcelRequire("kQ82p");

var $lTtQZ = parcelRequire("lTtQZ");
const $fb23e6c1d2768f48$export$c9b0b9ddba618847 = (dateStr)=>{
    if (dateStr) {
        const date = (0, $kQ82p.default)(dateStr.replace(/\//g, '-'));
        if ((0, $dBLX0.default)(date)) return (0, $57raR.default)(new Date(date), 'yyyy-MM-dd');
    }
    return '';
};
const $fb23e6c1d2768f48$export$4df2a4adbb0e5391 = (dateStr)=>{
    if (dateStr) {
        const date = (0, $kQ82p.default)(dateStr);
        if ((0, $dBLX0.default)(date)) return (0, $57raR.default)(new Date(date), 'yyyy/MM/dd');
    }
    return '';
};
const $fb23e6c1d2768f48$export$d9939b5b983bc908 = ()=>(0, $57raR.default)((0, $lTtQZ.default)(), 'yyyy/MM/dd');
const $fb23e6c1d2768f48$export$6350eb346dee22fe = (dateStr)=>{
    if (dateStr) return (0, $dBLX0.default)((0, $kQ82p.default)(dateStr.replace(/\//g, '-')));
    return false;
};
const $fb23e6c1d2768f48$export$bcd9d8ad44970e94 = (dateStr)=>{
    let dateISO;
    if (dateStr && $fb23e6c1d2768f48$export$6350eb346dee22fe(dateStr)) dateISO = $fb23e6c1d2768f48$export$c9b0b9ddba618847(dateStr);
    return dateISO || null;
};
const $fb23e6c1d2768f48$export$e36c611b04695a2e = (dateStr)=>{
    const date = (0, $kQ82p.default)(dateStr);
    if ((0, $dBLX0.default)(date)) return (0, $guEFH.default)(date);
    return undefined;
};
const $fb23e6c1d2768f48$export$8d60448f563c47a6 = {
    year: 'numeric',
    month: 'short',
    day: '2-digit'
};

});


parcelRegister("b89ZB", function(module, exports) {
$parcel$export(module.exports, "getHasDismissedReleaseAutomationBanner", () => $95158b9658bbb040$export$b8702a08258e1098);
$parcel$export(module.exports, "dismissReleaseAutomationBanner", () => $95158b9658bbb040$export$7f678873378110b8);
$parcel$export(module.exports, "fireReleaseAutomationBannerError", () => $95158b9658bbb040$export$76cf25de6ffb8030);

var $9pTd3 = parcelRequire("9pTd3");

var $eBhI6 = parcelRequire("eBhI6");
const $95158b9658bbb040$export$b8702a08258e1098 = async (accountId)=>{
    const url = `/rest/api/3/user/properties/hasDismissedReleaseAutomationBanner?accountId=${accountId}`;
    const fetchResponse = await fetch(url, (0, $eBhI6.getDefaultOptions)(url));
    // ok is true only when status code is 2xx.
    if (fetchResponse.ok) {
        const responseObj = await fetchResponse.json();
        return responseObj.value;
    }
    const { status: status } = fetchResponse;
    // 401: If credential is incorrect, the user is not authorised and should not see the banner
    if (status === 401) return true;
    // 404: API deliberately returns 404 if user property is not found, which implies the user has not dismissed the banner
    if (status === 404) return false;
    throw new Error(`Fetching hasDismisssedReleaseAutomationBanner user property failed. Status code: ${fetchResponse.status}`);
};
const $95158b9658bbb040$export$7f678873378110b8 = async (accountId)=>{
    const url = `/rest/api/3/user/properties/hasDismissedReleaseAutomationBanner?accountId=${accountId}`;
    const fetchResponse = await fetch(url, {
        ...(0, $eBhI6.getDefaultOptions)(url),
        method: 'PUT',
        body: JSON.stringify(true)
    });
    if (!fetchResponse.ok) throw Error('Failed to dismiss release automation banner via user properties.');
};
const $95158b9658bbb040$export$76cf25de6ffb8030 = (error)=>(0, $9pTd3.fireErrorAnalytics)({
        meta: {
            id: 'versions.release.version.modal.release.automation.user.property',
            packageName: 'jiraVersionModals',
            teamName: 'jolt'
        },
        error: error,
        sendToPrivacyUnsafeSplunk: true
    });

});


parcelRegister("1j2EU", function(module, exports) {
$parcel$export(module.exports, "SET_CONTEXT", () => $4059eda9add4a05f$export$4bc4e62e7d72b94b);
$parcel$export(module.exports, "setContext", () => $4059eda9add4a05f$export$2f04de43fe27971a);
$parcel$export(module.exports, "SET_HANDLERS", () => $4059eda9add4a05f$export$bc2eae499d5e6cec);
$parcel$export(module.exports, "setHandlers", () => $4059eda9add4a05f$export$241365d6eef6c169);
$parcel$export(module.exports, "INITIAL_REQUEST", () => $4059eda9add4a05f$export$e1efaa8f406867bb);
$parcel$export(module.exports, "initialRequest", () => $4059eda9add4a05f$export$3bccc812fdbc3954);
$parcel$export(module.exports, "INITIAL_REQUEST_SUCCESS", () => $4059eda9add4a05f$export$37a4e72ae1c0a1b5);
$parcel$export(module.exports, "initialRequestSuccess", () => $4059eda9add4a05f$export$fbef4e4c40c06dae);
$parcel$export(module.exports, "SET_VERSION_UNRESOLVED_ISSUES_COUNT", () => $4059eda9add4a05f$export$a558394b02430fa);
$parcel$export(module.exports, "setUnreleasedIssuesCount", () => $4059eda9add4a05f$export$521ad3c091ef9f4b);
$parcel$export(module.exports, "SWAP_ISSUES", () => $4059eda9add4a05f$export$1e105c795f4df801);
$parcel$export(module.exports, "swapIssues", () => $4059eda9add4a05f$export$f9d0b46042c1093d);
$parcel$export(module.exports, "RELEASE_VERSION_UPDATE", () => $4059eda9add4a05f$export$a7943bb075347bd4);
$parcel$export(module.exports, "releaseVersionUpdate", () => $4059eda9add4a05f$export$6e5a7b93aba64e1c);
$parcel$export(module.exports, "RELEASE_VERSION_REQUEST", () => $4059eda9add4a05f$export$b482a6a2418379a4);
$parcel$export(module.exports, "releaseVersionRequest", () => $4059eda9add4a05f$export$f25b64441359ac5d);
$parcel$export(module.exports, "RELEASE_VERSION_SUCCESS", () => $4059eda9add4a05f$export$9f45f3d28614fd39);
$parcel$export(module.exports, "releaseVersionSuccess", () => $4059eda9add4a05f$export$ef2ca233886223dd);
$parcel$export(module.exports, "RELEASE_VERSION_FAILURE", () => $4059eda9add4a05f$export$f79008eab89d4f56);
$parcel$export(module.exports, "releaseVersionFailure", () => $4059eda9add4a05f$export$f40837cd887e0e7d);
$parcel$export(module.exports, "RELEASE_VERSION_VALIDATION_FAILURE", () => $4059eda9add4a05f$export$15feef518e3a0f72);
$parcel$export(module.exports, "releaseVersionValidationFailure", () => $4059eda9add4a05f$export$d206bb816a78117c);
$parcel$export(module.exports, "CREATE_RELEASE_NOTES_OPTIONS", () => $4059eda9add4a05f$export$95df9c1149c6615a);
$parcel$export(module.exports, "setCreateReleaseNotesOptionConfig", () => $4059eda9add4a05f$export$778db09b7ef0e606);
$parcel$export(module.exports, "RELEASE_SET_REDIRECT_TO_CREATE_RELEASE_NOTES_STATUS", () => $4059eda9add4a05f$export$95c8c0da90c589f);
$parcel$export(module.exports, "releaseRedirectToCreateReleaseNotesStatus", () => $4059eda9add4a05f$export$bec051bc82fda7b3);
const $4059eda9add4a05f$export$4bc4e62e7d72b94b = 'release-version-modal.state.SET_CONTEXT';
const $4059eda9add4a05f$export$2f04de43fe27971a = (payload)=>({
        type: $4059eda9add4a05f$export$4bc4e62e7d72b94b,
        payload: payload
    });
const $4059eda9add4a05f$export$bc2eae499d5e6cec = 'release-version-modal.state.SET_HANDLERS';
const $4059eda9add4a05f$export$241365d6eef6c169 = (payload)=>({
        type: $4059eda9add4a05f$export$bc2eae499d5e6cec,
        payload: payload
    });
const $4059eda9add4a05f$export$e1efaa8f406867bb = 'release-version-modal.state.INITIAL_REQUEST';
const $4059eda9add4a05f$export$3bccc812fdbc3954 = (versionId)=>({
        type: $4059eda9add4a05f$export$e1efaa8f406867bb,
        payload: versionId
    });
const $4059eda9add4a05f$export$37a4e72ae1c0a1b5 = 'release-version-modal.state.INITIAL_REQUEST_SUCCESS';
const $4059eda9add4a05f$export$fbef4e4c40c06dae = (version)=>({
        type: $4059eda9add4a05f$export$37a4e72ae1c0a1b5,
        payload: version
    });
const $4059eda9add4a05f$export$a558394b02430fa = 'release-version-modal.state.SET_VERSION_UNRESOLVED_ISSUES_COUNT';
const $4059eda9add4a05f$export$521ad3c091ef9f4b = (payload)=>({
        type: $4059eda9add4a05f$export$a558394b02430fa,
        payload: payload
    });
const $4059eda9add4a05f$export$33d1af9ce619539e = 'release-version-modal.state.SET_VERSION';
const $4059eda9add4a05f$export$f99c3c9c04cda7ae = (payload)=>({
        type: $4059eda9add4a05f$export$33d1af9ce619539e,
        payload: payload
    });
const $4059eda9add4a05f$export$1e105c795f4df801 = 'release-version-modal.state.SWAP_ISSUES';
const $4059eda9add4a05f$export$f9d0b46042c1093d = (payload)=>({
        type: $4059eda9add4a05f$export$1e105c795f4df801,
        payload: payload
    });
const $4059eda9add4a05f$export$a7943bb075347bd4 = 'release-version-modal.state.RELEASE_VERSION_UPDATE';
const $4059eda9add4a05f$export$6e5a7b93aba64e1c = (payload)=>({
        type: $4059eda9add4a05f$export$a7943bb075347bd4,
        payload: payload
    });
const $4059eda9add4a05f$export$b482a6a2418379a4 = 'release-version-modal.state.RELEASE_VERSION_REQUEST';
const $4059eda9add4a05f$export$f25b64441359ac5d = ()=>({
        type: $4059eda9add4a05f$export$b482a6a2418379a4
    });
const $4059eda9add4a05f$export$9f45f3d28614fd39 = 'release-version-modal.state.RELEASE_VERSION_SUCCESS';
const $4059eda9add4a05f$export$ef2ca233886223dd = (payload)=>({
        type: $4059eda9add4a05f$export$9f45f3d28614fd39,
        payload: payload
    });
const $4059eda9add4a05f$export$f79008eab89d4f56 = 'release-version-modal.state.RELEASE_VERSION_FAILURE';
const $4059eda9add4a05f$export$f40837cd887e0e7d = (payload)=>({
        type: $4059eda9add4a05f$export$f79008eab89d4f56,
        payload: payload
    });
const $4059eda9add4a05f$export$15feef518e3a0f72 = 'release-version-modal.state.RELEASE_VERSION_VALIDATION_FAILURE';
const $4059eda9add4a05f$export$d206bb816a78117c = (payload)=>({
        type: $4059eda9add4a05f$export$15feef518e3a0f72,
        payload: payload
    });
const $4059eda9add4a05f$export$95df9c1149c6615a = 'release-version-modal.state.CREATE_RELEASE_NOTES_OPTIONS';
const $4059eda9add4a05f$export$778db09b7ef0e606 = (payload)=>({
        type: $4059eda9add4a05f$export$95df9c1149c6615a,
        payload: payload
    });
const $4059eda9add4a05f$export$95c8c0da90c589f = 'release-version-modal.state.RELEASE_SET_REDIRECT_TO_CREATE_RELEASE_NOTES_STATUS';
const $4059eda9add4a05f$export$bec051bc82fda7b3 = (payload)=>({
        type: $4059eda9add4a05f$export$95c8c0da90c589f,
        payload: payload
    });

});

parcelRegister("gLW5o", function(module, exports) {
$parcel$export(module.exports, "getProjectKey", () => $1a8df3e691c7a226$export$667f2a0f99c75faa);
$parcel$export(module.exports, "getVersion", () => $1a8df3e691c7a226$export$c506eb22e615ba4a);
$parcel$export(module.exports, "getVersionId", () => $1a8df3e691c7a226$export$d0a84488c5034e2b);
$parcel$export(module.exports, "getTodoInProgressIssuesCount", () => $1a8df3e691c7a226$export$7c32856ef2a2cb6);
$parcel$export(module.exports, "getUnresolvedIssuesCount", () => $1a8df3e691c7a226$export$b7679bf23524baba);
$parcel$export(module.exports, "getResolvedIssuesCount", () => $1a8df3e691c7a226$export$96488947387acc21);
$parcel$export(module.exports, "getDoneIssuesCount", () => $1a8df3e691c7a226$export$51a75c074eb3f4d4);
$parcel$export(module.exports, "getName", () => $1a8df3e691c7a226$export$7d9f7e9c1c02b41e);
$parcel$export(module.exports, "getReleaseDate", () => $1a8df3e691c7a226$export$9664966f747b3c18);
$parcel$export(module.exports, "getErrors", () => $1a8df3e691c7a226$export$501239432719417d);
$parcel$export(module.exports, "isSwapSelected", () => $1a8df3e691c7a226$export$8fff49f07292ff94);
$parcel$export(module.exports, "isSaving", () => $1a8df3e691c7a226$export$3b51d1dcee070cea);
$parcel$export(module.exports, "isInitiating", () => $1a8df3e691c7a226$export$8b35c3a55e549a0d);
$parcel$export(module.exports, "getOnOpenedHandler", () => $1a8df3e691c7a226$export$9cb228195867c4ba);
$parcel$export(module.exports, "getOnErrorHandler", () => $1a8df3e691c7a226$export$1a207b7e599ecdc7);
$parcel$export(module.exports, "getOnSuccessHandler", () => $1a8df3e691c7a226$export$8fb55c0bc571e8e7);
$parcel$export(module.exports, "getOnCancelHandler", () => $1a8df3e691c7a226$export$e776433ed4e15cc4);
$parcel$export(module.exports, "getPropsForVersionPicker", () => $1a8df3e691c7a226$export$95a1217518b748b8);
$parcel$export(module.exports, "isReleaseDisabled", () => $1a8df3e691c7a226$export$2a2f3b8b22c4af1f);
$parcel$export(module.exports, "isKeepingIssues", () => $1a8df3e691c7a226$export$e783a0e680cad4ec);
$parcel$export(module.exports, "shouldShowCreateReleaseNotesOption", () => $1a8df3e691c7a226$export$37c3a3cc47342e65);
$parcel$export(module.exports, "shouldRedirectToCreateReleaseNotes", () => $1a8df3e691c7a226$export$24122e8f86a884b6);

var $ahm5r = parcelRequire("ahm5r");
const $1a8df3e691c7a226$export$667f2a0f99c75faa = (state)=>state.context.projectKey;
const $1a8df3e691c7a226$export$c506eb22e615ba4a = (state)=>state.version;
const $1a8df3e691c7a226$export$57294fc3393f82ae = (state)=>state.version.moveUnfixedIssuesTo;
const $1a8df3e691c7a226$export$d0a84488c5034e2b = (state)=>state.version.id;
const $1a8df3e691c7a226$export$7c32856ef2a2cb6 = (state)=>{
    if (state.version.issuesStatus) return state.version.issuesStatus.toDo + state.version.issuesStatus.inProgress;
    return 0;
};
const $1a8df3e691c7a226$export$b7679bf23524baba = (state)=>state.unresolvedIssuesCount;
const $1a8df3e691c7a226$export$36e4434605c3220 = (state)=>{
    if (state.version.issuesStatus) return state.version.issuesStatus.done + state.version.issuesStatus.toDo + state.version.issuesStatus.inProgress;
    return 0;
};
const $1a8df3e691c7a226$export$96488947387acc21 = (state)=>$1a8df3e691c7a226$export$36e4434605c3220(state) - $1a8df3e691c7a226$export$b7679bf23524baba(state);
const $1a8df3e691c7a226$export$51a75c074eb3f4d4 = (state)=>{
    if (state.version.issuesStatus) return state.version.issuesStatus.done;
    return 0;
};
const $1a8df3e691c7a226$export$7d9f7e9c1c02b41e = (state)=>$1a8df3e691c7a226$export$c506eb22e615ba4a(state).name || '';
const $1a8df3e691c7a226$export$9664966f747b3c18 = (state)=>$1a8df3e691c7a226$export$c506eb22e615ba4a(state).releaseDate || '';
const $1a8df3e691c7a226$export$501239432719417d = (0, $ahm5r.createSelector)(// @ts-expect-error - TS2571 - Object is of type 'unknown'.
(state)=>state.errors, (errors)=>{
    const { releaseDate: releaseDate = '', moveUnfixedIssuesTo: moveUnfixedIssuesTo = '' } = errors || {};
    return {
        releaseDate: releaseDate,
        moveUnfixedIssuesTo: moveUnfixedIssuesTo
    };
});
const $1a8df3e691c7a226$export$8fff49f07292ff94 = (state)=>state.shouldSwapIssues;
const $1a8df3e691c7a226$export$3b51d1dcee070cea = (state)=>!!state.isSaving;
const $1a8df3e691c7a226$export$8b35c3a55e549a0d = (state)=>!!state.isInitiating;
const $1a8df3e691c7a226$export$9cb228195867c4ba = (state)=>state.handlers.onOpened;
const $1a8df3e691c7a226$export$1a207b7e599ecdc7 = (state)=>state.handlers.onError;
const $1a8df3e691c7a226$export$8fb55c0bc571e8e7 = (state)=>state.handlers.onSuccess;
const $1a8df3e691c7a226$export$e776433ed4e15cc4 = (state)=>state.handlers.onCancel;
const $1a8df3e691c7a226$export$95a1217518b748b8 = (state)=>({
        projectKey: state.context.projectKey,
        shouldSwapIssues: state.shouldSwapIssues,
        isSaving: state.isSaving,
        versionId: state.version.id
    });
const $1a8df3e691c7a226$var$hasTodoInProgressIssues = (state)=>$1a8df3e691c7a226$export$7c32856ef2a2cb6(state) > 0;
const $1a8df3e691c7a226$export$2a2f3b8b22c4af1f = (state)=>state.isSaving || $1a8df3e691c7a226$export$b7679bf23524baba(state) > 0 && state.shouldSwapIssues && !$1a8df3e691c7a226$export$57294fc3393f82ae(state);
const $1a8df3e691c7a226$export$e783a0e680cad4ec = (state)=>{
    if ($1a8df3e691c7a226$var$hasTodoInProgressIssues(state)) return state.shouldSwapIssues ? !$1a8df3e691c7a226$export$57294fc3393f82ae(state) : true;
    return true;
};
const $1a8df3e691c7a226$export$37c3a3cc47342e65 = (state)=>state.shouldShowCreateReleaseNotesOption;
const $1a8df3e691c7a226$export$24122e8f86a884b6 = (state)=>state.shouldRedirectToCreateReleaseNotes;

});


parcelRegister("55jCe", function(module, exports) {
$parcel$export(module.exports, "initialRequestSuccessEpic", () => $4b1d07453b825a2a$export$9d210f02e9fc914d);
$parcel$export(module.exports, "releaseVersionRequestSuccessEpic", () => $4b1d07453b825a2a$export$77863bf7469abd8f);
$parcel$export(module.exports, "releaseVersionRequestFailureEpic", () => $4b1d07453b825a2a$export$79de050f634d0345);

var $7kixv = parcelRequire("7kixv");
parcelRequire("1AyD5");
parcelRequire("6cJUr");

var $1j2EU = parcelRequire("1j2EU");

var $gLW5o = parcelRequire("gLW5o");
const $4b1d07453b825a2a$export$9d210f02e9fc914d = (action$, store)=>action$.ofType((0, $1j2EU.INITIAL_REQUEST_SUCCESS)).mergeMap(()=>{
        const state = store.getState();
        const versionId = (0, $gLW5o.getVersionId)(state);
        (0, $gLW5o.getOnOpenedHandler)(state)({
            id: versionId
        });
        return (0, $7kixv.Observable).empty();
    });
const $4b1d07453b825a2a$export$77863bf7469abd8f = (action$, store)=>action$.ofType((0, $1j2EU.RELEASE_VERSION_SUCCESS)).mergeMap(({ payload: version })=>{
        const state = store.getState();
        (0, $gLW5o.getOnSuccessHandler)(state)(version, {
            shouldRedirectToCreateReleaseNotes: (0, $gLW5o.shouldRedirectToCreateReleaseNotes)(state)
        });
        return (0, $7kixv.Observable).empty();
    });
const $4b1d07453b825a2a$export$79de050f634d0345 = (action$, store)=>action$.ofType((0, $1j2EU.RELEASE_VERSION_FAILURE)).mergeMap(({ payload: id })=>{
        const state = store.getState();
        (0, $gLW5o.getOnErrorHandler)(state)(id);
        return (0, $7kixv.Observable).empty();
    });

});


parcelRegister("8qLnW", function(module, exports) {
$parcel$export(module.exports, "default", () => $0b547e08dd4b5da3$export$2e2bcd8739ae039);

var $gs6vs = parcelRequire("gs6vs");

var $lRdZJ = parcelRequire("lRdZJ");
const $0b547e08dd4b5da3$var$createStore = (rootEpic)=>(0, $gs6vs.default)({
        appName: 'release-version',
        rootReducer: $lRdZJ.default,
        rootEpic: rootEpic
    });
var $0b547e08dd4b5da3$export$2e2bcd8739ae039 = $0b547e08dd4b5da3$var$createStore;

});
parcelRegister("lRdZJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $1940dfed1e9cdbea$export$2e2bcd8739ae039);

var $Xz6kS = parcelRequire("Xz6kS");

var $1O6Yz = parcelRequire("1O6Yz");

var $12DRg = parcelRequire("12DRg");

var $jFHCE = parcelRequire("jFHCE");

var $1j2EU = parcelRequire("1j2EU");
const $1940dfed1e9cdbea$export$d4c72bab9d6cc13a = {
    context: {
        projectKey: ''
    },
    handlers: {
        onOpened: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
        onError: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
        onSuccess: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
        onCancel: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
    },
    version: {
        id: '0',
        name: ''
    },
    unresolvedIssuesCount: 0,
    shouldSwapIssues: true,
    isInitiating: true,
    isSaving: false,
    shouldShowCreateReleaseNotesOption: false,
    hasReleaseNote: false,
    shouldRedirectToCreateReleaseNotes: true
};
const $1940dfed1e9cdbea$var$reducer = (state = $1940dfed1e9cdbea$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case 0, $1j2EU.SET_CONTEXT:
            {
                const context = action.payload;
                // @ts-expect-error - TS2322 - Type 'SetContextPayload | undefined' is not assignable to type '{ readonly readonly projectKey: string; }'.
                return {
                    ...state,
                    context: context
                };
            }
        case 0, $1j2EU.SET_VERSION_UNRESOLVED_ISSUES_COUNT:
            {
                const unresolvedIssuesCount = action.payload;
                return {
                    ...state,
                    unresolvedIssuesCount: unresolvedIssuesCount || 0
                };
            }
        case 0, $1j2EU.SWAP_ISSUES:
            // @ts-expect-error - TS2322 - Type 'boolean | undefined' is not assignable to type 'boolean'.
            return {
                ...state,
                shouldSwapIssues: action.payload
            };
        case 0, $1j2EU.SET_HANDLERS:
            {
                const handlers = action.payload;
                return {
                    ...state,
                    handlers: (0, (/*@__PURE__*/$parcel$interopDefault($1O6Yz)))({}, state.handlers, handlers)
                };
            }
        case 0, $1j2EU.INITIAL_REQUEST_SUCCESS:
            {
                const version = action.payload;
                // @ts-expect-error - TS2322 - Type 'Pick<{ version: ReleasableVersion | undefined; context: { readonly readonly projectKey: string; }; handlers: Handlers; errors?: ReleaseVersionValidationErrors | undefined; isInitiating?: boolean | undefined; isSaving?: boolean | undefined; shouldSwapIssues: boolean; }, "version" | ... 4 more ... | "...' is not assignable to type 'State'.
                return (0, (/*@__PURE__*/$parcel$interopDefault($jFHCE)))({
                    ...state,
                    version: version
                }, 'isInitiating');
            }
        case 0, $1j2EU.RELEASE_VERSION_UPDATE:
            {
                const prevVersion = state.version;
                const prevErrors = state.errors;
                const nextVersion = action.payload;
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const errors = {};
                if (action.payload && action.payload.moveUnfixedIssuesTo) errors.moveUnfixedIssuesTo = '';
                if (action.payload && action.payload.releaseDate) errors.releaseDate = '';
                return {
                    ...state,
                    errors: (0, (/*@__PURE__*/$parcel$interopDefault($Xz6kS)))({}, prevErrors, errors),
                    version: (0, (/*@__PURE__*/$parcel$interopDefault($Xz6kS)))({}, prevVersion, nextVersion)
                };
            }
        case 0, $1j2EU.RELEASE_VERSION_VALIDATION_FAILURE:
            {
                const errors = action.payload;
                return (0, (/*@__PURE__*/$parcel$interopDefault($jFHCE)))({
                    ...state,
                    errors: errors
                }, 'isSaving');
            }
        case 0, $1j2EU.RELEASE_VERSION_REQUEST:
            return {
                ...state,
                isSaving: true
            };
        case 0, $1j2EU.RELEASE_VERSION_SUCCESS:
        case 0, $1j2EU.RELEASE_VERSION_FAILURE:
            return (0, (/*@__PURE__*/$parcel$interopDefault($jFHCE)))(state, 'isSaving');
        case 0, $1j2EU.INITIAL_REQUEST:
            return state;
        case 0, $1j2EU.CREATE_RELEASE_NOTES_OPTIONS:
            return {
                ...state,
                ...action.payload,
                shouldRedirectToCreateReleaseNotes: !(action.payload?.hasReleaseNote ?? false)
            };
        case 0, $1j2EU.RELEASE_SET_REDIRECT_TO_CREATE_RELEASE_NOTES_STATUS:
            {
                const shouldRedirectToCreateReleaseNotes = action.payload !== undefined ? action.payload : false;
                return {
                    ...state,
                    shouldRedirectToCreateReleaseNotes: shouldRedirectToCreateReleaseNotes
                };
            }
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};
var $1940dfed1e9cdbea$export$2e2bcd8739ae039 = $1940dfed1e9cdbea$var$reducer;

});


parcelRegister("55VVW", function(module, exports) {
$parcel$export(module.exports, "default", () => $509dc8b928671c4f$export$2e2bcd8739ae039);

var $gnQAk = parcelRequire("gnQAk");

var $1j2EU = parcelRequire("1j2EU");

var $gLW5o = parcelRequire("gLW5o");

var $btYbu = parcelRequire("btYbu");

var $fZ8fz = parcelRequire("fZ8fz");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $509dc8b928671c4f$var$mapStateToProps = (state)=>({
        unresolvedIssuesCount: (0, $gLW5o.getUnresolvedIssuesCount)(state),
        isReleaseDisabled: (0, $gLW5o.isReleaseDisabled)(state),
        name: (0, $gLW5o.getName)(state),
        isSaving: (0, $gLW5o.isSaving)(state),
        isInitiating: (0, $gLW5o.isInitiating)(state),
        onCancel: (0, $gLW5o.getOnCancelHandler)(state),
        Content: $btYbu.default,
        shouldRedirectToCreateReleaseNotes: (0, $gLW5o.shouldRedirectToCreateReleaseNotes)(state),
        shouldShowCreateReleaseNotesOption: (0, $gLW5o.shouldShowCreateReleaseNotesOption)(state)
    });
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $509dc8b928671c4f$var$dispatcher = (dispatch)=>({
        onRelease: ()=>dispatch((0, $1j2EU.releaseVersionRequest)()),
        setRedirectToCreateReleaseNotesStatus: (value)=>dispatch((0, $1j2EU.releaseRedirectToCreateReleaseNotesStatus)(value))
    });
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $509dc8b928671c4f$var$mapDispatchToProps = (dispatch)=>$509dc8b928671c4f$var$dispatcher(dispatch);
var $509dc8b928671c4f$export$2e2bcd8739ae039 = (0, $gnQAk.connect)($509dc8b928671c4f$var$mapStateToProps, $509dc8b928671c4f$var$mapDispatchToProps)((0, $fZ8fz.default));

});
parcelRegister("btYbu", function(module, exports) {
$parcel$export(module.exports, "default", () => $25159c5cf854cb39$export$2e2bcd8739ae039);

var $gnQAk = parcelRequire("gnQAk");

var $duHz5 = parcelRequire("duHz5");

var $gLW5o = parcelRequire("gLW5o");

var $6bKRV = parcelRequire("6bKRV");

var $aMFUs = parcelRequire("aMFUs");

var $7LVYa = parcelRequire("7LVYa");

var $kb64x = parcelRequire("kb64x");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $25159c5cf854cb39$var$mapStateToProps = (state)=>({
        SwapIssues: $7LVYa.default,
        ReleaseDate: $aMFUs.default,
        ReleaseAutomationBanner: $6bKRV.ReleaseAutomationBanner,
        doneIssues: (0, $gLW5o.getDoneIssuesCount)(state),
        unresolvedIssuesCount: (0, $gLW5o.getUnresolvedIssuesCount)(state),
        resolvedIssuesCount: (0, $gLW5o.getResolvedIssuesCount)(state),
        unresolvedIssuesUrl: (0, $duHz5.getUnresolvedIssuesInVersionJql)((0, $gLW5o.getProjectKey)(state), (0, $gLW5o.getName)(state)),
        resolvedIssueUrl: (0, $duHz5.getResolvedIssuesInVersionJql)((0, $gLW5o.getProjectKey)(state), (0, $gLW5o.getName)(state))
    });
var $25159c5cf854cb39$export$2e2bcd8739ae039 = (0, $gnQAk.connect)($25159c5cf854cb39$var$mapStateToProps, {})((0, $kb64x.default));

});
parcelRegister("duHz5", function(module, exports) {
$parcel$export(module.exports, "getUnresolvedIssuesInVersionJql", () => $c1dc4f42aad7c9ce$export$6ec377b2fc8168c7);
$parcel$export(module.exports, "getResolvedIssuesInVersionJql", () => $c1dc4f42aad7c9ce$export$c14e075033246e76);

var $bnIBr = parcelRequire("bnIBr");
const $c1dc4f42aad7c9ce$export$6ec377b2fc8168c7 = (projectKey, versionName)=>{
    const jql = `project = ${(0, $bnIBr.toQuotedString)(projectKey)} AND fixVersion = ${(0, $bnIBr.toQuotedString)(versionName)} AND resolution is EMPTY`;
    return (0, $bnIBr.createAllWorkUrl)(jql);
};
const $c1dc4f42aad7c9ce$export$c14e075033246e76 = (projectKey, versionName)=>(0, $bnIBr.createAllWorkUrl)(`project = ${(0, $bnIBr.toQuotedString)(projectKey)} AND fixVersion = ${(0, $bnIBr.toQuotedString)(versionName)} AND resolution is NOT EMPTY`);

});
parcelRegister("bnIBr", function(module, exports) {
$parcel$export(module.exports, "toQuotedString", () => $a183e8d5995c289a$export$dbeab020a4aa404);
$parcel$export(module.exports, "createProjectAllWorkUri", () => $a183e8d5995c289a$export$497544a08e0b5e51);
$parcel$export(module.exports, "createAllWorkUrl", () => $a183e8d5995c289a$export$ca075a1255c9a76d);

var $4cTDP = parcelRequire("4cTDP");
const $a183e8d5995c289a$var$ENCODE_MAP = {
    '\t': '\\t',
    '\n': '\\n',
    '\r': '\\r',
    '"': '\\"',
    "'": "\\'",
    '\\': '\\\\'
};
const $a183e8d5995c289a$export$946fe289c25510be = (character, ignoredCharacter)=>{
    if (character === ignoredCharacter) return character;
    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly '\t': "\\t"; readonly '\n': "\\n"; readonly '\r': "\\r"; readonly '"': "\\\""; readonly "'": "\\'"; readonly '\\': "\\\\"; }'.
    return $a183e8d5995c289a$var$ENCODE_MAP[character] || character;
};
const $a183e8d5995c289a$export$dbeab020a4aa404 = (parameter)=>{
    let escaped = '';
    for(let position = 0; position < parameter.length; position += 1)escaped += $a183e8d5995c289a$export$946fe289c25510be(parameter[position], "'");
    return `"${escaped}"`;
};
const $a183e8d5995c289a$export$497544a08e0b5e51 = (jql)=>(0, $4cTDP.fg)('jira_list_nin_merge') ? `/list/?jql=${encodeURIComponent(jql)}` : `/issues/?jql=${encodeURIComponent(jql)}`;
const $a183e8d5995c289a$export$ca075a1255c9a76d = (jql)=>`/issues/?jql=${encodeURIComponent(jql)}`;

});


parcelRegister("6bKRV", function(module, exports) {
$parcel$export(module.exports, "ReleaseAutomationBanner", () => $cdcff1031e7cba19$export$45e1a2bd60e730ec);
/* ReleaseAutomationBanner.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $bmZ1f = parcelRequire("bmZ1f");

var $goZPP = parcelRequire("goZPP");

var $6zhpo = parcelRequire("6zhpo");

var $4ECjj = parcelRequire("4ECjj");

var $lRq8t = parcelRequire("lRq8t");

var $kGj4V = parcelRequire("kGj4V");
var $eS29z = parcelRequire("eS29z");
var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $2aY2d = parcelRequire("2aY2d");

var $6a5Bv = parcelRequire("6a5Bv");

var $jM32i = parcelRequire("jM32i");

var $hh0mH = parcelRequire("hh0mH");
const $cdcff1031e7cba19$export$d6be0a6034032add = (projectProps)=>`${(0, $4ECjj.getBaseAutomationUrl)(projectProps)}#rule/new?componentFilterCriteria=RELEASE_MANAGEMENT_TRIGGERS`;
const $cdcff1031e7cba19$export$45e1a2bd60e730ec = ({ isTransitionEnabled: isTransitionEnabled = true })=>{
    const { showBanner: showBanner, dismissBanner: dismissBanner } = (0, $6a5Bv.useReleaseAutomationBanner)();
    const { data: projectContext, loading: loading, error: error } = (0, $2aY2d.useProjectContext)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    if (loading) return null;
    if (error) throw error;
    if (projectContext == null) throw Error('Missing project context when rendering ReleaseAutomationBanner');
    const { simplified: isSimplified, projectKey: projectKey, projectType: projectType } = projectContext;
    const renderBannerContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($cdcff1031e7cba19$var$Spacer, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($cdcff1031e7cba19$var$Section, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("img", {
        width: 14,
        height: 16,
        src: (0, (/*@__PURE__*/$parcel$interopDefault($jM32i))),
        alt: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($cdcff1031e7cba19$var$CallToAction, {
        href: $cdcff1031e7cba19$export$d6be0a6034032add({
            isSimplified: isSimplified,
            projectKey: projectKey,
            projectType: projectType
        }),
        target: "_blank",
        rel: "noopener noreferrer",
        title: formatMessage((0, $hh0mH.default).setupReleaseAutomation),
        onClick: ()=>{
            (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'link'
            }), 'newRuleAutomationLink');
            dismissBanner();
        }
    }, formatMessage((0, $hh0mH.default).setupReleaseAutomation)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($cdcff1031e7cba19$var$Dismiss, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        shouldFitContainer: true,
        appearance: "subtle" // eslint-disable-next-line jira/react-no-inline-function-prop
        ,
        onClick: (_, analyticsEvent)=>{
            (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'dismissButton');
            dismissBanner();
        },
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6zhpo))), {
            label: formatMessage((0, $hh0mH.default).dismiss)
        })
    }))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kGj4V.ContextualAnalyticsData), {
        sourceType: (0, $aa42ce8e355d58fa$export$238d30785c4bca84),
        sourceName: "releaseAutomationCallToAction"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eS29z.FireScreenAnalytics), null), isTransitionEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($cdcff1031e7cba19$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bmZ1f.default), {
        in: showBanner,
        timeout: $cdcff1031e7cba19$var$TRANSITION_DURATION,
        classNames: "release-automation-banner",
        unmountOnExit: true
    }, renderBannerContent)) : renderBannerContent);
};
const $cdcff1031e7cba19$var$BANNER_HEIGHT = 80;
const $cdcff1031e7cba19$var$TRANSITION_DURATION = 400; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cdcff1031e7cba19$var$Section = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "section", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rko12b0 _zulppxbi _189e1dm9 _1dqonqa1 _1h6d1l7x _1e0c1txw _4cvr1h6o _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cdcff1031e7cba19$var$CallToAction = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _16jlkb7n _1bto1l2s",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cdcff1031e7cba19$var$Dismiss = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1bsbzwfg",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cdcff1031e7cba19$var$Spacer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_4t3i1tcg",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cdcff1031e7cba19$var$Wrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_lnbg15vq _11ok15vq _1k7uidpf _pmb0idpf _1sz115vq _iayz15vq _19q1o91y _lghnkb7n _3g9qys9h _1b0e15vq _19ci15vq _28jmkb7n _13e1ys9h _1g5d15vq _153n15vq _khvao91y _zsv0idpf _qigkidpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("4ECjj", function(module, exports) {
$parcel$export(module.exports, "getBaseAutomationUrl", () => $b690f45aef8a790c$export$8e479e490e1e69bc);
const $b690f45aef8a790c$export$8e479e490e1e69bc = ({ projectKey: projectKey, projectType: projectType, isSimplified: isSimplified })=>{
    /**
	 * Confusing mapping of urls here.
	 * Classic Projects - always under /automate
	 * Next Gen Projects - under /automation for all project types except JSD
	 */ if (projectType === 'service_desk') return `/jira/servicedesk/projects/${projectKey}/settings/automate`;
    if (projectType === 'business') return `/jira/core/projects/${projectKey}/settings/${isSimplified ? 'automation' : 'automate'}`;
    return `/jira/software/${isSimplified ? '' : 'c/'}projects/${projectKey}/settings/${isSimplified ? 'automation' : 'automate'}`;
};

});

parcelRegister("jM32i", function(module, exports) {
module.exports = new URL("lightning.44c03a60.svg", import.meta.url).toString();

});

parcelRegister("hh0mH", function(module, exports) {
$parcel$export(module.exports, "default", () => $5f22b00838365592$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $5f22b00838365592$var$messages = (0, $7qGN1.defineMessages)({
    setupReleaseAutomation: {
        "id": "project-directories.versions.release-version-modal.content.release-automation-banner.setup-release-automation",
        "defaultMessage": "Set up release automation"
    },
    dismiss: {
        "id": "project-directories.versions.release-version-modal.content.release-automation-banner.dismiss",
        "defaultMessage": "Dismiss"
    }
});
var $5f22b00838365592$export$2e2bcd8739ae039 = $5f22b00838365592$var$messages;

});


parcelRegister("aMFUs", function(module, exports) {
$parcel$export(module.exports, "default", () => $7a46d50b5ab0119a$export$2e2bcd8739ae039);

var $gnQAk = parcelRequire("gnQAk");

var $1j2EU = parcelRequire("1j2EU");

var $gLW5o = parcelRequire("gLW5o");

var $hzbrQ = parcelRequire("hzbrQ");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $7a46d50b5ab0119a$var$mapStateToProps = (state)=>({
        releaseDate: (0, $gLW5o.getReleaseDate)(state),
        errors: (0, $gLW5o.getErrors)(state),
        isSaving: (0, $gLW5o.isSaving)(state)
    });
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $7a46d50b5ab0119a$var$dispatcher = (dispatch)=>({
        // @ts-expect-error - TS7006 - Parameter 'version' implicitly has an 'any' type.
        onInputChange: (version)=>dispatch((0, $1j2EU.releaseVersionUpdate)(version))
    });
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $7a46d50b5ab0119a$var$mapDispatchToProps = (dispatch)=>$7a46d50b5ab0119a$var$dispatcher(dispatch);
var $7a46d50b5ab0119a$export$2e2bcd8739ae039 = (0, $gnQAk.connect)($7a46d50b5ab0119a$var$mapStateToProps, $7a46d50b5ab0119a$var$mapDispatchToProps)((0, $hzbrQ.default));

});
parcelRegister("hzbrQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $7633d1d443ba987b$export$2e2bcd8739ae039);
/* ReleaseDatePicker.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $fTjQo = parcelRequire("fTjQo");

var $iUa8i = parcelRequire("iUa8i");

var $6svxr = parcelRequire("6svxr");

var $h3OS7 = parcelRequire("h3OS7");

var $idGBm = parcelRequire("idGBm");

var $fgNUD = parcelRequire("fgNUD");

var $fvP65 = parcelRequire("fvP65");
class $7633d1d443ba987b$export$55e7fadddcffb796 extends (0, $eJOHy.Component) {
    inputChange(update) {
        const { onInputChange: onInputChange } = this.props;
        onInputChange({
            releaseDate: update.releaseDate
        });
    }
    render() {
        const { intl: { formatMessage: formatMessage, locale: locale }, releaseDate: releaseDate, errors: errors, isSaving: isSaving } = this.props;
        const { releaseDate: releaseDateError } = errors;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6svxr.default), {
            id: formatMessage((0, $fvP65.default).releaseDate),
            name: "releaseDate",
            label: formatMessage((0, $fvP65.default).releaseDate)
        }, ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($7633d1d443ba987b$var$DatePickerContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fgNUD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iUa8i.default), {
                id: formatMessage((0, $fvP65.default).releaseDate),
                isDisabled: isSaving,
                defaultValue: releaseDate !== '' ? (0, $fTjQo.default)(new Date(releaseDate)) : releaseDate,
                onChange: this.onReleaseDateChange,
                placeholder: formatMessage((0, $h3OS7.default).placeholderDate),
                locale: locale,
                shouldShowCalendarButton: true
            })))), releaseDateError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($7633d1d443ba987b$var$ValidationError, null, releaseDateError));
    }
    constructor(...args){
        super(...args), this.onReleaseDateChange = (releaseDate)=>{
            if (releaseDate) this.inputChange({
                releaseDate: releaseDate
            });
            else this.inputChange({
                releaseDate: ''
            });
        };
    }
}
var $7633d1d443ba987b$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, $idGBm.injectIntlV2)($7633d1d443ba987b$export$55e7fadddcffb796);
const $7633d1d443ba987b$var$DatePickerContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1bsb1ssb",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7633d1d443ba987b$var$ValidationError = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19pku2gc _syaz1tmw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("iUa8i", function(module, exports) {
$parcel$export(module.exports, "default", () => $b8d7b5e7995f81e7$export$2e2bcd8739ae039);

var $eGOwo = parcelRequire("eGOwo");

var $1BRZx = parcelRequire("1BRZx");

var $lLHJE = parcelRequire("lLHJE");

var $k2Uo2 = parcelRequire("k2Uo2");
const $b8d7b5e7995f81e7$var$DatePicker = (0, $1BRZx.componentWithCondition)(()=>(0, $eGOwo.fg)('dst-date-picker-use-functional-component'), (0, $k2Uo2.default), (0, $lLHJE.default));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$b8d7b5e7995f81e7$export$2e2bcd8739ae039 = $b8d7b5e7995f81e7$var$DatePicker;

});
parcelRegister("1BRZx", function(module, exports) {
$parcel$export(module.exports, "componentWithCondition", () => $48de19f2c65a8561$export$6e8ea24b15199873);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");
function $48de19f2c65a8561$export$6e8ea24b15199873(condition, ComponentTrue, ComponentFalse) {
    const ComponentWithCondition = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>// eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore: to unblock React 18.2.0 -> 18.3.1 version bump in Jira
        condition() ? /*#__PURE__*/ (0, $gt9Am.jsx)(ComponentTrue, {
            ...props,
            ref: ref
        }) : /*#__PURE__*/ (0, $gt9Am.jsx)(ComponentFalse, {
            ...props,
            ref: ref
        }));
    if (ComponentTrue.name !== '') ComponentWithCondition.displayName = `ComponentWithCondition[${condition.name}]`;
    return ComponentWithCondition;
}

});

parcelRegister("lLHJE", function(module, exports) {
$parcel$export(module.exports, "default", () => $2fe32780a1f5c05c$export$2e2bcd8739ae039);
/* date-picker-class.tsx generated by @compiled/babel-plugin v0.36.1 */ /// <reference types="node" />

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $dBLX0 = parcelRequire("dBLX0");
var $kQ82p = parcelRequire("kQ82p");

var $5fWw9 = parcelRequire("5fWw9");
var $dUaMU = parcelRequire("dUaMU");
var $4J0ad = parcelRequire("4J0ad");

var $Ay1uj = parcelRequire("Ay1uj");

var $6qaBj = parcelRequire("6qaBj");

var $gl2vi = parcelRequire("gl2vi");

var $3GKOL = parcelRequire("3GKOL");

var $cK9J2 = parcelRequire("cK9J2");

var $eGOwo = parcelRequire("eGOwo");

var $8IeH1 = parcelRequire("8IeH1");

var $c4OV1 = parcelRequire("c4OV1");
var $e9zKl = parcelRequire("e9zKl");

var $RoXqn = parcelRequire("RoXqn");

var $47or1 = parcelRequire("47or1");

var $hmV0i = parcelRequire("hmV0i");

var $gNwsY = parcelRequire("gNwsY");

var $1u9xN = parcelRequire("1u9xN");

var $7OE9J = parcelRequire("7OE9J");
const $2fe32780a1f5c05c$var$packageName = "platform-pkg";
const $2fe32780a1f5c05c$var$packageVersion = "0.0.0-use.local";
const $2fe32780a1f5c05c$var$datePickerDefaultProps = {
    defaultIsOpen: false,
    defaultValue: '',
    disabled: [],
    disabledDateFilter: (_)=>false,
    locale: 'en-US',
    // These disables are here for proper typing when used as defaults. They
    // should *not* use the `noop` function.
    /* eslint-disable @repo/internal/react/use-noop */ onBlur: (_event)=>{},
    onChange: (_value)=>{},
    onFocus: (_event)=>{} /* eslint-enable @repo/internal/react/use-noop */ 
};
const $2fe32780a1f5c05c$var$styles = {
    pickerContainerStyles: "_kqswh2mm",
    iconContainerStyles: "_v564vrg3 _1e0c1txw _4t3i1osq _kqswstnw _4cvr1h6o _i0dl1kw7 _syaz1rpy _152tze3t _rjxpze3t _30l3azsu",
    iconSpacingWithClearButtonStyles: "_12l2xy5q",
    iconSpacingWithoutClearButtonStyles: "_12l21b66",
    dropdownIndicatorStyles: "_1ul91k8s _1tke1k8s _1e0c1txw _4cvr1h6o _1bah1h6o"
}; // eslint-disable-next-line @repo/internal/react/no-class-components
class $2fe32780a1f5c05c$export$df43d21f5faca9f7 extends (0, $eJOHy.Component) {
    static{
        this.defaultProps = $2fe32780a1f5c05c$var$datePickerDefaultProps;
    }
    constructor(props){
        super(props), this.containerRef = null, this.calendarRef = /*#__PURE__*/ (0, $eJOHy.createRef)(), this.calendarButtonRef = /*#__PURE__*/ (0, $eJOHy.createRef)(), // correctly to allow controlled/uncontrolled usage.
        this.getValue = ()=>this.props.value ?? this.state.value, this.getIsOpen = ()=>this.props.isOpen ?? this.state.isOpen, this.onCalendarChange = ({ iso: iso })=>{
            this.setState({
                calendarValue: (0, $47or1.getParsedISO)({
                    iso: iso
                })
            });
        }, this.onCalendarSelect = ({ iso: iso })=>{
            this.setState({
                selectInputValue: '',
                isOpen: false,
                calendarValue: iso,
                value: iso,
                wasOpenedFromCalendarButton: false
            });
            this.props.onChange(iso); // Yes, this is not ideal. The alternative is to be able to place a ref
            // on the inner input of Select itself, which would require a lot of
            // extra stuff in the Select component for only this one thing. While
            // this would be more "React-y", it doesn't seem to pose any other
            // benefits. Performance-wise, we are only searching within the
            // container, so it's quick.
            if (this.state.wasOpenedFromCalendarButton) this.calendarButtonRef.current?.focus();
            else {
                const innerCombobox = this.containerRef?.querySelector('[role="combobox"]');
                innerCombobox?.focus();
            }
            this.setState({
                isOpen: false
            });
        }, this.onInputClick = ()=>{
            if (!this.props.isDisabled && !this.getIsOpen()) this.setState({
                isOpen: true,
                wasOpenedFromCalendarButton: false
            });
        }, this.onContainerBlur = (event)=>{
            const newlyFocusedElement = event.relatedTarget;
            if (!this.containerRef?.contains(newlyFocusedElement)) {
                this.setState({
                    isOpen: false,
                    shouldSetFocusOnCurrentDay: false,
                    wasOpenedFromCalendarButton: false
                });
                this.props.onBlur(event);
            }
        }, this.onContainerFocus = ()=>{
            this.setState({
                shouldSetFocusOnCurrentDay: false
            });
        }, this.onSelectBlur = (event)=>{
            const newlyFocusedElement = event.relatedTarget;
            if (this.state.clearingFromIcon) // Don't close menu if blurring after the user has clicked clear
            this.setState({
                clearingFromIcon: false
            });
            else if (!this.containerRef?.contains(newlyFocusedElement)) // Don't close menu if focus is staying within the date picker's
            // container. Makes keyboard accessibility of calendar possible
            this.setState({
                isOpen: false,
                isFocused: false,
                wasOpenedFromCalendarButton: false
            });
        }, this.onSelectFocus = (event)=>{
            const { clearingFromIcon: clearingFromIcon } = this.state;
            const value = this.getValue();
            if (clearingFromIcon) // Don't open menu if focussing after the user has clicked clear
            this.setState({
                clearingFromIcon: false
            });
            else this.setState({
                // Don't open when focused into via keyboard if the calendar button is present
                isOpen: !this.props.shouldShowCalendarButton,
                calendarValue: value,
                isFocused: true,
                wasOpenedFromCalendarButton: false
            });
            this.props.onFocus(event);
        }, this.onTextInput = (event)=>{
            const inputValue = event.target.value;
            if (inputValue) {
                const parsed = (0, $47or1.parseDate)(inputValue, {
                    parseInputValue: this.props.parseInputValue,
                    dateFormat: this.props.dateFormat,
                    l10n: this.state.l10n
                }); // Only try to set the date if we have month & day
                if (parsed && (0, $dBLX0.default)(parsed)) // We format the parsed date to YYYY-MM-DD here because
                // this is the format expected by the @atlaskit/calendar component
                this.setState({
                    calendarValue: (0, $1u9xN.getShortISOString)(parsed)
                });
            }
            this.setState({
                isOpen: true,
                wasOpenedFromCalendarButton: false
            });
        }, this.onInputKeyDown = (event)=>{
            const { calendarValue: calendarValue } = this.state;
            const value = this.getValue();
            const keyPressed = event.key.toLowerCase(); // If the input is focused and the calendar is not visible, handle space and enter clicks
            if (!this.state.isOpen && (keyPressed === 'enter' || keyPressed === ' ')) this.setState({
                isOpen: true,
                wasOpenedFromCalendarButton: false
            });
            switch(keyPressed){
                case 'escape':
                    // Yes, this is not ideal. The alternative is to be able to place a ref
                    // on the inner input of Select itself, which would require a lot of
                    // extra stuff in the Select component for only this one thing. While
                    // this would be more "React-y", it doesn't seem to pose any other
                    // benefits. Performance-wise, we are only searching within the
                    // container, so it's quick.
                    if (this.state.wasOpenedFromCalendarButton) this.calendarButtonRef.current?.focus();
                    else {
                        const innerCombobox = this.containerRef?.querySelector('[role="combobox"]');
                        innerCombobox?.focus();
                    }
                    this.setState({
                        isOpen: false,
                        shouldSetFocusOnCurrentDay: false,
                        wasOpenedFromCalendarButton: false
                    });
                    break;
                case 'backspace':
                case 'delete':
                    {
                        const inputCount = 0;
                        if (value && event.target instanceof HTMLInputElement && event.target.value.length <= inputCount) // If being cleared from keyboard, don't change behaviour
                        this.setState({
                            clearingFromIcon: false,
                            value: ''
                        });
                        break;
                    }
                case 'enter':
                    if (!this.state.isOpen) return;
                     // Prevent form submission when a date is selected
                    // using enter. See https://product-fabric.atlassian.net/browse/DSP-2501
                    // for more details.
                    event.preventDefault();
                    if (!(0, $47or1.isDateDisabled)(calendarValue, {
                        disabled: this.props.disabled
                    })) {
                        // Get a safe `calendarValue` in case the value exceeds the maximum
                        // allowed by ISO 8601
                        const safeCalendarValue = (0, $1u9xN.getSafeCalendarValue)(calendarValue);
                        const valueChanged = safeCalendarValue !== value;
                        this.setState({
                            selectInputValue: '',
                            isOpen: false,
                            value: safeCalendarValue,
                            calendarValue: safeCalendarValue,
                            wasOpenedFromCalendarButton: false
                        });
                        if (valueChanged) this.props.onChange(safeCalendarValue);
                    }
                    break;
                case 'arrowdown':
                case 'arrowup':
                    if (!this.state.shouldSetFocusOnCurrentDay) this.setState({
                        isOpen: true,
                        shouldSetFocusOnCurrentDay: true
                    });
                    break;
                default:
                    break;
            }
        }, this.onCalendarButtonKeyDown = (e)=>{
            // Don't allow an arrow up or down to open the menu, since the input key
            // down handler is actually on the parent.
            if (e.type === 'keydown' && (e.key === 'ArrowDown' || e.key === 'ArrowUp')) e.stopPropagation();
             // We want to stop this from triggering other keydown events, particularly
            // for space and enter presses. Otherwise, it opens and then closes
            // immediately.
            if (e.type === 'keydown' && (e.key === ' ' || e.key === 'Enter')) {
                e.stopPropagation();
                this.setState({
                    isKeyDown: true,
                    wasOpenedFromCalendarButton: true
                });
            }
        } // This event handler is triggered from both keydown and click. It's weird.
        , this.onCalendarButtonClick = (e)=>{
            this.setState({
                isOpen: !this.state.isOpen,
                wasOpenedFromCalendarButton: true
            }, ()=>{
                // We don't want the focus to move if this is a click event
                if (!this.state.isKeyDown) return;
                this.setState({
                    isKeyDown: false
                }); // Focus on the first button within the calendar
                this.calendarRef?.current?.querySelector('button')?.focus();
            });
            e.stopPropagation();
        }, this.onClear = ()=>{
            let changedState = {
                value: '',
                calendarValue: this.props.defaultValue || (0, $1u9xN.getShortISOString)(new Date())
            };
            if (!this.props.hideIcon) changedState = {
                ...changedState,
                clearingFromIcon: true
            };
            this.setState(changedState);
            this.props.onChange('');
        } // `unknown` is used because `value` is unused so it does not matter.
        , this.onSelectChange = (_value, action)=>{
            // Used for native clear event in React Select
            // Triggered when clicking ClearIndicator or backspace with no value
            if (action.action === 'clear') this.onClear();
        }, this.handleSelectInputChange = (selectInputValue, actionMeta)=>{
            const onInputChange = this.props.selectProps?.onInputChange;
            if (onInputChange) onInputChange(selectInputValue, actionMeta);
            this.setState({
                selectInputValue: selectInputValue
            });
        }, this.getContainerRef = (ref)=>{
            const oldRef = this.containerRef;
            this.containerRef = ref; // Cause a re-render if we're getting the container ref for the first time
            // as the layered menu requires it for dimension calculation
            if (oldRef == null && ref != null) this.forceUpdate();
        };
        this.state = {
            isKeyDown: false,
            isOpen: this.props.defaultIsOpen,
            isFocused: false,
            clearingFromIcon: false,
            selectInputValue: this.props.selectProps?.inputValue || '',
            value: this.props.value || this.props.defaultValue,
            calendarValue: this.props.value || this.props.defaultValue || (0, $1u9xN.getShortISOString)(new Date()),
            l10n: (0, $cK9J2.createLocalizationProvider)(this.props.locale),
            locale: this.props.locale,
            shouldSetFocusOnCurrentDay: false,
            wasOpenedFromCalendarButton: false
        };
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.locale !== prevState.locale) return {
            l10n: (0, $cK9J2.createLocalizationProvider)(nextProps.locale),
            locale: nextProps.locale
        };
        else return null;
    }
    render() {
        const { appearance: appearance = 'default', 'aria-describedby': ariaDescribedBy, autoFocus: autoFocus = false, clearControlLabel: clearControlLabel = 'Clear', hideIcon: hideIcon = false, openCalendarLabel: openCalendarLabel = 'Open calendar', disabled: disabled, disabledDateFilter: disabledDateFilter, icon: Icon = (0, (/*@__PURE__*/$parcel$interopDefault($3GKOL))), id: id = '', innerProps: innerProps = {}, inputLabel: inputLabel = 'Date picker', inputLabelId: inputLabelId, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isRequired: isRequired = false, label: label = '', locale: locale, maxDate: maxDate, minDate: minDate, name: name = '', nextMonthLabel: nextMonthLabel, previousMonthLabel: previousMonthLabel, selectProps: selectProps = {}, shouldShowCalendarButton: shouldShowCalendarButton, spacing: spacing = 'default', testId: testId, weekStartDay: weekStartDay } = this.props;
        const { calendarValue: calendarValue, selectInputValue: selectInputValue } = this.state;
        const value = this.getValue();
        let actualSelectInputValue;
        actualSelectInputValue = selectInputValue;
        const menuIsOpen = this.getIsOpen() && !isDisabled;
        const showClearIndicator = Boolean((value || selectInputValue) && !hideIcon);
        let clearIndicator = Icon;
        if ((0, $eGOwo.fg)('platform-visual-refresh-icons')) clearIndicator = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                xcss: $2fe32780a1f5c05c$var$styles.dropdownIndicatorStyles,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)(Icon, {
                    ...props
                })
            });
        const dropDownIcon = appearance === 'subtle' || hideIcon || showClearIndicator ? null : clearIndicator;
        const selectComponents = {
            DropdownIndicator: shouldShowCalendarButton ? (0, $RoXqn.EmptyComponent) : dropDownIcon,
            // Only use this new container component if the calendar button is shown.
            // Otherwise, it throws errors downstream for some reason
            ...shouldShowCalendarButton ? {
                IndicatorsContainer: (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $hmV0i.IndicatorsContainer), {
                        ...props,
                        showClearIndicator: showClearIndicator
                    })
            } : {},
            Menu: $gNwsY.Menu,
            // SingleValue is defined in the render because of UI generator limitations
            ...!showClearIndicator && {
                ClearIndicator: (0, $RoXqn.EmptyComponent)
            },
            ...selectProps.components
        };
        const { styles: selectStyles = {} } = selectProps;
        const disabledStyle = isDisabled ? {
            pointerEvents: 'none',
            color: "var(--ds-icon-disabled, inherit)"
        } : {};
        const calendarProps = {
            calendarContainerRef: this.containerRef,
            calendarDisabled: disabled,
            calendarDisabledDateFilter: disabledDateFilter,
            calendarMaxDate: maxDate,
            calendarMinDate: minDate,
            calendarRef: this.calendarRef,
            calendarValue: value && (0, $1u9xN.getShortISOString)((0, $kQ82p.default)(value)),
            calendarView: calendarValue,
            onCalendarChange: this.onCalendarChange,
            onCalendarSelect: this.onCalendarSelect,
            calendarLocale: locale,
            calendarWeekStartDay: weekStartDay,
            shouldSetFocusOnCurrentDay: this.state.shouldSetFocusOnCurrentDay,
            menuInnerWrapper: this.props.menuInnerWrapper
        }; // @ts-ignore -- Argument of type 'StylesConfig<OptionType, false, GroupBase<OptionType>>' is not assignable to parameter of type 'StylesConfig<OptionType, boolean, GroupBase<OptionType>>'.
        const mergedStyles = (0, $e9zKl.mergeStyles)(selectStyles, {
            control: (base)=>({
                    ...base,
                    ...disabledStyle
                }),
            indicatorsContainer: (base)=>({
                    ...base,
                    paddingLeft: "var(--ds-space-025, 2px)",
                    // ICON_PADDING = 2
                    paddingRight: "var(--ds-space-075, 6px)" // 8 - ICON_PADDING = 6
                })
        });
        const initialValue = value ? {
            label: (0, $47or1.formatDate)(value, {
                formatDisplayLabel: this.props.formatDisplayLabel,
                dateFormat: this.props.dateFormat,
                l10n: this.state.l10n
            }),
            value: value
        } : null; // `label` takes precedence of the `inputLabel`
        const fullopenCalendarLabel = label || inputLabel ? `${label || inputLabel}, ${openCalendarLabel}` : openCalendarLabel;
        return /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
            ...innerProps,
            role: "presentation",
            onBlur: this.onContainerBlur,
            onFocus: this.onContainerFocus,
            onClick: this.onInputClick,
            onInput: this.onTextInput,
            onKeyDown: this.onInputKeyDown,
            ref: this.getContainerRef,
            "data-testid": testId && `${testId}--container`,
            className: (0, $hcewu.default)([
                $2fe32780a1f5c05c$var$styles.pickerContainerStyles
            ]),
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)("input", {
                    name: name,
                    type: "hidden",
                    value: value,
                    "data-testid": testId && `${testId}--input`
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gl2vi.IdProvider), {
                    children: ({ id: valueId })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $c4OV1.default), {
                            appearance: this.props.appearance,
                            "aria-describedby": ariaDescribedBy ? `${ariaDescribedBy} ${valueId}` : valueId,
                            label: label || undefined,
                            autoFocus: autoFocus,
                            clearControlLabel: clearControlLabel,
                            closeMenuOnSelect: true,
                            enableAnimation: false,
                            inputId: id,
                            inputValue: actualSelectInputValue,
                            isDisabled: isDisabled,
                            isRequired: isRequired,
                            menuIsOpen: menuIsOpen,
                            onBlur: this.onSelectBlur,
                            onChange: this.onSelectChange,
                            onFocus: this.onSelectFocus,
                            onInputChange: this.handleSelectInputChange,
                            placeholder: (0, $47or1.getPlaceholder)({
                                placeholder: this.props.placeholder,
                                l10n: this.state.l10n
                            }),
                            styles: mergedStyles,
                            value: initialValue,
                            ...selectProps,
                            // up when you alter some of the properties in the `selectComponents`
                            // object. These errors are still present, and I suspect have always
                            // been present, without changing the unrelated code. Ignoring as the
                            // component still works as expected despite this error. And also
                            // because the select refresh team may solve it later.
                            components: {
                                ...selectComponents,
                                SingleValue: (0, $7OE9J.makeSingleValue)({
                                    id: valueId,
                                    lang: this.props.locale
                                })
                            },
                            // selectProps or not and what wil be overwritten
                            isClearable: true,
                            isInvalid: isInvalid,
                            spacing: spacing,
                            testId: testId,
                            // @ts-ignore --  Property 'calendarContainerRef' does not exist on type 'IntrinsicAttributes & LibraryManagedAttributes<(<Option extends unknown = OptionType, IsMulti extends boolean = false>(props: AtlaskitSelectProps<Option, IsMulti> & { ...; }) => Element), AtlaskitSelectProps<...> & { ...; }>'.
                            calendarContainerRef: calendarProps.calendarContainerRef,
                            calendarDisabled: calendarProps.calendarDisabled,
                            calendarDisabledDateFilter: calendarProps.calendarDisabledDateFilter,
                            calendarLocale: calendarProps.calendarLocale,
                            calendarMaxDate: calendarProps.calendarMaxDate,
                            calendarMinDate: calendarProps.calendarMinDate,
                            calendarRef: calendarProps.calendarRef,
                            calendarValue: calendarProps.calendarValue,
                            calendarView: calendarProps.calendarView,
                            calendarWeekStartDay: calendarProps.calendarWeekStartDay,
                            nextMonthLabel: nextMonthLabel,
                            onCalendarChange: calendarProps.onCalendarChange,
                            onCalendarSelect: calendarProps.onCalendarSelect,
                            previousMonthLabel: previousMonthLabel,
                            shouldSetFocusOnCurrentDay: calendarProps.shouldSetFocusOnCurrentDay,
                            menuInnerWrapper: calendarProps.menuInnerWrapper
                        })
                }),
                shouldShowCalendarButton && !isDisabled ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gl2vi.IdProvider), {
                    prefix: "open-calendar-label--",
                    children: ({ id: openCalendarLabelId })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                            xcss: (0, $6qaBj.cx)($2fe32780a1f5c05c$var$styles.iconContainerStyles, value && !hideIcon ? $2fe32780a1f5c05c$var$styles.iconSpacingWithClearButtonStyles : $2fe32780a1f5c05c$var$styles.iconSpacingWithoutClearButtonStyles),
                            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $Ay1uj.default), {
                                appearance: "subtle",
                                label: !inputLabelId ? fullopenCalendarLabel : openCalendarLabel,
                                "aria-labelledby": inputLabelId ? `${inputLabelId} ${openCalendarLabelId}` : undefined,
                                id: openCalendarLabelId,
                                icon: (iconProps)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3GKOL))), {
                                        ...iconProps,
                                        color: "var(--ds-icon, #292A2E)"
                                    }),
                                onClick: this.onCalendarButtonClick,
                                onKeyDown: this.onCalendarButtonKeyDown,
                                ref: this.calendarButtonRef,
                                testId: testId && `${testId}--open-calendar-button`
                            })
                        })
                }) : null
            ]
        });
    }
}
const $2fe32780a1f5c05c$var$DatePicker = (0, $dUaMU.default)({
    componentName: 'datePicker',
    packageName: $2fe32780a1f5c05c$var$packageName,
    packageVersion: $2fe32780a1f5c05c$var$packageVersion
})((0, $4J0ad.default)({
    onChange: (0, $5fWw9.default)('atlaskit')({
        action: 'selectedDate',
        actionSubject: 'datePicker',
        attributes: {
            componentName: 'datePicker',
            packageName: $2fe32780a1f5c05c$var$packageName,
            packageVersion: $2fe32780a1f5c05c$var$packageVersion
        }
    })
})($2fe32780a1f5c05c$export$df43d21f5faca9f7));
var $2fe32780a1f5c05c$export$2e2bcd8739ae039 = $2fe32780a1f5c05c$var$DatePicker;

});
parcelRegister("3GKOL", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e82594be434237a3254dda0015850bff>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2af99c62070f9b2c$var$_react = $2af99c62070f9b2c$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $2af99c62070f9b2c$var$_calendar = $2af99c62070f9b2c$var$_interopRequireDefault((parcelRequire("btkTq")));

var $2af99c62070f9b2c$var$_calendar2 = $2af99c62070f9b2c$var$_interopRequireDefault((parcelRequire("76JV8")));
function $2af99c62070f9b2c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CalendarIcon.
 * This component is CalendarIcon, with `UNSAFE_fallbackIcon` set to "CalendarIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: date metadata, date input field, calendar view, jira status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2af99c62070f9b2c$var$CalendarIcon = (props)=>/*#__PURE__*/ $2af99c62070f9b2c$var$_react.default.createElement($2af99c62070f9b2c$var$_calendar.default, Object.assign({
        name: "CalendarIcon",
        LEGACY_fallbackIcon: $2af99c62070f9b2c$var$_calendar2.default
    }, props));
$2af99c62070f9b2c$var$CalendarIcon.displayName = 'CalendarIconMigration';
var $2af99c62070f9b2c$var$_default = module.exports.default = $2af99c62070f9b2c$var$CalendarIcon;

});
parcelRegister("btkTq", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c44ca3af5d99d99573761123bc1c1f79>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $85a29c08b1b7d658$var$_react = $85a29c08b1b7d658$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $85a29c08b1b7d658$var$_baseNew = $85a29c08b1b7d658$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $85a29c08b1b7d658$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Calendar".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: date metadata, date input field, calendar view, jira status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $85a29c08b1b7d658$var$CalendarIcon = (props)=>/*#__PURE__*/ $85a29c08b1b7d658$var$_react.default.createElement($85a29c08b1b7d658$var$_baseNew.default, Object.assign({
        name: "CalendarIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4.5 2.5v2H6v-2h4v2h1.5v-2H13a.5.5 0 0 1 .5.5v3h-11V3a.5.5 0 0 1 .5-.5zm-2 5V13a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V7.5zm9-6.5H13a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1.5V0H6v1h4V0h1.5z" clip-rule="evenodd"/>`
    }, props));
$85a29c08b1b7d658$var$CalendarIcon.displayName = 'CalendarIcon';
var $85a29c08b1b7d658$var$_default = module.exports.default = $85a29c08b1b7d658$var$CalendarIcon;

});

parcelRegister("76JV8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $52ccb6d3a2735d8d$var$_react = $52ccb6d3a2735d8d$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $52ccb6d3a2735d8d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $52ccb6d3a2735d8d$var$CalendarIcon = (props)=>/*#__PURE__*/ $52ccb6d3a2735d8d$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M4.995 5h14.01C20.107 5 21 5.895 21 6.994v12.012A1.994 1.994 0 0 1 19.005 21H4.995A1.995 1.995 0 0 1 3 19.006V6.994C3 5.893 3.892 5 4.995 5M5 9v9a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V9zm1-5a1 1 0 0 1 2 0v1H6zm10 0a1 1 0 0 1 2 0v1h-2zm-9 9v-2.001h2V13zm8 0v-2.001h2V13zm-4 0v-2.001h2.001V13zm-4 4v-2h2v2zm4 0v-2h2.001v2zm4 0v-2h2v2z"/></svg>`
    }, props));
$52ccb6d3a2735d8d$var$CalendarIcon.displayName = 'CalendarIcon';
var $52ccb6d3a2735d8d$var$_default = module.exports.default = $52ccb6d3a2735d8d$var$CalendarIcon;

});


parcelRegister("cK9J2", function(module, exports) {
$parcel$export(module.exports, "createLocalizationProvider", () => $2150f4a906bcb332$export$ea56ca58f08ffa52);

var $4ZGCx = parcelRequire("4ZGCx");

var $ktSIT = parcelRequire("ktSIT");

var $92aEh = parcelRequire("92aEh");
const $2150f4a906bcb332$export$ea56ca58f08ffa52 = (locale, formatterOptions)=>{
    // Intl.DateFormat expects locales in the format of 'la-CO' however it is
    // common for locale to be provided in the format of 'la_CO', where 'la' is
    // language and 'CO' is country.
    const normalizedLocale = (0, $4ZGCx.normalizeLocale)(locale);
    const formatDate = (date)=>Intl.DateTimeFormat(normalizedLocale).format(date);
    const formatTime = (date)=>Intl.DateTimeFormat(normalizedLocale, {
            hour: 'numeric',
            minute: 'numeric'
        }).format(date);
    const getDays = (weekStartDay = 0, length)=>{
        const dayFormatter = Intl.DateTimeFormat(normalizedLocale, {
            weekday: length
        });
        // Right now there is no way to find out first day of the week based on Intl (locale)
        // api. Check issue here: https://github.com/tc39/ecma402/issues/6
        // So we rotate the weekdays based on #weekStartDay parameter.
        const weekdays = [
            0,
            1,
            2,
            3,
            4,
            5,
            6
        ];
        const rotatedWeekdays = weekStartDay > 0 ? [
            ...weekdays.slice(weekStartDay),
            ...weekdays.slice(0, weekStartDay)
        ] : weekdays;
        return rotatedWeekdays.map((day)=>{
            // Some short days are longer than 3 characters but are unique if the first
            // three non-white characters are used.
            const result = dayFormatter// Date range chosen which has a Sun-Sat range so we can extract the names
            .format(new Date(2000, 9, day + 1, 12))// \u200E matches on the Left-to-Right Mark character in IE/Edge
            .replace(/[\s\u200E]/g, '');
            // If short days, only return first three characters. Else return whole thing
            if (length === 'short') return result.substring(0, 3);
            else return result;
        });
    };
    const getDaysShort = (weekStartDay = 0)=>{
        return getDays(weekStartDay, 'short');
    };
    const getDaysLong = (weekStartDay = 0)=>{
        return getDays(weekStartDay, 'long');
    };
    const getMonthsLong = ()=>{
        const monthFormatter = Intl.DateTimeFormat(normalizedLocale, {
            month: 'long'
        });
        return [
            0,
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11
        ].map((month)=>// Date chosen for no real reason, the only important part is the month
            // Using 2020 'cos Safari has a faulty implementation when we use the year 2000
            // Intl.DateTimeFormat("en-US", { month: 'long'}).format(new Date(2000, 3, 1))
            // should give "April" but gives "March" in Safari
            monthFormatter.format(new Date(2020, month, 1)));
    };
    const parseDate = (date, options = {})=>(0, $ktSIT.createDateParser)(normalizedLocale)(date, options);
    const formatToParts = (date = new Date())=>{
        const formatter = new Intl.DateTimeFormat(normalizedLocale, formatterOptions);
        /**
		 * Safari has a bug that returns the wrong month for years 2005 and before.
		 * The error occurs when the passed date has been created with numbers, like new Date(2000, 3, 1)
		 * Not all the months fail in each year. To ensure the correct output,
		 * we select 2020 as the base year for the whole date,
		 * then we replace in the result the original input year
		 */ const fixedDate = new Date(date);
        fixedDate.setFullYear(2020);
        const fixedParts = (0, $92aEh.toFormattedParts)(formatter.formatToParts(fixedDate));
        const originalParts = (0, $92aEh.toFormattedParts)(formatter.formatToParts(date));
        if (fixedParts.year) fixedParts.year = originalParts.year;
        /**
		 * Chrome has a bug that returns hour="00" when it's 12:00pm in certain languages
		 * We fix it by detecting the real time with getHours method
		 */ if (fixedParts.hour === '00' && fixedDate.getHours() === 12) fixedParts.hour = '12';
        return fixedParts;
    };
    return {
        getDaysShort: getDaysShort,
        getDaysLong: getDaysLong,
        getMonthsLong: getMonthsLong,
        formatDate: formatDate,
        formatTime: formatTime,
        parseDate: parseDate,
        formatToParts: formatToParts
    };
};

});
parcelRegister("4ZGCx", function(module, exports) {
$parcel$export(module.exports, "normalizeLocale", () => $caa7b379de4e9e4d$export$dca0327c9b9c6498);
const $caa7b379de4e9e4d$export$dca0327c9b9c6498 = (locale)=>locale.replace(/_/g, '-');

});

parcelRegister("ktSIT", function(module, exports) {
$parcel$export(module.exports, "createDateParser", () => $f0407708fddca50b$export$cfa2ef2687faeda2);

var $4ZGCx = parcelRequire("4ZGCx");

var $61I7t = parcelRequire("61I7t");
const $f0407708fddca50b$var$INVALID_DATE = new Date(NaN);
const $f0407708fddca50b$var$INVARIANT = {
    year: 1993,
    month: 2,
    day: 18
};
const $f0407708fddca50b$var$INVARIANT_DATE = (0, $61I7t.toDate)($f0407708fddca50b$var$INVARIANT);
const $f0407708fddca50b$var$FORMAT_EXTRACTOR_REGEX = /(\d+)[^\d]+(\d+)[^\d]+(\d+)\.?/;
const $f0407708fddca50b$var$DATE_PARSER_REGEX = /(\d+)[^\d]*(\d+)?[^\d]*(\d+)?\.?/;
// Internet Explorer returns non-printing characters when formatting a date
const $f0407708fddca50b$var$stripExtras = (str)=>str.replace(/\u200E/g, '');
const $f0407708fddca50b$var$extractDateParts = (matchResult)=>{
    return matchResult// Get the 3 capture groups
    .splice(1, 4)// Convert them to numbers
    .map((datePart)=>parseInt(datePart, 10));
};
const $f0407708fddca50b$export$cfa2ef2687faeda2 = (locale)=>{
    // Intl.DateFormat expects locales in the format of 'la-CO' however it is
    // common for locale to be provided in the format of 'la_CO', where 'la' is
    // language and 'CO' is country.
    const normalizedLocale = (0, $4ZGCx.normalizeLocale)(locale);
    const dateFormatter = Intl.DateTimeFormat(normalizedLocale);
    // Generate a date string from a hard coded date, this allows us to determine
    // the year/month/day position for the provided locale.
    const rawDateString = dateFormatter.format($f0407708fddca50b$var$INVARIANT_DATE);
    const shortDate = $f0407708fddca50b$var$stripExtras(rawDateString);
    // Extract the date pieces from the locale formatted date string
    const formatMatch = shortDate.match($f0407708fddca50b$var$FORMAT_EXTRACTOR_REGEX);
    if (!formatMatch) throw new Error('Unable to create DateParser');
    const formatParts = $f0407708fddca50b$var$extractDateParts(formatMatch);
    // Find the year/month/day positions of the locale formatted invariant date
    const yearPosition = formatParts.indexOf($f0407708fddca50b$var$INVARIANT.year);
    const monthPosition = formatParts.indexOf($f0407708fddca50b$var$INVARIANT.month);
    const dayPosition = formatParts.indexOf($f0407708fddca50b$var$INVARIANT.day);
    return (date, options = {})=>{
        const dateMatch = $f0407708fddca50b$var$stripExtras(date).match($f0407708fddca50b$var$DATE_PARSER_REGEX);
        if (!dateMatch) return $f0407708fddca50b$var$INVALID_DATE;
        const dateParts = $f0407708fddca50b$var$extractDateParts(dateMatch);
        // Use the previously extracted year/month/day positions to extract each
        // date piece.
        const extractedDate = {
            year: dateParts[yearPosition],
            month: dateParts[monthPosition],
            day: dateParts[dayPosition]
        };
        const normalizedDate = (0, $61I7t.normalizeDate)(extractedDate, options?.defaultFirstDay);
        if (!(0, $61I7t.isValid)(normalizedDate)) return $f0407708fddca50b$var$INVALID_DATE;
        return (0, $61I7t.toDate)(normalizedDate);
    };
};

});
parcelRegister("61I7t", function(module, exports) {
$parcel$export(module.exports, "toDate", () => $862914b96a01ecbb$export$e67a095c620b86fe);
$parcel$export(module.exports, "isValid", () => $862914b96a01ecbb$export$1ea939691cdc45b8);
$parcel$export(module.exports, "normalizeDate", () => $862914b96a01ecbb$export$fcc71269590ba0a8);
/**
 * A numerical representation of a date:
 *  - year: any positive integer
 *  - month: 1 - 12 (Jan - Dec)
 *  - day: 1 - [28, 29, 30, 31] (depending on month)
 */ const $862914b96a01ecbb$export$abe96da78d4f59dd = (date)=>({
        year: date.getFullYear(),
        month: date.getMonth() + 1,
        day: date.getDate()
    });
const $862914b96a01ecbb$export$e67a095c620b86fe = (date)=>// The 'proper' month is stored in a DateObj but Date expects month index
    new Date(date.year, date.month - 1, date.day);
const $862914b96a01ecbb$export$553d7fa8e3805fc0 = (year)=>{
    return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
};
const $862914b96a01ecbb$export$f645ddd439eb259d = (year, month)=>{
    // February depends on leap year
    if (month === 2 && $862914b96a01ecbb$export$553d7fa8e3805fc0(year)) return 29;
    return [
        31,
        28,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ][month - 1];
};
const $862914b96a01ecbb$export$1ea939691cdc45b8 = (date)=>{
    const { year: year, month: month, day: day } = date;
    const daysInMonth = $862914b96a01ecbb$export$f645ddd439eb259d(year, month);
    return 1 <= month && month <= 12 && 1 <= day && day <= daysInMonth;
};
const $862914b96a01ecbb$export$fcc71269590ba0a8 = (date, defaultFirstDay = false)=>{
    const now = $862914b96a01ecbb$export$abe96da78d4f59dd(new Date());
    const { year: year, month: month, day: day } = date;
    // 19 should evaluate to 2019
    const fullYear = year < 100 ? 2000 + year : year;
    // Missing date pieces are filled in with their current date values
    const normalizedYear = !isNaN(fullYear) ? fullYear : now.year;
    const normalizedMonth = !isNaN(month) && month !== 0 ? month : now.month;
    const normalizedDay = !isNaN(day) && day !== 0 ? day : month !== 0 && defaultFirstDay ? 1 : now.day;
    return {
        year: normalizedYear,
        month: normalizedMonth,
        day: normalizedDay
    };
};

});


parcelRegister("92aEh", function(module, exports) {
$parcel$export(module.exports, "toFormattedParts", () => $0bfc942d7a009811$export$9b7ca29af37c192);
const $0bfc942d7a009811$export$9b7ca29af37c192 = (rawParts)=>rawParts.reduce((result, datePart)=>({
            ...result,
            [datePart.type]: datePart.value
        }), {});

});


parcelRegister("RoXqn", function(module, exports) {
$parcel$export(module.exports, "EmptyComponent", () => $f314d4d8e1112a31$export$5e30e9a24d6c1203);
$parcel$export(module.exports, "placeholderDatetime", () => $f314d4d8e1112a31$export$fff8babee5abe3e2);
$parcel$export(module.exports, "defaultTimes", () => $f314d4d8e1112a31$export$b42ffb9f09b1861b);
$parcel$export(module.exports, "defaultTimeFormat", () => $f314d4d8e1112a31$export$9e6d8fcf62256b85);
$parcel$export(module.exports, "defaultDateFormat", () => $f314d4d8e1112a31$export$75032c84f56650eb);
$parcel$export(module.exports, "padToTwo", () => $f314d4d8e1112a31$export$a7de57e5b672ccdb);
$parcel$export(module.exports, "formatDateTimeZoneIntoIso", () => $f314d4d8e1112a31$export$2eeb05a2ecc2ce0a);
/**
 * This component is used to hide portions of Select component.
 */ const $f314d4d8e1112a31$export$5e30e9a24d6c1203 = ()=>null;
const $f314d4d8e1112a31$export$fff8babee5abe3e2 = new Date(1993, 1, 18, 13);
const $f314d4d8e1112a31$export$b42ffb9f09b1861b = [
    '09:00',
    '09:30',
    '10:00',
    '10:30',
    '11:00',
    '11:30',
    '12:00',
    '12:30',
    '13:00',
    '13:30',
    '14:00',
    '14:30',
    '15:00',
    '15:30',
    '16:00',
    '16:30',
    '17:00',
    '17:30',
    '18:00'
];
const $f314d4d8e1112a31$export$9e6d8fcf62256b85 = 'h:mma';
const $f314d4d8e1112a31$export$75032c84f56650eb = 'YYYY/MM/DD';
function $f314d4d8e1112a31$export$a7de57e5b672ccdb(number) {
    return number <= 99 ? `0${number}`.slice(-2) : `${number}`;
}
function $f314d4d8e1112a31$export$2eeb05a2ecc2ce0a(date, time, zone) {
    // 12:00 => 12:00, 1:00 => 01:00
    const needsLeadingZero = /^\d:/;
    const sanitizedTime = needsLeadingZero.test(time) ? `0${time}` : time;
    return `${date}T${sanitizedTime}${zone}`;
}

});

parcelRegister("47or1", function(module, exports) {
$parcel$export(module.exports, "isDateDisabled", () => $0a9aca5af48d76f0$export$d38e7e283938128c);
$parcel$export(module.exports, "getParsedISO", () => $0a9aca5af48d76f0$export$38db26406d1a1ee2);
$parcel$export(module.exports, "parseDate", () => $0a9aca5af48d76f0$export$6b862160d295c8e);
$parcel$export(module.exports, "formatDate", () => $0a9aca5af48d76f0$export$3ae94a2503e890a1);
$parcel$export(module.exports, "getPlaceholder", () => $0a9aca5af48d76f0$export$d3f5c5e0a5023fa0);
/**
 * Everything in this file is to smooth out the migration of the new date picker
 * (https://product-fabric.atlassian.net/browse/DSP-20682). When that ticket is
 * complete, all of these functions will ilkely be merged back into the date
 * picker. Please do not pre-optimize and put these back into the date picker
 * unless you are working on the DTP Refresh and you have a good reason to do
 * so, thank you!
 *
 * All variables within the `di` objects are dependency injections. They should
 * be read from within the component at the end of the day. But because we are
 * extracting them, we have to inject them in every place manually. When we
 * re-introduce them to the components, we can likely remove the `di` variables
 * and instead use internal variables.
 *
 * If component _only_ has injected variables, it is fully internal and was
 * broken out to be it's own function.
 */ 
var $57raR = parcelRequire("57raR");
var $cBFyu = parcelRequire("cBFyu");
var $kQ82p = parcelRequire("kQ82p");

var $5PwWU = parcelRequire("5PwWU");

var $RoXqn = parcelRequire("RoXqn");
const $0a9aca5af48d76f0$export$d38e7e283938128c = (date, di)=>{
    const { disabled: disabled } = di;
    return disabled.indexOf(date) > -1;
};
const $0a9aca5af48d76f0$export$38db26406d1a1ee2 = (di)=>{
    const { iso: iso } = di;
    const [year, month, date] = iso.split('-');
    let newIso = iso;
    const parsedDate = parseInt(date, 10);
    const parsedMonth = parseInt(month, 10);
    const parsedYear = parseInt(year, 10);
    const lastDayInMonth = (0, $cBFyu.default)(new Date(parsedYear, parsedMonth - 1)).getDate();
    if (lastDayInMonth < parsedDate) newIso = `${parsedYear}-${(0, $RoXqn.padToTwo)(parsedMonth)}-${(0, $RoXqn.padToTwo)(lastDayInMonth)}`;
    else newIso = `${parsedYear}-${(0, $RoXqn.padToTwo)(parsedMonth)}-${(0, $RoXqn.padToTwo)(parsedDate)}`;
    return newIso;
};
const $0a9aca5af48d76f0$export$6b862160d295c8e = (date, di)=>{
    const { parseInputValue: parseInputValue, dateFormat: dateFormat, l10n: l10n } = di;
    if (parseInputValue) return parseInputValue(date, dateFormat || (0, $RoXqn.defaultDateFormat));
    return l10n.parseDate(date);
};
const $0a9aca5af48d76f0$export$3ae94a2503e890a1 = (value, di)=>{
    const { formatDisplayLabel: formatDisplayLabel, dateFormat: dateFormat, l10n: l10n } = di;
    if (formatDisplayLabel) return formatDisplayLabel(value, dateFormat || (0, $RoXqn.defaultDateFormat));
    const date = (0, $kQ82p.default)(value);
    return dateFormat ? (0, $57raR.default)(date, (0, $5PwWU.convertTokens)(dateFormat)) : l10n.formatDate(date);
};
const $0a9aca5af48d76f0$export$d3f5c5e0a5023fa0 = (di)=>{
    const { placeholder: placeholder, l10n: l10n } = di;
    return placeholder || l10n.formatDate((0, $RoXqn.placeholderDatetime));
};

});
parcelRegister("5PwWU", function(module, exports) {
$parcel$export(module.exports, "convertTokens", () => $0e0ecc26a93a278c$export$4d5430175be73d45);
// https://github.com/date-fns/date-fns-upgrade/blob/master/src/v2/convertTokens/index.ts
const $0e0ecc26a93a278c$var$tokensMap = {
    // 'D MMMM': '',
    // 'Do MMMM': '',
    // 'DD MMMM': '',
    M: 'L',
    Mo: 'Mo',
    MM: 'LL',
    MMM: 'LLL',
    MMMM: 'LLLL',
    Q: 'q',
    Qo: 'qo',
    D: 'd',
    Do: 'do',
    DD: 'dd',
    DDD: 'D',
    DDDo: 'Do',
    DDDD: 'DDD',
    d: 'i',
    do: 'io',
    dd: 'iiiiii',
    ddd: 'iii',
    dddd: 'iiii',
    A: 'a',
    a: 'a',
    aa: 'aaaa',
    E: 'i',
    W: 'I',
    Wo: 'Io',
    WW: 'II',
    YY: 'yy',
    YYYY: 'yyyy',
    GG: 'RR',
    GGGG: 'RRRR',
    H: 'H',
    HH: 'HH',
    h: 'h',
    hh: 'hh',
    m: 'm',
    mm: 'mm',
    s: 's',
    ss: 'ss',
    S: 'S',
    SS: 'SS',
    SSS: 'SSS',
    Z: 'xxx',
    ZZ: 'xx',
    X: 't',
    x: 'T'
};
const $0e0ecc26a93a278c$var$v1tokens = Object.keys($0e0ecc26a93a278c$var$tokensMap).sort().reverse();
const $0e0ecc26a93a278c$var$tokensRegExp = new RegExp(// v1 escape string (unsure the purpose of post-pipe capture group)
"(\\[[^\\[]*\\])|(\\\\)?('.+'|" + // All v1 tokens
$0e0ecc26a93a278c$var$v1tokens.join('|') + '|.)', 'g');
function $0e0ecc26a93a278c$export$4d5430175be73d45(format) {
    const tokensCaptures = format.match($0e0ecc26a93a278c$var$tokensRegExp);
    if (!tokensCaptures) return format;
    return tokensCaptures.reduce((parsed, tokenString, index)=>{
        const v2token = $0e0ecc26a93a278c$var$tokensMap[tokenString];
        if (!v2token) {
            const escapedCaptures = tokenString.match(/^\[(.+)\]$/);
            if (escapedCaptures) parsed.escapedTextBuffer.push(escapedCaptures[1]);
            else parsed.escapedTextBuffer.push(tokenString);
        }
        const endOfString = index === tokensCaptures.length - 1;
        if (parsed.escapedTextBuffer.length && (v2token || endOfString)) {
            // This allows double parentheses to be rendered correctly
            // according to date-fns's spec.
            // https://date-fns.org/v2.29.3/docs/format
            //
            // We have to keep the single quote and then remove it because
            // browser support for lookahead/behind is low and causes breaking
            // errors (HOT-104152)
            const filteredEscapedTextBuffer = parsed.escapedTextBuffer.map((token)=>token[0] === "'" && token.slice(-1) === "'" ? token.slice(1, -1) : token).filter((token)=>token !== "'").join('');
            parsed.formatBuffer.push(`'${filteredEscapedTextBuffer}'`);
            parsed.escapedTextBuffer = [];
        }
        if (v2token) parsed.formatBuffer.push(v2token);
        return parsed;
    }, {
        formatBuffer: [],
        escapedTextBuffer: []
    }).formatBuffer.join('');
}

});


parcelRegister("hmV0i", function(module, exports) {
$parcel$export(module.exports, "IndicatorsContainer", () => $85a1248019ae74fb$export$d0ffd7e649cab6f);
/* indicators-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $6XEne = parcelRequire("6XEne");
const $85a1248019ae74fb$var$styles = {
    calendarButtonInclusionStyles: "_ahbqxy5q",
    calendarButtonOnlyInclusionStyles: "_ahbq1ejb"
};
const $85a1248019ae74fb$export$d0ffd7e649cab6f = ({ showClearIndicator: showClearIndicator, ...rest })=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        className: (0, $hcewu.default)([
            showClearIndicator ? $85a1248019ae74fb$var$styles.calendarButtonInclusionStyles : $85a1248019ae74fb$var$styles.calendarButtonOnlyInclusionStyles
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6XEne.components).IndicatorsContainer, {
            ...rest
        })
    });

});

parcelRegister("gNwsY", function(module, exports) {
$parcel$export(module.exports, "Menu", () => $41b3b0700e22b1c1$export$d9b273488cd8ce6f);
/* menu.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $dBLX0 = parcelRequire("dBLX0");
var $kQ82p = parcelRequire("kQ82p");

var $cSUzd = parcelRequire("cSUzd");

var $3rigy = parcelRequire("3rigy");

var $7G7nX = parcelRequire("7G7nX");
/**
 * @param isos A series of ISO dates.
 * @returns The last valid date within the array of ISO strings.
 */ function $41b3b0700e22b1c1$var$getValidDate(isos) {
    return isos.reduce((acc, iso)=>{
        const date = (0, $kQ82p.default)(iso);
        return (0, $dBLX0.default)(date) ? {
            day: date.getDate(),
            month: date.getMonth() + 1,
            year: date.getFullYear()
        } : acc;
    }, {});
}
const $41b3b0700e22b1c1$var$menuStyles = null;
const $41b3b0700e22b1c1$export$d9b273488cd8ce6f = ({ selectProps: selectProps, innerProps: innerProps })=>{
    const { calendarValue: calendarValue, calendarView: calendarView, menuInnerWrapper: MenuInnerWrapper } = selectProps;
    const { day: day, month: month, year: year } = $41b3b0700e22b1c1$var$getValidDate([
        calendarValue,
        calendarView
    ]);
    const onMenuMouseDown = (event)=>{
        if (event.button !== 0) return;
        event.stopPropagation();
        event.preventDefault();
    };
    const Wrapper = typeof MenuInnerWrapper === 'function' ? MenuInnerWrapper : (0, $eJOHy.Fragment);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3rigy.Layering), {
        isDisabled: false,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7G7nX.default), {
            inputValue: selectProps.inputValue,
            containerRef: selectProps.calendarContainerRef,
            content: /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                ...innerProps,
                onMouseDown: onMenuMouseDown,
                className: (0, $hcewu.default)([
                    "_2rko12b0 _1reo15vq _18m915vq _1pbyowjs _bfhk1bhr _16qs130s"
                ]),
                children: /*#__PURE__*/ (0, $gt9Am.jsx)(Wrapper, {
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $cSUzd.default), {
                        day: day,
                        month: month,
                        year: year,
                        disabled: selectProps.calendarDisabled,
                        disabledDateFilter: selectProps.calendarDisabledDateFilter,
                        minDate: selectProps.calendarMinDate,
                        maxDate: selectProps.calendarMaxDate,
                        nextMonthLabel: selectProps.nextMonthLabel,
                        onChange: selectProps.onCalendarChange,
                        onSelect: selectProps.onCalendarSelect,
                        previousMonthLabel: selectProps.previousMonthLabel,
                        ref: selectProps.calendarRef,
                        selected: [
                            selectProps.calendarValue
                        ],
                        shouldSetFocusOnCurrentDay: selectProps.shouldSetFocusOnCurrentDay,
                        locale: selectProps.calendarLocale,
                        testId: selectProps.testId && `${selectProps.testId}--calendar`,
                        weekStartDay: selectProps.calendarWeekStartDay
                    })
                })
            }),
            testId: selectProps.testId
        })
    });
};

});
parcelRegister("cSUzd", function(module, exports) {
$parcel$export(module.exports, "default", () => $d1db3bdfc4d701b2$export$2e2bcd8739ae039);
/* calendar.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $jrFnt = parcelRequire("jrFnt");

var $3Vuhz = parcelRequire("3Vuhz");

var $gl2vi = parcelRequire("gl2vi");

var $8IeH1 = parcelRequire("8IeH1");
var $78OnL = parcelRequire("78OnL");

var $hWhuM = parcelRequire("hWhuM");

var $jOHXZ = parcelRequire("jOHXZ");

var $1p4Fz = parcelRequire("1p4Fz");

var $h2Y6s = parcelRequire("h2Y6s");

var $7pqrO = parcelRequire("7pqrO");

var $8m7JM = parcelRequire("8m7JM");

var $5Pa93 = parcelRequire("5Pa93");

var $cM3gB = parcelRequire("cM3gB");

var $lPLOh = parcelRequire("lPLOh");

var $jtNxE = parcelRequire("jtNxE");
const $d1db3bdfc4d701b2$var$styles = {
    box: "_1e0c1o8l _uiztglyw"
};
const $d1db3bdfc4d701b2$var$analyticsAttributes = {
    componentName: 'calendar',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $d1db3bdfc4d701b2$var$InnerCalendar = /*#__PURE__*/ (0, $eJOHy.forwardRef)(function Calendar({ day: day, defaultDay: defaultDay = 0, defaultMonth: defaultMonth = 0, defaultPreviouslySelected: defaultPreviouslySelected = (0, $h2Y6s.blankStringArray), defaultSelected: defaultSelected = (0, $h2Y6s.blankStringArray), defaultYear: defaultYear = 0, disabled: disabled, disabledDateFilter: disabledDateFilter, minDate: minDate, maxDate: maxDate, month: month, nextMonthLabel: nextMonthLabel, onBlur: onBlur = (0, $3Vuhz.default), onChange: onChange = (0, $3Vuhz.default), onFocus: onFocus = (0, $3Vuhz.default), onSelect: onSelect = (0, $3Vuhz.default), previouslySelected: previouslySelected, previousMonthLabel: previousMonthLabel, selected: selected, shouldSetFocusOnCurrentDay: shouldSetFocusOnCurrentDay = false, today: today, locale: locale = 'en-US', year: year, analyticsContext: analyticsContext, weekStartDay: weekStartDay = 0, testId: testId, className: className, style: style, tabIndex: tabIndex = 0 }, ref) {
    const { day: [dayValue, setDayValue], month: [monthValue, setMonthValue], year: [yearValue, setYearValue], today: [todayValue], selected: [selectedValue, setSelectedValue], previous: [previouslySelectedValue, setPreviouslySelectedValue] } = (0, $7pqrO.default)({
        day: day,
        defaultDay: defaultDay,
        month: month,
        defaultMonth: defaultMonth,
        year: year,
        defaultYear: defaultYear,
        today: today,
        selected: selected,
        defaultSelected: defaultSelected,
        previouslySelected: previouslySelected,
        defaultPreviouslySelected: defaultPreviouslySelected
    });
    const [shouldSetFocus, setShouldSetFocus] = (0, $eJOHy.useState)(false);
    const onChangeWithAnalytics = (0, $jrFnt.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        ...$d1db3bdfc4d701b2$var$analyticsAttributes
    });
    const { navigate: navigate, handleClickNextMonth: handleClickNextMonth, handleClickNextYear: handleClickNextYear, handleClickPrevMonth: handleClickPrevMonth, handleClickPrevYear: handleClickPrevYear } = (0, $cM3gB.default)({
        day: [
            dayValue,
            setDayValue
        ],
        month: [
            monthValue,
            setMonthValue
        ],
        year: [
            yearValue,
            setYearValue
        ],
        shouldSetFocus: [
            shouldSetFocus,
            setShouldSetFocus
        ],
        onChange: onChangeWithAnalytics
    });
    const onSelectWithAnalytics = (0, $jrFnt.usePlatformLeafEventHandler)({
        fn: onSelect,
        action: 'selected',
        analyticsData: analyticsContext,
        ...$d1db3bdfc4d701b2$var$analyticsAttributes
    });
    const { handleClickDay: handleClickDay, handleContainerKeyDown: handleContainerKeyDown } = (0, $lPLOh.default)({
        day: [
            dayValue,
            setDayValue
        ],
        month: [
            monthValue,
            setMonthValue
        ],
        year: [
            yearValue,
            setYearValue
        ],
        selected: [
            selectedValue,
            setSelectedValue
        ],
        previous: [
            ,
            setPreviouslySelectedValue
        ],
        onSelect: onSelectWithAnalytics,
        navigate: navigate
    });
    const { handleContainerBlur: handleContainerBlur, handleContainerFocus: handleContainerFocus } = (0, $8m7JM.default)({
        onFocus: onFocus,
        onBlur: onBlur
    });
    const { monthsLong: monthsLong, daysShort: daysShort, daysLong: daysLong } = (0, $jtNxE.default)({
        locale: locale,
        weekStartDay: weekStartDay
    });
    const weeks = (0, $5Pa93.default)({
        day: dayValue,
        month: monthValue,
        year: yearValue,
        today: todayValue,
        selected: selectedValue,
        previouslySelected: previouslySelectedValue,
        disabled: disabled,
        disabledDateFilter: disabledDateFilter,
        minDate: minDate,
        maxDate: maxDate,
        daysLong: daysLong,
        weekStartDay: weekStartDay
    });
    const getNextMonthHeading = ()=>{
        // Next month is (currentMonth - 1) + 1, or just currentMonth in this
        // instance.
        const nextMonth = monthValue % 12;
        const showNextYear = monthValue === 12;
        return `${monthsLong[nextMonth]} ${showNextYear ? yearValue + 1 : yearValue}`;
    };
    const getNextYearHeading = ()=>{
        // Months are held in Date object as zero-indexed
        const thisMonth = (monthValue - 1) % 12;
        const nextYear = yearValue + 1;
        return `${monthsLong[thisMonth]} ${nextYear}`;
    };
    const getPreviousMonthHeading = ()=>{
        // Previous month is (monthValue - 1) - 1. Need to add 12 so the modulo
        // works as expected and stays positive.
        const previousMonth = (monthValue + 12 - 2) % 12;
        const showPreviousYear = monthValue === 1;
        return `${monthsLong[previousMonth]} ${showPreviousYear ? yearValue - 1 : yearValue}`;
    };
    const getPreviousYearHeading = ()=>{
        // Months are held in Date object as zero-indexed
        const thisMonth = (monthValue - 1) % 12;
        const previousYear = yearValue - 1;
        return `${monthsLong[thisMonth]} ${previousYear}`;
    };
    const headerId = (0, $gl2vi.useId)();
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    , {
        className: className,
        style: style,
        onBlur: handleContainerBlur,
        onFocus: handleContainerFocus,
        "data-testid": testId && `${testId}--container`,
        ref: ref,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
            xcss: $d1db3bdfc4d701b2$var$styles.box,
            padding: "space.200",
            "aria-label": "calendar",
            testId: testId && `${testId}--calendar`,
            children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $78OnL.default), {
                space: "space.150",
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hWhuM.default // The month number needs to be translated to index in the month
                    ), {
                        // name array e.g. 1 (January) -> 0
                        monthLongTitle: monthsLong[monthValue - 1],
                        year: yearValue,
                        nextMonthLabel: nextMonthLabel,
                        previousMonthLabel: previousMonthLabel,
                        nextMonthHeading: getNextMonthHeading(),
                        nextYearHeading: getNextYearHeading(),
                        previousMonthHeading: getPreviousMonthHeading(),
                        previousYearHeading: getPreviousYearHeading(),
                        handleClickNextMonth: handleClickNextMonth,
                        handleClickNextYear: handleClickNextYear,
                        handleClickPrevMonth: handleClickPrevMonth,
                        handleClickPrevYear: handleClickPrevYear,
                        headerId: headerId,
                        tabIndex: tabIndex,
                        testId: testId
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $8IeH1.default), {
                        role: "grid",
                        onKeyDown: handleContainerKeyDown,
                        "aria-labelledby": headerId,
                        testId: testId && `${testId}--calendar-dates`,
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1p4Fz.default), {
                                daysShort: daysShort,
                                testId: testId
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jOHXZ.default), {
                                weeks: weeks,
                                handleClickDay: handleClickDay,
                                monthsLong: monthsLong,
                                shouldSetFocus: shouldSetFocus || shouldSetFocusOnCurrentDay,
                                tabIndex: tabIndex,
                                testId: testId
                            })
                        ]
                    })
                ]
            })
        })
    });
});
/**
 * __Calendar__
 *
 * A calendar is used for date selection.
 *
 * - [Examples](https://atlassian.design/components/calendar/examples)
 * - [Code](https://atlassian.design/components/calendar/code)
 * - [Usage](https://atlassian.design/components/calendar/usage)
 */ const $d1db3bdfc4d701b2$var$Calendar = /*#__PURE__*/ (0, $eJOHy.memo)(/*#__PURE__*/ (0, $eJOHy.forwardRef)(function Calendar(props, ref) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)($d1db3bdfc4d701b2$var$InnerCalendar, {
        ...props,
        ref: ref
    });
}));
$d1db3bdfc4d701b2$var$Calendar.displayName = 'Calendar';
var $d1db3bdfc4d701b2$export$2e2bcd8739ae039 = $d1db3bdfc4d701b2$var$Calendar;

});
parcelRegister("hWhuM", function(module, exports) {
$parcel$export(module.exports, "default", () => $8fe58087a91a587c$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $Ay1uj = parcelRequire("Ay1uj");

var $gl2vi = parcelRequire("gl2vi");

var $806LH = parcelRequire("806LH");

var $ld0cd = parcelRequire("ld0cd");

var $cqfIR = parcelRequire("cqfIR");

var $8PCRQ = parcelRequire("8PCRQ");

var $cQxBL = parcelRequire("cQxBL");

var $8IeH1 = parcelRequire("8IeH1");
var $6djmC = parcelRequire("6djmC");
const $8fe58087a91a587c$var$Header = /*#__PURE__*/ (0, $eJOHy.memo)(function Header({ monthLongTitle: monthLongTitle, year: year, previousMonthLabel: previousMonthLabel = 'Previous month', previousYearLabel: previousYearLabel = 'Previous year', previousMonthHeading: previousMonthHeading, previousYearHeading: previousYearHeading, nextMonthLabel: nextMonthLabel = 'Next month', nextYearLabel: nextYearLabel = 'Next year', nextMonthHeading: nextMonthHeading, nextYearHeading: nextYearHeading, handleClickPrevMonth: handleClickPrevMonth, handleClickPrevYear: handleClickPrevYear, handleClickNextMonth: handleClickNextMonth, handleClickNextYear: handleClickNextYear, headerId: headerId, tabIndex: tabIndex, testId: testId }) {
    const announceId = (0, $gl2vi.useId)();
    // All of this is because `aria-atomic` is not fully supported for different
    // assistive technologies. We want the value of the current month and year to
    // be announced, but *only* if that value has been interacted with since
    // being mounted. This allows us to conditionally apply the `aria-live`
    // attribute.  Without this, the `aria-live` property is set on mount and
    // overrides the default input's readout in downstream consumers (e.g.
    // datetime picker).
    const [hasInteractedWithMonthOrYear, setHasInteractedWithMonthOrYear] = (0, $eJOHy.useState)(false);
    const handlePrevMonthInteraction = (e)=>{
        if (!hasInteractedWithMonthOrYear) setHasInteractedWithMonthOrYear(true);
        handleClickPrevMonth(e);
    };
    const handlePrevYearInteraction = (e)=>{
        if (!hasInteractedWithMonthOrYear) setHasInteractedWithMonthOrYear(true);
        handleClickPrevYear(e);
    };
    const handleNextMonthInteraction = (e)=>{
        if (!hasInteractedWithMonthOrYear) setHasInteractedWithMonthOrYear(true);
        handleClickNextMonth(e);
    };
    const handleNextYearInteraction = (e)=>{
        if (!hasInteractedWithMonthOrYear) setHasInteractedWithMonthOrYear(true);
        handleClickNextYear(e);
    };
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        paddingInline: "space.100",
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $6djmC.default), {
            space: "space.0",
            alignBlock: "center",
            spread: "space-between",
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $6djmC.default), {
                    space: "space.100",
                    alignBlock: "start",
                    children: [
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $Ay1uj.default), {
                            appearance: "subtle",
                            spacing: "compact",
                            tabIndex: tabIndex,
                            onClick: handlePrevYearInteraction,
                            testId: testId && `${testId}--previous-year`,
                            icon: (iconProps)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ld0cd))), {
                                    ...iconProps,
                                    size: "small"
                                }),
                            label: `${previousYearLabel}, ${previousYearHeading}`
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $Ay1uj.default), {
                            appearance: "subtle",
                            spacing: "compact",
                            tabIndex: tabIndex,
                            onClick: handlePrevMonthInteraction,
                            testId: testId && `${testId}--previous-month`,
                            icon: (iconProps)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8PCRQ))), {
                                    ...iconProps,
                                    size: "small"
                                }),
                            label: `${previousMonthLabel}, ${previousMonthHeading}`
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                    "aria-live": hasInteractedWithMonthOrYear ? 'polite' : undefined,
                    id: announceId,
                    testId: testId && `${testId}--current-month-year--container`,
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $806LH.default), {
                        size: "xsmall",
                        as: "h2",
                        id: headerId,
                        testId: testId && `${testId}--current-month-year`,
                        children: `${monthLongTitle} ${year}`
                    })
                }),
                /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $6djmC.default), {
                    space: "space.100",
                    alignBlock: "end",
                    children: [
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $Ay1uj.default), {
                            appearance: "subtle",
                            spacing: "compact",
                            tabIndex: tabIndex,
                            onClick: handleNextMonthInteraction,
                            testId: testId && `${testId}--next-month`,
                            icon: (iconProps)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cQxBL))), {
                                    ...iconProps,
                                    size: "small"
                                }),
                            label: `${nextMonthLabel}, ${nextMonthHeading}`
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $Ay1uj.default), {
                            appearance: "subtle",
                            spacing: "compact",
                            tabIndex: tabIndex,
                            onClick: handleNextYearInteraction,
                            testId: testId && `${testId}--next-year`,
                            icon: (iconProps)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cqfIR))), {
                                    ...iconProps,
                                    size: "small"
                                }),
                            label: `${nextYearLabel}, ${nextYearHeading}`
                        })
                    ]
                })
            ]
        })
    });
});
$8fe58087a91a587c$var$Header.displayName = 'Header';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$8fe58087a91a587c$export$2e2bcd8739ae039 = $8fe58087a91a587c$var$Header;

});
parcelRegister("ld0cd", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3a1ef6001ab87a1d8d52e3fa36b1ca44>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f70af6cd1d0cef8e$var$_react = $f70af6cd1d0cef8e$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $f70af6cd1d0cef8e$var$_baseNew = $f70af6cd1d0cef8e$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $f70af6cd1d0cef8e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronDoubleLeft".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: Navigate to previous year in calendar/date picker
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f70af6cd1d0cef8e$var$ChevronDoubleLeftIcon = (props)=>/*#__PURE__*/ $f70af6cd1d0cef8e$var$_react.default.createElement($f70af6cd1d0cef8e$var$_baseNew.default, Object.assign({
        name: "ChevronDoubleLeftIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m7.72 1.47-6 6a.75.75 0 0 0-.052 1.004l.052.056 6 6 1.06-1.06L3.31 8l5.47-5.47z"/><path fill="currentcolor" d="m12.47 1.47-6 6a.75.75 0 0 0-.052 1.004l.052.056 6 6 1.06-1.06L8.06 8l5.47-5.47z"/>`
    }, props));
$f70af6cd1d0cef8e$var$ChevronDoubleLeftIcon.displayName = 'ChevronDoubleLeftIcon';
var $f70af6cd1d0cef8e$var$_default = module.exports.default = $f70af6cd1d0cef8e$var$ChevronDoubleLeftIcon;

});

parcelRegister("cqfIR", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5b4e628ea814f393cf264d604c04f2e9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $90b41be71667434a$var$_react = $90b41be71667434a$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $90b41be71667434a$var$_baseNew = $90b41be71667434a$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $90b41be71667434a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronDoubleRight".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: Navigate to next year in calendar/date picker
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $90b41be71667434a$var$ChevronDoubleRightIcon = (props)=>/*#__PURE__*/ $90b41be71667434a$var$_react.default.createElement($90b41be71667434a$var$_baseNew.default, Object.assign({
        name: "ChevronDoubleRightIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m8.28 1.47 6 6a.75.75 0 0 1 .052 1.004l-.052.056-6 6-1.06-1.06L12.69 8 7.22 2.53z"/><path fill="currentcolor" d="m3.53 1.47 6 6a.75.75 0 0 1 .052 1.004l-.052.056-6 6-1.06-1.06L7.94 8 2.47 2.53z"/>`
    }, props));
$90b41be71667434a$var$ChevronDoubleRightIcon.displayName = 'ChevronDoubleRightIcon';
var $90b41be71667434a$var$_default = module.exports.default = $90b41be71667434a$var$ChevronDoubleRightIcon;

});

parcelRegister("8PCRQ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8ee9ad5072a30451ff7ca2ddc0961d03>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $66e13c6de5d90262$var$_react = $66e13c6de5d90262$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $66e13c6de5d90262$var$_baseNew = $66e13c6de5d90262$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $66e13c6de5d90262$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronLeft".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Navigate back, show previous page of pagination results
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $66e13c6de5d90262$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $66e13c6de5d90262$var$_react.default.createElement($66e13c6de5d90262$var$_baseNew.default, Object.assign({
        name: "ChevronLeftIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m9.97 1.47-6 6a.75.75 0 0 0-.052 1.004l.052.056 6 6 1.06-1.06L5.56 8l5.47-5.47z"/>`
    }, props));
$66e13c6de5d90262$var$ChevronLeftIcon.displayName = 'ChevronLeftIcon';
var $66e13c6de5d90262$var$_default = module.exports.default = $66e13c6de5d90262$var$ChevronLeftIcon;

});


parcelRegister("jOHXZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $7776188040914bac$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");

var $17gD3 = parcelRequire("17gD3");

var $48tPc = parcelRequire("48tPc");
const $7776188040914bac$var$WeekDays = /*#__PURE__*/ (0, $eJOHy.memo)(function WeekDays({ weeks: weeks, handleClickDay: handleClickDay, monthsLong: monthsLong, shouldSetFocus: shouldSetFocus, tabIndex: tabIndex, testId: testId }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8nu6j.default), {
        role: "rowgroup",
        testId: testId && `${testId}--month`,
        children: weeks.map((week, i)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $48tPc.default), {
                testId: testId && `${testId}--week`,
                children: week.values.map((weekDay)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $17gD3.default), {
                        isDisabled: weekDay.isDisabled,
                        isFocused: weekDay.isFocused,
                        isToday: weekDay.isToday,
                        dayLong: weekDay.weekDayName,
                        month: weekDay.month,
                        monthLong: monthsLong[weekDay.month - 1],
                        onClick: handleClickDay,
                        isPreviouslySelected: weekDay.isPreviouslySelected,
                        isSelected: weekDay.isSelected,
                        isSibling: weekDay.isSiblingMonth,
                        year: weekDay.year,
                        shouldSetFocus: shouldSetFocus,
                        tabIndex: tabIndex,
                        testId: testId,
                        children: weekDay.day
                    }, `${week.id}-${weekDay.id}`))
            }, i))
    });
});
$7776188040914bac$var$WeekDays.displayName = 'WeekDays';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$7776188040914bac$export$2e2bcd8739ae039 = $7776188040914bac$var$WeekDays;

});
parcelRegister("17gD3", function(module, exports) {
$parcel$export(module.exports, "default", () => $7f55ebb7772d4c5d$export$2e2bcd8739ae039);
/* date.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $3Vuhz = parcelRequire("3Vuhz");

var $hYvlq = parcelRequire("hYvlq");
const $7f55ebb7772d4c5d$var$dateCellSiblingStyle = null;
const $7f55ebb7772d4c5d$var$dateCellTodayStyle = null;
const $7f55ebb7772d4c5d$var$dateCellPrevSelectedStyle = null;
const $7f55ebb7772d4c5d$var$dateCellSelectedStyle = null;
const $7f55ebb7772d4c5d$var$dateCellDisabledStyle = null;
const $7f55ebb7772d4c5d$var$dateCellStyles = null;
const $7f55ebb7772d4c5d$var$Date = /*#__PURE__*/ (0, $eJOHy.memo)(/*#__PURE__*/ (0, $eJOHy.forwardRef)(function Date({ children: day, isDisabled: isDisabled = false, isFocused: isFocused = false, isToday: isToday = false, dayLong: dayLong, month: month, monthLong: monthLong, onClick: onClick = (0, $3Vuhz.default), isPreviouslySelected: isPreviouslySelected = false, isSelected: isSelected = false, isSibling: isSibling = false, year: year, shouldSetFocus: shouldSetFocus, tabIndex: tabIndex, testId: testId }, _ref) {
    const dateRef = (0, $eJOHy.useRef)({
        day: day,
        month: month,
        year: year,
        isDisabled: isDisabled
    });
    (0, $eJOHy.useEffect)(()=>{
        dateRef.current = {
            day: day,
            month: month,
            year: year,
            isDisabled: isDisabled
        };
    }, [
        day,
        month,
        year,
        isDisabled
    ]);
    const focusRef = (0, $eJOHy.useRef)(null);
    (0, $eJOHy.useEffect)(()=>{
        if (isFocused && shouldSetFocus && focusRef.current) focusRef.current.focus();
    }, [
        isFocused,
        shouldSetFocus
    ]);
    const handleClick = (0, $eJOHy.useCallback)(()=>{
        const { day: dayValue, month: monthValue, year: yearValue, isDisabled: isDisabledValue } = dateRef.current;
        if (!isDisabledValue) onClick({
            day: dayValue,
            month: monthValue,
            year: yearValue
        });
    }, [
        onClick
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hYvlq.default), {
        role: "gridcell",
        alignItems: "center",
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("button", {
            "aria-current": isToday ? 'date' : undefined,
            "aria-disabled": isDisabled || undefined,
            "aria-label": `${day}, ${dayLong} ${monthLong} ${year}`,
            "aria-pressed": isSelected ? 'true' : 'false',
            tabIndex: isFocused ? tabIndex : -1,
            type: "button",
            onClick: handleClick,
            ref: focusRef,
            "data-disabled": isDisabled || undefined,
            "data-focused": isFocused || undefined,
            "data-prev-selected": isPreviouslySelected || undefined,
            "data-selected": isSelected || undefined,
            "data-sibling": isSibling || undefined,
            "data-today": isToday || undefined,
            "data-testid": testId && (isSelected ? `${testId}--selected-day` : `${testId}--day`),
            className: (0, $hcewu.default)([
                "_kkk2n7od _2rkofajl _11c82smr _1h6d3acm _1dqonqa1 _189e1dm9 _1e0c1ule _kqswh2mm _16jlkb7n _bfhk18uv _syazj3m3 _80omtlke _85i51b66 _1q511b66 _y4tirdoj _bozgrdoj _y3gn1h6o _pojj194a _10knnqa1 _1wysdkaa _irr314ae _30l3j3m3 _1di61l7b _9h8hj3m3",
                isSibling && "_syaz1wmz _30l31wmz",
                isToday && "_syaz1ldt _k48p1igg _1ywu1ule _1qdgyh40 _18postnw _1hfk1r31 _aetrb3bt _1gufv77o _1czdv77o _g0nfv77o",
                isPreviouslySelected && "_bfhk29zg _syazc8hx _30l3c8hx",
                isSelected && "_bfhk1p4p _syazqueg _irr3quvt _30l31uqy",
                isDisabled && "_syaz7dlb _80om13gf _irr318uv _30l37dlb"
            ]),
            children: day
        })
    });
}));
$7f55ebb7772d4c5d$var$Date.displayName = 'Date';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$7f55ebb7772d4c5d$export$2e2bcd8739ae039 = $7f55ebb7772d4c5d$var$Date;

});
parcelRegister("hYvlq", function(module, exports) {
$parcel$export(module.exports, "default", () => $3e062987a137d87a$export$2e2bcd8739ae039);
/* grid.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $3e062987a137d87a$var$rowGapMap = {
    'space.0': "_1p57ze3t",
    'space.025': "_1p57v77o",
    'space.050': "_1p571b66",
    'space.075': "_1p5712x7",
    'space.100': "_1p57u2gc",
    'space.150': "_1p57utpp",
    'space.200': "_1p57pxbi",
    'space.250': "_1p57v47k",
    'space.300': "_1p571ejb",
    'space.400': "_1p57xy5q",
    'space.500': "_1p571jfw",
    'space.600': "_1p57oahv",
    'space.800': "_1p57xncg",
    'space.1000': "_1p571epz"
};
const $3e062987a137d87a$var$columnGapMap = {
    'space.0': "_gy1pze3t",
    'space.025': "_gy1pv77o",
    'space.050': "_gy1p1b66",
    'space.075': "_gy1p12x7",
    'space.100': "_gy1pu2gc",
    'space.150': "_gy1putpp",
    'space.200': "_gy1ppxbi",
    'space.250': "_gy1pv47k",
    'space.300': "_gy1p1ejb",
    'space.400': "_gy1pxy5q",
    'space.500': "_gy1p1jfw",
    'space.600': "_gy1poahv",
    'space.800': "_gy1pxncg",
    'space.1000': "_gy1p1epz"
};
const $3e062987a137d87a$var$justifyContentMap = {
    start: "_1bahv2br",
    center: "_1bah1h6o",
    end: "_1bahh9n0",
    'space-between': "_1bah1yb4",
    'space-around': "_1bah1b1v",
    'space-evenly': "_1bahitcz",
    stretch: "_1bah1fhb"
};
const $3e062987a137d87a$var$alignContentMap = {
    start: "_ae4vv2br",
    center: "_ae4v1h6o",
    end: "_ae4vh9n0",
    'space-between': "_ae4v1yb4",
    'space-around': "_ae4v1b1v",
    'space-evenly': "_ae4vitcz",
    stretch: "_ae4v1fhb"
};
const $3e062987a137d87a$var$alignItemsMap = {
    start: "_4cvrv2br",
    center: "_4cvr1h6o",
    baseline: "_4cvr1q9y",
    end: "_4cvrh9n0",
    stretch: "_4cvr1fhb"
};
const $3e062987a137d87a$var$baseStyles = {
    root: "_1e0c11p5 _vchhusvi"
};
const $3e062987a137d87a$var$gridAutoFlowMap = {
    row: "_wij2vrvc",
    column: "_wij21bp4",
    dense: "_wij218l3",
    'row dense': "_wij2j5tq",
    'column dense': "_wij2adhi"
};
/**
 * __Grid__
 *
 * `Grid` is a primitive component that implements the CSS Grid API.
 *
 * - [Examples](https://atlassian.design/components/primitives/grid/examples)
 * - [Code](https://atlassian.design/components/primitives/grid/code)
 *
 * @example
 * ```tsx
 * import { Grid, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Grid gap="space.100" gridColumns="1fr 1fr">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Grid>
 * )
 * ```
 */ const $3e062987a137d87a$var$Grid = /*#__PURE__*/ (0, $eJOHy.memo)(/*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: as, alignItems: alignItems, alignContent: alignContent, justifyContent: justifyContent, gap: gap, columnGap: columnGap, rowGap: rowGap, children: children, id: id, role: role, testId: testId, autoFlow: autoFlow, xcss: xcss }, ref)=>{
    const Component = as || 'div';
    return /*#__PURE__*/ (0, $gt9Am.jsx)(Component, {
        id: id,
        role: role,
        className: (0, $hcewu.default)([
            $3e062987a137d87a$var$baseStyles.root,
            gap && $3e062987a137d87a$var$columnGapMap[gap],
            columnGap && $3e062987a137d87a$var$columnGapMap[columnGap],
            gap && $3e062987a137d87a$var$rowGapMap[gap],
            rowGap && $3e062987a137d87a$var$rowGapMap[rowGap],
            alignItems && $3e062987a137d87a$var$alignItemsMap[alignItems],
            alignContent && $3e062987a137d87a$var$alignContentMap[alignContent],
            justifyContent && $3e062987a137d87a$var$justifyContentMap[justifyContent],
            autoFlow && $3e062987a137d87a$var$gridAutoFlowMap[autoFlow],
            xcss
        ]),
        "data-testid": testId,
        ref: ref,
        children: children
    });
}));
$3e062987a137d87a$var$Grid.displayName = 'Grid';
var $3e062987a137d87a$export$2e2bcd8739ae039 = $3e062987a137d87a$var$Grid;

});


parcelRegister("48tPc", function(module, exports) {
$parcel$export(module.exports, "default", () => $4f5de1de4465d4ec$export$2e2bcd8739ae039);
/* week-day-grid.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hYvlq = parcelRequire("hYvlq");
const $4f5de1de4465d4ec$var$styles = {
    templateColumns: "_yv0eloeq"
};
/**
 * __Week day grid__
 *
 * A week day grid aligns elements in a 7 wide grid layout.
 *
 */ const $4f5de1de4465d4ec$var$WeekDayGrid = ({ testId: testId, children: children, isHidden: isHidden })=>{
    const row = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hYvlq.default), {
        testId: testId,
        xcss: $4f5de1de4465d4ec$var$styles.templateColumns,
        role: "row",
        children: children
    });
    return isHidden ? /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        "aria-hidden": "true",
        children: row
    }) : row;
};
var $4f5de1de4465d4ec$export$2e2bcd8739ae039 = $4f5de1de4465d4ec$var$WeekDayGrid;

});


parcelRegister("1p4Fz", function(module, exports) {
$parcel$export(module.exports, "default", () => $be65a37818b8364c$export$2e2bcd8739ae039);
/* week-header.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $8IeH1 = parcelRequire("8IeH1");
var $3cMgR = parcelRequire("3cMgR");

var $48tPc = parcelRequire("48tPc");
const $be65a37818b8364c$var$styles = {
    columnHeader: "_1ul98pqr _o5721q9c _1e0c1txw _1bah1h6o"
};
const $be65a37818b8364c$var$WeekHeader = /*#__PURE__*/ (0, $eJOHy.memo)(function WeekHeader({ daysShort: daysShort, testId: testId }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $48tPc.default), {
        isHidden: true,
        testId: testId && `${testId}--column-headers`,
        children: daysShort.map((shortDay)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                padding: "space.100",
                xcss: $be65a37818b8364c$var$styles.columnHeader,
                role: "columnheader",
                testId: testId && `${testId}--column-header`,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3cMgR.default), {
                    weight: "bold",
                    size: "UNSAFE_small",
                    align: "center",
                    color: "color.text.subtle",
                    children: shortDay
                })
            }, shortDay))
    });
});
$be65a37818b8364c$var$WeekHeader.displayName = 'WeekHeader';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$be65a37818b8364c$export$2e2bcd8739ae039 = $be65a37818b8364c$var$WeekHeader;

});

parcelRegister("h2Y6s", function(module, exports) {
$parcel$export(module.exports, "arrowKeys", () => $be18158d85881f31$export$8b15eca9c6d5c48a);
$parcel$export(module.exports, "daysPerWeek", () => $be18158d85881f31$export$3ae905d9742bef55);
$parcel$export(module.exports, "monthsPerYear", () => $be18158d85881f31$export$c9b7c010035d60c6);
$parcel$export(module.exports, "blankStringArray", () => $be18158d85881f31$export$8fa20d70624f8b9d);
const $be18158d85881f31$export$8b15eca9c6d5c48a = {
    ArrowDown: 'down',
    ArrowLeft: 'left',
    ArrowRight: 'right',
    ArrowUp: 'up'
};
const $be18158d85881f31$export$3ae905d9742bef55 = 7;
const $be18158d85881f31$export$c9b7c010035d60c6 = 12;
const $be18158d85881f31$export$8fa20d70624f8b9d = [];

});

parcelRegister("7pqrO", function(module, exports) {
$parcel$export(module.exports, "default", () => $dd0ab84481a095dc$export$2e2bcd8739ae039);

var $7O2l7 = parcelRequire("7O2l7");

var $3c3v8 = parcelRequire("3c3v8");

var $ediHA = parcelRequire("ediHA");
function $dd0ab84481a095dc$export$2e2bcd8739ae039({ day: day, defaultDay: defaultDay, month: month, defaultMonth: defaultMonth, year: year, defaultYear: defaultYear, today: today, selected: selected, defaultSelected: defaultSelected, previouslySelected: previouslySelected, defaultPreviouslySelected: defaultPreviouslySelected }) {
    const { current: { thisDay: thisDay, thisMonth: thisMonth, thisYear: thisYear } } = (0, $3c3v8.default)(()=>{
        const now = new Date();
        const thisDay = now.getDate();
        const thisMonth = now.getMonth() + 1;
        const thisYear = now.getFullYear();
        return {
            thisDay: thisDay,
            thisMonth: thisMonth,
            thisYear: thisYear
        };
    });
    const [dayValue, setDayValue] = (0, $7O2l7.default)(day, ()=>defaultDay || thisDay);
    const [monthValue, setMonthValue] = (0, $7O2l7.default)(month, ()=>defaultMonth || thisMonth);
    const [yearValue, setYearValue] = (0, $7O2l7.default)(year, ()=>defaultYear || thisYear);
    const [todayValue] = (0, $7O2l7.default)(today, ()=>today || `${thisYear}-${(0, $ediHA.default)(thisMonth)}-${(0, $ediHA.default)(thisDay)}`);
    const [selectedValue, setSelectedValue] = (0, $7O2l7.default)(selected, ()=>defaultSelected);
    const [previouslySelectedValue, setPreviouslySelectedValue] = (0, $7O2l7.default)(previouslySelected, ()=>defaultPreviouslySelected);
    return {
        day: [
            dayValue,
            setDayValue
        ],
        month: [
            monthValue,
            setMonthValue
        ],
        year: [
            yearValue,
            setYearValue
        ],
        today: [
            todayValue
        ],
        selected: [
            selectedValue,
            setSelectedValue
        ],
        previous: [
            previouslySelectedValue,
            setPreviouslySelectedValue
        ]
    };
}

});
parcelRegister("ediHA", function(module, exports) {
$parcel$export(module.exports, "default", () => $50fecd0d0148fc4a$export$2e2bcd8739ae039);
function $50fecd0d0148fc4a$export$2e2bcd8739ae039(num) {
    return num < 10 ? `0${num}` : `${num}`;
}

});


parcelRegister("8m7JM", function(module, exports) {
$parcel$export(module.exports, "default", () => $c971afa7669251e8$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");
function $c971afa7669251e8$export$2e2bcd8739ae039({ onBlur: onBlur, onFocus: onFocus }) {
    const handleContainerBlur = (0, $eJOHy.useCallback)((event)=>{
        onBlur(event);
    }, [
        onBlur
    ]);
    const handleContainerFocus = (0, $eJOHy.useCallback)((event)=>{
        onFocus(event);
    }, [
        onFocus
    ]);
    return {
        handleContainerBlur: handleContainerBlur,
        handleContainerFocus: handleContainerFocus
    };
}

});

parcelRegister("5Pa93", function(module, exports) {
$parcel$export(module.exports, "default", () => $6571678cf382b203$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $kQ82p = parcelRequire("kQ82p");

var $h2Y6s = parcelRequire("h2Y6s");

var $fdbAT = parcelRequire("fdbAT");

var $cFI4x = parcelRequire("cFI4x");
function $6571678cf382b203$var$useGetCalendarWithSixthWeek(calendar, { month: month, year: year, weekStartDay: weekStartDay }) {
    const shouldDisplaySixthWeek = calendar.length % 6;
    const calendarLastValue = calendar[calendar.length - 1];
    return (0, $eJOHy.useMemo)(()=>{
        // Some months jump between 5 and 6 weeks to display. In some cases 4 (Feb
        // with the 1st on a Monday etc). This ensures the UI doesn't jump around by
        // catering to always showing 6 weeks.
        if (shouldDisplaySixthWeek) {
            const lastDayIsSibling = calendarLastValue.siblingMonth;
            const sliceStart = lastDayIsSibling ? (0, $h2Y6s.daysPerWeek) : 0;
            return (0, $cFI4x.default)(year, month, {
                weekStartDay: weekStartDay
            }).slice(sliceStart, sliceStart + (0, $h2Y6s.daysPerWeek)).map((date)=>({
                    ...date,
                    siblingMonth: true
                }));
        }
        return [];
    }, [
        calendarLastValue,
        month,
        shouldDisplaySixthWeek,
        weekStartDay,
        year
    ]);
}
function $6571678cf382b203$export$2e2bcd8739ae039({ day: day, daysLong: daysLong, month: month, year: year, today: today, disabled: disabled, disabledDateFilter: disabledDateFilter, minDate: minDateString, maxDate: maxDateString, selected: selected, previouslySelected: previouslySelected, weekStartDay: weekStartDay }) {
    const calendar = (0, $eJOHy.useMemo)(()=>(0, $cFI4x.default)(year, month - 1, {
            weekStartDay: weekStartDay
        }), [
        month,
        weekStartDay,
        year
    ]);
    const calendarWithSixthWeek = $6571678cf382b203$var$useGetCalendarWithSixthWeek(calendar, {
        month: month,
        year: year,
        weekStartDay: weekStartDay
    });
    if (calendarWithSixthWeek) calendar.push(...calendarWithSixthWeek);
    const minDate = minDateString ? (0, $kQ82p.default)(minDateString) : undefined;
    const maxDate = maxDateString ? (0, $kQ82p.default)(maxDateString) : undefined;
    const needJsDate = minDateString || maxDateString;
    return (0, $eJOHy.useMemo)(()=>{
        const weeks = [];
        calendar.forEach((date)=>{
            const dateAsString = (0, $fdbAT.default)(date, {
                fixMonth: true
            });
            const JSDate = needJsDate ? (0, $kQ82p.default)(dateAsString) : undefined;
            let week;
            if (date.weekDay === weekStartDay) {
                week = {
                    id: dateAsString,
                    values: []
                };
                weeks.push(week);
            } else week = weeks[weeks.length - 1];
            const weekDayOffset = (date.weekDay - weekStartDay) % 7;
            // Define a bunch of `const`s
            const weekDayName = daysLong[weekDayOffset];
            const isDisabledByArray = disabled ? disabled.indexOf(dateAsString) > -1 : false;
            const isDisabledByFilter = disabledDateFilter ? disabledDateFilter(dateAsString) : false;
            const isDisabledByMin = minDate && JSDate ? JSDate < minDate : false;
            const isDisabledByMax = maxDate && JSDate ? JSDate > maxDate : false;
            const isDisabled = isDisabledByArray || isDisabledByFilter || isDisabledByMin || isDisabledByMax;
            const isFocused = day === date.day && !date.siblingMonth;
            const isPreviouslySelected = !isDisabled && previouslySelected.indexOf(dateAsString) > -1;
            const isSelected = !isDisabled && selected.indexOf(dateAsString) > -1;
            const isSiblingMonth = !!date.siblingMonth;
            const isToday = today === dateAsString;
            week.values.push({
                id: dateAsString,
                isDisabled: isDisabled,
                isFocused: isFocused,
                isToday: isToday,
                month: date.month + 1,
                isPreviouslySelected: isPreviouslySelected,
                isSelected: isSelected,
                isSiblingMonth: isSiblingMonth,
                year: date.year,
                day: date.day,
                weekDayName: weekDayName
            });
        });
        return weeks;
    }, [
        calendar,
        day,
        disabled,
        disabledDateFilter,
        minDate,
        maxDate,
        needJsDate,
        previouslySelected,
        selected,
        today,
        weekStartDay,
        daysLong
    ]);
}

});
parcelRegister("fdbAT", function(module, exports) {
$parcel$export(module.exports, "default", () => $33e505eaecca4d6d$export$2e2bcd8739ae039);

var $ediHA = parcelRequire("ediHA");
function $33e505eaecca4d6d$export$2e2bcd8739ae039(date, options) {
    return `${date.year}-${(0, $ediHA.default)(date.month + (options && options.fixMonth ? 1 : 0))}-${(0, $ediHA.default)(date.day)}`;
}

});

parcelRegister("cFI4x", function(module, exports) {
$parcel$export(module.exports, "default", () => $5fc98c4c7dc36d65$export$2e2bcd8739ae039);
/**
 * Logic taken from https://github.com/WesSouza/calendar-base which is not maintained for quite sometime.
 * This will help us fixing any issue we might get or any new functionality we might want to support.
 * Not changing much code below. Just removed those parts which we don't need.
 */ 
var $h2Y6s = parcelRequire("h2Y6s");

var $d9oTA = parcelRequire("d9oTA");
function $5fc98c4c7dc36d65$export$2e2bcd8739ae039(year, month, { weekStartDay: weekStartDay = 0 } = {
    weekStartDay: 0
}) {
    const date = new Date(Date.UTC(year, month, 1, 0, 0, 0, 0));
    const utcYear = date.getUTCFullYear();
    const utcMonth = date.getUTCMonth();
    const calendar = [];
    const firstDay = date.getUTCDay();
    const firstDate = -(((0, $h2Y6s.daysPerWeek) - weekStartDay + firstDay) % (0, $h2Y6s.daysPerWeek));
    const lastDate = (0, $d9oTA.default)(utcYear, utcMonth);
    const lastDay = (lastDate - firstDate) % (0, $h2Y6s.daysPerWeek);
    const lastDateOfPreviousMonth = (0, $d9oTA.default)(utcYear, utcMonth - 1);
    let dateCounter = firstDate;
    let currentDay;
    let currentDate;
    let currentDateObject = null;
    let calculatedMonth;
    let calculatedYear;
    const maxDateCount = lastDate - dateCounter + (lastDay !== 0 ? (0, $h2Y6s.daysPerWeek) - lastDay : 0) + firstDate;
    while(dateCounter < maxDateCount){
        currentDate = dateCounter + 1;
        currentDay = ((dateCounter < 1 ? (0, $h2Y6s.daysPerWeek) + dateCounter : dateCounter) + firstDay) % (0, $h2Y6s.daysPerWeek);
        if (currentDate < 1 || currentDate > lastDate) {
            if (currentDate < 1) {
                calculatedMonth = utcMonth - 1;
                calculatedYear = utcYear;
                if (calculatedMonth < 0) {
                    calculatedMonth = (0, $h2Y6s.monthsPerYear) - 1;
                    calculatedYear--;
                }
                currentDate = lastDateOfPreviousMonth + currentDate;
            } else if (currentDate > lastDate) {
                calculatedMonth = utcMonth + 1;
                calculatedYear = utcYear;
                if (calculatedMonth > (0, $h2Y6s.monthsPerYear) - 1) {
                    calculatedMonth = 0;
                    calculatedYear++;
                }
                currentDate = dateCounter - lastDate + 1;
            }
            if (calculatedMonth !== undefined && calculatedYear !== undefined) currentDateObject = {
                day: currentDate,
                weekDay: currentDay,
                month: calculatedMonth,
                year: calculatedYear,
                siblingMonth: true
            };
        } else currentDateObject = {
            day: currentDate,
            weekDay: currentDay,
            month: utcMonth,
            year: utcYear
        };
        calendar.push(currentDateObject);
        dateCounter++;
    }
    return calendar;
}

});
parcelRegister("d9oTA", function(module, exports) {
$parcel$export(module.exports, "default", () => $bdb6610bba124d19$export$2e2bcd8739ae039);
function $bdb6610bba124d19$export$2e2bcd8739ae039(year, month) {
    return new Date(year, month + 1, 0).getDate();
}

});



parcelRegister("cM3gB", function(module, exports) {
$parcel$export(module.exports, "default", () => $e11abbd67514b7e7$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $h2Y6s = parcelRequire("h2Y6s");

var $fdbAT = parcelRequire("fdbAT");

var $d9oTA = parcelRequire("d9oTA");
const $e11abbd67514b7e7$var$getNextMonth = (monthValue, yearValue)=>{
    let month = monthValue;
    let year = yearValue;
    if (month === (0, $h2Y6s.monthsPerYear)) {
        month = 1;
        year += 1;
    } else month += 1;
    return {
        month: month,
        year: year
    };
};
const $e11abbd67514b7e7$var$getPrevMonth = (monthValue, yearValue)=>{
    let month = monthValue;
    let year = yearValue;
    if (month === 1) {
        month = (0, $h2Y6s.monthsPerYear);
        year -= 1;
    } else month -= 1;
    return {
        month: month,
        year: year
    };
};
function $e11abbd67514b7e7$export$2e2bcd8739ae039({ day: [dayValue, setDayValue], month: [monthValue, setMonthValue], year: [yearValue, setYearValue], shouldSetFocus: [_shouldSetFocus, setShouldSetFocus], onChange: onChange }) {
    const dateRef = (0, $eJOHy.useRef)({
        day: dayValue,
        month: monthValue,
        year: yearValue
    });
    (0, $eJOHy.useEffect)(()=>{
        dateRef.current = {
            day: dayValue,
            month: monthValue,
            year: yearValue
        };
    }, [
        dayValue,
        monthValue,
        yearValue
    ]);
    const triggerOnChange = (0, $eJOHy.useCallback)(({ year: year, month: month, day: day, type: type })=>{
        const iso = (0, $fdbAT.default)({
            year: year,
            month: month,
            day: day
        });
        const isFocusableType = [
            'up',
            'down',
            'left',
            'right'
        ].includes(type);
        onChange({
            day: day,
            month: month,
            year: year,
            iso: iso,
            type: type
        });
        setDayValue(day);
        setMonthValue(month);
        setYearValue(year);
        setShouldSetFocus(isFocusableType);
    }, [
        onChange,
        setDayValue,
        setMonthValue,
        setYearValue,
        setShouldSetFocus
    ]);
    const navigate = (0, $eJOHy.useCallback)((type)=>{
        const { day: day, month: month, year: year } = dateRef.current;
        if (type === 'down') {
            const next = day + (0, $h2Y6s.daysPerWeek);
            const daysInMonth = (0, $d9oTA.default)(year, month - 1);
            if (next > daysInMonth) {
                const { month: nextMonth, year: nextYear } = $e11abbd67514b7e7$var$getNextMonth(month, year);
                triggerOnChange({
                    year: nextYear,
                    month: nextMonth,
                    day: next - daysInMonth,
                    type: type
                });
            } else triggerOnChange({
                year: year,
                month: month,
                day: next,
                type: type
            });
        } else if (type === 'left') {
            const prev = day - 1;
            if (prev < 1) {
                const { month: prevMonth, year: prevYear } = $e11abbd67514b7e7$var$getPrevMonth(month, year);
                const prevDay = (0, $d9oTA.default)(prevYear, prevMonth - 1);
                triggerOnChange({
                    year: prevYear,
                    month: prevMonth,
                    day: prevDay,
                    type: type
                });
            } else triggerOnChange({
                year: year,
                month: month,
                day: prev,
                type: type
            });
        } else if (type === 'right') {
            const next = day + 1;
            const daysInMonth = (0, $d9oTA.default)(year, month - 1);
            if (next > daysInMonth) {
                const { month: nextMonth, year: nextYear } = $e11abbd67514b7e7$var$getNextMonth(month, year);
                triggerOnChange({
                    year: nextYear,
                    month: nextMonth,
                    day: 1,
                    type: type
                });
            } else triggerOnChange({
                year: year,
                month: month,
                day: next,
                type: type
            });
        } else if (type === 'up') {
            const prev = day - (0, $h2Y6s.daysPerWeek);
            if (prev < 1) {
                const { month: prevMonth, year: prevYear } = $e11abbd67514b7e7$var$getPrevMonth(month, year);
                const prevDay = (0, $d9oTA.default)(prevYear, prevMonth - 1) + prev;
                triggerOnChange({
                    year: prevYear,
                    month: prevMonth,
                    day: prevDay,
                    type: type
                });
            } else triggerOnChange({
                year: year,
                month: month,
                day: prev,
                type: type
            });
        }
    }, [
        triggerOnChange
    ]);
    const handleClickNextMonth = (0, $eJOHy.useCallback)(()=>{
        const { day: day, month: month, year: year } = {
            ...dateRef.current,
            ...$e11abbd67514b7e7$var$getNextMonth(dateRef.current.month, dateRef.current.year)
        };
        triggerOnChange({
            day: day,
            month: month,
            year: year,
            type: 'nextMonth'
        });
    }, [
        triggerOnChange
    ]);
    const handleClickNextYear = (0, $eJOHy.useCallback)(()=>{
        const { day: day, month: month, year: year } = dateRef.current;
        triggerOnChange({
            day: day,
            month: month,
            year: year + 1,
            type: 'nextYear'
        });
    }, [
        triggerOnChange
    ]);
    const handleClickPrevMonth = (0, $eJOHy.useCallback)(()=>{
        const { day: day, month: month, year: year } = {
            ...dateRef.current,
            ...$e11abbd67514b7e7$var$getPrevMonth(dateRef.current.month, dateRef.current.year)
        };
        triggerOnChange({
            day: day,
            month: month,
            year: year,
            type: 'prevMonth'
        });
    }, [
        triggerOnChange
    ]);
    const handleClickPrevYear = (0, $eJOHy.useCallback)(()=>{
        const { day: day, month: month, year: year } = dateRef.current;
        triggerOnChange({
            day: day,
            month: month,
            year: year - 1,
            type: 'prevYear'
        });
    }, [
        triggerOnChange
    ]);
    return {
        navigate: navigate,
        handleClickNextMonth: handleClickNextMonth,
        handleClickNextYear: handleClickNextYear,
        handleClickPrevMonth: handleClickPrevMonth,
        handleClickPrevYear: handleClickPrevYear
    };
}

});

parcelRegister("lPLOh", function(module, exports) {
$parcel$export(module.exports, "default", () => $395ce53b4353da25$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $h2Y6s = parcelRequire("h2Y6s");

var $fdbAT = parcelRequire("fdbAT");
function $395ce53b4353da25$export$2e2bcd8739ae039({ day: [dayValue], month: [monthValue], year: [yearValue], selected: [selectedValue, setSelectedValue], previous: [, setPreviouslySelectedValue], onSelect: onSelect, navigate: navigate }) {
    const dateRef = (0, $eJOHy.useRef)({
        day: dayValue,
        month: monthValue,
        year: yearValue
    });
    (0, $eJOHy.useEffect)(()=>{
        dateRef.current = {
            day: dayValue,
            month: monthValue,
            year: yearValue
        };
    }, [
        dayValue,
        monthValue,
        yearValue
    ]);
    const triggerOnSelect = (0, $eJOHy.useCallback)(({ year: year, month: month, day: day })=>{
        const iso = (0, $fdbAT.default)({
            year: year,
            month: month,
            day: day
        });
        onSelect({
            day: day,
            month: month,
            year: year,
            iso: iso
        });
        setPreviouslySelectedValue(selectedValue);
        setSelectedValue([
            iso
        ]);
    }, [
        onSelect,
        selectedValue,
        setPreviouslySelectedValue,
        setSelectedValue
    ]);
    const handleClickDay = (0, $eJOHy.useCallback)(({ year: year, month: month, day: day })=>{
        triggerOnSelect({
            year: year,
            month: month,
            day: day
        });
    }, [
        triggerOnSelect
    ]);
    const handleContainerKeyDown = (0, $eJOHy.useCallback)((e)=>{
        const { key: key } = e;
        const arrowKey = (0, $h2Y6s.arrowKeys)[key];
        if (key === 'Enter' || key === ' ') {
            e.preventDefault();
            triggerOnSelect(dateRef.current);
        } else if (arrowKey) {
            e.preventDefault();
            navigate(arrowKey);
        }
    }, [
        triggerOnSelect,
        navigate
    ]);
    return {
        handleClickDay: handleClickDay,
        handleContainerKeyDown: handleContainerKeyDown
    };
}

});

parcelRegister("jtNxE", function(module, exports) {
$parcel$export(module.exports, "default", () => $01a6b7d4c4da291b$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $cK9J2 = parcelRequire("cK9J2");
function $01a6b7d4c4da291b$export$2e2bcd8739ae039({ locale: locale, weekStartDay: weekStartDay }) {
    const l10n = (0, $eJOHy.useMemo)(()=>(0, $cK9J2.createLocalizationProvider)(locale), [
        locale
    ]);
    const monthsLong = (0, $eJOHy.useMemo)(()=>l10n.getMonthsLong(), [
        l10n
    ]);
    const daysShort = (0, $eJOHy.useMemo)(()=>l10n.getDaysShort(weekStartDay), [
        l10n,
        weekStartDay
    ]);
    const daysLong = (0, $eJOHy.useMemo)(()=>l10n.getDaysLong(weekStartDay), [
        l10n,
        weekStartDay
    ]);
    return {
        monthsLong: monthsLong,
        daysShort: daysShort,
        daysLong: daysLong
    };
}

});


parcelRegister("7G7nX", function(module, exports) {
$parcel$export(module.exports, "default", () => $68ce7a484b05c143$export$2e2bcd8739ae039);
/* fixed-layer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $3Vuhz = parcelRequire("3Vuhz");

var $anoAR = parcelRequire("anoAR");

var $6G5P1 = parcelRequire("6G5P1");
var $8qmYl = parcelRequire("8qmYl");
var $azjc1 = parcelRequire("azjc1");
const $68ce7a484b05c143$var$styles = {
    root: "_bfhk18uv _kqswstnw _154ize3t",
    popperStyles: "_1pbyowjs"
};
class $68ce7a484b05c143$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    componentDidUpdate(prevProps) {
        if (prevProps.inputValue !== this.props.inputValue) this.update();
    }
    render() {
        const { containerRef: containerRef, content: content, testId: testId } = this.props;
        // Wait for containerRef callback to cause a re-render
        if (!containerRef) return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {});
        const divStyles = {
            height: containerRef.getBoundingClientRect().height,
            // Don't block the clear button
            width: containerRef.getBoundingClientRect().width - parseInt((0, $anoAR.sizes).small.slice(0, -2)) - 8
        };
        return(/* Need to wrap layer in a fixed position div so that it will render its content as fixed
       * We need to set the intial top value to where the container is and zIndex so that it still
       * applies since we're creating a new stacking context. */ /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $6G5P1.Manager), {
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $azjc1.Reference), {
                    children: ({ ref: ref })=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                            ref: ref,
                            "data-layer-child": true,
                            style: divStyles,
                            className: (0, $hcewu.default)([
                                $68ce7a484b05c143$var$styles.root
                            ])
                        })
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8qmYl.Popper), {
                    children: ({ ref: ref, style: style, update: update })=>{
                        this.update = update;
                        return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                            ref: ref,
                            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                            style: style,
                            "data-testid": testId && `${testId}--popper--container`,
                            className: (0, $hcewu.default)([
                                $68ce7a484b05c143$var$styles.popperStyles
                            ]),
                            children: content
                        });
                    }
                })
            ]
        }));
    }
    constructor(...args){
        super(...args), this.update = (0, $3Vuhz.default);
    }
}

});
parcelRegister("anoAR", function(module, exports) {
$parcel$export(module.exports, "sizes", () => $19bef17192bf3a9c$export$c647cb0ee6e282fe);
const $19bef17192bf3a9c$export$c647cb0ee6e282fe = {
    small: '16px',
    medium: '24px',
    large: '32px',
    xlarge: '48px'
};
const $19bef17192bf3a9c$export$7bd66fc94c81bf84 = {
    small: 'small',
    medium: 'medium',
    large: 'large',
    xlarge: 'xlarge'
};
const $19bef17192bf3a9c$export$62ad7b0c781000e9 = {
    small: {
        width: $19bef17192bf3a9c$export$c647cb0ee6e282fe.small,
        height: $19bef17192bf3a9c$export$c647cb0ee6e282fe.small
    },
    medium: {
        width: $19bef17192bf3a9c$export$c647cb0ee6e282fe.medium,
        height: $19bef17192bf3a9c$export$c647cb0ee6e282fe.medium
    },
    large: {
        width: $19bef17192bf3a9c$export$c647cb0ee6e282fe.large,
        height: $19bef17192bf3a9c$export$c647cb0ee6e282fe.large
    },
    xlarge: {
        width: $19bef17192bf3a9c$export$c647cb0ee6e282fe.xlarge,
        height: $19bef17192bf3a9c$export$c647cb0ee6e282fe.xlarge
    }
};

});



parcelRegister("1u9xN", function(module, exports) {
$parcel$export(module.exports, "getShortISOString", () => $a3c204a1b42604a4$export$77d5bc49fed7ef14);
$parcel$export(module.exports, "getSafeCalendarValue", () => $a3c204a1b42604a4$export$ff525416014fb67d);

var $57raR = parcelRequire("57raR");

var $5PwWU = parcelRequire("5PwWU");
function $a3c204a1b42604a4$export$77d5bc49fed7ef14(date) {
    return (0, $57raR.default)(date, (0, $5PwWU.convertTokens)('YYYY-MM-DD'));
}
function $a3c204a1b42604a4$export$ff525416014fb67d(calendarValue) {
    // If `calendarValue` has a year that is greater than 9999, default to
    // today's date
    const yearIsOverLimit = calendarValue.match(/^\d{5,}/);
    if (yearIsOverLimit) return $a3c204a1b42604a4$export$77d5bc49fed7ef14(new Date());
    return calendarValue;
}

});

parcelRegister("7OE9J", function(module, exports) {
$parcel$export(module.exports, "makeSingleValue", () => $8e54d9aa121b2675$export$6e30bf8cb1347b56);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $6XEne = parcelRequire("6XEne");
const $8e54d9aa121b2675$export$6e30bf8cb1347b56 = // TODO: Make ID required
({ id: id, lang: lang })=>({ children: children, className: className, clearValue: clearValue, cx: cx, data: data, getStyles: getStyles, getValue: getValue, hasValue: hasValue, isDisabled: isDisabled, isMulti: isMulti, isRtl: isRtl, options: options, selectOption: selectOption, selectProps: selectProps, setValue: setValue, ...rest })=>{
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6XEne.components).SingleValue, {
            ...rest,
            // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-classname-prop
            className: className,
            clearValue: clearValue,
            cx: cx,
            data: data,
            getStyles: getStyles,
            getValue: getValue,
            hasValue: hasValue,
            innerProps: {
                id: id,
                lang: lang
            },
            isDisabled: isDisabled,
            isMulti: isMulti,
            isRtl: isRtl,
            options: options,
            selectOption: selectOption,
            selectProps: selectProps,
            setValue: setValue,
            children: children
        });
    };

});


parcelRegister("k2Uo2", function(module, exports) {
$parcel$export(module.exports, "default", () => $00683ba6c52d5435$export$2e2bcd8739ae039);
/* date-picker-fc.tsx generated by @compiled/babel-plugin v0.36.1 */ /// <reference types="node" />
// for typing `process`

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $dBLX0 = parcelRequire("dBLX0");
var $kQ82p = parcelRequire("kQ82p");

var $jrFnt = parcelRequire("jrFnt");

var $Ay1uj = parcelRequire("Ay1uj");

var $6qaBj = parcelRequire("6qaBj");

var $gl2vi = parcelRequire("gl2vi");

var $3GKOL = parcelRequire("3GKOL");

var $cK9J2 = parcelRequire("cK9J2");

var $eGOwo = parcelRequire("eGOwo");

var $8IeH1 = parcelRequire("8IeH1");

var $c4OV1 = parcelRequire("c4OV1");
var $e9zKl = parcelRequire("e9zKl");

var $RoXqn = parcelRequire("RoXqn");

var $47or1 = parcelRequire("47or1");

var $hmV0i = parcelRequire("hmV0i");

var $gNwsY = parcelRequire("gNwsY");

var $1u9xN = parcelRequire("1u9xN");

var $7OE9J = parcelRequire("7OE9J");
const $00683ba6c52d5435$var$packageName = "platform-pkg";
const $00683ba6c52d5435$var$packageVersion = "0.0.0-use.local";
const $00683ba6c52d5435$var$styles = {
    pickerContainerStyle: "_kqswh2mm",
    dropdownIndicatorStyles: "_1ul91k8s _1tke1k8s _1e0c1txw _4cvr1h6o _1bah1h6o",
    iconContainerStyles: "_v564vrg3 _1e0c1txw _4t3i1osq _kqswstnw _4cvr1h6o _i0dl1kw7 _syaz1rpy _152tze3t _rjxpze3t _30l3azsu",
    iconSpacingWithClearButtonStyles: "_12l2xy5q",
    iconSpacingWithoutClearButtonStyles: "_12l21b66"
};
const $00683ba6c52d5435$var$analyticsAttributes = {
    componentName: 'datePicker',
    packageName: $00683ba6c52d5435$var$packageName,
    packageVersion: $00683ba6c52d5435$var$packageVersion
}; /**
    * __Date picker__
    *
    * A date picker allows the user to select a particular date.
    *
    * - [Examples](https://atlassian.design/components/datetime-picker/date-picker/examples)
    * - [Code](https://atlassian.design/components/datetime-picker/date-picker/code)
    * - [Usage](https://atlassian.design/components/datetime-picker/date-picker/usage)
    */ 
const $00683ba6c52d5435$var$DatePicker = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, _forwardedRef)=>{
    const containerRef = (0, $eJOHy.useRef)(null);
    const calendarRef = (0, $eJOHy.useRef)(null);
    const calendarButtonRef = (0, $eJOHy.useRef)(null);
    const { appearance: appearance = 'default', autoFocus: autoFocus = false, clearControlLabel: clearControlLabel = 'Clear', hideIcon: hideIcon = false, openCalendarLabel: openCalendarLabel = 'Open calendar', defaultIsOpen: defaultIsOpen = false, defaultValue: defaultValue = '', disabled: disabled = [], disabledDateFilter: disabledDateFilter = (_)=>false, icon: Icon = (0, (/*@__PURE__*/$parcel$interopDefault($3GKOL))), id: id = '', innerProps: innerProps = {}, inputLabel: inputLabel = 'Date picker', inputLabelId: inputLabelId, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isRequired: isRequired = false, label: label = '', name: name = '', onBlur: /* eslint-disable @repo/internal/react/use-noop */ onBlur = (_event)=>{}, onChange: onChangeProp = (_value)=>{}, onFocus: onFocus = (_event)=>{}, selectProps: /* eslint-enable @repo/internal/react/use-noop */ selectProps = {}, shouldShowCalendarButton: shouldShowCalendarButton, spacing: spacing = 'default', locale: propLocale = 'en-US', value: propValue, isOpen: isOpenProp, maxDate: maxDate, minDate: minDate, weekStartDay: weekStartDay, formatDisplayLabel: formatDisplayLabel, testId: testId, 'aria-describedby': ariaDescribedBy, placeholder: placeholder, nextMonthLabel: nextMonthLabel, previousMonthLabel: previousMonthLabel, ...rest } = props;
    const [isOpen, setIsOpen] = (0, $eJOHy.useState)(defaultIsOpen);
    const [_, setIsFocused] = (0, $eJOHy.useState)(false);
    const [clearingFromIcon, setClearingFromIcon] = (0, $eJOHy.useState)(false);
    const [selectInputValue, setSelectInputValue] = (0, $eJOHy.useState)(selectProps.inputValue);
    const [value, setValue] = (0, $eJOHy.useState)(propValue || defaultValue);
    const [calendarValue, setCalendarValue] = (0, $eJOHy.useState)(propValue || defaultValue || (0, $1u9xN.getShortISOString)(new Date()));
    const [l10n, setL10n] = (0, $eJOHy.useState)((0, $cK9J2.createLocalizationProvider)(propLocale));
    const [locale, setLocale] = (0, $eJOHy.useState)(propLocale);
    const [shouldSetFocusOnCurrentDay, setShouldSetFocusOnCurrentDay] = (0, $eJOHy.useState)(false);
    const [isKeyDown, setIsKeyDown] = (0, $eJOHy.useState)(false);
    const [wasOpenedFromCalendarButton, setWasOpenedFromCalendarButton] = (0, $eJOHy.useState)(false); // Hack to force update: https://legacy.reactjs.org/docs/hooks-faq.html#is-there-something-like-forceupdate
    const [, forceUpdate] = (0, $eJOHy.useReducer)((x)=>!x, true);
    const onChangePropWithAnalytics = (0, $jrFnt.usePlatformLeafEventHandler)({
        fn: onChangeProp,
        action: 'selectedDate',
        actionSubject: 'datePicker',
        ...$00683ba6c52d5435$var$analyticsAttributes
    });
    if (propLocale !== locale) {
        setL10n((0, $cK9J2.createLocalizationProvider)(propLocale));
        setLocale(propLocale);
    }
    (0, $eJOHy.useEffect)(()=>{
        // We don't want the focus to move if this is a click event
        if (!isKeyDown) return;
        if (isOpen && wasOpenedFromCalendarButton) {
            setIsKeyDown(false); // Focus on the first button within the calendar
            calendarRef?.current?.querySelector('button')?.focus();
        }
    }, [
        isKeyDown,
        calendarRef,
        isOpen,
        wasOpenedFromCalendarButton
    ]);
    const getValue = ()=>propValue ?? value;
    const getIsOpen = ()=>isOpenProp ?? isOpen;
    const onCalendarChange = ({ iso: iso })=>{
        setCalendarValue((0, $47or1.getParsedISO)({
            iso: iso
        }));
    };
    const onCalendarSelect = ({ iso: iso })=>{
        setSelectInputValue('');
        setIsOpen(false);
        setCalendarValue(iso);
        setValue(iso);
        setWasOpenedFromCalendarButton(false);
        onChangePropWithAnalytics(iso); // Yes, this is not ideal. The alternative is to be able to place a ref
        // on the inner input of Select itself, which would require a lot of
        // extra stuff in the Select component for only this one thing. While
        // this would be more "React-y", it doesn't seem to pose any other
        // benefits. Performance-wise, we are only searching within the
        // container, so it's quick.
        if (wasOpenedFromCalendarButton) calendarButtonRef.current?.focus();
        else {
            const innerCombobox = containerRef?.current?.querySelector('[role="combobox"]');
            innerCombobox?.focus();
        }
        setIsOpen(false);
    };
    const onInputClick = ()=>{
        if (!isDisabled && !getIsOpen()) {
            setIsOpen(true);
            setWasOpenedFromCalendarButton(false);
        }
    };
    const onContainerBlur = (event)=>{
        const newlyFocusedElement = event.relatedTarget;
        if (!containerRef?.current?.contains(newlyFocusedElement)) {
            setIsOpen(false);
            setShouldSetFocusOnCurrentDay(false);
            setWasOpenedFromCalendarButton(false);
            onBlur(event);
        }
    };
    const onContainerFocus = ()=>{
        setShouldSetFocusOnCurrentDay(false);
    };
    const onSelectBlur = (event)=>{
        const newlyFocusedElement = event.relatedTarget;
        if (clearingFromIcon) // Don't close menu if blurring after the user has clicked clear
        setClearingFromIcon(false);
        else if (!containerRef?.current?.contains(newlyFocusedElement)) {
            // Don't close menu if focus is staying within the date picker's
            // container. Makes keyboard accessibility of calendar possible
            setIsOpen(false);
            setIsFocused(false);
            setWasOpenedFromCalendarButton(false);
        }
    };
    const onSelectFocus = (event)=>{
        const value = getValue();
        if (clearingFromIcon) // Don't open menu if focussing after the user has clicked clear
        setClearingFromIcon(false);
        else {
            // Don't open when focused into via keyboard if the calendar button is present
            setIsOpen(!shouldShowCalendarButton);
            setCalendarValue(value);
            setIsFocused(true);
            setWasOpenedFromCalendarButton(false);
        }
        onFocus(event);
    };
    const onTextInput = (event)=>{
        const inputValue = event.target.value;
        if (inputValue) {
            const parsed = (0, $47or1.parseDate)(inputValue, {
                parseInputValue: rest?.parseInputValue,
                dateFormat: rest?.dateFormat,
                l10n: l10n
            }); // Only try to set the date if we have month & day
            if (parsed && (0, $dBLX0.default)(parsed)) // We format the parsed date to YYYY-MM-DD here because
            // this is the format expected by the @atlaskit/calendar component
            setCalendarValue((0, $1u9xN.getShortISOString)(parsed));
        }
        setIsOpen(true);
        setWasOpenedFromCalendarButton(false);
    };
    const onInputKeyDown = (event)=>{
        const value = getValue();
        const keyPressed = event.key.toLowerCase(); // If the input is focused and the calendar is not visible, handle space and enter clicks
        if (!isOpen && (keyPressed === 'enter' || keyPressed === ' ')) {
            setIsOpen(true);
            setWasOpenedFromCalendarButton(false);
        }
        switch(keyPressed){
            case 'escape':
                // Yes, this is not ideal. The alternative is to be able to place a ref
                // on the inner input of Select itself, which would require a lot of
                // extra stuff in the Select component for only this one thing. While
                // this would be more "React-y", it doesn't seem to pose any other
                // benefits. Performance-wise, we are only searching within the
                // container, so it's quick.
                if (wasOpenedFromCalendarButton) calendarButtonRef.current?.focus();
                else {
                    const innerCombobox = containerRef?.current?.querySelector('[role="combobox"]');
                    innerCombobox?.focus();
                }
                setIsOpen(false);
                setShouldSetFocusOnCurrentDay(false);
                setWasOpenedFromCalendarButton(false);
                break;
            case 'backspace':
            case 'delete':
                {
                    const inputCount = 0;
                    if (value && event.target instanceof HTMLInputElement && event.target.value.length <= inputCount) {
                        // If being cleared from keyboard, don't change behaviour
                        setClearingFromIcon(false);
                        setValue('');
                    }
                    break;
                }
            case 'enter':
                if (!isOpen) return;
                 // Prevent form submission when a date is selected
                // using enter. See https://product-fabric.atlassian.net/browse/DSP-2501
                // for more details.
                event.preventDefault();
                if (!(0, $47or1.isDateDisabled)(calendarValue, {
                    disabled: disabled
                })) {
                    // Get a safe `calendarValue` in case the value exceeds the maximum
                    // allowed by ISO 8601
                    const safeCalendarValue = (0, $1u9xN.getSafeCalendarValue)(calendarValue);
                    const valueChanged = safeCalendarValue !== value;
                    setSelectInputValue('');
                    setIsOpen(false);
                    setValue(safeCalendarValue);
                    setCalendarValue(safeCalendarValue);
                    setWasOpenedFromCalendarButton(wasOpenedFromCalendarButton);
                    if (valueChanged) onChangePropWithAnalytics(safeCalendarValue);
                }
                break;
            case 'arrowdown':
            case 'arrowup':
                if (!shouldSetFocusOnCurrentDay) {
                    setIsOpen(true);
                    setShouldSetFocusOnCurrentDay(true);
                }
                break;
            default:
                break;
        }
    };
    const onCalendarButtonKeyDown = (e)=>{
        // Don't allow an arrow up or down to open the menu, since the input key
        // down handler is actually on the parent.
        if (e.type === 'keydown' && (e.key === 'ArrowDown' || e.key === 'ArrowUp')) e.stopPropagation();
         // We want to stop this from triggering other keydown events, particularly
        // for space and enter presses. Otherwise, it opens and then closes
        // immediately.
        if (e.type === 'keydown' && (e.key === ' ' || e.key === 'Enter')) {
            e.stopPropagation();
            setIsKeyDown(true);
            setWasOpenedFromCalendarButton(true);
        }
    }; // This event handler is triggered from both keydown and click. It's weird.
    const onCalendarButtonClick = (e)=>{
        setIsOpen((isOpen)=>{
            if (isOpen) {
                props.selectProps?.onMenuClose?.();
                return false;
            } else {
                props.selectProps?.onMenuOpen?.();
                return true;
            }
        });
        setWasOpenedFromCalendarButton(true);
        e.stopPropagation();
    };
    const onClear = ()=>{
        setValue('');
        setCalendarValue(defaultValue || (0, $1u9xN.getShortISOString)(new Date()));
        if (!hideIcon) setClearingFromIcon(true);
        onChangePropWithAnalytics('');
    }; // `unknown` is used because `value` is unused so it does not matter.
    const onSelectChange = (_value, action)=>{
        // Used for native clear event in React Select
        // Triggered when clicking ClearIndicator or backspace with no value
        if (action.action === 'clear') onClear();
    };
    const handleSelectInputChange = (selectInputValue, actionMeta)=>{
        if (selectProps.onInputChange) selectProps.onInputChange(selectInputValue, actionMeta);
        setSelectInputValue(selectInputValue);
    };
    const getContainerRef = (0, $eJOHy.useCallback)((ref)=>{
        const oldRef = containerRef.current;
        containerRef.current = ref; // Cause a re-render if we're getting the container ref for the first time
        // as the layered menu requires it for dimension calculation
        if (oldRef == null && ref != null) forceUpdate();
    }, [
        containerRef
    ]);
    const getterValue = getValue();
    let actualSelectInputValue;
    actualSelectInputValue = selectInputValue;
    const menuIsOpen = getIsOpen() && !isDisabled;
    const showClearIndicator = Boolean((getterValue || selectInputValue) && !hideIcon);
    let clearIndicator = Icon;
    if ((0, $eGOwo.fg)('platform-visual-refresh-icons')) clearIndicator = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
            xcss: $00683ba6c52d5435$var$styles.dropdownIndicatorStyles,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)(Icon, {
                ...props
            })
        });
    const dropDownIcon = appearance === 'subtle' || hideIcon || showClearIndicator ? null : clearIndicator;
    const valueId = (0, $gl2vi.useId)();
    const SingleValue = (0, $7OE9J.makeSingleValue)({
        id: valueId,
        lang: propLocale
    });
    const selectComponents = {
        ...selectProps.components,
        DropdownIndicator: shouldShowCalendarButton ? (0, $RoXqn.EmptyComponent) : dropDownIcon,
        // Only use this new container component if the calendar button is shown.
        // Otherwise, it throws errors downstream for some reason
        ...shouldShowCalendarButton ? {
            IndicatorsContainer: (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $hmV0i.IndicatorsContainer), {
                    ...props,
                    showClearIndicator: showClearIndicator
                })
        } : {},
        Menu: $gNwsY.Menu,
        SingleValue: SingleValue,
        ...!showClearIndicator && {
            ClearIndicator: (0, $RoXqn.EmptyComponent)
        }
    };
    const { styles: selectStyles = {} } = selectProps;
    const disabledStyle = isDisabled ? {
        pointerEvents: 'none',
        color: "var(--ds-icon-disabled, inherit)"
    } : {};
    const calendarProps = {
        calendarContainerRef: containerRef.current,
        calendarDisabled: disabled,
        calendarDisabledDateFilter: disabledDateFilter,
        calendarMaxDate: maxDate,
        calendarMinDate: minDate,
        calendarRef: calendarRef,
        calendarValue: getterValue && (0, $1u9xN.getShortISOString)((0, $kQ82p.default)(getterValue)),
        calendarView: calendarValue,
        onCalendarChange: onCalendarChange,
        onCalendarSelect: onCalendarSelect,
        calendarLocale: locale,
        calendarWeekStartDay: weekStartDay,
        shouldSetFocusOnCurrentDay: shouldSetFocusOnCurrentDay,
        /**
     * This overrides the inner wrapper the Calendar.
     * @private Please use this with extreme caution, this API may be changed in the future.
     */ menuInnerWrapper: props?.menuInnerWrapper
    }; // @ts-ignore -- Argument of type 'StylesConfig<OptionType, false, GroupBase<OptionType>>' is not assignable to parameter of type 'StylesConfig<OptionType, boolean, GroupBase<OptionType>>'.
    const mergedStyles = (0, $e9zKl.mergeStyles)(selectStyles, {
        control: (base)=>({
                ...base,
                ...disabledStyle
            }),
        indicatorsContainer: (base)=>({
                ...base,
                paddingLeft: "var(--ds-space-025, 2px)",
                // ICON_PADDING = 2
                paddingRight: "var(--ds-space-075, 6px)" // 8 - ICON_PADDING = 6
            })
    });
    const initialValue = getterValue ? {
        label: (0, $47or1.formatDate)(getterValue, {
            formatDisplayLabel: formatDisplayLabel,
            dateFormat: rest?.dateFormat,
            l10n: l10n
        }),
        value: getterValue
    } : null; // `label` takes precedence of the `inputLabel`
    const fullopenCalendarLabel = label || inputLabel ? `${label || inputLabel}, ${openCalendarLabel}` : openCalendarLabel;
    const openCalendarLabelId = `open-calendar-label--${(0, $gl2vi.useId)()}`;
    return /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
        ...innerProps,
        "data-testid": testId && `${testId}--container`,
        onBlur: onContainerBlur,
        onFocus: onContainerFocus,
        onClick: onInputClick,
        onInput: onTextInput,
        onKeyDown: onInputKeyDown,
        ref: getContainerRef,
        role: "presentation",
        className: (0, $hcewu.default)([
            $00683ba6c52d5435$var$styles.pickerContainerStyle
        ]),
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)("input", {
                name: name,
                type: "hidden",
                value: getterValue,
                "data-testid": testId && `${testId}--input`
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $c4OV1.default), {
                appearance: appearance,
                "aria-describedby": ariaDescribedBy ? `${ariaDescribedBy} ${valueId}` : valueId,
                label: label || undefined,
                autoFocus: autoFocus,
                clearControlLabel: clearControlLabel,
                closeMenuOnSelect: true,
                enableAnimation: false,
                inputId: id,
                inputValue: actualSelectInputValue,
                isDisabled: isDisabled,
                isRequired: isRequired,
                menuIsOpen: menuIsOpen,
                onBlur: onSelectBlur,
                onChange: onSelectChange,
                onFocus: onSelectFocus,
                onInputChange: handleSelectInputChange,
                placeholder: (0, $47or1.getPlaceholder)({
                    placeholder: placeholder,
                    l10n: l10n
                }),
                // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
                styles: mergedStyles,
                value: initialValue,
                ...selectProps,
                // up when you alter some of the properties in the `selectComponents`
                // object. These errors are still present, and I suspect have always
                // been present, without changing the unrelated code. Ignoring as the
                // component still works as expected despite this error. And also
                // because the select refresh team may solve it later.
                components: selectComponents,
                // selectProps or not and what wil be overwritten
                isClearable: true,
                isInvalid: isInvalid,
                spacing: spacing,
                testId: testId,
                // @ts-ignore --  Property 'calendarContainerRef' does not exist on type 'IntrinsicAttributes & LibraryManagedAttributes<(<Option extends unknown = OptionType, IsMulti extends boolean = false>(props: AtlaskitSelectProps<Option, IsMulti> & { ...; }) => Element), AtlaskitSelectProps<...> & { ...; }>'.
                calendarContainerRef: calendarProps.calendarContainerRef,
                calendarDisabled: calendarProps.calendarDisabled,
                calendarDisabledDateFilter: calendarProps.calendarDisabledDateFilter,
                calendarLocale: calendarProps.calendarLocale,
                calendarMaxDate: calendarProps.calendarMaxDate,
                calendarMinDate: calendarProps.calendarMinDate,
                calendarRef: calendarProps.calendarRef,
                calendarValue: calendarProps.calendarValue,
                calendarView: calendarProps.calendarView,
                calendarWeekStartDay: calendarProps.calendarWeekStartDay,
                nextMonthLabel: nextMonthLabel,
                onCalendarChange: calendarProps.onCalendarChange,
                onCalendarSelect: calendarProps.onCalendarSelect,
                previousMonthLabel: previousMonthLabel,
                shouldSetFocusOnCurrentDay: calendarProps.shouldSetFocusOnCurrentDay,
                menuInnerWrapper: calendarProps.menuInnerWrapper
            }),
            shouldShowCalendarButton && !isDisabled ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                xcss: (0, $6qaBj.cx)($00683ba6c52d5435$var$styles.iconContainerStyles, value && !hideIcon ? $00683ba6c52d5435$var$styles.iconSpacingWithClearButtonStyles : $00683ba6c52d5435$var$styles.iconSpacingWithoutClearButtonStyles),
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $Ay1uj.default), {
                    appearance: "subtle",
                    label: !inputLabelId ? fullopenCalendarLabel : openCalendarLabel,
                    "aria-labelledby": inputLabelId ? `${inputLabelId} ${openCalendarLabelId}` : undefined,
                    id: openCalendarLabelId,
                    icon: (iconProps)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3GKOL))), {
                            ...iconProps,
                            color: "var(--ds-icon, #292A2E)"
                        }),
                    onClick: onCalendarButtonClick,
                    onKeyDown: onCalendarButtonKeyDown,
                    ref: calendarButtonRef,
                    testId: testId && `${testId}--open-calendar-button`
                })
            }) : null
        ]
    });
});
var $00683ba6c52d5435$export$2e2bcd8739ae039 = $00683ba6c52d5435$var$DatePicker;

});


parcelRegister("h3OS7", function(module, exports) {
$parcel$export(module.exports, "default", () => $ac8e88b2b26eb9d1$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $ac8e88b2b26eb9d1$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    placeholderDate: {
        "id": "common-date.utils.date-messages.placeholder-date",
        "defaultMessage": "e.g. 2018/12/31"
    }
});

});

parcelRegister("fgNUD", function(module, exports) {
$parcel$export(module.exports, "default", () => $463b2e2732c3d1c8$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");
// eslint-disable-next-line jira/react/no-class-components
class $463b2e2732c3d1c8$var$SuppressEscKey extends (0, $eJOHy.Component) {
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
            role: "presentation",
            onKeyDown: this.onKeyEvent,
            onKeyUp: this.onKeyEvent
        }, this.props.children);
    }
    constructor(...args){
        super(...args), this.onKeyEvent = (e)=>{
            const { key: key } = e;
            if (key === 'Escape') {
                e.stopPropagation();
                e.nativeEvent.stopImmediatePropagation();
            }
        };
    }
}
var $463b2e2732c3d1c8$export$2e2bcd8739ae039 = $463b2e2732c3d1c8$var$SuppressEscKey;

});

parcelRegister("fvP65", function(module, exports) {
$parcel$export(module.exports, "default", () => $ec9049b7382a0d67$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $ec9049b7382a0d67$var$messages = (0, $7qGN1.defineMessages)({
    releaseDate: {
        "id": "project-directories.versions.release-version-modal.content.release-date.release-date",
        "defaultMessage": "Release date"
    }
});
var $ec9049b7382a0d67$export$2e2bcd8739ae039 = $ec9049b7382a0d67$var$messages;

});



parcelRegister("7LVYa", function(module, exports) {
$parcel$export(module.exports, "default", () => $aed7db7de0dec685$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $LFmXM = parcelRequire("LFmXM");

var $gnQAk = parcelRequire("gnQAk");

var $7zFqE = parcelRequire("7zFqE");

var $1j2EU = parcelRequire("1j2EU");

var $gLW5o = parcelRequire("gLW5o");

var $delku = parcelRequire("delku");
const $aed7db7de0dec685$var$mapStateToProps = ()=>{
    const renderVersionPickerFactory = (0, $LFmXM.default)((shouldSwapIssues, isSaving, projectKey, versionId)=>(props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7zFqE.default), {
                isDisabled: !shouldSwapIssues || isSaving,
                projectKey: projectKey,
                ignore: [
                    versionId
                ],
                versionStatuses: [
                    'UNRELEASED'
                ],
                ...props
            }));
    return (state)=>{
        const { projectKey: projectKey, shouldSwapIssues: shouldSwapIssues, isSaving: isSaving, versionId: versionId } = (0, $gLW5o.getPropsForVersionPicker)(state);
        return {
            toDoInProgressIssuesCount: (0, $gLW5o.getTodoInProgressIssuesCount)(state),
            isSaving: (0, $gLW5o.isSaving)(state),
            shouldSwapIssues: (0, $gLW5o.isSwapSelected)(state),
            errors: (0, $gLW5o.getErrors)(state),
            renderVersionPicker: renderVersionPickerFactory(shouldSwapIssues, isSaving, projectKey, versionId)
        };
    };
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $aed7db7de0dec685$var$dispatcher = (dispatch)=>({
        // @ts-expect-error - TS7006 - Parameter 'version' implicitly has an 'any' type.
        onInputChange: (version)=>dispatch((0, $1j2EU.releaseVersionUpdate)(version)),
        // @ts-expect-error - TS7006 - Parameter 'swap' implicitly has an 'any' type.
        onSwapIssuesSelected: (swap)=>dispatch((0, $1j2EU.swapIssues)(swap))
    });
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $aed7db7de0dec685$var$mapDispatchToProps = (dispatch)=>$aed7db7de0dec685$var$dispatcher(dispatch);
var $aed7db7de0dec685$export$2e2bcd8739ae039 = (0, $gnQAk.connect)($aed7db7de0dec685$var$mapStateToProps, $aed7db7de0dec685$var$mapDispatchToProps)((0, $delku.default));

});
parcelRegister("7zFqE", function(module, exports) {
$parcel$export(module.exports, "default", () => $8eeee8d4b29e30db$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react-component-props

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $6sjW5 = parcelRequire("6sjW5");

var $fJTOm = parcelRequire("fJTOm");

var $idGBm = parcelRequire("idGBm");

var $fdDZf = parcelRequire("fdDZf");

var $dqHWY = parcelRequire("dqHWY");

var $kTLpN = parcelRequire("kTLpN");
class $8eeee8d4b29e30db$export$c7c815960e157d78 extends (0, $eJOHy.Component) {
    static{
        this.defaultProps = {
            isRequired: false,
            isDisabled: false,
            isClearableWithCrossIcon: false,
            noPortal: false,
            value: undefined,
            label: '',
            placeholder: undefined,
            ignore: [],
            versionStatuses: [],
            onSelected: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
        };
    }
    getVersionIdsToIgnore() {
        const { value: value, ignore: ignore } = this.props;
        if (value) return [
            value.id,
            ...ignore
        ];
        return ignore;
    }
    getPlaceholder() {
        const { intl: { formatMessage: formatMessage } } = this.props;
        return this.props.placeholder === undefined ? formatMessage((0, $kTLpN.default).placeholder) : this.props.placeholder;
    }
    getValue() {
        const { value: value } = this.props;
        if (value === null || value === undefined) return value;
        return (0, $dqHWY.transformVersion)(value);
    }
    render() {
        const { label: label, isRequired: isRequired, isDisabled: isDisabled, intl: intl, noPortal: noPortal, isClearableWithCrossIcon: isClearableWithCrossIcon } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fJTOm.Picker), {
            ...this.props,
            value: this.getValue(),
            label: label,
            placeholder: this.getPlaceholder(),
            isRequired: isRequired,
            isDisabled: isDisabled,
            isClearableWithCrossIcon: isClearableWithCrossIcon,
            errorMessage: intl.formatMessage((0, $kTLpN.default).error),
            onSelected: this.onSelected,
            options: this.onFetchOptions,
            noPortal: noPortal,
            intl: intl
        });
    }
    constructor(...args){
        super(...args), this.onSelected = (selectedOption, analyticsEvent)=>selectedOption ? this.props.onSelected({
                id: selectedOption.value,
                name: selectedOption.label
            }, analyticsEvent) : this.props.onSelected(undefined, analyticsEvent), this.onFetchOptions = (filter)=>(0, $fdDZf.requestVersions)(this.props.projectKey, filter, this.props.versionStatuses, this.getVersionIdsToIgnore());
    }
}
var $8eeee8d4b29e30db$export$2e2bcd8739ae039 = (0, $idGBm.injectIntlV2)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
(0, $6sjW5.default)({
    onSelected: 'versionPicker'
})($8eeee8d4b29e30db$export$c7c815960e157d78));

});
parcelRegister("fJTOm", function(module, exports) {
$parcel$export(module.exports, "getOptionBaseStyles", () => $69685483963d086b$export$cef6e25059b681a);
$parcel$export(module.exports, "Picker", () => $69685483963d086b$export$ba25329847403e11);
$parcel$export(module.exports, "default", () => $69685483963d086b$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $3s8bj = parcelRequire("3s8bj");

var $12DRg = parcelRequire("12DRg");

var $4ibbN = parcelRequire("4ibbN");

var $1jVV7 = parcelRequire("1jVV7");

var $goZPP = parcelRequire("goZPP");

var $8IeH1 = parcelRequire("8IeH1");

var $3DNvO = parcelRequire("3DNvO");
var $6UCkD = parcelRequire("6UCkD");
var $6XEne = parcelRequire("6XEne");
var $kVcjU = parcelRequire("kVcjU");
var $c4OV1 = parcelRequire("c4OV1");

var $k71qx = parcelRequire("k71qx");

var $fceQU = parcelRequire("fceQU");

var $4cTDP = parcelRequire("4cTDP");

var $lxUP5 = parcelRequire("lxUP5");

var $6joHJ = parcelRequire("6joHJ");

var $6YFG2 = parcelRequire("6YFG2");

var $6rlhA = parcelRequire("6rlhA");
const $69685483963d086b$export$3a3072dd741f354b = 500;
const $69685483963d086b$export$cef6e25059b681a = (optionState)=>({
        ...optionState.isDisabled ? {
            cursor: 'not-allowed',
            color: "var(--ds-text-subtlest, #6B6E76)",
            '&, :active': {
                backgroundColor: 'transparent'
            }
        } : {
            cursor: 'pointer'
        },
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis'
    });
class $69685483963d086b$export$ba25329847403e11 extends (0, $eJOHy.Component) {
    static{
        this.defaultProps = {
            isRequired: false,
            isDisabled: false,
            isClearable: false,
            isCompact: false,
            isCreatable: false,
            isMulti: false,
            noPortal: false,
            isCheckbox: false,
            label: undefined,
            defaultValue: undefined,
            width: 'auto',
            onSelected: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
            onMultiSelected: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
        };
    }
    static getDerivedStateFromProps(props) {
        if (props.menuIsOpen !== undefined) return {
            menuIsOpen: props.menuIsOpen
        };
        return null;
    }
    constructor(props){
        super(props), this.state = {
            validationState: 'default',
            showErrorMessage: false,
            menuWasOpen: false,
            menuIsOpen: false,
            initialFocusHandled: false
        }, this.onSelected = (selection, action, analyticsEvent)=>{
            this.setState(()=>({
                    menuIsOpen: false
                }));
            const { isMulti: isMulti } = this.props;
            if (Array.isArray(selection)) {
                if (isMulti) // @ts-expect-error - TS2554 - Expected 1 arguments, but got 2.
                this.props.onMultiSelected(selection, analyticsEvent);
                else // When the selection is cleared in single select mode, selection is an array.
                this.props.onSelected(undefined, analyticsEvent);
            } else // @ts-expect-error - TS2339 - Property 'value' does not exist on type 'SelectOption'.
            selection && selection.value ? this.props.onSelected(selection, analyticsEvent) : this.props.onSelected(undefined, analyticsEvent);
        }, this.onMenuOpen = ()=>{
            this.setState(()=>({
                    menuIsOpen: true,
                    menuWasOpen: true
                }));
        }, this.onMenuClose = ()=>{
            this.setState(()=>({
                    menuIsOpen: false
                }));
        }, this.onBlur = (event)=>{
            this.hideErrorMessage();
            const { onBlur: onBlur } = this.props;
            if (onBlur && typeof onBlur === 'function') onBlur(event);
        }, this.onFocus = (event)=>{
            this.showErrorMessage();
            const { onFocus: onFocus } = this.props;
            if (onFocus && typeof onFocus === 'function') onFocus(event);
        }, this.setErrorState = ()=>{
            this.setState({
                showErrorMessage: true,
                validationState: 'error'
            });
        }, this.showErrorMessage = ()=>this.setState({
                showErrorMessage: true
            }), this.hideErrorMessage = ()=>this.setState({
                showErrorMessage: false
            }) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        , this.loadOptions = (filter, callback)=>{
            this.setState({
                validationState: 'default'
            });
            this.debouncedLoadOptions(filter, callback);
        }, this.renderOption = (props)=>{
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const propsData = props.data;
            const disableReason = props.isDisabled && propsData && propsData.disableReason || null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
                position: "right",
                content: disableReason
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6XEne.components).Option // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            , props));
        } // Will remove this renderMenuList when clean up FG since it's no longer needed
        , this.renderMenuList = (menuListProps)=>{
            const { isClearable: isClearable, intl: { formatMessage: formatMessage } } = this.props;
            return(// @ts-expect-error - TS2740 - Type '{ children: (Element | ReactNode)[]; hasValue: boolean; clearValue: () => void; }' is missing the following properties from type 'CommonProps<OptionTypeBase, boolean, GroupTypeBase<OptionTypeBase>>': cx, getStyles, getValue, isMulti, and 6 more.
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6XEne.components).MenuList, menuListProps, isClearable && menuListProps.hasValue && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
                xcss: $69685483963d086b$var$styles.clearButtonWrapper
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
                appearance: "link",
                shouldFitContainer: true,
                onClick: menuListProps.clearValue
            }, formatMessage((0, $6rlhA.default).clearSelected))), menuListProps.children));
        }, this.renderValueContainer = (props)=>{
            const { onValueContainerClick: onValueContainerClick } = props.selectProps;
            return(// eslint-disable-next-line @atlassian/a11y/interactive-element-not-keyboard-focusable
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
                xcss: $69685483963d086b$var$styles.valueContainer,
                onClick: onValueContainerClick,
                testId: "common-components-picker.base.react-dnd-and-select-focus-bug-fix"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6XEne.components).ValueContainer, props)));
        }; // This is initialized in constructor because when it is a class property then flow gets confused about the generic type in callback.
        // That is a known bug: https://github.com/facebook/flow/issues/6978
        this.debouncedLoadOptions = (0, (/*@__PURE__*/$parcel$interopDefault($3s8bj)))(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        (filter, callback)=>{
            // @ts-expect-error - TS2349 - This expression is not callable.
            this.props.options(filter).then(callback, ()=>{
                callback([]);
                this.setErrorState();
            });
        }, $69685483963d086b$export$3a3072dd741f354b); // @ts-expect-error - Property 'selectRef' does not exist on type 'Picker<SelectOption>'
        this.selectRef = /*#__PURE__*/ (0, $eJOHy.createRef)();
    }
    getSelectComponent(isAsync) {
        if (this.props.isCreatable) return isAsync ? (0, $3DNvO.default) : (0, $kVcjU.default);
        if (isAsync) return 0, $4ibbN.AsyncSelectWithAnalytics;
        return this.props.isCheckbox ? (0, $6UCkD.default) : (0, $c4OV1.default);
    }
    getComponentOverrides() {
        const { menuWasOpen: menuWasOpen } = this.state;
        const Option = {
            Option: this.renderOption
        }; // Remove MenuList when clean up FG since we no longer need to override to add `Clear Selected` button
        const MenuList = (0, $4cTDP.fg)('jfp-a11y-team_update_legacy_select_clear_fuction') ? {} : {
            MenuList: this.renderMenuList
        };
        const LoadingIndicator = menuWasOpen ? {} : {
            LoadingIndicator: null
        };
        return {
            ...this.props.components,
            ...Option,
            ...MenuList,
            ...LoadingIndicator
        };
    }
    render() {
        const { showErrorMessage: showErrorMessage, validationState: validationState, menuIsOpen: menuIsOpen } = this.state;
        const { intl: { formatMessage: formatMessage } } = this.props;
        const { label: label, listItemCustomStyles: listItemCustomStyles, placeholder: placeholder = formatMessage((0, $6rlhA.default).defaultPlaceholder), defaultValue: defaultValue, isRequired: isRequired, isDisabled: isDisabled, isCompact: isCompact, isClearableWithCrossIcon: isClearableWithCrossIcon, errorMessage: errorMessage, options: options, width: width, minWidth: minWidth, noPortal: noPortal, isCheckbox: isCheckbox, hasDraggableParentComponent: hasDraggableParentComponent } = this.props;
        const isAsync = typeof options === 'function';
        const SelectComponent = this.getSelectComponent(isAsync);
        const isErrorMessageOpened = showErrorMessage && validationState === 'error';
        let selectParams = {
            placeholder: placeholder,
            isDisabled: isDisabled,
            isClearable: isClearableWithCrossIcon || false,
            defaultValue: defaultValue,
            defaultOptions: true,
            autoFocus: !!this.props.autoFocus,
            loadOptions: isAsync && this.loadOptions,
            options: !isAsync && options,
            onChange: this.onSelected,
            noOptionsMessage: ()=>this.props.noOptionsMessage ?? formatMessage((0, $6rlhA.default).noOptions),
            loadingMessage: ()=>formatMessage((0, $6rlhA.default).loading),
            validationState: this.state.validationState,
            onBlur: this.onBlur,
            onFocus: this.onFocus,
            menuPortalTarget: noPortal ? null : (0, $fceQU.getDocument)()?.body,
            spacing: isCompact ? 'compact' : 'default',
            styles: {
                ...this.props.styles,
                // without properly set zIndex value dropdown with options is cut inside modal dialogs
                // @ts-expect-error - TS7006 - Parameter 'base' implicitly has an 'any' type.
                menuPortal: (base)=>({
                        ...base,
                        zIndex: (0, $1jVV7.layers).modal
                    }),
                // @ts-expect-error - TS7006 - Parameter 'base' implicitly has an 'any' type.
                container: (base)=>({
                        ...base,
                        width: width,
                        minWidth: minWidth
                    }),
                // @ts-expect-error - TS7006 - Parameter 'base' implicitly has an 'any' type. | TS7006 - Parameter 'optionState' implicitly has an 'any' type.
                option: (base, optionState)=>({
                        ...base,
                        ...$69685483963d086b$export$cef6e25059b681a(optionState),
                        ...listItemCustomStyles
                    }),
                // @ts-expect-error - TS7006 - Parameter 'base' implicitly has an 'any' type. | TS7006 - Parameter 'optionState' implicitly has an 'any' type.
                menu: (base)=>{
                    return {
                        ...base,
                        width: 'max-content',
                        // This makes the menu fit the widest content
                        minWidth: '100%'
                    };
                }
            }
        };
        if (!isCheckbox) selectParams = {
            ...selectParams,
            menuIsOpen: // @ts-expect-error - TS2322 - Type '{ menuIsOpen: boolean; onMenuOpen: () => void; onMenuClose: () => void; components: { LoadingIndicator?: undefined; MenuList: (menuListProps: MenuListProps) => JSX.Element; Option: (props: CommonProps<...> & ... 1 more ... & { ...; }) => JSX.Element; } | { ...; }; ... 16 more ...; styles: { ...; }; }' is not assignable to type '{ placeholder: string; isDisabled: boolean | undefined; isClearable: boolean; defaultValue: SelectOption | undefined; defaultOptions: boolean; autoFocus: boolean; loadOptions: false | ((filter: string, callback: (arg1: SelectOption[]) => Record<...>) => void); ... 9 more ...; styles: { ...; }; }'.
            menuIsOpen,
            onMenuOpen: this.onMenuOpen,
            onMenuClose: this.onMenuClose,
            components: this.getComponentOverrides()
        };
         // When "hasDraggableParentComponent" is true, this means <Select /> is nested inside <Draggable /> from react-beautiful-dnd
        // This relationship prevents the dropdown menu from opening because of bugs in the default focus state and clicking in a particular area of <Select />
        // Context: https://hello.atlassian.net/wiki/spaces/~989411314/pages/2861097485/Investigation+Notes+for+atlaskit+select+react-beautiful-dnd#Temporary-Solution
        if (hasDraggableParentComponent) {
            const { initialFocusHandled: initialFocusHandled } = this.state;
            const handleClick = ()=>{
                if (initialFocusHandled) // As <Select /> is already focused, calling this.selectRef.current.focus() again no longer triggers its own handlers (i.e. onMenuOpen, onMenuClose)
                // We have to manually handle the open and close states of the dropdown menu based on a user's click from this point onwards to prevent the bug
                this.setState((state)=>({
                        menuIsOpen: !state.menuIsOpen
                    }));
                else if (!menuIsOpen) {
                    // Trigger focus state when ValueContainer is clicked for the first time
                    // The focused state will then invoke <Select /> instance's own handlers (e.g. onMenuOpen, onMenuClose)
                    // to manage the state of the dropdown menu
                    // @ts-expect-error - Property 'selectRef' does not exist on type 'Picker<SelectOption>'
                    this.selectRef.current.focus();
                    this.setState(()=>({
                            initialFocusHandled: true
                        }));
                }
            };
            selectParams = {
                ...selectParams,
                // @ts-expect-error - Object literal may only specify known properties, and 'ref' does not exist in type '{ placeholder: string; isDisabled: boolean | undefined; isClearable: boolean; defaultValue: SelectOption | undefined; defaultOptions: boolean; autoFocus: boolean; loadOptions: false | ((filter: string, callback: (arg1: SelectOption[]) => Record<...>) => void); ... 9 more ...; styles: { ...; }; }'
                // + Property 'selectRef' does not exist on type 'Picker<SelectOption>'
                ref: this.selectRef,
                components: {
                    ...this.getComponentOverrides,
                    ValueContainer: this.renderValueContainer
                },
                onValueContainerClick: handleClick,
                openMenuOnFocus: true
            };
        }
        const { isClearable: isClearable } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, label && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lxUP5.FieldLabel), {
            htmlFor: this.props.inputId,
            label: label,
            isRequired: isRequired
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6joHJ.JiraInlineDialog), {
            content: errorMessage,
            isOpen: isErrorMessageOpened,
            messageId: `common-components-picker.base.jira-inline-dialog.pickerErrorMessage.${this.props.inputId ?? 'unnamedInputId'}`,
            messageType: "transactional",
            placement: "right"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(SelectComponent, {
            inputId: this.props.inputId,
            ...this.props,
            ...selectParams,
            ...(0, $4cTDP.fg)('jfp-a11y-team_update_legacy_select_clear_fuction') ? {
                isClearable: isClearable
            } : {},
            options: isAsync ? undefined : this.props.options
        })));
    }
}
// @ts-expect-error This is required because of the ratcheted conversion from intlV2 to intl
const $69685483963d086b$var$PickerWithIntl = (0, $6YFG2.default)($69685483963d086b$export$ba25329847403e11);
const $69685483963d086b$var$DefaultPicker = (props)=>{
    // this function exists only to "preserve" generic on the Picker that is lost at injectIntl
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($69685483963d086b$var$PickerWithIntl, props);
};
$69685483963d086b$var$DefaultPicker.defaultProps = $69685483963d086b$export$ba25329847403e11.defaultProps;
var $69685483963d086b$export$2e2bcd8739ae039 = $69685483963d086b$var$DefaultPicker;
const $69685483963d086b$var$styles = {
    clearButtonWrapper: "_n7zlia51",
    valueContainer: "_16jlkb7n"
};

});
parcelRegister("4ibbN", function(module, exports) {
$parcel$export(module.exports, "AsyncSelectWithAnalytics", () => $ff7c32c387190ed2$export$ee664e5add893f9);

var $gWITR = parcelRequire("gWITR");

var $as6H2 = parcelRequire("as6H2");
const $ff7c32c387190ed2$export$ee664e5add893f9 = (0, $as6H2.default)('select', {
    onChange: 'changed'
})((0, $gWITR.default));

});

parcelRegister("3DNvO", function(module, exports) {
$parcel$export(module.exports, "default", () => $35aa8c3d4d43b8a4$export$2e2bcd8739ae039);

var $7pkFT = parcelRequire("7pkFT");

var $dDv66 = parcelRequire("dDv66");
const $35aa8c3d4d43b8a4$var$AsyncCreatableSelect = (0, $dDv66.default)((0, $7pkFT.default));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$35aa8c3d4d43b8a4$export$2e2bcd8739ae039 = $35aa8c3d4d43b8a4$var$AsyncCreatableSelect;

});
parcelRegister("7pkFT", function(module, exports) {
$parcel$export(module.exports, "default", () => $69fba18f5363b86b$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $5tlgh = parcelRequire("5tlgh");

var $iSKoM = parcelRequire("iSKoM");

var $9gNEN = parcelRequire("9gNEN");

var $gVVTN = parcelRequire("gVVTN");
const $69fba18f5363b86b$var$AsyncCreatableSelect = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>{
    const stateManagerProps = (0, $iSKoM.default)(props);
    const creatableProps = (0, $gVVTN.default)(stateManagerProps);
    const selectProps = (0, $9gNEN.default)(creatableProps);
    // @ts-ignore - TS2322: Complex generic type causing issues for help-center local consumption with TS 5.9.2
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5tlgh.default), {
        ref: ref,
        ...selectProps
    });
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$69fba18f5363b86b$export$2e2bcd8739ae039 = $69fba18f5363b86b$var$AsyncCreatableSelect;

});


parcelRegister("6UCkD", function(module, exports) {
$parcel$export(module.exports, "default", () => $3bb5dff77a1a2ff0$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $jzkyh = parcelRequire("jzkyh");

var $c4OV1 = parcelRequire("c4OV1");
const $3bb5dff77a1a2ff0$var$CheckboxSelectInternal = ({ components: components, ...props })=>{
    const mergedComponents = (0, $eJOHy.useMemo)(()=>({
            ...components,
            Option: (0, $jzkyh.CheckboxOption)
        }), [
        components
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $c4OV1.default), {
        closeMenuOnSelect: false,
        hideSelectedOptions: false,
        isMulti: true,
        ...props,
        components: mergedComponents
    });
};
const $3bb5dff77a1a2ff0$var$CheckboxSelect = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).memo($3bb5dff77a1a2ff0$var$CheckboxSelectInternal);
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$3bb5dff77a1a2ff0$export$2e2bcd8739ae039 = $3bb5dff77a1a2ff0$var$CheckboxSelect;

});

parcelRegister("lxUP5", function(module, exports) {
$parcel$export(module.exports, "FieldLabel", () => $02d61fcf6733b580$export$1acdcf5a973a8414);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $806LH = parcelRequire("806LH");
const $02d61fcf6733b580$export$1acdcf5a973a8414 = ({ label: label, htmlFor: htmlFor, isRequired: isRequired = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($02d61fcf6733b580$var$Label, {
        htmlFor: htmlFor
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $806LH.default), {
        size: "xxsmall",
        as: "h2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        className: (0, $hcewu.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _syaz1rpy _1e0c1ule _ca0qv47k _u5f3idpf _n3td1b66 _19bvidpf _ect41gqc"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("span", null, label), isRequired ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("span", {
        role: "presentation",
        className: (0, $hcewu.default)([
            "_syaz1tmw _19bvv77o _ect41gqc"
        ])
    }, "*") : null)));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $02d61fcf6733b580$var$Label = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "label", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1ule",
            __cmplp.className
        ])
    });
});
const $02d61fcf6733b580$var$labelStyle = null;
const $02d61fcf6733b580$var$requiredIndicatorStyle = null;

});

parcelRegister("6joHJ", function(module, exports) {
$parcel$export(module.exports, "JiraInlineDialog", () => $765bdfac52a4c302$export$7ab52478615504b3);

var $eJOHy = parcelRequire("eJOHy");

var $cwZBT = parcelRequire("cwZBT");

var $bRMVI = parcelRequire("bRMVI");

var $fYeTG = parcelRequire("fYeTG");

var $1kIuW = parcelRequire("1kIuW");
const $765bdfac52a4c302$export$7ab52478615504b3 = (props)=>{
    if ((0, $bRMVI.shouldBeChoreographed)(props)) {
        if ((0, $fYeTG.isMobileAndInViewPanelIterationExperiment)()) return null;
        const { messageType: messageType, ...rest } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1kIuW.ChoreographerInlineDialog), rest);
    }
    const { messageType: messageType, messageId: messageId, onMessageDisposition: onMessageDisposition, ...rest } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cwZBT.default), rest);
};

});
parcelRegister("1kIuW", function(module, exports) {
$parcel$export(module.exports, "ChoreographerInlineDialog", () => $7432b934335413bd$export$44a404f218b0e66e);

var $cwZBT = parcelRequire("cwZBT");

var $4GudG = parcelRequire("4GudG");
const $7432b934335413bd$export$44a404f218b0e66e = (0, $4GudG.withChoreographedToggle)((0, $cwZBT.default), 'isOpen', 'content');

});


parcelRegister("6rlhA", function(module, exports) {
$parcel$export(module.exports, "default", () => $742c5e69dae6a49f$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $742c5e69dae6a49f$var$messages = (0, $7qGN1.defineMessages)({
    noOptions: {
        "id": "common.components.picker.base.no-options",
        "defaultMessage": "No results"
    },
    loading: {
        "id": "common.components.picker.base.loading",
        "defaultMessage": "Searching..."
    },
    defaultPlaceholder: {
        "id": "common.components.picker.base.default-placeholder",
        "defaultMessage": "Select..."
    },
    clearSelected: {
        "id": "common.components.picker.base.clear-selected",
        "defaultMessage": "Clear selected"
    }
});
var $742c5e69dae6a49f$export$2e2bcd8739ae039 = $742c5e69dae6a49f$var$messages;

});


parcelRegister("fdDZf", function(module, exports) {
$parcel$export(module.exports, "requestVersions", () => $5a2419ee51463761$export$aadfb092a4919504);

var $3i6bm = parcelRequire("3i6bm");

var $dqHWY = parcelRequire("dqHWY");
const $5a2419ee51463761$export$aadfb092a4919504 = async (projectKey, filter, versionStatuses, ignore, excludeArchivedVersions = false)=>{
    const pageVersions = await (0, $3i6bm.requestVersions)(projectKey, filter, versionStatuses, ignore);
    return (0, $dqHWY.transformVersions)(pageVersions.values, ignore, excludeArchivedVersions);
};

});
parcelRegister("3i6bm", function(module, exports) {
$parcel$export(module.exports, "MAX_RESULTS", () => $61ccc071e11282ed$export$f6b2881bc1090cea);
$parcel$export(module.exports, "requestVersions", () => $61ccc071e11282ed$export$aadfb092a4919504);

var $b5RwB = parcelRequire("b5RwB");

var $hgi0g = parcelRequire("hgi0g");
const $61ccc071e11282ed$export$f6b2881bc1090cea = 5;
const $61ccc071e11282ed$export$b702ac644ba114c = (projectKey)=>`/rest/api/2/project/${projectKey}/version`;
const $61ccc071e11282ed$export$10181c3ba572bfce = (filter, versionStatuses, ignore)=>(0, $b5RwB.stringify)({
        startAt: 0,
        query: filter,
        maxResults: $61ccc071e11282ed$export$f6b2881bc1090cea + ignore.length,
        orderBy: '+NAME',
        status: versionStatuses.join(',')
    });
const $61ccc071e11282ed$export$8395ad088d65e586 = (projectKey, filter, versionStatuses, ignore)=>`${$61ccc071e11282ed$export$b702ac644ba114c(projectKey)}?${$61ccc071e11282ed$export$10181c3ba572bfce(filter, versionStatuses, ignore)}`;
const $61ccc071e11282ed$export$aadfb092a4919504 = async (projectKey, filter, versionStatuses, ignore)=>(0, $hgi0g.default)($61ccc071e11282ed$export$8395ad088d65e586(projectKey, filter, versionStatuses, ignore));

});

parcelRegister("dqHWY", function(module, exports) {
$parcel$export(module.exports, "transformVersion", () => $6e5a5e3fef83cd9d$export$390ab7123357e756);
$parcel$export(module.exports, "transformVersions", () => $6e5a5e3fef83cd9d$export$8bc7a3929156b65e);

var $3i6bm = parcelRequire("3i6bm");
const $6e5a5e3fef83cd9d$export$390ab7123357e756 = (component)=>({
        value: component.id,
        label: component.name
    });
const $6e5a5e3fef83cd9d$export$8bc7a3929156b65e = (data, ignore, excludeArchivedVersions)=>data.filter((value)=>!ignore.includes(value.id) && (!excludeArchivedVersions || !value.archived)).map($6e5a5e3fef83cd9d$export$390ab7123357e756).slice(0, (0, $3i6bm.MAX_RESULTS));

});


parcelRegister("kTLpN", function(module, exports) {
$parcel$export(module.exports, "default", () => $d36aee28257e64be$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $d36aee28257e64be$var$messages = (0, $7qGN1.defineMessages)({
    error: {
        "id": "version-picker.error",
        "defaultMessage": "We couldn't retrieve versions"
    },
    placeholder: {
        "id": "version-picker.placeholder",
        "defaultMessage": "Select version"
    }
});
var $d36aee28257e64be$export$2e2bcd8739ae039 = $d36aee28257e64be$var$messages;

});


parcelRegister("delku", function(module, exports) {
$parcel$export(module.exports, "default", () => $87dd23580bddc453$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $6svxr = parcelRequire("6svxr");

var $gPG64 = parcelRequire("gPG64");

var $cxKOj = parcelRequire("cxKOj");

var $4cTDP = parcelRequire("4cTDP");

var $idGBm = parcelRequire("idGBm");

var $eOn0y = parcelRequire("eOn0y");
// eslint-disable-next-line jira/react/no-class-components
class $87dd23580bddc453$var$SwapIssues extends (0, $eJOHy.Component) {
    inputChange(update) {
        const { onInputChange: onInputChange } = this.props;
        onInputChange({
            moveUnfixedIssuesTo: update.moveUnfixedIssuesTo
        });
    }
    render() {
        const { intl: { formatMessage: formatMessage }, toDoInProgressIssuesCount: toDoInProgressIssuesCount, shouldSwapIssues: shouldSwapIssues, errors: errors, isSaving: isSaving, renderVersionPicker: renderVersionPicker } = this.props;
        const { moveUnfixedIssuesTo: moveUnfixedIssuesToError } = errors;
        const invalidVersionChosenIssueTermRefreshGalaxia = (0, $cxKOj.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $eOn0y.default).invalidVersionChosenIssueTermRefreshGalaxia : (0, $eOn0y.default).invalidVersionChosenIssueTermRefresh;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6svxr.default), {
            name: "UnresolvedIssue",
            isRequired: true,
            label: formatMessage((0, $4cTDP.fg)('jira-issue-terminology-refresh-m3') ? (0, $eOn0y.default).unresolvedIssuesHeaderIssueTermRefresh : (0, $eOn0y.default).unresolvedIssuesHeader, {
                issues: toDoInProgressIssuesCount
            })
        }, ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gPG64.default), {
                isDisabled: isSaving,
                isChecked: shouldSwapIssues,
                onChange: this.onMoveIssuesSelected,
                label: formatMessage((0, $4cTDP.fg)('jira-issue-terminology-refresh-m3') ? (0, $eOn0y.default).unresolvedIssuesMoveIssueTermRefresh : (0, $eOn0y.default).unresolvedIssuesMove, {
                    issues: toDoInProgressIssuesCount
                }),
                testId: "version-modals.release-version-modal.content.swap-issues.move-radio"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($87dd23580bddc453$var$VersionPickerContainer, null, renderVersionPicker({
                onSelected: this.onSwapIssues
            })), moveUnfixedIssuesToError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($87dd23580bddc453$var$ValidationError, null, formatMessage((0, $4cTDP.fg)('jira-issue-terminology-refresh-m3') ? invalidVersionChosenIssueTermRefreshGalaxia : (0, $eOn0y.default).invalidVersionChosen, {
                issues: toDoInProgressIssuesCount
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gPG64.default), {
                isDisabled: isSaving,
                isChecked: !shouldSwapIssues,
                onChange: this.onRemoveVersionFromIssuesSelected,
                label: formatMessage((0, $4cTDP.fg)('jira-issue-terminology-refresh-m3') ? (0, $eOn0y.default).unresolvedIssuesIgnoreIssueTermRefresh : (0, $eOn0y.default).unresolvedIssuesIgnore),
                testId: "version-modals.release-version-modal.content.swap-issues.ignore-radio"
            })));
    }
    constructor(...args){
        super(...args), this.onSwapIssues = (version)=>{
            if (version) this.inputChange({
                moveUnfixedIssuesTo: version.id
            });
            else this.inputChange({
                moveUnfixedIssuesTo: ''
            });
        }, this.onMoveIssuesSelected = ()=>{
            const { onSwapIssuesSelected: onSwapIssuesSelected } = this.props;
            onSwapIssuesSelected(true);
        }, this.onRemoveVersionFromIssuesSelected = ()=>{
            const { onSwapIssuesSelected: onSwapIssuesSelected } = this.props;
            onSwapIssuesSelected(false);
        };
    }
}
var $87dd23580bddc453$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, $idGBm.injectIntlV2)($87dd23580bddc453$var$SwapIssues);
const $87dd23580bddc453$var$VersionPickerContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19pkidpf _2hwx16xz _otyru2gc _18u01ejb",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $87dd23580bddc453$var$ValidationError = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19pku2gc _syaz1tmw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("eOn0y", function(module, exports) {
$parcel$export(module.exports, "default", () => $0500860c03032044$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $0500860c03032044$var$messages = (0, $7qGN1.defineMessages)({
    unresolvedIssuesHeader: {
        "id": "project-directories.versions.release-version-modal.content.swap-issues.unresolved-issues-header",
        "defaultMessage": "Unresolved {issues, plural, one {issue} other {issues}}"
    },
    unresolvedIssuesMove: {
        "id": "project-directories.versions.release-version-modal.content.swap-issues.unresolved-issues-move",
        "defaultMessage": "Move unresolved {issues, plural, one {issue} other {issues}} to"
    },
    unresolvedIssuesIgnore: {
        "id": "project-directories.versions.release-version-modal.content.swap-issues.unresolved-issues-ignore",
        "defaultMessage": "Ignore unresolved issues"
    },
    invalidVersionChosen: {
        "id": "project-directories.versions.release-version-modal.content.swap-issues.invalid-version-chosen",
        "defaultMessage": "Can't use this version. Change this version to another in your project or remove it from {issues, plural, one {this issue} other {these issues}}."
    },
    unresolvedIssuesHeaderIssueTermRefresh: {
        "id": "project-directories.versions.release-version-modal.content.swap-issues.unresolved-issues-header-issue-term-refresh",
        "defaultMessage": "Unresolved {issues, plural, one {work item} other {work items}}"
    },
    unresolvedIssuesMoveIssueTermRefresh: {
        "id": "project-directories.versions.release-version-modal.content.swap-issues.unresolved-issues-move-issue-term-refresh",
        "defaultMessage": "Move unresolved {issues, plural, one {work item} other {work items}} to"
    },
    unresolvedIssuesIgnoreIssueTermRefresh: {
        "id": "project-directories.versions.release-version-modal.content.swap-issues.unresolved-issues-ignore-issue-term-refresh",
        "defaultMessage": "Ignore unresolved work items"
    },
    invalidVersionChosenIssueTermRefresh: {
        "id": "project-directories.versions.release-version-modal.content.swap-issues.invalid-version-chosen-issue-term-refresh",
        "defaultMessage": "Can't use this version. Change this version to another in your project or remove it from {issues, plural, one {this work item} other {these work items}}."
    },
    invalidVersionChosenIssueTermRefreshGalaxia: {
        "id": "project-directories.versions.release-version-modal.content.swap-issues.invalid-version-chosen-issue-term-refresh-galaxia",
        "defaultMessage": "Can't use this version. Change this version to another in your space or remove it from {issues, plural, one {this work item} other {these work items}}."
    }
});
var $0500860c03032044$export$2e2bcd8739ae039 = $0500860c03032044$var$messages;

});



parcelRegister("kb64x", function(module, exports) {
$parcel$export(module.exports, "default", () => $1ab1a4e29040d254$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $lc0OY = parcelRequire("lc0OY");

var $5vQ2T = parcelRequire("5vQ2T");

var $4cTDP = parcelRequire("4cTDP");

var $kDaaB = parcelRequire("kDaaB");

var $idGBm = parcelRequire("idGBm");

var $fKemo = parcelRequire("fKemo");
class $1ab1a4e29040d254$export$7c6e2c02157bb7d2 extends (0, $eJOHy.Component) {
    renderDescriptionWithIssues() {
        const { intl: { formatMessage: formatMessage }, unresolvedIssuesCount: unresolvedIssuesCount, unresolvedIssuesUrl: unresolvedIssuesUrl } = this.props;
        const unresolvedIssueJqlViewLink = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lc0OY.default), {
            href: unresolvedIssuesUrl
        }, formatMessage((0, $4cTDP.fg)('jira-issue-terminology-refresh-m3') ? (0, $fKemo.default).descriptionWithIssuesCountIssueTermRefresh : (0, $fKemo.default).descriptionWithIssuesCount, {
            issues: unresolvedIssuesCount
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kDaaB.default), {
            ...(0, $fKemo.default).descriptionWithIssues,
            values: {
                issueCountLink: unresolvedIssueJqlViewLink
            }
        }));
    }
    renderDescriptionWithoutIssues() {
        const { intl: { formatMessage: formatMessage }, resolvedIssueUrl: resolvedIssueUrl, resolvedIssuesCount: resolvedIssuesCount } = this.props;
        const resolvedIssueJqlViewLink = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lc0OY.default), {
            href: resolvedIssueUrl
        }, formatMessage((0, $4cTDP.fg)('jira-issue-terminology-refresh-m3') ? (0, $fKemo.default).descriptionWithoutIssuesIssueTermRefresh : (0, $fKemo.default).descriptionWithoutIssues, {
            doneIssues: resolvedIssuesCount
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kDaaB.default), {
            ...(0, $fKemo.default).descriptionWithoutIssuesRestMessage,
            values: {
                issueCountLink: resolvedIssueJqlViewLink
            }
        }));
    }
    render() {
        const { unresolvedIssuesCount: unresolvedIssuesCount, SwapIssues: SwapIssues, ReleaseDate: ReleaseDate, ReleaseAutomationBanner: ReleaseAutomationBanner } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, unresolvedIssuesCount > 0 ? this.renderDescriptionWithIssues() : this.renderDescriptionWithoutIssues(), unresolvedIssuesCount > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(SwapIssues, null) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ReleaseDate, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
            fallback: "unmount",
            packageName: "jiraSoftwareReleasesVersionDetail",
            teamName: "jolt",
            id: "releaseAutomationBanner"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ReleaseAutomationBanner, null)));
    }
}
var $1ab1a4e29040d254$export$2e2bcd8739ae039 = (0, $idGBm.injectIntlV2)($1ab1a4e29040d254$export$7c6e2c02157bb7d2);

});
parcelRegister("fKemo", function(module, exports) {
$parcel$export(module.exports, "default", () => $4c635f3b611b80a8$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $4c635f3b611b80a8$var$messages = (0, $7qGN1.defineMessages)({
    descriptionWithIssues: {
        "id": "project-directories.versions.release-version-modal.content.description-with-issues",
        "defaultMessage": "This release contains {issueCountLink}."
    },
    descriptionWithIssuesCount: {
        "id": "project-directories.versions.release-version-modal.content.description-with-issues-count",
        "defaultMessage": "{issues, plural, one {{issues} unresolved issue} other {{issues} unresolved issues}}"
    },
    descriptionWithoutIssues: {
        "id": "project-directories.versions.release-version-modal.content.description-without-issues",
        "defaultMessage": "{doneIssues} {doneIssues, plural, one {issue} other {issues}}"
    },
    descriptionWithoutIssuesRestMessage: {
        "id": "project-directories.versions.release-version-modal.content.description-without-issues-rest-message",
        "defaultMessage": "{issueCountLink} will be released."
    },
    descriptionWithIssuesCountIssueTermRefresh: {
        "id": "project-directories.versions.release-version-modal.content.description-with-issues-count-issue-term-refresh",
        "defaultMessage": "{issues, plural, one {{issues} unresolved work item} other {{issues} unresolved work items}}"
    },
    descriptionWithoutIssuesIssueTermRefresh: {
        "id": "project-directories.versions.release-version-modal.content.description-without-issues-issue-term-refresh",
        "defaultMessage": "{doneIssues} {doneIssues, plural, one {work item} other {work items}}"
    }
});
var $4c635f3b611b80a8$export$2e2bcd8739ae039 = $4c635f3b611b80a8$var$messages;

});



parcelRegister("fZ8fz", function(module, exports) {
$parcel$export(module.exports, "default", () => $f5300abc07ddf2ca$export$2e2bcd8739ae039);
/* ReleaseModal.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable jira/filename-case */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $goZPP = parcelRequire("goZPP");

var $ik0CA = parcelRequire("ik0CA");
var $kseeK = parcelRequire("kseeK");
var $2qG7I = parcelRequire("2qG7I");
var $5a9Ro = parcelRequire("5a9Ro");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $7ep4S = parcelRequire("7ep4S");

var $lJKII = parcelRequire("lJKII");

var $fdpHV = parcelRequire("fdpHV");

var $6sjW5 = parcelRequire("6sjW5");

var $4B7rn = parcelRequire("4B7rn");

var $idGBm = parcelRequire("idGBm");


var $4cTDP = parcelRequire("4cTDP");

var $gsea4 = parcelRequire("gsea4");

var $jmAOT = parcelRequire("jmAOT");
class $f5300abc07ddf2ca$export$b77f092f9cf63f1e extends (0, $eJOHy.Component) {
    render() {
        const { Content: Content, unresolvedIssuesCount: unresolvedIssuesCount, isInitiating: isInitiating, onCancel: onCancel, intl: { formatMessage: formatMessage }, name: name } = this.props;
        if (isInitiating) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4B7rn.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lJKII.JiraModal), {
            isOpen: true,
            width: "small" // @ts-expect-error - TS2769 - No overload matches this call.
            ,
            onClose: onCancel,
            testId: "version-modals.release-version-modal.release-version-modal",
            messageId: "version-modals.release-version-modal.modal-dialog.release-version-modal",
            messageType: "transactional"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2qG7I.default), {
            hasCloseButton: (0, $4cTDP.fg)('enghealth-41206-modal-header-close-button')
        }, unresolvedIssuesCount ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5a9Ro.default), {
            appearance: "warning"
        }, formatMessage((0, $jmAOT.default).header, {
            name: name
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5a9Ro.default), null, formatMessage((0, $jmAOT.default).header, {
            name: name
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ik0CA.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Content, null)), this.renderFooter(this.props)));
    }
    constructor(...args){
        super(...args), // @ts-expect-error - TS2344 - Type '{ new (): HTMLElement; prototype: HTMLElement; }' does not satisfy the constraint 'keyof IntrinsicElements | ForwardRefExoticComponent<any> | (new (props: any) => Component<any, {}, any>) | ((props: any, context?: any) => ReactElement<...> | null)'.
        this.onButtonMounted = (node)=>{
            this.button = node;
        }, // focus needs to be set on button in order to hide date-picker
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.onRelease = (...args)=>{
            if (this.button) this.button.focus();
            this.props.onRelease(this.props.shouldRedirectToCreateReleaseNotes, args[args.length - 1]);
        }, // eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/react-no-unneeded-arrow-function-properties
        this.renderFooter = (props)=>{
            const { intl: { formatMessage: formatMessage }, unresolvedIssuesCount: unresolvedIssuesCount, isSaving: isSaving, onCancel: onCancel, isReleaseDisabled: isReleaseDisabled, shouldRedirectToCreateReleaseNotes: shouldRedirectToCreateReleaseNotes, setRedirectToCreateReleaseNotesStatus: setRedirectToCreateReleaseNotesStatus, shouldShowCreateReleaseNotesOption: shouldShowCreateReleaseNotesOption } = this.props;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kseeK.default), props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f5300abc07ddf2ca$var$FooterContainer, {
                showReleaseNotesPrompt: shouldShowCreateReleaseNotesOption
            }, shouldShowCreateReleaseNotesOption && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gsea4.CreateReleaseNotesPrompt), {
                onChange: setRedirectToCreateReleaseNotesStatus,
                value: shouldRedirectToCreateReleaseNotes
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f5300abc07ddf2ca$var$ButtonsContainer, null, isSaving && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
                xcss: $f5300abc07ddf2ca$var$spinnerContainerStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7ep4S.default), {
                size: "small"
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
                onClick: this.onRelease,
                appearance: unresolvedIssuesCount ? 'warning' : 'primary',
                type: "submit",
                isDisabled: isReleaseDisabled,
                ref: this.onButtonMounted
            }, formatMessage((0, $jmAOT.default).release)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
                appearance: "subtle-link",
                isDisabled: false,
                onClick: onCancel
            }, formatMessage((0, $jmAOT.default).cancel)))));
        };
    }
}
var $f5300abc07ddf2ca$export$2e2bcd8739ae039 = (0, $fdpHV.AnalyticsSource)('releaseVersions', (0, $aa42ce8e355d58fa$export$1171103ea9083ffa))((0, $6sjW5.default)({
    onRelease: (isCreateReleaseNotesOptedIn)=>({
            name: 'release',
            isCreateReleaseNotesOptedIn: isCreateReleaseNotesOptedIn
        }),
    onCancel: 'cancel'
})((0, $idGBm.injectIntlV2)($f5300abc07ddf2ca$export$b77f092f9cf63f1e)));
const $f5300abc07ddf2ca$var$spinnerContainerStyles = (0, $1DXK0.xcss)({
    marginRight: 'space.200'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f5300abc07ddf2ca$var$ButtonsContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _1bahesu3 _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f5300abc07ddf2ca$var$FooterContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { showReleaseNotesPrompt: showReleaseNotesPrompt, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _1bsb1osq",
            __cmplp.showReleaseNotesPrompt ? "_1bah1yb4" : "_1bahesu3",
            __cmplp.className
        ])
    });
});

});
parcelRegister("gsea4", function(module, exports) {
$parcel$export(module.exports, "CreateReleaseNotesPrompt", () => $feb16466561619fd$export$d8a8f048cf64e9ff);
/* CreateReleaseNotesPrompt.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $86tBw = parcelRequire("86tBw");

var $lRq8t = parcelRequire("lRq8t");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $fXpHV = parcelRequire("fXpHV");
const $feb16466561619fd$export$d8a8f048cf64e9ff = ({ onChange: onChange, value: value })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const onValueChange = (0, $eJOHy.useCallback)((event)=>{
        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({
            action: 'toggled',
            actionSubject: 'checkbox'
        }), 'releaseModalCreateReleaseNotesCheckbox');
        onChange(event.target.checked);
    }, [
        createAnalyticsEvent,
        onChange
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($feb16466561619fd$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $86tBw.default), {
        name: "createReleaseNotes",
        label: formatMessage((0, $fXpHV.default).createReleaseNotesTitle),
        isChecked: value,
        onChange: onValueChange
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $feb16466561619fd$var$Wrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("86tBw", function(module, exports) {
$parcel$export(module.exports, "default", () => $43629aa548cc82fb$export$2e2bcd8739ae039);
/* checkbox.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $jrFnt = parcelRequire("jrFnt");

var $gyJTO = parcelRequire("gyJTO");

var $cM2mi = parcelRequire("cM2mi");
var $jJLKy = parcelRequire("jJLKy");
var $9ywMw = parcelRequire("9ywMw");
var $lsp6q = parcelRequire("lsp6q");
const $43629aa548cc82fb$var$checkboxStyles = {
    root: "_19itglyw _nd5lfibj _12ji1r31 _1qu2glyw _12y31o36 _1bsb1osq _4t3i1osq _r06hglyw _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _tzy4idpf _r050fibj _9bg71mn3 _19op11so _a30fhteq _1610e4h9 _13wo93zu _q5a61gyf _8gq114p8 _wje2mov0 _1fo21cni _eyedglyw _1ef78r4n _1h6r8r4n _smzg1nfn _1dk71nfn _l71j1i6y _t34a1i6y _y32gkivo _1ah9199y _1frj180l _h78e1g3k _dwvb1ps2 _1bok170n _1mhr17cl _fx2i3rva _10oaq2ws _w12s155b _15y61vek _e6ww155b _sg1j1vek _rphw18jz _y9y9mz2b _141bmz2b _255gmz2b _jj67mz2b _swhgmz2b _axq81diq _1jiz1diq _s9051diq _1efy1diq _1oav1diq _10y313gf _1wt913gf _qq8613gf _1adw13gf _12sr13gf _16jiglyw _693jglyw _1niqglyw _cl9tglyw _1jbnglyw _j1ta1hou _18qu1ps2 _1g52170n _1log17cl _32hzmz2b _1vv91diq _yjhd1hou _w1cowc43 _jdqn1onz _4y4t1onz _lvfrwc43 _g68dwc43 _13dk1onz _w1el1onz _a9yw1onz _1l3g1onz _dcdpgir2 _wobcgir2 _rp9wgir2 _9ebfwc43 _e43iwc43 _1tkuwc43 _1lehwc43 _b9q3wc43 _tu2918qt _1uxv18qt _1ufw18qt _opo918qt _1e8318qt _1k3d18qt _25yv18qt _1igz18qt _c7cc18qt _1swg18qt"
}; /**
    * __Checkbox__
    *
    * A checkbox an input control that allows a user to select one or more options from a number of choices.
    *
    * - [Examples](https://atlassian.design/components/checkbox/examples)
    * - [Code](https://atlassian.design/components/checkbox/code)
    * - [Usage](https://atlassian.design/components/checkbox/usage)
    */ 
const $43629aa548cc82fb$var$Checkbox = /*#__PURE__*/ (0, $eJOHy.memo)(/*#__PURE__*/ (0, $eJOHy.forwardRef)(function Checkbox({ isChecked: isCheckedProp, isDisabled: isDisabled = false, isInvalid: isInvalid = false, defaultChecked: defaultChecked = false, isIndeterminate: isIndeterminate = false, onChange: onChangeProps, analyticsContext: analyticsContext, label: label, name: name, value: value, isRequired: isRequired, testId: testId, xcss: xcss, className: className, ...rest }, ref) {
    const [isCheckedState, setIsCheckedState] = (0, $eJOHy.useState)(isCheckedProp !== undefined ? isCheckedProp : defaultChecked);
    const onChange = (0, $eJOHy.useCallback)((e, analyticsEvent)=>{
        setIsCheckedState(e.target.checked);
        if (onChangeProps) onChangeProps(e, analyticsEvent);
    }, [
        onChangeProps
    ]);
    const onChangeAnalytics = (0, $jrFnt.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        componentName: 'checkbox',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    const internalRef = (0, $eJOHy.useRef)(null);
    const mergedRefs = (0, $gyJTO.default)([
        internalRef,
        ref
    ]); // Use isChecked from the state if it is controlled
    const isChecked = isCheckedProp === undefined ? isCheckedState : isCheckedProp;
    (0, $eJOHy.useEffect)(()=>{
        if (internalRef.current) internalRef.current.indeterminate = isIndeterminate;
    }, [
        isIndeterminate
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $jJLKy.default), {
        isDisabled: isDisabled,
        label: label,
        id: rest.id ? `${rest.id}-label` : undefined,
        testId: testId && `${testId}--checkbox-label`,
        // When there is more usage of this pattern we'll update the lint rule.
        xcss: xcss,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)("input" // It is necessary only for Safari. It allows to render focus styles.
            , {
                tabIndex: 0,
                ...rest,
                type: "checkbox",
                ref: mergedRefs,
                disabled: isDisabled,
                checked: isChecked,
                value: value,
                name: name,
                required: isRequired,
                className: (0, $hcewu.default)([
                    $43629aa548cc82fb$var$checkboxStyles.root,
                    className
                ]),
                onChange: onChangeAnalytics,
                "aria-invalid": isInvalid ? 'true' : undefined,
                "data-testid": testId && `${testId}--hidden-checkbox`,
                "data-invalid": isInvalid ? 'true' : undefined
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $cM2mi.default), {
                isIndeterminate: isIndeterminate,
                isChecked: isChecked
            }),
            label && /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $9ywMw.default), {
                children: [
                    label,
                    isRequired && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lsp6q.default), {})
                ]
            })
        ]
    });
}));
$43629aa548cc82fb$var$Checkbox.displayName = 'Checkbox';
var $43629aa548cc82fb$export$2e2bcd8739ae039 = $43629aa548cc82fb$var$Checkbox;

});
parcelRegister("cM2mi", function(module, exports) {
$parcel$export(module.exports, "default", () => $b89a586a6c2ef726$export$2e2bcd8739ae039);
/* checkbox-icon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $2Swhg = parcelRequire("2Swhg");

var $eGOwo = parcelRequire("eGOwo");
function $b89a586a6c2ef726$var$getIcon(isIndeterminate, isChecked) {
    if (isIndeterminate) {
        if ((0, $eGOwo.fg)('platform-visual-refresh-icons')) return /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7.75 12.75H16.25V11.25H7.75V12.75Z",
            fill: "inherit"
        });
        else return /*#__PURE__*/ (0, $gt9Am.jsx)("rect", {
            fill: "inherit",
            x: "8",
            y: "11",
            width: "8",
            height: "2",
            rx: "1"
        });
    }
    if (isChecked) {
        if ((0, $eGOwo.fg)('platform-visual-refresh-icons')) return /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
            fill: "inherit"
        });
        else return /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
            d: "M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586l-1.293-1.293z",
            fill: "inherit"
        });
    }
    // No icon
    return null;
}
/**
 * __Checkbox icon__
 *
 * A checkbox icon is the visual representation of checkbox state,
 * which is shown instead of the native input.
 *
 * @internal
 */ const $b89a586a6c2ef726$var$CheckboxIcon = /*#__PURE__*/ (0, $eJOHy.memo)(({ isIndeterminate: isIndeterminate, isChecked: isChecked })=>{
    const icon = (0, $eJOHy.useMemo)(()=>$b89a586a6c2ef726$var$getIcon(isIndeterminate, isChecked), [
        isIndeterminate,
        isChecked
    ]);
    return(// eslint-disable-next-line @atlaskit/design-system/no-custom-icons
    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2Swhg.default), {
        label: "",
        primaryColor: "var(--checkbox-background-color)",
        secondaryColor: "var(--checkbox-tick-color)",
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)("g", {
            fillRule: "evenodd",
            children: [
                (0, $eGOwo.fg)('platform-visual-refresh-icons') ? /*#__PURE__*/ (0, $gt9Am.jsx)("rect", {
                    fill: "currentColor",
                    x: "5.5",
                    y: "5.5",
                    width: "13",
                    height: "13",
                    rx: "1.5"
                }) : /*#__PURE__*/ (0, $gt9Am.jsx)("rect", {
                    fill: "currentColor",
                    x: "6",
                    y: "6",
                    width: "12",
                    height: "12",
                    rx: "2"
                }),
                icon
            ]
        })
    }));
});
var $b89a586a6c2ef726$export$2e2bcd8739ae039 = $b89a586a6c2ef726$var$CheckboxIcon;

});

parcelRegister("jJLKy", function(module, exports) {
$parcel$export(module.exports, "default", () => $4573aabb850f2ff0$export$2e2bcd8739ae039);
/* label.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $4573aabb850f2ff0$var$baseStyles = null;
const $4573aabb850f2ff0$var$textLabelLayoutStyles = null;
const $4573aabb850f2ff0$var$disabledStyles = null;
const $4573aabb850f2ff0$var$labelStyles = null;
function $4573aabb850f2ff0$export$2e2bcd8739ae039({ children: children, isDisabled: isDisabled, testId: testId, label: label, id: id, xcss: xcss }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)("label", {
        className: (0, $hcewu.default)([
            "_11c82smr _1e0c11p5 _1ejihkll _umai184x _syazj3m3 _80om73ad",
            label && "_zulp1nu5 _yv0ey09t",
            isDisabled && "_syaz1tvo _80om13gf",
            "_h5e3mag2 _1nzs11d3 _1eszzyvw _yp0jhh5a _ay2w1y1w _d51u10ko _phft1fmg _1g1funzk _l6wkzyvw _1dikhh5a _1sfg1q3k _fpdj1y1w _1yjc194a _oaj11fmg _1j3h1q3k _eawb1dzn _1rda1qbb _18q015t7 _13hr3acm",
            xcss
        ]),
        "data-testid": testId,
        "data-disabled": isDisabled || undefined,
        id: id,
        children: children
    });
}

});

parcelRegister("9ywMw", function(module, exports) {
$parcel$export(module.exports, "default", () => $94306373cce3a9fe$export$2e2bcd8739ae039);
/* label-text.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $94306373cce3a9fe$var$labelTextStyles = null;
function $94306373cce3a9fe$export$2e2bcd8739ae039({ children: children }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        className: (0, $hcewu.default)([
            "_nd5l11ig _1wpz1h6o"
        ]),
        children: children
    });
}

});

parcelRegister("lsp6q", function(module, exports) {
$parcel$export(module.exports, "default", () => $bafcc116ddbb4544$export$2e2bcd8739ae039);
/* required-indicator.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $bafcc116ddbb4544$var$requiredIndicatorStyles = null;
function $bafcc116ddbb4544$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        "aria-hidden": true,
        className: (0, $hcewu.default)([
            "_syaz1gtz _bozgv77o"
        ]),
        children: "*"
    });
}

});


parcelRegister("fXpHV", function(module, exports) {
$parcel$export(module.exports, "default", () => $5d262568acd2c14e$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $5d262568acd2c14e$var$messages = (0, $7qGN1.defineMessages)({
    createReleaseNotesTitle: {
        "id": "project-directories.versions.release-version-modal.create-release-notes-prompt.create-release-notes-title",
        "defaultMessage": "Create release notes"
    }
});
var $5d262568acd2c14e$export$2e2bcd8739ae039 = $5d262568acd2c14e$var$messages;

});


parcelRegister("jmAOT", function(module, exports) {
$parcel$export(module.exports, "default", () => $08a212cb4beb1a86$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $08a212cb4beb1a86$var$messages = (0, $7qGN1.defineMessages)({
    header: {
        "id": "project-directories.versions.release-version-modal.header",
        "defaultMessage": "Release {name}"
    },
    release: {
        "id": "project-directories.versions.release-version-modal.release",
        "defaultMessage": "Release"
    },
    cancel: {
        "id": "project-directories.versions.release-version-modal.cancel",
        "defaultMessage": "Cancel"
    }
});
var $08a212cb4beb1a86$export$2e2bcd8739ae039 = $08a212cb4beb1a86$var$messages;

});




parcelRegister("gVv7l", function(module, exports) {
$parcel$export(module.exports, "default", () => $728595492b70cc1f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<eff6bbb8fd1c5cbef9a0b7352a9b5a38>>
 * @relayHash 1abf975667e0c9ee5b3f2be70e2c73a1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e7ac237c42a6f8772ca697f1e101e98fdbe98411d3c61d3395eb3afa396b6eb0
const $728595492b70cc1f$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "releaseNoteConfiguration"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "versionAri"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "versionAri"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = {
        "kind": "ScalarField",
        "name": "canEditRelatedWork"
    }, v6 = {
        "kind": "ScalarField",
        "name": "releasesNotesPreferenceType"
    }, v7 = {
        "kind": "ScalarField",
        "name": "issueKeyConfig"
    }, v8 = {
        "kind": "ScalarField",
        "name": "issueFieldIds"
    }, v9 = {
        "kind": "ScalarField",
        "name": "issueTypeIds"
    }, v10 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 100
        }
    ], v11 = [
        {
            "kind": "Variable",
            "name": "releaseNoteConfiguration",
            "variableName": "releaseNoteConfiguration"
        }
    ], v12 = {
        "kind": "ScalarField",
        "name": "isSystem"
    }, v13 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v14 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ],
        "type": "QueryError"
    }, v15 = {
        "kind": "ScalarField",
        "name": "name"
    }, v16 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v17 = {
        "kind": "ScalarField",
        "name": "endCursor"
    }, v18 = {
        "kind": "ScalarField",
        "name": "hasNextPage"
    }, v19 = [
        {
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
                v18 /*: any*/ ,
                v17 /*: any*/ 
            ]
        },
        {
            "concreteType": "JiraIssueFieldEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        v15 /*: any*/ 
                    ]
                },
                v16 /*: any*/ 
            ]
        }
    ], v20 = [
        "searchString"
    ], v21 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 10
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "uiReleaseNotesModalQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v2 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v4 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "jira.version.id"
                                                },
                                                v5 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                {
                                                    "kind": "RequiredField",
                                                    "field": {
                                                        "concreteType": "JiraReleaseNotesConfiguration",
                                                        "kind": "LinkedField",
                                                        "name": "releaseNotesConfiguration",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v7 /*: any*/ ,
                                                                "action": "THROW",
                                                                "path": "jira.version.releaseNotesConfiguration.issueKeyConfig"
                                                            },
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v8 /*: any*/ ,
                                                                "action": "THROW",
                                                                "path": "jira.version.releaseNotesConfiguration.issueFieldIds"
                                                            },
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v9 /*: any*/ ,
                                                                "action": "THROW",
                                                                "path": "jira.version.releaseNotesConfiguration.issueTypeIds"
                                                            }
                                                        ]
                                                    },
                                                    "action": "THROW",
                                                    "path": "jira.version.releaseNotesConfiguration"
                                                },
                                                {
                                                    "kind": "RequiredField",
                                                    "field": {
                                                        "args": v10 /*: any*/ ,
                                                        "concreteType": "JiraIssueTypeConnection",
                                                        "kind": "LinkedField",
                                                        "name": "releaseNotesOptionsIssueTypes",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": {
                                                                    "concreteType": "JiraIssueTypeEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "FragmentSpread",
                                                                            "name": "ui_softwareReleasesAddReleaseNotesModal_ReleaseNotesModal_jiraIssueTypeEdges"
                                                                        }
                                                                    ]
                                                                },
                                                                "action": "THROW",
                                                                "path": "jira.version.releaseNotesOptionsIssueTypes.edges"
                                                            }
                                                        ],
                                                        "storageKey": "releaseNotesOptionsIssueTypes(first:100)"
                                                    },
                                                    "action": "THROW",
                                                    "path": "jira.version.releaseNotesOptionsIssueTypes"
                                                },
                                                {
                                                    "args": v11 /*: any*/ ,
                                                    "kind": "FragmentSpread",
                                                    "name": "ui_softwareReleasesAddReleaseNotesModal_ReleaseNotesModalContent_version"
                                                },
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "formattingOptions_softwareReleasesAddReleaseNotesModal"
                                                },
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "embeddedPageReleaseNotes_softwareReleasesAddReleaseNotesModal_EmbeddedPageReleaseNotesModal"
                                                },
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "analyticsContext_softwareReleasesAddReleaseNotesModal_ReleaseNotesModalAnalyticsContext"
                                                },
                                                {
                                                    "concreteType": "JiraReleaseNotesInConfluenceAvailableSitesConnection",
                                                    "kind": "LinkedField",
                                                    "name": "availableSites",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "RequiredField",
                                                            "field": {
                                                                "concreteType": "JiraReleaseNotesInConfluenceAvailableSitesEdge",
                                                                "kind": "LinkedField",
                                                                "name": "edges",
                                                                "plural": true,
                                                                "selections": [
                                                                    {
                                                                        "kind": "RequiredField",
                                                                        "field": {
                                                                            "concreteType": "JiraReleaseNotesInConfluenceAvailableSite",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "RequiredField",
                                                                                    "field": v12 /*: any*/ ,
                                                                                    "action": "LOG",
                                                                                    "path": "jira.version.availableSites.edges.node.isSystem"
                                                                                }
                                                                            ]
                                                                        },
                                                                        "action": "LOG",
                                                                        "path": "jira.version.availableSites.edges.node"
                                                                    }
                                                                ]
                                                            },
                                                            "action": "LOG",
                                                            "path": "jira.version.availableSites.edges"
                                                        }
                                                    ]
                                                },
                                                v13 /*: any*/ 
                                            ],
                                            "type": "JiraVersion"
                                        },
                                        v14 /*: any*/ 
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.version"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "uiReleaseNotesModalQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "version",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        {
                                            "concreteType": "JiraReleaseNotesConfiguration",
                                            "kind": "LinkedField",
                                            "name": "releaseNotesConfiguration",
                                            "plural": false,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                v8 /*: any*/ ,
                                                v9 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "args": v10 /*: any*/ ,
                                            "concreteType": "JiraIssueTypeConnection",
                                            "kind": "LinkedField",
                                            "name": "releaseNotesOptionsIssueTypes",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssueTypeEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueType",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v4 /*: any*/ ,
                                                                v15 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraAvatar",
                                                                    "kind": "LinkedField",
                                                                    "name": "avatar",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "xsmall"
                                                                        }
                                                                    ]
                                                                },
                                                                v3 /*: any*/ 
                                                            ]
                                                        },
                                                        v16 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "concreteType": "PageInfo",
                                                    "kind": "LinkedField",
                                                    "name": "pageInfo",
                                                    "plural": false,
                                                    "selections": [
                                                        v17 /*: any*/ ,
                                                        v18 /*: any*/ 
                                                    ]
                                                }
                                            ],
                                            "storageKey": "releaseNotesOptionsIssueTypes(first:100)"
                                        },
                                        {
                                            "args": v10 /*: any*/ ,
                                            "handle": "connection",
                                            "key": "issueTypeSelector_releaseNotesOptionsIssueTypes",
                                            "kind": "LinkedHandle",
                                            "name": "releaseNotesOptionsIssueTypes"
                                        },
                                        {
                                            "args": v11 /*: any*/ ,
                                            "concreteType": "JiraADF",
                                            "kind": "LinkedField",
                                            "name": "releaseNotes",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "json"
                                                }
                                            ]
                                        },
                                        {
                                            "args": v10 /*: any*/ ,
                                            "concreteType": "JiraIssueFieldConnection",
                                            "kind": "LinkedField",
                                            "name": "releaseNotesOptionsIssueFields",
                                            "plural": false,
                                            "selections": v19 /*: any*/ ,
                                            "storageKey": "releaseNotesOptionsIssueFields(first:100)"
                                        },
                                        {
                                            "args": v10 /*: any*/ ,
                                            "filters": v20 /*: any*/ ,
                                            "handle": "connection",
                                            "key": "issueFieldSelectors_releaseNotesOptionsIssueFields",
                                            "kind": "LinkedHandle",
                                            "name": "releaseNotesOptionsIssueFields"
                                        },
                                        {
                                            "args": v21 /*: any*/ ,
                                            "concreteType": "JiraIssueFieldConnection",
                                            "kind": "LinkedField",
                                            "name": "nativeReleaseNotesOptionsIssueFields",
                                            "plural": false,
                                            "selections": v19 /*: any*/ ,
                                            "storageKey": "nativeReleaseNotesOptionsIssueFields(first:10)"
                                        },
                                        {
                                            "args": v21 /*: any*/ ,
                                            "filters": v20 /*: any*/ ,
                                            "handle": "connection",
                                            "key": "issueFieldSelectors_nativeReleaseNotesOptionsIssueFields",
                                            "kind": "LinkedHandle",
                                            "name": "nativeReleaseNotesOptionsIssueFields"
                                        },
                                        {
                                            "concreteType": "JiraReleaseNotesInConfluenceAvailableSitesConnection",
                                            "kind": "LinkedField",
                                            "name": "availableSites",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraReleaseNotesInConfluenceAvailableSitesEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraReleaseNotesInConfluenceAvailableSite",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v12 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        v13 /*: any*/ 
                                    ],
                                    "type": "JiraVersion"
                                },
                                v14 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v4 /*: any*/ 
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "e7ac237c42a6f8772ca697f1e101e98fdbe98411d3c61d3395eb3afa396b6eb0",
            "metadata": {},
            "name": "uiReleaseNotesModalQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$728595492b70cc1f$var$node.hash = "b8c5823683fa1dc8a3117a965fb8027e";
var $728595492b70cc1f$export$2e2bcd8739ae039 = $728595492b70cc1f$var$node;

});

parcelRegister("hmF8e", function(module, exports) {
$parcel$export(module.exports, "default", () => $feb4d42344c94814$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $feb4d42344c94814$var$messages = (0, $7qGN1.defineMessages)({
    buttonLabel: {
        "id": "software-releases-launch-card.version-status.button-label",
        "defaultMessage": "Version release state dropdown"
    },
    archiveOptionLabel: {
        "id": "software-releases-launch-card.version-status.archive-option-label",
        "defaultMessage": "Archive"
    },
    archivedLabel: {
        "id": "software-releases-launch-card.version-status.archived-label",
        "defaultMessage": "Archived"
    },
    releasedLabel: {
        "id": "software-releases-launch-card.version-status.released-label",
        "defaultMessage": "Released"
    },
    releaseOptionLabel: {
        "id": "software-releases-launch-card.version-status.release-option-label",
        "defaultMessage": "Release"
    },
    unarchiveOptionLabel: {
        "id": "software-releases-launch-card.version-status.unarchive-option-label",
        "defaultMessage": "Unarchive"
    },
    unreleaseOptionLabel: {
        "id": "software-releases-launch-card.version-status.unrelease-option-label",
        "defaultMessage": "Unrelease"
    },
    unreleasedLabel: {
        "id": "software-releases-launch-card.version-status.unreleased-label",
        "defaultMessage": "Unreleased"
    },
    archiveFailedFlagDescription: {
        "id": "software-releases-launch-card.version-status.archive-failed-flag-description",
        "defaultMessage": "We were not able to update the version archived status. Please refresh the page and try again."
    },
    genericUpdateFailedFlagTitle: {
        "id": "software-releases-launch-card.version-status.generic-update-failed-flag-title",
        "defaultMessage": "Something went wrong"
    },
    releaseFailedFlagDescription: {
        "id": "software-releases-launch-card.version-status.release-failed-flag-description",
        "defaultMessage": "We were not able to update the version released status. Please refresh the page and try again."
    }
});
var $feb4d42344c94814$export$2e2bcd8739ae039 = $feb4d42344c94814$var$messages;

});




parcelRegister("4Ji46", function(module, exports) {
$parcel$export(module.exports, "LoadingWrapper", () => $c7457faacc327bb7$export$43a792a870d28db2);
$parcel$export(module.exports, "StatusLoading", () => $c7457faacc327bb7$export$51c5b32c3d6a82a3);
$parcel$export(module.exports, "LatestDeploymentLoading", () => $c7457faacc327bb7$export$312fd886f74b4447);
$parcel$export(module.exports, "TwoColumnFieldWrapper", () => $c7457faacc327bb7$export$6dbdef323b681eb1);
$parcel$export(module.exports, "FieldLoadingWrapper", () => $c7457faacc327bb7$export$6f356a6f7f11d124);
$parcel$export(module.exports, "FieldLabelLoading", () => $c7457faacc327bb7$export$1411e5aa93aa9d74);
$parcel$export(module.exports, "FieldContentLoading", () => $c7457faacc327bb7$export$9f4ff45992eb7f88);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ /**
 * Loading component starts
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");
const $c7457faacc327bb7$var$skeletonKeyFrames = null;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c7457faacc327bb7$var$AnimationBaseDiv = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_ju25ru3m _5sagymdr _1o51q7pw _tip812c5 _1pglp3kn _1itk1pxg _12vemgnk _bfhkizff _j7hq1nls",
            __cmplp.className
        ])
    });
});
const $c7457faacc327bb7$export$43a792a870d28db2 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rkofajl _189ee4h9 _1dqonqa1 _1h6d1l7x",
            __cmplp.className
        ])
    });
});
const $c7457faacc327bb7$export$51c5b32c3d6a82a3 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = $c7457faacc327bb7$var$AnimationBaseDiv, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1bsb1osq _4t3i1ylp",
            __cmplp.className
        ])
    });
});
const $c7457faacc327bb7$export$312fd886f74b4447 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = $c7457faacc327bb7$var$AnimationBaseDiv, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1bsb1osq _4t3i8vuz",
            __cmplp.className
        ])
    });
});
const $c7457faacc327bb7$export$6dbdef323b681eb1 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1neqek2": (0, $awdRS.default)(`${__cmplp.height}px`)
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _4t3i2nrh",
            __cmplp.className
        ])
    });
});
const $c7457faacc327bb7$export$6f356a6f7f11d124 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug",
            __cmplp.className
        ])
    });
});
const $c7457faacc327bb7$export$1411e5aa93aa9d74 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = $c7457faacc327bb7$var$AnimationBaseDiv, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1bsb1ssb _4t3i7vkz _19pku2gc _2hwxidpf _otyru2gc _18u0idpf",
            __cmplp.className
        ])
    });
});
const $c7457faacc327bb7$export$9f4ff45992eb7f88 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = $c7457faacc327bb7$var$AnimationBaseDiv, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1bsb1n8h _4t3i1crf _19pku2gc _2hwxidpf _otyru2gc _18u0idpf",
            __cmplp.className
        ])
    });
});
const $c7457faacc327bb7$export$22183793b514d3aa = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _1bsb1osq _4t3i8vuz",
            __cmplp.className
        ])
    });
});

});


parcelRegister("liDzu", function(module, exports) {
$parcel$export(module.exports, "IssueListWithHeaderWithErrorBoundary", () => $2248552b80f5b0f2$export$d97e9356033839cd);

var $AGxK4 = parcelRequire("AGxK4");

var $8RKZD = parcelRequire("8RKZD");

var $1jLhk = parcelRequire("1jLhk");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $j4oe4 = parcelRequire("j4oe4");

var $806LH = parcelRequire("806LH");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $4cTDP = parcelRequire("4cTDP");

var $fi8WO = parcelRequire("fi8WO");

var $5vQ2T = parcelRequire("5vQ2T");

var $lRq8t = parcelRequire("lRq8t");

var $2imLM = parcelRequire("2imLM");

var $fwzaq = parcelRequire("fwzaq");

var $kGj4V = parcelRequire("kGj4V");

var $jISVN = parcelRequire("jISVN");

var $7ZUH2 = parcelRequire("7ZUH2");

var $amEKX = parcelRequire("amEKX");

var $lmneG = parcelRequire("lmneG");

var $9VxZ2 = parcelRequire("9VxZ2");

var $irNJ5 = parcelRequire("irNJ5");

var $9RVdp = parcelRequire("9RVdp");

var $emj3R = parcelRequire("emj3R");

var $2rI45 = parcelRequire("2rI45");

var $gxYtR = parcelRequire("gxYtR");

var $cLHPd = parcelRequire("cLHPd");

var $3nAD0 = parcelRequire("3nAD0");

var $cmxu9 = parcelRequire("cmxu9");

var $croBS = parcelRequire("croBS");

var $epqOj = parcelRequire("epqOj");

var $foOVA = parcelRequire("foOVA");

var $6OJ1M = parcelRequire("6OJ1M");
const $2248552b80f5b0f2$var$DEV_DETAILS_DIALOG_SCOPE_ID = 'VersionDetailsIssueList';
const $2248552b80f5b0f2$var$LOAD_MORE_PAGE_SIZE = 50;
const $2248552b80f5b0f2$var$IssuesRefetchable = ({ jiraVersion: jiraVersion })=>{
    const { isAnyFilterApplied: isAnyFilterApplied } = (0, $amEKX.useFilterSortingQueryParams)();
    const { filters: filters, sortBy: sortBy } = (0, $lmneG.useVersionIssuesGraphQLVariables)();
    const onExperienceSuccess = (0, $9RVdp.useViewVersionDetailsPageExperienceSuccess)(); /* eslint-disable @atlassian/relay/unused-fields */ 
    const versionFragmentRef = (0, $j4oe4.usePaginationFragment)((0, $1jLhk.default), jiraVersion);
    /* eslint-enable @atlassian/relay/unused-fields */ const { data: jiraVersionData, refetch: refetch, hasNext: hasNext, loadNext: loadNext, isLoadingNext: isLoadingNext } = versionFragmentRef;
    const loadNextPage = (0, $eJOHy.useCallback)(()=>{
        if (hasNext) loadNext($2248552b80f5b0f2$var$LOAD_MORE_PAGE_SIZE);
    }, [
        loadNext,
        hasNext
    ]);
    const issueEdges = jiraVersionData.issuesForList.edges.filter(Boolean);
    const totalIssuesCount = jiraVersionData.issuesForList.totalCount ?? issueEdges.length;
    const nextPageSize = Math.min(totalIssuesCount - issueEdges.length, $2248552b80f5b0f2$var$LOAD_MORE_PAGE_SIZE);
    const setLoadMoreElement = (0, $6OJ1M.useIntersectionObserver)({
        margin: 40,
        onIntersection: loadNextPage
    });
    const variables = (0, $9VxZ2.useDeepMemo)({
        sortBy: sortBy,
        filters: filters
    });
    const [debouncedRefetch] = (0, $fwzaq.default)((refetchVariables)=>{
        refetch({
            id: jiraVersionData.id,
            // @ts-expect-error TS2698 Spread types may only be created from object
            ...refetchVariables
        });
    }, 500);
    const isFirstRenderRef = (0, $eJOHy.useRef)(true);
    (0, $eJOHy.useEffect)(()=>{
        if (isFirstRenderRef.current) // Initial rendering is already after the query is executed by react-resource-router, so we don't need to run refetch for initial rendering.
        isFirstRenderRef.current = false;
        else // @ts-expect-error TS2345 - Argument is not assignable to parameter of type 'SuspenselessParameters'.
        debouncedRefetch(variables);
    }, [
        debouncedRefetch,
        variables
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, issueEdges.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        id: "jira.software.releases.version.detail.issue.list.empty-view",
        packageName: "jira-software-releases-version-detail-issue-list",
        teamName: "jolt",
        onError: ()=>{
            // We don't want to fire experience failure even if the table rendering fails when the table is empty. Table’s empty state doesn’t really show useful information anyway.
            onExperienceSuccess();
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $emj3R.EmptyView), {
        jiraVersion: jiraVersionData,
        isAnyFilterApplied: isAnyFilterApplied,
        textFilter: filters.searchStr ?? null
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cmxu9.Issues), {
        jiraIssueEdgesReference: issueEdges,
        jiraVersion: jiraVersionData,
        jiraVersionRefetch: jiraVersionData
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2248552b80f5b0f2$var$LoadingMoreContainer, {
        ref: setLoadMoreElement
    }, isLoadingNext ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cLHPd.IssueListSkeleton), {
        rowCount: nextPageSize
    }) : null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $irNJ5.ErrorBoundary), {
        id: "jira.software.releases.version.detail.issue.list.screen-analytics"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $foOVA.IssueListScreenAnalytics), {
        jiraVersionReference: jiraVersionData,
        jiraIssueEdgesReference: issueEdges
    })));
};
const $2248552b80f5b0f2$var$IssueListWithHeader = ({ jiraVersion: jiraVersion })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const data = (0, $j4oe4.useFragment)((0, $8RKZD.default), jiraVersion);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kGj4V.ContextualAnalyticsData), {
        sourceName: "versionDetailsTable",
        sourceType: (0, $aa42ce8e355d58fa$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $irNJ5.ErrorBoundary), {
        id: "issuesListDevDetailsDialog"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fi8WO.DevDetailsDialogLoaderAsync), {
        scopeId: $2248552b80f5b0f2$var$DEV_DETAILS_DIALOG_SCOPE_ID
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7ZUH2.CollapsibleSection), {
        jiraVersion: data,
        uiType: "ISSUES",
        renderHeader: (isCollapsed, onToggleClicked)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2248552b80f5b0f2$var$HeaderCollapsibleWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2248552b80f5b0f2$var$HeaderLeftWrapper, {
                onClick: onToggleClicked
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $806LH.default), {
                size: "small",
                as: "h2"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
                xcss: $2248552b80f5b0f2$var$sectionTitleStyles
            }, formatMessage((0, $4cTDP.fg)('jira-issue-terminology-update-m4') ? (0, $epqOj.default).issuesIssueTerminologyRefreshM4 : (0, $epqOj.default).issues))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
                id: "jira.software.releases.version.detail.issue-total-count",
                packageName: "jira-software-releases-version-detail-issue-list",
                teamName: "jolt"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gxYtR.IssueTotalCount), {
                jiraVersion: data
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7ZUH2.CollapsibleToggleButton), {
                isCollapsed: isCollapsed
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2248552b80f5b0f2$var$HeaderRightWrapper, null, data.canAddAndRemoveIssues === true && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2248552b80f5b0f2$var$AddIssueWrapper, {
                key: "addIssuesButton"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jISVN.AddIssuesToVersion), {
                appearance: "subtle",
                isIssueListFooterButton: true,
                jiraVersion: data,
                showIcon: true,
                showLabel: false
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3nAD0.IssuesMoreButton), {
                key: "issuesMoreButton",
                jiraVersion: data,
                jiraIssueEdges: data.issuesForList.edges.filter(Boolean)
            }))),
        renderBody: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $croBS.ListOptions), {
                jiraVersion: data
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
                name: "issues-refetchable",
                fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cLHPd.IssueListSkeleton), {
                    rowCount: 10,
                    marginTop: 16
                })
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2248552b80f5b0f2$var$IssuesRefetchable, {
                jiraVersion: data
            })))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9RVdp.ViewVersionDetailsPageExperienceSuccessTracker), null));
};
const $2248552b80f5b0f2$export$d97e9356033839cd = ({ jiraVersion: jiraVersion })=>{
    const jiraVersionData = (0, $j4oe4.useFragment)((0, $AGxK4.default), jiraVersion);
    const onExperienceFail = (0, $9RVdp.useViewVersionDetailsPageExperienceFail)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        fallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2rI45.ErrorView), null),
        id: "jira.software.releases.version.detail.issue.list",
        packageName: "jira-software-releases-version-detail-issue-list",
        teamName: "jolt",
        onError: (location, error)=>{
            // We consider the experience to have failed if the issues don't render.
            onExperienceFail(location, error);
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2248552b80f5b0f2$var$IssueListWithHeader, {
        jiraVersion: jiraVersionData
    }));
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2248552b80f5b0f2$var$LoadingMoreContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1bsb1osq _1tke7vkz",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2248552b80f5b0f2$var$AddIssueWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_4t3izwfg _1bsbzwfg",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2248552b80f5b0f2$var$HeaderCollapsibleWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _1bah1yb4 _4cvr1h6o _19pk1jfw _otyr1b66",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2248552b80f5b0f2$var$HeaderLeftWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1h6o _80omtlke",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2248552b80f5b0f2$var$HeaderRightWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $2248552b80f5b0f2$var$sectionTitleStyles = (0, $1DXK0.xcss)({
    marginRight: 'space.100'
});

});
parcelRegister("AGxK4", function(module, exports) {
$parcel$export(module.exports, "default", () => $57a9b2bf677da95b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3899b8733ba6e7fa9ae649f9b64eb5ae>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $57a9b2bf677da95b$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "ui_softwareReleasesVersionDetailIssueList_IssueListWithHeaderWithErrorBoundary_jiraVersion",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "ui_softwareReleasesVersionDetailIssueList_IssueListWithHeader_jiraVersion"
        }
    ],
    "type": "JiraVersion"
};
$57a9b2bf677da95b$var$node.hash = "dcffc936c288beebfd459b5bcb75d18a";
var $57a9b2bf677da95b$export$2e2bcd8739ae039 = $57a9b2bf677da95b$var$node;

});

parcelRegister("8RKZD", function(module, exports) {
$parcel$export(module.exports, "default", () => $20c04a19cb62a0cd$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<fc8305fdf5209e2adc6247847e2cf39d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $20c04a19cb62a0cd$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "after"
        },
        {
            "kind": "RootArgument",
            "name": "filters"
        },
        {
            "defaultValue": 20,
            "kind": "LocalArgument",
            "name": "first"
        },
        {
            "kind": "RootArgument",
            "name": "sortBy"
        }
    ],
    "kind": "Fragment",
    "metadata": {
        "connection": [
            {
                "count": "first",
                "cursor": "after",
                "direction": "forward",
                "path": [
                    "issuesForList"
                ]
            }
        ]
    },
    "name": "ui_softwareReleasesVersionDetailIssueList_IssueListWithHeader_jiraVersion",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "ui_softwareReleasesVersionDetailIssueList_IssuesRefetchable_jiraVersion"
        },
        {
            "kind": "FragmentSpread",
            "name": "listOptions_softwareReleasesVersionDetailIssueList"
        },
        {
            "kind": "FragmentSpread",
            "name": "issuesMoreButton_softwareReleasesVersionDetailIssueList_jiraVersion"
        },
        {
            "kind": "FragmentSpread",
            "name": "issueTotalCount_softwareReleasesVersionDetailIssueList"
        },
        {
            "kind": "FragmentSpread",
            "name": "ui_softwareReleasesCollapsibleUiToggle_CollapsibleSection"
        },
        {
            "kind": "FragmentSpread",
            "name": "ui_softwareReleasesAddIssuesToVersion_AddIssuesToVersion"
        },
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "canAddAndRemoveIssues"
        },
        {
            "kind": "RequiredField",
            "field": {
                "alias": "issuesForList",
                "args": [
                    {
                        "kind": "Literal",
                        "name": "filter",
                        "value": "ALL"
                    },
                    {
                        "kind": "Variable",
                        "name": "filters",
                        "variableName": "filters"
                    },
                    {
                        "kind": "Variable",
                        "name": "sortBy",
                        "variableName": "sortBy"
                    }
                ],
                "concreteType": "JiraIssueConnection",
                "kind": "LinkedField",
                "name": "__ListVersion_issuesForList_connection",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "totalCount"
                    },
                    {
                        "kind": "RequiredField",
                        "field": {
                            "concreteType": "JiraIssueEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": "issues_softwareReleasesVersionDetailIssueList_jiraIssueEdgesReference"
                                },
                                {
                                    "kind": "FragmentSpread",
                                    "name": "issuesMoreButton_softwareReleasesVersionDetailIssueList_jiraIssueEdges"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "cursor"
                                },
                                {
                                    "concreteType": "JiraIssue",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        }
                                    ]
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "issuesForList.edges"
                    },
                    {
                        "concreteType": "PageInfo",
                        "kind": "LinkedField",
                        "name": "pageInfo",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "endCursor"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "hasNextPage"
                            }
                        ]
                    }
                ]
            },
            "action": "THROW",
            "path": "issuesForList"
        }
    ],
    "type": "JiraVersion"
};
$20c04a19cb62a0cd$var$node.hash = "1b95186d8ae0c639ac2a3313467b4212";
var $20c04a19cb62a0cd$export$2e2bcd8739ae039 = $20c04a19cb62a0cd$var$node;

});

parcelRegister("1jLhk", function(module, exports) {
$parcel$export(module.exports, "default", () => $b5a45ecb0156438a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<afe953a9bd8335f4d97d24c69a64880b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck

var $cnGJC = parcelRequire("cnGJC");
const $b5a45ecb0156438a$var$node = function() {
    var v0 = [
        "issuesForList"
    ];
    return {
        "argumentDefinitions": [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "after"
            },
            {
                "kind": "RootArgument",
                "name": "filters"
            },
            {
                "defaultValue": 20,
                "kind": "LocalArgument",
                "name": "first"
            },
            {
                "kind": "RootArgument",
                "name": "isDevopsFeatureDisabledInFedRamp"
            },
            {
                "kind": "RootArgument",
                "name": "shouldIncludeDevOpsFieldsViaAgs"
            },
            {
                "kind": "RootArgument",
                "name": "sortBy"
            }
        ],
        "kind": "Fragment",
        "metadata": {
            "connection": [
                {
                    "count": "first",
                    "cursor": "after",
                    "direction": "forward",
                    "path": v0 /*: any*/ 
                }
            ],
            "refetch": {
                "connection": {
                    "forward": {
                        "count": "first",
                        "cursor": "after"
                    },
                    "backward": null,
                    "path": v0 /*: any*/ 
                },
                "fragmentPathInResult": [
                    "node"
                ],
                "operation": (0, $cnGJC.default),
                "identifierInfo": {
                    "identifierField": "id",
                    "identifierQueryVariableName": "id"
                }
            }
        },
        "name": "ui_softwareReleasesVersionDetailIssueList_IssuesRefetchable_jiraVersion",
        "selections": [
            {
                "kind": "FragmentSpread",
                "name": "issues_softwareReleasesVersionDetailIssueList_jiraVersion"
            },
            {
                "kind": "FragmentSpread",
                "name": "issues_softwareReleasesVersionDetailIssueList_jiraVersionRefetch"
            },
            {
                "kind": "FragmentSpread",
                "name": "emptyView_softwareReleasesVersionDetailIssueList"
            },
            {
                "kind": "FragmentSpread",
                "name": "screenAnalytics_softwareReleasesVersionDetailIssueList_IssueListScreenAnalytics_jiraVersionReference"
            },
            {
                "kind": "ScalarField",
                "name": "id"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "alias": "issuesForList",
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "filter",
                            "value": "ALL"
                        },
                        {
                            "kind": "Variable",
                            "name": "filters",
                            "variableName": "filters"
                        },
                        {
                            "kind": "Variable",
                            "name": "sortBy",
                            "variableName": "sortBy"
                        }
                    ],
                    "concreteType": "JiraIssueConnection",
                    "kind": "LinkedField",
                    "name": "__ListVersion_issuesForList_connection",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "totalCount"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "jql"
                        },
                        {
                            "kind": "RequiredField",
                            "field": {
                                "concreteType": "JiraIssueEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "kind": "FragmentSpread",
                                        "name": "issues_softwareReleasesVersionDetailIssueList_jiraIssueEdgesReference"
                                    },
                                    {
                                        "kind": "FragmentSpread",
                                        "name": "issuesMoreButton_softwareReleasesVersionDetailIssueList_jiraIssueEdges"
                                    },
                                    {
                                        "kind": "FragmentSpread",
                                        "name": "screenAnalytics_softwareReleasesVersionDetailIssueList_IssueListScreenAnalytics_jiraIssueEdgesReference"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "cursor"
                                    },
                                    {
                                        "concreteType": "JiraIssue",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "__typename"
                                            }
                                        ]
                                    }
                                ]
                            },
                            "action": "THROW",
                            "path": "issuesForList.edges"
                        },
                        {
                            "concreteType": "PageInfo",
                            "kind": "LinkedField",
                            "name": "pageInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "endCursor"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "hasNextPage"
                                }
                            ]
                        }
                    ]
                },
                "action": "THROW",
                "path": "issuesForList"
            }
        ],
        "type": "JiraVersion"
    };
}();
$b5a45ecb0156438a$var$node.hash = "1a52a23b324242e6dd47774f54758481";
var $b5a45ecb0156438a$export$2e2bcd8739ae039 = $b5a45ecb0156438a$var$node;

});
parcelRegister("cnGJC", function(module, exports) {
$parcel$export(module.exports, "default", () => $01e37dcbb2e9fa59$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b8e5e6c4861be36ba1ebe02a7ca72dd8>>
 * @relayHash 926652cbe6aafd3eddbe8535aad42e17
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 63750ab0a2250525c5ca610965a5619cc87f7f724597c54e44da6e307b787ac6
const $01e37dcbb2e9fa59$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filters"
    }, v2 = {
        "defaultValue": 20,
        "kind": "LocalArgument",
        "name": "first"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "id"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isDevopsFeatureDisabledInFedRamp"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldIncludeDevOpsFieldsViaAgs"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "sortBy"
    }, v7 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "id"
        }
    ], v8 = {
        "kind": "Variable",
        "name": "after",
        "variableName": "after"
    }, v9 = {
        "kind": "Variable",
        "name": "first",
        "variableName": "first"
    }, v10 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v11 = {
        "kind": "ScalarField",
        "name": "id"
    }, v12 = {
        "kind": "ScalarField",
        "name": "key"
    }, v13 = {
        "kind": "ScalarField",
        "name": "name"
    }, v14 = [
        v8 /*: any*/ ,
        {
            "kind": "Literal",
            "name": "filter",
            "value": "ALL"
        },
        {
            "kind": "Variable",
            "name": "filters",
            "variableName": "filters"
        },
        v9 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "sortBy",
            "variableName": "sortBy"
        }
    ], v15 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v16 = {
        "kind": "ScalarField",
        "name": "count"
    }, v17 = {
        "kind": "ScalarField",
        "name": "state"
    }, v18 = {
        "concreteType": "DevOpsSummarisedBuildState",
        "kind": "LinkedField",
        "name": "buildStates",
        "plural": true,
        "selections": [
            v17 /*: any*/ ,
            v16 /*: any*/ 
        ]
    }, v19 = [
        v16 /*: any*/ 
    ], v20 = [
        v16 /*: any*/ ,
        v11 /*: any*/ 
    ], v21 = {
        "concreteType": "DevOpsSummarisedDeployments",
        "kind": "LinkedField",
        "name": "summarisedDeployments",
        "plural": false,
        "selections": v20 /*: any*/ 
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "verionDetailsIssueListQuery",
            "selections": [
                {
                    "args": v7 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                v8 /*: any*/ ,
                                v9 /*: any*/ 
                            ],
                            "kind": "FragmentSpread",
                            "name": "ui_softwareReleasesVersionDetailIssueList_IssuesRefetchable_jiraVersion"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "verionDetailsIssueListQuery",
            "selections": [
                {
                    "args": v7 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v10 /*: any*/ ,
                        v11 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "concreteType": "JiraVersionWarningConfig",
                                    "kind": "LinkedField",
                                    "name": "warningConfig",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "openPullRequest"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "openReview"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "unreviewedCode"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "failingBuild"
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canViewDevTools"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "versionIssueTableHiddenColumns"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canAddAndRemoveIssues"
                                },
                                {
                                    "concreteType": "JiraProject",
                                    "kind": "LinkedField",
                                    "name": "project",
                                    "plural": false,
                                    "selections": [
                                        v11 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "projectId"
                                        },
                                        v12 /*: any*/ 
                                    ]
                                },
                                v13 /*: any*/ ,
                                {
                                    "alias": "issuesForList",
                                    "args": v14 /*: any*/ ,
                                    "concreteType": "JiraIssueConnection",
                                    "kind": "LinkedField",
                                    "name": "issues",
                                    "plural": false,
                                    "selections": [
                                        v15 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "jql"
                                        },
                                        {
                                            "concreteType": "JiraIssueEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssue",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v12 /*: any*/ ,
                                                        v11 /*: any*/ ,
                                                        {
                                                            "args": [
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "ids",
                                                                    "value": [
                                                                        "priority",
                                                                        "summary",
                                                                        "assignee",
                                                                        "status",
                                                                        "issuetype"
                                                                    ]
                                                                }
                                                            ],
                                                            "concreteType": "JiraIssueFieldConnection",
                                                            "kind": "LinkedField",
                                                            "name": "fieldsById",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v10 /*: any*/ ,
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "fieldId"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraStatus",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "status",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraStatusCategory",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "statusCategory",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "statusCategoryId"
                                                                                                        },
                                                                                                        v11 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                v11 /*: any*/ ,
                                                                                                v13 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "description"
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraStatusField"
                                                                                },
                                                                                v11 /*: any*/ ,
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "user",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v10 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "picture"
                                                                                                },
                                                                                                v13 /*: any*/ ,
                                                                                                v11 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraSingleSelectUserPickerField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "text"
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraSingleLineTextField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraIssueType",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "issueType",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v13 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraAvatar",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "avatar",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "xsmall"
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v11 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraIssueTypeField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraPriority",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "priority",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v13 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "iconUrl"
                                                                                                },
                                                                                                v11 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraPriorityField"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "storageKey": "fieldsById(ids:[\"priority\",\"summary\",\"assignee\",\"status\",\"issuetype\"])"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "issueId"
                                                        },
                                                        {
                                                            "concreteType": "DevOpsSummarisedFeatureFlags",
                                                            "kind": "LinkedField",
                                                            "name": "summarisedFeatureFlags",
                                                            "plural": false,
                                                            "selections": [
                                                                v15 /*: any*/ 
                                                            ]
                                                        },
                                                        v10 /*: any*/ ,
                                                        {
                                                            "condition": "isDevopsFeatureDisabledInFedRamp",
                                                            "kind": "Condition",
                                                            "passingValue": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "DevOpsSummarisedEntities",
                                                                    "kind": "LinkedField",
                                                                    "name": "devOpsSummarisedEntities",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "DevOpsSummarisedDeployments",
                                                                            "kind": "LinkedField",
                                                                            "name": "summarisedDeployments",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v16 /*: any*/ ,
                                                                                v11 /*: any*/ ,
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "deploymentState"
                                                                                },
                                                                                {
                                                                                    "concreteType": "DevOpsEnvironment",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "deploymentEnvironment",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "category"
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "concreteType": "DevOpsSummarisedBuilds",
                                                                            "kind": "LinkedField",
                                                                            "name": "summarisedBuilds",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v16 /*: any*/ ,
                                                                                v11 /*: any*/ ,
                                                                                v18 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "JiraIssueDevSummaryResult",
                                                                    "kind": "LinkedField",
                                                                    "name": "devSummaryCache",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueDevSummary",
                                                                            "kind": "LinkedField",
                                                                            "name": "devSummary",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssuePullRequestDevSummaryContainer",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "pullrequest",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraIssuePullRequestDevSummary",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "overall",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v16 /*: any*/ ,
                                                                                                v17 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "concreteType": "JiraIssueBranchDevSummaryContainer",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "branch",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraIssueBranchDevSummary",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "overall",
                                                                                            "plural": false,
                                                                                            "selections": v19 /*: any*/ 
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "concreteType": "JiraIssueReviewDevSummaryContainer",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "review",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraIssueReviewDevSummary",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "overall",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v16 /*: any*/ ,
                                                                                                v17 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "lastUpdated"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "stateCount"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "concreteType": "JiraIssueDevSummaryByProvider",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "summaryByProvider",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "providerId"
                                                                                                },
                                                                                                v13 /*: any*/ ,
                                                                                                v16 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "concreteType": "JiraIssueCommitDevSummaryContainer",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "commit",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraIssueCommitDevSummary",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "overall",
                                                                                            "plural": false,
                                                                                            "selections": v19 /*: any*/ 
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "concreteType": "JiraIssueBuildDevSummaryContainer",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "build",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraIssueBuildDevSummary",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "overall",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v16 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "failedBuildCount"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "successfulBuildCount"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "unknownBuildCount"
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "concreteType": "JiraIssueDeploymentEnvironmentDevSummaryContainer",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "deploymentEnvironments",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraIssueDeploymentEnvironmentDevSummary",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "overall",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssueDeploymentEnvironment",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "topEnvironments",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "status"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "title"
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "DevOpsSummarisedFeatureFlags",
                                                                    "kind": "LinkedField",
                                                                    "name": "summarisedFeatureFlags",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "mostRelevantDisplayName"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "mostRelevantEnabled"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "mostRelevantRolloutPercentage"
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "condition": "shouldIncludeDevOpsFieldsViaAgs",
                                                                    "kind": "Condition",
                                                                    "passingValue": true,
                                                                    "selections": [
                                                                        v21 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "DevOpsSummarisedBuilds",
                                                                            "kind": "LinkedField",
                                                                            "name": "summarisedBuilds",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v18 /*: any*/ ,
                                                                                v16 /*: any*/ ,
                                                                                v11 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "condition": "shouldIncludeDevOpsFieldsViaAgs",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": [
                                                                v21 /*: any*/ ,
                                                                {
                                                                    "concreteType": "DevOpsSummarisedBuilds",
                                                                    "kind": "LinkedField",
                                                                    "name": "summarisedBuilds",
                                                                    "plural": false,
                                                                    "selections": v20 /*: any*/ 
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "cursor"
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "PageInfo",
                                            "kind": "LinkedField",
                                            "name": "pageInfo",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "endCursor"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasNextPage"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "alias": "issuesForList",
                                    "args": v14 /*: any*/ ,
                                    "filters": [
                                        "filter",
                                        "sortBy",
                                        "filters"
                                    ],
                                    "handle": "connection",
                                    "key": "ListVersion_issuesForList",
                                    "kind": "LinkedHandle",
                                    "name": "issues"
                                },
                                {
                                    "condition": "isDevopsFeatureDisabledInFedRamp",
                                    "kind": "Condition",
                                    "passingValue": false,
                                    "selections": [
                                        {
                                            "concreteType": "DevOpsSummarisedEntities",
                                            "kind": "LinkedField",
                                            "name": "devOpsSummarisedEntities",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "DevOpsProviders",
                                                    "kind": "LinkedField",
                                                    "name": "providers",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "DevOpsFeatureFlagProvider",
                                                            "kind": "LinkedField",
                                                            "name": "featureFlagProviders",
                                                            "plural": true,
                                                            "selections": [
                                                                v10 /*: any*/ ,
                                                                v11 /*: any*/ ,
                                                                v13 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "createFeatureFlagTemplateUrl"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "connectFeatureFlagTemplateUrl"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "logoUrl"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ],
                            "type": "JiraVersion"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "63750ab0a2250525c5ca610965a5619cc87f7f724597c54e44da6e307b787ac6",
            "metadata": {},
            "name": "verionDetailsIssueListQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$01e37dcbb2e9fa59$var$node.hash = "1a52a23b324242e6dd47774f54758481";
var $01e37dcbb2e9fa59$export$2e2bcd8739ae039 = $01e37dcbb2e9fa59$var$node;

});


parcelRegister("fi8WO", function(module, exports) {
$parcel$export(module.exports, "DevDetailsDialogLoaderAsync", () => $64dfbf748663c639$export$f5ffc0f323543e16);

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $2imLM = parcelRequire("2imLM");

var $bQWwW = parcelRequire("bQWwW");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $64dfbf748663c639$var$DevDetailDialogLoaderWithContainer = (0, $bQWwW.lazy)(()=>(parcelRequire("c1PiR")), {
    ssr: false,
    moduleId: "./src/packages/development/details-loader/src/ui/index-old.tsx"
});
const $64dfbf748663c639$export$f5ffc0f323543e16 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "dev-detail-dialog-loader-with-container",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($64dfbf748663c639$var$DevDetailDialogLoaderWithContainer, props));
$64dfbf748663c639$export$f5ffc0f323543e16.defaultProps = {
    onCloseDevDetailDialog: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
};
var /**
 * @deprecated - Use the DevDetailsDialogLoader (sync) component instead (in /index.tsx).
 */ $64dfbf748663c639$export$2e2bcd8739ae039 = $64dfbf748663c639$export$f5ffc0f323543e16;

});
parcelRegister("c1PiR", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("7D0ce").then(()=>parcelRequire('69I1h'));

});


parcelRegister("7ZUH2", function(module, exports) {
$parcel$export(module.exports, "CollapsibleToggleButton", () => $f4f76c3524151cbe$export$9438d677ba26a40a);
$parcel$export(module.exports, "CollapsibleSection", () => $f4f76c3524151cbe$export$55b973e094275b13);

var $3HujP = parcelRequire("3HujP");

var $boXtt = parcelRequire("boXtt");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $j4oe4 = parcelRequire("j4oe4");

var $1OQKp = parcelRequire("1OQKp");

var $cQxBL = parcelRequire("cQxBL");

var $goZPP = parcelRequire("goZPP");

var $9pTd3 = parcelRequire("9pTd3");

var $lRq8t = parcelRequire("lRq8t");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $2SGz8 = parcelRequire("2SGz8");

var $7sboX = parcelRequire("7sboX");
const $f4f76c3524151cbe$var$getNewCollapsedUis = (currentState, type, isCurrentlyCollapsed)=>isCurrentlyCollapsed ? currentState.filter((value)=>value !== type) : [
        ...currentState,
        type
    ];
const $f4f76c3524151cbe$export$9438d677ba26a40a = ({ isCollapsed: isCollapsed, onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const icon = isCollapsed ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cQxBL))), {
        spacing: "spacious",
        label: formatMessage((0, $2SGz8.default).collapsedIconLabel),
        size: "small"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1OQKp))), {
        spacing: "spacious",
        label: formatMessage((0, $2SGz8.default).expandedIconLabel),
        size: "small"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        appearance: "subtle",
        iconBefore: icon,
        onClick: onClick
    });
};
const $f4f76c3524151cbe$export$55b973e094275b13 = ({ jiraVersion: jiraVersion, uiType: uiType, renderHeader: renderHeader, renderBody: renderBody })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const version = (0, $j4oe4.useFragment)((0, $boXtt.default), jiraVersion);
    const collapsedUis = (version.collapsedUis ?? []).filter(Boolean);
    const [updateCollapsedUis] = // eslint-disable-next-line jira/graphql/restrict-graphql-in-unnamed-files
    (0, $j4oe4.useMutation)((0, $3HujP.default));
    const onError = ()=>{
        (0, $9pTd3.fireErrorAnalytics)({
            meta: {
                id: 'jira.releases.version.detail.collapsed-uis.user-preference.mutation.error.id',
                packageName: 'jiraSoftwareReleasesCollapsibleUiToggle',
                teamName: 'jolt'
            },
            error: Error('Unable to update collapsed ui state'),
            sendToPrivacyUnsafeSplunk: true
        });
    };
    const saveUserPreference = (newCollapsedUis)=>{
        updateCollapsedUis({
            variables: {
                input: {
                    collapsedUis: newCollapsedUis,
                    versionId: version.id
                }
            },
            onCompleted: (data)=>{
                if (!data.jira?.saveVersionDetailsCollapsedUis?.success) onError();
            },
            onError: onError,
            optimisticResponse: {
                jira: {
                    saveVersionDetailsCollapsedUis: {
                        success: true,
                        version: {
                            collapsedUis: newCollapsedUis,
                            id: version.id
                        }
                    }
                }
            }
        });
    };
    const isCollapsed = collapsedUis.includes(uiType);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, renderHeader(isCollapsed, ()=>{
        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({
            action: 'toggled',
            actionSubject: 'collapsedUiToggleButon'
        }), 'versionDetailsCollapsedUis', {
            uiType: uiType,
            action: isCollapsed ? 'expand' : 'collapse'
        });
        saveUserPreference($f4f76c3524151cbe$var$getNewCollapsedUis(collapsedUis, uiType, isCollapsed));
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f4f76c3524151cbe$var$CollapsibleContent, {
        isCollapsed: (0, $7sboX.checkIsCollapsed)(version.collapsedUis, uiType)
    }, renderBody()));
};
const $f4f76c3524151cbe$var$CollapsibleContent = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isCollapsed: isCollapsed, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "",
            __cmplp.isCollapsed ? "_1e0cglyw" : "_1e0c1ule",
            __cmplp.isCollapsed ? "_otyr1jfw" : "_otyrze3t",
            __cmplp.className
        ])
    });
});

});
parcelRegister("3HujP", function(module, exports) {
$parcel$export(module.exports, "default", () => $84ad34d6c7b55c9d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<91eb2a3d04e52917a45ca405de73e8cd>>
 * @relayHash 0d7cc146aa12b13eaa5a11bd667fa49c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 59da25bc507c60457c7c0a7f80672b6888c11c77e2bed2a33db2c0d2dcd80db9
const $84ad34d6c7b55c9d$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "kind": "ScalarField",
        "name": "collapsedUis"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ui_collapsibleUiTriggerButton_updateCollapsedUisMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraVersionDetailsCollapsedUisPayload",
                            "kind": "LinkedField",
                            "name": "saveVersionDetailsCollapsedUis",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "concreteType": "JiraVersion",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ui_collapsibleUiTriggerButton_updateCollapsedUisMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraVersionDetailsCollapsedUisPayload",
                            "kind": "LinkedField",
                            "name": "saveVersionDetailsCollapsedUis",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "concreteType": "JiraVersion",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "59da25bc507c60457c7c0a7f80672b6888c11c77e2bed2a33db2c0d2dcd80db9",
            "metadata": {},
            "name": "ui_collapsibleUiTriggerButton_updateCollapsedUisMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$84ad34d6c7b55c9d$var$node.hash = "784b6375f621589ebabb1f85323c82aa";
var $84ad34d6c7b55c9d$export$2e2bcd8739ae039 = $84ad34d6c7b55c9d$var$node;

});

parcelRegister("boXtt", function(module, exports) {
$parcel$export(module.exports, "default", () => $110154130d6db5f8$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c85bb8d4319589d7107ce65db6b00c60>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $110154130d6db5f8$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "ui_softwareReleasesCollapsibleUiToggle_CollapsibleSection",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "collapsedUis"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "id"
            },
            "action": "THROW",
            "path": "id"
        }
    ],
    "type": "JiraVersion"
};
$110154130d6db5f8$var$node.hash = "4c7960151ff25f69412e79192a278d0e";
var $110154130d6db5f8$export$2e2bcd8739ae039 = $110154130d6db5f8$var$node;

});

parcelRegister("2SGz8", function(module, exports) {
$parcel$export(module.exports, "default", () => $41c71df3b3af9a35$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $41c71df3b3af9a35$var$messages = (0, $7qGN1.defineMessages)({
    collapsedIconLabel: {
        "id": "software-releases-collapsible-ui-toggle.collapsed-icon-label",
        "defaultMessage": "Click/enter to expand the section"
    },
    expandedIconLabel: {
        "id": "software-releases-collapsible-ui-toggle.expanded-icon-label",
        "defaultMessage": "Click/enter to collapse the section"
    }
});
var $41c71df3b3af9a35$export$2e2bcd8739ae039 = $41c71df3b3af9a35$var$messages;

});

parcelRegister("7sboX", function(module, exports) {
$parcel$export(module.exports, "checkIsCollapsed", () => $5ca37b9b7a835c06$export$b5bb70308851c0e1);
const $5ca37b9b7a835c06$export$b5bb70308851c0e1 = (collapsedUis, type)=>(collapsedUis ?? []).includes(type);

});


parcelRegister("amEKX", function(module, exports) {
$parcel$export(module.exports, "useFilterSortingQueryParams", () => $24d5be23dd25a870$export$c59d013998b3679d);

var $jx0Vw = parcelRequire("jx0Vw");

var $9TL1j = parcelRequire("9TL1j");


var $fnAle = parcelRequire("fnAle");
const $24d5be23dd25a870$var$joinValuesIfNotEmpty = (values)=>values.length ? values.join(',') : undefined;
const $24d5be23dd25a870$export$c59d013998b3679d = ()=>{
    const [queryParams, setQueryParams] = (0, $9TL1j.useQueryParams)((0, $3b2c8cea68e59ddc$export$e39925d10cebc0b), (0, $3b2c8cea68e59ddc$export$b98a7875ddbefaac), (0, $3b2c8cea68e59ddc$export$c307007520232013), (0, $3b2c8cea68e59ddc$export$2552faed9df6a2cd), (0, $3b2c8cea68e59ddc$export$f78d8c81fcad32a2), (0, $3b2c8cea68e59ddc$export$13d5b2891ca65cd6), (0, $3b2c8cea68e59ddc$export$810a1f7ed2facfcb));
    const parsedQueryParams = (0, $fnAle.parseQueryParams)(queryParams);
    return {
        parsedQueryParams: parsedQueryParams,
        isAnyFilterApplied: (0, $fnAle.isAnyFilterApplied)(parsedQueryParams),
        setTextFilterParam: (searchStr)=>setQueryParams({
                [(0, $3b2c8cea68e59ddc$export$e39925d10cebc0b)]: searchStr === '' || searchStr == null ? undefined : searchStr
            }),
        setEpicFilterParam: (issueIds)=>setQueryParams({
                [(0, $3b2c8cea68e59ddc$export$b98a7875ddbefaac)]: $24d5be23dd25a870$var$joinValuesIfNotEmpty(issueIds)
            }),
        setStatusCategoryFilterParam: (statusCategories)=>setQueryParams({
                [(0, $3b2c8cea68e59ddc$export$c307007520232013)]: $24d5be23dd25a870$var$joinValuesIfNotEmpty(statusCategories.map((0, $jx0Vw.statusCategoryForId)))
            }),
        setWarningsFilterParam: (warnings)=>setQueryParams({
                [(0, $3b2c8cea68e59ddc$export$2552faed9df6a2cd)]: $24d5be23dd25a870$var$joinValuesIfNotEmpty(warnings)
            }),
        setAssigneeFilterParam: (assignees)=>setQueryParams({
                [(0, $3b2c8cea68e59ddc$export$f78d8c81fcad32a2)]: $24d5be23dd25a870$var$joinValuesIfNotEmpty(assignees)
            }),
        setSortByParam: (sortBy)=>setQueryParams({
                [(0, $3b2c8cea68e59ddc$export$13d5b2891ca65cd6)]: sortBy
            }),
        setSortOrderParam: (sortOrder)=>setQueryParams({
                [(0, $3b2c8cea68e59ddc$export$810a1f7ed2facfcb)]: sortOrder
            }),
        clearAll: ()=>{
            setQueryParams({
                [(0, $3b2c8cea68e59ddc$export$e39925d10cebc0b)]: undefined,
                [(0, $3b2c8cea68e59ddc$export$b98a7875ddbefaac)]: undefined,
                [(0, $3b2c8cea68e59ddc$export$c307007520232013)]: undefined,
                [(0, $3b2c8cea68e59ddc$export$2552faed9df6a2cd)]: undefined,
                [(0, $3b2c8cea68e59ddc$export$f78d8c81fcad32a2)]: undefined,
                [(0, $3b2c8cea68e59ddc$export$13d5b2891ca65cd6)]: undefined,
                [(0, $3b2c8cea68e59ddc$export$810a1f7ed2facfcb)]: undefined
            });
        },
        showIssuesWithWarnings: (warnings)=>{
            setQueryParams({
                [(0, $3b2c8cea68e59ddc$export$e39925d10cebc0b)]: undefined,
                [(0, $3b2c8cea68e59ddc$export$b98a7875ddbefaac)]: undefined,
                [(0, $3b2c8cea68e59ddc$export$c307007520232013)]: undefined,
                [(0, $3b2c8cea68e59ddc$export$2552faed9df6a2cd)]: $24d5be23dd25a870$var$joinValuesIfNotEmpty(warnings),
                [(0, $3b2c8cea68e59ddc$export$f78d8c81fcad32a2)]: undefined,
                [(0, $3b2c8cea68e59ddc$export$13d5b2891ca65cd6)]: undefined,
                [(0, $3b2c8cea68e59ddc$export$810a1f7ed2facfcb)]: undefined
            });
        },
        showStatusCategoryIssues: (statusCategories)=>{
            setQueryParams({
                [(0, $3b2c8cea68e59ddc$export$e39925d10cebc0b)]: undefined,
                [(0, $3b2c8cea68e59ddc$export$b98a7875ddbefaac)]: undefined,
                [(0, $3b2c8cea68e59ddc$export$c307007520232013)]: $24d5be23dd25a870$var$joinValuesIfNotEmpty(statusCategories.map((0, $jx0Vw.statusCategoryForId))),
                [(0, $3b2c8cea68e59ddc$export$2552faed9df6a2cd)]: undefined,
                [(0, $3b2c8cea68e59ddc$export$f78d8c81fcad32a2)]: undefined,
                [(0, $3b2c8cea68e59ddc$export$13d5b2891ca65cd6)]: undefined,
                [(0, $3b2c8cea68e59ddc$export$810a1f7ed2facfcb)]: undefined
            });
        }
    };
};
const $24d5be23dd25a870$export$22b92ff6db8f144a = ()=>{
    const { parsedQueryParams: parsedQueryParams } = $24d5be23dd25a870$export$c59d013998b3679d();
    return {
        sortByField: parsedQueryParams[0, $3b2c8cea68e59ddc$export$13d5b2891ca65cd6] ?? 'CREATED',
        sortOrder: parsedQueryParams[0, $3b2c8cea68e59ddc$export$810a1f7ed2facfcb] ?? 'ASC'
    };
};

});
const $3b2c8cea68e59ddc$export$e39925d10cebc0b = 'text';
const $3b2c8cea68e59ddc$export$b98a7875ddbefaac = 'epics';
const $3b2c8cea68e59ddc$export$c307007520232013 = 'statusCategory';
const $3b2c8cea68e59ddc$export$2552faed9df6a2cd = 'warnings';
const $3b2c8cea68e59ddc$export$f78d8c81fcad32a2 = 'assignee';
const $3b2c8cea68e59ddc$export$13d5b2891ca65cd6 = 'sortBy';
const $3b2c8cea68e59ddc$export$810a1f7ed2facfcb = 'sortOrder';


parcelRegister("9VxZ2", function(module, exports) {
$parcel$export(module.exports, "useDeepMemo", () => $9f31c131ac8959b8$export$722debc0e56fea39);

var $eJOHy = parcelRequire("eJOHy");

var $cSmYj = parcelRequire("cSmYj");
const $9f31c131ac8959b8$export$722debc0e56fea39 = (value)=>{
    const ref = (0, $eJOHy.useRef)(value);
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(value, ref.current)) ref.current = value;
    return ref.current;
};

});

parcelRegister("irNJ5", function(module, exports) {
$parcel$export(module.exports, "ErrorBoundary", () => $b0f46b933222ca0a$export$e926676385687eaf);

var $eJOHy = parcelRequire("eJOHy");

var $5vQ2T = parcelRequire("5vQ2T");
const $b0f46b933222ca0a$export$e926676385687eaf = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        fallback: "flag",
        ...props,
        packageName: "jiraSoftwareReleasesVersionDetailIssueList",
        teamName: "jolt"
    });

});

parcelRegister("9RVdp", function(module, exports) {
$parcel$export(module.exports, "useViewVersionDetailsPageExperienceFail", () => $fa58644390f8fac8$export$f9fb921f60393679);
$parcel$export(module.exports, "useViewVersionDetailsPageExperienceSuccess", () => $fa58644390f8fac8$export$1a84e8ad118354e4);
$parcel$export(module.exports, "ViewVersionDetailsPageExperienceSuccessTracker", () => $fa58644390f8fac8$export$ab0e4c71ad46eacd);

var $eJOHy = parcelRequire("eJOHy");

var $aqnJa = parcelRequire("aqnJa");

var $4ctwv = parcelRequire("4ctwv");

var $5fhwJ = parcelRequire("5fhwJ");
const $fa58644390f8fac8$var$VIEW_VERSION_DETAILS_PAGE_EXPERIENCE_NAME = 'viewVersionDetailsPage';
const $fa58644390f8fac8$export$f9fb921f60393679 = ()=>(0, $aqnJa.useExperienceFail)({
        experience: $fa58644390f8fac8$var$VIEW_VERSION_DETAILS_PAGE_EXPERIENCE_NAME
    });
const $fa58644390f8fac8$export$1a84e8ad118354e4 = ()=>(0, $4ctwv.useExperienceSuccess)({
        experience: $fa58644390f8fac8$var$VIEW_VERSION_DETAILS_PAGE_EXPERIENCE_NAME
    });
const $fa58644390f8fac8$export$ab0e4c71ad46eacd = ()=>{
    const projectInfo = (0, $5fhwJ.useProjectAnalyticsAttributes)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4ctwv.ExperienceSuccess), {
        experience: $fa58644390f8fac8$var$VIEW_VERSION_DETAILS_PAGE_EXPERIENCE_NAME,
        attributes: {
            ...projectInfo
        }
    });
};

});
parcelRegister("5fhwJ", function(module, exports) {
$parcel$export(module.exports, "useProjectAnalyticsAttributes", () => $c8cd95eaef85b90c$export$b6a91b2d78273787);

var $6UU7v = parcelRequire("6UU7v");

var $dZRaT = parcelRequire("dZRaT");

var $2QZBX = parcelRequire("2QZBX");

var $eJrcF = parcelRequire("eJrcF");
const $c8cd95eaef85b90c$export$a3138047c831fa4e = (0, $6UU7v.withSuspense)(()=>// eslint-disable-next-line jira/react/no-usage-of-hooks-outside-components
    (0, $eJrcF.useResource)((0, $dZRaT.projectContextResource)));
const $c8cd95eaef85b90c$export$8f31c2503e1efa93 = ()=>{
    const { data: data, error: error } = $c8cd95eaef85b90c$export$a3138047c831fa4e();
    if (data == null) throw new Error(`data of useProjectContext via withSuspense shouldn't be null. If projectContext is null, this means an invalid project key was provided and the page should return a 404 and useProjectContext should never be called. error: ${error !== null ? error.message : 'null'}`);
    return {
        ...data,
        projectKey: (0, $2QZBX.toProjectKey)(data.projectKey),
        projectId: (0, $2QZBX.toProjectId)(data.projectId.toString())
    };
};
const $c8cd95eaef85b90c$export$b6a91b2d78273787 = ()=>{
    const { projectId: projectId, isProjectAdmin: isProjectAdmin, simplified: simplified } = $c8cd95eaef85b90c$export$8f31c2503e1efa93();
    return {
        isSimplified: simplified,
        isProjectAdmin: isProjectAdmin,
        projectId: projectId
    };
};

});


parcelRegister("emj3R", function(module, exports) {
$parcel$export(module.exports, "EmptyView", () => $0ae00d6ea7c232c3$export$f716ac8971c5316e);

var $1yZ0e = parcelRequire("1yZ0e");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $j4oe4 = parcelRequire("j4oe4");

var $goZPP = parcelRequire("goZPP");

var $6MnLl = parcelRequire("6MnLl");

var $4cTDP = parcelRequire("4cTDP");

var $lRq8t = parcelRequire("lRq8t");

var $kRgKj = parcelRequire("kRgKj");

var $jISVN = parcelRequire("jISVN");

var $amEKX = parcelRequire("amEKX");

var $8Vjjc = parcelRequire("8Vjjc");

var $jwuob = parcelRequire("jwuob");

var $zXx6E = parcelRequire("zXx6E");
const $0ae00d6ea7c232c3$export$f716ac8971c5316e = ({ jiraVersion: jiraVersion, isAnyFilterApplied: isAnyFilterApplied, textFilter: textFilter })=>{
    const { clearAll: clearAll } = (0, $amEKX.useFilterSortingQueryParams)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const version = (0, $j4oe4.useFragment)((0, $1yZ0e.default), jiraVersion);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0ae00d6ea7c232c3$var$Container, {
        "data-testid": "software-releases-version-detail-issue-list.ui.empty-view"
    }, isAnyFilterApplied ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6MnLl.default), {
        headingLevel: 2,
        header: textFilter !== null ? formatMessage((0, $zXx6E.default).noIssuesMatchTextFilterHeader, {
            textFilter: textFilter
        }) : formatMessage((0, $4cTDP.fg)('jira-issue-terminology-update-m4') ? (0, $zXx6E.default).noIssuesMatchFilterHeaderIssueTerminologyRefreshM4 : (0, $zXx6E.default).noIssuesMatchFilterHeader),
        description: textFilter !== null ? formatMessage((0, $zXx6E.default).noIssuesMatchTextFilterDescription) : formatMessage((0, $4cTDP.fg)('jira-issue-terminology-update-m4') ? (0, $zXx6E.default).noIssuesMatchFilterDescriptionIssueTerminologyRefreshM4 : (0, $zXx6E.default).noIssuesMatchFilterDescription),
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($jwuob))),
        imageWidth: 64,
        imageHeight: 92,
        primaryAction: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
            appearance: "primary",
            onClick: (_, analyticsEvent)=>{
                clearAll();
                (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'clearFilter');
            }
        }, formatMessage((0, $zXx6E.default).clearFilters))
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6MnLl.default), {
        headingLevel: 2,
        header: formatMessage((0, $zXx6E.default).noIssuesInVersionHeader),
        description: formatMessage((0, $4cTDP.fg)('jira-issue-terminology-update-m4') ? (0, $zXx6E.default).noIssuesInVersionDescriptionIssueTerminologyRefreshM4 : (0, $zXx6E.default).noIssuesInVersionDescription),
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($8Vjjc))),
        imageWidth: 128,
        imageHeight: 104,
        primaryAction: version?.canAddAndRemoveIssues === true ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jISVN.AddIssuesToVersion), {
            appearance: "primary",
            jiraVersion: version
        }) : undefined
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0ae00d6ea7c232c3$var$Container = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_ca0qv47k",
            __cmplp.className
        ])
    });
});

});
parcelRegister("1yZ0e", function(module, exports) {
$parcel$export(module.exports, "default", () => $4cb4e506b9bfe098$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<69fe4b1ae49101ed737d416416098410>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $4cb4e506b9bfe098$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "emptyView_softwareReleasesVersionDetailIssueList",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "canAddAndRemoveIssues"
            },
            "action": "LOG",
            "path": "canAddAndRemoveIssues"
        },
        {
            "kind": "FragmentSpread",
            "name": "ui_softwareReleasesAddIssuesToVersion_AddIssuesToVersion"
        }
    ],
    "type": "JiraVersion"
};
$4cb4e506b9bfe098$var$node.hash = "e747dc1997c64c6a07fe54d01ff7878c";
var $4cb4e506b9bfe098$export$2e2bcd8739ae039 = $4cb4e506b9bfe098$var$node;

});

parcelRegister("8Vjjc", function(module, exports) {
module.exports = new URL("noIssuesInVersion.348ccc3b.svg", import.meta.url).toString();

});

parcelRegister("jwuob", function(module, exports) {
module.exports = new URL("noSearchResults.d74f9061.svg", import.meta.url).toString();

});

parcelRegister("zXx6E", function(module, exports) {
$parcel$export(module.exports, "default", () => $41b8a70921335e66$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $41b8a70921335e66$var$messages = (0, $7qGN1.defineMessages)({
    // No issues in version case.
    noIssuesInVersionHeader: {
        "id": "software-releases-version-detail-issue-list.empty-view.no-issues-in-version-header",
        "defaultMessage": "Nothing to see here"
    },
    noIssuesInVersionDescription: {
        "id": "software-releases-version-detail-issue-list.empty-view.no-issues-in-version-description",
        "defaultMessage": "No issues have been added yet."
    },
    // Non-text filter applied, no matching issues.
    noIssuesMatchFilterHeader: {
        "id": "software-releases-version-detail-issue-list.empty-view.no-issues-match-filter-header",
        "defaultMessage": "No issues here"
    },
    noIssuesMatchFilterDescription: {
        "id": "software-releases-version-detail-issue-list.empty-view.no-issues-match-filter-description",
        "defaultMessage": "We didn't find any issues that match the filters you've chosen"
    },
    // Text filter applied, no matching issues.
    // Note that non-text filters may *also* be applied. These messages cover both cases.
    noIssuesMatchTextFilterHeader: {
        "id": "software-releases-version-detail-issue-list.empty-view.no-issues-match-text-filter-header",
        "defaultMessage": "We didn't find any results for \"{textFilter}\""
    },
    noIssuesMatchTextFilterDescription: {
        "id": "software-releases-version-detail-issue-list.empty-view.no-issues-match-text-filter-description",
        "defaultMessage": "Try changing your search or check any filters."
    },
    clearFilters: {
        "id": "software-releases-version-detail-issue-list.empty-view.clear-filters",
        "defaultMessage": "Clear filters"
    },
    noIssuesInVersionDescriptionIssueTerminologyRefreshM4: {
        "id": "software-releases-version-detail-issue-list.empty-view.no-issues-in-version-description-issue-terminology-refresh-m4",
        "defaultMessage": "No work items have been added yet."
    },
    noIssuesMatchFilterHeaderIssueTerminologyRefreshM4: {
        "id": "software-releases-version-detail-issue-list.empty-view.no-issues-match-filter-header-issue-terminology-refresh-m4",
        "defaultMessage": "No work items here"
    },
    noIssuesMatchFilterDescriptionIssueTerminologyRefreshM4: {
        "id": "software-releases-version-detail-issue-list.empty-view.no-issues-match-filter-description-issue-terminology-refresh-m4",
        "defaultMessage": "We didn't find any work items that match the filters you've chosen"
    }
});
var $41b8a70921335e66$export$2e2bcd8739ae039 = $41b8a70921335e66$var$messages;

});


parcelRegister("2rI45", function(module, exports) {
$parcel$export(module.exports, "ErrorView", () => $55789d5a6654c6a1$export$8c68b6013ae44ca6);
/* ErrorView.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $goZPP = parcelRequire("goZPP");

var $806LH = parcelRequire("806LH");

var $4cTDP = parcelRequire("4cTDP");

var $lRq8t = parcelRequire("lRq8t");

var $1LbfJ = parcelRequire("1LbfJ");

var $3j6Cs = parcelRequire("3j6Cs");
const $55789d5a6654c6a1$export$8c68b6013ae44ca6 = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($55789d5a6654c6a1$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($55789d5a6654c6a1$var$Img, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($1LbfJ))),
        alt: formatMessage((0, $4cTDP.fg)('jira-issue-terminology-update-m4') ? (0, $3j6Cs.default).errorImageAltIssueTerminologyRefreshM4 : (0, $3j6Cs.default).errorImageAlt)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $806LH.default), {
        size: "small"
    }, formatMessage((0, $4cTDP.fg)('jira-issue-terminology-update-m4') ? (0, $3j6Cs.default).failToLoadTitleNonFianlIssueTerminologyRefreshM4 : (0, $3j6Cs.default).failToLoadTitleNonFianl)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($55789d5a6654c6a1$var$ButtonContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        appearance: "link",
        onClick: ()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.location.reload();
        }
    }, formatMessage((0, $3j6Cs.default).refreshButtonLabel))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $55789d5a6654c6a1$var$Container = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_ca0q1epz _1e0c1txw _2lx21bp4 _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $55789d5a6654c6a1$var$Img = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_otyrxy5q",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $55789d5a6654c6a1$var$ButtonContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19pku2gc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("1LbfJ", function(module, exports) {
module.exports = new URL("error.e4b20277.svg", import.meta.url).toString();

});

parcelRegister("3j6Cs", function(module, exports) {
$parcel$export(module.exports, "default", () => $8e0a5c8c08606e0e$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $8e0a5c8c08606e0e$var$messages = (0, $7qGN1.defineMessages)({
    failToLoadTitleNonFianl: {
        "id": "software-releases-version-detail-issue-list.error-view.fail-to-load-title-non-fianl",
        "defaultMessage": "Can't load issues"
    },
    refreshButtonLabel: {
        "id": "software-releases-version-detail-issue-list.error-view.refresh-button-label",
        "defaultMessage": "Refresh page"
    },
    errorImageAlt: {
        "id": "software-releases-version-detail-issue-list.error-view.error-image-alt",
        "defaultMessage": "Image that shows loading issues failed."
    },
    failToLoadTitleNonFianlIssueTerminologyRefreshM4: {
        "id": "software-releases-version-detail-issue-list.error-view.fail-to-load-title-non-fianl-issue-terminology-refresh-m4",
        "defaultMessage": "Can't load work items"
    },
    errorImageAltIssueTerminologyRefreshM4: {
        "id": "software-releases-version-detail-issue-list.error-view.error-image-alt-issue-terminology-refresh-m4",
        "defaultMessage": "Image that shows loading work items failed."
    }
});
var $8e0a5c8c08606e0e$export$2e2bcd8739ae039 = $8e0a5c8c08606e0e$var$messages;

});


parcelRegister("gxYtR", function(module, exports) {
$parcel$export(module.exports, "IssueTotalCount", () => $10dea8fb6a707cf1$export$7866c3f349a6505);

var $jYpjp = parcelRequire("jYpjp");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $j4oe4 = parcelRequire("j4oe4");
const $10dea8fb6a707cf1$export$7866c3f349a6505 = ({ jiraVersion: jiraVersion })=>{
    const data = (0, $j4oe4.useFragment)((0, $jYpjp.default), jiraVersion);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($10dea8fb6a707cf1$var$TotalCountLozenge, null, data.allIssuesRedesignTemp.totalCount);
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $10dea8fb6a707cf1$var$TotalCountLozenge = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_11c81o8v _2rko1mok _bfhkysee _1e0c1txw _1bah1h6o _4cvr1h6o _4t3i7vkz _19pkv77o _u5f31b66 _19bv1b66",
            __cmplp.className
        ])
    });
});

});
parcelRegister("jYpjp", function(module, exports) {
$parcel$export(module.exports, "default", () => $516c2bb87a707612$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<74f5e9e98ceace44d2a9daca4b2abd30>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $516c2bb87a707612$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "issueTotalCount_softwareReleasesVersionDetailIssueList",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "alias": "allIssuesRedesignTemp",
                "concreteType": "JiraIssueConnection",
                "kind": "LinkedField",
                "name": "issues",
                "plural": false,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "kind": "ScalarField",
                            "name": "totalCount"
                        },
                        "action": "THROW",
                        "path": "allIssuesRedesignTemp.totalCount"
                    }
                ]
            },
            "action": "THROW",
            "path": "allIssuesRedesignTemp"
        }
    ],
    "type": "JiraVersion"
};
$516c2bb87a707612$var$node.hash = "aaf1e03a6deba9e0e365569571ef5db3";
var $516c2bb87a707612$export$2e2bcd8739ae039 = $516c2bb87a707612$var$node;

});


parcelRegister("cLHPd", function(module, exports) {
$parcel$export(module.exports, "IssueListSkeleton", () => $915a8076e467f6ae$export$ebd1a9517b9c28aa);
/* IssueListSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");
const $915a8076e467f6ae$var$IssueRowSkeleton = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($915a8076e467f6ae$var$IssueRowSkeletonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($915a8076e467f6ae$var$IssueTypeSkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($915a8076e467f6ae$var$IssueFieldSkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($915a8076e467f6ae$var$IssueSummarySkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($915a8076e467f6ae$var$IssueFieldSkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($915a8076e467f6ae$var$IssueAssigneeSkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($915a8076e467f6ae$var$IssueDevDataSkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($915a8076e467f6ae$var$IssueDevDataSkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($915a8076e467f6ae$var$IssueDevDataSkeleton, null));
const $915a8076e467f6ae$export$ebd1a9517b9c28aa = ({ rowCount: rowCount, marginTop: marginTop })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($915a8076e467f6ae$var$Wrapper, {
        marginTop: marginTop
    }, [
        ...Array(rowCount < 0 ? 10 : rowCount).keys()
    ].map((index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($915a8076e467f6ae$var$IssueRowSkeleton, {
            key: index
        })));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $915a8076e467f6ae$var$Wrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { marginTop: marginTop, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1fj4wta": (0, $awdRS.default)(__cmplp.marginTop, "px")
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "",
            __cmplp.marginTop ? "_19pkmye1" : "_19pkidpf",
            __cmplp.className
        ])
    });
});
const $915a8076e467f6ae$var$skeletonKeyFrames = null;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $915a8076e467f6ae$var$AnimationBaseDiv = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_ju25ru3m _5sagymdr _1o51q7pw _tip812c5 _1pglp3kn _1itk1pxg _12vemgnk _bfhkizff _j7hq1nls",
            __cmplp.className
        ])
    });
});
const $915a8076e467f6ae$var$IssueRowSkeletonWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_4t3ickbl _19bvpxbi _u5f3oahv _1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $915a8076e467f6ae$var$IssueTypeSkeleton = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = $915a8076e467f6ae$var$AnimationBaseDiv, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rkofajl _4t3i7vkz _1bsb7vkz _2hwxu2gc",
            __cmplp.className
        ])
    });
});
const $915a8076e467f6ae$var$IssueFieldSkeleton = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = $915a8076e467f6ae$var$AnimationBaseDiv, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rkofajl _4t3i7vkz _1bsbvbgk _2hwxpxbi",
            __cmplp.className
        ])
    });
});
const $915a8076e467f6ae$var$IssueDevDataSkeleton = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = $915a8076e467f6ae$var$AnimationBaseDiv, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rkofajl _4t3i7vkz _1bsbvbgk _2hwxxy5q",
            __cmplp.className
        ])
    });
});
const $915a8076e467f6ae$var$IssueSummarySkeleton = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = $915a8076e467f6ae$var$AnimationBaseDiv, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rkofajl _4t3i7vkz _2hwx16xz _16jlkb7n",
            __cmplp.className
        ])
    });
});
const $915a8076e467f6ae$var$IssueAssigneeSkeleton = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = $915a8076e467f6ae$var$AnimationBaseDiv, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rko1rr0 _4t3i1tcg _1bsb1tcg _2hwxxncg",
            __cmplp.className
        ])
    });
});

});

parcelRegister("3nAD0", function(module, exports) {
$parcel$export(module.exports, "IssuesMoreButton", () => $752c8467e6b2d475$export$ef8795476184c09b);

var $eJOHy = parcelRequire("eJOHy");

var $goZPP = parcelRequire("goZPP");

var $NByNW = parcelRequire("NByNW");

var $5vQ2T = parcelRequire("5vQ2T");

var $lRq8t = parcelRequire("lRq8t");

var $2imLM = parcelRequire("2imLM");

var $bQWwW = parcelRequire("bQWwW");

var $iKHnQ = parcelRequire("iKHnQ");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $752c8467e6b2d475$var$MoreButtonLazy = (0, $bQWwW.lazy)(()=>(parcelRequire("hGiXC")).then((mod)=>mod.IssuesMoreButton), {
    moduleId: "./src/packages/releases/issue-list/src/ui/issues-more-button/index.tsx"
});
const $752c8467e6b2d475$export$ef8795476184c09b = (props)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        fallback: "flag",
        id: "jira.software.releases.version.detail.issue.list.more.button",
        packageName: "jira-software-releases-version-detail-issue-list",
        teamName: "jolt"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "jira-software-releases-version-detail-issue-list",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
            appearance: "subtle",
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($NByNW))), {
                spacing: "spacious",
                label: formatMessage((0, $iKHnQ.default).moreButtonLabel)
            })
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($752c8467e6b2d475$var$MoreButtonLazy, props)));
};

});
parcelRegister("iKHnQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $d4dddb2d303a6048$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $d4dddb2d303a6048$var$messages = (0, $7qGN1.defineMessages)({
    issueNavigatorLink: {
        "id": "software-releases-version-detail-issue-list.issues-more-button.issue-navigator-link",
        "defaultMessage": "View in Issue Navigator"
    },
    moreButtonLabel: {
        "id": "software-releases-version-detail-issue-list.issues-more-button.more-button-label",
        "defaultMessage": "More actions for the work item list"
    },
    displayInformation: {
        "id": "software-releases-version-detail-issue-list.issues-more-button.display-information",
        "defaultMessage": "Display information"
    },
    assigneeColumnLabel: {
        "id": "software-releases-version-detail-issue-list.issues-more-button.assignee-column-label",
        "defaultMessage": "Assignee"
    },
    priorityColumnLabel: {
        "id": "software-releases-version-detail-issue-list.issues-more-button.priority-column-label",
        "defaultMessage": "Priority"
    },
    issueStatusColumnLabel: {
        "id": "software-releases-version-detail-issue-list.issues-more-button.issue-status-column-label",
        "defaultMessage": "Issue status"
    },
    developmentStatusColumnLabel: {
        "id": "software-releases-version-detail-issue-list.issues-more-button.development-status-column-label",
        "defaultMessage": "Development status"
    },
    buildStatusColumnLabel: {
        "id": "software-releases-version-detail-issue-list.issues-more-button.build-status-column-label",
        "defaultMessage": "Build status"
    },
    deliveryStatusColumnLabel: {
        "id": "software-releases-version-detail-issue-list.issues-more-button.delivery-status-column-label",
        "defaultMessage": "Delivery status"
    },
    featureFlagStatusColumnLabel: {
        "id": "software-releases-version-detail-issue-list.issues-more-button.feature-flag-status-column-label",
        "defaultMessage": "Feature flag status"
    },
    errorFlagDescription: {
        "id": "software-releases-version-detail-issue-list.issues-more-button.error-flag-description",
        "defaultMessage": "We couldn't save your preference. Please try again."
    },
    moreActionColumnLabel: {
        "id": "software-releases-version-detail-issue-list.issues-more-button.more-action-column-label",
        "defaultMessage": "More actions"
    },
    manageWarningsButtonLabel: {
        "id": "software-releases-version-detail-issue-list.issues-more-button.manage-warnings-button-label",
        "defaultMessage": "Manage warnings"
    },
    issueNavigatorLinkIssueTerminologyRefreshM4: {
        "id": "software-releases-version-detail-issue-list.issues-more-button.issue-navigator-link-issue-terminology-refresh-m4",
        "defaultMessage": "View in All work navigator"
    },
    issueStatusColumnLabelIssueTerminologyRefreshM4: {
        "id": "software-releases-version-detail-issue-list.issues-more-button.issue-status-column-label-issue-terminology-refresh-m4",
        "defaultMessage": "Work item status"
    }
});
var $d4dddb2d303a6048$export$2e2bcd8739ae039 = $d4dddb2d303a6048$var$messages;

});

parcelRegister("hGiXC", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("kofQx").then(()=>parcelRequire('6D0kO'));

});


parcelRegister("cmxu9", function(module, exports) {
$parcel$export(module.exports, "Issues", () => $0c61bff3d156d188$export$1cb51167b20548a0);

var $fwfFj = parcelRequire("fwfFj");

var $1Bnzo = parcelRequire("1Bnzo");

var $4ldu6 = parcelRequire("4ldu6");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $j4oe4 = parcelRequire("j4oe4");

var $7XH79 = parcelRequire("7XH79");

var $jom8W = parcelRequire("jom8W");

var $ih73V = parcelRequire("ih73V");

var $hcnPw = parcelRequire("hcnPw");

var $lvzYV = parcelRequire("lvzYV");
const $0c61bff3d156d188$export$1cb51167b20548a0 = ({ jiraIssueEdgesReference: jiraIssueEdgesReference, jiraVersion: jiraVersion, jiraVersionRefetch: jiraVersionRefetch })=>{
    const [isFeatureFlagEmptyStateModalOpen, setIsFeatureFlagEmptyStateModalOpen] = (0, $eJOHy.useState)(false);
    const featureFlagButtonRef = (0, $eJOHy.useRef)(null);
    const jiraIssueEdgeReferenceData = (0, $j4oe4.useFragment)((0, $4ldu6.default), jiraIssueEdgesReference);
    const version = (0, $j4oe4.useFragment)((0, $1Bnzo.default), jiraVersion);
    const [versionRefetch, refetch] = (0, $j4oe4.useRefetchableFragment)((0, $fwfFj.default), jiraVersionRefetch);
    const [refetchDevOpsProviders] = (0, $7XH79.useSuspenselessRefetch)((0, $ih73V.default), refetch, {
        fetchPolicy: 'network-only'
    });
    const featureFlagProviders = (versionRefetch.devOpsSummarisedEntities?.providers.featureFlagProviders ?? []).filter(Boolean);
    const nodes = jiraIssueEdgeReferenceData?.map((edge)=>edge.node).filter(Boolean); // TODO: This will be improved by getting these values from the server either from Data Depot
    // or ARI Graph Store relationships. The current code has a bug that might result incorrect
    // boolean due to pagination. Also this is ugly to calculate in FE.
    const hasBambooDeployment = nodes.some((node)=>(node.devSummaryCache?.devSummary?.deploymentEnvironments?.overall?.topEnvironments ?? []).filter((deployment)=>deployment.status === 'DEPLOYED').length > 0);
    const hasDeployments = nodes.some((node)=>node.summarisedDeployments?.count != null && node.summarisedDeployments?.count > 0);
    const hasCommits = nodes.some((node)=>Number(node.devSummaryCache?.devSummary?.commit?.overall?.count) > 0);
    const hasPullRequests = nodes.some((node)=>Number(node.devSummaryCache?.devSummary?.pullrequest?.overall?.count) > 0);
    const hasBranches = nodes.some((node)=>Number(node.devSummaryCache?.devSummary?.branch?.overall?.count) > 0);
    const hasBuilds = nodes.some((node)=>Number(node.summarisedBuilds?.count) > 0) || nodes.some((node)=>Number(node.devSummaryCache?.devSummary?.build?.overall?.count) > 0);
    const hasReviews = nodes.some((node)=>Number(node.devSummaryCache?.devSummary?.review?.overall?.count) > 0);
    const hasDevelopments = hasCommits || hasPullRequests || hasBranches || hasReviews;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0c61bff3d156d188$var$IssuesContainer, null, nodes.map((node, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lvzYV.IssueCard), {
            rowNum: i + 1,
            key: node.key,
            jiraIssue: node,
            jiraVersion: version,
            onFeatureFlagEmptyStateModalOpen: setIsFeatureFlagEmptyStateModalOpen,
            featureFlagButtonRef: featureFlagButtonRef,
            hasBambooDeployment: hasBambooDeployment,
            hasDeployments: hasDeployments,
            hasDevelopments: hasDevelopments,
            hasBuilds: hasBuilds
        })), !(0, $jom8W.isDevopsFeatureDisabledInFedRamp)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hcnPw.FeatureFlagEmptyStateExperienceModal), {
        returnFocusRef: featureFlagButtonRef,
        devOpsFeatureFlagProviders: featureFlagProviders,
        isOpen: isFeatureFlagEmptyStateModalOpen,
        onClose: ()=>setIsFeatureFlagEmptyStateModalOpen(false),
        onInstallSuccess: ()=>refetchDevOpsProviders({
                id: versionRefetch.id,
                isDevopsFeatureDisabledInFedRamp: (0, $jom8W.isDevopsFeatureDisabledInFedRamp)()
            })
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0c61bff3d156d188$var$IssuesContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1pbykb7n _kqswh2mm _bfhkvuon",
            __cmplp.className
        ])
    });
});

});
parcelRegister("fwfFj", function(module, exports) {
$parcel$export(module.exports, "default", () => $670f6627c5337a66$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5c3b088ebe7d201a81358ecbe804e714>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck

var $ih73V = parcelRequire("ih73V");
const $670f6627c5337a66$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "isDevopsFeatureDisabledInFedRamp"
        }
    ],
    "kind": "Fragment",
    "metadata": {
        "refetch": {
            "fragmentPathInResult": [
                "node"
            ],
            "operation": (0, $ih73V.default),
            "identifierInfo": {
                "identifierField": "id",
                "identifierQueryVariableName": "id"
            }
        }
    },
    "name": "issues_softwareReleasesVersionDetailIssueList_jiraVersionRefetch",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "condition": "isDevopsFeatureDisabledInFedRamp",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
                {
                    "concreteType": "DevOpsSummarisedEntities",
                    "kind": "LinkedField",
                    "name": "devOpsSummarisedEntities",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "concreteType": "DevOpsProviders",
                                "kind": "LinkedField",
                                "name": "providers",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "RequiredField",
                                        "field": {
                                            "concreteType": "DevOpsFeatureFlagProvider",
                                            "kind": "LinkedField",
                                            "name": "featureFlagProviders",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "featureFlagsEmptyState_softwareReleasesVersionDetailIssueList_FeatureFlagEmptyStateExperienceModal"
                                                }
                                            ]
                                        },
                                        "action": "NONE",
                                        "path": "devOpsSummarisedEntities.providers.featureFlagProviders"
                                    }
                                ]
                            },
                            "action": "NONE",
                            "path": "devOpsSummarisedEntities.providers"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraVersion"
};
$670f6627c5337a66$var$node.hash = "67e86aee284b1de0db813afbd23b7bbc";
var $670f6627c5337a66$export$2e2bcd8739ae039 = $670f6627c5337a66$var$node;

});
parcelRegister("ih73V", function(module, exports) {
$parcel$export(module.exports, "default", () => $96e8610fb48f2b85$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b14598e6e29ba4e7759c67bfb497ffd8>>
 * @relayHash e4db664c14f25d2cbd5656b656921164
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3cbb87d716e7da1ddfbdbde8292c44abd6d8a20728f8b637597b48bcde37becc
const $96e8610fb48f2b85$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "id"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isDevopsFeatureDisabledInFedRamp"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "id"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "versionDetailIssueListJiraVersionRefetchQuery",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "issues_softwareReleasesVersionDetailIssueList_jiraVersionRefetch"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "versionDetailIssueListJiraVersionRefetchQuery",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "condition": "isDevopsFeatureDisabledInFedRamp",
                                    "kind": "Condition",
                                    "passingValue": false,
                                    "selections": [
                                        {
                                            "concreteType": "DevOpsSummarisedEntities",
                                            "kind": "LinkedField",
                                            "name": "devOpsSummarisedEntities",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "DevOpsProviders",
                                                    "kind": "LinkedField",
                                                    "name": "providers",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "DevOpsFeatureFlagProvider",
                                                            "kind": "LinkedField",
                                                            "name": "featureFlagProviders",
                                                            "plural": true,
                                                            "selections": [
                                                                v3 /*: any*/ ,
                                                                v4 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "name"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "logoUrl"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ],
                            "type": "JiraVersion"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "3cbb87d716e7da1ddfbdbde8292c44abd6d8a20728f8b637597b48bcde37becc",
            "metadata": {},
            "name": "versionDetailIssueListJiraVersionRefetchQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$96e8610fb48f2b85$var$node.hash = "67e86aee284b1de0db813afbd23b7bbc";
var $96e8610fb48f2b85$export$2e2bcd8739ae039 = $96e8610fb48f2b85$var$node;

});


parcelRegister("1Bnzo", function(module, exports) {
$parcel$export(module.exports, "default", () => $56086327dc79532d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a94a622415ac6299a5332ad1cea1e5c9>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $56086327dc79532d$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "issues_softwareReleasesVersionDetailIssueList_jiraVersion",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "issueCard_softwareReleasesVersionDetailIssueList_jiraVersion"
        }
    ],
    "type": "JiraVersion"
};
$56086327dc79532d$var$node.hash = "224ec701c99ed1fc3c24b3cb47926906";
var $56086327dc79532d$export$2e2bcd8739ae039 = $56086327dc79532d$var$node;

});

parcelRegister("4ldu6", function(module, exports) {
$parcel$export(module.exports, "default", () => $66d3f3694b494a78$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9eb3c88bef8f92e2541b6393844a7505>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $66d3f3694b494a78$var$node = function() {
    var v0 = [
        {
            "kind": "ScalarField",
            "name": "count"
        }
    ], v1 = [
        {
            "concreteType": "DevOpsSummarisedDeployments",
            "kind": "LinkedField",
            "name": "summarisedDeployments",
            "plural": false,
            "selections": v0 /*: any*/ 
        },
        {
            "concreteType": "DevOpsSummarisedBuilds",
            "kind": "LinkedField",
            "name": "summarisedBuilds",
            "plural": false,
            "selections": v0 /*: any*/ 
        }
    ];
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "isDevopsFeatureDisabledInFedRamp"
            },
            {
                "kind": "RootArgument",
                "name": "shouldIncludeDevOpsFieldsViaAgs"
            }
        ],
        "kind": "Fragment",
        "metadata": {
            "plural": true
        },
        "name": "issues_softwareReleasesVersionDetailIssueList_jiraIssueEdgesReference",
        "selections": [
            {
                "kind": "RequiredField",
                "field": {
                    "concreteType": "JiraIssue",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "kind": "ScalarField",
                                "name": "key"
                            },
                            "action": "THROW",
                            "path": "node.key"
                        },
                        {
                            "condition": "isDevopsFeatureDisabledInFedRamp",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "concreteType": "DevOpsSummarisedEntities",
                                    "kind": "LinkedField",
                                    "name": "devOpsSummarisedEntities",
                                    "plural": false,
                                    "selections": v1 /*: any*/ 
                                },
                                {
                                    "concreteType": "JiraIssueDevSummaryResult",
                                    "kind": "LinkedField",
                                    "name": "devSummaryCache",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueDevSummary",
                                            "kind": "LinkedField",
                                            "name": "devSummary",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssuePullRequestDevSummaryContainer",
                                                    "kind": "LinkedField",
                                                    "name": "pullrequest",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssuePullRequestDevSummary",
                                                            "kind": "LinkedField",
                                                            "name": "overall",
                                                            "plural": false,
                                                            "selections": v0 /*: any*/ 
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "JiraIssueBranchDevSummaryContainer",
                                                    "kind": "LinkedField",
                                                    "name": "branch",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueBranchDevSummary",
                                                            "kind": "LinkedField",
                                                            "name": "overall",
                                                            "plural": false,
                                                            "selections": v0 /*: any*/ 
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "JiraIssueReviewDevSummaryContainer",
                                                    "kind": "LinkedField",
                                                    "name": "review",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueReviewDevSummary",
                                                            "kind": "LinkedField",
                                                            "name": "overall",
                                                            "plural": false,
                                                            "selections": v0 /*: any*/ 
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "JiraIssueCommitDevSummaryContainer",
                                                    "kind": "LinkedField",
                                                    "name": "commit",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueCommitDevSummary",
                                                            "kind": "LinkedField",
                                                            "name": "overall",
                                                            "plural": false,
                                                            "selections": v0 /*: any*/ 
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "JiraIssueBuildDevSummaryContainer",
                                                    "kind": "LinkedField",
                                                    "name": "build",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueBuildDevSummary",
                                                            "kind": "LinkedField",
                                                            "name": "overall",
                                                            "plural": false,
                                                            "selections": v0 /*: any*/ 
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "JiraIssueDeploymentEnvironmentDevSummaryContainer",
                                                    "kind": "LinkedField",
                                                    "name": "deploymentEnvironments",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueDeploymentEnvironmentDevSummary",
                                                            "kind": "LinkedField",
                                                            "name": "overall",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueDeploymentEnvironment",
                                                                    "kind": "LinkedField",
                                                                    "name": "topEnvironments",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "status"
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "condition": "shouldIncludeDevOpsFieldsViaAgs",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": v1 /*: any*/ 
                        },
                        {
                            "kind": "FragmentSpread",
                            "name": "issueCard_softwareReleasesVersionDetailIssueList_jiraIssue"
                        }
                    ]
                },
                "action": "THROW",
                "path": "node"
            }
        ],
        "type": "JiraIssueEdge"
    };
}();
$66d3f3694b494a78$var$node.hash = "9f22d41da8c51a4ad6a88b9583ed10fd";
var $66d3f3694b494a78$export$2e2bcd8739ae039 = $66d3f3694b494a78$var$node;

});

parcelRegister("hcnPw", function(module, exports) {
$parcel$export(module.exports, "FeatureFlagEmptyStateExperienceModal", () => $d8dce2b61f091773$export$4e1e35d50ebac320);

var $dwGKl = parcelRequire("dwGKl");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $956it = parcelRequire("956it");

var $4B7rn = parcelRequire("4B7rn");

var $lJKII = parcelRequire("lJKII");

var $jAzxV = parcelRequire("jAzxV");
const $d8dce2b61f091773$export$4e1e35d50ebac320 = ({ isOpen: isOpen, onClose: onClose, devOpsFeatureFlagProviders: devOpsFeatureFlagProviders, onInstallSuccess: onInstallSuccess, returnFocusRef: returnFocusRef })=>{
    const featureFlagProviders = (0, $j4oe4.useFragment)((0, $dwGKl.default), devOpsFeatureFlagProviders);
    const entryPoint = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jAzxV.FeatureFlagEmptyStateExperienceEntryPoint), {
        onInstallSuccess: onInstallSuccess,
        devOpsFeatureFlagProviders: featureFlagProviders,
        isOpen: isOpen,
        onClose: onClose
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $956it.default), null, isOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4B7rn.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lJKII.JiraModal), {
        shouldReturnFocus: returnFocusRef,
        onClose: onClose,
        width: 592,
        autoFocus: false,
        messageId: "software-releases-version-detail-issue-list.ui.issues.feature-flags-empty-state.modal-dialog",
        messageType: "transactional"
    }, entryPoint)) : null);
};

});
parcelRegister("dwGKl", function(module, exports) {
$parcel$export(module.exports, "default", () => $6e6c7346d66e16eb$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b5ece995d5336893a3d038e4fba6e8d5>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $6e6c7346d66e16eb$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": {
        "plural": true
    },
    "name": "featureFlagsEmptyState_softwareReleasesVersionDetailIssueList_FeatureFlagEmptyStateExperienceModal",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "async_softwareEmptyStateExperienceFeatureFlags_FeatureFlagEmptyStateExperienceEntryPoint"
        }
    ],
    "type": "DevOpsFeatureFlagProvider"
};
$6e6c7346d66e16eb$var$node.hash = "0fbad5b696ab8a25991a0d1c79838173";
var $6e6c7346d66e16eb$export$2e2bcd8739ae039 = $6e6c7346d66e16eb$var$node;

});

parcelRegister("jAzxV", function(module, exports) {
$parcel$export(module.exports, "FeatureFlagEmptyStateExperienceEntryPoint", () => $946974158aa14bb4$export$d0d10a136f7d769f);

var $eRdJx = parcelRequire("eRdJx");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $j4oe4 = parcelRequire("j4oe4");

var $7ep4S = parcelRequire("7ep4S");

var $5vQ2T = parcelRequire("5vQ2T");

var $2imLM = parcelRequire("2imLM");

var $8oKDI = parcelRequire("8oKDI");

var $2aY2d = parcelRequire("2aY2d");

var $cHtIB = parcelRequire("cHtIB");

var $bQWwW = parcelRequire("bQWwW");

var $isHDA = parcelRequire("isHDA");

var $iNMIK = parcelRequire("iNMIK");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $946974158aa14bb4$var$FeatureFlagEmptyStateExperienceQueryLoader = (0, $bQWwW.lazy)(()=>(parcelRequire("aDyiK")).then((mod)=>mod.FeatureFlagsEmptyStateExperienceQueryLoader), {
    ssr: false,
    moduleId: "./src/packages/software/empty-state-experience/feature-flags/src/ui/index.tsx"
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $946974158aa14bb4$var$Loading = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_4cvr1h6o _6a6z1h6o _1e0c11p5 _ca0q1epz _u5f3idpf _n3td1epz _19bvidpf",
            __cmplp.className
        ])
    });
});
const $946974158aa14bb4$export$d0d10a136f7d769f = ({ isOpen: isOpen, onClose: onClose, devOpsFeatureFlagProviders: devOpsFeatureFlagProviders, onInstallSuccess: onInstallSuccess })=>{
    const [queryReference, loadQuery] = (0, $j4oe4.useQueryLoader)((0, $iNMIK.default));
    const { data: projectContext } = (0, $2aY2d.useProjectContext)();
    const cloudId = (0, $cHtIB.useCloudId)();
    const onExperienceFail = (0, $isHDA.useViewFeatureFlagsEmptyStateExperienceExperienceFail)();
    const featureFlagProviders = (0, $j4oe4.useFragment)((0, $eRdJx.default), devOpsFeatureFlagProviders);
    (0, $eJOHy.useLayoutEffect)(()=>{
        if (projectContext?.projectId != null && isOpen) loadQuery({
            projectAri: (0, $8oKDI.createAri)({
                resourceId: projectContext.projectId.toString(),
                resourceOwner: 'jira',
                resourceType: 'project',
                cloudId: cloudId
            })
        }, {
            fetchPolicy: 'store-and-network'
        });
    }, [
        isOpen,
        loadQuery,
        cloudId,
        projectContext
    ]);
    return projectContext != null && isOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        fallback: "flag",
        id: "featureFlagEmptyStateExperienceEntryPoint",
        packageName: "jiraSoftwareEmptyStateExperienceFeatureFlags",
        teamName: "jolt",
        onError: (location, error)=>{
            onExperienceFail(location, error);
            onClose();
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "software-empty-state-experience-feature-flags",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($946974158aa14bb4$var$Loading, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7ep4S.default), {
            size: "large"
        }))
    }, queryReference != null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($946974158aa14bb4$var$FeatureFlagEmptyStateExperienceQueryLoader, {
        onInstallSuccess: onInstallSuccess,
        devOpsFeatureFlagProviders: featureFlagProviders,
        queryReference: queryReference
    }) : null))) : null;
};

});
parcelRegister("eRdJx", function(module, exports) {
$parcel$export(module.exports, "default", () => $a2591ba9adcd2da5$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<938070df7d9719f61ec9a07cd353d6c0>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $a2591ba9adcd2da5$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": {
        "plural": true
    },
    "name": "async_softwareEmptyStateExperienceFeatureFlags_FeatureFlagEmptyStateExperienceEntryPoint",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "ui_softwareEmptyStateExperienceFeatureFlags_FeatureFlagsEmptyStateExperienceQueryLoader_devOpsFeatureFlagProviders"
        }
    ],
    "type": "DevOpsFeatureFlagProvider"
};
$a2591ba9adcd2da5$var$node.hash = "17afe0c67200280c81407f20b1ac9cf2";
var $a2591ba9adcd2da5$export$2e2bcd8739ae039 = $a2591ba9adcd2da5$var$node;

});

parcelRegister("iNMIK", function(module, exports) {
$parcel$export(module.exports, "default", () => $dfc51be6e8f58964$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<70c3440a202cfdad1b4e531c7435152b>>
 * @relayHash ebd0cfdc3b09a8f2dd0b3e7d12e0b64d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 26f590dcda44b5fc757b038bb24223ad14175c339c87b80b056b42ed91aa2a99
const $dfc51be6e8f58964$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectAri"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "uiFeatureFlagsEmptyStateExperienceQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "ui_softwareEmptyStateExperienceFeatureFlags_FeatureFlagsEmptyStateExperience_query"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "uiFeatureFlagsEmptyStateExperienceQuery",
            "selections": [
                {
                    "concreteType": "DevOps",
                    "kind": "LinkedField",
                    "name": "devOps",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "AriGraph",
                            "kind": "LinkedField",
                            "name": "ariGraph",
                            "plural": false,
                            "selections": [
                                {
                                    "args": [
                                        {
                                            "fields": [
                                                {
                                                    "kind": "Variable",
                                                    "name": "from",
                                                    "variableName": "projectAri"
                                                },
                                                {
                                                    "kind": "Literal",
                                                    "name": "type",
                                                    "value": "project-associated-feature-flag"
                                                }
                                            ],
                                            "kind": "ObjectValue",
                                            "name": "filter"
                                        },
                                        {
                                            "kind": "Literal",
                                            "name": "first",
                                            "value": 1
                                        }
                                    ],
                                    "concreteType": "AriGraphRelationshipConnection",
                                    "kind": "LinkedField",
                                    "name": "relationships",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "AriGraphRelationship",
                                            "kind": "LinkedField",
                                            "name": "nodes",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "26f590dcda44b5fc757b038bb24223ad14175c339c87b80b056b42ed91aa2a99",
            "metadata": {},
            "name": "uiFeatureFlagsEmptyStateExperienceQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$dfc51be6e8f58964$var$node.hash = "c8856730dcfda88439b157a25ff3f97f";
var $dfc51be6e8f58964$export$2e2bcd8739ae039 = $dfc51be6e8f58964$var$node;

});

parcelRegister("aDyiK", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("lFxtR").then(()=>parcelRequire('h5GvG'));

});



parcelRegister("lvzYV", function(module, exports) {
$parcel$export(module.exports, "IssueCard", () => $06bdc74af041e289$export$11b5a73dc1ef6ab9);

var $kOK7J = parcelRequire("kOK7J");

var $8lCis = parcelRequire("8lCis");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $j4oe4 = parcelRequire("j4oe4");

var $l98s9 = parcelRequire("l98s9");


var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $2QZBX = parcelRequire("2QZBX");

var $jom8W = parcelRequire("jom8W");

var $i6OEF = parcelRequire("i6OEF");

var $4HIFl = parcelRequire("4HIFl");

var $kO0T0 = parcelRequire("kO0T0");


var $irNJ5 = parcelRequire("irNJ5");

var $gKV7x = parcelRequire("gKV7x");

var $l0sHK = parcelRequire("l0sHK");

var $3KkgD = parcelRequire("3KkgD");

var $6ajZe = parcelRequire("6ajZe");

var $5Zdes = parcelRequire("5Zdes");

var $hIiNX = parcelRequire("hIiNX");

var $4bYle = parcelRequire("4bYle");

var $jCedg = parcelRequire("jCedg");
const $06bdc74af041e289$var$DEV_DETAILS_DIALOG_SCOPE_ID = 'VersionDetailsIssueList';
const $06bdc74af041e289$export$11b5a73dc1ef6ab9 = ({ jiraIssue: jiraIssue, jiraVersion: jiraVersion, hasBambooDeployment: hasBambooDeployment, hasDeployments: hasDeployments, hasDevelopments: hasDevelopments, hasBuilds: hasBuilds, onFeatureFlagEmptyStateModalOpen: onFeatureFlagEmptyStateModalOpen, featureFlagButtonRef: featureFlagButtonRef, rowNum: rowNum })=>{
    const issue = (0, $j4oe4.useFragment)((0, $8lCis.default), jiraIssue);
    const { showDevDetailDialog: showDevDetailDialog } = (0, $l98s9.useDevOpsDetailsDialogLoaderActions)($06bdc74af041e289$var$DEV_DETAILS_DIALOG_SCOPE_ID);
    const [, sidebarActions] = (0, $i6OEF.useSidebarStore)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const handleClick = (dataType, reviewData)=>{
        showDevDetailDialog(dataType, dataType === (0, $e31f0ec65fa77dec$export$3f1e2b276d607490) ? reviewData : undefined, (0, $2QZBX.toIssueKey)(issue.key), (0, $2QZBX.toIssueId)(issue.issueId));
    };
    const jiraVersionData = (0, $j4oe4.useFragment)((0, $kOK7J.default), jiraVersion);
    const { canViewDevTools: canViewDevTools, devOpsSummarisedEntities: devOpsSummarisedEntities, versionIssueTableHiddenColumns: versionIssueTableHiddenColumns } = jiraVersionData;
    const fields = issue.fieldsById.edges.map((edge)=>edge?.node).filter(Boolean);
    const jiraIssueSummaryField = fields.find((fieldNode)=>fieldNode?.fieldId === 'summary');
    const jiraIssueTypeField = fields.find((fieldNode)=>fieldNode?.fieldId === 'issuetype');
    const jiraPriorityField = fields.find((fieldNode)=>fieldNode?.fieldId === 'priority');
    const jiraStatusField = fields.find((fieldNode)=>fieldNode?.fieldId === 'status');
    const jiraAssigneeField = fields.find((fieldNode)=>fieldNode?.fieldId === 'assignee');
    const issueUrl = `/browse/${issue.key}`;
    const onIssueClick = (e)=>{
        if (e.target instanceof Element && e.target.closest((0, $4HIFl.getIssueCardClickIgnorePreventDefaultTargetSelector)()) != null) {
            // These are a tags with href to create a feature flag that shouldn't prevent default
            if (e.target.closest((0, $4HIFl.getIssueCardClickIgnoreTargetNoPreventDefaultSelector)())) return;
            e.preventDefault();
            return;
        }
        const modifiersPressed = Boolean(e.shiftKey || e.metaKey || e.ctrlKey);
        const shouldOpenIssueSidebar = // on primary button click
        e.button === 0 && // no modifier buttons have been pressed
        !modifiersPressed;
        if (shouldOpenIssueSidebar) {
            // stops the default behaviour of opening the issue in a new link
            e.preventDefault();
            sidebarActions.showIssue(issue.key);
        }
        const event = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'link'
        });
        (0, $kRgKj.fireUIAnalytics)(event, 'versionDetailsIssue', {
            clickType: e.button,
            modifiersPressed: modifiersPressed
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kO0T0.IssueWarningProvider), {
        jiraVersion: jiraVersionData,
        jiraIssue: issue
    }, ({ hasWarnings: hasWarnings, hasOpenPullRequestWarning: hasOpenPullRequestWarning, hasFailingBuildsWarning: hasFailingBuildsWarning, hasUnreviewedCodeWarning: hasUnreviewedCodeWarning, hasOpenReviewWarning: hasOpenReviewWarning })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($06bdc74af041e289$var$IssueCardContainer, {
            href: issueUrl,
            target: "_blank",
            rel: "noopener noreferrer",
            onClick: onIssueClick,
            "data-component-selector": (0, $bf14b8aa894cb92b$export$b343d4705e10ba61),
            "data-testid": "software-releases-version-detail-issue-list.ui.issues.issue-card",
            hasWarnings: hasWarnings
        }, jiraIssueSummaryField && jiraIssueTypeField && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jCedg.Summary), {
            jiraIssue: issue,
            jiraIssueSummaryField: jiraIssueSummaryField,
            jiraIssueTypeField: jiraIssueTypeField
        }), jiraPriorityField && !versionIssueTableHiddenColumns.includes('ISSUE_PRIORITY') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hIiNX.Priority), {
            jiraPriorityField: jiraPriorityField
        }), jiraStatusField && !versionIssueTableHiddenColumns.includes('ISSUE_STATUS') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4bYle.Status), {
            jiraStatusField: jiraStatusField
        }), jiraAssigneeField && !versionIssueTableHiddenColumns.includes('ISSUE_ASSIGNEE') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gKV7x.Assignee), {
            jiraAssigneeField: jiraAssigneeField
        }), !(0, $jom8W.isDevopsFeatureDisabledInFedRamp)() && canViewDevTools && hasDevelopments && !versionIssueTableHiddenColumns.includes('DEVELOPMENT_STATUS') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $irNJ5.ErrorBoundary), {
            id: "issueListIssueCardDevelopment",
            fallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3KkgD.DevelopmentContainer), null)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3KkgD.Development), {
            jiraIssue: issue,
            onClick: handleClick
        })), !(0, $jom8W.isDevopsFeatureDisabledInFedRamp)() && (hasBambooDeployment || hasDeployments || hasBuilds) && canViewDevTools && !versionIssueTableHiddenColumns.includes('DEPLOYMENT_STATUS') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $irNJ5.ErrorBoundary), {
            id: "issueListIssueCardDelivery",
            fallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $l0sHK.DeliveryContainer), null)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $l0sHK.Delivery), {
            jiraIssue: issue,
            onClick: handleClick
        })), !(0, $jom8W.isDevopsFeatureDisabledInFedRamp)() && canViewDevTools && devOpsSummarisedEntities && !versionIssueTableHiddenColumns.includes('FEATURE_FLAG_STATUS') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $irNJ5.ErrorBoundary), {
            id: "issueListIssueCardFeatureFlags",
            fallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($06bdc74af041e289$var$FeatureFlagsContainer, null)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
            "data-version-details-issue-click-ignore-target": (0, $4HIFl.ISSUE_CARD_CLICK_IGNORE_TARGET)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6ajZe.FeatureFlags), {
            devOpsSummarisedEntities: devOpsSummarisedEntities,
            jiraIssue: issue,
            onClick: handleClick,
            featureFlagButtonRef: featureFlagButtonRef,
            setFeatureFlagEmptyStateModalOpen: onFeatureFlagEmptyStateModalOpen,
            rowNum: rowNum
        }))), !versionIssueTableHiddenColumns.includes('MORE_ACTION') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $irNJ5.ErrorBoundary), {
            id: "issueListIssueCardMoreButton",
            fallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5Zdes.OnHoverVisibility), null, null)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
            "data-version-details-issue-click-ignore-target": (0, $4HIFl.ISSUE_CARD_CLICK_IGNORE_TARGET)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5Zdes.MoreButton), {
            jiraVersion: jiraVersionData,
            jiraIssue: issue,
            hasWarnings: hasWarnings,
            hasOpenPullRequestWarning: hasOpenPullRequestWarning,
            hasFailingBuildsWarning: hasFailingBuildsWarning,
            hasUnreviewedCodeWarning: hasUnreviewedCodeWarning,
            hasOpenReviewWarning: hasOpenReviewWarning
        })))));
};
const $06bdc74af041e289$var$WARNING_COLOR = "var(--ds-background-warning, #FFF5DB)";
const $06bdc74af041e289$var$WARNING_HOVER_COLOR = "var(--ds-background-warning-hovered, #FCE4A6)";
const $06bdc74af041e289$var$HOVER_COLOR = "var(--ds-background-neutral-hovered, #0B120E24)"; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $06bdc74af041e289$var$IssueCardContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { hasWarnings: hasWarnings, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1d5pv2t": (0, $awdRS.default)(__cmplp.hasWarnings && $06bdc74af041e289$var$WARNING_COLOR)
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_189efywm _1dqonqa1 _1h6d1l7x _1e0c1txw _4cvr1h6o _bfhk62r0 _4t3izwfg _ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvpxbi _gy1pu2gc _7cca15wb _64eze4h9 _1ov8fajl _k8kwfajl _1rcdfajl _1wp9fajl _1a3b18uv _4fprglyw _5goinqa1 _7ehiglyw _9oik18uv _1bnxglyw _jf4cnqa1",
            __cmplp.hasWarnings ? "_10j719zu _irr319zu" : "_10j7plhp _irr3plhp",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $06bdc74af041e289$var$FeatureFlagsContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _1b081l8a _15yj1l8a _13n41tcg _fhcx1tcg",
            __cmplp.className
        ])
    });
});

});
parcelRegister("kOK7J", function(module, exports) {
$parcel$export(module.exports, "default", () => $652909d8d5684f1d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<74f23412886a917642ce5f650f64f940>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $652909d8d5684f1d$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "isDevopsFeatureDisabledInFedRamp"
        }
    ],
    "kind": "Fragment",
    "name": "issueCard_softwareReleasesVersionDetailIssueList_jiraVersion",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "ui_softwareReleasesVersionIssueWarningController_IssueWarningProvider_jiraVersion"
        },
        {
            "kind": "ScalarField",
            "name": "canViewDevTools"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "versionIssueTableHiddenColumns"
            },
            "action": "THROW",
            "path": "versionIssueTableHiddenColumns"
        },
        {
            "condition": "isDevopsFeatureDisabledInFedRamp",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
                {
                    "concreteType": "DevOpsSummarisedEntities",
                    "kind": "LinkedField",
                    "name": "devOpsSummarisedEntities",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "featureFlags_softwareReleasesVersionDetailIssueList_devOpsSummarisedEntities"
                        }
                    ]
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "moreButton_softwareReleasesVersionDetailIssueList_jiraVersion"
        }
    ],
    "type": "JiraVersion"
};
$652909d8d5684f1d$var$node.hash = "522ae3c2b555fac40be79e26c643efd9";
var $652909d8d5684f1d$export$2e2bcd8739ae039 = $652909d8d5684f1d$var$node;

});

parcelRegister("8lCis", function(module, exports) {
$parcel$export(module.exports, "default", () => $5d29a3a8681d0bc9$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<53501a3cdefe37344eda446c082034d1>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $5d29a3a8681d0bc9$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "isDevopsFeatureDisabledInFedRamp"
        }
    ],
    "kind": "Fragment",
    "name": "issueCard_softwareReleasesVersionDetailIssueList_jiraIssue",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "moreButton_softwareReleasesVersionDetailIssueList_jiraIssue"
        },
        {
            "kind": "FragmentSpread",
            "name": "ui_softwareReleasesVersionIssueWarningController_IssueWarningProvider_jiraIssue"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "issueId"
            },
            "action": "THROW",
            "path": "issueId"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "key"
            },
            "action": "THROW",
            "path": "key"
        },
        {
            "kind": "RequiredField",
            "field": {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "ids",
                        "value": [
                            "priority",
                            "summary",
                            "assignee",
                            "status",
                            "issuetype"
                        ]
                    }
                ],
                "concreteType": "JiraIssueFieldConnection",
                "kind": "LinkedField",
                "name": "fieldsById",
                "plural": false,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "concreteType": "JiraIssueFieldEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "kind": "ScalarField",
                                                "name": "fieldId"
                                            },
                                            "action": "THROW",
                                            "path": "fieldsById.edges.node.fieldId"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "status_softwareReleasesVersionDetailIssueList"
                                                }
                                            ],
                                            "type": "JiraStatusField"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "assignee_softwareReleasesVersionDetailIssueList"
                                                }
                                            ],
                                            "type": "JiraSingleSelectUserPickerField"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "summary_softwareReleasesVersionDetailIssueList_jiraIssueSummaryField"
                                                }
                                            ],
                                            "type": "JiraSingleLineTextField"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "summary_softwareReleasesVersionDetailIssueList_jiraIssueTypeField"
                                                }
                                            ],
                                            "type": "JiraIssueTypeField"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "priority_softwareReleasesVersionDetailIssueList"
                                                }
                                            ],
                                            "type": "JiraPriorityField"
                                        }
                                    ]
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "fieldsById.edges"
                    }
                ],
                "storageKey": "fieldsById(ids:[\"priority\",\"summary\",\"assignee\",\"status\",\"issuetype\"])"
            },
            "action": "THROW",
            "path": "fieldsById"
        },
        {
            "condition": "isDevopsFeatureDisabledInFedRamp",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "delivery_softwareReleasesVersionDetailIssueList"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "development_softwareReleasesVersionDetailIssueList"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "featureFlags_softwareReleasesVersionDetailIssueList_jiraIssue"
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "summary_softwareReleasesVersionDetailIssueList_jiraIssue"
        }
    ],
    "type": "JiraIssue"
};
$5d29a3a8681d0bc9$var$node.hash = "81587616f95bbce4695593a62ffa6d45";
var $5d29a3a8681d0bc9$export$2e2bcd8739ae039 = $5d29a3a8681d0bc9$var$node;

});

parcelRegister("l98s9", function(module, exports) {
$parcel$export(module.exports, "loadDialogBridge", () => $8014e8107a33fa31$export$7e12f7cd0f50fe5a);
$parcel$export(module.exports, "DevOpsDetailsDialogLoaderContainer", () => $8014e8107a33fa31$export$5e6e4cfb89bdcb55);
$parcel$export(module.exports, "DevOpsDetailsDialogLoaderSubscriber", () => $8014e8107a33fa31$export$693f51ab225dff94);
$parcel$export(module.exports, "useDevOpsDetailsDialogLoaderActions", () => $8014e8107a33fa31$export$506ad06ecf691cd3);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $gjeS9 = parcelRequire("gjeS9");


var $6E16M = parcelRequire("6E16M");
var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");
var $ht3nQ = parcelRequire("ht3nQ");
var $14kUX = parcelRequire("14kUX");

var $kG1Dx = parcelRequire("kG1Dx");
const $8014e8107a33fa31$export$7e12f7cd0f50fe5a = async ()=>// eslint-disable-next-line jira/wrm/no-load-bridge
    (0, $gjeS9.loadBridge)({
        name: (0, $kG1Dx.DEV_DETAILS_WRM_RESOURCE),
        wrmKeys: [
            'wrc!com.atlassian.jira.plugins.jira-development-integration-plugin:devstatus-wrm',
            'wrc!com.atlassian.jira.plugins.jira-development-integration-plugin:devsummarycf-resources'
        ]
    });
const $8014e8107a33fa31$export$e324594224ef24da = {
    resetState: (stateOverrides)=>({ setState: setState })=>{
            // @ts-expect-error - TS2722 - Cannot invoke an object which is possibly 'undefined'.
            setState({
                ...(0, $kG1Dx.INITIAL_STATE),
                ...stateOverrides
            });
        },
    updateState: (stateUpdates)=>({ getState: getState, setState: setState })=>{
            // @ts-expect-error - TS2722 - Cannot invoke an object which is possibly 'undefined'. | TS2722 - Cannot invoke an object which is possibly 'undefined'.
            setState({
                ...getState(),
                ...stateUpdates
            });
        },
    showDevDetailDialog: (itemType, legacyData, targetIssueKey, targetIssueId)=>({ setState: setState, getState: getState })=>{
            if (itemType === (0, $e31f0ec65fa77dec$export$3f1e2b276d607490)) // @ts-expect-error - TS2722 - Cannot invoke an object which is possibly 'undefined'.
            setState({
                // @ts-expect-error - TS2722 - Cannot invoke an object which is possibly 'undefined'.
                ...getState(),
                legacyDevPanelDetailsDialogShownCounter: // @ts-expect-error - TS2722 - Cannot invoke an object which is possibly 'undefined'.
                getState().legacyDevPanelDetailsDialogShownCounter + 1,
                isDevPanelDetailsDialogShown: false,
                dataTypeSelected: itemType,
                legacyData: legacyData,
                issueKey: targetIssueKey,
                issueId: targetIssueId
            });
            else // @ts-expect-error - TS2722 - Cannot invoke an object which is possibly 'undefined'.
            setState({
                // @ts-expect-error - TS2722 - Cannot invoke an object which is possibly 'undefined'.
                ...getState(),
                isDevPanelDetailsDialogShown: true,
                dataTypeSelected: itemType,
                issueKey: targetIssueKey,
                issueId: targetIssueId
            });
        },
    closeDetailDialog: ()=>({ setState: setState, getState: getState })=>{
            // @ts-expect-error - TS2722 - Cannot invoke an object which is possibly 'undefined'.
            setState({
                // @ts-expect-error - TS2722 - Cannot invoke an object which is possibly 'undefined'.
                ...getState(),
                // @ts-expect-error - TS2322 - Type '""' is not assignable to type 'PanelDataTypes | undefined'.
                dataTypeSelected: '',
                isDevPanelDetailsDialogShown: false,
                issueKey: undefined,
                issueId: undefined
            });
        }
};
const $8014e8107a33fa31$export$390f32400eaf98c9 = (0, $GtRbT.createStore)({
    name: 'DetailsDialogLoaderRemoteState',
    initialState: (0, $kG1Dx.INITIAL_STATE),
    actions: $8014e8107a33fa31$export$e324594224ef24da
});
const $8014e8107a33fa31$export$5e6e4cfb89bdcb55 = (0, $6E16M.createContainer)($8014e8107a33fa31$export$390f32400eaf98c9);
const $8014e8107a33fa31$export$693f51ab225dff94 = (0, $ht3nQ.createSubscriber)($8014e8107a33fa31$export$390f32400eaf98c9);
const $8014e8107a33fa31$export$550d4b3c29100112 = (0, $iJq0l.createHook)($8014e8107a33fa31$export$390f32400eaf98c9);
function $8014e8107a33fa31$export$506ad06ecf691cd3(scopeId) {
    return (0, $14kUX.defaultRegistry).getStore($8014e8107a33fa31$export$390f32400eaf98c9, scopeId)?.actions;
}

});
const $e31f0ec65fa77dec$export$e18d81f044132a0e = 'branch';
const $e31f0ec65fa77dec$export$74a388a09f2a004e = 'build';
const $e31f0ec65fa77dec$export$2e42513c7764d5f3 = 'repository';
const $e31f0ec65fa77dec$export$3f1e2b276d607490 = 'review';
const $e31f0ec65fa77dec$export$90cac6260ae9ced5 = 'deployment-environment';
const $e31f0ec65fa77dec$export$6f74b53d652f13f3 = 'pullrequest';
const $e31f0ec65fa77dec$export$c69477f358d30f7e = 'feature-flags';
const $e31f0ec65fa77dec$export$56470bdd9cd798d0 = 'remote-links';
const $e31f0ec65fa77dec$export$b4bb784d069c9ab = 'development.details.details-header';

parcelRegister("kG1Dx", function(module, exports) {
$parcel$export(module.exports, "INITIAL_STATE", () => $0cd59c186515875d$export$36d128238e6b60f5);
$parcel$export(module.exports, "DEV_DETAILS_WRM_RESOURCE", () => $0cd59c186515875d$export$43a8ab4f373ff0ee);
const $0cd59c186515875d$export$36d128238e6b60f5 = {
    issueId: '',
    issueKey: undefined,
    locale: 'en_US',
    // @ts-expect-error - TS2322 - Type '""' is not assignable to type 'PanelDataTypes'.
    dataTypeSelected: '',
    legacyData: undefined,
    isDevPanelDetailsDialogShown: false,
    legacyDevPanelDetailsDialogShownCounter: 0
};
const $0cd59c186515875d$export$b5ed55f3ed234f95 = 'wrc!com.atlassian.jira.plugins.jira-development-integration-plugin:devsummarycf-resources';
const $0cd59c186515875d$export$43a8ab4f373ff0ee = 'jira-development-status/releasereport/dev-status-dialog-bridge';
const $0cd59c186515875d$export$432f9ff6c01431e3 = 'jira-development-status/util/WRM';

});


parcelRegister("4HIFl", function(module, exports) {
$parcel$export(module.exports, "ISSUE_CARD_CLICK_IGNORE_TARGET", () => $038cd8985978b74f$export$4fbe2e62d82203a7);
$parcel$export(module.exports, "VERSION_SELECT_MENU_PORTAL_CLASS_PREFIX", () => $038cd8985978b74f$export$57f23f1fe030a106);
$parcel$export(module.exports, "FEATURE_FLAG_ACTION_DROPDOWN_ANCHORS", () => $038cd8985978b74f$export$36d427b8bcbcfc80);
$parcel$export(module.exports, "getIssueCardClickIgnorePreventDefaultTargetSelector", () => $038cd8985978b74f$export$31dcba8332a40055);
$parcel$export(module.exports, "getIssueCardClickIgnoreTargetNoPreventDefaultSelector", () => $038cd8985978b74f$export$6c4862367e99e37a);
// These are utility data-version-details-issue-click-ignore-target attributes to prevent issue side bar to open when actionable items are clicked in an issue card
// Should prevent default to prevent the whole issue card (a tag) not to be clicked
const $038cd8985978b74f$export$4fbe2e62d82203a7 = 'issueClickOpenIssueIgnoreTarget';
const $038cd8985978b74f$export$57f23f1fe030a106 = 'move-issue-modal-select-dropdown';
const $038cd8985978b74f$export$36d427b8bcbcfc80 = 'featureFlagAnchorActionDropdown';
const $038cd8985978b74f$export$31dcba8332a40055 = ()=>`[data-version-details-issue-click-ignore-target="${$038cd8985978b74f$export$4fbe2e62d82203a7}"],
    [data-version-details-issue-click-ignore-target="${$038cd8985978b74f$export$36d427b8bcbcfc80}"],
    [data-testid="software-releases-move-issues-between-versions.ui.move-issue-version-select-modal--blanket"],
    [class^='${$038cd8985978b74f$export$57f23f1fe030a106}'], [class*=' ${$038cd8985978b74f$export$57f23f1fe030a106}']`;
const $038cd8985978b74f$export$6c4862367e99e37a = ()=>`[data-version-details-issue-click-ignore-target="${$038cd8985978b74f$export$36d427b8bcbcfc80}"]`;

});

parcelRegister("kO0T0", function(module, exports) {
$parcel$export(module.exports, "IssueWarningProvider", () => $80fdfe6f63ff9113$export$3786225113492c89);
$parcel$export(module.exports, "IssuesWarningCountProvider", () => $80fdfe6f63ff9113$export$d7ec5473e7d825ae);

var $ghz4S = parcelRequire("ghz4S");

var $3NOQE = parcelRequire("3NOQE");

var $dq471 = parcelRequire("dq471");

var $dbTOZ = parcelRequire("dbTOZ");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $jx0Vw = parcelRequire("jx0Vw");
const $80fdfe6f63ff9113$var$getDevSummaryDataWarnings = (issue, jiraVersionData)=>{
    const fields = issue.fieldsById.edges.map((edge)=>edge?.node).filter(Boolean);
    const jiraStatusField = fields.find((fieldNode)=>fieldNode?.fieldId === 'status');
    const issueStatus = (0, $jx0Vw.statusCategoryForId)(jiraStatusField?.status?.statusCategory?.statusCategoryId);
    const build = issue.devSummaryCache?.devSummary.build;
    const commit = issue.devSummaryCache?.devSummary.commit;
    const pullrequest = issue.devSummaryCache?.devSummary.pullrequest;
    const pullrequestCount = issue.devSummaryCache?.devSummary.pullrequest?.overall.count ?? 0;
    const reviewState = issue.devSummaryCache?.devSummary?.review?.overall?.state;
    const reviewCount = issue.devSummaryCache?.devSummary?.review?.overall?.count ?? 0;
    const openPullRequest = jiraVersionData.warningConfig?.openPullRequest;
    const failingBuild = jiraVersionData.warningConfig?.failingBuild;
    const unreviewedCode = jiraVersionData.warningConfig?.unreviewedCode;
    const openReview = jiraVersionData.warningConfig?.openReview;
    const failingBuildCount = (build?.overall.failedBuildCount ?? 0) + ((issue.devOpsSummarisedEntities?.summarisedBuilds?.buildStates ?? []).find((buildState)=>buildState?.state === 'FAILED')?.count ?? 0);
    const hasOpenPullRequestWarning = issueStatus === 'DONE' && openPullRequest === 'ENABLED' && pullrequest?.overall?.state === 'OPEN' && pullrequest.overall.count > 0;
    const hasFailingBuildsWarning = issueStatus === 'DONE' && failingBuild === 'ENABLED' && build != null && failingBuildCount > 0;
    const hasUnreviewedCodeWarning = issueStatus === 'DONE' && unreviewedCode === 'ENABLED' && pullrequestCount === 0 && reviewCount === 0 && commit != null && commit.overall.count > 0;
    const hasOpenReviewWarning = issueStatus === 'DONE' && openReview === 'ENABLED' && reviewState != null && ![
        'CLOSED',
        'REJECTED'
    ].includes(reviewState);
    const hasWarnings = issueStatus === 'DONE' && (hasOpenPullRequestWarning || hasFailingBuildsWarning || hasUnreviewedCodeWarning || hasOpenReviewWarning);
    return {
        hasWarnings: hasWarnings,
        hasOpenPullRequestWarning: hasOpenPullRequestWarning,
        hasFailingBuildsWarning: hasFailingBuildsWarning,
        hasUnreviewedCodeWarning: hasUnreviewedCodeWarning,
        hasOpenReviewWarning: hasOpenReviewWarning
    };
};
const $80fdfe6f63ff9113$var$getIssueNodeWarningsCount = (edges, jiraVersionData)=>edges.map((edge)=>edge.node).filter(Boolean).reduce((acc, issue)=>{
        const warningResult = $80fdfe6f63ff9113$var$getDevSummaryDataWarnings(issue, jiraVersionData);
        if (warningResult.hasWarnings) return acc + 1;
        return acc;
    }, 0);
const $80fdfe6f63ff9113$var$getIssueWarnings = (issue, jiraVersionData)=>$80fdfe6f63ff9113$var$getDevSummaryDataWarnings(issue, jiraVersionData);
const $80fdfe6f63ff9113$export$3786225113492c89 = ({ jiraVersion: jiraVersion, jiraIssue: jiraIssue, children: children })=>{
    const issue = (0, $j4oe4.useFragment)((0, $dbTOZ.default), jiraIssue);
    const jiraVersionData = (0, $j4oe4.useFragment)((0, $dq471.default), jiraVersion);
    const warningFlags = $80fdfe6f63ff9113$var$getIssueWarnings(issue, jiraVersionData);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children(warningFlags));
};
const $80fdfe6f63ff9113$export$d7ec5473e7d825ae = ({ jiraVersion: jiraVersion, issueEdges: issueEdges, children: children })=>{
    const jiraIssueEdgeReferenceData = (0, $j4oe4.useFragment)((0, $3NOQE.default), issueEdges);
    const warningConfig = (0, $j4oe4.useFragment)((0, $ghz4S.default), jiraVersion);
    const warningCount = $80fdfe6f63ff9113$var$getIssueNodeWarningsCount(jiraIssueEdgeReferenceData, warningConfig);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children(warningCount));
};

});
parcelRegister("ghz4S", function(module, exports) {
$parcel$export(module.exports, "default", () => $0118704a916bc7bd$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<181a2844f19811967a175c2a899887e7>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $0118704a916bc7bd$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "ui_softwareReleasesVersionIssueWarningController_IssuesWarningCountProvider_jiraVersion",
    "selections": [
        {
            "concreteType": "JiraVersionWarningConfig",
            "kind": "LinkedField",
            "name": "warningConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "kind": "ScalarField",
                        "name": "openPullRequest"
                    },
                    "action": "NONE",
                    "path": "warningConfig.openPullRequest"
                },
                {
                    "kind": "RequiredField",
                    "field": {
                        "kind": "ScalarField",
                        "name": "openReview"
                    },
                    "action": "NONE",
                    "path": "warningConfig.openReview"
                },
                {
                    "kind": "RequiredField",
                    "field": {
                        "kind": "ScalarField",
                        "name": "unreviewedCode"
                    },
                    "action": "NONE",
                    "path": "warningConfig.unreviewedCode"
                },
                {
                    "kind": "RequiredField",
                    "field": {
                        "kind": "ScalarField",
                        "name": "failingBuild"
                    },
                    "action": "NONE",
                    "path": "warningConfig.failingBuild"
                }
            ]
        }
    ],
    "type": "JiraVersion"
};
$0118704a916bc7bd$var$node.hash = "a12dea52160bb6c6b5d0ff127f4a7b36";
var $0118704a916bc7bd$export$2e2bcd8739ae039 = $0118704a916bc7bd$var$node;

});

parcelRegister("3NOQE", function(module, exports) {
$parcel$export(module.exports, "default", () => $beb6a6dedaacde0a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<70475c9d29d1800f98ebde7d315b6dbb>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $beb6a6dedaacde0a$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "count"
    }, v1 = {
        "kind": "ScalarField",
        "name": "state"
    };
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "isDevopsFeatureDisabledInFedRamp"
            }
        ],
        "kind": "Fragment",
        "metadata": {
            "plural": true
        },
        "name": "ui_softwareReleasesVersionIssueWarningController_IssuesWarningCountProvider_issueEdges",
        "selections": [
            {
                "concreteType": "JiraIssue",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "ids",
                                    "value": [
                                        "priority",
                                        "summary",
                                        "assignee",
                                        "status",
                                        "issuetype"
                                    ]
                                }
                            ],
                            "concreteType": "JiraIssueFieldConnection",
                            "kind": "LinkedField",
                            "name": "fieldsById",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "concreteType": "JiraIssueFieldEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "kind": "ScalarField",
                                                            "name": "fieldId"
                                                        },
                                                        "action": "THROW",
                                                        "path": "node.fieldsById.edges.node.fieldId"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraStatus",
                                                                "kind": "LinkedField",
                                                                "name": "status",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraStatusCategory",
                                                                        "kind": "LinkedField",
                                                                        "name": "statusCategory",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "ScalarField",
                                                                                "name": "statusCategoryId"
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraStatusField"
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    "action": "THROW",
                                    "path": "node.fieldsById.edges"
                                }
                            ],
                            "storageKey": "fieldsById(ids:[\"priority\",\"summary\",\"assignee\",\"status\",\"issuetype\"])"
                        },
                        "action": "THROW",
                        "path": "node.fieldsById"
                    },
                    {
                        "condition": "isDevopsFeatureDisabledInFedRamp",
                        "kind": "Condition",
                        "passingValue": false,
                        "selections": [
                            {
                                "concreteType": "DevOpsSummarisedEntities",
                                "kind": "LinkedField",
                                "name": "devOpsSummarisedEntities",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "DevOpsSummarisedBuilds",
                                        "kind": "LinkedField",
                                        "name": "summarisedBuilds",
                                        "plural": false,
                                        "selections": [
                                            v0 /*: any*/ ,
                                            {
                                                "concreteType": "DevOpsSummarisedBuildState",
                                                "kind": "LinkedField",
                                                "name": "buildStates",
                                                "plural": true,
                                                "selections": [
                                                    v1 /*: any*/ ,
                                                    v0 /*: any*/ 
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "concreteType": "JiraIssueDevSummaryResult",
                                    "kind": "LinkedField",
                                    "name": "devSummaryCache",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "concreteType": "JiraIssueDevSummary",
                                                "kind": "LinkedField",
                                                "name": "devSummary",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "concreteType": "JiraIssuePullRequestDevSummaryContainer",
                                                            "kind": "LinkedField",
                                                            "name": "pullrequest",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": {
                                                                        "concreteType": "JiraIssuePullRequestDevSummary",
                                                                        "kind": "LinkedField",
                                                                        "name": "overall",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": v1 /*: any*/ ,
                                                                                "action": "NONE",
                                                                                "path": "node.devSummaryCache.devSummary.pullrequest.overall.state"
                                                                            },
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": v0 /*: any*/ ,
                                                                                "action": "NONE",
                                                                                "path": "node.devSummaryCache.devSummary.pullrequest.overall.count"
                                                                            }
                                                                        ]
                                                                    },
                                                                    "action": "NONE",
                                                                    "path": "node.devSummaryCache.devSummary.pullrequest.overall"
                                                                }
                                                            ]
                                                        },
                                                        "action": "NONE",
                                                        "path": "node.devSummaryCache.devSummary.pullrequest"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "concreteType": "JiraIssueReviewDevSummaryContainer",
                                                            "kind": "LinkedField",
                                                            "name": "review",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": {
                                                                        "concreteType": "JiraIssueReviewDevSummary",
                                                                        "kind": "LinkedField",
                                                                        "name": "overall",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": v0 /*: any*/ ,
                                                                                "action": "NONE",
                                                                                "path": "node.devSummaryCache.devSummary.review.overall.count"
                                                                            },
                                                                            v1 /*: any*/ 
                                                                        ]
                                                                    },
                                                                    "action": "NONE",
                                                                    "path": "node.devSummaryCache.devSummary.review.overall"
                                                                }
                                                            ]
                                                        },
                                                        "action": "NONE",
                                                        "path": "node.devSummaryCache.devSummary.review"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "concreteType": "JiraIssueCommitDevSummaryContainer",
                                                            "kind": "LinkedField",
                                                            "name": "commit",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": {
                                                                        "concreteType": "JiraIssueCommitDevSummary",
                                                                        "kind": "LinkedField",
                                                                        "name": "overall",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": v0 /*: any*/ ,
                                                                                "action": "NONE",
                                                                                "path": "node.devSummaryCache.devSummary.commit.overall.count"
                                                                            }
                                                                        ]
                                                                    },
                                                                    "action": "NONE",
                                                                    "path": "node.devSummaryCache.devSummary.commit.overall"
                                                                }
                                                            ]
                                                        },
                                                        "action": "NONE",
                                                        "path": "node.devSummaryCache.devSummary.commit"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "concreteType": "JiraIssueBuildDevSummaryContainer",
                                                            "kind": "LinkedField",
                                                            "name": "build",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": {
                                                                        "concreteType": "JiraIssueBuildDevSummary",
                                                                        "kind": "LinkedField",
                                                                        "name": "overall",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": v0 /*: any*/ ,
                                                                                "action": "NONE",
                                                                                "path": "node.devSummaryCache.devSummary.build.overall.count"
                                                                            },
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "failedBuildCount"
                                                                                },
                                                                                "action": "NONE",
                                                                                "path": "node.devSummaryCache.devSummary.build.overall.failedBuildCount"
                                                                            }
                                                                        ]
                                                                    },
                                                                    "action": "NONE",
                                                                    "path": "node.devSummaryCache.devSummary.build.overall"
                                                                }
                                                            ]
                                                        },
                                                        "action": "NONE",
                                                        "path": "node.devSummaryCache.devSummary.build"
                                                    }
                                                ]
                                            },
                                            "action": "NONE",
                                            "path": "node.devSummaryCache.devSummary"
                                        }
                                    ]
                                },
                                "action": "NONE",
                                "path": "node.devSummaryCache"
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraIssueEdge"
    };
}();
$beb6a6dedaacde0a$var$node.hash = "2af391280f3df5e713e3630effb3b264";
var $beb6a6dedaacde0a$export$2e2bcd8739ae039 = $beb6a6dedaacde0a$var$node;

});

parcelRegister("dq471", function(module, exports) {
$parcel$export(module.exports, "default", () => $0f88fe85bc4c8474$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<07ab4de75721935837d0b41078aab8fe>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $0f88fe85bc4c8474$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "ui_softwareReleasesVersionIssueWarningController_IssueWarningProvider_jiraVersion",
    "selections": [
        {
            "concreteType": "JiraVersionWarningConfig",
            "kind": "LinkedField",
            "name": "warningConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "kind": "ScalarField",
                        "name": "openPullRequest"
                    },
                    "action": "NONE",
                    "path": "warningConfig.openPullRequest"
                },
                {
                    "kind": "RequiredField",
                    "field": {
                        "kind": "ScalarField",
                        "name": "openReview"
                    },
                    "action": "NONE",
                    "path": "warningConfig.openReview"
                },
                {
                    "kind": "RequiredField",
                    "field": {
                        "kind": "ScalarField",
                        "name": "unreviewedCode"
                    },
                    "action": "NONE",
                    "path": "warningConfig.unreviewedCode"
                },
                {
                    "kind": "RequiredField",
                    "field": {
                        "kind": "ScalarField",
                        "name": "failingBuild"
                    },
                    "action": "NONE",
                    "path": "warningConfig.failingBuild"
                }
            ]
        }
    ],
    "type": "JiraVersion"
};
$0f88fe85bc4c8474$var$node.hash = "e4b994880d16817a096017c816579b1b";
var $0f88fe85bc4c8474$export$2e2bcd8739ae039 = $0f88fe85bc4c8474$var$node;

});

parcelRegister("dbTOZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $610a91222ce9213f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1d623581b7a92661251cd4486c951a21>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $610a91222ce9213f$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "count"
    }, v1 = {
        "kind": "ScalarField",
        "name": "state"
    }, v2 = [
        v1 /*: any*/ ,
        v0 /*: any*/ 
    ];
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "isDevopsFeatureDisabledInFedRamp"
            }
        ],
        "kind": "Fragment",
        "name": "ui_softwareReleasesVersionIssueWarningController_IssueWarningProvider_jiraIssue",
        "selections": [
            {
                "kind": "RequiredField",
                "field": {
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "ids",
                            "value": [
                                "priority",
                                "summary",
                                "assignee",
                                "status",
                                "issuetype"
                            ]
                        }
                    ],
                    "concreteType": "JiraIssueFieldConnection",
                    "kind": "LinkedField",
                    "name": "fieldsById",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "concreteType": "JiraIssueFieldEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "RequiredField",
                                                "field": {
                                                    "kind": "ScalarField",
                                                    "name": "fieldId"
                                                },
                                                "action": "THROW",
                                                "path": "fieldsById.edges.node.fieldId"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraStatus",
                                                        "kind": "LinkedField",
                                                        "name": "status",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraStatusCategory",
                                                                "kind": "LinkedField",
                                                                "name": "statusCategory",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "statusCategoryId"
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "type": "JiraStatusField"
                                            }
                                        ]
                                    }
                                ]
                            },
                            "action": "THROW",
                            "path": "fieldsById.edges"
                        }
                    ],
                    "storageKey": "fieldsById(ids:[\"priority\",\"summary\",\"assignee\",\"status\",\"issuetype\"])"
                },
                "action": "THROW",
                "path": "fieldsById"
            },
            {
                "condition": "isDevopsFeatureDisabledInFedRamp",
                "kind": "Condition",
                "passingValue": false,
                "selections": [
                    {
                        "concreteType": "DevOpsSummarisedEntities",
                        "kind": "LinkedField",
                        "name": "devOpsSummarisedEntities",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "DevOpsSummarisedBuilds",
                                "kind": "LinkedField",
                                "name": "summarisedBuilds",
                                "plural": false,
                                "selections": [
                                    v0 /*: any*/ ,
                                    {
                                        "concreteType": "DevOpsSummarisedBuildState",
                                        "kind": "LinkedField",
                                        "name": "buildStates",
                                        "plural": true,
                                        "selections": v2 /*: any*/ 
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "concreteType": "JiraIssueDevSummaryResult",
                        "kind": "LinkedField",
                        "name": "devSummaryCache",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "concreteType": "JiraIssueDevSummary",
                                    "kind": "LinkedField",
                                    "name": "devSummary",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "concreteType": "JiraIssuePullRequestDevSummaryContainer",
                                                "kind": "LinkedField",
                                                "name": "pullrequest",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "concreteType": "JiraIssuePullRequestDevSummary",
                                                            "kind": "LinkedField",
                                                            "name": "overall",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v1 /*: any*/ ,
                                                                    "action": "NONE",
                                                                    "path": "devSummaryCache.devSummary.pullrequest.overall.state"
                                                                },
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v0 /*: any*/ ,
                                                                    "action": "NONE",
                                                                    "path": "devSummaryCache.devSummary.pullrequest.overall.count"
                                                                }
                                                            ]
                                                        },
                                                        "action": "NONE",
                                                        "path": "devSummaryCache.devSummary.pullrequest.overall"
                                                    }
                                                ]
                                            },
                                            "action": "NONE",
                                            "path": "devSummaryCache.devSummary.pullrequest"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "concreteType": "JiraIssueCommitDevSummaryContainer",
                                                "kind": "LinkedField",
                                                "name": "commit",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "concreteType": "JiraIssueCommitDevSummary",
                                                            "kind": "LinkedField",
                                                            "name": "overall",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v0 /*: any*/ ,
                                                                    "action": "NONE",
                                                                    "path": "devSummaryCache.devSummary.commit.overall.count"
                                                                }
                                                            ]
                                                        },
                                                        "action": "NONE",
                                                        "path": "devSummaryCache.devSummary.commit.overall"
                                                    }
                                                ]
                                            },
                                            "action": "NONE",
                                            "path": "devSummaryCache.devSummary.commit"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "concreteType": "JiraIssueBuildDevSummaryContainer",
                                                "kind": "LinkedField",
                                                "name": "build",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "concreteType": "JiraIssueBuildDevSummary",
                                                            "kind": "LinkedField",
                                                            "name": "overall",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": {
                                                                        "kind": "ScalarField",
                                                                        "name": "failedBuildCount"
                                                                    },
                                                                    "action": "NONE",
                                                                    "path": "devSummaryCache.devSummary.build.overall.failedBuildCount"
                                                                }
                                                            ]
                                                        },
                                                        "action": "NONE",
                                                        "path": "devSummaryCache.devSummary.build.overall"
                                                    }
                                                ]
                                            },
                                            "action": "NONE",
                                            "path": "devSummaryCache.devSummary.build"
                                        },
                                        {
                                            "concreteType": "JiraIssueReviewDevSummaryContainer",
                                            "kind": "LinkedField",
                                            "name": "review",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssueReviewDevSummary",
                                                    "kind": "LinkedField",
                                                    "name": "overall",
                                                    "plural": false,
                                                    "selections": v2 /*: any*/ 
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "action": "NONE",
                                "path": "devSummaryCache.devSummary"
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraIssue"
    };
}();
$610a91222ce9213f$var$node.hash = "ffa772f7a474b433d08a55e95366246c";
var $610a91222ce9213f$export$2e2bcd8739ae039 = $610a91222ce9213f$var$node;

});


const $bf14b8aa894cb92b$export$b343d4705e10ba61 = 'VersionDetailIssueListIssueCardContainer';
const $bf14b8aa894cb92b$export$6bc465585d114926 = 'VersionDetailsIssueList';
const $bf14b8aa894cb92b$export$eb4c541f23d39ba2 = 1740;
const $bf14b8aa894cb92b$export$ac70ca19af3aa92c = 1380;

parcelRegister("gKV7x", function(module, exports) {
$parcel$export(module.exports, "Assignee", () => $585832b6085f70f4$export$361f73eba39649ac);

var $2XDxP = parcelRequire("2XDxP");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $j4oe4 = parcelRequire("j4oe4");

var $5DgXR = parcelRequire("5DgXR");

var $k71qx = parcelRequire("k71qx");

var $lRq8t = parcelRequire("lRq8t");

var $bqLtg = parcelRequire("bqLtg");
const $585832b6085f70f4$export$361f73eba39649ac = ({ jiraAssigneeField: jiraAssigneeField })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const data = (0, $j4oe4.useFragment)((0, $2XDxP.default), jiraAssigneeField);
    const avatarUrl = data?.user == null ? '' : data.user.picture;
    const displayName = data?.user == null ? formatMessage((0, $bqLtg.default).unassigned) : data.user.name;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($585832b6085f70f4$var$AssigneeContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: displayName,
        position: "bottom-start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($585832b6085f70f4$var$VerticalCenter, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5DgXR.default), {
        appearance: "circle",
        src: avatarUrl,
        size: "small"
    }))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $585832b6085f70f4$var$AssigneeContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1h6o _4t3izwfg _1bsbzwfg _1ul9zwfg _8mocu2gc",
            __cmplp.className
        ])
    });
});
const $585832b6085f70f4$var$VerticalCenter = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("2XDxP", function(module, exports) {
$parcel$export(module.exports, "default", () => $1547c59486815e5d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<0f9ca0ad69f75332a07996cc07876757>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $1547c59486815e5d$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "assignee_softwareReleasesVersionDetailIssueList",
    "selections": [
        {
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "picture"
                },
                {
                    "kind": "ScalarField",
                    "name": "name"
                }
            ]
        }
    ],
    "type": "JiraSingleSelectUserPickerField"
};
$1547c59486815e5d$var$node.hash = "a79331910374d5f581f31a15777ff330";
var $1547c59486815e5d$export$2e2bcd8739ae039 = $1547c59486815e5d$var$node;

});

parcelRegister("bqLtg", function(module, exports) {
$parcel$export(module.exports, "default", () => $4e8e2b4071bb6ca7$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $4e8e2b4071bb6ca7$var$messages = (0, $7qGN1.defineMessages)({
    unassigned: {
        "id": "software-releases-version-detail-issue-list.issues.issue-card.assignee.unassigned",
        "defaultMessage": "Unassigned"
    }
});
var $4e8e2b4071bb6ca7$export$2e2bcd8739ae039 = $4e8e2b4071bb6ca7$var$messages;

});


parcelRegister("l0sHK", function(module, exports) {
$parcel$export(module.exports, "DeliveryInfo", () => $830c4b280d294a23$export$61f40ad692662ca7);
$parcel$export(module.exports, "Delivery", () => $830c4b280d294a23$export$12cbedef95fe0035);
$parcel$export(module.exports, "DeliveryContainer", () => $830c4b280d294a23$export$8901d2e97ed55253);

var $lGNj3 = parcelRequire("lGNj3");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $12DRg = parcelRequire("12DRg");

var $j4oe4 = parcelRequire("j4oe4");


var $ihplE = parcelRequire("ihplE");

var $1A9lq = parcelRequire("1A9lq");


var $4HIFl = parcelRequire("4HIFl");


var $irNJ5 = parcelRequire("irNJ5");

var $4ISMJ = parcelRequire("4ISMJ");

var $3x5hB = parcelRequire("3x5hB");

var $6XmLY = parcelRequire("6XmLY");
const $830c4b280d294a23$var$getDeploymentDetails = (devOpsSummarisedEntities)=>{
    const summaries = devOpsSummarisedEntities?.summarisedDeployments;
    if (!summaries) return undefined;
    const { deploymentState: deploymentState, deploymentEnvironment: deploymentEnvironment } = summaries;
    return {
        deploymentState: deploymentState ?? undefined,
        deploymentEnvironment: deploymentEnvironment?.category ?? undefined
    };
};
const $830c4b280d294a23$export$61f40ad692662ca7 = ({ issueId: issueId, scopeId: scopeId, customTrigger: customTrigger, devSummaryCache: devSummaryCache, devOpsSummarisedEntities: devOpsSummarisedEntities, zIndexForPopup: zIndexForPopup, location: location, onClick: onClick = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))) })=>{
    const devSummary = devSummaryCache?.devSummary;
    const hasBambooDeployments = (devSummary?.deploymentEnvironments?.overall?.topEnvironments ?? []).filter((deployment)=>deployment.status === 'DEPLOYED').length > 0;
    const hasBuilds = Number(devSummary?.build?.overall?.count) > 0 || Number(devOpsSummarisedEntities?.summarisedBuilds?.count) > 0;
    const deploymentCount = devOpsSummarisedEntities?.summarisedDeployments?.count ?? 0;
    const hasDeployments = deploymentCount > 0;
    if (devOpsSummarisedEntities != null && hasDeployments) {
        const deploymentDetails = $830c4b280d294a23$var$getDeploymentDetails(devOpsSummarisedEntities);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1A9lq.default), {
            devInfoType: (0, $ihplE.DevInfoTypes).DEPLOYMENT,
            issueId: Number(issueId),
            customTrigger: customTrigger,
            scopeId: scopeId,
            deploymentDetails: deploymentDetails,
            zIndex: zIndexForPopup,
            location: location
        });
    }
    if (devSummary != null && hasBambooDeployments) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4ISMJ.BambooDeploymentData), {
        jiraIssueDevSummary: devSummary,
        onDeploymentClicked: ()=>onClick((0, $e31f0ec65fa77dec$export$90cac6260ae9ced5))
    });
    if (devSummary != null && hasBuilds) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3x5hB.BuildData), {
        devOpsSummarisedBuilds: devOpsSummarisedEntities?.summarisedBuilds ?? undefined,
        jiraIssueDevSummary: devSummary,
        onBuildClicked: ()=>onClick((0, $e31f0ec65fa77dec$export$74a388a09f2a004e))
    });
    return null;
};
const $830c4b280d294a23$export$12cbedef95fe0035 = ({ jiraIssue: jiraIssue, onClick: onClick })=>{
    const { issueId: issueId, devSummaryCache: devSummaryCache, devOpsSummarisedEntities: devOpsSummarisedEntities, summarisedDeployments: summarisedDeployments, summarisedBuilds: summarisedBuilds } = (0, $j4oe4.useFragment)((0, $lGNj3.default), jiraIssue);
    const devSummary = devSummaryCache?.devSummary;
    const hasBambooDeployments = (devSummary?.deploymentEnvironments?.overall?.topEnvironments ?? []).filter((deployment)=>deployment.status === 'DEPLOYED').length > 0;
    const hasBuilds = Number(devSummary?.build?.overall?.count) > 0 || Number(summarisedBuilds?.count) > 0;
    const deploymentCount = summarisedDeployments?.count ?? 0;
    const hasDeployments = deploymentCount > 0;
    if (devOpsSummarisedEntities != null && hasDeployments) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($830c4b280d294a23$export$8901d2e97ed55253, {
        "data-version-details-issue-click-ignore-target": (0, $4HIFl.ISSUE_CARD_CLICK_IGNORE_TARGET)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $irNJ5.ErrorBoundary), {
        id: "issuesListDeploymentData"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1A9lq.default), {
        devInfoType: (0, $ihplE.DevInfoTypes).DEPLOYMENT,
        issueId: Number(issueId),
        customTrigger: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6XmLY.DeploymentData), {
            jiraIssueDevOpsSummarisedEntities: devOpsSummarisedEntities,
            onDeploymentClicked: ()=>onClick((0, $e31f0ec65fa77dec$export$90cac6260ae9ced5))
        }),
        scopeId: (0, $bf14b8aa894cb92b$export$6bc465585d114926),
        isStopPropagationOnClick: false,
        location: (0, $2425df669549d924$export$ede40e627a0cbf14)
    })));
    if (devSummary != null && hasBambooDeployments) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($830c4b280d294a23$export$8901d2e97ed55253, {
        "data-version-details-issue-click-ignore-target": (0, $4HIFl.ISSUE_CARD_CLICK_IGNORE_TARGET)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $irNJ5.ErrorBoundary), {
        id: "issuesListBambooDeploymentData"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4ISMJ.BambooDeploymentData), {
        jiraIssueDevSummary: devSummary,
        onDeploymentClicked: ()=>onClick((0, $e31f0ec65fa77dec$export$90cac6260ae9ced5))
    })));
    if (devSummary != null && hasBuilds) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($830c4b280d294a23$export$8901d2e97ed55253, {
        "data-version-details-issue-click-ignore-target": (0, $4HIFl.ISSUE_CARD_CLICK_IGNORE_TARGET)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $irNJ5.ErrorBoundary), {
        fallback: "flag",
        id: "issuesListBuildData"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3x5hB.BuildData), {
        devOpsSummarisedBuilds: summarisedBuilds ?? undefined,
        jiraIssueDevSummary: devSummary,
        onBuildClicked: ()=>onClick((0, $e31f0ec65fa77dec$export$74a388a09f2a004e))
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($830c4b280d294a23$export$8901d2e97ed55253, null);
};
const $830c4b280d294a23$export$8901d2e97ed55253 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_17av1lit _fmdx1lit _jyrf1tcg _3ufp1tcg",
            __cmplp.className
        ])
    });
});

});
parcelRegister("lGNj3", function(module, exports) {
$parcel$export(module.exports, "default", () => $79dda9408c180fa2$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f4f897058d07ec624ab4dc06192c57c2>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $79dda9408c180fa2$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "count"
    }, v1 = [
        v0 /*: any*/ 
    ], v2 = {
        "concreteType": "DevOpsSummarisedDeployments",
        "kind": "LinkedField",
        "name": "summarisedDeployments",
        "plural": false,
        "selections": v1 /*: any*/ 
    }, v3 = {
        "kind": "FragmentSpread",
        "name": "buildData_softwareReleasesVersionDetailIssueList_devOpsSummarisedBuilds"
    };
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "shouldIncludeDevOpsFieldsViaAgs"
            }
        ],
        "kind": "Fragment",
        "name": "delivery_softwareReleasesVersionDetailIssueList",
        "selections": [
            {
                "concreteType": "DevOpsSummarisedEntities",
                "kind": "LinkedField",
                "name": "devOpsSummarisedEntities",
                "plural": false,
                "selections": [
                    v2 /*: any*/ ,
                    {
                        "concreteType": "DevOpsSummarisedBuilds",
                        "kind": "LinkedField",
                        "name": "summarisedBuilds",
                        "plural": false,
                        "selections": [
                            v0 /*: any*/ ,
                            v3 /*: any*/ 
                        ]
                    },
                    {
                        "kind": "FragmentSpread",
                        "name": "deploymentData_softwareReleasesVersionDetailIssueList"
                    }
                ]
            },
            {
                "condition": "shouldIncludeDevOpsFieldsViaAgs",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    v2 /*: any*/ ,
                    {
                        "concreteType": "DevOpsSummarisedBuilds",
                        "kind": "LinkedField",
                        "name": "summarisedBuilds",
                        "plural": false,
                        "selections": [
                            v3 /*: any*/ ,
                            v0 /*: any*/ 
                        ]
                    }
                ]
            },
            {
                "concreteType": "JiraIssueDevSummaryResult",
                "kind": "LinkedField",
                "name": "devSummaryCache",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraIssueDevSummary",
                        "kind": "LinkedField",
                        "name": "devSummary",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraIssueBuildDevSummaryContainer",
                                "kind": "LinkedField",
                                "name": "build",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraIssueBuildDevSummary",
                                        "kind": "LinkedField",
                                        "name": "overall",
                                        "plural": false,
                                        "selections": v1 /*: any*/ 
                                    }
                                ]
                            },
                            {
                                "concreteType": "JiraIssueDeploymentEnvironmentDevSummaryContainer",
                                "kind": "LinkedField",
                                "name": "deploymentEnvironments",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraIssueDeploymentEnvironmentDevSummary",
                                        "kind": "LinkedField",
                                        "name": "overall",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraIssueDeploymentEnvironment",
                                                "kind": "LinkedField",
                                                "name": "topEnvironments",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "status"
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "bambooDeploymentData_softwareReleasesVersionDetailIssueList"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "buildData_softwareReleasesVersionDetailIssueList_jiraIssueDevSummary"
                            }
                        ]
                    }
                ]
            },
            {
                "kind": "ScalarField",
                "name": "issueId"
            }
        ],
        "type": "JiraIssue"
    };
}();
$79dda9408c180fa2$var$node.hash = "cc5169ba959e61a60ddf7a3d0ca12b66";
var $79dda9408c180fa2$export$2e2bcd8739ae039 = $79dda9408c180fa2$var$node;

});

const $2425df669549d924$export$9b8283d5878d2491 = 'board';
const $2425df669549d924$export$76a449e52fa0e1e8 = 'issue';
const $2425df669549d924$export$ede40e627a0cbf14 = 'version_details';
const $2425df669549d924$export$464c50016d069471 = 'issue_view_child_issues_list';
const $2425df669549d924$export$3a46c5b594c0f84c = 'issue_view_linked_issues_list';

parcelRegister("ihplE", function(module, exports) {
$parcel$export(module.exports, "DevInfoTypes", () => $955f77e570d8bbac$export$a100703e17b2650a);
$parcel$export(module.exports, "DevInfoTypeMap", () => $955f77e570d8bbac$export$39c00ace65e13f2d);
$parcel$export(module.exports, "ButtonStatus", () => $955f77e570d8bbac$export$477d4d2d93581a40);
const $955f77e570d8bbac$export$a100703e17b2650a = Object.freeze({
    BRANCH: 'branch',
    COMMIT: 'commit',
    PULLREQUEST: 'pullrequest',
    DECLINED: 'declined',
    MERGED: 'merged',
    DEPLOYMENT: 'deployment',
    DESIGN: 'design'
});
const $955f77e570d8bbac$export$39c00ace65e13f2d = {
    [$955f77e570d8bbac$export$a100703e17b2650a.BRANCH]: 'branch',
    [$955f77e570d8bbac$export$a100703e17b2650a.COMMIT]: 'commit',
    [$955f77e570d8bbac$export$a100703e17b2650a.PULLREQUEST]: 'pull request',
    [$955f77e570d8bbac$export$a100703e17b2650a.MERGED]: 'pull request',
    [$955f77e570d8bbac$export$a100703e17b2650a.DECLINED]: 'pull request',
    [$955f77e570d8bbac$export$a100703e17b2650a.DEPLOYMENT]: 'deployment',
    [$955f77e570d8bbac$export$a100703e17b2650a.DESIGN]: 'design'
};
const $955f77e570d8bbac$export$477d4d2d93581a40 = Object.freeze({
    ACTIVE: 'active',
    HOVER: 'hover',
    DEFAULT: 'default'
});

});

parcelRegister("1A9lq", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "DevInfoIconView", () => $369abbd35031240e$export$b98af1fb6b8b345e);
$parcel$export(module.exports, "default", () => $369abbd35031240e$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $LFmXM = parcelRequire("LFmXM");

var $1jVV7 = parcelRequire("1jVV7");

var $abjs4 = parcelRequire("abjs4");

var $awZZu = parcelRequire("awZZu");

var $bzGVj = parcelRequire("bzGVj");

var $7XCnf = parcelRequire("7XCnf");

var $guB6Y = parcelRequire("guB6Y");

var $j0bRy = parcelRequire("j0bRy");

var $MUJuW = parcelRequire("MUJuW");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $ghO0p = parcelRequire("ghO0p");

var $eSnSE = parcelRequire("eSnSE");


var $ihplE = parcelRequire("ihplE");

var $2mWl5 = parcelRequire("2mWl5");

var $51yhA = parcelRequire("51yhA");

var $dPIoB = parcelRequire("dPIoB");

var $dZ3jN = parcelRequire("dZ3jN");

var $cBavF = parcelRequire("cBavF");

var $kdtFw = parcelRequire("kdtFw");

var $iWvkh = parcelRequire("iWvkh");

var $5vQ2T = parcelRequire("5vQ2T");

var $8Uqf3 = parcelRequire("8Uqf3");

var $4ctwv = parcelRequire("4ctwv");

var $9Fnbb = parcelRequire("9Fnbb");

var $lRq8t = parcelRequire("lRq8t");

var $irfiw = parcelRequire("irfiw");

var $8oKDI = parcelRequire("8oKDI");

var $8nMzv = parcelRequire("8nMzv");

var $kGj4V = parcelRequire("kGj4V");

var $5HFSX = parcelRequire("5HFSX");

var $6rP4O = parcelRequire("6rP4O");

var $koAZ4 = parcelRequire("koAZ4");

var $4cTDP = parcelRequire("4cTDP");

var $jgZxT = parcelRequire("jgZxT");

var $4C7GN = parcelRequire("4C7GN");
const $369abbd35031240e$var$DEV_INFO_BUTTON_ID = 'development-board-dev-info-icon.button-text';
const $369abbd35031240e$var$DevInfoIconsMapping = (0, $LFmXM.default)((formatMessage)=>({
        [(0, $ihplE.DevInfoTypes).BRANCH]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($awZZu))), {
            label: formatMessage((0, $4C7GN.default).branchIconLabel),
            color: "var(--ds-icon, #292A2E)"
        }),
        [(0, $ihplE.DevInfoTypes).COMMIT]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7XCnf))), {
            label: formatMessage((0, $4C7GN.default).commitIconLabel),
            color: "var(--ds-icon, #292A2E)"
        }),
        [(0, $ihplE.DevInfoTypes).PULLREQUEST]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($MUJuW))), {
            label: formatMessage((0, $4C7GN.default).openPullRequestIconLabel),
            color: "var(--ds-icon, #292A2E)"
        }),
        [(0, $ihplE.DevInfoTypes).DECLINED]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($guB6Y))), {
            label: formatMessage((0, $4C7GN.default).declinedPullRequestIconLabel),
            color: "var(--ds-icon, #292A2E)"
        }),
        [(0, $ihplE.DevInfoTypes).MERGED]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($j0bRy))), {
            label: formatMessage((0, $4C7GN.default).mergedPullRequestIconLabel),
            color: "var(--ds-icon-accent-green, #22A06B)"
        }),
        [(0, $ihplE.DevInfoTypes).DEPLOYMENT]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bzGVj))), {
            label: formatMessage((0, $4C7GN.default).deploymentIconLabel),
            color: "var(--ds-icon, #292A2E)"
        }),
        [(0, $ihplE.DevInfoTypes).DESIGN]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            xcss: $369abbd35031240e$var$DesignIconStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9Fnbb.default), {
            label: formatMessage((0, $4C7GN.default).designIconLabel)
        }))
    }));
const $369abbd35031240e$var$getDevInfoIcon = (devInfoType, formatMessage, deploymentDetails)=>{
    if (deploymentDetails?.deploymentState && deploymentDetails?.deploymentEnvironment) {
        if (deploymentDetails.deploymentEnvironment === (0, $jgZxT.DeploymentEnvironment).PRODUCTION && deploymentDetails.deploymentState === (0, $jgZxT.DeploymentState).SUCCESSFUL) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dPIoB.DeploymentProdSuccess), {
            size: "small",
            label: formatMessage((0, $4C7GN.default).deploymentProductionSuccessIconLabel)
        });
        if (deploymentDetails.deploymentEnvironment === (0, $jgZxT.DeploymentEnvironment).PRODUCTION && deploymentDetails.deploymentState === (0, $jgZxT.DeploymentState).FAILED) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dPIoB.DeploymentProdFailed), {
            size: "small",
            label: formatMessage((0, $4C7GN.default).deploymentProductionFailedIconLabel)
        });
        if (deploymentDetails.deploymentEnvironment !== (0, $jgZxT.DeploymentEnvironment).PRODUCTION && deploymentDetails.deploymentState === (0, $jgZxT.DeploymentState).SUCCESSFUL) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dPIoB.DeploymentNonProdSuccess), {
            size: "small",
            label: formatMessage((0, $4C7GN.default).deploymentNonProductionSuccessIconLabel)
        });
        if (deploymentDetails.deploymentEnvironment !== (0, $jgZxT.DeploymentEnvironment).PRODUCTION && deploymentDetails.deploymentState === (0, $jgZxT.DeploymentState).FAILED) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dPIoB.DeploymentNonProdFailed), {
            size: "small",
            label: formatMessage((0, $4C7GN.default).deploymentNonProductionFailedIconLabel)
        });
    }
    return $369abbd35031240e$var$DevInfoIconsMapping(formatMessage)[devInfoType];
};
const $369abbd35031240e$var$TriggerComponent = ({ triggerProps: triggerProps, customTrigger: customTrigger })=>{
    const omitProp = (prop, { [prop]: _, ...rest })=>rest;
    const modifierTriggerProps = omitProp('aria-expanded', triggerProps);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", modifierTriggerProps, customTrigger);
};
const $369abbd35031240e$export$b98af1fb6b8b345e = ({ issueId: issueId, devInfoType: devInfoType, allowNativeContextMenu: allowNativeContextMenu, customTrigger: customTrigger, scopeId: scopeId, deploymentDetails: deploymentDetails, isStopPropagationOnClick: isStopPropagationOnClick = true, placement: placement = 'bottom-start', offset: offset, zIndex: /* Setting zIndex slighlty lower than the default so that other popups (like the right-click context menu) appear on top of this */ zIndex = (0, $1jVV7.layers).layer - 1 })=>{
    const [isOpen, setIsOpen] = (0, $eJOHy.useState)(false);
    const [isHoverMode, setIsHoverMode] = (0, $eJOHy.useState)(true);
    const [shouldAutoFocus, setShouldAutoFocus] = (0, $eJOHy.useState)(true);
    const timeoutRef = (0, $eJOHy.useRef)(undefined);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { cloudId: cloudId } = (0, $koAZ4.useTenantContext)();
    const issueAri = (0, $eJOHy.useMemo)(()=>(0, $51yhA.createIssueAri)(cloudId, issueId.toString()), [
        cloudId,
        issueId
    ]);
    const siteAri = (0, $8oKDI.createAri)({
        resourceOwner: 'jira',
        resourceType: 'site',
        resourceId: cloudId
    });
    const initialTrigger = (0, $eJOHy.useRef)(null);
    const devInfoIcon = $369abbd35031240e$var$getDevInfoIcon(devInfoType, formatMessage, deploymentDetails);
    const popupType = devInfoType === (0, $ihplE.DevInfoTypes).MERGED || devInfoType === (0, $ihplE.DevInfoTypes).DECLINED ? (0, $ihplE.DevInfoTypes).PULLREQUEST : devInfoType;
    const { id: experienceId, name: experienceName } = (0, $jgZxT.experienceDetails)[popupType];
    const onExperienceSuccess = (0, $4ctwv.useExperienceSuccess)({
        experience: experienceName
    });
    const entryPointParams = (0, $eJOHy.useMemo)(()=>({
            issueId: issueAri
        }), [
        issueAri
    ]); // eslint-disable-next-line @atlassian/react-entrypoint/prefer-entrypoint-file-import
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject, stopMetric: stopMetric } = (0, $iWvkh.useEntryPoint)((0, $4cTDP.fg)('jira_devinfo_migration_dd_to_ugs') ? (0, $jgZxT.popupEntryPoints)[popupType] : (0, $jgZxT.popupEntryPointsOld)[popupType], entryPointParams, (0, $jgZxT.metrics)[popupType]); // Entry point for the design modal that is used in the design details popup
    const designEntrypoint = (0, $iWvkh.useEntryPoint)((0, $irfiw.designModalEntryPoint), {
        siteAri: siteAri,
        issueAri: issueAri,
        cloudId: cloudId
    });
    const designModalTriggerRef = (0, $dZ3jN.useEntryPointButtonTrigger)(designEntrypoint.entryPointActions);
    const entryPointErrorBoundaryProps = (0, $eJOHy.useMemo)(()=>({
            ...(0, $jgZxT.packageDetails)[popupType],
            errorFallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mWl5.default), {
                    devInfoType: devInfoType,
                    issueAri: issueAri,
                    scopeId: scopeId
                })
        }), [
        devInfoType,
        issueAri,
        popupType,
        scopeId
    ]);
    const runtimeProps = (0, $eJOHy.useMemo)(()=>({
            issueAri: issueAri,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            devInfoType: devInfoType,
            trigger: initialTrigger.current ?? undefined,
            onReady: ()=>{
                stopMetric();
                onExperienceSuccess();
            },
            scopeId: scopeId,
            modalTriggerRef: devInfoType === (0, $ihplE.DevInfoTypes).DESIGN ? designModalTriggerRef : undefined
        }), [
        issueAri,
        devInfoType,
        scopeId,
        designModalTriggerRef,
        stopMetric,
        onExperienceSuccess
    ]);
    const handleDevIconClick = (0, $eJOHy.useCallback)(()=>{
        clearTimeout(timeoutRef.current);
        if (initialTrigger.current === null) initialTrigger.current = 'click';
        if (isOpen && isHoverMode) setIsHoverMode(false);
        else if (isOpen && !isHoverMode) {
            initialTrigger.current = null;
            setIsOpen(false);
            setIsHoverMode(true);
        } else {
            entryPointActions.load();
            setShouldAutoFocus(true);
            setIsOpen(true);
            setIsHoverMode(false);
        }
    }, [
        entryPointActions,
        isHoverMode,
        isOpen
    ]);
    const handleMouseEnter = ()=>{
        if (!isHoverMode) return;
        clearTimeout(timeoutRef.current);
        setShouldAutoFocus(false);
        if (!isOpen) {
            entryPointActions.preload();
            timeoutRef.current = undefined;
            timeoutRef.current = setTimeout(()=>{
                if (initialTrigger.current === null) initialTrigger.current = 'hover';
                entryPointActions.load();
                setIsOpen(true);
            }, (0, $jgZxT.HOVER_TIMEOUT_MS));
        }
    };
    const handleMouseLeave = ()=>{
        if (!isHoverMode) return;
        clearTimeout(timeoutRef.current);
        entryPointActions.cancelPreload();
        timeoutRef.current = undefined;
        if (isOpen) timeoutRef.current = setTimeout(()=>{
            initialTrigger.current = null;
            setShouldAutoFocus(true);
            setIsHoverMode(true);
            setIsOpen(false);
        }, (0, $jgZxT.HOVER_TIMEOUT_MS));
    };
    if ((0, $jgZxT.iconColor)[devInfoType] === undefined) (0, $eSnSE.default).safeErrorWithoutCustomerData('packages.development.board.dev-info-icon', 'unexpected devInfoType', {
        devInfoType: devInfoType
    });
    const customTheme = (0, $ghO0p.getTheme)({
        buttonStyles: {
            subtle: {
                color: {
                    // @ts-expect-error - TS2322 - Type '{ color: { default: string | undefined; hover: string | undefined; active: string | undefined; }; }' is not assignable to type 'CSSInterpolation'. | TS2532 - Object is possibly 'undefined'.
                    default: (0, $jgZxT.iconColor)[devInfoType][(0, $ihplE.ButtonStatus).DEFAULT],
                    hover: (0, $jgZxT.iconColor)[devInfoType][(0, $ihplE.ButtonStatus).HOVER],
                    active: (0, $jgZxT.iconColor)[devInfoType][(0, $ihplE.ButtonStatus).ACTIVE]
                }
            }
        }
    });
    const devInfoTextId = `${$369abbd35031240e$var$DEV_INFO_BUTTON_ID}-${issueId}`;
    return(// eslint-disable-next-line @atlassian/a11y/interactive-element-not-keyboard-focusable
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("span", {
        role: "presentation",
        "data-testid": "development-board-dev-info-icon.container" // eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events
        ,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        onClick: (e)=>{
            // Prevents clicks on the icon from opening the Issue view
            if (isStopPropagationOnClick) e.stopPropagation();
        },
        onKeyDown: (e)=>{
            // Prevents using keyboard to open the Issue view
            e.stopPropagation();
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nMzv.JiraPopup), {
        placement: placement,
        shouldFlip: true,
        autoFocus: shouldAutoFocus,
        shouldUseCaptureOnOutsideClick: true,
        testId: "development-board-dev-info-icon.popup",
        messageId: "development-board-dev-info-icon.popup",
        messageType: "transactional",
        trigger: (triggerProps)=>customTrigger != null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($369abbd35031240e$var$TriggerComponent, {
                triggerProps: triggerProps,
                customTrigger: customTrigger
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $abjs4.default), {
                ...triggerProps,
                onClick: handleDevIconClick,
                isSelected: isOpen && !isHoverMode,
                theme: customTheme,
                appearance: "subtle",
                spacing: "compact",
                iconBefore: devInfoIcon,
                "aria-describedby": devInfoTextId
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($369abbd35031240e$var$DevInfoButtonText, {
                id: devInfoTextId
            }, (0, $jgZxT.DevInfoButtonLabelMapping)(formatMessage)[devInfoType])),
        isOpen: isOpen,
        onClose: ()=>{
            initialTrigger.current = null;
            setIsOpen(false);
            setIsHoverMode(true);
        },
        offset: offset,
        zIndex: zIndex,
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div" // We are stopping right-click event propagation to not show the custom context menu from the Jira Issue Card
            , {
                // and instead use the event default
                onContextMenu: (event)=>{
                    if (!allowNativeContextMenu) event.preventDefault();
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8Uqf3.ExperienceStart), {
                analyticsSource: experienceName,
                experience: experienceName,
                experienceId: experienceId
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
                entryPointReferenceSubject: entryPointReferenceSubject,
                ...entryPointErrorBoundaryProps,
                fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6rP4O.DevInfoDetailsPopupSkeleton), {
                    devinfoType: popupType
                }),
                runtimeProps: runtimeProps
            }))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kdtFw.ModalEntryPointContainer), {
        entryPointReferenceSubject: designEntrypoint.entryPointReferenceSubject,
        id: "jiraDesignModal",
        packageName: "design-modal",
        entryPointActions: designEntrypoint.entryPointActions,
        runtimeProps: {
            initialSelectedDesign: 0
        }
    })));
};
const $369abbd35031240e$var$ERROR_ID = 'renderDevInfoIcon';
const $369abbd35031240e$var$PACKAGE_NAME = 'jiraDevelopmentBoardDevInfoIcon';
const $369abbd35031240e$var$DevInfoIcon = ({ issueId: issueId, devInfoType: devInfoType, allowNativeContextMenu: allowNativeContextMenu, customTrigger: customTrigger, scopeId: scopeId, deploymentDetails: deploymentDetails, isStopPropagationOnClick: isStopPropagationOnClick = true, placement: placement, offset: offset, zIndex: zIndex, location: location = (0, $2425df669549d924$export$9b8283d5878d2491) })=>{
    const attributes = {
        devInfoType: devInfoType ?? 'unexpected',
        location: location
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        id: $369abbd35031240e$var$ERROR_ID,
        packageName: $369abbd35031240e$var$PACKAGE_NAME,
        teamName: "jolt",
        fallback: "unmount",
        attributes: attributes,
        extraEventData: attributes,
        sendToPrivacyUnsafeSplunk: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5HFSX.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kGj4V.ContextualAnalyticsData), {
        sourceType: (0, $aa42ce8e355d58fa$export$cae2783c9279926),
        sourceName: "DevInfoIcon",
        attributes: attributes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($369abbd35031240e$export$b98af1fb6b8b345e, {
        issueId: issueId,
        devInfoType: devInfoType,
        allowNativeContextMenu: allowNativeContextMenu,
        customTrigger: customTrigger,
        scopeId: scopeId,
        deploymentDetails: deploymentDetails,
        isStopPropagationOnClick: isStopPropagationOnClick,
        placement: placement,
        offset: offset,
        zIndex: zIndex
    }))));
};
var $369abbd35031240e$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $369abbd35031240e$var$DevInfoIcon;
const $369abbd35031240e$var$DevInfoButtonText = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0cglyw",
            __cmplp.className
        ])
    });
});
const $369abbd35031240e$var$DesignIconStyles = (0, $1DXK0.xcss)({
    height: '16px',
    width: '16px',
    display: 'flex',
    justifyContent: 'center'
});

});
parcelRegister("awZZu", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5d8d971bf9def65ea3fd98a53d2a797b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7aacfa98324a1e60$var$_react = $7aacfa98324a1e60$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $7aacfa98324a1e60$var$_baseNew = $7aacfa98324a1e60$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $7aacfa98324a1e60$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Branch".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for branches in Bitbucket and Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7aacfa98324a1e60$var$BranchIcon = (props)=>/*#__PURE__*/ $7aacfa98324a1e60$var$_react.default.createElement($7aacfa98324a1e60$var$_baseNew.default, Object.assign({
        name: "BranchIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4.25 2.5a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5M2 3.25a2.25 2.25 0 1 1 3 2.122V9H3.5V5.372A2.25 2.25 0 0 1 2 3.25m9.75-.75a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m-2.25.75a2.25 2.25 0 1 1 3 2.122v4.878a3.25 3.25 0 0 1-3.25 3.25H6.372a2.25 2.25 0 1 1 0-1.5H9.25A1.75 1.75 0 0 0 11 10.25V5.372A2.25 2.25 0 0 1 9.5 3.25M4.25 12a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5" clip-rule="evenodd"/>`
    }, props));
$7aacfa98324a1e60$var$BranchIcon.displayName = 'BranchIcon';
var $7aacfa98324a1e60$var$_default = module.exports.default = $7aacfa98324a1e60$var$BranchIcon;

});

parcelRegister("bzGVj", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c02a973e1b80a41efb48b80326ffc315>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $86d44242ca1c7b8f$var$_react = $86d44242ca1c7b8f$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $86d44242ca1c7b8f$var$_baseNew = $86d44242ca1c7b8f$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $86d44242ca1c7b8f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CloudArrowUp".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: deployments in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $86d44242ca1c7b8f$var$CloudArrowUpIcon = (props)=>/*#__PURE__*/ $86d44242ca1c7b8f$var$_react.default.createElement($86d44242ca1c7b8f$var$_baseNew.default, Object.assign({
        name: "CloudArrowUpIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 3a4.25 4.25 0 0 0-4.236 3.9.75.75 0 0 1-.565.668A2.251 2.251 0 0 0 3.75 12v1.5a3.75 3.75 0 0 1-1.418-7.222 5.751 5.751 0 0 1 11.239-.458A4 4 0 0 1 12 13.5V12a2.5 2.5 0 0 0 .712-4.897.75.75 0 0 1-.526-.59A4.25 4.25 0 0 0 8 3m0 4a.75.75 0 0 1 .53.22l3 3-1.06 1.06-1.72-1.72V16h-1.5V9.56l-1.72 1.72-1.06-1.06 3-3A.75.75 0 0 1 8 7" clip-rule="evenodd"/>`
    }, props));
$86d44242ca1c7b8f$var$CloudArrowUpIcon.displayName = 'CloudArrowUpIcon';
var $86d44242ca1c7b8f$var$_default = module.exports.default = $86d44242ca1c7b8f$var$CloudArrowUpIcon;

});

parcelRegister("7XCnf", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6ab489d2a38e8a0acc1962f05ff04e40>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5cbbcf5690c6b367$var$_react = $5cbbcf5690c6b367$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $5cbbcf5690c6b367$var$_baseNew = $5cbbcf5690c6b367$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $5cbbcf5690c6b367$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Commit".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for commits in Jira or Bitbucket.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5cbbcf5690c6b367$var$CommitIcon = (props)=>/*#__PURE__*/ $5cbbcf5690c6b367$var$_react.default.createElement($5cbbcf5690c6b367$var$_baseNew.default, Object.assign({
        name: "CommitIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M7.25 5.354a2.751 2.751 0 0 0 0 5.292V16h1.5v-5.353a2.751 2.751 0 0 0 0-5.293V0h-1.5zM8 6.75a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5" clip-rule="evenodd"/>`
    }, props));
$5cbbcf5690c6b367$var$CommitIcon.displayName = 'CommitIcon';
var $5cbbcf5690c6b367$var$_default = module.exports.default = $5cbbcf5690c6b367$var$CommitIcon;

});

parcelRegister("guB6Y", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::aa3ac1cb079d613c521a1d89096297a4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c01c3c443729d7ac$var$_react = $c01c3c443729d7ac$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $c01c3c443729d7ac$var$_baseNew = $c01c3c443729d7ac$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $c01c3c443729d7ac$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "MergeFailure".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for branches in Bitbucket and Jira that have failed to merge.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c01c3c443729d7ac$var$MergeFailureIcon = (props)=>/*#__PURE__*/ $c01c3c443729d7ac$var$_react.default.createElement($c01c3c443729d7ac$var$_baseNew.default, Object.assign({
        name: "MergeFailureIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3.19 3.25 1.47 1.53 2.53.47l1.72 1.72L5.97.47l1.06 1.06-1.72 1.72 1.72 1.72-1.06 1.06-1.72-1.72-1.72 1.72-1.06-1.06zM8.5 2.5h1.25a2.75 2.75 0 0 1 2.75 2.75v5.378a2.251 2.251 0 1 1-1.5 0V5.25C11 4.56 10.44 4 9.75 4H8.5zm-5 8.128V7.5H5v3.128a2.251 2.251 0 1 1-1.5 0M4.25 12a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m7.5 0a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5" clip-rule="evenodd"/>`
    }, props));
$c01c3c443729d7ac$var$MergeFailureIcon.displayName = 'MergeFailureIcon';
var $c01c3c443729d7ac$var$_default = module.exports.default = $c01c3c443729d7ac$var$MergeFailureIcon;

});

parcelRegister("j0bRy", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::29b3c3398bed31dbea6a6d22470908b9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dd5738169219237b$var$_react = $dd5738169219237b$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $dd5738169219237b$var$_baseNew = $dd5738169219237b$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $dd5738169219237b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "MergeSuccess".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for branches in Bitbucket and Jira that have successfully merged.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $dd5738169219237b$var$MergeSuccessIcon = (props)=>/*#__PURE__*/ $dd5738169219237b$var$_react.default.createElement($dd5738169219237b$var$_baseNew.default, Object.assign({
        name: "MergeSuccessIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m6.174.77 1.152.96-3.333 4a.75.75 0 0 1-1.152 0l-1.667-2 1.152-.96 1.09 1.308zM8.5 2.5h1.25a2.75 2.75 0 0 1 2.75 2.75v5.378a2.251 2.251 0 1 1-1.5 0V5.25C11 4.56 10.44 4 9.75 4H8.5zm-5 8.128V7.5H5v3.128a2.251 2.251 0 1 1-1.5 0M4.25 12a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m7.5 0a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5" clip-rule="evenodd"/>`
    }, props));
$dd5738169219237b$var$MergeSuccessIcon.displayName = 'MergeSuccessIcon';
var $dd5738169219237b$var$_default = module.exports.default = $dd5738169219237b$var$MergeSuccessIcon;

});

parcelRegister("MUJuW", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::baa34f3217bb36f9859c9b6bddb020ad>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $09307dc51f4f46f2$var$_react = $09307dc51f4f46f2$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $09307dc51f4f46f2$var$_baseNew = $09307dc51f4f46f2$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $09307dc51f4f46f2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PullRequest".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for pull requests.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $09307dc51f4f46f2$var$PullRequestIcon = (props)=>/*#__PURE__*/ $09307dc51f4f46f2$var$_react.default.createElement($09307dc51f4f46f2$var$_baseNew.default, Object.assign({
        name: "PullRequestIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4.25 2.5a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5M2 3.25a2.25 2.25 0 1 1 3 2.122v5.256a2.251 2.251 0 1 1-1.5 0V5.372A2.25 2.25 0 0 1 2 3.25m6-.75h1.75a2.75 2.75 0 0 1 2.75 2.75v5.378a2.251 2.251 0 1 1-1.5 0V5.25C11 4.56 10.44 4 9.75 4H8zM4.25 12a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m7.5 0a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5" clip-rule="evenodd"/>`
    }, props));
$09307dc51f4f46f2$var$PullRequestIcon.displayName = 'PullRequestIcon';
var $09307dc51f4f46f2$var$_default = module.exports.default = $09307dc51f4f46f2$var$PullRequestIcon;

});

parcelRegister("ghO0p", function(module, exports) {
$parcel$export(module.exports, "getTheme", () => $9094dd14e382848f$export$89cbf1a0881c8b9c);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // @ts-expect-error - TS2614 - Module '"@atlaskit/button"' has no exported member 'ButtonTheme'. Did you mean to use 'import ButtonTheme from "@atlaskit/button"' instead?

const $9094dd14e382848f$export$9e61512f2dc2cbb0 = (currentTheme, props)=>{
    const { buttonStyles: buttonStyles, ...rest } = currentTheme(props);
    const theme = {
        ...rest,
        buttonStyles: {
            ...buttonStyles,
            backgroundColor: (0, $7bb4c1736002a04a$exports).P400,
            '> span': {
                color: (0, $7bb4c1736002a04a$exports).N0
            }
        }
    };
    return theme;
};
const $9094dd14e382848f$export$f9380c9a627682d3 = (newTheme, themeProps)=>{
    const { appearance: appearance, mode: mode, state: state } = themeProps;
    if (!appearance || !newTheme[appearance]) return undefined;
    const root = newTheme[appearance];
    // @ts-expect-error - TS2739 - Type 'Record<string, any>' is missing the following properties from type 'ThemeTokens': buttonStyles, spinnerStyles
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return Object.keys(root).reduce((acc, val)=>{
        let node = root;
        [
            val,
            state,
            mode
        ].forEach((item)=>{
            if (!item) return;
            if (!node[item] && node[item] !== 0) return;
            if (typeof node[item] !== 'object') {
                acc[val] = node[item];
                return;
            }
            node = node[item];
        });
        return acc;
    }, {});
};
const $9094dd14e382848f$export$89cbf1a0881c8b9c = (overrides)=>(currentTheme, themeProps)=>{
        const theme = currentTheme(themeProps);
        // @ts-expect-error - TS2322 - Type 'Record<string, any>' is not assignable to type 'ThemeTokens'.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const styles = Object.entries(theme).reduce(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        (acc, [key, value])=>{
            // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type 'Partial<ThemeTokens>'.
            if (!overrides?.[key]) {
                acc[key] = value;
                return acc;
            }
            // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type 'Partial<ThemeTokens>'.
            const overriddenStyles = $9094dd14e382848f$export$f9380c9a627682d3(overrides[key], themeProps);
            acc[key] = {
                ...value,
                ...overriddenStyles
            };
            return acc;
        }, {});
        return styles;
    };

});

parcelRegister("2mWl5", function(module, exports) {
$parcel$export(module.exports, "default", () => $fa80a3df28aec062$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $goZPP = parcelRequire("goZPP");

var $806LH = parcelRequire("806LH");

var $80DPg = parcelRequire("80DPg");

var $lRq8t = parcelRequire("lRq8t");

var $assJw = parcelRequire("assJw");

var $ihplE = parcelRequire("ihplE");

var $7UMNT = parcelRequire("7UMNT");

var $fyBkS = parcelRequire("fyBkS");
const $fa80a3df28aec062$var$ErrorFallback = ({ devInfoType: devInfoType, issueAri: issueAri, scopeId: scopeId })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { showDevDetailDialogForPopup: showDevDetailDialogForPopup } = (0, $7UMNT.useShowDevDetailDialogForPopup)(scopeId);
    const handleLinkClick = ()=>{
        showDevDetailDialogForPopup(devInfoType, issueAri);
    };
    const devInfoTypeName = (0, $ihplE.DevInfoTypeMap)[devInfoType];
    const errorMessage = devInfoType === (0, $ihplE.DevInfoTypes).DESIGN ? formatMessage((0, $fyBkS.default).designErrorDescription, {
        devInfoType: devInfoTypeName
    }) : formatMessage((0, $fyBkS.default).errorDescription, {
        devInfoType: devInfoTypeName
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $assJw.PopupContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $assJw.PopupTitle), null, formatMessage((0, $fyBkS.default).errorPopupTitle, {
        devInfoType: (0, $ihplE.DevInfoTypeMap)[devInfoType]
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $806LH.default), {
        size: "xsmall"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fa80a3df28aec062$var$Header, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($80DPg))), {
        spacing: "spacious",
        label: "",
        color: "var(--ds-icon-danger, #C9372C)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fa80a3df28aec062$var$Title, null, formatMessage((0, $fyBkS.default).errorTitle)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fa80a3df28aec062$var$Description, null, errorMessage, devInfoType !== (0, $ihplE.DevInfoTypes).DESIGN && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fa80a3df28aec062$var$StyledButton, {
        appearance: "link",
        onClick: handleLinkClick
    }, formatMessage((0, $fyBkS.default).developmentErrorDescriptionCta))));
};
var $fa80a3df28aec062$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $fa80a3df28aec062$var$ErrorFallback;
const $fa80a3df28aec062$var$Title = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_18u01b66",
            __cmplp.className
        ])
    });
});
const $fa80a3df28aec062$var$Description = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_syaz1rpy _18u0u2gc",
            __cmplp.className
        ])
    });
});
const $fa80a3df28aec062$var$StyledButton = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = (0, $goZPP.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1ytiidpf _7yhbidpf _1bdkidpf _24rcidpf _1yxxidpf _12r2i7a9 _if291ule",
            __cmplp.className
        ])
    });
});
const $fa80a3df28aec062$var$Header = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1h6o _syaz1rpy _19pku2gc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("7UMNT", function(module, exports) {
$parcel$export(module.exports, "useShowDevDetailDialogForPopup", () => $3cc472b58165e02d$export$cdc75a6c65207319);

var $l98s9 = parcelRequire("l98s9");


var $8oKDI = parcelRequire("8oKDI");

var $ihplE = parcelRequire("ihplE");
const $3cc472b58165e02d$export$166d6c8e7de25541 = (issueAri)=>(0, $8oKDI.parseAri)(issueAri)?.resourceId;
const $3cc472b58165e02d$var$devInfoTypeToPanelDataType = (devInfoType)=>{
    if (devInfoType === (0, $ihplE.DevInfoTypes).COMMIT) return 0, $e31f0ec65fa77dec$export$2e42513c7764d5f3;
    if (devInfoType === (0, $ihplE.DevInfoTypes).DEPLOYMENT) return 0, $e31f0ec65fa77dec$export$90cac6260ae9ced5;
    return devInfoType;
};
function $3cc472b58165e02d$export$cdc75a6c65207319(scopeId) {
    const { showDevDetailDialog: showDevDetailDialog } = (0, $l98s9.useDevOpsDetailsDialogLoaderActions)(scopeId || 'software-board.board');
    const showDevDetailDialogForPopup = (devInfoType, issueAri)=>{
        const type = $3cc472b58165e02d$var$devInfoTypeToPanelDataType(devInfoType);
        const issueId = $3cc472b58165e02d$export$166d6c8e7de25541(issueAri);
        // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'PanelDataTypes'.
        showDevDetailDialog(type, undefined, '', issueId);
    };
    return {
        showDevDetailDialogForPopup: showDevDetailDialogForPopup
    };
}

});

parcelRegister("fyBkS", function(module, exports) {
$parcel$export(module.exports, "default", () => $39742a2a45960cdb$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $39742a2a45960cdb$var$messages = (0, $7qGN1.defineMessages)({
    errorPopupTitle: {
        "id": "development-board-common.error-fallback.error-popup-title",
        "defaultMessage": "{devInfoType}"
    },
    errorTitle: {
        "id": "development-board-common.error-fallback.error-title",
        "defaultMessage": "Something went wrong"
    },
    errorDescription: {
        "id": "development-board-common.error-fallback.error-description",
        "defaultMessage": "For some reason we couldn't load this {devInfoType}."
    },
    developmentErrorDescriptionCta: {
        "id": "development-board-common.error-fallback.development-error-description-cta",
        "defaultMessage": "View all development information."
    },
    designErrorDescription: {
        "id": "development-board-common.error-fallback.design-error-description",
        "defaultMessage": "For some reason we couldn't load this design. Refresh your page to try again."
    }
});
var $39742a2a45960cdb$export$2e2bcd8739ae039 = $39742a2a45960cdb$var$messages;

});


parcelRegister("51yhA", function(module, exports) {
$parcel$export(module.exports, "createIssueAri", () => $7f5196c3e2f780b7$export$6b0ec881a3540845);

var $8oKDI = parcelRequire("8oKDI");
const $7f5196c3e2f780b7$export$6b0ec881a3540845 = (cloudId, issueId)=>(0, $8oKDI.createAri)({
        resourceOwner: 'jira',
        cloudId: cloudId,
        resourceType: 'issue',
        resourceId: issueId
    });

});

parcelRegister("dPIoB", function(module, exports) {
$parcel$export(module.exports, "DeploymentProdSuccess", () => $3e893de12eb02693$export$8409a6d16fd5ac8e);
$parcel$export(module.exports, "DeploymentNonProdSuccess", () => $3e893de12eb02693$export$814ebe75b826c47b);
$parcel$export(module.exports, "DeploymentProdFailed", () => $3e893de12eb02693$export$22f2b1620b38359);
$parcel$export(module.exports, "DeploymentNonProdFailed", () => $3e893de12eb02693$export$5b461fe0712c5c45);

var $eJOHy = parcelRequire("eJOHy");

var $fL0In = parcelRequire("fL0In");
const $3e893de12eb02693$export$8409a6d16fd5ac8e = ({ size: size, label: label })=>// eslint-disable-next-line @atlaskit/design-system/no-custom-icons
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fL0In.default), {
        size: size,
        label: label,
        glyph: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 16 16",
                width: "16",
                height: "16",
                fill: "none"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
                fill: "var(--ds-icon-inverse, #FFFFFF)",
                d: "M0 0h16v16H0z",
                fillOpacity: ".01"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
                fill: "var(--ds-icon-success, #6A9A23)",
                d: "M1 9.75a3.15 3.15 0 0 0 2.8 3.13v.02h8.4v-.02a3.15 3.15 0 0 0 .533-6.155 4.902 4.902 0 0 0-9.466 0A3.151 3.151 0 0 0 1 9.75Zm5.85-1.8a.669.669 0 1 0-.946.946l1.15 1.15a.67.67 0 0 0 .946 0l2.096-2.096a.67.67 0 1 0-.946-.946L7.527 8.627 6.85 7.95Z",
                clipRule: "evenodd",
                fillRule: "evenodd"
            }))
    });
const $3e893de12eb02693$export$814ebe75b826c47b = ({ size: size, label: label })=>// eslint-disable-next-line @atlaskit/design-system/no-custom-icons
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fL0In.default), {
        size: size,
        label: label,
        glyph: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 16 16",
                width: "16",
                height: "16",
                fill: "none"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
                fill: "var(--ds-icon-inverse, #FFFFFF)",
                d: "M0 0h16v16H0z",
                fillOpacity: "0"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("mask", {
                id: "a",
                fill: "var(--ds-icon-inverse, #FFFFFF)"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
                fill: "var(--ds-icon-success, #6A9A23)",
                d: "M3.8 12.9a3.2 3.2 0 0 1-.5-6.2 4.9 4.9 0 0 1 9.4 0 3.2 3.2 0 0 1-.5 6.2H3.8Z",
                clipRule: "evenodd",
                fillRule: "evenodd"
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
                fill: "var(--ds-icon-success, #6A9A23)",
                d: "M3.8 12.9h1.5v-1.4L4 11.4l-.2 1.5Zm-.5-6.2.4 1.5.8-.3.2-.8-1.4-.4Zm9.4 0-1.4.4.2.8.8.3.4-1.5Zm-.5 6.2-.2-1.5-1.3.1V13h1.5Zm0 0v1.5h1.5v-1.5h-1.5Zm-8.4 0H2.3v1.5h1.5v-1.5Zm.2-1.5c-.9-.1-1.5-.8-1.5-1.7h-3c0 2.4 1.8 4.4 4.1 4.7l.4-3ZM2.5 9.7c0-.7.5-1.3 1.2-1.5l-.9-3C1 5.9-.5 7.7-.5 9.8h3Zm2.2-2.6A3.4 3.4 0 0 1 8 4.6v-3c-3 0-5.4 2-6.2 4.7l3 .8ZM8 4.6c1.6 0 2.9 1 3.3 2.5l2.9-.8A6.4 6.4 0 0 0 8 1.6v3Zm4.3 3.6c.7.2 1.2.8 1.2 1.5h3c0-2-1.4-3.9-3.3-4.4l-.9 2.9Zm1.2 1.5c0 .9-.6 1.6-1.5 1.7l.4 3a4.7 4.7 0 0 0 4.1-4.7h-3ZM10.7 13h3-3Zm1.5-1.5H3.8v3h8.4v-3Zm-6.9 1.5h-3 3Z",
                mask: "url(#a)"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
                fill: "var(--ds-icon-success, #6A9A23)",
                d: "M6.8 7.9 7 8l.6.6L9 7.2a.6.6 0 1 1 .8.8L8 9.8a.6.6 0 0 1-.8 0l-1-1a.6.6 0 0 1 .6-1Z"
            }))
    });
const $3e893de12eb02693$export$22f2b1620b38359 = ({ size: size, label: label })=>// eslint-disable-next-line @atlaskit/design-system/no-custom-icons
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fL0In.default), {
        size: size,
        label: label,
        glyph: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 16 16",
                width: "16",
                height: "16",
                fill: "none"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
                fill: "var(--ds-icon-inverse, #FFFFFF)",
                d: "M0 0h16v16H0z",
                fillOpacity: ".01"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
                fill: "var(--ds-icon-danger, #C9372C)",
                d: "M3.8 12.88a3.15 3.15 0 0 1-.53-6.15 4.9 4.9 0 0 1 9.46 0 3.15 3.15 0 0 1-.53 6.15v.02H3.8v-.02Zm3.55-6.63a.75.75 0 0 1 1.5 0v2a.75.75 0 0 1-1.5 0v-2ZM8.1 9.5a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5Z",
                clipRule: "evenodd",
                fillRule: "evenodd"
            }))
    });
const $3e893de12eb02693$export$5b461fe0712c5c45 = ({ size: size, label: label })=>// eslint-disable-next-line @atlaskit/design-system/no-custom-icons
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fL0In.default), {
        size: size,
        label: label,
        glyph: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 16 16",
                width: "16",
                height: "16",
                fill: "none"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
                fill: "var(--ds-icon-inverse, #FFFFFF)",
                d: "M0 0h16v16H0z",
                fillOpacity: "0"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("mask", {
                id: "a",
                fill: "var(--ds-icon-inverse, #FFFFFF)"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
                fill: "var(--ds-icon-danger, #C9372C)",
                d: "M3.8 12.9a3.2 3.2 0 0 1-.5-6.2 4.9 4.9 0 0 1 9.4 0 3.2 3.2 0 0 1-.5 6.2H3.8Z",
                clipRule: "evenodd",
                fillRule: "evenodd"
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
                fill: "var(--ds-icon-danger, #C9372C)",
                d: "M3.8 12.9h1.5v-1.4L4 11.4l-.2 1.5Zm-.5-6.2.4 1.5.8-.3.2-.8-1.4-.4Zm9.4 0-1.4.4.2.8.8.3.4-1.5Zm-.5 6.2-.2-1.5-1.3.1V13h1.5Zm0 0v1.5h1.5v-1.5h-1.5Zm-8.4 0H2.3v1.5h1.5v-1.5Zm.2-1.5c-.9-.1-1.5-.8-1.5-1.7h-3c0 2.4 1.8 4.4 4.1 4.7l.4-3ZM2.5 9.7c0-.7.5-1.3 1.2-1.5l-.9-3C1 5.9-.5 7.7-.5 9.8h3Zm2.2-2.6A3.4 3.4 0 0 1 8 4.6v-3c-3 0-5.4 2-6.2 4.7l3 .8ZM8 4.6c1.6 0 2.9 1 3.3 2.5l2.9-.8A6.4 6.4 0 0 0 8 1.6v3Zm4.3 3.6c.7.2 1.2.8 1.2 1.5h3c0-2-1.4-3.9-3.3-4.4l-.9 2.9Zm1.2 1.5c0 .9-.6 1.6-1.5 1.7l.4 3a4.7 4.7 0 0 0 4.1-4.7h-3ZM10.7 13h3-3Zm1.5-1.5H3.8v3h8.4v-3Zm-6.9 1.5h-3 3Z",
                mask: "url(#a)"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("rect", {
                width: "1.5",
                height: "3.5",
                x: "7.4",
                y: "5.5",
                fill: "var(--ds-icon-danger, #C9372C)",
                rx: ".8"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("rect", {
                width: "1.5",
                height: "1.5",
                x: "7.4",
                y: "9.5",
                fill: "var(--ds-icon-danger, #C9372C)",
                rx: ".8"
            }))
    });

});

parcelRegister("9Fnbb", function(module, exports) {
$parcel$export(module.exports, "default", () => $d8140bc85e27515e$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $fL0In = parcelRequire("fL0In");
const $d8140bc85e27515e$var$DesignIconSVG = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": props['data-testid'],
        "aria-label": props['aria-label'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: props.className
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        fill: "currentcolor",
        d: "M9.864 10.736c.77-.746 1.893-.536 2.72.265.826.8 1.043 1.888.273 2.634-1.816 1.76-5.482 2.002-4.765 1.207 1.587-1.76.578-2.949 1.772-4.106M19.968 4.03c.402.378-3.1 4.732-4.427 5.98-.659.62-1.012.826-1.276 1.016-.115.082-.15-.027-.177-.076a3.7 3.7 0 0 0-.63-.801c-.236-.222-.607-.445-.867-.572-.053-.025-.169-.058-.08-.166.201-.249.421-.58 1.08-1.2 1.327-1.247 5.974-4.56 6.377-4.181M18.38 19.946a1 1 0 0 1-.332.054.95.95 0 0 1-.913-.628c-.343-.957-1.14-1.642-2.257-1.933-2.182-.568-3.22-.264-5.053.995l-.16.11a9 9 0 0 1-1.049.644c-1.477.755-2.632.825-3.482.419-.586-.28-.989-.794-1.1-1.407-.254-1.403.93-2.647 2.602-3.156a.906.906 0 0 1 1.155.601.92.92 0 0 1-.62 1.186c-.33.1-.717.311-.978.533-.195.165-.33.355-.306.434.042.138.088.185.16.214.155.063.445.029.818-.096q.247-.083.524-.21c.196-.088.348-.165.58-.287.076-.04.177-.11.445-.303 1.09-.784 1.802-1.198 2.845-1.52 1.562-.482 3.18-.39 4.802.272 1.399.57 2.399 1.589 2.883 2.94.174.483-.07.97-.564 1.138"
    }));
const $d8140bc85e27515e$var$DesignIcon = (props)=>// eslint-disable-next-line @atlaskit/design-system/no-custom-icons
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fL0In.default), {
        ...props,
        glyph: $d8140bc85e27515e$var$DesignIconSVG
    });
var $d8140bc85e27515e$export$2e2bcd8739ae039 = $d8140bc85e27515e$var$DesignIcon;

});

parcelRegister("irfiw", function(module, exports) {
$parcel$export(module.exports, "designModalEntryPoint", () => $ee0916071f3406a8$export$b98395a806b85a49);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

var $gGtuj = parcelRequire("gGtuj");

const $ee0916071f3406a8$export$b98395a806b85a49 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("a5afP")), {
        moduleId: "576d28f0",
        priority: "interaction"
    }),
    getPreloadProps: ({ siteAri: siteAri, issueAri: issueAri, cloudId: cloudId, designAri: designAri })=>({
            queries: {
                designModal: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: (0, $gGtuj.default),
                    variables: {
                        siteAri: siteAri,
                        issueAri: issueAri,
                        cloudId: cloudId,
                        designAri: designAri
                    }
                }
            }
        })
});

});
parcelRegister("gGtuj", function(module, exports) {
$parcel$export(module.exports, "default", () => $67729088f7fd7df9$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1775dc6f451f5aa08f2de993d8e993cc>>
 * @relayHash f75963656ac83b6e4f5b855b41942d4f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5455aa42cc5ba971a154b4555e76f70cb6faf70a0f41a193d62856efb789841b
const $67729088f7fd7df9$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "5455aa42cc5ba971a154b4555e76f70cb6faf70a0f41a193d62856efb789841b",
        "metadata": {},
        "name": "ui_DesignModalQuery",
        "operationKind": "query",
        "text": null
    }
};
var $67729088f7fd7df9$export$2e2bcd8739ae039 = $67729088f7fd7df9$var$node;

});

parcelRegister("a5afP", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("gSgrR").then(()=>parcelRequire('hPnJ8'));

});


parcelRegister("6rP4O", function(module, exports) {
$parcel$export(module.exports, "DevInfoDetailsPopupSkeleton", () => $0316a41cdfc9a3e1$export$9044eba4855892a5);
/* DevInfoDetailsPopupSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $6umqd = parcelRequire("6umqd");

var $5LPHa = parcelRequire("5LPHa");

var $avR4x = parcelRequire("avR4x");

var $hWyQI = parcelRequire("hWyQI");

var $3x6lS = parcelRequire("3x6lS");

var $YZwMO = parcelRequire("YZwMO");
// Try to keep SPA JS bundle as small as possible, skeletons should not have dependencies, so here we use hard coding instead of import gridSize
const $0316a41cdfc9a3e1$var$customCssStyles = null;
const $0316a41cdfc9a3e1$var$skeletonStyles = null;
const $0316a41cdfc9a3e1$export$ae7439e01588d047 = {
    BRANCH: 'branch',
    COMMIT: 'commit',
    PULLREQUEST: 'pullrequest',
    DEPLOYMENT: 'deployment',
    DESIGN: 'design'
};
const $0316a41cdfc9a3e1$var$skeletonAsset = {
    [$0316a41cdfc9a3e1$export$ae7439e01588d047.BRANCH]: (0, (/*@__PURE__*/$parcel$interopDefault($5LPHa))),
    [$0316a41cdfc9a3e1$export$ae7439e01588d047.COMMIT]: (0, (/*@__PURE__*/$parcel$interopDefault($avR4x))),
    [$0316a41cdfc9a3e1$export$ae7439e01588d047.PULLREQUEST]: (0, (/*@__PURE__*/$parcel$interopDefault($YZwMO))),
    [$0316a41cdfc9a3e1$export$ae7439e01588d047.DEPLOYMENT]: (0, (/*@__PURE__*/$parcel$interopDefault($hWyQI))),
    [$0316a41cdfc9a3e1$export$ae7439e01588d047.DESIGN]: (0, (/*@__PURE__*/$parcel$interopDefault($3x6lS)))
};
const $0316a41cdfc9a3e1$export$9044eba4855892a5 = ({ devinfoType: devinfoType })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        className: (0, $hcewu.default)([
            devinfoType === $0316a41cdfc9a3e1$export$ae7439e01588d047.BRANCH && "_1bsbnklw _4t3i1lit _ca0qze3t _u5f3pxbi _n3tdze3t _19bvpxbi _vchhusvi",
            devinfoType === $0316a41cdfc9a3e1$export$ae7439e01588d047.COMMIT && "_1bsbnklw _4t3i1lit _ca0qze3t _u5f3pxbi _n3tdze3t _19bvpxbi _vchhusvi",
            devinfoType === $0316a41cdfc9a3e1$export$ae7439e01588d047.PULLREQUEST && "_1bsbnklw _ca0qze3t _u5f3pxbi _n3tdze3t _19bvpxbi _vchhusvi _4t3imgvx",
            devinfoType === $0316a41cdfc9a3e1$export$ae7439e01588d047.DEPLOYMENT && "_1bsbnklw _4t3i1lit",
            devinfoType === $0316a41cdfc9a3e1$export$ae7439e01588d047.DESIGN && "_1bsbnklw _4t3i1lit _ca0qze3t _u5f3pxbi _n3tdze3t _19bvpxbi _vchhusvi"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6umqd.AppSkeletonImage), {
        src: $0316a41cdfc9a3e1$var$skeletonAsset[devinfoType],
        className: (0, $hcewu.default)([
            "_1wgmglyw _rcujmgjw"
        ])
    }));

});
parcelRegister("5LPHa", function(module, exports) {
module.exports = new URL("branch-details-popup.tpl.90980aef.svg", import.meta.url).toString();

});

parcelRegister("avR4x", function(module, exports) {
module.exports = new URL("commit-details-popup.tpl.ef7b25c8.svg", import.meta.url).toString();

});

parcelRegister("hWyQI", function(module, exports) {
module.exports = new URL("deployment-details-popup.tpl.d0e045e6.svg", import.meta.url).toString();

});

parcelRegister("3x6lS", function(module, exports) {
module.exports = new URL("design-details-popup.tpl.da785a24.svg", import.meta.url).toString();

});

parcelRegister("YZwMO", function(module, exports) {
module.exports = new URL("pr-details-popup.tpl.2fd71422.svg", import.meta.url).toString();

});


parcelRegister("jgZxT", function(module, exports) {
$parcel$export(module.exports, "HOVER_TIMEOUT_MS", () => $87678ec5f92aea2f$export$bbec45119b804b4d);
$parcel$export(module.exports, "DevInfoButtonLabelMapping", () => $87678ec5f92aea2f$export$41f3316f17440396);
$parcel$export(module.exports, "iconColor", () => $87678ec5f92aea2f$export$3797a580396e3639);
$parcel$export(module.exports, "experienceDetails", () => $87678ec5f92aea2f$export$ba2604b0fdde2542);
$parcel$export(module.exports, "metrics", () => $87678ec5f92aea2f$export$b0c5c2fac8144e54);
$parcel$export(module.exports, "packageDetails", () => $87678ec5f92aea2f$export$48b44d9f3c6e15de);
$parcel$export(module.exports, "popupEntryPointsOld", () => $87678ec5f92aea2f$export$b0c175bfb49cef40);
$parcel$export(module.exports, "popupEntryPoints", () => $87678ec5f92aea2f$export$1452632269dce6);
$parcel$export(module.exports, "DeploymentState", () => $87678ec5f92aea2f$export$a12a01ce2571070a);
$parcel$export(module.exports, "DeploymentEnvironment", () => $87678ec5f92aea2f$export$618f130aff825d2b);

var $LFmXM = parcelRequire("LFmXM");

var $aN6vU = parcelRequire("aN6vU");

var $d7eFH = parcelRequire("d7eFH");

var $epq8v = parcelRequire("epq8v");

var $1IIVN = parcelRequire("1IIVN");

var $ihplE = parcelRequire("ihplE");

var $2WAf5 = parcelRequire("2WAf5");

var $4GBRr = parcelRequire("4GBRr");

var $jPIBc = parcelRequire("jPIBc");

var $9p0ej = parcelRequire("9p0ej");

var $28n2N = parcelRequire("28n2N");

var $8Fo16 = parcelRequire("8Fo16");

var $4C7GN = parcelRequire("4C7GN");
const $87678ec5f92aea2f$export$bbec45119b804b4d = 300;
const $87678ec5f92aea2f$export$41f3316f17440396 = (0, $LFmXM.default)((formatMessage)=>({
        [(0, $ihplE.DevInfoTypes).BRANCH]: formatMessage((0, $4C7GN.default).branchIconButtonLabel),
        [(0, $ihplE.DevInfoTypes).COMMIT]: formatMessage((0, $4C7GN.default).commitIconButtonLabel),
        [(0, $ihplE.DevInfoTypes).PULLREQUEST]: formatMessage((0, $4C7GN.default).pullRequestIconButtonLabel),
        [(0, $ihplE.DevInfoTypes).MERGED]: formatMessage((0, $4C7GN.default).pullRequestIconButtonLabel),
        [(0, $ihplE.DevInfoTypes).DECLINED]: formatMessage((0, $4C7GN.default).pullRequestIconButtonLabel),
        [(0, $ihplE.DevInfoTypes).DEPLOYMENT]: formatMessage((0, $4C7GN.default).deploymentIconButtonLabel),
        [(0, $ihplE.DevInfoTypes).DESIGN]: formatMessage((0, $4C7GN.default).designIconButtonLabel)
    }));
const $87678ec5f92aea2f$export$3797a580396e3639 = {
    [(0, $ihplE.DevInfoTypes).BRANCH]: {
        [(0, $ihplE.ButtonStatus).ACTIVE]: "var(--ds-icon-inverse, #FFFFFF)",
        [(0, $ihplE.ButtonStatus).HOVER]: "var(--ds-icon-subtle, #505258)",
        [(0, $ihplE.ButtonStatus).DEFAULT]: "var(--ds-icon-subtle, #505258)"
    },
    [(0, $ihplE.DevInfoTypes).COMMIT]: {
        [(0, $ihplE.ButtonStatus).ACTIVE]: "var(--ds-icon-inverse, #FFFFFF)",
        [(0, $ihplE.ButtonStatus).HOVER]: "var(--ds-icon-subtle, #505258)",
        [(0, $ihplE.ButtonStatus).DEFAULT]: "var(--ds-icon-subtle, #505258)"
    },
    [(0, $ihplE.DevInfoTypes).PULLREQUEST]: {
        [(0, $ihplE.ButtonStatus).ACTIVE]: "var(--ds-icon-inverse, #FFFFFF)",
        [(0, $ihplE.ButtonStatus).HOVER]: "var(--ds-icon-subtle, #505258)",
        [(0, $ihplE.ButtonStatus).DEFAULT]: "var(--ds-icon-subtle, #505258)"
    },
    [(0, $ihplE.DevInfoTypes).MERGED]: {
        [(0, $ihplE.ButtonStatus).ACTIVE]: "var(--ds-icon-success, #6A9A23)",
        [(0, $ihplE.ButtonStatus).HOVER]: "var(--ds-icon-success, #6A9A23)",
        [(0, $ihplE.ButtonStatus).DEFAULT]: "var(--ds-icon-success, #6A9A23)"
    },
    [(0, $ihplE.DevInfoTypes).DECLINED]: {
        [(0, $ihplE.ButtonStatus).ACTIVE]: "var(--ds-icon-danger, #C9372C)",
        [(0, $ihplE.ButtonStatus).HOVER]: "var(--ds-icon-danger, #C9372C)",
        [(0, $ihplE.ButtonStatus).DEFAULT]: "var(--ds-icon-danger, #C9372C)"
    },
    [(0, $ihplE.DevInfoTypes).DEPLOYMENT]: {
        [(0, $ihplE.ButtonStatus).ACTIVE]: "var(--ds-icon-inverse, #FFFFFF)",
        [(0, $ihplE.ButtonStatus).HOVER]: "var(--ds-icon-subtle, #505258)",
        [(0, $ihplE.ButtonStatus).DEFAULT]: "var(--ds-icon-subtle, #505258)"
    },
    [(0, $ihplE.DevInfoTypes).DESIGN]: {
        [(0, $ihplE.ButtonStatus).ACTIVE]: "var(--ds-icon-inverse, #FFFFFF)",
        [(0, $ihplE.ButtonStatus).HOVER]: "var(--ds-icon-subtle, #505258)",
        [(0, $ihplE.ButtonStatus).DEFAULT]: "var(--ds-icon-subtle, #505258)"
    }
};
const $87678ec5f92aea2f$export$ba2604b0fdde2542 = {
    [(0, $ihplE.DevInfoTypes).BRANCH]: {
        id: 'branchDetailsPopup',
        name: 'jiraSoftwareBoardBranchDetailsPopup'
    },
    [(0, $ihplE.DevInfoTypes).COMMIT]: {
        id: 'commitDetailsPopup',
        name: 'jiraSoftwareBoardCommitDetailsPopup'
    },
    [(0, $ihplE.DevInfoTypes).DEPLOYMENT]: {
        id: 'deploymentDetailsPopup',
        name: 'jiraSoftwareBoardDeploymentDetailsPopup'
    },
    [(0, $ihplE.DevInfoTypes).PULLREQUEST]: {
        id: 'prDetailsPopup',
        name: 'jiraSoftwareBoardPrDetailsPopup'
    },
    [(0, $ihplE.DevInfoTypes).DESIGN]: {
        id: 'designDetailsPopup',
        name: 'jiraSoftwareBoardDesignDetailsPopup'
    }
};
const $87678ec5f92aea2f$export$b0c5c2fac8144e54 = {
    [(0, $ihplE.DevInfoTypes).BRANCH]: (0, $8Fo16.branchDetailsPopupLoad),
    [(0, $ihplE.DevInfoTypes).COMMIT]: (0, $8Fo16.commitDetailsPopupLoad),
    [(0, $ihplE.DevInfoTypes).DEPLOYMENT]: (0, $8Fo16.deploymentDetailsPopupLoad),
    [(0, $ihplE.DevInfoTypes).PULLREQUEST]: (0, $8Fo16.prDetailsPopupLoad),
    [(0, $ihplE.DevInfoTypes).DESIGN]: (0, $8Fo16.designDetailsPopupLoad)
};
const $87678ec5f92aea2f$export$48b44d9f3c6e15de = {
    [(0, $ihplE.DevInfoTypes).BRANCH]: {
        id: 'renderBranchDetailsPopup',
        packageName: 'jiraDevelopmentBoardBranchDetailsPopup',
        teamName: 'jolt'
    },
    [(0, $ihplE.DevInfoTypes).COMMIT]: {
        id: 'renderCommitDetailsPopup',
        packageName: 'jiraDevelopmentBoardCommitDetailsPopup',
        teamName: 'jolt'
    },
    [(0, $ihplE.DevInfoTypes).DEPLOYMENT]: {
        id: 'renderDeploymentDetailsPopup',
        packageName: 'jiraDevelopmentBoardDeploymentDetailsPopup',
        teamName: 'jolt'
    },
    [(0, $ihplE.DevInfoTypes).PULLREQUEST]: {
        id: 'renderPRDetailsPopup',
        packageName: 'jiraDevelopmentBoardPrDetailsPopup',
        teamName: 'jolt'
    },
    [(0, $ihplE.DevInfoTypes).DESIGN]: {
        id: 'renderDesignDetailsPopup',
        packageName: 'jiraDevelopmentBoardDesignDetailsPopup',
        teamName: 'helios'
    }
};
const $87678ec5f92aea2f$export$b0c175bfb49cef40 = {
    [(0, $ihplE.DevInfoTypes).BRANCH]: (0, $aN6vU.branchDetailsEntryPoint),
    [(0, $ihplE.DevInfoTypes).COMMIT]: (0, $epq8v.commitDetailsEntryPoint),
    [(0, $ihplE.DevInfoTypes).DEPLOYMENT]: (0, $2WAf5.deploymentDetailsEntryPoint),
    [(0, $ihplE.DevInfoTypes).PULLREQUEST]: (0, $9p0ej.pullRequestDetailsEntryPoint),
    [(0, $ihplE.DevInfoTypes).DESIGN]: (0, $jPIBc.designDetailsEntryPoint)
};
const $87678ec5f92aea2f$export$1452632269dce6 = {
    [(0, $ihplE.DevInfoTypes).BRANCH]: (0, $d7eFH.branchDetailsEntryPoint),
    [(0, $ihplE.DevInfoTypes).COMMIT]: (0, $1IIVN.commitDetailsEntryPoint),
    [(0, $ihplE.DevInfoTypes).DEPLOYMENT]: (0, $4GBRr.deploymentDetailsEntryPoint),
    [(0, $ihplE.DevInfoTypes).PULLREQUEST]: (0, $28n2N.pullRequestDetailsNewEntryPoint),
    [(0, $ihplE.DevInfoTypes).DESIGN]: (0, $jPIBc.designDetailsEntryPoint)
};
const $87678ec5f92aea2f$export$a12a01ce2571070a = Object.freeze({
    SUCCESSFUL: 'SUCCESSFUL',
    FAILED: 'FAILED'
});
const $87678ec5f92aea2f$export$618f130aff825d2b = Object.freeze({
    PRODUCTION: 'PRODUCTION',
    STAGING: 'STAGING',
    TESTING: 'TESTING'
});

});
parcelRegister("aN6vU", function(module, exports) {
$parcel$export(module.exports, "branchDetailsEntryPoint", () => $96450119820cc4ab$export$4e1fb223e6b994ad);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

var $cNEW8 = parcelRequire("cNEW8");

const $96450119820cc4ab$export$4e1fb223e6b994ad = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("5TrrV")), {
        moduleId: "019b5ba6",
        moduleName: "BranchDetailsPopupView",
        priority: "interaction"
    }),
    getPreloadProps: ({ issueId: issueId })=>({
            queries: {
                branchDetailsForIssue: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $cNEW8.default,
                    variables: {
                        issueId: issueId
                    }
                }
            }
        })
});

});
parcelRegister("cNEW8", function(module, exports) {
$parcel$export(module.exports, "default", () => $d3767ff209ab9750$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f141e8f9ddd74338bd64ad27b0e07f03>>
 * @relayHash 2117e720949cfe5ff0567aed4ff232d9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID cd73558b61b6f87043dfd8085777f1bb529ce15ae97d53788fd25d84c4476050
const $d3767ff209ab9750$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "cd73558b61b6f87043dfd8085777f1bb529ce15ae97d53788fd25d84c4476050",
        "metadata": {},
        "name": "BranchDetailsPopupViewQuery",
        "operationKind": "query",
        "text": null
    }
};
var $d3767ff209ab9750$export$2e2bcd8739ae039 = $d3767ff209ab9750$var$node;

});

parcelRegister("5TrrV", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("g1oCq").then(()=>parcelRequire('lvWgo'));

});


parcelRegister("d7eFH", function(module, exports) {
$parcel$export(module.exports, "branchDetailsEntryPoint", () => $b47b95df4bd10235$export$4e1fb223e6b994ad);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

var $jS1xI = parcelRequire("jS1xI");

const $b47b95df4bd10235$export$4e1fb223e6b994ad = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("4TIw2")), {
        moduleId: "c66be48f",
        moduleName: "BranchDetailsPopupView",
        priority: "interaction"
    }),
    getPreloadProps: ({ issueId: issueId })=>({
            queries: {
                branchDetailsForIssue: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $jS1xI.default,
                    variables: {
                        issueId: issueId
                    }
                }
            }
        })
});

});
parcelRegister("jS1xI", function(module, exports) {
$parcel$export(module.exports, "default", () => $ff22ab737c592a6b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<561cfd0883d7cf08517f09025354a76a>>
 * @relayHash f91e9769c2224ef6537429ff8eeeb48b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a216d9d8e29f9f633b18a89297380a5f81b34bdb221c9e18da37c9f456697f42

var $37Ewn = parcelRequire("37Ewn");
const $ff22ab737c592a6b$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "issueId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "issueId"
        }
    ], v2 = [
        {
            "kind": "Literal",
            "name": "input",
            "value": {
                "filterLegacy": true
            }
        }
    ], v3 = {
        "concreteType": "JiraDevInfoConfigError",
        "kind": "LinkedField",
        "name": "configErrors",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "dataProviderId"
            },
            {
                "kind": "ScalarField",
                "name": "errorType"
            }
        ]
    }, v4 = {
        "kind": "ScalarField",
        "name": "name"
    }, v5 = [
        v4 /*: any*/ 
    ], v6 = {
        "concreteType": "JiraDevOpsBranchDetails",
        "kind": "LinkedField",
        "name": "details",
        "plural": true,
        "selections": [
            v4 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "entityUrl"
            },
            {
                "concreteType": "JiraScmRepository",
                "kind": "LinkedField",
                "name": "scmRepository",
                "plural": false,
                "selections": v5 /*: any*/ 
            }
        ]
    }, v7 = {
        "kind": "ScalarField",
        "name": "url"
    }, v8 = {
        "kind": "InlineFragment",
        "selections": v5 /*: any*/ ,
        "type": "ExternalRepository"
    }, v9 = {
        "kind": "ScalarField",
        "name": "id"
    }, v10 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v11 = {
        "kind": "InlineFragment",
        "selections": [
            v9 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "BranchDetailsPopupViewBranchDetailsPopupViewQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v1 /*: any*/ ,
                                    "concreteType": "JiraIssue",
                                    "kind": "LinkedField",
                                    "name": "issueById",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "args": v2 /*: any*/ ,
                                            "concreteType": "JiraIssueBranches",
                                            "kind": "LinkedField",
                                            "name": "linkedBranches",
                                            "plural": false,
                                            "selections": [
                                                v3 /*: any*/ ,
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v6 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "jira.issueById.linkedBranches.details"
                                                }
                                            ],
                                            "storageKey": "linkedBranches(input:{\"filterLegacy\":true})"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.issueById"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                },
                {
                    "concreteType": "GraphStore",
                    "kind": "LinkedField",
                    "name": "graphStore",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "GraphStoreSimplifiedIssueAssociatedBranchConnection",
                            "kind": "LinkedField",
                            "name": "issueAssociatedBranch",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "GraphStoreSimplifiedIssueAssociatedBranchEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v7 /*: any*/ ,
                                                        v4 /*: any*/ ,
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "container",
                                                            "plural": false,
                                                            "selections": [
                                                                v8 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "type": "ExternalBranch"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "BranchDetailsPopupViewBranchDetailsPopupViewQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraIssue",
                            "kind": "LinkedField",
                            "name": "issueById",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v2 /*: any*/ ,
                                    "concreteType": "JiraIssueBranches",
                                    "kind": "LinkedField",
                                    "name": "linkedBranches",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        v6 /*: any*/ 
                                    ],
                                    "storageKey": "linkedBranches(input:{\"filterLegacy\":true})"
                                },
                                v9 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "GraphStore",
                    "kind": "LinkedField",
                    "name": "graphStore",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "GraphStoreSimplifiedIssueAssociatedBranchConnection",
                            "kind": "LinkedField",
                            "name": "issueAssociatedBranch",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "GraphStoreSimplifiedIssueAssociatedBranchEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v10 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v7 /*: any*/ ,
                                                        v4 /*: any*/ ,
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "container",
                                                            "plural": false,
                                                            "selections": [
                                                                v10 /*: any*/ ,
                                                                v8 /*: any*/ ,
                                                                v11 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "type": "ExternalBranch"
                                                },
                                                v11 /*: any*/ 
                                            ]
                                        },
                                        v9 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "a216d9d8e29f9f633b18a89297380a5f81b34bdb221c9e18da37c9f456697f42",
            "metadata": {},
            "name": "BranchDetailsPopupViewBranchDetailsPopupViewQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$ff22ab737c592a6b$var$node.hash = "aa501b66ec944036d33defe26ab72b91";
(0, $37Ewn.PreloadableQueryRegistry).set($ff22ab737c592a6b$var$node.params.id, $ff22ab737c592a6b$var$node);
var $ff22ab737c592a6b$export$2e2bcd8739ae039 = $ff22ab737c592a6b$var$node;

});

parcelRegister("4TIw2", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("2DZcv").then(()=>parcelRequire('eg69Y'));

});


parcelRegister("epq8v", function(module, exports) {
$parcel$export(module.exports, "commitDetailsEntryPoint", () => $894d82c043c9fc61$export$543707906869c79b);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

var $iOgJJ = parcelRequire("iOgJJ");

const $894d82c043c9fc61$export$543707906869c79b = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("3mILT")), {
        moduleId: "cd708d5a",
        moduleName: "CommitDetailsPopupView",
        priority: "interaction"
    }),
    getPreloadProps: ({ issueId: issueId })=>({
            queries: {
                commitDetailsForIssue: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $iOgJJ.default,
                    variables: {
                        issueId: issueId
                    }
                }
            }
        })
});

});
parcelRegister("iOgJJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $c2e641748f0944ff$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<cd1ba3099e75104640098810f83c64a2>>
 * @relayHash c879c122491285841c431ba88e98867e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6a727cea1b43d9f2cef75fa50de2bcbca0808bca56bc73cdc09d7a78108aedab
const $c2e641748f0944ff$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "6a727cea1b43d9f2cef75fa50de2bcbca0808bca56bc73cdc09d7a78108aedab",
        "metadata": {},
        "name": "CommitDetailsPopupViewQuery",
        "operationKind": "query",
        "text": null
    }
};
var $c2e641748f0944ff$export$2e2bcd8739ae039 = $c2e641748f0944ff$var$node;

});

parcelRegister("3mILT", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("jpIhK").then(()=>parcelRequire('26KKg'));

});


parcelRegister("1IIVN", function(module, exports) {
$parcel$export(module.exports, "commitDetailsEntryPoint", () => $e53e1879380b80b2$export$543707906869c79b);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

var $lLXFw = parcelRequire("lLXFw");

const $e53e1879380b80b2$export$543707906869c79b = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>{
        return (parcelRequire("inqRW"));
    }, {
        moduleId: "d73a4ee6",
        moduleName: "CommitDetailsPopupView",
        priority: "interaction"
    }),
    getPreloadProps: ({ issueId: issueId })=>({
            queries: {
                commitDetailsForIssue: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $lLXFw.default,
                    variables: {
                        issueId: issueId
                    }
                }
            }
        })
});

});
parcelRegister("lLXFw", function(module, exports) {
$parcel$export(module.exports, "default", () => $ad1f1225aa9e749a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a6e61915d0d64aaa865f242dea93b12a>>
 * @relayHash 2bf8d62dc6c5873c241a7411c81c16ec
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID fe8907d2399e24d926245722555453f9c22ffceae0abb8d339c68a0ecc7949de
const $ad1f1225aa9e749a$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "fe8907d2399e24d926245722555453f9c22ffceae0abb8d339c68a0ecc7949de",
        "metadata": {},
        "name": "CommitDetailsPopupViewCommitDetailsPopupViewQuery",
        "operationKind": "query",
        "text": null
    }
};
var $ad1f1225aa9e749a$export$2e2bcd8739ae039 = $ad1f1225aa9e749a$var$node;

});

parcelRegister("inqRW", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("7s7Iy").then(()=>parcelRequire('3AVFN'));

});


parcelRegister("2WAf5", function(module, exports) {
$parcel$export(module.exports, "deploymentDetailsEntryPoint", () => $1f214b02e0ffade9$export$bb44df517ead129f);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

var $kptA3 = parcelRequire("kptA3");

const $1f214b02e0ffade9$export$bb44df517ead129f = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("eLbVu")), {
        moduleId: "05ca3f4b",
        moduleName: "DeploymentDetailsPopup",
        priority: "interaction"
    }),
    getPreloadProps: ({ issueId: issueId })=>({
            queries: {
                deployments: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $kptA3.default,
                    variables: {
                        issueAris: [
                            issueId
                        ]
                    }
                }
            }
        })
});

});
parcelRegister("kptA3", function(module, exports) {
$parcel$export(module.exports, "default", () => $54c85c5e191a967c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5d5c6aecb398c60923b0f053463587c9>>
 * @relayHash b7f13685547567cb79b9104935dfddf0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 45cc764c8610f168265f189084eaf420bb8cc7cdaa6d3f678c6beeb06931b2ca
const $54c85c5e191a967c$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "45cc764c8610f168265f189084eaf420bb8cc7cdaa6d3f678c6beeb06931b2ca",
        "metadata": {},
        "name": "DeploymentDetailsPopupQuery",
        "operationKind": "query",
        "text": null
    }
};
var $54c85c5e191a967c$export$2e2bcd8739ae039 = $54c85c5e191a967c$var$node;

});

parcelRegister("eLbVu", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("1I4GK").then(()=>parcelRequire('etgUQ'));

});


parcelRegister("4GBRr", function(module, exports) {
$parcel$export(module.exports, "deploymentDetailsEntryPoint", () => $e63f09cc29cdee99$export$bb44df517ead129f);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

var $2gJo5 = parcelRequire("2gJo5");

const $e63f09cc29cdee99$export$bb44df517ead129f = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("lB6Kv")), {
        moduleId: "dd16a561",
        moduleName: "DeploymentDetailsPopup",
        priority: "interaction"
    }),
    getPreloadProps: ({ issueId: issueId })=>({
            queries: {
                deployments: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $2gJo5.default,
                    variables: {
                        issueAri: issueId
                    }
                }
            }
        })
});

});
parcelRegister("2gJo5", function(module, exports) {
$parcel$export(module.exports, "default", () => $1945c15bc122137f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5126f622b2ae8164bb2c13a7d1b90395>>
 * @relayHash 45572fe1b9eb6de0dfbaf2f842a3ba1c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d76fa6613144ca0b5385c7d7365506dd33267d06634f959c28b9d3cd30b5bddb
const $1945c15bc122137f$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "d76fa6613144ca0b5385c7d7365506dd33267d06634f959c28b9d3cd30b5bddb",
        "metadata": {},
        "name": "DeploymentDetailsPopupUiQuery",
        "operationKind": "query",
        "text": null
    }
};
var $1945c15bc122137f$export$2e2bcd8739ae039 = $1945c15bc122137f$var$node;

});

parcelRegister("lB6Kv", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("9XBok").then(()=>parcelRequire('fkQj2'));

});


parcelRegister("jPIBc", function(module, exports) {
$parcel$export(module.exports, "designDetailsEntryPoint", () => $e36dfa901fee6c7b$export$9b838851ea165d28);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

var $6YhpM = parcelRequire("6YhpM");

const $e36dfa901fee6c7b$export$9b838851ea165d28 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("lmNP4")), {
        moduleId: "b95980ed",
        moduleName: "DesignDetailsPopup",
        priority: "interaction"
    }),
    getPreloadProps: ({ issueId: issueId })=>({
            queries: {
                designDetailsPopup: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $6YhpM.default,
                    variables: {
                        issueAri: issueId
                    }
                }
            }
        })
});

});
parcelRegister("6YhpM", function(module, exports) {
$parcel$export(module.exports, "default", () => $c32599ab1fd7db12$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f0c6804fca61c9c039653e243946e589>>
 * @relayHash 0c3ac12d45ed9bc8274f9cae76b24ed6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4259ae0d3302519de00e9a44d84c99a4c9a8376a826603d6e7ab5634250f8017
const $c32599ab1fd7db12$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "4259ae0d3302519de00e9a44d84c99a4c9a8376a826603d6e7ab5634250f8017",
        "metadata": {},
        "name": "DesignDetailsPopupQuery",
        "operationKind": "query",
        "text": null
    }
};
var $c32599ab1fd7db12$export$2e2bcd8739ae039 = $c32599ab1fd7db12$var$node;

});

parcelRegister("lmNP4", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("4fOQw").then(()=>parcelRequire('ao3s0'));

});


parcelRegister("9p0ej", function(module, exports) {
$parcel$export(module.exports, "pullRequestDetailsEntryPoint", () => $adeaa99aba152484$export$37ab544e7066c095);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

var $45bdj = parcelRequire("45bdj");

const $adeaa99aba152484$export$37ab544e7066c095 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("bI5sK")), {
        moduleId: "cf783bc7",
        moduleName: "PRDetailsPopupView",
        priority: "interaction"
    }),
    getPreloadProps: ({ issueId: issueId, isNetworkOnly: isNetworkOnly = false })=>({
            queries: {
                pullRequestDetailsForIssue: {
                    options: {
                        fetchPolicy: isNetworkOnly ? 'network-only' : 'store-and-network'
                    },
                    parameters: $45bdj.default,
                    variables: {
                        issueId: issueId
                    }
                }
            }
        })
});

});
parcelRegister("45bdj", function(module, exports) {
$parcel$export(module.exports, "default", () => $6d8781484f88be25$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b36b64bf56162aeae9847c6b9d5622c4>>
 * @relayHash 7430b3e713f48209533b4c2cbdbd1515
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f92753f274185647bb7ca2f2fd590f76e5c9f6c7138a64b2a8acd0d575c89c9f
const $6d8781484f88be25$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "f92753f274185647bb7ca2f2fd590f76e5c9f6c7138a64b2a8acd0d575c89c9f",
        "metadata": {},
        "name": "PRDetailsPopupViewQuery",
        "operationKind": "query",
        "text": null
    }
};
var $6d8781484f88be25$export$2e2bcd8739ae039 = $6d8781484f88be25$var$node;

});

parcelRegister("bI5sK", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("7vBa2").then(()=>parcelRequire('bjtFX'));

});


parcelRegister("28n2N", function(module, exports) {
$parcel$export(module.exports, "pullRequestDetailsNewEntryPoint", () => $af23a14eb1a945c0$export$464b40a8e325de45);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

var $ilUa9 = parcelRequire("ilUa9");

const $af23a14eb1a945c0$export$464b40a8e325de45 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("eQB9S")), {
        moduleId: "acf7ed6c",
        moduleName: "PRDetailsPopupView",
        priority: "interaction"
    }),
    getPreloadProps: ({ issueId: issueId, isNetworkOnly: isNetworkOnly = false })=>({
            queries: {
                pullRequestDetailsForIssue: {
                    options: {
                        fetchPolicy: isNetworkOnly ? 'network-only' : 'store-and-network'
                    },
                    parameters: $ilUa9.default,
                    variables: {
                        issueId: issueId
                    }
                }
            }
        })
});

});
parcelRegister("ilUa9", function(module, exports) {
$parcel$export(module.exports, "default", () => $0b97a7bd51dd1ec7$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<df31d60c27af19f37593d9c26fceb25d>>
 * @relayHash be1c1fb8fb6d4391e28ce4c975d1938d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5fe5f85261296a591308f2f6b2f5a124d20eae0cd54295e3c49f5fac3c4ffaf4
const $0b97a7bd51dd1ec7$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "5fe5f85261296a591308f2f6b2f5a124d20eae0cd54295e3c49f5fac3c4ffaf4",
        "metadata": {},
        "name": "PRDetailsPopupViewUiQuery",
        "operationKind": "query",
        "text": null
    }
};
var $0b97a7bd51dd1ec7$export$2e2bcd8739ae039 = $0b97a7bd51dd1ec7$var$node;

});

parcelRegister("eQB9S", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("gZ001").then(()=>parcelRequire('b8TQj'));

});


parcelRegister("8Fo16", function(module, exports) {
$parcel$export(module.exports, "branchDetailsPopupLoad", () => $0b28b2df2568b853$export$1e45f095e94fd8a);
$parcel$export(module.exports, "commitDetailsPopupLoad", () => $0b28b2df2568b853$export$e3af05dcf8f03d06);
$parcel$export(module.exports, "deploymentDetailsPopupLoad", () => $0b28b2df2568b853$export$205c7cad3de97a2);
$parcel$export(module.exports, "prDetailsPopupLoad", () => $0b28b2df2568b853$export$3ca761127f6f2822);
$parcel$export(module.exports, "designDetailsPopupLoad", () => $0b28b2df2568b853$export$935f70f8029ab734);

var $hqYEY = parcelRequire("hqYEY");
const $0b28b2df2568b853$export$1e45f095e94fd8a = (0, $hqYEY.metrics).interaction({
    key: 'board.branch-details-popup-load'
});
const $0b28b2df2568b853$export$e3af05dcf8f03d06 = (0, $hqYEY.metrics).interaction({
    key: 'board.commit-details-popup-load'
});
const $0b28b2df2568b853$export$205c7cad3de97a2 = (0, $hqYEY.metrics).interaction({
    key: 'board.deployment-details-popup-load'
});
const $0b28b2df2568b853$export$3ca761127f6f2822 = (0, $hqYEY.metrics).interaction({
    key: 'board.pr-details-popup-load'
});
const $0b28b2df2568b853$export$935f70f8029ab734 = (0, $hqYEY.metrics).interaction({
    key: 'board.design-details-popup-load'
});

});

parcelRegister("4C7GN", function(module, exports) {
$parcel$export(module.exports, "default", () => $eac396c8fc57b97b$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $eac396c8fc57b97b$var$messages = (0, $7qGN1.defineMessages)({
    branchIconLabel: {
        "id": "development-board-dev-info-icon.branch-icon-label",
        "defaultMessage": "branch"
    },
    commitIconLabel: {
        "id": "development-board-dev-info-icon.commit-icon-label",
        "defaultMessage": "commit"
    },
    designIconLabel: {
        "id": "development-board-dev-info-icon.design-icon-label",
        "defaultMessage": "Linked design data"
    },
    deploymentIconLabel: {
        "id": "development-board-dev-info-icon.deployment-icon-label",
        "defaultMessage": "Linked deployment data."
    },
    deploymentProductionSuccessIconLabel: {
        "id": "development-board-dev-info-icon.deployment-production-success-icon-label",
        "defaultMessage": "Successful deployment to production."
    },
    deploymentProductionFailedIconLabel: {
        "id": "development-board-dev-info-icon.deployment-production-failed-icon-label",
        "defaultMessage": "Failed deployment to production."
    },
    deploymentNonProductionSuccessIconLabel: {
        "id": "development-board-dev-info-icon.deployment-non-production-success-icon-label",
        "defaultMessage": "Successful deployment to non-production environment."
    },
    deploymentNonProductionFailedIconLabel: {
        "id": "development-board-dev-info-icon.deployment-non-production-failed-icon-label",
        "defaultMessage": "Failed deployment to non-production environment."
    },
    openPullRequestIconLabel: {
        "id": "development-board-dev-info-icon.open-pull-request-icon-label",
        "defaultMessage": "pull request"
    },
    mergedPullRequestIconLabel: {
        "id": "development-board-dev-info-icon.merged-pull-request-icon-label",
        "defaultMessage": "merged pull request"
    },
    declinedPullRequestIconLabel: {
        "id": "development-board-dev-info-icon.declined-pull-request-icon-label",
        "defaultMessage": "declined pull request"
    },
    branchIconButtonLabel: {
        "id": "development-board-dev-info-icon.branch-icon-button-label",
        "defaultMessage": "Select to open branch details."
    },
    commitIconButtonLabel: {
        "id": "development-board-dev-info-icon.commit-icon-button-label",
        "defaultMessage": "Select to open commit details."
    },
    pullRequestIconButtonLabel: {
        "id": "development-board-dev-info-icon.pull-request-icon-button-label",
        "defaultMessage": "Select to open pull request details."
    },
    deploymentIconButtonLabel: {
        "id": "development-board-dev-info-icon.deployment-icon-button-label",
        "defaultMessage": "Select to open deployment details."
    },
    designIconButtonLabel: {
        "id": "development-board-dev-info-icon.design-icon-button-label",
        "defaultMessage": "Select to open design details."
    }
});
var $eac396c8fc57b97b$export$2e2bcd8739ae039 = $eac396c8fc57b97b$var$messages;

});



parcelRegister("4ISMJ", function(module, exports) {
$parcel$export(module.exports, "BambooDeploymentData", () => $0f32260dfeb6b74d$export$d73f8a5da425a8c5);

var $eYEJ5 = parcelRequire("eYEJ5");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $j4oe4 = parcelRequire("j4oe4");

var $goZPP = parcelRequire("goZPP");

var $3wl9L = parcelRequire("3wl9L");

var $k71qx = parcelRequire("k71qx");

var $lRq8t = parcelRequire("lRq8t");

var $kRgKj = parcelRequire("kRgKj");

var $9ym4f = parcelRequire("9ym4f");
const $0f32260dfeb6b74d$var$MAX_DISPLAYED_ENVIRONMENTS = 3;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0f32260dfeb6b74d$var$IconWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $0f32260dfeb6b74d$export$d73f8a5da425a8c5 = ({ jiraIssueDevSummary: jiraIssueDevSummary, onDeploymentClicked: onDeploymentClicked })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const data = (0, $j4oe4.useFragment)((0, $eYEJ5.default), jiraIssueDevSummary);
    const deployedBuilds = (data.deploymentEnvironments.overall.topEnvironments ?? []).filter((deployment)=>deployment.status === 'DEPLOYED');
    const environments = deployedBuilds.filter((environment)=>environment).map((environment)=>environment.title);
    const displayedEnvironments = environments.slice(0, $0f32260dfeb6b74d$var$MAX_DISPLAYED_ENVIRONMENTS).join(', ');
    const remainingEnvironments = environments.length > $0f32260dfeb6b74d$var$MAX_DISPLAYED_ENVIRONMENTS ? deployedBuilds.length - $0f32260dfeb6b74d$var$MAX_DISPLAYED_ENVIRONMENTS : null;
    return deployedBuilds.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0f32260dfeb6b74d$var$IconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        spacing: "compact",
        appearance: "subtle-link",
        onClick: (_, analyticsEvent)=>{
            onDeploymentClicked();
            (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'bambooSummaryCell');
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: formatMessage((0, $9ym4f.default).deployedEnvironments, {
            hasHiddenEnvironments: !!remainingEnvironments,
            displayedEnvironments: displayedEnvironments,
            othersCount: remainingEnvironments ?? 0
        }),
        onShow: (analyticsEvent)=>{
            (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'bambooSummaryTooltip');
        },
        position: "bottom"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3wl9L))), {
        spacing: "spacious",
        label: formatMessage((0, $9ym4f.default).bambooDeploymentIcon),
        color: "var(--ds-icon-success, #6A9A23)"
    })))) : null;
};

});
parcelRegister("eYEJ5", function(module, exports) {
$parcel$export(module.exports, "default", () => $70336a0ca34ea1f2$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e0b19c688784554a1b0ae24dca989610>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $70336a0ca34ea1f2$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "bambooDeploymentData_softwareReleasesVersionDetailIssueList",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "concreteType": "JiraIssueDeploymentEnvironmentDevSummaryContainer",
                "kind": "LinkedField",
                "name": "deploymentEnvironments",
                "plural": false,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "concreteType": "JiraIssueDeploymentEnvironmentDevSummary",
                            "kind": "LinkedField",
                            "name": "overall",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "concreteType": "JiraIssueDeploymentEnvironment",
                                        "kind": "LinkedField",
                                        "name": "topEnvironments",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "RequiredField",
                                                "field": {
                                                    "kind": "ScalarField",
                                                    "name": "status"
                                                },
                                                "action": "THROW",
                                                "path": "deploymentEnvironments.overall.topEnvironments.status"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "title"
                                            }
                                        ]
                                    },
                                    "action": "THROW",
                                    "path": "deploymentEnvironments.overall.topEnvironments"
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "deploymentEnvironments.overall"
                    }
                ]
            },
            "action": "THROW",
            "path": "deploymentEnvironments"
        }
    ],
    "type": "JiraIssueDevSummary"
};
$70336a0ca34ea1f2$var$node.hash = "f1dd87aba73205d2eb34f56156e152c9";
var $70336a0ca34ea1f2$export$2e2bcd8739ae039 = $70336a0ca34ea1f2$var$node;

});

parcelRegister("9ym4f", function(module, exports) {
$parcel$export(module.exports, "default", () => $b2bd01468622272d$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $b2bd01468622272d$var$messages = (0, $7qGN1.defineMessages)({
    bambooDeploymentIcon: {
        "id": "software-releases-version-detail-issue-list.issues.issue-card.delivery.bamboo-deployment-data.bamboo-deployment-icon",
        "defaultMessage": "Bamboo deployment icon"
    },
    deployedEnvironments: {
        "id": "software-releases-version-detail-issue-list.issues.issue-card.delivery.bamboo-deployment-data.deployed-environments",
        "defaultMessage": "{hasHiddenEnvironments, select, false {Deployed to {displayedEnvironments}} other {Deployed to {displayedEnvironments} and {othersCount, number} {othersCount, plural, one {other} other {others}}}}"
    }
});
var $b2bd01468622272d$export$2e2bcd8739ae039 = $b2bd01468622272d$var$messages;

});


parcelRegister("3x5hB", function(module, exports) {
$parcel$export(module.exports, "BuildData", () => $507f0bd7ed270736$export$c35480212824a8c6);

var $fllQj = parcelRequire("fllQj");

var $apyMx = parcelRequire("apyMx");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $j4oe4 = parcelRequire("j4oe4");

var $goZPP = parcelRequire("goZPP");

var $3wl9L = parcelRequire("3wl9L");

var $a03qM = parcelRequire("a03qM");

var $8mxGC = parcelRequire("8mxGC");

var $k71qx = parcelRequire("k71qx");

var $lRq8t = parcelRequire("lRq8t");

var $kRgKj = parcelRequire("kRgKj");

var $cVZcJ = parcelRequire("cVZcJ");
const $507f0bd7ed270736$export$be58b4326e23250f = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $507f0bd7ed270736$export$c35480212824a8c6 = ({ jiraIssueDevSummary: jiraIssueDevSummary, devOpsSummarisedBuilds: devOpsSummarisedBuilds, onBuildClicked: onBuildClicked })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const appLinkBuildData = (0, $j4oe4.useFragment)((0, $apyMx.default), jiraIssueDevSummary);
    const nonAppLinkBuildData = (0, $j4oe4.useFragment)((0, $fllQj.default), devOpsSummarisedBuilds ?? null);
    const { failedBuildCount: failedBuildCountAppLink, successfulBuildCount: successfulBuildCountAppLink, unknownBuildCount: unknownBuildCountAppLink } = appLinkBuildData.build.overall;
    const buildStates = nonAppLinkBuildData?.buildStates ?? [];
    const failedBuildCountNonAppLink = buildStates.find((buildState)=>buildState?.state === 'FAILED')?.count ?? 0;
    const successfulBuildCountNonAppLink = buildStates.find((buildState)=>buildState?.state === 'SUCCESSFUL')?.count ?? 0;
    const unknownBuildCountNonAppLink = buildStates.find((buildState)=>buildState?.state === 'UNKNOWN')?.count ?? 0;
    const failedBuildCount = failedBuildCountAppLink + failedBuildCountNonAppLink;
    const successfulBuildCount = successfulBuildCountAppLink + successfulBuildCountNonAppLink;
    const unknownBuildCount = unknownBuildCountAppLink + unknownBuildCountNonAppLink;
    const hasBuilds = failedBuildCount + successfulBuildCount + unknownBuildCount > 0;
    const renderIcon = ()=>{
        if (failedBuildCount > 0) {
            const failedBuildMessage = formatMessage((0, $cVZcJ.default).failedBuild, {
                buildCount: failedBuildCount
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
                content: failedBuildMessage
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a03qM))), {
                spacing: "spacious",
                label: failedBuildMessage,
                color: "var(--ds-icon-danger, #C9372C)"
            }));
        }
        if (successfulBuildCount > 0) {
            const successfulBuildMessage = formatMessage((0, $cVZcJ.default).successfulBuild, {
                buildCount: successfulBuildCount
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
                content: successfulBuildMessage
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3wl9L))), {
                spacing: "spacious",
                label: successfulBuildMessage,
                color: "var(--ds-icon-success, #6A9A23)"
            }));
        }
        if (unknownBuildCount > 0) {
            const unknownBuildMessage = formatMessage((0, $cVZcJ.default).unknownBuild, {
                buildCount: unknownBuildCount
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
                content: unknownBuildMessage
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8mxGC))), {
                spacing: "spacious",
                label: unknownBuildMessage,
                color: "var(--ds-icon-warning, #E06C00)"
            }));
        }
        return null;
    };
    return hasBuilds ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($507f0bd7ed270736$export$be58b4326e23250f, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        spacing: "none",
        appearance: "subtle-link",
        onClick: (_, analyticsEvent)=>{
            onBuildClicked();
            (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'versionsBuildsLozenge');
        }
    }, renderIcon())) : null;
};

});
parcelRegister("fllQj", function(module, exports) {
$parcel$export(module.exports, "default", () => $3c782acf9544e30e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c29b101cc868f9fea8432c1a43a162ce>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $3c782acf9544e30e$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "buildData_softwareReleasesVersionDetailIssueList_devOpsSummarisedBuilds",
    "selections": [
        {
            "concreteType": "DevOpsSummarisedBuildState",
            "kind": "LinkedField",
            "name": "buildStates",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "state"
                },
                {
                    "kind": "ScalarField",
                    "name": "count"
                }
            ]
        }
    ],
    "type": "DevOpsSummarisedBuilds"
};
$3c782acf9544e30e$var$node.hash = "dd56ce5fd7d57ba00bf945a310710b23";
var $3c782acf9544e30e$export$2e2bcd8739ae039 = $3c782acf9544e30e$var$node;

});

parcelRegister("apyMx", function(module, exports) {
$parcel$export(module.exports, "default", () => $795f52b1170f5f93$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<02f164da7183161ef2a4218fc267af7d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $795f52b1170f5f93$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "buildData_softwareReleasesVersionDetailIssueList_jiraIssueDevSummary",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "concreteType": "JiraIssueBuildDevSummaryContainer",
                "kind": "LinkedField",
                "name": "build",
                "plural": false,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "concreteType": "JiraIssueBuildDevSummary",
                            "kind": "LinkedField",
                            "name": "overall",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "kind": "ScalarField",
                                        "name": "failedBuildCount"
                                    },
                                    "action": "THROW",
                                    "path": "build.overall.failedBuildCount"
                                },
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "kind": "ScalarField",
                                        "name": "successfulBuildCount"
                                    },
                                    "action": "THROW",
                                    "path": "build.overall.successfulBuildCount"
                                },
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "kind": "ScalarField",
                                        "name": "unknownBuildCount"
                                    },
                                    "action": "THROW",
                                    "path": "build.overall.unknownBuildCount"
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "build.overall"
                    }
                ]
            },
            "action": "THROW",
            "path": "build"
        }
    ],
    "type": "JiraIssueDevSummary"
};
$795f52b1170f5f93$var$node.hash = "51c2585ef90bb27a6d71bf4d7670a32b";
var $795f52b1170f5f93$export$2e2bcd8739ae039 = $795f52b1170f5f93$var$node;

});

parcelRegister("cVZcJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $153bcdc3d27bce44$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $153bcdc3d27bce44$var$messages = (0, $7qGN1.defineMessages)({
    successfulBuild: {
        "id": "software-releases-version-detail-issue-list.issues.issue-card.delivery.build-data.successful-build",
        "defaultMessage": "{buildCount} successful {buildCount, plural, one {build} other {builds}}"
    },
    failedBuild: {
        "id": "software-releases-version-detail-issue-list.issues.issue-card.delivery.build-data.failed-build",
        "defaultMessage": "{buildCount} failed {buildCount, plural, one {build} other {builds}}"
    },
    unknownBuild: {
        "id": "software-releases-version-detail-issue-list.issues.issue-card.delivery.build-data.unknown-build",
        "defaultMessage": "{buildCount} unknown state {buildCount, plural, one {build} other {builds}}"
    }
});
var $153bcdc3d27bce44$export$2e2bcd8739ae039 = $153bcdc3d27bce44$var$messages;

});


parcelRegister("6XmLY", function(module, exports) {
$parcel$export(module.exports, "DeploymentData", () => $966811a6906ea4c1$export$b2b8032dce325acb);

var $3UZVY = parcelRequire("3UZVY");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $j4oe4 = parcelRequire("j4oe4");

var $goZPP = parcelRequire("goZPP");

var $lRq8t = parcelRequire("lRq8t");

var $kRgKj = parcelRequire("kRgKj");

var $jBmfi = parcelRequire("jBmfi");

var $80RPC = parcelRequire("80RPC");

var $cQY2F = parcelRequire("cQY2F");
const $966811a6906ea4c1$var$mapEnvironmentCategory = (category, formatMessage)=>{
    switch(category){
        case 'PRODUCTION':
            return formatMessage((0, $80RPC.default).production);
        case 'STAGING':
            return formatMessage((0, $80RPC.default).staging);
        case 'TESTING':
            return formatMessage((0, $80RPC.default).testing);
        case 'DEVELOPMENT':
            return formatMessage((0, $80RPC.default).development);
        case 'UNMAPPED':
            return formatMessage((0, $80RPC.default).unmapped);
        default:
            return formatMessage((0, $80RPC.default).unmapped);
    }
};
const $966811a6906ea4c1$var$mapState = (state, formatMessage)=>{
    switch(state){
        case (0, $jBmfi.DeploymentStateOptions).PENDING:
            return formatMessage((0, $80RPC.default).pending);
        case (0, $jBmfi.DeploymentStateOptions).IN_PROGRESS:
            return formatMessage((0, $80RPC.default).inProgress);
        case (0, $jBmfi.DeploymentStateOptions).SUCCESSFUL:
            return formatMessage((0, $80RPC.default).successful);
        case (0, $jBmfi.DeploymentStateOptions).FAILED:
            return formatMessage((0, $80RPC.default).failed);
        case (0, $jBmfi.DeploymentStateOptions).ROLLED_BACK:
            return formatMessage((0, $80RPC.default).rolledBack);
        case (0, $jBmfi.DeploymentStateOptions).CANCELLED:
            return formatMessage((0, $80RPC.default).cancelled);
        default:
            return formatMessage((0, $80RPC.default).unknown);
    }
};
const $966811a6906ea4c1$export$b2b8032dce325acb = ({ onDeploymentClicked: onDeploymentClicked, jiraIssueDevOpsSummarisedEntities: jiraIssueSummarisedEntities })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { summarisedDeployments: summarisedDeployments } = (0, $j4oe4.useFragment)((0, $3UZVY.default), jiraIssueSummarisedEntities);
    // If null, there is nothing to display
    if (summarisedDeployments == null) return null; // Same logic as <StatusIcon/> component that falls back to Unknown if null
    const category = summarisedDeployments.deploymentEnvironment?.category ? summarisedDeployments.deploymentEnvironment.category : 'UNMAPPED';
    const state = summarisedDeployments.deploymentState ? summarisedDeployments.deploymentState : 'UNKNOWN';
    const environmentCategory = $966811a6906ea4c1$var$mapEnvironmentCategory(category, formatMessage);
    const deploymentState = $966811a6906ea4c1$var$mapState(state, formatMessage);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($966811a6906ea4c1$var$BaseContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        spacing: "none",
        appearance: "subtle-link",
        onClick: (_, analyticsEvent)=>{
            onDeploymentClicked();
            (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'deploymentSummaryCell');
        },
        "aria-label": formatMessage((0, $80RPC.default).deploymentDataAriaLabel, {
            environmentCategory: environmentCategory,
            deploymentState: deploymentState
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($966811a6906ea4c1$var$ContentsContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($966811a6906ea4c1$var$StatusContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cQY2F.StatusIcon), {
        jiraSummarisedDeployments: summarisedDeployments
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($966811a6906ea4c1$var$DescriptionInternalContainer, null, environmentCategory))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $966811a6906ea4c1$var$BaseContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $966811a6906ea4c1$var$ContentsContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $966811a6906ea4c1$var$DescriptionInternalContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _18u0u2gc _1bto1l2s _1vhi1ule _ifb4glyw",
            __cmplp.className
        ])
    });
});
const $966811a6906ea4c1$var$StatusContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_4t3i1tcg _syaz1rpy",
            __cmplp.className
        ])
    });
});

});
parcelRegister("3UZVY", function(module, exports) {
$parcel$export(module.exports, "default", () => $623a8e885f7f8a81$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<67c4a61676a6940dc19deb497108d795>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $623a8e885f7f8a81$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "deploymentData_softwareReleasesVersionDetailIssueList",
    "selections": [
        {
            "concreteType": "DevOpsSummarisedDeployments",
            "kind": "LinkedField",
            "name": "summarisedDeployments",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "deploymentState"
                },
                {
                    "concreteType": "DevOpsEnvironment",
                    "kind": "LinkedField",
                    "name": "deploymentEnvironment",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "category"
                        }
                    ]
                },
                {
                    "kind": "FragmentSpread",
                    "name": "statusIcon_softwareReleasesVersionDetailIssueList"
                }
            ]
        }
    ],
    "type": "DevOpsSummarisedEntities"
};
$623a8e885f7f8a81$var$node.hash = "277da37647ab9525c90d0b7f19fa625e";
var $623a8e885f7f8a81$export$2e2bcd8739ae039 = $623a8e885f7f8a81$var$node;

});

parcelRegister("80RPC", function(module, exports) {
$parcel$export(module.exports, "default", () => $3a97e87ee22b24d0$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $3a97e87ee22b24d0$var$messages = (0, $7qGN1.defineMessages)({
    deploymentsTooltip: {
        "id": "software-releases-version-detail-issue-list.issues.issue-card.delivery.deployment-data.deployments-tooltip",
        "defaultMessage": "{deploymentCount} {deploymentCount, plural, one {deployment} other {deployments}}"
    },
    production: {
        "id": "software-releases-version-detail-issue-list.issues.issue-card.delivery.deployment-data.production",
        "defaultMessage": "Production"
    },
    staging: {
        "id": "software-releases-version-detail-issue-list.issues.issue-card.delivery.deployment-data.staging",
        "defaultMessage": "Staging"
    },
    testing: {
        "id": "software-releases-version-detail-issue-list.issues.issue-card.delivery.deployment-data.testing",
        "defaultMessage": "Testing"
    },
    development: {
        "id": "software-releases-version-detail-issue-list.issues.issue-card.delivery.deployment-data.development",
        "defaultMessage": "Development"
    },
    unmapped: {
        "id": "software-releases-version-detail-issue-list.issues.issue-card.delivery.deployment-data.unmapped",
        "defaultMessage": "Undefined environment"
    },
    pending: {
        "id": "software-releases-version-detail-issue-list.issues.issue-card.delivery.deployment-state.pending",
        "defaultMessage": "Pending"
    },
    inProgress: {
        "id": "software-releases-version-detail-issue-list.issues.issue-card.delivery.deployment-state.in-progress",
        "defaultMessage": "In progress"
    },
    successful: {
        "id": "software-releases-version-detail-issue-list.issues.issue-card.delivery.deployment-state.successful",
        "defaultMessage": "Successful"
    },
    failed: {
        "id": "software-releases-version-detail-issue-list.issues.issue-card.delivery.deployment-state.failed",
        "defaultMessage": "Failed"
    },
    rolledBack: {
        "id": "software-releases-version-detail-issue-list.issues.issue-card.delivery.deployment-state.rolled-back",
        "defaultMessage": "Rolled back"
    },
    cancelled: {
        "id": "software-releases-version-detail-issue-list.issues.issue-card.delivery.deployment-state.cancelled",
        "defaultMessage": "Canceled"
    },
    unknown: {
        "id": "software-releases-version-detail-issue-list.issues.issue-card.delivery.deployment-state.unknown",
        "defaultMessage": "Unknown"
    },
    deploymentDataAriaLabel: {
        "id": "software-releases-version-detail-issue-list.issues.issue-card.delivery.deployment-data.deployment-data-aria-label",
        "defaultMessage": "{environmentCategory} deployment {deploymentState}"
    }
});
var $3a97e87ee22b24d0$export$2e2bcd8739ae039 = $3a97e87ee22b24d0$var$messages;

});

parcelRegister("cQY2F", function(module, exports) {
$parcel$export(module.exports, "StatusIcon", () => $09915fa6a38d3a0a$export$b131c49b26d3f427);

var $6TJWx = parcelRequire("6TJWx");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $k71qx = parcelRequire("k71qx");

var $lRq8t = parcelRequire("lRq8t");

var $2ztQs = parcelRequire("2ztQs");

var $jBmfi = parcelRequire("jBmfi");

var $aQubH = parcelRequire("aQubH");
const $09915fa6a38d3a0a$var$mapState = (state, environmentType, formatMessage)=>{
    switch(state){
        case (0, $jBmfi.DeploymentStateOptions).PENDING:
            return {
                message: formatMessage((0, $aQubH.default).pending),
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2ztQs.DeploymentIcons), {
                    deploymentState: (0, $jBmfi.DeploymentStateOptions).PENDING,
                    size: "medium"
                })
            };
        case (0, $jBmfi.DeploymentStateOptions).IN_PROGRESS:
            return {
                message: formatMessage((0, $aQubH.default).inProgress),
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2ztQs.DeploymentIcons), {
                    deploymentState: (0, $jBmfi.DeploymentStateOptions).IN_PROGRESS,
                    size: "medium"
                })
            };
        case (0, $jBmfi.DeploymentStateOptions).SUCCESSFUL:
            if (environmentType === 'PRODUCTION') return {
                message: formatMessage((0, $aQubH.default).successful),
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2ztQs.DeploymentIcons), {
                    deploymentState: (0, $jBmfi.DeploymentStateOptions).SUCCESSFUL,
                    size: "medium"
                })
            };
            return {
                message: formatMessage((0, $aQubH.default).successful),
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2ztQs.DeploymentIcons), {
                    deploymentState: (0, $jBmfi.DeploymentStateOptions).SUCCESSFULNONPRODUCTION,
                    size: "medium"
                })
            };
        case (0, $jBmfi.DeploymentStateOptions).FAILED:
            return {
                message: formatMessage((0, $aQubH.default).failed),
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2ztQs.DeploymentIcons), {
                    deploymentState: (0, $jBmfi.DeploymentStateOptions).FAILED,
                    size: "medium"
                })
            };
        case (0, $jBmfi.DeploymentStateOptions).ROLLED_BACK:
            return {
                message: formatMessage((0, $aQubH.default).rolledBack),
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2ztQs.DeploymentIcons), {
                    deploymentState: (0, $jBmfi.DeploymentStateOptions).ROLLED_BACK,
                    size: "medium"
                })
            };
        case (0, $jBmfi.DeploymentStateOptions).CANCELLED:
            return {
                message: formatMessage((0, $aQubH.default).cancelled),
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2ztQs.DeploymentIcons), {
                    deploymentState: (0, $jBmfi.DeploymentStateOptions).CANCELLED,
                    size: "medium"
                })
            };
        case (0, $jBmfi.DeploymentStateOptions).UNKNOWN:
            return {
                message: formatMessage((0, $aQubH.default).unknown),
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2ztQs.DeploymentIcons), {
                    deploymentState: (0, $jBmfi.DeploymentStateOptions).UNKNOWN,
                    size: "medium"
                })
            };
        default:
            return {
                message: formatMessage((0, $aQubH.default).unknown),
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2ztQs.DeploymentIcons), {
                    deploymentState: (0, $jBmfi.DeploymentStateOptions).UNKNOWN,
                    size: "medium"
                })
            };
    }
};
const $09915fa6a38d3a0a$export$b131c49b26d3f427 = ({ jiraSummarisedDeployments: jiraSummarisedDeployments })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const deploymentSummary = (0, $j4oe4.useFragment)((0, $6TJWx.default), jiraSummarisedDeployments);
    const state = deploymentSummary.deploymentState ? deploymentSummary.deploymentState : 'UNKNOWN';
    const environment = deploymentSummary.deploymentEnvironment?.category ? deploymentSummary.deploymentEnvironment.category : 'UNMAPPED';
    const { icon: icon, message: message } = $09915fa6a38d3a0a$var$mapState(state, environment, formatMessage);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: message
    }, icon);
};

});
parcelRegister("6TJWx", function(module, exports) {
$parcel$export(module.exports, "default", () => $7a5121a0ec473832$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<975170e91daa818ce2bf2ced6fa58557>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $7a5121a0ec473832$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "statusIcon_softwareReleasesVersionDetailIssueList",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "deploymentState"
        },
        {
            "concreteType": "DevOpsEnvironment",
            "kind": "LinkedField",
            "name": "deploymentEnvironment",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "category"
                }
            ]
        }
    ],
    "type": "DevOpsSummarisedDeployments"
};
$7a5121a0ec473832$var$node.hash = "f151e3f42403e9b74c8517a51ce0be46";
var $7a5121a0ec473832$export$2e2bcd8739ae039 = $7a5121a0ec473832$var$node;

});

parcelRegister("aQubH", function(module, exports) {
$parcel$export(module.exports, "default", () => $378add849170c624$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $378add849170c624$var$messages = (0, $7qGN1.defineMessages)({
    pending: {
        "id": "software-releases-version-detail-issue-list.issues.issue-card.delivery.deployment-data.status-icon.pending",
        "defaultMessage": "Pending"
    },
    inProgress: {
        "id": "software-releases-version-detail-issue-list.issues.issue-card.delivery.deployment-data.status-icon.in-progress",
        "defaultMessage": "In-progress"
    },
    successful: {
        "id": "software-releases-version-detail-issue-list.issues.issue-card.delivery.deployment-data.status-icon.successful",
        "defaultMessage": "Successful"
    },
    failed: {
        "id": "software-releases-version-detail-issue-list.issues.issue-card.delivery.deployment-data.status-icon.failed",
        "defaultMessage": "Failed"
    },
    rolledBack: {
        "id": "software-releases-version-detail-issue-list.issues.issue-card.delivery.deployment-data.status-icon.rolled-back",
        "defaultMessage": "Rolled back"
    },
    cancelled: {
        "id": "software-releases-version-detail-issue-list.issues.issue-card.delivery.deployment-data.status-icon.cancelled",
        "defaultMessage": "Canceled"
    },
    unknown: {
        "id": "software-releases-version-detail-issue-list.issues.issue-card.delivery.deployment-data.status-icon.unknown",
        "defaultMessage": "Unknown"
    }
});
var $378add849170c624$export$2e2bcd8739ae039 = $378add849170c624$var$messages;

});




parcelRegister("3KkgD", function(module, exports) {
$parcel$export(module.exports, "Development", () => $78701ae0dadf4119$export$fb8a2d432bc2d196);
$parcel$export(module.exports, "DevelopmentContainer", () => $78701ae0dadf4119$export$3c8f918e865f8ead);

var $9zQL6 = parcelRequire("9zQL6");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $j4oe4 = parcelRequire("j4oe4");

var $goZPP = parcelRequire("goZPP");

var $MUJuW = parcelRequire("MUJuW");

var $awZZu = parcelRequire("awZZu");

var $7XCnf = parcelRequire("7XCnf");

var $k71qx = parcelRequire("k71qx");


var $ihplE = parcelRequire("ihplE");

var $1A9lq = parcelRequire("1A9lq");


var $lRq8t = parcelRequire("lRq8t");

var $kRgKj = parcelRequire("kRgKj");

var $4HIFl = parcelRequire("4HIFl");


var $7OCWP = parcelRequire("7OCWP");

var $88Rj9 = parcelRequire("88Rj9");

var $b4Glt = parcelRequire("b4Glt");
const $78701ae0dadf4119$export$fb8a2d432bc2d196 = ({ jiraIssue: jiraIssue, onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { issueId: issueId, devSummaryCache: devSummaryCache } = (0, $j4oe4.useFragment)((0, $9zQL6.default), jiraIssue);
    const { branch: branch, commit: commit, pullrequest: pullrequest, review: review } = devSummaryCache.devSummary;
    const pullRequestCount = pullrequest.overall.count;
    const pullRequestState = pullrequest.overall.state;
    if (pullRequestCount > 0 && pullRequestState) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($78701ae0dadf4119$export$3c8f918e865f8ead, {
        "data-version-details-issue-click-ignore-target": (0, $4HIFl.ISSUE_CARD_CLICK_IGNORE_TARGET)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        appearance: "subtle-link",
        onClick: (_, analyticsEvent)=>{
            onClick((0, $e31f0ec65fa77dec$export$6f74b53d652f13f3));
            (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'versionsPullRequestLozenge');
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($78701ae0dadf4119$var$VerticalCenter, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1A9lq.default), {
        devInfoType: (0, $ihplE.DevInfoTypes).PULLREQUEST,
        issueId: Number(issueId),
        customTrigger: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $88Rj9.CustomPullRequestIcon), {
            pullRequestState: (0, $b4Glt.toDevInfoType)(pullrequest.overall.state),
            label: formatMessage((0, $7OCWP.default).pullRequestIconLabel),
            primaryColor: (0, $b4Glt.mapPullRequestStateToIconColour)(pullrequest.overall.state)
        }),
        isStopPropagationOnClick: false,
        scopeId: (0, $bf14b8aa894cb92b$export$6bc465585d114926),
        location: (0, $2425df669549d924$export$ede40e627a0cbf14)
    }))));
    const reviewCount = review.overall.count;
    const reviewState = review.overall.state;
    if (reviewCount > 0 && reviewState) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($78701ae0dadf4119$export$3c8f918e865f8ead, {
        "data-version-details-issue-click-ignore-target": (0, $4HIFl.ISSUE_CARD_CLICK_IGNORE_TARGET)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: formatMessage((0, $7OCWP.default).reviewCount, {
            reviewCount: reviewCount
        }),
        position: "bottom-start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        appearance: "subtle-link",
        onClick: (_, analyticsEvent)=>{
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const reviewDataByProvider = {};
            review.summaryByProvider.forEach(({ providerId: providerId, name: name, count: count })=>{
                if (providerId != null) reviewDataByProvider[providerId] = {
                    name: name,
                    count: count
                };
            });
            onClick((0, $e31f0ec65fa77dec$export$3f1e2b276d607490), {
                overall: {
                    count: review.overall.count,
                    lastUpdated: review.overall.lastUpdated ?? '',
                    state: (0, $b4Glt.toReviewState)(reviewState),
                    stateCount: review.overall.stateCount
                },
                byInstanceType: reviewDataByProvider
            });
            (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'versionsReviewLozenge');
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($78701ae0dadf4119$var$VerticalCenter, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($MUJuW))), {
        label: formatMessage((0, $7OCWP.default).reviewIconLabel),
        color: (0, $b4Glt.mapReviewStateToIconColour)(reviewState)
    })))));
    const branchCount = branch.overall.count;
    if (branchCount > 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($78701ae0dadf4119$export$3c8f918e865f8ead, {
        "data-version-details-issue-click-ignore-target": (0, $4HIFl.ISSUE_CARD_CLICK_IGNORE_TARGET)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        appearance: "subtle-link",
        onClick: (_, analyticsEvent)=>{
            onClick((0, $e31f0ec65fa77dec$export$e18d81f044132a0e));
            (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'versionsBranchLozenge');
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($78701ae0dadf4119$var$VerticalCenter, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1A9lq.default), {
        devInfoType: (0, $ihplE.DevInfoTypes).BRANCH,
        issueId: Number(issueId),
        customTrigger: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($awZZu))), {
            spacing: "spacious",
            label: formatMessage((0, $7OCWP.default).branchIconLabel),
            color: "var(--ds-icon, #292A2E)"
        }),
        scopeId: (0, $bf14b8aa894cb92b$export$6bc465585d114926),
        location: (0, $2425df669549d924$export$ede40e627a0cbf14)
    }))));
    const commitCount = commit.overall.count;
    if (commitCount > 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($78701ae0dadf4119$export$3c8f918e865f8ead, {
        "data-version-details-issue-click-ignore-target": (0, $4HIFl.ISSUE_CARD_CLICK_IGNORE_TARGET)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($78701ae0dadf4119$var$VerticalCenter, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1A9lq.default), {
        devInfoType: (0, $ihplE.DevInfoTypes).COMMIT,
        issueId: Number(issueId),
        customTrigger: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
            appearance: "subtle-link",
            onClick: (_, analyticsEvent)=>{
                onClick((0, $e31f0ec65fa77dec$export$2e42513c7764d5f3));
                (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'versionsCommitLozenge');
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7XCnf))), {
            spacing: "spacious",
            label: formatMessage((0, $7OCWP.default).commitIconLabel),
            color: "var(--ds-icon, #292A2E)"
        })),
        scopeId: (0, $bf14b8aa894cb92b$export$6bc465585d114926),
        location: (0, $2425df669549d924$export$ede40e627a0cbf14)
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($78701ae0dadf4119$export$3c8f918e865f8ead, null);
};
const $78701ae0dadf4119$export$3c8f918e865f8ead = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1bsbckbl _1ul9ckbl",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $78701ae0dadf4119$var$VerticalCenter = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("9zQL6", function(module, exports) {
$parcel$export(module.exports, "default", () => $27e3369db631cd0d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<59d3ab5850892cb433979868803b1f20>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $27e3369db631cd0d$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "count"
    }, v1 = {
        "kind": "ScalarField",
        "name": "state"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "development_softwareReleasesVersionDetailIssueList",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "issueId"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "concreteType": "JiraIssueDevSummaryResult",
                    "kind": "LinkedField",
                    "name": "devSummaryCache",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "concreteType": "JiraIssueDevSummary",
                                "kind": "LinkedField",
                                "name": "devSummary",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "RequiredField",
                                        "field": {
                                            "concreteType": "JiraIssueBranchDevSummaryContainer",
                                            "kind": "LinkedField",
                                            "name": "branch",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "RequiredField",
                                                    "field": {
                                                        "concreteType": "JiraIssueBranchDevSummary",
                                                        "kind": "LinkedField",
                                                        "name": "overall",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v0 /*: any*/ ,
                                                                "action": "THROW",
                                                                "path": "devSummaryCache.devSummary.branch.overall.count"
                                                            }
                                                        ]
                                                    },
                                                    "action": "THROW",
                                                    "path": "devSummaryCache.devSummary.branch.overall"
                                                }
                                            ]
                                        },
                                        "action": "THROW",
                                        "path": "devSummaryCache.devSummary.branch"
                                    },
                                    {
                                        "kind": "RequiredField",
                                        "field": {
                                            "concreteType": "JiraIssueCommitDevSummaryContainer",
                                            "kind": "LinkedField",
                                            "name": "commit",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "RequiredField",
                                                    "field": {
                                                        "concreteType": "JiraIssueCommitDevSummary",
                                                        "kind": "LinkedField",
                                                        "name": "overall",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v0 /*: any*/ ,
                                                                "action": "THROW",
                                                                "path": "devSummaryCache.devSummary.commit.overall.count"
                                                            }
                                                        ]
                                                    },
                                                    "action": "THROW",
                                                    "path": "devSummaryCache.devSummary.commit.overall"
                                                }
                                            ]
                                        },
                                        "action": "THROW",
                                        "path": "devSummaryCache.devSummary.commit"
                                    },
                                    {
                                        "kind": "RequiredField",
                                        "field": {
                                            "concreteType": "JiraIssuePullRequestDevSummaryContainer",
                                            "kind": "LinkedField",
                                            "name": "pullrequest",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "RequiredField",
                                                    "field": {
                                                        "concreteType": "JiraIssuePullRequestDevSummary",
                                                        "kind": "LinkedField",
                                                        "name": "overall",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v0 /*: any*/ ,
                                                                "action": "THROW",
                                                                "path": "devSummaryCache.devSummary.pullrequest.overall.count"
                                                            },
                                                            v1 /*: any*/ 
                                                        ]
                                                    },
                                                    "action": "THROW",
                                                    "path": "devSummaryCache.devSummary.pullrequest.overall"
                                                }
                                            ]
                                        },
                                        "action": "THROW",
                                        "path": "devSummaryCache.devSummary.pullrequest"
                                    },
                                    {
                                        "kind": "RequiredField",
                                        "field": {
                                            "concreteType": "JiraIssueReviewDevSummaryContainer",
                                            "kind": "LinkedField",
                                            "name": "review",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "RequiredField",
                                                    "field": {
                                                        "concreteType": "JiraIssueReviewDevSummary",
                                                        "kind": "LinkedField",
                                                        "name": "overall",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v0 /*: any*/ ,
                                                                "action": "THROW",
                                                                "path": "devSummaryCache.devSummary.review.overall.count"
                                                            },
                                                            v1 /*: any*/ ,
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "lastUpdated"
                                                            },
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": {
                                                                    "kind": "ScalarField",
                                                                    "name": "stateCount"
                                                                },
                                                                "action": "THROW",
                                                                "path": "devSummaryCache.devSummary.review.overall.stateCount"
                                                            }
                                                        ]
                                                    },
                                                    "action": "THROW",
                                                    "path": "devSummaryCache.devSummary.review.overall"
                                                },
                                                {
                                                    "kind": "RequiredField",
                                                    "field": {
                                                        "concreteType": "JiraIssueDevSummaryByProvider",
                                                        "kind": "LinkedField",
                                                        "name": "summaryByProvider",
                                                        "plural": true,
                                                        "selections": [
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "providerId"
                                                            },
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "name"
                                                            },
                                                            v0 /*: any*/ 
                                                        ]
                                                    },
                                                    "action": "THROW",
                                                    "path": "devSummaryCache.devSummary.review.summaryByProvider"
                                                }
                                            ]
                                        },
                                        "action": "THROW",
                                        "path": "devSummaryCache.devSummary.review"
                                    }
                                ]
                            },
                            "action": "THROW",
                            "path": "devSummaryCache.devSummary"
                        }
                    ]
                },
                "action": "THROW",
                "path": "devSummaryCache"
            }
        ],
        "type": "JiraIssue"
    };
}();
$27e3369db631cd0d$var$node.hash = "a6fa00d421e78b1cfca02a289c940e70";
var $27e3369db631cd0d$export$2e2bcd8739ae039 = $27e3369db631cd0d$var$node;

});

parcelRegister("7OCWP", function(module, exports) {
$parcel$export(module.exports, "default", () => $61f23dbb455b654c$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $61f23dbb455b654c$var$messages = (0, $7qGN1.defineMessages)({
    commitIconLabel: {
        "id": "software-releases-version-detail-issue-list.issues.issue-card.development.commit-icon-label",
        "defaultMessage": "Commits"
    },
    branchIconLabel: {
        "id": "software-releases-version-detail-issue-list.issues.issue-card.development.branch-icon-label",
        "defaultMessage": "Branches"
    },
    pullRequestIconLabel: {
        "id": "software-releases-version-detail-issue-list.issues.issue-card.development.pull-request-icon-label",
        "defaultMessage": "Pull requests"
    },
    reviewCount: {
        "id": "software-releases-version-detail-issue-list.issues.issue-card.development.review-count",
        "defaultMessage": "{reviewCount} {reviewCount, plural, one {review} other {reviews}}"
    },
    reviewIconLabel: {
        "id": "software-releases-version-detail-issue-list.issues.issue-card.development.review-icon-label",
        "defaultMessage": "Reviews"
    }
});
var $61f23dbb455b654c$export$2e2bcd8739ae039 = $61f23dbb455b654c$var$messages;

});

parcelRegister("88Rj9", function(module, exports) {
$parcel$export(module.exports, "CustomPullRequestIcon", () => $7d60afbc1438b24e$export$59a5de4025575d75);

var $eJOHy = parcelRequire("eJOHy");

var $fL0In = parcelRequire("fL0In");

var $MUJuW = parcelRequire("MUJuW");

var $ihplE = parcelRequire("ihplE");
const $7d60afbc1438b24e$var$PullrequestDeclinedIcon = ({ label: label })=>// eslint-disable-next-line @atlaskit/design-system/no-custom-icons
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fL0In.default), {
        label: label,
        glyph: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("rect", {
                width: "24",
                height: "24",
                fill: "var(--ds-icon-inverse, #FFFFFF)",
                fillOpacity: "0.01"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M6.75 5.25C6.19772 5.25 5.75 5.69772 5.75 6.25C5.75 6.80228 6.19772 7.25 6.75 7.25C7.30228 7.25 7.75 6.80228 7.75 6.25C7.75 5.69772 7.30228 5.25 6.75 5.25ZM3.75 6.25C3.75 4.59315 5.09315 3.25 6.75 3.25C8.40685 3.25 9.75 4.59315 9.75 6.25C9.75 7.55622 8.91519 8.66746 7.75 9.07929V20.25C7.75 20.8023 7.30228 21.25 6.75 21.25C6.19772 21.25 5.75 20.8023 5.75 20.25V9.07929C4.58481 8.66746 3.75 7.55622 3.75 6.25Z",
                fill: "var(--ds-icon-danger, #C9372C)"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M16.75 11.25C17.3023 11.25 17.75 11.6977 17.75 12.25V15.4207C18.9152 15.8325 19.75 16.9438 19.75 18.25C19.75 19.9069 18.4069 21.25 16.75 21.25C15.0931 21.25 13.75 19.9069 13.75 18.25C13.75 16.9438 14.5848 15.8325 15.75 15.4207V12.25C15.75 11.6977 16.1977 11.25 16.75 11.25ZM16.75 17.25C16.1977 17.25 15.75 17.6977 15.75 18.25C15.75 18.8023 16.1977 19.25 16.75 19.25C17.3023 19.25 17.75 18.8023 17.75 18.25C17.75 17.6977 17.3023 17.25 16.75 17.25Z",
                fill: "var(--ds-icon-danger, #C9372C)"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M13.5429 3.04289C13.9334 2.65237 14.5666 2.65237 14.9571 3.04289L16.75 4.83579L18.5429 3.04289C18.9334 2.65237 19.5666 2.65237 19.9571 3.04289C20.3476 3.43342 20.3476 4.06658 19.9571 4.45711L18.1642 6.25L19.9571 8.04289C20.3476 8.43342 20.3476 9.06658 19.9571 9.45711C19.5666 9.84763 18.9334 9.84763 18.5429 9.45711L16.75 7.66421L14.9571 9.45711C14.5666 9.84763 13.9334 9.84763 13.5429 9.45711C13.1524 9.06658 13.1524 8.43342 13.5429 8.04289L15.3358 6.25L13.5429 4.45711C13.1524 4.06658 13.1524 3.43342 13.5429 3.04289Z",
                fill: "var(--ds-icon-danger, #C9372C)"
            }))
    });
const $7d60afbc1438b24e$var$PullrequestMergedIcon = ({ label: label })=>// eslint-disable-next-line @atlaskit/design-system/no-custom-icons
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fL0In.default), {
        label: label,
        glyph: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("rect", {
                width: "24",
                height: "24",
                fill: "var(--ds-icon-inverse, #FFFFFF)",
                fillOpacity: "0.01"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M6.5 5C5.94772 5 5.5 5.44772 5.5 6C5.5 6.55228 5.94772 7 6.5 7C7.05228 7 7.5 6.55228 7.5 6C7.5 5.44772 7.05228 5 6.5 5ZM3.5 6C3.5 4.34315 4.84315 3 6.5 3C8.15685 3 9.5 4.34315 9.5 6C9.5 7.30622 8.66519 8.41746 7.5 8.82929V20C7.5 20.5523 7.05228 21 6.5 21C5.94772 21 5.5 20.5523 5.5 20V8.82929C4.33481 8.41746 3.5 7.30622 3.5 6Z",
                fill: "var(--ds-icon-success, #6A9A23)"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M6.5 7C7.05228 7 7.5 7.44772 7.5 8V10C7.5 13.5912 10.2043 16.5508 13.6876 16.9534C14.1123 15.8126 15.2113 15 16.5 15C18.1569 15 19.5 16.3431 19.5 18C19.5 19.6569 18.1569 21 16.5 21C15.1793 21 14.0579 20.1466 13.6572 18.9611C9.08185 18.5362 5.5 14.6864 5.5 10V8C5.5 7.44772 5.94772 7 6.5 7ZM16.5 17C15.9477 17 15.5 17.4477 15.5 18C15.5 18.5523 15.9477 19 16.5 19C17.0523 19 17.5 18.5523 17.5 18C17.5 17.4477 17.0523 17 16.5 17Z",
                fill: "var(--ds-icon-success, #6A9A23)"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M20.2071 4.29289C20.5976 4.68342 20.5976 5.31658 20.2071 5.70711L16.2071 9.70711C15.8166 10.0976 15.1834 10.0976 14.7929 9.70711L12.7929 7.70711C12.4024 7.31658 12.4024 6.68342 12.7929 6.29289C13.1834 5.90237 13.8166 5.90237 14.2071 6.29289L15.5 7.58579L18.7929 4.29289C19.1834 3.90237 19.8166 3.90237 20.2071 4.29289Z",
                fill: "var(--ds-icon-success, #6A9A23)"
            }))
    });
const $7d60afbc1438b24e$export$59a5de4025575d75 = ({ pullRequestState: pullRequestState, label: label, primaryColor: primaryColor })=>{
    if (pullRequestState === (0, $ihplE.DevInfoTypes).DECLINED) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($7d60afbc1438b24e$var$PullrequestDeclinedIcon, {
        label: label
    });
    if (pullRequestState === (0, $ihplE.DevInfoTypes).MERGED) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($7d60afbc1438b24e$var$PullrequestMergedIcon, {
        label: label
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($MUJuW))), {
        label: label,
        LEGACY_primaryColor: primaryColor
    });
};

});

parcelRegister("b4Glt", function(module, exports) {
$parcel$export(module.exports, "mapPullRequestStateToIconColour", () => $6ca64084a4ccbd60$export$b659f6ad1597c81c);
$parcel$export(module.exports, "mapReviewStateToIconColour", () => $6ca64084a4ccbd60$export$3503f5c2d5e8553a);
$parcel$export(module.exports, "toReviewState", () => $6ca64084a4ccbd60$export$e4227c1382daeae5);
$parcel$export(module.exports, "toDevInfoType", () => $6ca64084a4ccbd60$export$f3b34c5748a7d335);

var $ihplE = parcelRequire("ihplE");
const $6ca64084a4ccbd60$export$b659f6ad1597c81c = (state)=>{
    switch(state){
        case 'MERGED':
            return "var(--ds-icon-success, #6A9A23)";
        case 'DECLINED':
            return "var(--ds-icon-danger, #C9372C)";
        default:
            return "var(--ds-icon, #292A2E)";
    }
};
const $6ca64084a4ccbd60$export$3503f5c2d5e8553a = (state)=>{
    switch(state){
        case 'REVIEW':
            return "var(--ds-icon, #292A2E)";
        case 'APPROVAL':
            return "var(--ds-icon, #292A2E)";
        case 'SUMMARIZE':
            return "var(--ds-icon, #292A2E)";
        case 'REJECTED':
            return "var(--ds-icon-danger, #C9372C)";
        case 'CLOSED':
            return "var(--ds-icon-success, #6A9A23)";
        case 'DRAFT':
            return "var(--ds-icon, #292A2E)";
        case 'DEAD':
            return "var(--ds-icon-danger, #C9372C)";
        case 'UNKNOWN':
            return "var(--ds-icon-danger, #C9372C)";
        default:
            return "var(--ds-icon, #292A2E)";
    }
};
const $6ca64084a4ccbd60$export$e4227c1382daeae5 = (state)=>{
    switch(state){
        case 'REVIEW':
        case 'APPROVAL':
        case 'SUMMARIZE':
        case 'REJECTED':
        case 'CLOSED':
        case 'DRAFT':
        case 'DEAD':
            return state;
        default:
            return 'UNKNOWN';
    }
};
const $6ca64084a4ccbd60$export$f3b34c5748a7d335 = (state)=>{
    switch(state){
        case 'DECLINED':
            return (0, $ihplE.DevInfoTypes).DECLINED;
        case 'MERGED':
            return (0, $ihplE.DevInfoTypes).MERGED;
        default:
            return (0, $ihplE.DevInfoTypes).PULLREQUEST;
    }
};

});


parcelRegister("6ajZe", function(module, exports) {
$parcel$export(module.exports, "FeatureFlags", () => $07ec9ae6f5ab1ffd$export$ab28ab2e245553c7);

var $gFtfA = parcelRequire("gFtfA");

var $aoPbh = parcelRequire("aoPbh");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $j4oe4 = parcelRequire("j4oe4");

var $goZPP = parcelRequire("goZPP");


var $kRgKj = parcelRequire("kRgKj");

var $1Zr8r = parcelRequire("1Zr8r");

var $8YYSL = parcelRequire("8YYSL");

var $dCP7m = parcelRequire("dCP7m");
const $07ec9ae6f5ab1ffd$export$ab28ab2e245553c7 = ({ devOpsSummarisedEntities: devOpsSummarisedEntities, jiraIssue: jiraIssue, onClick: onClick, setFeatureFlagEmptyStateModalOpen: setFeatureFlagEmptyStateModalOpen, featureFlagButtonRef: featureFlagButtonRef, rowNum: rowNum })=>{
    const issue = (0, $j4oe4.useFragment)((0, $aoPbh.default), jiraIssue);
    const { providers: providers } = (0, $j4oe4.useFragment)((0, $gFtfA.default), devOpsSummarisedEntities);
    const summarisedFlags = issue.summarisedFeatureFlags;
    const featureFlagCount = summarisedFlags?.totalCount ?? 0;
    const hasFeatureFlags = summarisedFlags != null && featureFlagCount != null && featureFlagCount > 0;
    const featureFlagProviders = (providers.featureFlagProviders ?? []).filter(Boolean);
    const hasFeatureFlagProviders = featureFlagProviders.length > 0;
    const renderContent = ()=>{
        const fields = issue.fieldsById.edges.map((edge)=>edge?.node).filter(Boolean);
        const jiraIssueSummary = fields.find((fieldNode)=>fieldNode?.fieldId === 'summary'); // Render the single or multiple flags component if the issue has at least one linked
        // feature flag
        if (hasFeatureFlags) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
            appearance: "subtle-link",
            spacing: "none",
            onClick: (_, analyticsEvent)=>{
                onClick((0, $e31f0ec65fa77dec$export$c69477f358d30f7e));
                (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'featureFlagSummaryCell');
            }
        }, featureFlagCount === 1 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dCP7m.SingleFlag), {
            summarisedFlags: summarisedFlags
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8YYSL.MultipleFlags), {
            jiraIssue: issue,
            summarisedFlags: summarisedFlags
        }));
         // Render the "add flag" dropdown if there's at least one feature flag provider and the
        // issue has no linked feature flags
        if (hasFeatureFlagProviders) return jiraIssueSummary != null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($07ec9ae6f5ab1ffd$export$e7937791cac9c51b, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1Zr8r.AddFeatureFlagDropdown), {
            devOpsFeatureFlagProviders: featureFlagProviders,
            jiraIssue: issue,
            jiraIssueSummary: jiraIssueSummary,
            onOpenFeatureFlagEmptyStateModal: ()=>setFeatureFlagEmptyStateModalOpen(true)
        })) : null;
         // If the issue has no linked feature flags and there are no linked providers, return the
        // "add feature flag provider" button
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($07ec9ae6f5ab1ffd$export$e7937791cac9c51b, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1Zr8r.AddFeatureFlagButton), {
            featureFlagButtonRef: featureFlagButtonRef,
            onOpenFeatureFlagEmptyStateModal: ()=>setFeatureFlagEmptyStateModalOpen(true),
            rowNum: rowNum
        }));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($07ec9ae6f5ab1ffd$export$c518a6c3736e9db7, null, renderContent(), " ");
};
const $07ec9ae6f5ab1ffd$export$e7937791cac9c51b = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        className: (0, $hcewu.default)([
            "_1wtl15vq _j9irewfl",
            "_qrawewfl"
        ])
    }, children); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $07ec9ae6f5ab1ffd$export$c518a6c3736e9db7 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _1b081l8a _15yj1l8a _13n41tcg _fhcx1tcg",
            __cmplp.className
        ])
    });
});
const $07ec9ae6f5ab1ffd$var$styles = null;
const $07ec9ae6f5ab1ffd$var$stylesWithFocusWithin = null;

});
parcelRegister("gFtfA", function(module, exports) {
$parcel$export(module.exports, "default", () => $27cde43076588449$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ce2c34f4872428c634fc08b19e03484c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $27cde43076588449$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "featureFlags_softwareReleasesVersionDetailIssueList_devOpsSummarisedEntities",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "concreteType": "DevOpsProviders",
                "kind": "LinkedField",
                "name": "providers",
                "plural": false,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "concreteType": "DevOpsFeatureFlagProvider",
                            "kind": "LinkedField",
                            "name": "featureFlagProviders",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                },
                                {
                                    "kind": "FragmentSpread",
                                    "name": "addFeatureFlag_softwareReleasesVersionDetailIssueList_AddFeatureFlagDropdown_devOpsFeatureFlagProviders"
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "providers.featureFlagProviders"
                    }
                ]
            },
            "action": "THROW",
            "path": "providers"
        }
    ],
    "type": "DevOpsSummarisedEntities"
};
$27cde43076588449$var$node.hash = "6396e923543528812899038e05950d31";
var $27cde43076588449$export$2e2bcd8739ae039 = $27cde43076588449$var$node;

});

parcelRegister("aoPbh", function(module, exports) {
$parcel$export(module.exports, "default", () => $ebed1d6fc57e0502$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3f31c4749c13d147d19d3d7f37ad80b6>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $ebed1d6fc57e0502$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "featureFlags_softwareReleasesVersionDetailIssueList_jiraIssue",
    "selections": [
        {
            "concreteType": "DevOpsSummarisedFeatureFlags",
            "kind": "LinkedField",
            "name": "summarisedFeatureFlags",
            "plural": false,
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "multipleFlags_softwareReleasesVersionDetailIssueList_summarisedFlags"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "singleFlag_softwareReleasesVersionDetailIssueList"
                },
                {
                    "kind": "ScalarField",
                    "name": "totalCount"
                }
            ]
        },
        {
            "kind": "RequiredField",
            "field": {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "ids",
                        "value": [
                            "priority",
                            "summary",
                            "assignee",
                            "status",
                            "issuetype"
                        ]
                    }
                ],
                "concreteType": "JiraIssueFieldConnection",
                "kind": "LinkedField",
                "name": "fieldsById",
                "plural": false,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "concreteType": "JiraIssueFieldEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "kind": "ScalarField",
                                                "name": "fieldId"
                                            },
                                            "action": "THROW",
                                            "path": "fieldsById.edges.node.fieldId"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "addFeatureFlag_softwareReleasesVersionDetailIssueList_AddFeatureFlagDropdown_jiraIssueSummary"
                                                }
                                            ],
                                            "type": "JiraSingleLineTextField"
                                        }
                                    ]
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "fieldsById.edges"
                    }
                ],
                "storageKey": "fieldsById(ids:[\"priority\",\"summary\",\"assignee\",\"status\",\"issuetype\"])"
            },
            "action": "THROW",
            "path": "fieldsById"
        },
        {
            "kind": "FragmentSpread",
            "name": "addFeatureFlag_softwareReleasesVersionDetailIssueList_AddFeatureFlagDropdown_jiraIssue"
        },
        {
            "kind": "FragmentSpread",
            "name": "multipleFlags_softwareReleasesVersionDetailIssueList_jiraIssue"
        }
    ],
    "type": "JiraIssue"
};
$ebed1d6fc57e0502$var$node.hash = "bdfcd9de28b80604417e3f543bdb55e1";
var $ebed1d6fc57e0502$export$2e2bcd8739ae039 = $ebed1d6fc57e0502$var$node;

});

parcelRegister("1Zr8r", function(module, exports) {
$parcel$export(module.exports, "AddFeatureFlagDropdown", () => $650b5e59cc0f692f$export$e0238a9f85d3899d);
$parcel$export(module.exports, "AddFeatureFlagButton", () => $650b5e59cc0f692f$export$18659c2363dd7739);

var $2ZcnN = parcelRequire("2ZcnN");

var $erUek = parcelRequire("erUek");

var $2M0ob = parcelRequire("2M0ob");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $j4oe4 = parcelRequire("j4oe4");

var $goZPP = parcelRequire("goZPP");

var $lRq8t = parcelRequire("lRq8t");

var $2imLM = parcelRequire("2imLM");

var $kGj4V = parcelRequire("kGj4V");
var $kRgKj = parcelRequire("kRgKj");

var $eS29z = parcelRequire("eS29z");

var $bQWwW = parcelRequire("bQWwW");

var $2VEfl = parcelRequire("2VEfl");

var $htfHB = parcelRequire("htfHB");

var $fynQc = parcelRequire("fynQc");

const $650b5e59cc0f692f$var$ActionMenu = (0, $bQWwW.lazy)(()=>(parcelRequire("bqINX")).then((module)=>module.ActionMenu), {
    moduleId: "./src/packages/releases/issue-list/src/ui/issues/issue-card/feature-flags/add-feature-flag/action-menu/index.tsx"
}); // Extract just the content excluding button so we don't need to worry about passing props and
// forwardRef
const $650b5e59cc0f692f$var$TriggerContent = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($650b5e59cc0f692f$var$ButtonContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $htfHB.AddFeatureFlagIcon), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($650b5e59cc0f692f$var$ButtonText, null, children));
const $650b5e59cc0f692f$export$e0238a9f85d3899d = ({ jiraIssue: jiraIssue, jiraIssueSummary: jiraIssueSummary, devOpsFeatureFlagProviders: devOpsFeatureFlagProviders, onOpenFeatureFlagEmptyStateModal: onOpenFeatureFlagEmptyStateModal })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [isDropdownOpen, setIsDropdownOpen] = (0, $eJOHy.useState)(false);
    const issue = (0, $j4oe4.useFragment)((0, $2M0ob.default), jiraIssue);
    const issueSummary = (0, $j4oe4.useFragment)((0, $erUek.default), jiraIssueSummary);
    const featureFlagProviders = (0, $j4oe4.useFragment)((0, $2ZcnN.default), devOpsFeatureFlagProviders);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($650b5e59cc0f692f$var$OnHoverContainer, {
        isVisible: isDropdownOpen
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "action-menu",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
            appearance: "subtle-link",
            spacing: "none",
            isDisabled: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($650b5e59cc0f692f$var$TriggerContent, null, formatMessage((0, $fynQc.default).addFeatureFlag)))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($650b5e59cc0f692f$var$ActionMenu, {
        jiraIssue: issue,
        jiraIssueSummary: issueSummary,
        onOpenChange: ({ isOpen: isOpen })=>setIsDropdownOpen(isOpen),
        devOpsFeatureFlagProviders: featureFlagProviders,
        onOpenFeatureFlagEmptyStateExperience: onOpenFeatureFlagEmptyStateModal,
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
                appearance: "subtle-link",
                spacing: "none",
                ref: triggerRef,
                ...props
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($650b5e59cc0f692f$var$TriggerContent, null, formatMessage((0, $fynQc.default).addFeatureFlag)))
    })));
};
const $650b5e59cc0f692f$export$18659c2363dd7739 = ({ onOpenFeatureFlagEmptyStateModal: onOpenFeatureFlagEmptyStateModal, rowNum: rowNum, featureFlagButtonRef: featureFlagButtonRef })=>{
    const spotlightButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "action-button-no-provider",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
            appearance: "subtle-link",
            spacing: "none",
            isDisabled: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $htfHB.AddFeatureFlagIcon), null))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2VEfl.ActionButtonNoProviderAsync), {
        emptyStateButtonRef: featureFlagButtonRef,
        onClick: (_, analyticsEvent)=>{
            (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'versionDetailAddFeatureFlagButton');
            onOpenFeatureFlagEmptyStateModal();
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $htfHB.AddFeatureFlagIcon), null)));
    const regularButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        ref: featureFlagButtonRef,
        appearance: "subtle-link",
        spacing: "none",
        onClick: (_, analyticsEvent)=>{
            (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'versionDetailAddFeatureFlagButton');
            onOpenFeatureFlagEmptyStateModal();
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $htfHB.AddFeatureFlagIcon), null));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($650b5e59cc0f692f$var$AddFeatureFlagButtonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kGj4V.ContextualAnalyticsData), {
        sourceName: "versionDetailsTableAddFeatureFlagActionButton",
        sourceType: (0, $aa42ce8e355d58fa$export$f636b5b56f1d624a)
    }, rowNum === 1 ? spotlightButton : regularButton, rowNum === 1 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eS29z.FireScreenAnalytics), null) : null));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $650b5e59cc0f692f$var$ButtonContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $650b5e59cc0f692f$var$ButtonText = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_u5f3u2gc _1flu1nu9 _1a4cglyw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $650b5e59cc0f692f$var$AddFeatureFlagButtonWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $650b5e59cc0f692f$var$OnHoverContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isVisible: isVisible, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw",
            __cmplp.isVisible ? "_3um015ya" : "_3um015vq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("2ZcnN", function(module, exports) {
$parcel$export(module.exports, "default", () => $2aba1301c568a5ab$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b5e7746a103df83550bdda76eb8415f7>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $2aba1301c568a5ab$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": {
        "plural": true
    },
    "name": "addFeatureFlag_softwareReleasesVersionDetailIssueList_AddFeatureFlagDropdown_devOpsFeatureFlagProviders",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "actionMenu_softwareReleasesVersionDetailIssueList_devOpsFeatureFlagProviders"
        }
    ],
    "type": "DevOpsFeatureFlagProvider"
};
$2aba1301c568a5ab$var$node.hash = "9b78d95e09cfbfd2c5af5b680d6fc543";
var $2aba1301c568a5ab$export$2e2bcd8739ae039 = $2aba1301c568a5ab$var$node;

});

parcelRegister("erUek", function(module, exports) {
$parcel$export(module.exports, "default", () => $87868b50c72650ac$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2c9a416112e3bed4c41b26a4d887a703>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $87868b50c72650ac$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "addFeatureFlag_softwareReleasesVersionDetailIssueList_AddFeatureFlagDropdown_jiraIssueSummary",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "actionMenu_softwareReleasesVersionDetailIssueList_jiraIssueSummary"
        }
    ],
    "type": "JiraSingleLineTextField"
};
$87868b50c72650ac$var$node.hash = "f26b20a2f8e5f0c916921d8c8691c202";
var $87868b50c72650ac$export$2e2bcd8739ae039 = $87868b50c72650ac$var$node;

});

parcelRegister("2M0ob", function(module, exports) {
$parcel$export(module.exports, "default", () => $6ff94d4489928ab3$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e5c21fffefe38a3c828a06aaddbce9c8>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $6ff94d4489928ab3$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "addFeatureFlag_softwareReleasesVersionDetailIssueList_AddFeatureFlagDropdown_jiraIssue",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "actionMenu_softwareReleasesVersionDetailIssueList_jiraIssue"
        }
    ],
    "type": "JiraIssue"
};
$6ff94d4489928ab3$var$node.hash = "3ccc732c38654f19cf9d23f0c776cb28";
var $6ff94d4489928ab3$export$2e2bcd8739ae039 = $6ff94d4489928ab3$var$node;

});

parcelRegister("2VEfl", function(module, exports) {
$parcel$export(module.exports, "ActionButtonNoProviderAsync", () => $c5ac8d91693e70ec$export$86b05afa2718604);

var $eJOHy = parcelRequire("eJOHy");

var $bQWwW = parcelRequire("bQWwW");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $c5ac8d91693e70ec$var$ActionButtonNoProviderLazy = (0, $bQWwW.lazy)(()=>(parcelRequire("26N1R")).then((module)=>module.ActionButtonNoProvider), {
    moduleId: "./src/packages/releases/issue-list/src/ui/issues/issue-card/feature-flags/add-feature-flag/action-button-no-provider/ActionButtonNoProvider.tsx"
});
const $c5ac8d91693e70ec$export$86b05afa2718604 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c5ac8d91693e70ec$var$ActionButtonNoProviderLazy, props);

});
parcelRegister("26N1R", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("4d6AY").then(()=>parcelRequire('3aXuO'));

});


parcelRegister("htfHB", function(module, exports) {
$parcel$export(module.exports, "AddFeatureFlagIcon", () => $455cded08346235b$export$c3b91b420ace5d12);
/* AddFeatureFlagIcon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $fL0In = parcelRequire("fL0In");

var $lRq8t = parcelRequire("lRq8t");

var $5gKbQ = parcelRequire("5gKbQ");
const $455cded08346235b$var$AddFeatureFlagGlyph = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M17 2C17.5523 2 18 2.44772 18 3V5H20C20.5523 5 21 5.44772 21 6C21 6.55228 20.5523 7 20 7H18V9C18 9.55228 17.5523 10 17 10C16.4477 10 16 9.55228 16 9V7H14C13.4477 7 13 6.55228 13 6C13 5.44772 13.4477 5 14 5H16V3C16 2.44772 16.4477 2 17 2ZM12.2444 4.49608C12.3613 4.52442 12.477 4.55249 12.5917 4.57991C12.2263 4.9423 12 5.44472 12 6C12 6.17625 12.0228 6.34718 12.0656 6.50999C11.966 6.48607 11.867 6.46205 11.7688 6.43821L11.768 6.43801L11.7623 6.43662L11.7623 6.43662C10.3856 6.10219 9.16838 5.80649 8 6.14801V10.852C8.36666 10.7863 8.7385 10.7539 9.111 10.755C10.205 10.755 11.259 11.011 12.24 11.25C13.621 11.585 14.84 11.88 16.008 11.539V10.737C16.3004 10.9044 16.639 11 17 11C17.3676 11 17.712 10.9008 18.008 10.7278V12.221C18.0081 12.4088 17.9554 12.5927 17.8558 12.7519C17.7562 12.9111 17.6139 13.039 17.445 13.121C16.6509 13.5034 15.7793 13.6974 14.898 13.688C13.8103 13.688 12.7622 13.434 11.785 13.1971L11.785 13.1971L11.768 13.193C10.389 12.858 9.17 12.562 8 12.903V18.681C8 19.218 7.55 19.658 7 19.658C6.45 19.658 6 19.218 6 18.681V12.235V5.46601C6 5.27855 6.05268 5.09486 6.15205 4.93591C6.25143 4.77695 6.39348 4.64912 6.562 4.56701C8.553 3.60001 10.511 4.07501 12.24 4.49501L12.2444 4.49608Z",
        fill: "currentcolor"
    }));
const $455cded08346235b$export$c3b91b420ace5d12 = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($455cded08346235b$export$be58b4326e23250f, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fL0In.default), {
        testId: "software-releases-version-detail-issue-list.ui.issues.issue-card.feature-flags.add-feature-flag.icon.icon",
        glyph: $455cded08346235b$var$AddFeatureFlagGlyph,
        size: "medium",
        label: formatMessage((0, $5gKbQ.default).addFeatureFlagIconLabel)
    }));
};
const $455cded08346235b$export$be58b4326e23250f = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("5gKbQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $ec3c805b0540345f$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $ec3c805b0540345f$var$messages = (0, $7qGN1.defineMessages)({
    addFeatureFlagIconLabel: {
        "id": "software-releases-version-detail-issue-list.issues.issue-card.feature-flags.add-feature-flag.icon.add-feature-flag-icon-label",
        "defaultMessage": "Add feature flag icon"
    }
});
var $ec3c805b0540345f$export$2e2bcd8739ae039 = $ec3c805b0540345f$var$messages;

});


parcelRegister("fynQc", function(module, exports) {
$parcel$export(module.exports, "default", () => $79827613f60a618d$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $79827613f60a618d$var$messages = (0, $7qGN1.defineMessages)({
    addFeatureFlag: {
        "id": "software-releases-version-detail-issue-list.issues.issue-card.feature-flags.add-feature-flag.add-feature-flag",
        "defaultMessage": "Add flag"
    },
    createFeatureFlagMenuItem: {
        "id": "software-releases-version-detail-issue-list.issues.issue-card.feature-flags.add-feature-flag.create-feature-flag-menu-item",
        "defaultMessage": "Create feature flag"
    },
    connectFeatureFlagMenuItem: {
        "id": "software-releases-version-detail-issue-list.issues.issue-card.feature-flags.add-feature-flag.connect-feature-flag-menu-item",
        "defaultMessage": "Connect feature flag"
    },
    installAnotherToolMenuItem: {
        "id": "software-releases-version-detail-issue-list.issues.issue-card.feature-flags.add-feature-flag.install-another-tool-menu-item",
        "defaultMessage": "Install another tool"
    }
});
var $79827613f60a618d$export$2e2bcd8739ae039 = $79827613f60a618d$var$messages;

});

parcelRegister("bqINX", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("2m2FL").then(()=>parcelRequire('51BUM'));

});


parcelRegister("8YYSL", function(module, exports) {
$parcel$export(module.exports, "MultipleFlags", () => $d28f7ce6212a383d$export$6d8ca791f6cb1232);

var $byknu = parcelRequire("byknu");

var $ha3nR = parcelRequire("ha3nR");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $j4oe4 = parcelRequire("j4oe4");

var $k71qx = parcelRequire("k71qx");

var $lRq8t = parcelRequire("lRq8t");

var $2imLM = parcelRequire("2imLM");

var $kRgKj = parcelRequire("kRgKj");

var $2PCow = parcelRequire("2PCow");

var $gLD30 = parcelRequire("gLD30");

var $i0vl4 = parcelRequire("i0vl4");
const $d28f7ce6212a383d$export$6d8ca791f6cb1232 = ({ jiraIssue: jiraIssue, summarisedFlags: summarisedFlags })=>{
    const { formatMessage: formatMessage, formatNumber: formatNumber } = (0, $lRq8t.default)();
    const issue = (0, $j4oe4.useFragment)((0, $ha3nR.default), jiraIssue);
    const { totalCount: totalCount } = (0, $j4oe4.useFragment)((0, $byknu.default), summarisedFlags);
    const [tooltipQueryReference, loadTooltipQuery] = (0, $i0vl4.useTooltipContentQuery)(issue.id);
    const tooltipContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "tooltip-content",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, formatMessage((0, $gLD30.default).tooltipLoading))
    }, tooltipQueryReference == null ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i0vl4.TooltipContent), {
        queryReference: tooltipQueryReference
    }));
    const cellContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d28f7ce6212a383d$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2PCow.MultipleFlagsIcon), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d28f7ce6212a383d$var$TextContainer, null, formatMessage((0, $gLD30.default).flags, {
        count: formatNumber(totalCount)
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        onFocus: loadTooltipQuery,
        onMouseOver: loadTooltipQuery
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        testId: "software-releases-version-detail-issue-list.ui.issues.issue-card.feature-flags.multiple-flags.tooltip",
        content: tooltipContent,
        onShow: (analyticsEvent)=>{
            (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'featureFlagSummaryTooltip');
        },
        position: "bottom-start"
    }, cellContent));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d28f7ce6212a383d$var$Container = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_zulp1b66 _1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d28f7ce6212a383d$var$TextContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1flu1nu9 _1a4cglyw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("byknu", function(module, exports) {
$parcel$export(module.exports, "default", () => $d1e90219860efbea$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<94a012cadd441203c8d2c31f966162e3>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $d1e90219860efbea$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "multipleFlags_softwareReleasesVersionDetailIssueList_summarisedFlags",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "totalCount"
            },
            "action": "THROW",
            "path": "totalCount"
        }
    ],
    "type": "DevOpsSummarisedFeatureFlags"
};
$d1e90219860efbea$var$node.hash = "f8750caf47e7cdb0f524b2138f711e5d";
var $d1e90219860efbea$export$2e2bcd8739ae039 = $d1e90219860efbea$var$node;

});

parcelRegister("ha3nR", function(module, exports) {
$parcel$export(module.exports, "default", () => $a5058194138e7471$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9e76ab10079ddc5bd9646614f150b688>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $a5058194138e7471$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "multipleFlags_softwareReleasesVersionDetailIssueList_jiraIssue",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "id"
            },
            "action": "THROW",
            "path": "id"
        }
    ],
    "type": "JiraIssue"
};
$a5058194138e7471$var$node.hash = "895bdec15c863c74e317666c4dea1c42";
var $a5058194138e7471$export$2e2bcd8739ae039 = $a5058194138e7471$var$node;

});

parcelRegister("2PCow", function(module, exports) {
$parcel$export(module.exports, "MultipleFlagsIcon", () => $ab99fa48af70eae5$export$b02a1ce334df672e);

var $eJOHy = parcelRequire("eJOHy");

var $fL0In = parcelRequire("fL0In");

var $lRq8t = parcelRequire("lRq8t");

var $ajZ51 = parcelRequire("ajZ51");

var $gx3V3 = parcelRequire("gx3V3");
const $ab99fa48af70eae5$var$MultipleFlagsGlyph = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("img", {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($ajZ51))),
        alt: ""
    });
const $ab99fa48af70eae5$export$b02a1ce334df672e = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return(// eslint-disable-next-line @atlaskit/design-system/no-custom-icons
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fL0In.default), {
        testId: "software-releases-version-detail-issue-list.ui.issues.issue-card.feature-flags.multiple-flags.icon.multiple",
        size: "medium",
        glyph: $ab99fa48af70eae5$var$MultipleFlagsGlyph,
        label: formatMessage((0, $gx3V3.default).multipleFlagsIconLabel)
    }));
};

});
parcelRegister("ajZ51", function(module, exports) {
module.exports = new URL("multiple-flags.fdb5d926.svg", import.meta.url).toString();

});

parcelRegister("gx3V3", function(module, exports) {
$parcel$export(module.exports, "default", () => $da9cbcd93a091dc7$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $da9cbcd93a091dc7$var$messages = (0, $7qGN1.defineMessages)({
    multipleFlagsIconLabel: {
        "id": "software-releases-version-detail-issue-list.issues.issue-card.feature-flags.multiple-flags.icon.multiple-flags-icon-label",
        "defaultMessage": "Multiple feature flags"
    }
});
var $da9cbcd93a091dc7$export$2e2bcd8739ae039 = $da9cbcd93a091dc7$var$messages;

});


parcelRegister("gLD30", function(module, exports) {
$parcel$export(module.exports, "default", () => $050c0177facc07a8$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $050c0177facc07a8$var$messages = (0, $7qGN1.defineMessages)({
    flags: {
        "id": "software-releases-version-detail-issue-list.issues.issue-card.feature-flags.multiple-flags.flags",
        "defaultMessage": "{count} {count, plural, one {flag} other {flags}}"
    },
    tooltipLoading: {
        "id": "software-releases-version-detail-issue-list.issues.issue-card.feature-flags.multiple-flags.tooltip-loading",
        "defaultMessage": "Loading..."
    }
});
var $050c0177facc07a8$export$2e2bcd8739ae039 = $050c0177facc07a8$var$messages;

});

parcelRegister("i0vl4", function(module, exports) {
$parcel$export(module.exports, "useTooltipContentQuery", () => $42fb2cbd04c8f194$export$8f5a61dd01353b26);
$parcel$export(module.exports, "TooltipContent", () => $42fb2cbd04c8f194$export$e9003e2be37ec060);

var $jogHN = parcelRequire("jogHN");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $2nlj2 = parcelRequire("2nlj2");

var $j4oe4 = parcelRequire("j4oe4");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $lRq8t = parcelRequire("lRq8t");

var $aLv15 = parcelRequire("aLv15");
const $42fb2cbd04c8f194$var$MAX_DISPLAY_NAME_LENGTH = 32;
const $42fb2cbd04c8f194$var$MAX_FLAGS_TO_SHOW = 3;
const $42fb2cbd04c8f194$export$8f5a61dd01353b26 = (issueId)=>{
    const [queryRef, loadQuery] = (0, $j4oe4.useQueryLoader)((0, $jogHN.default));
    return [
        queryRef,
        ()=>loadQuery({
                issueId: issueId
            })
    ];
};
const $42fb2cbd04c8f194$export$e9003e2be37ec060 = ({ queryReference: queryReference })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const result = (0, $j4oe4.usePreloadedQuery)((0, $jogHN.default), queryReference);
    const { totalCount: totalCount, edges: edges } = result.devOps.entitiesByAssociations.featureFlagEntities;
    const featureFlags = edges?.flatMap((edge)=>edge?.node == null ? [] : [
            edge.node
        ]).map((node)=>({
            id: node.id,
            displayName: node.displayName.length > $42fb2cbd04c8f194$var$MAX_DISPLAY_NAME_LENGTH ? (0, (/*@__PURE__*/$parcel$interopDefault($2nlj2)))(node.displayName, {
                length: $42fb2cbd04c8f194$var$MAX_DISPLAY_NAME_LENGTH,
                separator: ' '
            }) : node.displayName,
            enabled: node.summary.enabled
        }));
    const hiddenFlagsCount = Math.max(0, totalCount - $42fb2cbd04c8f194$var$MAX_FLAGS_TO_SHOW);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $42fb2cbd04c8f194$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($42fb2cbd04c8f194$var$FeatureFlagList, null, featureFlags.map(({ id: id, displayName: displayName, enabled: enabled })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("li", {
            key: id
        }, enabled ? formatMessage((0, $aLv15.default).flagEnabled, {
            displayName: displayName
        }) : formatMessage((0, $aLv15.default).flagDisabled, {
            displayName: displayName
        })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($42fb2cbd04c8f194$var$MoreFlagsText, null, hiddenFlagsCount > 0 ? formatMessage((0, $aLv15.default).flagsHidden, {
        hiddenFlagsCount: hiddenFlagsCount
    }) : null));
};
const $42fb2cbd04c8f194$var$containerStyles = (0, $1DXK0.xcss)({
    margin: 'space.050'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $42fb2cbd04c8f194$var$FeatureFlagList = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "ol", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_qtt8glyw _19bvidpf",
            __cmplp.className
        ])
    });
});
const $42fb2cbd04c8f194$var$MoreFlagsText = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19pk1b66",
            __cmplp.className
        ])
    });
});

});
parcelRegister("jogHN", function(module, exports) {
$parcel$export(module.exports, "default", () => $ac36ed4287a48b74$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<fbd43c099929d1939c8e2128492206d3>>
 * @relayHash 41cd8d72cd786835b67fae78de599312
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID dff5c0a2fd12a20d8c39553c2a3cdae2a128b7c8518310de561d020720953cdc
const $ac36ed4287a48b74$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "issueId"
        }
    ], v1 = [
        {
            "items": [
                {
                    "kind": "Variable",
                    "name": "ids.0",
                    "variableName": "issueId"
                }
            ],
            "kind": "ListValue",
            "name": "ids"
        }
    ], v2 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 3
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v6 = {
        "kind": "ScalarField",
        "name": "enabled"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "tooltipContentForVersionDetailsIssueCardFeatureFlagsQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "DevOps",
                        "kind": "LinkedField",
                        "name": "devOps",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v1 /*: any*/ ,
                                    "concreteType": "DevOpsEntities",
                                    "kind": "LinkedField",
                                    "name": "entitiesByAssociations",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "args": v2 /*: any*/ ,
                                                "concreteType": "DevOpsFeatureFlagConnection",
                                                "kind": "LinkedField",
                                                "name": "featureFlagEntities",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v3 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "devOps.entitiesByAssociations.featureFlagEntities.totalCount"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "concreteType": "DevOpsFeatureFlagEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "DevOpsFeatureFlag",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "RequiredField",
                                                                            "field": v4 /*: any*/ ,
                                                                            "action": "NONE",
                                                                            "path": "devOps.entitiesByAssociations.featureFlagEntities.edges.node.id"
                                                                        },
                                                                        {
                                                                            "kind": "RequiredField",
                                                                            "field": v5 /*: any*/ ,
                                                                            "action": "NONE",
                                                                            "path": "devOps.entitiesByAssociations.featureFlagEntities.edges.node.displayName"
                                                                        },
                                                                        {
                                                                            "kind": "RequiredField",
                                                                            "field": {
                                                                                "concreteType": "DevOpsFeatureFlagSummary",
                                                                                "kind": "LinkedField",
                                                                                "name": "summary",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    {
                                                                                        "kind": "RequiredField",
                                                                                        "field": v6 /*: any*/ ,
                                                                                        "action": "NONE",
                                                                                        "path": "devOps.entitiesByAssociations.featureFlagEntities.edges.node.summary.enabled"
                                                                                    }
                                                                                ]
                                                                            },
                                                                            "action": "NONE",
                                                                            "path": "devOps.entitiesByAssociations.featureFlagEntities.edges.node.summary"
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        "action": "THROW",
                                                        "path": "devOps.entitiesByAssociations.featureFlagEntities.edges"
                                                    }
                                                ],
                                                "storageKey": "featureFlagEntities(first:3)"
                                            },
                                            "action": "THROW",
                                            "path": "devOps.entitiesByAssociations.featureFlagEntities"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "devOps.entitiesByAssociations"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "devOps"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "tooltipContentForVersionDetailsIssueCardFeatureFlagsQuery",
            "selections": [
                {
                    "concreteType": "DevOps",
                    "kind": "LinkedField",
                    "name": "devOps",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "DevOpsEntities",
                            "kind": "LinkedField",
                            "name": "entitiesByAssociations",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v2 /*: any*/ ,
                                    "concreteType": "DevOpsFeatureFlagConnection",
                                    "kind": "LinkedField",
                                    "name": "featureFlagEntities",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "concreteType": "DevOpsFeatureFlagEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "DevOpsFeatureFlag",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v4 /*: any*/ ,
                                                        v5 /*: any*/ ,
                                                        {
                                                            "concreteType": "DevOpsFeatureFlagSummary",
                                                            "kind": "LinkedField",
                                                            "name": "summary",
                                                            "plural": false,
                                                            "selections": [
                                                                v6 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ],
                                    "storageKey": "featureFlagEntities(first:3)"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "dff5c0a2fd12a20d8c39553c2a3cdae2a128b7c8518310de561d020720953cdc",
            "metadata": {},
            "name": "tooltipContentForVersionDetailsIssueCardFeatureFlagsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$ac36ed4287a48b74$var$node.hash = "c17feb1731a74b476c57976ce322ce68";
var $ac36ed4287a48b74$export$2e2bcd8739ae039 = $ac36ed4287a48b74$var$node;

});

parcelRegister("aLv15", function(module, exports) {
$parcel$export(module.exports, "default", () => $097ebf7325252166$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $097ebf7325252166$var$messages = (0, $7qGN1.defineMessages)({
    flagEnabled: {
        "id": "software-releases-version-detail-issue-list.issues.issue-card.feature-flags.multiple-flags.tooltip-content.flag-enabled",
        "defaultMessage": "\u2018{displayName}\u2019 is on"
    },
    flagDisabled: {
        "id": "software-releases-version-detail-issue-list.issues.issue-card.feature-flags.multiple-flags.tooltip-content.flag-disabled",
        "defaultMessage": "\u2018{displayName}\u2019 is off"
    },
    flagsHidden: {
        "id": "software-releases-version-detail-issue-list.issues.issue-card.feature-flags.multiple-flags.tooltip-content.flags-hidden",
        "defaultMessage": "+ {hiddenFlagsCount} more"
    }
});
var $097ebf7325252166$export$2e2bcd8739ae039 = $097ebf7325252166$var$messages;

});



parcelRegister("dCP7m", function(module, exports) {
$parcel$export(module.exports, "SingleFlag", () => $5fac0143b33525f7$export$c039c42a03fd637);

var $evaaS = parcelRequire("evaaS");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $2nlj2 = parcelRequire("2nlj2");

var $j4oe4 = parcelRequire("j4oe4");

var $k71qx = parcelRequire("k71qx");

var $lRq8t = parcelRequire("lRq8t");

var $kRgKj = parcelRequire("kRgKj");

var $5Q0ff = parcelRequire("5Q0ff");

var $8GrvF = parcelRequire("8GrvF");
const $5fac0143b33525f7$var$MAX_DISPLAY_NAME_LENGTH = 255;
const $5fac0143b33525f7$export$c039c42a03fd637 = ({ summarisedFlags: summarisedFlags })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { mostRelevantDisplayName: mostRelevantDisplayName, mostRelevantEnabled: mostRelevantEnabled, mostRelevantRolloutPercentage: mostRelevantRolloutPercentage } = (0, $j4oe4.useFragment)((0, $evaaS.default), summarisedFlags);
    const truncatedDisplayName = mostRelevantDisplayName.length > $5fac0143b33525f7$var$MAX_DISPLAY_NAME_LENGTH ? (0, (/*@__PURE__*/$parcel$interopDefault($2nlj2)))(mostRelevantDisplayName, {
        length: $5fac0143b33525f7$var$MAX_DISPLAY_NAME_LENGTH,
        separator: ' '
    }) : mostRelevantDisplayName;
    const renderTooltip = ()=>{
        if (!mostRelevantEnabled) return formatMessage((0, $8GrvF.default).flagDisabled, {
            displayName: truncatedDisplayName
        });
        if (mostRelevantRolloutPercentage == null) return formatMessage((0, $8GrvF.default).flagWithoutPercentage, {
            displayName: truncatedDisplayName
        });
        return formatMessage((0, $8GrvF.default).flagWithPercentage, {
            displayName: truncatedDisplayName,
            percentage: mostRelevantRolloutPercentage / 100
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        testId: "software-releases-version-detail-issue-list.ui.issues.issue-card.feature-flags.single-flag.tooltip",
        content: renderTooltip(),
        onShow: (analyticsEvent)=>{
            (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'featureFlagSummaryTooltip');
        },
        position: "bottom-start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($5fac0143b33525f7$var$Container, null, mostRelevantEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5Q0ff.FlagEnabledIcon), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5Q0ff.FlagDisabledIcon), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($5fac0143b33525f7$var$TextContainer, null, mostRelevantRolloutPercentage != null ? `${formatMessage((0, $8GrvF.default).flagPercentageRollout, {
        featureFlagPercentageRollout: mostRelevantRolloutPercentage / 100
    })}` : null)));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5fac0143b33525f7$var$Container = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_zulp1b66 _1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5fac0143b33525f7$var$TextContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1flu1nu9 _1a4cglyw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("evaaS", function(module, exports) {
$parcel$export(module.exports, "default", () => $e8ee71592f7749d7$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5aad7f5364f82e7ffbeae52ea8540080>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $e8ee71592f7749d7$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "singleFlag_softwareReleasesVersionDetailIssueList",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "mostRelevantDisplayName"
            },
            "action": "THROW",
            "path": "mostRelevantDisplayName"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "mostRelevantEnabled"
            },
            "action": "THROW",
            "path": "mostRelevantEnabled"
        },
        {
            "kind": "ScalarField",
            "name": "mostRelevantRolloutPercentage"
        }
    ],
    "type": "DevOpsSummarisedFeatureFlags"
};
$e8ee71592f7749d7$var$node.hash = "5843724954a8e05bf3074b304ff85341";
var $e8ee71592f7749d7$export$2e2bcd8739ae039 = $e8ee71592f7749d7$var$node;

});

parcelRegister("5Q0ff", function(module, exports) {
$parcel$export(module.exports, "FlagDisabledIcon", () => $55b29dc5ce17e8b2$export$a94a5376ccc0e3fb);
$parcel$export(module.exports, "FlagEnabledIcon", () => $55b29dc5ce17e8b2$export$b99b90244f32ccbf);

var $eJOHy = parcelRequire("eJOHy");

var $fL0In = parcelRequire("fL0In");

var $lRq8t = parcelRequire("lRq8t");

var $gn7Pl = parcelRequire("gn7Pl");

var $04Joq = parcelRequire("04Joq");

var $lu5By = parcelRequire("lu5By");
const $55b29dc5ce17e8b2$var$size = 'medium';
const $55b29dc5ce17e8b2$var$FlagDisabledGlyph = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("img", {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($gn7Pl))),
        alt: ""
    });
const $55b29dc5ce17e8b2$export$a94a5376ccc0e3fb = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return(// eslint-disable-next-line @atlaskit/design-system/no-custom-icons
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fL0In.default), {
        testId: "software-releases-version-detail-issue-list.ui.issues.issue-card.feature-flags.single-flag.icons.disabled",
        size: $55b29dc5ce17e8b2$var$size,
        glyph: $55b29dc5ce17e8b2$var$FlagDisabledGlyph,
        label: formatMessage((0, $lu5By.default).flagDisabledIconLabel)
    }));
};
const $55b29dc5ce17e8b2$var$FlagEnabledGlyph = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("img", {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($04Joq))),
        alt: ""
    });
const $55b29dc5ce17e8b2$export$b99b90244f32ccbf = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return(// eslint-disable-next-line @atlaskit/design-system/no-custom-icons
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fL0In.default), {
        testId: "software-releases-version-detail-issue-list.ui.issues.issue-card.feature-flags.single-flag.icons.enabled",
        size: $55b29dc5ce17e8b2$var$size,
        glyph: $55b29dc5ce17e8b2$var$FlagEnabledGlyph,
        label: formatMessage((0, $lu5By.default).flagEnabledIconLabel)
    }));
};

});
parcelRegister("gn7Pl", function(module, exports) {
module.exports = new URL("flag-disabled.813c2320.svg", import.meta.url).toString();

});

parcelRegister("04Joq", function(module, exports) {
module.exports = new URL("flag-enabled.1378f3de.svg", import.meta.url).toString();

});

parcelRegister("lu5By", function(module, exports) {
$parcel$export(module.exports, "default", () => $646d942c70a5f45b$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $646d942c70a5f45b$var$messages = (0, $7qGN1.defineMessages)({
    flagEnabledIconLabel: {
        "id": "software-releases-version-detail-issue-list.issues.issue-card.feature-flags.single-flag.icons.flag-enabled-icon-label",
        "defaultMessage": "Feature flag enabled"
    },
    flagDisabledIconLabel: {
        "id": "software-releases-version-detail-issue-list.issues.issue-card.feature-flags.single-flag.icons.flag-disabled-icon-label",
        "defaultMessage": "Feature flag disabled"
    }
});
var $646d942c70a5f45b$export$2e2bcd8739ae039 = $646d942c70a5f45b$var$messages;

});


parcelRegister("8GrvF", function(module, exports) {
$parcel$export(module.exports, "default", () => $eb43202a2246abf8$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $eb43202a2246abf8$var$messages = (0, $7qGN1.defineMessages)({
    flagDisabled: {
        "id": "software-releases-version-detail-issue-list.issues.issue-card.feature-flags.single-flag.flag-disabled",
        "defaultMessage": "\u2018{displayName}\u2019 is off"
    },
    flagWithoutPercentage: {
        "id": "software-releases-version-detail-issue-list.issues.issue-card.feature-flags.single-flag.flag-without-percentage",
        "defaultMessage": "\u2018{displayName}\u2019 is on"
    },
    flagWithPercentage: {
        "id": "software-releases-version-detail-issue-list.issues.issue-card.feature-flags.single-flag.flag-with-percentage",
        "defaultMessage": "\u2018{displayName}\u2019 is on at {percentage, number, percent}"
    },
    flagPercentageRollout: {
        "id": "software-releases-version-detail-issue-list.issues.issue-card.feature-flags.single-flag.flag-percentage-rollout",
        "defaultMessage": "{featureFlagPercentageRollout, number, percent}"
    }
});
var $eb43202a2246abf8$export$2e2bcd8739ae039 = $eb43202a2246abf8$var$messages;

});



parcelRegister("5Zdes", function(module, exports) {
$parcel$export(module.exports, "MoreButton", () => $dedfe01edac300ec$export$7f94856880993f27);
$parcel$export(module.exports, "OnHoverVisibility", () => $dedfe01edac300ec$export$e7937791cac9c51b);

var $8BCB8 = parcelRequire("8BCB8");

var $5aUI2 = parcelRequire("5aUI2");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $goZPP = parcelRequire("goZPP");

var $NByNW = parcelRequire("NByNW");

var $d8UFE = parcelRequire("d8UFE");

var $lRq8t = parcelRequire("lRq8t");

var $bzbsd = parcelRequire("bzbsd");

var $4cTDP = parcelRequire("4cTDP");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $kOIsX = parcelRequire("kOIsX");

var $hTqCv = parcelRequire("hTqCv");

var $euoQO = parcelRequire("euoQO");
const $dedfe01edac300ec$export$7f94856880993f27 = ({ jiraIssue: jiraIssue, jiraVersion: jiraVersion, hasWarnings: hasWarnings, hasOpenPullRequestWarning: hasOpenPullRequestWarning, hasFailingBuildsWarning: hasFailingBuildsWarning, hasUnreviewedCodeWarning: hasUnreviewedCodeWarning, hasOpenReviewWarning: hasOpenReviewWarning })=>{
    const issue = (0, $j4oe4.useFragment)((0, $5aUI2.default), jiraIssue);
    const version = (0, $j4oe4.useFragment)((0, $8BCB8.default), jiraVersion);
    const [isPopupOpen, setIsOpen] = (0, $eJOHy.useState)(false);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [moveIssuesBetweenVersionsQueryReference, loadMoveIssuesBetweenVersionsQuery] = (0, $hTqCv.useMoveIssuesBetweenVersionsQuery)(version.project.id, 4, version.id);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const moreButtonRef = (0, $eJOHy.useRef)(null);
    const togglePopup = ()=>{
        if (hasWarnings) {
            const warnings = [];
            if (hasOpenPullRequestWarning) warnings.push('OPEN_PULL_REQUEST');
            if (hasFailingBuildsWarning) warnings.push('FAILING_BUILD');
            if (hasUnreviewedCodeWarning) warnings.push('UNREVIEWED_CODE');
            if (hasOpenReviewWarning) warnings.push('OPEN_REVIEW');
            (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'IssueWarningMoreButton'
            }), {
                warnings: warnings.toString()
            });
        }
        if (moveIssuesBetweenVersionsQueryReference == null) loadMoveIssuesBetweenVersionsQuery();
        setIsOpen(!isPopupOpen);
    };
    const handlePopupClose = ()=>{
        setIsOpen(false);
        if (moreButtonRef.current) requestAnimationFrame(()=>{
            moreButtonRef.current?.focus();
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($dedfe01edac300ec$export$e7937791cac9c51b, (0, $4cTDP.fg)('jfp_a11y_issue_view_release_move_focus_to_trigger') && {
        isPopupVisible: isPopupOpen
    }, (!!version.canAddAndRemoveIssues || hasWarnings) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kOIsX.default), {
        renderTrigger: ({ triggerProps: triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
                ...triggerProps,
                ref: (0, $bzbsd.default)(triggerProps.ref, moreButtonRef),
                iconBefore: hasWarnings ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($d8UFE))), {
                    testId: "software-releases-version-detail-issue-list.ui.issues.issue-card.more-button.issue-card-warning-more-button",
                    color: "var(--ds-icon-warning, #E06C00)",
                    label: formatMessage((0, $euoQO.default).moreVersions),
                    spacing: "spacious"
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($NByNW))), {
                    spacing: "spacious",
                    label: formatMessage((0, $euoQO.default).moreVersions, {
                        issueKey: issue.key
                    })
                }),
                onClick: togglePopup,
                onMouseOver: loadMoveIssuesBetweenVersionsQuery,
                appearance: "subtle",
                isSelected: isPopupOpen
            }),
        queryReference: moveIssuesBetweenVersionsQueryReference,
        jiraIssue: issue,
        onClose: handlePopupClose,
        isOpen: isPopupOpen
    }));
};
const $dedfe01edac300ec$export$e7937791cac9c51b = ({ children: children, isPopupVisible: isPopupVisible })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        className: (0, $hcewu.default)([
            "_1bsb1ylp _1wtl15vq _j9irewfl",
            "_1rxyhgya _qrawewfl",
            isPopupVisible && "_1wtlewfl"
        ])
    }, children);
const $dedfe01edac300ec$var$styles = null;
const $dedfe01edac300ec$var$stylesWithFocusWithin = null;
const $dedfe01edac300ec$var$stylesWithVisibility = null;

});
parcelRegister("8BCB8", function(module, exports) {
$parcel$export(module.exports, "default", () => $c6bc7408a16a441e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7122e0be96e2941d3d8936d1014528e8>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $c6bc7408a16a441e$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "moreButton_softwareReleasesVersionDetailIssueList_jiraVersion",
        "selections": [
            {
                "kind": "RequiredField",
                "field": v0 /*: any*/ ,
                "action": "THROW",
                "path": "id"
            },
            {
                "kind": "ScalarField",
                "name": "canAddAndRemoveIssues"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "concreteType": "JiraProject",
                    "kind": "LinkedField",
                    "name": "project",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": v0 /*: any*/ ,
                            "action": "THROW",
                            "path": "project.id"
                        }
                    ]
                },
                "action": "THROW",
                "path": "project"
            }
        ],
        "type": "JiraVersion"
    };
}();
$c6bc7408a16a441e$var$node.hash = "e838cd21a0e90d2500f678bc796ae098";
var $c6bc7408a16a441e$export$2e2bcd8739ae039 = $c6bc7408a16a441e$var$node;

});

parcelRegister("5aUI2", function(module, exports) {
$parcel$export(module.exports, "default", () => $9587cfd1a15ecbca$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<877dfa62b9ef93692d02178709546477>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $9587cfd1a15ecbca$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "moreButton_softwareReleasesVersionDetailIssueList_jiraIssue",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "ui_softwareReleasesMoveIssuesBetweenVersions_MoveIssuesBetweenVersions_jiraIssue"
        },
        {
            "kind": "ScalarField",
            "name": "key"
        }
    ],
    "type": "JiraIssue"
};
$9587cfd1a15ecbca$var$node.hash = "fd443315ecfab8b84a64de9bab079996";
var $9587cfd1a15ecbca$export$2e2bcd8739ae039 = $9587cfd1a15ecbca$var$node;

});

parcelRegister("kOIsX", function(module, exports) {
$parcel$export(module.exports, "default", () => $31be111912ee7ea2$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $5vQ2T = parcelRequire("5vQ2T");

var $2imLM = parcelRequire("2imLM");

var $bQWwW = parcelRequire("bQWwW");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $31be111912ee7ea2$var$MoveVersions = (0, $bQWwW.lazy)(()=>Promise.resolve((parcelRequire("hTqCv"))).then((mod)=>mod.MoveIssuesBetweenVersions), {
    moduleId: "./src/packages/releases/move-issues-between-versions/src/ui/index.tsx"
});
const $31be111912ee7ea2$var$LazyMoveVersions = ({ renderTrigger: renderTrigger, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        id: "async.jira.move.issues.between.versions",
        packageName: "jira-software-releases-move-issues-between-versions",
        teamName: "jolt"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "move-issues-between-versions",
        fallback: renderTrigger({
            triggerProps: {},
            isLoading: true,
            isSelected: false
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($31be111912ee7ea2$var$MoveVersions, {
        renderTrigger: renderTrigger,
        ...props
    })));
var $31be111912ee7ea2$export$2e2bcd8739ae039 = $31be111912ee7ea2$var$LazyMoveVersions;

});
parcelRegister("hTqCv", function(module, exports) {
$parcel$export(module.exports, "useMoveIssuesBetweenVersionsQuery", () => $47494a6a54e58bc9$export$4d5ca68749a2d51a);
$parcel$export(module.exports, "MoveIssuesBetweenVersions", () => $47494a6a54e58bc9$export$1113ac51f1804da9);

var $cJq6l = parcelRequire("cJq6l");

var $5WgEW = parcelRequire("5WgEW");

var $dvVy4 = parcelRequire("dvVy4");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $j4oe4 = parcelRequire("j4oe4");

var $956it = parcelRequire("956it");

var $4B7rn = parcelRequire("4B7rn");

var $5vQ2T = parcelRequire("5vQ2T");

var $lJKII = parcelRequire("lJKII");

var $2imLM = parcelRequire("2imLM");

var $8nMzv = parcelRequire("8nMzv");

var $4HIFl = parcelRequire("4HIFl");

var $dnHcQ = parcelRequire("dnHcQ");

var $99ZCQ = parcelRequire("99ZCQ");
const $47494a6a54e58bc9$export$4d5ca68749a2d51a = (projectAri, first, versionAri)=>{
    const [queryRef, loadQuery] = (0, $j4oe4.useQueryLoader)((0, $dvVy4.default));
    return [
        queryRef,
        ()=>loadQuery({
                projectAri: projectAri,
                first: first,
                versionAri: versionAri
            }, {
                fetchPolicy: 'store-or-network'
            })
    ];
};
const $47494a6a54e58bc9$export$56eba4b61234c117 = ({ queryReference: queryReference, jiraIssue: jiraIssue, onClose: onClose, isVersionPickerModalOpen: isVersionPickerModalOpen, setIsVersionPickerModalOpen: setIsVersionPickerModalOpen })=>{
    const { jira: jira } = (0, $j4oe4.usePreloadedQuery)((0, $dvVy4.default), queryReference);
    const issue = (0, $j4oe4.useFragment)((0, $5WgEW.default), jiraIssue);
    const { version: version, versionsForProject: versionsForProject } = jira;
    const handleClose = ()=>{
        setIsVersionPickerModalOpen(false);
        onClose();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $99ZCQ.VersionList), {
        jiraVersionEdges: versionsForProject.edges.filter(Boolean),
        jiraIssue: issue,
        jiraVersion: version,
        onVersionPickerModalOpen: ()=>{
            setIsVersionPickerModalOpen(true);
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $956it.default), null, isVersionPickerModalOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        id: "jira.move.issues.between.versions.version.picker",
        packageName: "jira-software-releases-move-issues-between-versions",
        teamName: "jolt",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4B7rn.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lJKII.JiraModal // This is used to ignore issue click when move issue modal is opened and anywhere is clicked in/outside of the modal
    ), {
        testId: "software-releases-move-issues-between-versions.ui.move-issue-version-select-modal",
        autoFocus: false,
        width: "small",
        onClose: handleClose,
        messageId: "software-releases-move-issues-between-versions.ui.modal-dialog",
        messageType: "transactional"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dnHcQ.VersionPicker), {
        jiraVersion: version,
        jiraIssue: issue,
        onClose: handleClose
    }))))));
};
const $47494a6a54e58bc9$export$1113ac51f1804da9 = ({ renderTrigger: renderTrigger, jiraIssue: jiraIssue, queryReference: queryReference, isOpen: isOpen, onClose: onClose })=>{
    const [isVersionPickerModalOpen, setIsVersionPickerModalOpen] = (0, $eJOHy.useState)(false);
    const handleClose = ()=>{
        if (!isVersionPickerModalOpen) onClose();
    };
    const issue = (0, $j4oe4.useFragment)((0, $cJq6l.default), jiraIssue);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($47494a6a54e58bc9$var$HoverVisibilityControlWrapper, {
        isVisible: isOpen
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nMzv.JiraPopup), {
        isOpen: isOpen,
        autoFocus: false,
        onClose: handleClose,
        placement: "left-start",
        messageId: "software-releases-move-issues-between-versions.ui.popup",
        messageType: "transactional",
        fallbackPlacements: [
            'left-end'
        ],
        content: ()=>queryReference != null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
                name: "move-issues-between-versions-popup-content",
                fallback: null
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
                "data-version-details-issue-click-ignore-target": (0, $4HIFl.ISSUE_CARD_CLICK_IGNORE_TARGET)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($47494a6a54e58bc9$export$56eba4b61234c117, {
                isVersionPickerModalOpen: isVersionPickerModalOpen,
                jiraIssue: issue,
                onClose: onClose,
                queryReference: queryReference,
                setIsVersionPickerModalOpen: setIsVersionPickerModalOpen
            }))) : null,
        trigger: (triggerProps)=>renderTrigger({
                triggerProps: triggerProps,
                isSelected: isOpen,
                isLoading: false
            })
    }));
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $47494a6a54e58bc9$var$HoverVisibilityControlWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isVisible: isVisible, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "",
            __cmplp.isVisible ? "_3um0ewfl" : "_3um015vq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("cJq6l", function(module, exports) {
$parcel$export(module.exports, "default", () => $3bd2b162bf93e594$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7333e707d2161a8b1aa1f22f627e1650>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $3bd2b162bf93e594$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "ui_softwareReleasesMoveIssuesBetweenVersions_MoveIssuesBetweenVersions_jiraIssue",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "ui_softwareReleasesMoveIssuesBetweenVersions_MoveIssuesBetweenVersionsPopupContent_jiraIssue"
        }
    ],
    "type": "JiraIssue"
};
$3bd2b162bf93e594$var$node.hash = "a82d3697e92fea96f21c1bc4281c03e5";
var $3bd2b162bf93e594$export$2e2bcd8739ae039 = $3bd2b162bf93e594$var$node;

});

parcelRegister("5WgEW", function(module, exports) {
$parcel$export(module.exports, "default", () => $3fab23fdb796fb04$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<bb939ed30ff6ba50b14702d8011d102a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $3fab23fdb796fb04$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "ui_softwareReleasesMoveIssuesBetweenVersions_MoveIssuesBetweenVersionsPopupContent_jiraIssue",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "versionList_softwareReleasesMoveIssuesBetweenVersions_jiraIssue"
        },
        {
            "kind": "FragmentSpread",
            "name": "ui_softwareReleasesVersionPicker_VersionPicker_jiraIssue"
        }
    ],
    "type": "JiraIssue"
};
$3fab23fdb796fb04$var$node.hash = "a7d48e98e04811f2286b41cb01a9419a";
var $3fab23fdb796fb04$export$2e2bcd8739ae039 = $3fab23fdb796fb04$var$node;

});

parcelRegister("dvVy4", function(module, exports) {
$parcel$export(module.exports, "default", () => $f121efdde62aa3cc$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b0a8342d9fdd521c7874e63ec6e8e6c4>>
 * @relayHash fffb275f3c1642370db8ca26640d4d1d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0c62d9f35893c4558aa832a3da78fb1119e9bb8ef77a3c044ed4fd5a3679820f
const $f121efdde62aa3cc$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectAri"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "versionAri"
    }, v3 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "versionAri"
        }
    ], v4 = {
        "kind": "Literal",
        "name": "filter",
        "value": [
            "UNRELEASED"
        ]
    }, v5 = {
        "kind": "Variable",
        "name": "jiraProjectId",
        "variableName": "projectAri"
    }, v6 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v7 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v8 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "endCursor"
            },
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            }
        ]
    }, v9 = {
        "kind": "ScalarField",
        "name": "id"
    }, v10 = {
        "kind": "ScalarField",
        "name": "versionId"
    }, v11 = [
        v4 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        v5 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "uiMoveIssuesBetweenVersionsQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v3 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "versionList_softwareReleasesMoveIssuesBetweenVersions_jiraVersion"
                                                },
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "ui_softwareReleasesVersionPicker_VersionPicker_jiraVersion"
                                                }
                                            ],
                                            "type": "JiraVersion"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.version"
                            },
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "alias": "versionsForProject",
                                    "args": [
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ 
                                    ],
                                    "concreteType": "JiraVersionConnection",
                                    "kind": "LinkedField",
                                    "name": "__moveIssuesBetweenVersions_versionsForProject_connection",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "concreteType": "JiraVersionEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "versionList_softwareReleasesMoveIssuesBetweenVersions_jiraVersionEdges"
                                                    },
                                                    v6 /*: any*/ ,
                                                    {
                                                        "concreteType": "JiraVersion",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            v7 /*: any*/ 
                                                        ]
                                                    }
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "jira.versionsForProject.edges"
                                        },
                                        v8 /*: any*/ 
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.versionsForProject"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "uiMoveIssuesBetweenVersionsQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "version",
                            "plural": false,
                            "selections": [
                                v7 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "canAddAndRemoveIssues"
                                        },
                                        {
                                            "concreteType": "JiraVersionWarningConfig",
                                            "kind": "LinkedField",
                                            "name": "warningConfig",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "openPullRequest"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "openReview"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "unreviewedCode"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "failingBuild"
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "JiraProject",
                                            "kind": "LinkedField",
                                            "name": "project",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "projectId"
                                                },
                                                v9 /*: any*/ 
                                            ]
                                        }
                                    ],
                                    "type": "JiraVersion"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v9 /*: any*/ 
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        },
                        {
                            "args": v11 /*: any*/ ,
                            "concreteType": "JiraVersionConnection",
                            "kind": "LinkedField",
                            "name": "versionsForProject",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraVersionEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraVersion",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v10 /*: any*/ ,
                                                v9 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "name"
                                                },
                                                v7 /*: any*/ 
                                            ]
                                        },
                                        v6 /*: any*/ 
                                    ]
                                },
                                v8 /*: any*/ 
                            ]
                        },
                        {
                            "args": v11 /*: any*/ ,
                            "filters": [
                                "jiraProjectId",
                                "filter"
                            ],
                            "handle": "connection",
                            "key": "moveIssuesBetweenVersions_versionsForProject",
                            "kind": "LinkedHandle",
                            "name": "versionsForProject"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "0c62d9f35893c4558aa832a3da78fb1119e9bb8ef77a3c044ed4fd5a3679820f",
            "metadata": {
                "connection": [
                    {
                        "count": "first",
                        "cursor": null,
                        "direction": "forward",
                        "path": [
                            "jira",
                            "versionsForProject"
                        ]
                    }
                ]
            },
            "name": "uiMoveIssuesBetweenVersionsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$f121efdde62aa3cc$var$node.hash = "58c061e61158c45d3f183de8ea9ac7ab";
var $f121efdde62aa3cc$export$2e2bcd8739ae039 = $f121efdde62aa3cc$var$node;

});

parcelRegister("dnHcQ", function(module, exports) {
$parcel$export(module.exports, "VersionPicker", () => $2f93cd1aae4701c3$export$c7c815960e157d78);
/* async.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $ik0CA = parcelRequire("ik0CA");

var $7ep4S = parcelRequire("7ep4S");

var $2imLM = parcelRequire("2imLM");

var $bQWwW = parcelRequire("bQWwW");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2f93cd1aae4701c3$var$LazyVersionsPicker = (0, $bQWwW.lazy)(()=>(parcelRequire("iRsiK")).then((module)=>module.VersionPicker), {
    moduleId: "./src/packages/releases/version-picker/src/ui/index.tsx"
});
const $2f93cd1aae4701c3$var$LoadingModal = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ik0CA.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2f93cd1aae4701c3$export$43a792a870d28db2, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7ep4S.default), {
        size: "large"
    })));
const $2f93cd1aae4701c3$export$c7c815960e157d78 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "version-picker",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2f93cd1aae4701c3$var$LoadingModal, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2f93cd1aae4701c3$var$LazyVersionsPicker, props)); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $2f93cd1aae4701c3$export$43a792a870d28db2 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _1bah1h6o _4cvr1h6o _4t3i1lit",
            __cmplp.className
        ])
    });
});

});
parcelRegister("iRsiK", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("bfmmF").then(()=>parcelRequire('a7H0a'));

});


parcelRegister("99ZCQ", function(module, exports) {
$parcel$export(module.exports, "VersionList", () => $762f86fc0db29f00$export$e1d14e02661b0653);

var $7Yfib = parcelRequire("7Yfib");

var $kxh2k = parcelRequire("kxh2k");

var $9zjXO = parcelRequire("9zjXO");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $7saMl = parcelRequire("7saMl");
var $eJOdq = parcelRequire("eJOdq");
var $jUgeq = parcelRequire("jUgeq");
var $6YEko = parcelRequire("6YEko");

var $lRq8t = parcelRequire("lRq8t");

var $lFjOD = parcelRequire("lFjOD");

var $fy4rW = parcelRequire("fy4rW");

var $86M6Q = parcelRequire("86M6Q");

var $6dJRd = parcelRequire("6dJRd");
const $762f86fc0db29f00$export$e1d14e02661b0653 = ({ jiraVersionEdges: jiraVersionEdges, jiraIssue: jiraIssue, jiraVersion: jiraVersion, onVersionPickerModalOpen: onVersionPickerModalOpen })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const versions = (0, $j4oe4.useFragment)((0, $9zjXO.default), jiraVersionEdges);
    const issue = (0, $j4oe4.useFragment)((0, $kxh2k.default), jiraIssue);
    const version = (0, $j4oe4.useFragment)((0, $7Yfib.default), jiraVersion);
    const originalJiraVersion = version.id;
    const allVersions = versions.filter(Boolean).filter((object)=>object.node.versionId !== version.versionId);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jUgeq.default), {
        maxWidth: 221
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lFjOD.IssueWarning), {
        jiraIssue: issue,
        jiraVersion: version
    }), !!version.canAddAndRemoveIssues && allVersions.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6YEko.default), {
        hasSeparator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJOdq.default), null, formatMessage((0, $fy4rW.default).versionsListHeader)), allVersions.map((edge)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $86M6Q.MoveIssueToOtherVersion), {
            originalJiraVersion: originalJiraVersion,
            jiraVersion: edge.node,
            key: edge.node.versionId,
            jiraIssue: issue
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7saMl.default), {
        onClick: onVersionPickerModalOpen
    }, formatMessage((0, $fy4rW.default).otherVersionsButton))) : null, !!version.canAddAndRemoveIssues && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6dJRd.RemoveIssueFromVersion), {
        originalJiraVersion: originalJiraVersion,
        jiraIssue: issue
    }));
};

});
parcelRegister("7Yfib", function(module, exports) {
$parcel$export(module.exports, "default", () => $b35020725674a4a2$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7d95a12b061ade2e68cb3366d9b4aafc>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $b35020725674a4a2$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "versionList_softwareReleasesMoveIssuesBetweenVersions_jiraVersion",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "id"
            },
            "action": "THROW",
            "path": "id"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "versionId"
            },
            "action": "THROW",
            "path": "versionId"
        },
        {
            "kind": "ScalarField",
            "name": "canAddAndRemoveIssues"
        },
        {
            "kind": "FragmentSpread",
            "name": "issueWarning_softwareReleasesMoveIssuesBetweenVersions_jiraVersion"
        }
    ],
    "type": "JiraVersion"
};
$b35020725674a4a2$var$node.hash = "3401c25196bed99e751ba57506a3021b";
var $b35020725674a4a2$export$2e2bcd8739ae039 = $b35020725674a4a2$var$node;

});

parcelRegister("kxh2k", function(module, exports) {
$parcel$export(module.exports, "default", () => $fe402a88c01adfee$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<8ad8ccebd103a9c9dc8732c3a9fcce65>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $fe402a88c01adfee$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "versionList_softwareReleasesMoveIssuesBetweenVersions_jiraIssue",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "id"
            },
            "action": "THROW",
            "path": "id"
        },
        {
            "kind": "FragmentSpread",
            "name": "moveIssueToOtherVersion_softwareReleasesMoveIssuesBetweenVersions_jiraIssue"
        },
        {
            "kind": "FragmentSpread",
            "name": "removeIssueFromVersion_softwareReleasesMoveIssuesBetweenVersions"
        },
        {
            "kind": "FragmentSpread",
            "name": "issueWarning_softwareReleasesMoveIssuesBetweenVersions_jiraIssue"
        }
    ],
    "type": "JiraIssue"
};
$fe402a88c01adfee$var$node.hash = "9dbec216043d11ab3ebbdd111e565798";
var $fe402a88c01adfee$export$2e2bcd8739ae039 = $fe402a88c01adfee$var$node;

});

parcelRegister("9zjXO", function(module, exports) {
$parcel$export(module.exports, "default", () => $787716dae5405676$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c6ed5cd1b7e4a57c0234a7709c1d5948>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $787716dae5405676$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": {
        "plural": true
    },
    "name": "versionList_softwareReleasesMoveIssuesBetweenVersions_jiraVersionEdges",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "concreteType": "JiraVersion",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "kind": "ScalarField",
                            "name": "versionId"
                        },
                        "action": "NONE",
                        "path": "node.versionId"
                    },
                    {
                        "kind": "FragmentSpread",
                        "name": "moveIssueToOtherVersion_softwareReleasesMoveIssuesBetweenVersions_jiraVersion"
                    }
                ]
            },
            "action": "NONE",
            "path": "node"
        }
    ],
    "type": "JiraVersionEdge"
};
$787716dae5405676$var$node.hash = "62c56f9fefcd51f7cc6feffc9b24ce64";
var $787716dae5405676$export$2e2bcd8739ae039 = $787716dae5405676$var$node;

});

parcelRegister("lFjOD", function(module, exports) {
$parcel$export(module.exports, "IssueWarning", () => $c1d9eb6435cff0dc$export$40ff2db377648cee);

var $hb7nF = parcelRequire("hb7nF");

var $hNEgM = parcelRequire("hNEgM");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $j4oe4 = parcelRequire("j4oe4");

var $eJOdq = parcelRequire("eJOdq");
var $6YEko = parcelRequire("6YEko");

var $4cTDP = parcelRequire("4cTDP");

var $lRq8t = parcelRequire("lRq8t");

var $kO0T0 = parcelRequire("kO0T0");

var $dJCl0 = parcelRequire("dJCl0");
const $c1d9eb6435cff0dc$export$40ff2db377648cee = ({ jiraIssue: jiraIssue, jiraVersion: jiraVersion })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const issue = (0, $j4oe4.useFragment)((0, $hNEgM.default), jiraIssue);
    const version = (0, $j4oe4.useFragment)((0, $hb7nF.default), jiraVersion);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kO0T0.IssueWarningProvider), {
        jiraVersion: version,
        jiraIssue: issue
    }, ({ hasOpenPullRequestWarning: hasOpenPullRequestWarning, hasFailingBuildsWarning: hasFailingBuildsWarning, hasUnreviewedCodeWarning: hasUnreviewedCodeWarning, hasOpenReviewWarning: hasOpenReviewWarning })=>{
        const warningsMessages = [];
        if (hasOpenPullRequestWarning) warningsMessages.push((0, $dJCl0.default).openPullRequest);
        if (hasFailingBuildsWarning) warningsMessages.push((0, $dJCl0.default).failingBuilds);
        if (hasUnreviewedCodeWarning) warningsMessages.push((0, $dJCl0.default).unreviewedCode);
        if (hasOpenReviewWarning) warningsMessages.push((0, $dJCl0.default).openReviews);
        if (warningsMessages.length === 1) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6YEko.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJOdq.default), null, formatMessage((0, $dJCl0.default).issueWarningHeader)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c1d9eb6435cff0dc$var$WarningDescription, null, formatMessage((0, $4cTDP.fg)('jira-issue-terminology-update-m4') ? (0, $dJCl0.default).issueWarningIssueTerminologyRefreshM4 : (0, $dJCl0.default).issueWarning, {
            warning: formatMessage(warningsMessages[0])
        })));
        if (warningsMessages.length > 1) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6YEko.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJOdq.default), null, formatMessage((0, $dJCl0.default).issueWarningHeader)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c1d9eb6435cff0dc$var$WarningDescription, null, formatMessage((0, $4cTDP.fg)('jira-issue-terminology-update-m4') ? (0, $dJCl0.default).issueMultipleWarningsIssueTerminologyRefreshM4 : (0, $dJCl0.default).issueMultipleWarnings)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c1d9eb6435cff0dc$var$List, null, warningsMessages.map((warning)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c1d9eb6435cff0dc$var$ListItem, {
                key: warning.id
            }, formatMessage(warning)))));
        return null;
    });
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $c1d9eb6435cff0dc$var$ListItem = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "li", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_syaz1sqi",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $c1d9eb6435cff0dc$var$List = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "ul", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19pkidpf _2hwxidpf _otyrv47k _18u0idpf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $c1d9eb6435cff0dc$var$WarningDescription = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0q19bv _u5f3v47k _n3tdv47k _19bvv47k _syaz1sqi",
            __cmplp.className
        ])
    });
});

});
parcelRegister("hb7nF", function(module, exports) {
$parcel$export(module.exports, "default", () => $23bf7a4a56762ffd$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<fc806f27375ba559d72104dd3b1e5529>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $23bf7a4a56762ffd$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "issueWarning_softwareReleasesMoveIssuesBetweenVersions_jiraVersion",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "ui_softwareReleasesVersionIssueWarningController_IssueWarningProvider_jiraVersion"
        }
    ],
    "type": "JiraVersion"
};
$23bf7a4a56762ffd$var$node.hash = "4337c06001af5c62a61021cb3fd03fad";
var $23bf7a4a56762ffd$export$2e2bcd8739ae039 = $23bf7a4a56762ffd$var$node;

});

parcelRegister("hNEgM", function(module, exports) {
$parcel$export(module.exports, "default", () => $112ec2325c04dc49$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1c8e2786f37ec89f823a315d3db55e81>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $112ec2325c04dc49$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "issueWarning_softwareReleasesMoveIssuesBetweenVersions_jiraIssue",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "ui_softwareReleasesVersionIssueWarningController_IssueWarningProvider_jiraIssue"
        }
    ],
    "type": "JiraIssue"
};
$112ec2325c04dc49$var$node.hash = "c07bf95905363410cf22a75dbe9a1754";
var $112ec2325c04dc49$export$2e2bcd8739ae039 = $112ec2325c04dc49$var$node;

});

parcelRegister("dJCl0", function(module, exports) {
$parcel$export(module.exports, "default", () => $d3369574c6b07f06$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $d3369574c6b07f06$var$messages = (0, $7qGN1.defineMessages)({
    issueWarningHeader: {
        "id": "software-releases-move-issues-between-versions.version-list.issue-warning.issue-warning-header",
        "defaultMessage": "Warning"
    },
    issueWarning: {
        "id": "software-releases-move-issues-between-versions.version-list.issue-warning.issue-warning",
        "defaultMessage": "This issue has {warning}"
    },
    issueMultipleWarnings: {
        "id": "software-releases-move-issues-between-versions.version-list.issue-warning.issue-multiple-warnings",
        "defaultMessage": "This issue is done but has:"
    },
    openPullRequest: {
        "id": "software-releases-move-issues-between-versions.version-list.issue-warning.open-pull-request",
        "defaultMessage": "open pull requests"
    },
    failingBuilds: {
        "id": "software-releases-move-issues-between-versions.version-list.issue-warning.failing-builds",
        "defaultMessage": "failing builds"
    },
    unreviewedCode: {
        "id": "software-releases-move-issues-between-versions.version-list.issue-warning.unreviewed-code",
        "defaultMessage": "unreviewed code"
    },
    openReviews: {
        "id": "software-releases-move-issues-between-versions.version-list.issue-warning.open-reviews",
        "defaultMessage": "open reviews"
    },
    issueWarningIssueTerminologyRefreshM4: {
        "id": "software-releases-move-issues-between-versions.version-list.issue-warning.issue-warning-issue-terminology-refresh-m4",
        "defaultMessage": "This work item has {warning}"
    },
    issueMultipleWarningsIssueTerminologyRefreshM4: {
        "id": "software-releases-move-issues-between-versions.version-list.issue-warning.issue-multiple-warnings-issue-terminology-refresh-m4",
        "defaultMessage": "This work item is done but has:"
    }
});
var $d3369574c6b07f06$export$2e2bcd8739ae039 = $d3369574c6b07f06$var$messages;

});


parcelRegister("fy4rW", function(module, exports) {
$parcel$export(module.exports, "default", () => $1413b5d5e3057a82$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $1413b5d5e3057a82$var$messages = (0, $7qGN1.defineMessages)({
    versionsListHeader: {
        "id": "software-releases-move-issues-between-versions.version-list.versions-list-header",
        "defaultMessage": "Move to"
    },
    otherVersionsButton: {
        "id": "software-releases-move-issues-between-versions.version-list.other-versions-button",
        "defaultMessage": "View all versions"
    }
});
var $1413b5d5e3057a82$export$2e2bcd8739ae039 = $1413b5d5e3057a82$var$messages;

});

parcelRegister("86M6Q", function(module, exports) {
$parcel$export(module.exports, "MoveIssueToOtherVersion", () => $9250b513a65d5427$export$7bc266f2ce749644);

var $7wGon = parcelRequire("7wGon");

var $jzxg6 = parcelRequire("jzxg6");

var $9Im1k = parcelRequire("9Im1k");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $7saMl = parcelRequire("7saMl");

var $4cTDP = parcelRequire("4cTDP");

var $9pTd3 = parcelRequire("9pTd3");

var $cSXp8 = parcelRequire("cSXp8");

var $lRq8t = parcelRequire("lRq8t");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $jom8W = parcelRequire("jom8W");

var $lmneG = parcelRequire("lmneG");

var $OQpA2 = parcelRequire("OQpA2");

var $inQl7 = parcelRequire("inQl7");

var $b1cH3 = parcelRequire("b1cH3");
const $9250b513a65d5427$export$7bc266f2ce749644 = ({ jiraVersion: jiraVersion, jiraIssue: jiraIssue, originalJiraVersion: originalJiraVersion })=>{
    const { showFlag: showFlag } = (0, $cSXp8.useFlagsService)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const issue = (0, $j4oe4.useFragment)((0, $9Im1k.default), jiraIssue);
    const version = (0, $j4oe4.useFragment)((0, $jzxg6.default), jiraVersion);
    const [moveIssuesToFixVersion] = // eslint-disable-next-line jira/graphql/restrict-graphql-in-unnamed-files
    (0, $j4oe4.useMutation)((0, $7wGon.default));
    const { filters: filters, sortBy: sortBy } = (0, $lmneG.useVersionIssuesGraphQLVariables)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const analyticsEvent = createAnalyticsEvent({
        action: 'clicked',
        actionSubject: 'button'
    });
    const experienceStart = (0, $OQpA2.useMoveIssuesBetweenVersionsExperienceStart)();
    const experienceFail = (0, $OQpA2.useMoveIssuesBetweenVersionsExperienceFail)();
    const experienceSuccess = (0, $OQpA2.useMoveIssuesBetweenVersionsExperienceSuccess)();
    const onError = (err)=>{
        showFlag({
            type: 'error',
            title: formatMessage((0, $inQl7.default).errorFlagDescription, {
                issueKey: issue.key,
                versionName: version.name
            }),
            messageId: 'software-releases-move-issues-between-versions.ui.version-list.move-issue-to-other-version.show-flag.error.on-error.show-flag.error',
            messageType: 'transactional'
        });
        experienceFail('graphql error', err);
        (0, $9pTd3.fireErrorAnalytics)({
            error: err,
            meta: {
                id: 'jira.releases.remove-issue-from-version.mutation',
                packageName: 'jiraSoftwareReleasesMoveIssuesBetweenVersions',
                teamName: 'jolt'
            },
            sendToPrivacyUnsafeSplunk: true
        });
    };
    const onErrorWithPermissionValidationEnabled = (issueKey, issuesWithMissingResolvePermission, issuesWithMissingEditPermission)=>{
        const error = (0, $b1cH3.getErrorMessage)(issueKey, issuesWithMissingResolvePermission, issuesWithMissingEditPermission, formatMessage);
        showFlag({
            type: 'error',
            title: formatMessage((0, $4cTDP.fg)('jira-issue-terminology-update-m4') ? (0, $inQl7.default).errorFlagTitleIssueTerminologyRefreshM4 : (0, $inQl7.default).errorFlagTitle),
            description: error,
            messageId: 'software-releases-move-issues-between-versions.ui.version-list.move-issue-to-other-version.show-flag.error.on-error-with-permission-validation-enabled.show-flag.error',
            messageType: 'transactional'
        });
        experienceFail('graphql error', new Error(error));
        (0, $9pTd3.fireErrorAnalytics)({
            error: new Error(error),
            meta: {
                id: 'jira.releases.remove-issue-from-version.mutation',
                packageName: 'jiraSoftwareReleasesMoveIssuesBetweenVersions',
                teamName: 'jolt'
            },
            sendToPrivacyUnsafeSplunk: true
        });
    };
    const onUpdateVersion = ()=>{
        moveIssuesToFixVersion({
            variables: {
                input: {
                    issueIds: [
                        issue.id
                    ],
                    originalVersionId: originalJiraVersion,
                    targetVersionId: version.id
                },
                isDevopsFeatureDisabledInFedRamp: (0, $jom8W.isDevopsFeatureDisabledInFedRamp)(),
                shouldIncludeDevOpsFieldsViaAgs: !(0, $jom8W.isDevopsFeatureDisabledInFedRamp)(),
                filters: filters,
                sortBy: sortBy
            },
            onCompleted: (data)=>{
                if (data?.jira?.moveIssuesToFixVersion?.success !== true) onErrorWithPermissionValidationEnabled(issue.key, data?.jira?.moveIssuesToFixVersion?.issuesWithMissingResolvePermission, data?.jira?.moveIssuesToFixVersion?.issuesWithMissingEditPermission);
                else {
                    const flagText = formatMessage((0, $inQl7.default).successFlagDescription, {
                        issueKey: issue.key,
                        versionName: version.name
                    });
                    showFlag({
                        type: 'success',
                        title: flagText,
                        messageId: 'software-releases-move-issues-between-versions.ui.version-list.move-issue-to-other-version.show-flag.success.on-completed.show-flag.success',
                        messageType: 'transactional'
                    });
                    experienceSuccess();
                }
            },
            onError: onError
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7saMl.default), {
        onClick: ()=>{
            (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'moveIssueToVersion');
            experienceStart();
            onUpdateVersion();
        }
    }, version.name);
};

});
parcelRegister("7wGon", function(module, exports) {
$parcel$export(module.exports, "default", () => $257c29c41a3f68c0$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1f742146063c0eef84f5e3e8e6973a3b>>
 * @relayHash 07b96563baf5d018afb7d88ebd41d028
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID de92db525f29aacdea6702bef5f5eaa0758d1c12bf49b6b04be053e62b09848a
const $257c29c41a3f68c0$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filters"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "input"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isDevopsFeatureDisabledInFedRamp"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldIncludeDevOpsFieldsViaAgs"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "sortBy"
    }, v5 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v6 = {
        "kind": "ScalarField",
        "name": "success"
    }, v7 = [
        {
            "kind": "ScalarField",
            "name": "message"
        }
    ], v8 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": v7 /*: any*/ 
    }, v9 = {
        "kind": "ScalarField",
        "name": "issuesWithMissingResolvePermission"
    }, v10 = {
        "kind": "ScalarField",
        "name": "issuesWithMissingEditPermission"
    }, v11 = {
        "kind": "ScalarField",
        "name": "id"
    }, v12 = {
        "kind": "Literal",
        "name": "filter",
        "value": "ALL"
    }, v13 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v14 = [
        v13 /*: any*/ 
    ], v15 = {
        "kind": "ScalarField",
        "name": "key"
    }, v16 = {
        "kind": "ScalarField",
        "name": "name"
    }, v17 = {
        "kind": "ScalarField",
        "name": "collapsedUis"
    }, v18 = {
        "kind": "ScalarField",
        "name": "canEdit"
    }, v19 = {
        "kind": "ScalarField",
        "name": "status"
    }, v20 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v21 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v22 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v23 = {
        "kind": "ScalarField",
        "name": "description"
    }, v24 = [
        v12 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "filters",
            "variableName": "filters"
        },
        {
            "kind": "Literal",
            "name": "first",
            "value": 20
        },
        {
            "kind": "Variable",
            "name": "sortBy",
            "variableName": "sortBy"
        }
    ], v25 = {
        "kind": "ScalarField",
        "name": "count"
    }, v26 = {
        "kind": "ScalarField",
        "name": "state"
    }, v27 = {
        "concreteType": "DevOpsSummarisedBuildState",
        "kind": "LinkedField",
        "name": "buildStates",
        "plural": true,
        "selections": [
            v26 /*: any*/ ,
            v25 /*: any*/ 
        ]
    }, v28 = [
        v25 /*: any*/ 
    ], v29 = {
        "kind": "ScalarField",
        "name": "title"
    }, v30 = [
        v25 /*: any*/ ,
        v11 /*: any*/ 
    ], v31 = {
        "concreteType": "DevOpsSummarisedDeployments",
        "kind": "LinkedField",
        "name": "summarisedDeployments",
        "plural": false,
        "selections": v30 /*: any*/ 
    }, v32 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v33 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "endCursor"
            },
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            }
        ]
    }, v34 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 100
        }
    ], v35 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "moveIssueToOtherVersion_softwareReleasesMoveIssuesBetweenVersionsMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v5 /*: any*/ ,
                            "concreteType": "JiraMoveIssuesToFixVersionPayload",
                            "kind": "LinkedField",
                            "name": "moveIssuesToFixVersion",
                            "plural": false,
                            "selections": [
                                v6 /*: any*/ ,
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                {
                                    "concreteType": "JiraVersion",
                                    "kind": "LinkedField",
                                    "name": "originalVersion",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "addRelatedWorkPopup_softwareReleasesAddRelatedWorkToVersion_jiraVersion"
                                        },
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "issueTotalCount_softwareReleasesVersionDetailIssueList"
                                        },
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "ui_softwareReleasesVersionDetail_VersionDetailInner_jiraVersion"
                                        },
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "ui_softwareReleasesVersionDetailIssueList_IssuesRefetchable_jiraVersion"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v4 /*: any*/ ,
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "moveIssueToOtherVersion_softwareReleasesMoveIssuesBetweenVersionsMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v5 /*: any*/ ,
                            "concreteType": "JiraMoveIssuesToFixVersionPayload",
                            "kind": "LinkedField",
                            "name": "moveIssuesToFixVersion",
                            "plural": false,
                            "selections": [
                                v6 /*: any*/ ,
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                {
                                    "concreteType": "JiraVersion",
                                    "kind": "LinkedField",
                                    "name": "originalVersion",
                                    "plural": false,
                                    "selections": [
                                        v11 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "canEditRelatedWork"
                                        },
                                        {
                                            "alias": "allIssues",
                                            "args": [
                                                v12 /*: any*/ 
                                            ],
                                            "concreteType": "JiraIssueConnection",
                                            "kind": "LinkedField",
                                            "name": "issues",
                                            "plural": false,
                                            "selections": v14 /*: any*/ ,
                                            "storageKey": "issues(filter:\"ALL\")"
                                        },
                                        {
                                            "concreteType": "JiraProject",
                                            "kind": "LinkedField",
                                            "name": "project",
                                            "plural": false,
                                            "selections": [
                                                v11 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "projectId"
                                                },
                                                v15 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "cloudId"
                                                },
                                                {
                                                    "args": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "filter",
                                                            "value": {
                                                                "maxHierarchyLevel": 1,
                                                                "minHierarchyLevel": 1
                                                            }
                                                        }
                                                    ],
                                                    "concreteType": "JiraIssueTypeConnection",
                                                    "kind": "LinkedField",
                                                    "name": "issueTypes",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueTypeEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueType",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueTypeHierarchyLevel",
                                                                            "kind": "LinkedField",
                                                                            "name": "hierarchy",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v16 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v11 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "storageKey": "issueTypes(filter:{\"maxHierarchyLevel\":1,\"minHierarchyLevel\":1})"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "projectStyle"
                                                }
                                            ]
                                        },
                                        {
                                            "alias": "allIssuesRedesignTemp",
                                            "concreteType": "JiraIssueConnection",
                                            "kind": "LinkedField",
                                            "name": "issues",
                                            "plural": false,
                                            "selections": v14 /*: any*/ 
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "canAddAndRemoveIssues"
                                        },
                                        v17 /*: any*/ ,
                                        v18 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "startDate"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "releaseDate"
                                        },
                                        v19 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "versionId"
                                        },
                                        {
                                            "concreteType": "JiraVersionDriverResult",
                                            "kind": "LinkedField",
                                            "name": "driverData",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "driver",
                                                    "plural": false,
                                                    "selections": [
                                                        v20 /*: any*/ ,
                                                        v21 /*: any*/ ,
                                                        v16 /*: any*/ ,
                                                        v22 /*: any*/ ,
                                                        v11 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "concreteType": "QueryError",
                                                    "kind": "LinkedField",
                                                    "name": "queryError",
                                                    "plural": false,
                                                    "selections": v7 /*: any*/ 
                                                }
                                            ]
                                        },
                                        v23 /*: any*/ ,
                                        v16 /*: any*/ ,
                                        {
                                            "concreteType": "JiraVersionWarningConfig",
                                            "kind": "LinkedField",
                                            "name": "warningConfig",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "openPullRequest"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "openReview"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "unreviewedCode"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "failingBuild"
                                                },
                                                v18 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "concreteType": "JiraVersionConnectAddonIframeData",
                                            "kind": "LinkedField",
                                            "name": "connectAddonIframeData",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "appKey"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "moduleKey"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "appName"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "location"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "options"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "canViewDevTools"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "versionIssueTableHiddenColumns"
                                        },
                                        {
                                            "alias": "issuesForList",
                                            "args": v24 /*: any*/ ,
                                            "concreteType": "JiraIssueConnection",
                                            "kind": "LinkedField",
                                            "name": "issues",
                                            "plural": false,
                                            "selections": [
                                                v13 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "jql"
                                                },
                                                {
                                                    "concreteType": "JiraIssueEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssue",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v15 /*: any*/ ,
                                                                v11 /*: any*/ ,
                                                                {
                                                                    "args": [
                                                                        {
                                                                            "kind": "Literal",
                                                                            "name": "ids",
                                                                            "value": [
                                                                                "priority",
                                                                                "summary",
                                                                                "assignee",
                                                                                "status",
                                                                                "issuetype"
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "concreteType": "JiraIssueFieldConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "fieldsById",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueFieldEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v20 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "fieldId"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraStatus",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "status",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraStatusCategory",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "statusCategory",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "statusCategoryId"
                                                                                                                },
                                                                                                                v11 /*: any*/ 
                                                                                                            ]
                                                                                                        },
                                                                                                        v11 /*: any*/ ,
                                                                                                        v16 /*: any*/ ,
                                                                                                        v23 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraStatusField"
                                                                                        },
                                                                                        v11 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "user",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v20 /*: any*/ ,
                                                                                                        v22 /*: any*/ ,
                                                                                                        v16 /*: any*/ ,
                                                                                                        v11 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraSingleSelectUserPickerField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "text"
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraSingleLineTextField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssueType",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "issueType",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v16 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraAvatar",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "avatar",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "xsmall"
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v11 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraIssueTypeField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraPriority",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "priority",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v16 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "iconUrl"
                                                                                                        },
                                                                                                        v11 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraPriorityField"
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "storageKey": "fieldsById(ids:[\"priority\",\"summary\",\"assignee\",\"status\",\"issuetype\"])"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "issueId"
                                                                },
                                                                {
                                                                    "concreteType": "DevOpsSummarisedFeatureFlags",
                                                                    "kind": "LinkedField",
                                                                    "name": "summarisedFeatureFlags",
                                                                    "plural": false,
                                                                    "selections": v14 /*: any*/ 
                                                                },
                                                                v20 /*: any*/ ,
                                                                {
                                                                    "condition": "isDevopsFeatureDisabledInFedRamp",
                                                                    "kind": "Condition",
                                                                    "passingValue": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "DevOpsSummarisedEntities",
                                                                            "kind": "LinkedField",
                                                                            "name": "devOpsSummarisedEntities",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "DevOpsSummarisedDeployments",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "summarisedDeployments",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v25 /*: any*/ ,
                                                                                        v11 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "deploymentState"
                                                                                        },
                                                                                        {
                                                                                            "concreteType": "DevOpsEnvironment",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "deploymentEnvironment",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "category"
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "concreteType": "DevOpsSummarisedBuilds",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "summarisedBuilds",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v25 /*: any*/ ,
                                                                                        v11 /*: any*/ ,
                                                                                        v27 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "concreteType": "JiraIssueDevSummaryResult",
                                                                            "kind": "LinkedField",
                                                                            "name": "devSummaryCache",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueDevSummary",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "devSummary",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraIssuePullRequestDevSummaryContainer",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "pullrequest",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssuePullRequestDevSummary",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "overall",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v25 /*: any*/ ,
                                                                                                        v26 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "concreteType": "JiraIssueBranchDevSummaryContainer",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "branch",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssueBranchDevSummary",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "overall",
                                                                                                    "plural": false,
                                                                                                    "selections": v28 /*: any*/ 
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "concreteType": "JiraIssueReviewDevSummaryContainer",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "review",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssueReviewDevSummary",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "overall",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v25 /*: any*/ ,
                                                                                                        v26 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "lastUpdated"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "stateCount"
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                {
                                                                                                    "concreteType": "JiraIssueDevSummaryByProvider",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "summaryByProvider",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "providerId"
                                                                                                        },
                                                                                                        v16 /*: any*/ ,
                                                                                                        v25 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "concreteType": "JiraIssueCommitDevSummaryContainer",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "commit",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssueCommitDevSummary",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "overall",
                                                                                                    "plural": false,
                                                                                                    "selections": v28 /*: any*/ 
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "concreteType": "JiraIssueBuildDevSummaryContainer",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "build",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssueBuildDevSummary",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "overall",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v25 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "failedBuildCount"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "successfulBuildCount"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "unknownBuildCount"
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "concreteType": "JiraIssueDeploymentEnvironmentDevSummaryContainer",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "deploymentEnvironments",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssueDeploymentEnvironmentDevSummary",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "overall",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssueDeploymentEnvironment",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "topEnvironments",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                v19 /*: any*/ ,
                                                                                                                v29 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "concreteType": "DevOpsSummarisedFeatureFlags",
                                                                            "kind": "LinkedField",
                                                                            "name": "summarisedFeatureFlags",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "mostRelevantDisplayName"
                                                                                },
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "mostRelevantEnabled"
                                                                                },
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "mostRelevantRolloutPercentage"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "condition": "shouldIncludeDevOpsFieldsViaAgs",
                                                                            "kind": "Condition",
                                                                            "passingValue": true,
                                                                            "selections": [
                                                                                v31 /*: any*/ ,
                                                                                {
                                                                                    "concreteType": "DevOpsSummarisedBuilds",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "summarisedBuilds",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v27 /*: any*/ ,
                                                                                        v25 /*: any*/ ,
                                                                                        v11 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "condition": "shouldIncludeDevOpsFieldsViaAgs",
                                                                    "kind": "Condition",
                                                                    "passingValue": true,
                                                                    "selections": [
                                                                        v31 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "DevOpsSummarisedBuilds",
                                                                            "kind": "LinkedField",
                                                                            "name": "summarisedBuilds",
                                                                            "plural": false,
                                                                            "selections": v30 /*: any*/ 
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        v32 /*: any*/ 
                                                    ]
                                                },
                                                v33 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "alias": "issuesForList",
                                            "args": v24 /*: any*/ ,
                                            "filters": [
                                                "filter",
                                                "sortBy",
                                                "filters"
                                            ],
                                            "handle": "connection",
                                            "key": "ListVersion_issuesForList",
                                            "kind": "LinkedHandle",
                                            "name": "issues"
                                        },
                                        v17 /*: any*/ ,
                                        {
                                            "args": v34 /*: any*/ ,
                                            "concreteType": "JiraVersionApproverConnection",
                                            "kind": "LinkedField",
                                            "name": "approvers",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraVersionApproverEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraVersionApprover",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v11 /*: any*/ ,
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "user",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v20 /*: any*/ ,
                                                                        v16 /*: any*/ ,
                                                                        v22 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "AtlassianAccountUserExtendedProfile",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "extendedProfile",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "jobTitle"
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "type": "AtlassianAccountUser"
                                                                        },
                                                                        v11 /*: any*/ ,
                                                                        v21 /*: any*/ 
                                                                    ]
                                                                },
                                                                v19 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "declineReason"
                                                                },
                                                                v23 /*: any*/ ,
                                                                v35 /*: any*/ ,
                                                                v20 /*: any*/ 
                                                            ]
                                                        },
                                                        v32 /*: any*/ 
                                                    ]
                                                },
                                                v33 /*: any*/ 
                                            ],
                                            "storageKey": "approvers(first:100)"
                                        },
                                        {
                                            "args": v34 /*: any*/ ,
                                            "handle": "connection",
                                            "key": "version_approvers",
                                            "kind": "LinkedHandle",
                                            "name": "approvers"
                                        },
                                        {
                                            "concreteType": "JiraVersionRichTextSection",
                                            "kind": "LinkedField",
                                            "name": "richTextSection",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraADF",
                                                    "kind": "LinkedField",
                                                    "name": "content",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "json"
                                                        }
                                                    ]
                                                },
                                                v29 /*: any*/ 
                                            ]
                                        },
                                        v35 /*: any*/ ,
                                        {
                                            "condition": "isDevopsFeatureDisabledInFedRamp",
                                            "kind": "Condition",
                                            "passingValue": false,
                                            "selections": [
                                                {
                                                    "concreteType": "DevOpsSummarisedEntities",
                                                    "kind": "LinkedField",
                                                    "name": "devOpsSummarisedEntities",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "DevOpsProviders",
                                                            "kind": "LinkedField",
                                                            "name": "providers",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "DevOpsFeatureFlagProvider",
                                                                    "kind": "LinkedField",
                                                                    "name": "featureFlagProviders",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        v20 /*: any*/ ,
                                                                        v11 /*: any*/ ,
                                                                        v16 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "createFeatureFlagTemplateUrl"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "connectFeatureFlagTemplateUrl"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "logoUrl"
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "de92db525f29aacdea6702bef5f5eaa0758d1c12bf49b6b04be053e62b09848a",
            "metadata": {},
            "name": "moveIssueToOtherVersion_softwareReleasesMoveIssuesBetweenVersionsMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$257c29c41a3f68c0$var$node.hash = "99186247cd88cec5255d60a17909165e";
var $257c29c41a3f68c0$export$2e2bcd8739ae039 = $257c29c41a3f68c0$var$node;

});

parcelRegister("jzxg6", function(module, exports) {
$parcel$export(module.exports, "default", () => $42a6b10cee7c1dfd$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<fca745311578f3101b6fa0e65717a6fb>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $42a6b10cee7c1dfd$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "moveIssueToOtherVersion_softwareReleasesMoveIssuesBetweenVersions_jiraVersion",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "id"
            },
            "action": "THROW",
            "path": "id"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "name"
            },
            "action": "THROW",
            "path": "name"
        }
    ],
    "type": "JiraVersion"
};
$42a6b10cee7c1dfd$var$node.hash = "84a88afd5bdd1daa65b86ea3c2e3ac4e";
var $42a6b10cee7c1dfd$export$2e2bcd8739ae039 = $42a6b10cee7c1dfd$var$node;

});

parcelRegister("9Im1k", function(module, exports) {
$parcel$export(module.exports, "default", () => $2e1a4565e72d69a3$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<0944c4d992234c1aa8d6cf7cf7334012>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $2e1a4565e72d69a3$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "moveIssueToOtherVersion_softwareReleasesMoveIssuesBetweenVersions_jiraIssue",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "id"
            },
            "action": "THROW",
            "path": "id"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "key"
            },
            "action": "THROW",
            "path": "key"
        }
    ],
    "type": "JiraIssue"
};
$2e1a4565e72d69a3$var$node.hash = "970de75536631065f879841e95abf41b";
var $2e1a4565e72d69a3$export$2e2bcd8739ae039 = $2e1a4565e72d69a3$var$node;

});

parcelRegister("OQpA2", function(module, exports) {
$parcel$export(module.exports, "useMoveIssuesBetweenVersionsExperienceStart", () => $4963689b4bbb79b6$export$b93744d3b3f8b975);
$parcel$export(module.exports, "useMoveIssuesBetweenVersionsExperienceFail", () => $4963689b4bbb79b6$export$476b47bb3c16d45a);
$parcel$export(module.exports, "useMoveIssuesBetweenVersionsExperienceSuccess", () => $4963689b4bbb79b6$export$a7bd95f0cc752718);

var $aqnJa = parcelRequire("aqnJa");

var $8Uqf3 = parcelRequire("8Uqf3");

var $4ctwv = parcelRequire("4ctwv");

var $lBYgs = parcelRequire("lBYgs");

var $1BZ8a = parcelRequire("1BZ8a");
const $4963689b4bbb79b6$export$52919046b94109dc = 'moveIssueBetweenVersions';
const $4963689b4bbb79b6$var$ANALYTICS_SOURCE = 'versionDetails';
const $4963689b4bbb79b6$export$b93744d3b3f8b975 = ()=>{
    const appEditions = (0, $1BZ8a.useAppEditions)();
    return (0, $8Uqf3.useExperienceStart)({
        experience: $4963689b4bbb79b6$export$52919046b94109dc,
        experienceId: `${Date.now()}`,
        analyticsSource: $4963689b4bbb79b6$var$ANALYTICS_SOURCE,
        application: (0, $lBYgs.JIRA_SOFTWARE),
        edition: appEditions.software
    });
};
const $4963689b4bbb79b6$export$476b47bb3c16d45a = ()=>(0, $aqnJa.useExperienceFail)({
        experience: $4963689b4bbb79b6$export$52919046b94109dc
    });
const $4963689b4bbb79b6$export$a7bd95f0cc752718 = ()=>(0, $4ctwv.useExperienceSuccess)({
        experience: $4963689b4bbb79b6$export$52919046b94109dc
    });

});

parcelRegister("inQl7", function(module, exports) {
$parcel$export(module.exports, "default", () => $2dea30a15cf4098d$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $2dea30a15cf4098d$var$messages = (0, $7qGN1.defineMessages)({
    errorFlagTitle: {
        "id": "software-releases-move-issues-between-versions.version-list.move-issue-to-other-version.error-flag-title",
        "defaultMessage": "Can't move this issue to another version"
    },
    errorFlagDescription: {
        "id": "software-releases-move-issues-between-versions.version-list.move-issue-to-other-version.error-flag-description",
        "defaultMessage": "We couldn't move {issueKey} to {versionName}. Please try again."
    },
    successFlagDescription: {
        "id": "software-releases-move-issues-between-versions.version-list.move-issue-to-other-version.success-flag-description",
        "defaultMessage": "{issueKey} has been moved to {versionName}."
    },
    missingResolvePermissionErrorgFlagDescription: {
        "id": "software-releases-move-issues-between-versions.version-list.move-issue-to-other-version.missing-resolve-permission-errorg-flag-description",
        "defaultMessage": "You don't have permission to resolve {issueKey}, so you can't move it to another version."
    },
    missingEditPermissionErrorFlagDescription: {
        "id": "software-releases-move-issues-between-versions.version-list.move-issue-to-other-version.missing-edit-permission-error-flag-description",
        "defaultMessage": "You don't have permission to edit {issueKey}, so you can't move it to another version."
    },
    missingPermissionsErrorFlagDescription: {
        "id": "software-releases-move-issues-between-versions.version-list.move-issue-to-other-version.missing-permissions-error-flag-description",
        "defaultMessage": "You don't have permission to edit or resolve {issueKey}, so you can't move it to another version."
    },
    errorFlagTitleIssueTerminologyRefreshM4: {
        "id": "software-releases-move-issues-between-versions.version-list.move-issue-to-other-version.error-flag-title-issue-terminology-refresh-m4",
        "defaultMessage": "Can't move this work item to another version"
    }
});
var $2dea30a15cf4098d$export$2e2bcd8739ae039 = $2dea30a15cf4098d$var$messages;

});

parcelRegister("b1cH3", function(module, exports) {
$parcel$export(module.exports, "getErrorMessage", () => $b2694d748292ce1b$export$82f46aa4e6535a45);

var $inQl7 = parcelRequire("inQl7");
const $b2694d748292ce1b$export$82f46aa4e6535a45 = (issueKey, issuesWithMissingResolvePermission, issuesWithMissingEditPermission, formatMessage)=>{
    const issueIsMissingResolvePermission = issuesWithMissingResolvePermission !== null && issuesWithMissingResolvePermission !== undefined && issuesWithMissingResolvePermission.length > 0;
    const issueIsMissingEditPermission = issuesWithMissingEditPermission !== null && issuesWithMissingEditPermission !== undefined && issuesWithMissingEditPermission.length > 0;
    if (issueIsMissingResolvePermission && issueIsMissingEditPermission) return formatMessage((0, $inQl7.default).missingPermissionsErrorFlagDescription, {
        issueKey: issueKey
    });
    if (issueIsMissingResolvePermission) return formatMessage((0, $inQl7.default).missingResolvePermissionErrorgFlagDescription, {
        issueKey: issueKey
    });
    if (issueIsMissingEditPermission) return formatMessage((0, $inQl7.default).missingEditPermissionErrorFlagDescription, {
        issueKey: issueKey
    });
    return formatMessage((0, $inQl7.default).errorFlagDescription);
};

});


parcelRegister("6dJRd", function(module, exports) {
$parcel$export(module.exports, "RemoveIssueFromVersion", () => $2d51afa7fd12920e$export$d34fb821a58a3d5c);

var $2hdsB = parcelRequire("2hdsB");

var $58XD3 = parcelRequire("58XD3");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $7saMl = parcelRequire("7saMl");
var $6YEko = parcelRequire("6YEko");

var $4cTDP = parcelRequire("4cTDP");

var $9pTd3 = parcelRequire("9pTd3");

var $cSXp8 = parcelRequire("cSXp8");

var $lRq8t = parcelRequire("lRq8t");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $jom8W = parcelRequire("jom8W");

var $lmneG = parcelRequire("lmneG");

var $gcuR6 = parcelRequire("gcuR6");

var $8p5j0 = parcelRequire("8p5j0");

var $hlpKu = parcelRequire("hlpKu");
const $2d51afa7fd12920e$export$d34fb821a58a3d5c = ({ jiraIssue: jiraIssue, originalJiraVersion: originalJiraVersion })=>{
    const { showFlag: showFlag } = (0, $cSXp8.useFlagsService)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const issue = (0, $j4oe4.useFragment)((0, $58XD3.default), jiraIssue);
    const [removeIssuesFromFixVersion] = // eslint-disable-next-line jira/graphql/restrict-graphql-in-unnamed-files
    (0, $j4oe4.useMutation)((0, $2hdsB.default));
    const { filters: filters, sortBy: sortBy } = (0, $lmneG.useVersionIssuesGraphQLVariables)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const analyticsEvent = createAnalyticsEvent({
        action: 'clicked',
        actionSubject: 'button'
    });
    const experienceStart = (0, $gcuR6.useRemoveIssueFromVersionExperienceStart)();
    const experienceFail = (0, $gcuR6.useRemoveIssueFromVersionExperienceFail)();
    const experienceSuccess = (0, $gcuR6.useRemoveIssueFromVersionExperienceSuccess)();
    const onError = (err)=>{
        showFlag({
            type: 'error',
            title: formatMessage((0, $8p5j0.default).errorFlagDescription, {
                issueKey: issue.key
            }),
            messageId: 'software-releases-move-issues-between-versions.ui.version-list.remove-issue-from-version.show-flag.error.on-error.show-flag.error',
            messageType: 'transactional'
        });
        experienceFail('graphql error', err);
        (0, $9pTd3.fireErrorAnalytics)({
            error: err,
            meta: {
                id: 'jira.releases.remove-issue-from-version.mutation',
                packageName: 'jiraSoftwareReleasesMoveIssuesBetweenVersions',
                teamName: 'jolt'
            },
            sendToPrivacyUnsafeSplunk: true
        });
    };
    const onErrorWithPermissionValidationEnabled = (issueKey, issuesWithMissingResolvePermission, issuesWithMissingEditPermission)=>{
        const error = (0, $hlpKu.getErrorMessage)(issueKey, issuesWithMissingResolvePermission, issuesWithMissingEditPermission, formatMessage);
        showFlag({
            type: 'error',
            title: formatMessage((0, $4cTDP.fg)('jira-issue-terminology-update-m4') ? (0, $8p5j0.default).errorFlagTitleIssueTerminologyRefreshM4 : (0, $8p5j0.default).errorFlagTitle),
            description: error,
            messageId: 'software-releases-move-issues-between-versions.ui.version-list.remove-issue-from-version.show-flag.error.on-error-with-permission-validation-enabled.show-flag.error',
            messageType: 'transactional'
        });
        experienceFail('graphql error', new Error(error));
        (0, $9pTd3.fireErrorAnalytics)({
            error: new Error(error),
            meta: {
                id: 'jira.releases.remove-issue-from-version.mutation',
                packageName: 'jiraSoftwareReleasesMoveIssuesBetweenVersions',
                teamName: 'jolt'
            },
            sendToPrivacyUnsafeSplunk: true
        });
    };
    const onUpdateVersion = ()=>{
        removeIssuesFromFixVersion({
            variables: {
                input: {
                    issueIds: [
                        issue.id
                    ],
                    versionId: originalJiraVersion
                },
                isDevopsFeatureDisabledInFedRamp: (0, $jom8W.isDevopsFeatureDisabledInFedRamp)(),
                shouldIncludeDevOpsFieldsViaAgs: !(0, $jom8W.isDevopsFeatureDisabledInFedRamp)(),
                filters: filters,
                sortBy: sortBy
            },
            onCompleted: (data)=>{
                if (data?.jira?.removeIssuesFromFixVersion?.success !== true) {
                    const issuesWithMissingResolvePermission = data?.jira?.removeIssuesFromFixVersion?.issuesWithMissingResolvePermission || [];
                    const issuesWithMissingEditPermission = data?.jira?.removeIssuesFromFixVersion?.issuesWithMissingEditPermission || [];
                    onErrorWithPermissionValidationEnabled(issue.key, issuesWithMissingResolvePermission, issuesWithMissingEditPermission);
                } else {
                    const flagText = formatMessage((0, $8p5j0.default).successFlagDescription, {
                        issueKey: issue.key
                    });
                    experienceSuccess();
                    showFlag({
                        type: 'success',
                        title: flagText,
                        messageId: 'software-releases-move-issues-between-versions.ui.version-list.remove-issue-from-version.show-flag.success.on-completed.show-flag.success',
                        messageType: 'transactional'
                    });
                }
            },
            onError: onError
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6YEko.default), {
        hasSeparator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7saMl.default), {
        onClick: ()=>{
            (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'removeIssueFromVersion');
            experienceStart();
            onUpdateVersion();
        }
    }, formatMessage((0, $8p5j0.default).removeButtonTitle)));
};

});
parcelRegister("2hdsB", function(module, exports) {
$parcel$export(module.exports, "default", () => $01ebe76ebada27e9$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<048a25f0eb2b91c880f3ec4e02520d92>>
 * @relayHash 9fc7a217877cb0958ee863b6eb2a80bc
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1253732741586594cf8f5534298cd71ff14d6728edf8b0bf38c41fff0eae663b
const $01ebe76ebada27e9$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filters"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "input"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isDevopsFeatureDisabledInFedRamp"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldIncludeDevOpsFieldsViaAgs"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "sortBy"
    }, v5 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v6 = {
        "kind": "ScalarField",
        "name": "success"
    }, v7 = [
        {
            "kind": "ScalarField",
            "name": "message"
        }
    ], v8 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": v7 /*: any*/ 
    }, v9 = {
        "kind": "ScalarField",
        "name": "issuesWithMissingResolvePermission"
    }, v10 = {
        "kind": "ScalarField",
        "name": "issuesWithMissingEditPermission"
    }, v11 = {
        "kind": "ScalarField",
        "name": "id"
    }, v12 = {
        "kind": "Literal",
        "name": "filter",
        "value": "ALL"
    }, v13 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v14 = [
        v13 /*: any*/ 
    ], v15 = {
        "kind": "ScalarField",
        "name": "key"
    }, v16 = {
        "kind": "ScalarField",
        "name": "name"
    }, v17 = {
        "kind": "ScalarField",
        "name": "collapsedUis"
    }, v18 = {
        "kind": "ScalarField",
        "name": "canEdit"
    }, v19 = {
        "kind": "ScalarField",
        "name": "status"
    }, v20 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v21 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v22 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v23 = {
        "kind": "ScalarField",
        "name": "description"
    }, v24 = [
        v12 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "filters",
            "variableName": "filters"
        },
        {
            "kind": "Literal",
            "name": "first",
            "value": 20
        },
        {
            "kind": "Variable",
            "name": "sortBy",
            "variableName": "sortBy"
        }
    ], v25 = {
        "kind": "ScalarField",
        "name": "count"
    }, v26 = {
        "kind": "ScalarField",
        "name": "state"
    }, v27 = {
        "concreteType": "DevOpsSummarisedBuildState",
        "kind": "LinkedField",
        "name": "buildStates",
        "plural": true,
        "selections": [
            v26 /*: any*/ ,
            v25 /*: any*/ 
        ]
    }, v28 = [
        v25 /*: any*/ 
    ], v29 = {
        "kind": "ScalarField",
        "name": "title"
    }, v30 = [
        v25 /*: any*/ ,
        v11 /*: any*/ 
    ], v31 = {
        "concreteType": "DevOpsSummarisedDeployments",
        "kind": "LinkedField",
        "name": "summarisedDeployments",
        "plural": false,
        "selections": v30 /*: any*/ 
    }, v32 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v33 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "endCursor"
            },
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            }
        ]
    }, v34 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 100
        }
    ], v35 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "removeIssueFromVersion_softwareReleasesMoveIssuesBetweenVersionsMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v5 /*: any*/ ,
                            "concreteType": "JiraRemoveIssuesFromFixVersionPayload",
                            "kind": "LinkedField",
                            "name": "removeIssuesFromFixVersion",
                            "plural": false,
                            "selections": [
                                v6 /*: any*/ ,
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                {
                                    "concreteType": "JiraVersion",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "addRelatedWorkPopup_softwareReleasesAddRelatedWorkToVersion_jiraVersion"
                                        },
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "issueTotalCount_softwareReleasesVersionDetailIssueList"
                                        },
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "ui_softwareReleasesVersionDetail_VersionDetailInner_jiraVersion"
                                        },
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "ui_softwareReleasesVersionDetailIssueList_IssuesRefetchable_jiraVersion"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v4 /*: any*/ ,
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "removeIssueFromVersion_softwareReleasesMoveIssuesBetweenVersionsMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v5 /*: any*/ ,
                            "concreteType": "JiraRemoveIssuesFromFixVersionPayload",
                            "kind": "LinkedField",
                            "name": "removeIssuesFromFixVersion",
                            "plural": false,
                            "selections": [
                                v6 /*: any*/ ,
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                {
                                    "concreteType": "JiraVersion",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        v11 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "canEditRelatedWork"
                                        },
                                        {
                                            "alias": "allIssues",
                                            "args": [
                                                v12 /*: any*/ 
                                            ],
                                            "concreteType": "JiraIssueConnection",
                                            "kind": "LinkedField",
                                            "name": "issues",
                                            "plural": false,
                                            "selections": v14 /*: any*/ ,
                                            "storageKey": "issues(filter:\"ALL\")"
                                        },
                                        {
                                            "concreteType": "JiraProject",
                                            "kind": "LinkedField",
                                            "name": "project",
                                            "plural": false,
                                            "selections": [
                                                v11 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "projectId"
                                                },
                                                v15 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "cloudId"
                                                },
                                                {
                                                    "args": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "filter",
                                                            "value": {
                                                                "maxHierarchyLevel": 1,
                                                                "minHierarchyLevel": 1
                                                            }
                                                        }
                                                    ],
                                                    "concreteType": "JiraIssueTypeConnection",
                                                    "kind": "LinkedField",
                                                    "name": "issueTypes",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueTypeEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueType",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueTypeHierarchyLevel",
                                                                            "kind": "LinkedField",
                                                                            "name": "hierarchy",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v16 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v11 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "storageKey": "issueTypes(filter:{\"maxHierarchyLevel\":1,\"minHierarchyLevel\":1})"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "projectStyle"
                                                }
                                            ]
                                        },
                                        {
                                            "alias": "allIssuesRedesignTemp",
                                            "concreteType": "JiraIssueConnection",
                                            "kind": "LinkedField",
                                            "name": "issues",
                                            "plural": false,
                                            "selections": v14 /*: any*/ 
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "canAddAndRemoveIssues"
                                        },
                                        v17 /*: any*/ ,
                                        v18 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "startDate"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "releaseDate"
                                        },
                                        v19 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "versionId"
                                        },
                                        {
                                            "concreteType": "JiraVersionDriverResult",
                                            "kind": "LinkedField",
                                            "name": "driverData",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "driver",
                                                    "plural": false,
                                                    "selections": [
                                                        v20 /*: any*/ ,
                                                        v21 /*: any*/ ,
                                                        v16 /*: any*/ ,
                                                        v22 /*: any*/ ,
                                                        v11 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "concreteType": "QueryError",
                                                    "kind": "LinkedField",
                                                    "name": "queryError",
                                                    "plural": false,
                                                    "selections": v7 /*: any*/ 
                                                }
                                            ]
                                        },
                                        v23 /*: any*/ ,
                                        v16 /*: any*/ ,
                                        {
                                            "concreteType": "JiraVersionWarningConfig",
                                            "kind": "LinkedField",
                                            "name": "warningConfig",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "openPullRequest"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "openReview"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "unreviewedCode"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "failingBuild"
                                                },
                                                v18 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "concreteType": "JiraVersionConnectAddonIframeData",
                                            "kind": "LinkedField",
                                            "name": "connectAddonIframeData",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "appKey"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "moduleKey"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "appName"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "location"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "options"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "canViewDevTools"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "versionIssueTableHiddenColumns"
                                        },
                                        {
                                            "alias": "issuesForList",
                                            "args": v24 /*: any*/ ,
                                            "concreteType": "JiraIssueConnection",
                                            "kind": "LinkedField",
                                            "name": "issues",
                                            "plural": false,
                                            "selections": [
                                                v13 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "jql"
                                                },
                                                {
                                                    "concreteType": "JiraIssueEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssue",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v15 /*: any*/ ,
                                                                v11 /*: any*/ ,
                                                                {
                                                                    "args": [
                                                                        {
                                                                            "kind": "Literal",
                                                                            "name": "ids",
                                                                            "value": [
                                                                                "priority",
                                                                                "summary",
                                                                                "assignee",
                                                                                "status",
                                                                                "issuetype"
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "concreteType": "JiraIssueFieldConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "fieldsById",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueFieldEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v20 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "fieldId"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraStatus",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "status",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraStatusCategory",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "statusCategory",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "statusCategoryId"
                                                                                                                },
                                                                                                                v11 /*: any*/ 
                                                                                                            ]
                                                                                                        },
                                                                                                        v11 /*: any*/ ,
                                                                                                        v16 /*: any*/ ,
                                                                                                        v23 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraStatusField"
                                                                                        },
                                                                                        v11 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "user",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v20 /*: any*/ ,
                                                                                                        v22 /*: any*/ ,
                                                                                                        v16 /*: any*/ ,
                                                                                                        v11 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraSingleSelectUserPickerField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "text"
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraSingleLineTextField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssueType",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "issueType",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v16 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraAvatar",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "avatar",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "xsmall"
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v11 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraIssueTypeField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraPriority",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "priority",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v16 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "iconUrl"
                                                                                                        },
                                                                                                        v11 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraPriorityField"
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "storageKey": "fieldsById(ids:[\"priority\",\"summary\",\"assignee\",\"status\",\"issuetype\"])"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "issueId"
                                                                },
                                                                {
                                                                    "concreteType": "DevOpsSummarisedFeatureFlags",
                                                                    "kind": "LinkedField",
                                                                    "name": "summarisedFeatureFlags",
                                                                    "plural": false,
                                                                    "selections": v14 /*: any*/ 
                                                                },
                                                                v20 /*: any*/ ,
                                                                {
                                                                    "condition": "isDevopsFeatureDisabledInFedRamp",
                                                                    "kind": "Condition",
                                                                    "passingValue": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "DevOpsSummarisedEntities",
                                                                            "kind": "LinkedField",
                                                                            "name": "devOpsSummarisedEntities",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "DevOpsSummarisedDeployments",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "summarisedDeployments",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v25 /*: any*/ ,
                                                                                        v11 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "deploymentState"
                                                                                        },
                                                                                        {
                                                                                            "concreteType": "DevOpsEnvironment",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "deploymentEnvironment",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "category"
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "concreteType": "DevOpsSummarisedBuilds",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "summarisedBuilds",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v25 /*: any*/ ,
                                                                                        v11 /*: any*/ ,
                                                                                        v27 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "concreteType": "JiraIssueDevSummaryResult",
                                                                            "kind": "LinkedField",
                                                                            "name": "devSummaryCache",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueDevSummary",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "devSummary",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraIssuePullRequestDevSummaryContainer",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "pullrequest",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssuePullRequestDevSummary",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "overall",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v25 /*: any*/ ,
                                                                                                        v26 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "concreteType": "JiraIssueBranchDevSummaryContainer",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "branch",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssueBranchDevSummary",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "overall",
                                                                                                    "plural": false,
                                                                                                    "selections": v28 /*: any*/ 
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "concreteType": "JiraIssueReviewDevSummaryContainer",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "review",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssueReviewDevSummary",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "overall",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v25 /*: any*/ ,
                                                                                                        v26 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "lastUpdated"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "stateCount"
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                {
                                                                                                    "concreteType": "JiraIssueDevSummaryByProvider",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "summaryByProvider",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "providerId"
                                                                                                        },
                                                                                                        v16 /*: any*/ ,
                                                                                                        v25 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "concreteType": "JiraIssueCommitDevSummaryContainer",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "commit",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssueCommitDevSummary",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "overall",
                                                                                                    "plural": false,
                                                                                                    "selections": v28 /*: any*/ 
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "concreteType": "JiraIssueBuildDevSummaryContainer",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "build",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssueBuildDevSummary",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "overall",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v25 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "failedBuildCount"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "successfulBuildCount"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "unknownBuildCount"
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "concreteType": "JiraIssueDeploymentEnvironmentDevSummaryContainer",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "deploymentEnvironments",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssueDeploymentEnvironmentDevSummary",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "overall",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssueDeploymentEnvironment",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "topEnvironments",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                v19 /*: any*/ ,
                                                                                                                v29 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "concreteType": "DevOpsSummarisedFeatureFlags",
                                                                            "kind": "LinkedField",
                                                                            "name": "summarisedFeatureFlags",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "mostRelevantDisplayName"
                                                                                },
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "mostRelevantEnabled"
                                                                                },
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "mostRelevantRolloutPercentage"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "condition": "shouldIncludeDevOpsFieldsViaAgs",
                                                                            "kind": "Condition",
                                                                            "passingValue": true,
                                                                            "selections": [
                                                                                v31 /*: any*/ ,
                                                                                {
                                                                                    "concreteType": "DevOpsSummarisedBuilds",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "summarisedBuilds",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v27 /*: any*/ ,
                                                                                        v25 /*: any*/ ,
                                                                                        v11 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "condition": "shouldIncludeDevOpsFieldsViaAgs",
                                                                    "kind": "Condition",
                                                                    "passingValue": true,
                                                                    "selections": [
                                                                        v31 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "DevOpsSummarisedBuilds",
                                                                            "kind": "LinkedField",
                                                                            "name": "summarisedBuilds",
                                                                            "plural": false,
                                                                            "selections": v30 /*: any*/ 
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        v32 /*: any*/ 
                                                    ]
                                                },
                                                v33 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "alias": "issuesForList",
                                            "args": v24 /*: any*/ ,
                                            "filters": [
                                                "filter",
                                                "sortBy",
                                                "filters"
                                            ],
                                            "handle": "connection",
                                            "key": "ListVersion_issuesForList",
                                            "kind": "LinkedHandle",
                                            "name": "issues"
                                        },
                                        v17 /*: any*/ ,
                                        {
                                            "args": v34 /*: any*/ ,
                                            "concreteType": "JiraVersionApproverConnection",
                                            "kind": "LinkedField",
                                            "name": "approvers",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraVersionApproverEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraVersionApprover",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v11 /*: any*/ ,
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "user",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v20 /*: any*/ ,
                                                                        v16 /*: any*/ ,
                                                                        v22 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "AtlassianAccountUserExtendedProfile",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "extendedProfile",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "jobTitle"
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "type": "AtlassianAccountUser"
                                                                        },
                                                                        v11 /*: any*/ ,
                                                                        v21 /*: any*/ 
                                                                    ]
                                                                },
                                                                v19 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "declineReason"
                                                                },
                                                                v23 /*: any*/ ,
                                                                v35 /*: any*/ ,
                                                                v20 /*: any*/ 
                                                            ]
                                                        },
                                                        v32 /*: any*/ 
                                                    ]
                                                },
                                                v33 /*: any*/ 
                                            ],
                                            "storageKey": "approvers(first:100)"
                                        },
                                        {
                                            "args": v34 /*: any*/ ,
                                            "handle": "connection",
                                            "key": "version_approvers",
                                            "kind": "LinkedHandle",
                                            "name": "approvers"
                                        },
                                        {
                                            "concreteType": "JiraVersionRichTextSection",
                                            "kind": "LinkedField",
                                            "name": "richTextSection",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraADF",
                                                    "kind": "LinkedField",
                                                    "name": "content",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "json"
                                                        }
                                                    ]
                                                },
                                                v29 /*: any*/ 
                                            ]
                                        },
                                        v35 /*: any*/ ,
                                        {
                                            "condition": "isDevopsFeatureDisabledInFedRamp",
                                            "kind": "Condition",
                                            "passingValue": false,
                                            "selections": [
                                                {
                                                    "concreteType": "DevOpsSummarisedEntities",
                                                    "kind": "LinkedField",
                                                    "name": "devOpsSummarisedEntities",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "DevOpsProviders",
                                                            "kind": "LinkedField",
                                                            "name": "providers",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "DevOpsFeatureFlagProvider",
                                                                    "kind": "LinkedField",
                                                                    "name": "featureFlagProviders",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        v20 /*: any*/ ,
                                                                        v11 /*: any*/ ,
                                                                        v16 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "createFeatureFlagTemplateUrl"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "connectFeatureFlagTemplateUrl"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "logoUrl"
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "1253732741586594cf8f5534298cd71ff14d6728edf8b0bf38c41fff0eae663b",
            "metadata": {},
            "name": "removeIssueFromVersion_softwareReleasesMoveIssuesBetweenVersionsMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$01ebe76ebada27e9$var$node.hash = "a22d7bb9dbe9bce2c09ac689883c2338";
var $01ebe76ebada27e9$export$2e2bcd8739ae039 = $01ebe76ebada27e9$var$node;

});

parcelRegister("58XD3", function(module, exports) {
$parcel$export(module.exports, "default", () => $249017b84288a3ac$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<30ef410b078961ea01bc83dfef2d6e09>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $249017b84288a3ac$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "removeIssueFromVersion_softwareReleasesMoveIssuesBetweenVersions",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "id"
            },
            "action": "THROW",
            "path": "id"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "key"
            },
            "action": "THROW",
            "path": "key"
        }
    ],
    "type": "JiraIssue"
};
$249017b84288a3ac$var$node.hash = "bf7da4aac2b6cd1fbe625288d4086691";
var $249017b84288a3ac$export$2e2bcd8739ae039 = $249017b84288a3ac$var$node;

});

parcelRegister("gcuR6", function(module, exports) {
$parcel$export(module.exports, "useRemoveIssueFromVersionExperienceStart", () => $8f3978170b26504b$export$7d327eeb0dc00eee);
$parcel$export(module.exports, "useRemoveIssueFromVersionExperienceFail", () => $8f3978170b26504b$export$5da0a49410009ec1);
$parcel$export(module.exports, "useRemoveIssueFromVersionExperienceSuccess", () => $8f3978170b26504b$export$234c5c3c1b869f23);

var $aqnJa = parcelRequire("aqnJa");

var $8Uqf3 = parcelRequire("8Uqf3");

var $4ctwv = parcelRequire("4ctwv");

var $lBYgs = parcelRequire("lBYgs");

var $1BZ8a = parcelRequire("1BZ8a");
const $8f3978170b26504b$export$52919046b94109dc = 'removeIssueFromVersion';
const $8f3978170b26504b$var$ANALYTICS_SOURCE = 'versionDetails';
const $8f3978170b26504b$export$7d327eeb0dc00eee = ()=>{
    const appEditions = (0, $1BZ8a.useAppEditions)();
    return (0, $8Uqf3.useExperienceStart)({
        experience: $8f3978170b26504b$export$52919046b94109dc,
        experienceId: `${Date.now()}`,
        analyticsSource: $8f3978170b26504b$var$ANALYTICS_SOURCE,
        application: (0, $lBYgs.JIRA_SOFTWARE),
        edition: appEditions.software
    });
};
const $8f3978170b26504b$export$5da0a49410009ec1 = ()=>(0, $aqnJa.useExperienceFail)({
        experience: $8f3978170b26504b$export$52919046b94109dc
    });
const $8f3978170b26504b$export$234c5c3c1b869f23 = ()=>(0, $4ctwv.useExperienceSuccess)({
        experience: $8f3978170b26504b$export$52919046b94109dc
    });

});

parcelRegister("8p5j0", function(module, exports) {
$parcel$export(module.exports, "default", () => $6559d01bcb78e802$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $6559d01bcb78e802$var$messages = (0, $7qGN1.defineMessages)({
    errorFlagTitle: {
        "id": "software-releases-move-issues-between-versions.version-list.remove-issue-from-version.error-flag-title",
        "defaultMessage": "Can't remove this issue from version"
    },
    errorFlagDescription: {
        "id": "software-releases-move-issues-between-versions.version-list.remove-issue-from-version.error-flag-description",
        "defaultMessage": "We couldn't remove {issueKey} from this version. Please try again"
    },
    successFlagDescription: {
        "id": "software-releases-move-issues-between-versions.version-list.remove-issue-from-version.success-flag-description",
        "defaultMessage": "{issueKey} has been removed from this version."
    },
    removeButtonTitle: {
        "id": "software-releases-move-issues-between-versions.version-list.remove-issue-from-version.remove-button-title",
        "defaultMessage": "Remove from version"
    },
    missingResolvePermissionErrorgFlagDescription: {
        "id": "software-releases-move-issues-between-versions.version-list.remove-issue-from-version.missing-resolve-permission-errorg-flag-description",
        "defaultMessage": "You don't have permission to resolve {issueKey}, so you can't remove it from the version."
    },
    missingEditPermissionErrorFlagDescription: {
        "id": "software-releases-move-issues-between-versions.version-list.remove-issue-from-version.missing-edit-permission-error-flag-description",
        "defaultMessage": "You don't have permission to edit {issueKey}, so you can't remove it from the version."
    },
    missingPermissionsErrorFlagDescription: {
        "id": "software-releases-move-issues-between-versions.version-list.remove-issue-from-version.missing-permissions-error-flag-description",
        "defaultMessage": "You don't have permission to edit or resolve {issueKey}, so you can't remove it from the version."
    },
    errorFlagTitleIssueTerminologyRefreshM4: {
        "id": "software-releases-move-issues-between-versions.version-list.remove-issue-from-version.error-flag-title-issue-terminology-refresh-m4",
        "defaultMessage": "Can't remove this work item from version"
    }
});
var $6559d01bcb78e802$export$2e2bcd8739ae039 = $6559d01bcb78e802$var$messages;

});

parcelRegister("hlpKu", function(module, exports) {
$parcel$export(module.exports, "getErrorMessage", () => $6c098a76baed8a1e$export$82f46aa4e6535a45);

var $8p5j0 = parcelRequire("8p5j0");
const $6c098a76baed8a1e$export$82f46aa4e6535a45 = (issueKey, issuesWithMissingResolvePermission, issuesWithMissingEditPermission, formatMessage)=>{
    const issueIsMissingResolvePermission = issuesWithMissingResolvePermission !== null && issuesWithMissingResolvePermission !== undefined && issuesWithMissingResolvePermission.length > 0;
    const issueIsMissingEditPermission = issuesWithMissingEditPermission !== null && issuesWithMissingEditPermission !== undefined && issuesWithMissingEditPermission.length > 0;
    if (issueIsMissingResolvePermission && issueIsMissingEditPermission) return formatMessage((0, $8p5j0.default).missingPermissionsErrorFlagDescription, {
        issueKey: issueKey
    });
    if (issueIsMissingResolvePermission) return formatMessage((0, $8p5j0.default).missingResolvePermissionErrorgFlagDescription, {
        issueKey: issueKey
    });
    if (issueIsMissingEditPermission) return formatMessage((0, $8p5j0.default).missingEditPermissionErrorFlagDescription, {
        issueKey: issueKey
    });
    return formatMessage((0, $8p5j0.default).errorFlagDescription);
};

});





parcelRegister("euoQO", function(module, exports) {
$parcel$export(module.exports, "default", () => $99053e6bfa0730fa$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $99053e6bfa0730fa$var$messages = (0, $7qGN1.defineMessages)({
    moreVersions: {
        "id": "software-releases-version-detail-issue-list.issues.issue-card.more-button.more-versions",
        "defaultMessage": "More actions for {issueKey}"
    }
});
var $99053e6bfa0730fa$export$2e2bcd8739ae039 = $99053e6bfa0730fa$var$messages;

});


parcelRegister("hIiNX", function(module, exports) {
$parcel$export(module.exports, "Priority", () => $6317892f17eb4102$export$300334f671c43555);

var $eyutU = parcelRequire("eyutU");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $j4oe4 = parcelRequire("j4oe4");

var $8mxGC = parcelRequire("8mxGC");
const $6317892f17eb4102$export$300334f671c43555 = ({ jiraPriorityField: jiraPriorityField })=>{
    const [isPriorityIconBroken, setIsPriorityIconBroken] = (0, $eJOHy.useState)(false);
    const { priority: priority } = (0, $j4oe4.useFragment)((0, $eyutU.default), jiraPriorityField);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($6317892f17eb4102$var$PriorityContainer, null, priority && (isPriorityIconBroken ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8mxGC))), {
        label: priority.name || ''
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($6317892f17eb4102$var$Icon, {
        src: priority.iconUrl,
        alt: priority.name ?? undefined,
        title: priority.name ?? undefined,
        onError: ()=>{
            setIsPriorityIconBroken(true);
        }
    })));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6317892f17eb4102$var$Icon = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_16jlidpf _1o9zidpf _i0dl1wug _4t3i7vkz _1bsb7vkz _19pkidpf _2hwx1b66 _otyridpf _18u0idpf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6317892f17eb4102$var$PriorityContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1bsb7vkz _1ul97vkz _1e0c1txw _1bah1h6o _4cvr1h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("eyutU", function(module, exports) {
$parcel$export(module.exports, "default", () => $35a9a4e8d233e10b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e91e20f3fb1d0c82c7279249a4ac22bb>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $35a9a4e8d233e10b$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "priority_softwareReleasesVersionDetailIssueList",
    "selections": [
        {
            "concreteType": "JiraPriority",
            "kind": "LinkedField",
            "name": "priority",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "name"
                },
                {
                    "kind": "RequiredField",
                    "field": {
                        "kind": "ScalarField",
                        "name": "iconUrl"
                    },
                    "action": "NONE",
                    "path": "priority.iconUrl"
                }
            ]
        }
    ],
    "type": "JiraPriorityField"
};
$35a9a4e8d233e10b$var$node.hash = "ab255857fbd72fa53e70fe6a619699a6";
var $35a9a4e8d233e10b$export$2e2bcd8739ae039 = $35a9a4e8d233e10b$var$node;

});


parcelRegister("4bYle", function(module, exports) {
$parcel$export(module.exports, "Status", () => $e818ff09027c7990$export$96e9906d6d93a972);

var $ch8t5 = parcelRequire("ch8t5");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $j4oe4 = parcelRequire("j4oe4");

var $jx0Vw = parcelRequire("jx0Vw");

var $k71qx = parcelRequire("k71qx");

var $giHTp = parcelRequire("giHTp");
const $e818ff09027c7990$export$96e9906d6d93a972 = ({ jiraStatusField: jiraStatusField })=>{
    const { status: status } = (0, $j4oe4.useFragment)((0, $ch8t5.default), jiraStatusField);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e818ff09027c7990$var$StatusName, null, status.name), status.description != null && status.description.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e818ff09027c7990$var$StatusDescription, null, status.description))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $giHTp.default), {
        name: status.name,
        category: (0, $jx0Vw.statusCategoryForId)(status.statusCategory.statusCategoryId)
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e818ff09027c7990$var$StatusName = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_k48pmoej",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e818ff09027c7990$var$StatusDescription = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19pk1b66",
            __cmplp.className
        ])
    });
});

});
parcelRegister("ch8t5", function(module, exports) {
$parcel$export(module.exports, "default", () => $42e681b08d9bbb94$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<95f1026434793df353f849ec59749a29>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $42e681b08d9bbb94$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "status_softwareReleasesVersionDetailIssueList",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "concreteType": "JiraStatus",
                "kind": "LinkedField",
                "name": "status",
                "plural": false,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "kind": "ScalarField",
                            "name": "name"
                        },
                        "action": "THROW",
                        "path": "status.name"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "description"
                    },
                    {
                        "kind": "RequiredField",
                        "field": {
                            "concreteType": "JiraStatusCategory",
                            "kind": "LinkedField",
                            "name": "statusCategory",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "kind": "ScalarField",
                                        "name": "statusCategoryId"
                                    },
                                    "action": "THROW",
                                    "path": "status.statusCategory.statusCategoryId"
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "status.statusCategory"
                    }
                ]
            },
            "action": "THROW",
            "path": "status"
        }
    ],
    "type": "JiraStatusField"
};
$42e681b08d9bbb94$var$node.hash = "5e65ebd3a202999e9094506fd6a31982";
var $42e681b08d9bbb94$export$2e2bcd8739ae039 = $42e681b08d9bbb94$var$node;

});

parcelRegister("giHTp", function(module, exports) {
$parcel$export(module.exports, "default", () => $83c677465c2f30f1$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $jx0Vw = parcelRequire("jx0Vw");

var $jdqdp = parcelRequire("jdqdp");
const $83c677465c2f30f1$var$statusCategoryToAppearenceMap = {
    [(0, $jx0Vw.UNDEFINED)]: 'default',
    [(0, $jx0Vw.TODO)]: 'default',
    [(0, $jx0Vw.DONE)]: 'success',
    [(0, $jx0Vw.IN_PROGRESS)]: 'inprogress'
};
class $83c677465c2f30f1$export$2e2bcd8739ae039 extends (0, $eJOHy.Component) {
    static{
        this.defaultProps = {
            isActive: false
        };
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jdqdp.default), {
            testId: "common-components-status-lozenge.status-lozenge",
            isBold: this.props.isActive,
            appearance: $83c677465c2f30f1$var$statusCategoryToAppearenceMap[this.props.category],
            maxWidth: this.props.isFullWidth ? '100%' : undefined
        }, this.props.name);
    }
}

});


parcelRegister("jCedg", function(module, exports) {
$parcel$export(module.exports, "Summary", () => $5e3f976561429613$export$46453a0401d6cd1a);

var $iaqcM = parcelRequire("iaqcM");

var $1MvCb = parcelRequire("1MvCb");

var $lT6W2 = parcelRequire("lT6W2");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $k71qx = parcelRequire("k71qx");

var $czUU3 = parcelRequire("czUU3");
const $5e3f976561429613$var$TooltipTag = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($5e3f976561429613$var$IssueSummary, {
        ...props,
        ref: ref
    }));
const $5e3f976561429613$export$46453a0401d6cd1a = ({ jiraIssue: jiraIssue, jiraIssueSummaryField: jiraIssueSummaryField, jiraIssueTypeField: jiraIssueTypeField })=>{
    const { key: key } = (0, $j4oe4.useFragment)((0, $lT6W2.default), jiraIssue);
    const { text: summary } = (0, $j4oe4.useFragment)((0, $1MvCb.default), jiraIssueSummaryField);
    const { issueType: issueType } = (0, $j4oe4.useFragment)((0, $iaqcM.default), jiraIssueTypeField);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($5e3f976561429613$var$SummaryContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($5e3f976561429613$var$Icon, {
        src: issueType.avatar?.xsmall ?? (0, (/*@__PURE__*/$parcel$interopDefault($czUU3))),
        alt: issueType.name,
        title: issueType.name
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($5e3f976561429613$var$IssueKey, null, key), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: summary,
        tag: $5e3f976561429613$var$TooltipTag
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($5e3f976561429613$var$IssueSummary, null, summary)));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5e3f976561429613$var$SummaryContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw _4t3i1osq _1ul9uuw1 _4cvr1h6o _8mocu2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5e3f976561429613$var$Icon = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_16jlidpf _1o9zidpf _i0dl1wug _4t3i7vkz _1bsb7vkz _19pkidpf _2hwx1b66 _otyridpf _18u0idpf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @typescript-eslint/no-explicit-any, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5e3f976561429613$var$IssueSummary = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _1bto1l2s _o5721q9c _syazi7uo _9oik18uv _1bnx8stv _jf4cnqa1",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5e3f976561429613$var$IssueKey = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1o9zidpf _syaz1rpy _u5f3pxbi",
            __cmplp.className
        ])
    });
});

});
parcelRegister("iaqcM", function(module, exports) {
$parcel$export(module.exports, "default", () => $291dbcc12539820f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<269b69055861a60c9b538a02f44d6bfb>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $291dbcc12539820f$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "summary_softwareReleasesVersionDetailIssueList_jiraIssueTypeField",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "concreteType": "JiraIssueType",
                "kind": "LinkedField",
                "name": "issueType",
                "plural": false,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "kind": "ScalarField",
                            "name": "name"
                        },
                        "action": "THROW",
                        "path": "issueType.name"
                    },
                    {
                        "concreteType": "JiraAvatar",
                        "kind": "LinkedField",
                        "name": "avatar",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "kind": "ScalarField",
                                    "name": "xsmall"
                                },
                                "action": "LOG",
                                "path": "issueType.avatar.xsmall"
                            }
                        ]
                    }
                ]
            },
            "action": "THROW",
            "path": "issueType"
        }
    ],
    "type": "JiraIssueTypeField"
};
$291dbcc12539820f$var$node.hash = "9c2af22d7b07779fb498e0197b0b8a31";
var $291dbcc12539820f$export$2e2bcd8739ae039 = $291dbcc12539820f$var$node;

});

parcelRegister("1MvCb", function(module, exports) {
$parcel$export(module.exports, "default", () => $172c319b3a66105a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9997bef9f319cb4f9014d445188f50b1>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $172c319b3a66105a$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "summary_softwareReleasesVersionDetailIssueList_jiraIssueSummaryField",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "text"
            },
            "action": "THROW",
            "path": "text"
        }
    ],
    "type": "JiraSingleLineTextField"
};
$172c319b3a66105a$var$node.hash = "ecdba23eb4bd24552ee157f9d7e6c2dc";
var $172c319b3a66105a$export$2e2bcd8739ae039 = $172c319b3a66105a$var$node;

});

parcelRegister("lT6W2", function(module, exports) {
$parcel$export(module.exports, "default", () => $316d80558981ba33$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<8f3bafcb10f68f21b62cadc5fae27824>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $316d80558981ba33$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "summary_softwareReleasesVersionDetailIssueList_jiraIssue",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "key"
            },
            "action": "THROW",
            "path": "key"
        }
    ],
    "type": "JiraIssue"
};
$316d80558981ba33$var$node.hash = "be0a5b93419942c75fd2d852a9d5c8fc";
var $316d80558981ba33$export$2e2bcd8739ae039 = $316d80558981ba33$var$node;

});

parcelRegister("czUU3", function(module, exports) {
module.exports = new URL("issue-type-avatar-fallback.a9f6df1b.svg", import.meta.url).toString();

});




parcelRegister("croBS", function(module, exports) {
$parcel$export(module.exports, "ListOptions", () => $b8dfecfbc369f336$export$c50fde0141a9ce82);

var $I7unJ = parcelRequire("I7unJ");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $j4oe4 = parcelRequire("j4oe4");

var $gV6I6 = parcelRequire("gV6I6");

var $fdlCD = parcelRequire("fdlCD");
const $b8dfecfbc369f336$export$c50fde0141a9ce82 = ({ jiraVersion: jiraVersion })=>{
    const jiraVersionData = (0, $j4oe4.useFragment)((0, $I7unJ.default), jiraVersion);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b8dfecfbc369f336$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gV6I6.FiltersAsync), {
        jiraVersion: jiraVersionData
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b8dfecfbc369f336$var$SortingWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fdlCD.AsyncSortIssues), null)));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b8dfecfbc369f336$var$Wrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1h6o _4t3i1ylp _1ul9idpf _kqsw1if8 _154iidpf _1pbycs5v _bfhkvuon _ca0qpxbi _n3tdpxbi",
            __cmplp.className
        ])
    });
});
const $b8dfecfbc369f336$var$SortingWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("I7unJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $c4e60d494f6aaf8b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5ad9d1719b1000d014e3db5d4e26f842>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $c4e60d494f6aaf8b$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "listOptions_softwareReleasesVersionDetailIssueList",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "async_softwareReleasesVersionDetailIssueList_FiltersAsync"
        }
    ],
    "type": "JiraVersion"
};
$c4e60d494f6aaf8b$var$node.hash = "72816e24a790f41b4c2b45bd06ad26f9";
var $c4e60d494f6aaf8b$export$2e2bcd8739ae039 = $c4e60d494f6aaf8b$var$node;

});

parcelRegister("gV6I6", function(module, exports) {
$parcel$export(module.exports, "FiltersAsync", () => $480e201eb4521cea$export$c2ea1db993d10580);

var $jkkxQ = parcelRequire("jkkxQ");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $j4oe4 = parcelRequire("j4oe4");

var $5vQ2T = parcelRequire("5vQ2T");

var $2imLM = parcelRequire("2imLM");

var $bQWwW = parcelRequire("bQWwW");

const $480e201eb4521cea$var$FiltersLazy = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("gWTuo")).then((mod)=>mod.Filters), {
    moduleId: "./src/packages/releases/issue-list/src/ui/list-options/filters/index.tsx"
});
const $480e201eb4521cea$export$669f6ea7d267feaf = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($480e201eb4521cea$var$FilterBarLoadingWraper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($480e201eb4521cea$var$TextFilterSkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($480e201eb4521cea$var$AssigneeFilterSkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($480e201eb4521cea$var$DropdownFilterSkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($480e201eb4521cea$var$DropdownFilterSkeleton, null));
const $480e201eb4521cea$export$c2ea1db993d10580 = ({ jiraVersion: jiraVersion })=>{
    const jiraVersionData = (0, $j4oe4.useFragment)((0, $jkkxQ.default), jiraVersion);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        fallback: "flag",
        id: "jira.software.releases.version.detail.issue.list.filters",
        packageName: "jira-software-releases-version-detail-issue-list",
        teamName: "jolt"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "jira-software-releases-version-detail-issue-list-filters",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($480e201eb4521cea$export$669f6ea7d267feaf, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($480e201eb4521cea$var$FiltersLazy, {
        jiraVersion: jiraVersionData
    })));
};
const $480e201eb4521cea$var$skeletonKeyFrames = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $480e201eb4521cea$var$AnimationBaseDiv = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_ju25ru3m _5sagymdr _1o51q7pw _tip812c5 _1pglp3kn _1itk1pxg _12vemgnk _bfhkizff _j7hq1nls",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $480e201eb4521cea$var$FilterBarLoadingWraper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_4t3i1ylp _1bsb1osq _1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $480e201eb4521cea$var$TextFilterSkeleton = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = $480e201eb4521cea$var$AnimationBaseDiv, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rko12b0 _1bsb68cl _4t3i1ylp _2hwxpxbi",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $480e201eb4521cea$var$AssigneeFilterSkeleton = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = $480e201eb4521cea$var$AnimationBaseDiv, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rko1rr0 _4t3izwfg _1bsbzwfg _2hwxpxbi",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $480e201eb4521cea$var$DropdownFilterSkeleton = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = $480e201eb4521cea$var$AnimationBaseDiv, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rko1rr0 _4t3igktf _1bsbvbgk _2hwxpxbi",
            __cmplp.className
        ])
    });
});

});
parcelRegister("jkkxQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $5da8ebcb653055fe$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<42b58b01a1994dfcf0a3ac5a5b822aa3>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $5da8ebcb653055fe$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "async_softwareReleasesVersionDetailIssueList_FiltersAsync",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "filters_softwareReleasesVersionDetailIssueList"
        }
    ],
    "type": "JiraVersion"
};
$5da8ebcb653055fe$var$node.hash = "80684c6429225cfc5da72844f8d61f76";
var $5da8ebcb653055fe$export$2e2bcd8739ae039 = $5da8ebcb653055fe$var$node;

});

parcelRegister("gWTuo", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("cp1Ee").then(()=>parcelRequire('gsn0O'));

});


parcelRegister("fdlCD", function(module, exports) {
$parcel$export(module.exports, "AsyncSortIssues", () => $b854edcfcf5ec8c6$export$e985a1e694548d49);
/* AsyncSortIssues.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $cA0Y2 = parcelRequire("cA0Y2");

var $lRq8t = parcelRequire("lRq8t");

var $2imLM = parcelRequire("2imLM");

var $bQWwW = parcelRequire("bQWwW");

var $8QlQ2 = parcelRequire("8QlQ2");

var $4yJqM = parcelRequire("4yJqM");

var $1xdR3 = parcelRequire("1xdR3");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $b854edcfcf5ec8c6$var$LazySortIssues = (0, $bQWwW.lazy)(()=>Promise.resolve((parcelRequire("8QlQ2"))).then((module)=>module.SortIssuesDropdown), {
    moduleId: "./src/packages/releases/issue-list/src/ui/list-options/sorting/sorting-dropdown/SortIssuesDropdown.tsx"
});
const $b854edcfcf5ec8c6$export$e985a1e694548d49 = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { currentSortByOption: currentSortByOption, currentSortOrderOption: currentSortOrderOption } = (0, $1xdR3.useCurrentSortOptions)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "version-detail-sort-issues",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b854edcfcf5ec8c6$var$StyledButton, {
            iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8QlQ2.SortOrderIcon), {
                order: currentSortOrderOption.id
            })
        }, `${formatMessage((0, $4yJqM.default).sortBy)}: ${formatMessage(currentSortByOption.label)}`)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b854edcfcf5ec8c6$var$LazySortIssues, null));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $b854edcfcf5ec8c6$var$StyledButton = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = (0, $cA0Y2.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_fqox2smr _if291txw _1kba1h6o _12r21wq8",
            __cmplp.className
        ])
    });
});

});
parcelRegister("8QlQ2", function(module, exports) {
$parcel$export(module.exports, "SortIssuesDropdown", () => $542d6e6c13b07a01$export$2c14c390745c589);
$parcel$export(module.exports, "SortOrderIcon", () => $542d6e6c13b07a01$export$80ba57d0e34e16ec);
/* SortIssuesDropdown.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $cA0Y2 = parcelRequire("cA0Y2");

var $7rjYb = parcelRequire("7rjYb");
var $1pKTL = parcelRequire("1pKTL");
var $6TtH3 = parcelRequire("6TtH3");

var $8Gywp = parcelRequire("8Gywp");

var $aDbql = parcelRequire("aDbql");

var $6YEko = parcelRequire("6YEko");

var $4cTDP = parcelRequire("4cTDP");

var $lRq8t = parcelRequire("lRq8t");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $amEKX = parcelRequire("amEKX");

var $4yJqM = parcelRequire("4yJqM");

var $1xdR3 = parcelRequire("1xdR3");
const $542d6e6c13b07a01$export$2c14c390745c589 = ({ defaultOpen: defaultOpen })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { currentSortByOption: currentSortByOption, currentSortOrderOption: currentSortOrderOption } = (0, $1xdR3.useCurrentSortOptions)();
    const { setSortByParam: setSortByParam, setSortOrderParam: setSortOrderParam } = (0, $amEKX.useFilterSortingQueryParams)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7rjYb.default), {
        defaultOpen: defaultOpen,
        spacing: "compact",
        placement: "bottom-end",
        trigger: ({ triggerRef: triggerRef, isSelected: isSelected, ...providedProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($542d6e6c13b07a01$export$2d5d2ba3c7c8c40b, {
                ...providedProps,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                ref: triggerRef,
                isSelected: isSelected,
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($542d6e6c13b07a01$export$80ba57d0e34e16ec, {
                    order: currentSortOrderOption.id
                }),
                appearance: "subtle"
            }, `${formatMessage((0, $4yJqM.default).sortBy)}: ${formatMessage(currentSortByOption.label)}`)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6TtH3.default), {
        id: "sortByFields"
    }, ((0, $4cTDP.fg)('jira-issue-terminology-update-m4') ? (0, $1xdR3.sortByFieldOptions) : (0, $1xdR3.sortByFieldOptionsOld)).map((field)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($542d6e6c13b07a01$export$29d4895f75c15b40, {
            isSelected: field.id === currentSortByOption.id,
            id: field.id,
            key: field.id,
            onClick: ()=>{
                setSortByParam(field.id);
                const analyticsEvent = createAnalyticsEvent({
                    action: 'toggled',
                    actionSubject: 'radio'
                });
                (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'sorting', {
                    sortBy: field.id,
                    sortOrder: currentSortOrderOption.id
                });
            }
        }, formatMessage(field.label)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6YEko.default), {
        hasSeparator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6TtH3.default), {
        id: "sortOrderOptions"
    }, (0, $1xdR3.sortOrderOptions).map((order)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($542d6e6c13b07a01$export$29d4895f75c15b40, {
            isSelected: order.id === currentSortOrderOption.id,
            id: order.id,
            key: order.id,
            onClick: ()=>{
                setSortOrderParam(order.id);
                const analyticsEvent = createAnalyticsEvent({
                    action: 'toggled',
                    actionSubject: 'radio'
                });
                (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'sorting', {
                    sortBy: currentSortByOption.id,
                    sortOrder: order.id
                });
            }
        }, formatMessage(order.label))))));
};
const $542d6e6c13b07a01$export$80ba57d0e34e16ec = ({ order: order })=>{
    switch(order){
        case 'ASC':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aDbql))), {
                label: "software-releases-version-detail.common.sort-issues.ui.sort-order-icon.ascending"
            });
        case 'DESC':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8Gywp))), {
                label: "software-releases-version-detail.common.sort-issues.ui.sort-order-icon.descending"
            });
        default:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8Gywp))), {
                label: "software-releases-version-detail.common.sort-issues.ui.sort-order-icon.descending"
            });
    }
}; // This component is defined here deliberately to avoid DropdownItemRadio to be included in the Version details bundle.
const $542d6e6c13b07a01$export$29d4895f75c15b40 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = (0, $1pKTL.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_k48pi7a9 _1kha1b66",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $542d6e6c13b07a01$export$2d5d2ba3c7c8c40b = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = (0, $cA0Y2.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_fqox2smr _if291txw _1kba1h6o _12r21wq8",
            __cmplp.className
        ])
    });
});

});
parcelRegister("8Gywp", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fcfd9fc2877ad309c8a5d6e5d6ea9482>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $652d0645e24346a6$var$_react = $652d0645e24346a6$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $652d0645e24346a6$var$_baseNew = $652d0645e24346a6$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $652d0645e24346a6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowDown".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Know uses: sorting table headers or Bitbucket code difference.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $652d0645e24346a6$var$ArrowDownIcon = (props)=>/*#__PURE__*/ $652d0645e24346a6$var$_react.default.createElement($652d0645e24346a6$var$_baseNew.default, Object.assign({
        name: "ArrowDownIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.75 1v11.44l3.72-3.72 1.06 1.06-5 5a.75.75 0 0 1-1.06 0l-5-5 1.06-1.06 3.72 3.72V1z" clip-rule="evenodd"/>`
    }, props));
$652d0645e24346a6$var$ArrowDownIcon.displayName = 'ArrowDownIcon';
var $652d0645e24346a6$var$_default = module.exports.default = $652d0645e24346a6$var$ArrowDownIcon;

});

parcelRegister("aDbql", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::be13ec6c7b346b13ffda97746cc85c67>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7bd6687a611ada9e$var$_react = $7bd6687a611ada9e$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $7bd6687a611ada9e$var$_baseNew = $7bd6687a611ada9e$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $7bd6687a611ada9e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowUp".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: back to top.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7bd6687a611ada9e$var$ArrowUpIcon = (props)=>/*#__PURE__*/ $7bd6687a611ada9e$var$_react.default.createElement($7bd6687a611ada9e$var$_baseNew.default, Object.assign({
        name: "ArrowUpIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.75 15V3.56l3.72 3.72 1.06-1.06-5-5a.75.75 0 0 0-1.06 0l-5 5 1.06 1.06 3.72-3.72V15z" clip-rule="evenodd"/>`
    }, props));
$7bd6687a611ada9e$var$ArrowUpIcon.displayName = 'ArrowUpIcon';
var $7bd6687a611ada9e$var$_default = module.exports.default = $7bd6687a611ada9e$var$ArrowUpIcon;

});

parcelRegister("4yJqM", function(module, exports) {
$parcel$export(module.exports, "default", () => $722a2b28fa6db218$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $722a2b28fa6db218$var$messages = (0, $7qGN1.defineMessages)({
    sortByAssignee: {
        "id": "software-releases-version-detail-issue-list.list-options.sorting.sorting-dropdown.sort-by-assignee",
        "defaultMessage": "Assignee"
    },
    sortByDateCreated: {
        "id": "software-releases-version-detail-issue-list.list-options.sorting.sorting-dropdown.sort-by-date-created",
        "defaultMessage": "Date created"
    },
    sortByIssueKey: {
        "id": "software-releases-version-detail-issue-list.list-options.sorting.sorting-dropdown.sort-by-issue-key",
        "defaultMessage": "Issue key"
    },
    sortByPriority: {
        "id": "software-releases-version-detail-issue-list.list-options.sorting.sorting-dropdown.sort-by-priority",
        "defaultMessage": "Priority"
    },
    sortByIssueStatusCategory: {
        "id": "software-releases-version-detail-issue-list.list-options.sorting.sorting-dropdown.sort-by-issue-status-category",
        "defaultMessage": "Status category"
    },
    sortByIssueType: {
        "id": "software-releases-version-detail-issue-list.list-options.sorting.sorting-dropdown.sort-by-issue-type",
        "defaultMessage": "Type"
    },
    ascending: {
        "id": "software-releases-version-detail-issue-list.list-options.sorting.sorting-dropdown.ascending",
        "defaultMessage": "Ascending"
    },
    descending: {
        "id": "software-releases-version-detail-issue-list.list-options.sorting.sorting-dropdown.descending",
        "defaultMessage": "Descending"
    },
    sortBy: {
        "id": "software-releases-version-detail-issue-list.list-options.sorting.sorting-dropdown.sort-by",
        "defaultMessage": "Sort by"
    },
    sortByIssueKeyIssueTerminologyRefreshM4: {
        "id": "software-releases-version-detail-issue-list.list-options.sorting.sorting-dropdown.sort-by-issue-key-issue-terminology-refresh-m4",
        "defaultMessage": "Work item key"
    }
});
var $722a2b28fa6db218$export$2e2bcd8739ae039 = $722a2b28fa6db218$var$messages;

});

parcelRegister("1xdR3", function(module, exports) {
$parcel$export(module.exports, "sortOrderOptions", () => $10c0d0eca762dbc6$export$2969b4c3e7255782);
$parcel$export(module.exports, "sortByFieldOptions", () => $10c0d0eca762dbc6$export$bdbfa34747bc5af);
$parcel$export(module.exports, "sortByFieldOptionsOld", () => $10c0d0eca762dbc6$export$1b12bc0228e8b067);
$parcel$export(module.exports, "useCurrentSortOptions", () => $10c0d0eca762dbc6$export$43a8856ed2deb26e);

var $4cTDP = parcelRequire("4cTDP");


var $amEKX = parcelRequire("amEKX");

var $4yJqM = parcelRequire("4yJqM");
const $10c0d0eca762dbc6$export$2969b4c3e7255782 = [
    {
        id: 'ASC',
        label: (0, $4yJqM.default).ascending
    },
    {
        id: 'DESC',
        label: (0, $4yJqM.default).descending
    }
];
const $10c0d0eca762dbc6$export$bdbfa34747bc5af = [
    {
        id: 'CREATED',
        label: (0, $4yJqM.default).sortByDateCreated
    },
    {
        id: 'ASSIGNEE',
        label: (0, $4yJqM.default).sortByAssignee
    },
    {
        id: 'KEY',
        label: (0, $4yJqM.default).sortByIssueKeyIssueTerminologyRefreshM4
    },
    {
        id: 'PRIORITY',
        label: (0, $4yJqM.default).sortByPriority
    },
    {
        id: 'STATUS',
        label: (0, $4yJqM.default).sortByIssueStatusCategory
    },
    {
        id: 'TYPE',
        label: (0, $4yJqM.default).sortByIssueType
    }
];
const $10c0d0eca762dbc6$export$1b12bc0228e8b067 = [
    {
        id: 'CREATED',
        label: (0, $4yJqM.default).sortByDateCreated
    },
    {
        id: 'ASSIGNEE',
        label: (0, $4yJqM.default).sortByAssignee
    },
    {
        id: 'KEY',
        label: (0, $4yJqM.default).sortByIssueKey
    },
    {
        id: 'PRIORITY',
        label: (0, $4yJqM.default).sortByPriority
    },
    {
        id: 'STATUS',
        label: (0, $4yJqM.default).sortByIssueStatusCategory
    },
    {
        id: 'TYPE',
        label: (0, $4yJqM.default).sortByIssueType
    }
];
const $10c0d0eca762dbc6$export$43a8856ed2deb26e = ()=>{
    const { parsedQueryParams: parsedQueryParams } = (0, $amEKX.useFilterSortingQueryParams)();
    const fieldOptions = (0, $4cTDP.fg)('jira-issue-terminology-update-m4') ? $10c0d0eca762dbc6$export$bdbfa34747bc5af : $10c0d0eca762dbc6$export$1b12bc0228e8b067;
    const currentSortByOption = fieldOptions.find((option)=>option.id === parsedQueryParams[0, $3b2c8cea68e59ddc$export$13d5b2891ca65cd6]) ?? fieldOptions[0];
    const currentSortOrderOption = $10c0d0eca762dbc6$export$2969b4c3e7255782.find((option)=>option.id === parsedQueryParams[0, $3b2c8cea68e59ddc$export$810a1f7ed2facfcb]) ?? $10c0d0eca762dbc6$export$2969b4c3e7255782[0];
    return {
        currentSortByOption: currentSortByOption,
        currentSortOrderOption: currentSortOrderOption
    };
};

});




parcelRegister("epqOj", function(module, exports) {
$parcel$export(module.exports, "default", () => $5286ce758f46e3fe$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $5286ce758f46e3fe$var$messages = (0, $7qGN1.defineMessages)({
    issues: {
        "id": "software-releases-version-detail-issue-list.issues",
        "defaultMessage": "Issues"
    },
    addIssueIconLabel: {
        "id": "software-releases-version-detail-issue-list.add-issue-icon-label",
        "defaultMessage": "Add issues"
    },
    issuesIssueTerminologyRefreshM4: {
        "id": "software-releases-version-detail-issue-list.issues-issue-terminology-refresh-m4",
        "defaultMessage": "Work items"
    },
    addIssueIconLabelIssueTerminologyRefreshM4: {
        "id": "software-releases-version-detail-issue-list.add-issue-icon-label-issue-terminology-refresh-m4",
        "defaultMessage": "Add work items"
    }
});
var $5286ce758f46e3fe$export$2e2bcd8739ae039 = $5286ce758f46e3fe$var$messages;

});

parcelRegister("foOVA", function(module, exports) {
$parcel$export(module.exports, "IssueListScreenAnalytics", () => $e3fa706121dfe066$export$44cca2bcabf50abc);

var $gyykn = parcelRequire("gyykn");

var $i25Ll = parcelRequire("i25Ll");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $eS29z = parcelRequire("eS29z");

var $kO0T0 = parcelRequire("kO0T0");
const $e3fa706121dfe066$export$44cca2bcabf50abc = ({ jiraIssueEdgesReference: jiraIssueEdgesReference, jiraVersionReference: jiraVersionReference })=>{
    const jiraIssueEdgeReferenceData = (0, $j4oe4.useFragment)((0, $i25Ll.default), jiraIssueEdgesReference);
    const warningConfigFragment = (0, $j4oe4.useFragment)((0, $gyykn.default), jiraVersionReference);
    const nodes = jiraIssueEdgeReferenceData.map((edge)=>edge.node).filter(Boolean);
    // TODO: This will be improved by getting these values from the server either from Data Depot
    // or ARI Graph Store relationships. The current code has a bug that might result incorrect
    // boolean due to pagination. Also this is ugly to calculate in FE.
    const hasBambooDeployment = nodes.some((node)=>(node.devSummaryCache?.devSummary?.deploymentEnvironments?.overall?.topEnvironments ?? []).filter((deployment)=>deployment.status === 'DEPLOYED').length > 0);
    const hasDeployments = nodes.some((node)=>node.summarisedDeployments?.count != null && node.summarisedDeployments?.count > 0);
    const hasFeatureFlags = nodes.some((node)=>(node.summarisedFeatureFlags?.totalCount ?? 0) > 0);
    const hasCommits = nodes.some((node)=>Number(node.devSummaryCache?.devSummary?.commit?.overall?.count) > 0);
    const hasPullRequests = nodes.some((node)=>Number(node.devSummaryCache?.devSummary?.pullrequest?.overall?.count) > 0);
    const hasBranches = nodes.some((node)=>Number(node.devSummaryCache?.devSummary?.branch?.overall?.count) > 0);
    const hasBuilds = nodes.some((node)=>Number(node.devSummaryCache?.devSummary?.build?.overall?.count) > 0 || Number(node.summarisedBuilds?.count) > 0);
    const hasReviews = nodes.some((node)=>Number(node.devSummaryCache?.devSummary?.review?.overall?.count) > 0);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kO0T0.IssuesWarningCountProvider), {
        jiraVersion: warningConfigFragment,
        issueEdges: jiraIssueEdgeReferenceData
    }, (warningCount)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eS29z.FireScreenAnalytics), {
            attributes: {
                hasBamboo: hasBambooDeployment,
                hasBranches: hasBranches,
                hasBuilds: hasBuilds,
                hasCommits: hasCommits,
                hasDeployments: hasDeployments,
                hasFeatureFlags: hasFeatureFlags,
                hasPullRequests: hasPullRequests,
                hasReviews: hasReviews,
                warningCount: warningCount
            }
        }));
};

});
parcelRegister("gyykn", function(module, exports) {
$parcel$export(module.exports, "default", () => $c345679a41b1dbf7$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<0e7b3053e164d5901e6af58b7a501d5e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $c345679a41b1dbf7$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "screenAnalytics_softwareReleasesVersionDetailIssueList_IssueListScreenAnalytics_jiraVersionReference",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "ui_softwareReleasesVersionIssueWarningController_IssuesWarningCountProvider_jiraVersion"
        }
    ],
    "type": "JiraVersion"
};
$c345679a41b1dbf7$var$node.hash = "2dad59bd036f7e19ca923546c2912289";
var $c345679a41b1dbf7$export$2e2bcd8739ae039 = $c345679a41b1dbf7$var$node;

});

parcelRegister("i25Ll", function(module, exports) {
$parcel$export(module.exports, "default", () => $b795624b45686aa5$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d53cdb62c7218a329054318025c32557>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $b795624b45686aa5$var$node = function() {
    var v0 = [
        {
            "kind": "ScalarField",
            "name": "count"
        }
    ];
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "isDevopsFeatureDisabledInFedRamp"
            },
            {
                "kind": "RootArgument",
                "name": "shouldIncludeDevOpsFieldsViaAgs"
            }
        ],
        "kind": "Fragment",
        "metadata": {
            "plural": true
        },
        "name": "screenAnalytics_softwareReleasesVersionDetailIssueList_IssueListScreenAnalytics_jiraIssueEdgesReference",
        "selections": [
            {
                "concreteType": "JiraIssue",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                    {
                        "condition": "shouldIncludeDevOpsFieldsViaAgs",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            {
                                "concreteType": "DevOpsSummarisedDeployments",
                                "kind": "LinkedField",
                                "name": "summarisedDeployments",
                                "plural": false,
                                "selections": v0 /*: any*/ 
                            },
                            {
                                "concreteType": "DevOpsSummarisedBuilds",
                                "kind": "LinkedField",
                                "name": "summarisedBuilds",
                                "plural": false,
                                "selections": v0 /*: any*/ 
                            }
                        ]
                    },
                    {
                        "concreteType": "DevOpsSummarisedFeatureFlags",
                        "kind": "LinkedField",
                        "name": "summarisedFeatureFlags",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "totalCount"
                            }
                        ]
                    },
                    {
                        "condition": "isDevopsFeatureDisabledInFedRamp",
                        "kind": "Condition",
                        "passingValue": false,
                        "selections": [
                            {
                                "concreteType": "JiraIssueDevSummaryResult",
                                "kind": "LinkedField",
                                "name": "devSummaryCache",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraIssueDevSummary",
                                        "kind": "LinkedField",
                                        "name": "devSummary",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraIssuePullRequestDevSummaryContainer",
                                                "kind": "LinkedField",
                                                "name": "pullrequest",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraIssuePullRequestDevSummary",
                                                        "kind": "LinkedField",
                                                        "name": "overall",
                                                        "plural": false,
                                                        "selections": v0 /*: any*/ 
                                                    }
                                                ]
                                            },
                                            {
                                                "concreteType": "JiraIssueBranchDevSummaryContainer",
                                                "kind": "LinkedField",
                                                "name": "branch",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraIssueBranchDevSummary",
                                                        "kind": "LinkedField",
                                                        "name": "overall",
                                                        "plural": false,
                                                        "selections": v0 /*: any*/ 
                                                    }
                                                ]
                                            },
                                            {
                                                "concreteType": "JiraIssueReviewDevSummaryContainer",
                                                "kind": "LinkedField",
                                                "name": "review",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraIssueReviewDevSummary",
                                                        "kind": "LinkedField",
                                                        "name": "overall",
                                                        "plural": false,
                                                        "selections": v0 /*: any*/ 
                                                    }
                                                ]
                                            },
                                            {
                                                "concreteType": "JiraIssueCommitDevSummaryContainer",
                                                "kind": "LinkedField",
                                                "name": "commit",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraIssueCommitDevSummary",
                                                        "kind": "LinkedField",
                                                        "name": "overall",
                                                        "plural": false,
                                                        "selections": v0 /*: any*/ 
                                                    }
                                                ]
                                            },
                                            {
                                                "concreteType": "JiraIssueBuildDevSummaryContainer",
                                                "kind": "LinkedField",
                                                "name": "build",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraIssueBuildDevSummary",
                                                        "kind": "LinkedField",
                                                        "name": "overall",
                                                        "plural": false,
                                                        "selections": v0 /*: any*/ 
                                                    }
                                                ]
                                            },
                                            {
                                                "concreteType": "JiraIssueDeploymentEnvironmentDevSummaryContainer",
                                                "kind": "LinkedField",
                                                "name": "deploymentEnvironments",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraIssueDeploymentEnvironmentDevSummary",
                                                        "kind": "LinkedField",
                                                        "name": "overall",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraIssueDeploymentEnvironment",
                                                                "kind": "LinkedField",
                                                                "name": "topEnvironments",
                                                                "plural": true,
                                                                "selections": [
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "status"
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                "kind": "FragmentSpread",
                "name": "ui_softwareReleasesVersionIssueWarningController_IssuesWarningCountProvider_issueEdges"
            }
        ],
        "type": "JiraIssueEdge"
    };
}();
$b795624b45686aa5$var$node.hash = "986ab5c3f2a0f2a269dee80717c9a49d";
var $b795624b45686aa5$export$2e2bcd8739ae039 = $b795624b45686aa5$var$node;

});


parcelRegister("6OJ1M", function(module, exports) {
$parcel$export(module.exports, "useIntersectionObserver", () => $1b2cb15d4483bf53$export$a7395f9832c00176);

var $eJOHy = parcelRequire("eJOHy");
const $1b2cb15d4483bf53$export$a7395f9832c00176 = ({ margin: margin, onIntersection: onIntersection })=>{
    const [observedElement, setObservedElement] = (0, $eJOHy.useState)(null);
    (0, $eJOHy.useEffect)(()=>{
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        if (observedElement === null || window.IntersectionObserver === undefined) return undefined;
        const observerCallback = (entries)=>entries.forEach(({ isIntersecting: isIntersecting })=>{
                if (isIntersecting) onIntersection();
            });
        const observer = new IntersectionObserver(observerCallback, {
            rootMargin: `${margin}px`,
            threshold: 0
        });
        observer.observe(observedElement);
        return ()=>{
            observer.disconnect();
        };
    }, [
        observedElement,
        onIntersection,
        margin
    ]);
    return setObservedElement;
};

});


parcelRegister("1dvMC", function(module, exports) {
$parcel$export(module.exports, "VersionRelatedWorkExperienceStart", () => $ea9a09eccc35b568$export$e99e651b72ab598a);
$parcel$export(module.exports, "useViewVersionRelatedWorkExperienceFail", () => $ea9a09eccc35b568$export$ffb9ab4bec7b2f3c);
$parcel$export(module.exports, "VersionRelatedWorkExperienceSuccessTracker", () => $ea9a09eccc35b568$export$4e4779a3c4cff596);

var $eJOHy = parcelRequire("eJOHy");

var $aqnJa = parcelRequire("aqnJa");

var $8Uqf3 = parcelRequire("8Uqf3");

var $4ctwv = parcelRequire("4ctwv");

var $lBYgs = parcelRequire("lBYgs");

var $1BZ8a = parcelRequire("1BZ8a");
const $ea9a09eccc35b568$var$VERSION_RELATED_WORK_EXPERIENCE_NAME = 'viewVersionRelatedWork';
const $ea9a09eccc35b568$export$e99e651b72ab598a = ({ experienceId: experienceId })=>{
    const appEditions = (0, $1BZ8a.useAppEditions)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8Uqf3.ExperienceStart), {
        experienceId: experienceId,
        experience: $ea9a09eccc35b568$var$VERSION_RELATED_WORK_EXPERIENCE_NAME,
        analyticsSource: "versionDetails",
        edition: appEditions.software,
        application: (0, $lBYgs.JIRA_SOFTWARE)
    });
};
const $ea9a09eccc35b568$export$ffb9ab4bec7b2f3c = ()=>(0, $aqnJa.useExperienceFail)({
        experience: $ea9a09eccc35b568$var$VERSION_RELATED_WORK_EXPERIENCE_NAME
    });
const $ea9a09eccc35b568$export$4e4779a3c4cff596 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4ctwv.ExperienceSuccess), {
        experience: $ea9a09eccc35b568$var$VERSION_RELATED_WORK_EXPERIENCE_NAME
    });

});

parcelRegister("f4zNE", function(module, exports) {
$parcel$export(module.exports, "RelatedWork", () => $b98bf2c2600e197c$export$3200bfb79e9adbfb);

var $7qRwP = parcelRequire("7qRwP");

var $SWGaF = parcelRequire("SWGaF");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $j4oe4 = parcelRequire("j4oe4");

var $goZPP = parcelRequire("goZPP");

var $806LH = parcelRequire("806LH");

var $dcLzM = parcelRequire("dcLzM");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $jjS5D = parcelRequire("jjS5D");

var $4cTDP = parcelRequire("4cTDP");

var $lRq8t = parcelRequire("lRq8t");

var $eS29z = parcelRequire("eS29z");

var $b6bYe = parcelRequire("b6bYe");

var $8wUxx = parcelRequire("8wUxx");

var $l5MKM = parcelRequire("l5MKM");

var $7ZUH2 = parcelRequire("7ZUH2");

var $95O7y = parcelRequire("95O7y");

var $fi1AK = parcelRequire("fi1AK");

var $4bUJ2 = parcelRequire("4bUJ2");

var $abMBH = parcelRequire("abMBH");

var $YdBAX = parcelRequire("YdBAX");

var $3VMbq = parcelRequire("3VMbq");

var $g4whS = parcelRequire("g4whS");
const $b98bf2c2600e197c$export$8beb67dd759bbe2 = 5;
const $b98bf2c2600e197c$export$3200bfb79e9adbfb = ({ queryRef: queryRef })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8wUxx.RelatedWorkMutationLoadingProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b98bf2c2600e197c$var$RelatedWorkMain, {
        queryRef: queryRef
    }));
};
const $b98bf2c2600e197c$var$RelatedWorkMain = ({ queryRef: queryRef })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { isAddingRelatedWork: isAddingRelatedWork } = (0, $8wUxx.useRelatedWorkMutationLoading)();
    const { jira: jira } = (0, $j4oe4.usePreloadedQuery)((0, $SWGaF.default), queryRef);
    const versionFrag = jira.version;
    const version = (0, $j4oe4.useFragment)((0, $7qRwP.default), versionFrag);
    const [selectedCategory, setSelectedCategory] = (0, $95O7y.useQueryParam)('relatedWorkCategory');
    const addRelatedWorkExpFailed = (0, $b6bYe.useAddRelatedWorkExperienceFail)();
    const allRelatedWork = version.relatedWorkV2.edges.filter(Boolean);
    const relatedWorkInCategory = selectedCategory === undefined ? allRelatedWork : allRelatedWork.filter(({ node: node })=>node?.category === selectedCategory);
    const body = allRelatedWork.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, isAddingRelatedWork && (0, $4cTDP.fg)('jira-releases-related-work-remove-optimistic-resp') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $b98bf2c2600e197c$var$addRelatedWorkLoadingStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jjS5D.default), {
        isShimmering: true,
        borderRadius: 2,
        width: "100%",
        height: "52px"
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $YdBAX.RelatedWorkEmptyState), {
        jiraVersion: version,
        relatedWorkEdges: allRelatedWork
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fi1AK.ErrorBoundary), {
        id: "relatedWorkCategoryFilter",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $abMBH.CategoryFilter), {
        relatedWorkEdges: allRelatedWork,
        selectedCategory: selectedCategory,
        onCategorySelected: (category)=>setSelectedCategory(category, 'replace')
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $g4whS.RelatedWorkList), {
        jiraVersion: version,
        relatedWorkEdges: relatedWorkInCategory,
        selectedCategory: selectedCategory
    }), isAddingRelatedWork && (0, $4cTDP.fg)('jira-releases-related-work-remove-optimistic-resp') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $b98bf2c2600e197c$var$addRelatedWorkLoadingStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jjS5D.default), {
        isShimmering: true,
        borderRadius: 2,
        width: "100%",
        height: "52px"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b98bf2c2600e197c$var$ActionsContainer, null, version.status != null && version.status !== 'ARCHIVED' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fi1AK.ErrorBoundary), {
        id: "addRelatedPopup",
        fallback: "flag",
        onError: (location, error)=>{
            addRelatedWorkExpFailed(location, error);
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $l5MKM.AddRelatedWorkPopup), {
        jiraVersion: version,
        relatedWorkEdges: allRelatedWork,
        renderTrigger: ({ triggerProps: triggerProps, isLoading: isLoading, onClick: onClick, onMouseOver: onMouseOver })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b98bf2c2600e197c$var$AddButtonContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b98bf2c2600e197c$var$AddButton, {
                ...triggerProps,
                appearance: "subtle-link",
                testId: isLoading ? undefined : 'software-releases-version-related-work.ui.add-button',
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b98bf2c2600e197c$var$ActionIconContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dcLzM))), {
                    label: ""
                })),
                onClick: onClick,
                onMouseOver: onMouseOver,
                shouldFitContainer: true
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b98bf2c2600e197c$var$ShowMoreTextContainer, null, formatMessage((0, $3VMbq.default).addRelatedWork))))
    }))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4bUJ2.default), {
        relatedWorkEdges: allRelatedWork
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eS29z.FireScreenAnalytics), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7ZUH2.CollapsibleSection), {
        jiraVersion: version,
        uiType: "RELATED_WORK",
        renderHeader: (isCollapsed, onToggleClicked)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b98bf2c2600e197c$var$HeaderWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b98bf2c2600e197c$var$HeaderLeftWrapper, {
                onClick: onToggleClicked
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $806LH.default), {
                size: "small",
                as: "h2"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
                xcss: $b98bf2c2600e197c$var$sectionTitleStyles
            }, formatMessage((0, $3VMbq.default).relatedWorkHeading))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b98bf2c2600e197c$var$TotalCountLozenge, null, allRelatedWork.length), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7ZUH2.CollapsibleToggleButton), {
                isCollapsed: isCollapsed
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b98bf2c2600e197c$var$HeaderRightWrapper, null, version.status !== 'ARCHIVED' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fi1AK.ErrorBoundary), {
                key: "addRelatedWorkButton",
                id: "addRelatedPopupHeaderPlusButton",
                fallback: "flag",
                onError: (location, error)=>{
                    addRelatedWorkExpFailed(location, error);
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $l5MKM.AddRelatedWorkPopup), {
                jiraVersion: version,
                relatedWorkEdges: allRelatedWork,
                renderTrigger: ({ triggerProps: triggerProps, onClick: onClick, onMouseOver: onMouseOver })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b98bf2c2600e197c$var$AddIconButtonContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
                        ...triggerProps,
                        appearance: "subtle",
                        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dcLzM))), {
                            label: ""
                        }),
                        onClick: onClick,
                        onMouseOver: onMouseOver,
                        shouldFitContainer: true,
                        "aria-label": formatMessage((0, $3VMbq.default).addRelatedWork)
                    }))
            })))),
        renderBody: ()=>body
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b98bf2c2600e197c$var$ActionsContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_zulppxbi _1e0c1txw _2lx21bp4 _4cvr1y6m _ca0qu2gc _19bv1b66",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b98bf2c2600e197c$var$ActionIconContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_u5f3u2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b98bf2c2600e197c$var$ShowMoreTextContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_k48pi7a9",
            __cmplp.className
        ])
    });
}); // RLSS-2812 color.background.accent.gray.subtlest might be better than color.background.neutral
const $b98bf2c2600e197c$var$AddButtonContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rko1qi0 _1bsb1osq _80omtlke _ca0qu2gc _u5f3idpf _n3tdu2gc _19bvidpf _10j7i8nm _irr3i8nm",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b98bf2c2600e197c$var$AddButton = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = (0, $goZPP.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_14741e5h",
            __cmplp.className
        ])
    });
});
const $b98bf2c2600e197c$var$sectionTitleStyles = (0, $1DXK0.xcss)({
    marginTop: 'space.300',
    marginBottom: 'space.300',
    marginRight: 'space.100'
});
const $b98bf2c2600e197c$var$addRelatedWorkLoadingStyles = (0, $1DXK0.xcss)({
    paddingTop: 'space.100',
    paddingBottom: 'space.100'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b98bf2c2600e197c$var$AddIconButtonContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1bsbxy5q _4t3ixy5q",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b98bf2c2600e197c$var$HeaderWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _1bah1yb4 _4cvr1h6o _19pk1ejb",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b98bf2c2600e197c$var$HeaderLeftWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1h6o _80omtlke",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b98bf2c2600e197c$var$HeaderRightWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b98bf2c2600e197c$var$TotalCountLozenge = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_11c81o8v _2rko1mok _bfhkysee _1e0c1txw _1bah1h6o _4cvr1h6o _4t3ipxbi _19pkv77o _u5f31b66 _19bv1b66",
            __cmplp.className
        ])
    });
});

});
parcelRegister("7qRwP", function(module, exports) {
$parcel$export(module.exports, "default", () => $dfe60ad54cf5ec55$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f9594b0e9cfedaf2fac09cafe5fbee81>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $dfe60ad54cf5ec55$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "metadata": {
            "connection": [
                {
                    "count": null,
                    "cursor": null,
                    "direction": "forward",
                    "path": [
                        "relatedWorkV2"
                    ]
                }
            ]
        },
        "name": "ui_softwareReleasesVersionRelatedWork_RelatedWork",
        "selections": [
            {
                "kind": "RequiredField",
                "field": {
                    "alias": "relatedWorkV2",
                    "concreteType": "JiraVersionRelatedWorkV2Connection",
                    "kind": "LinkedField",
                    "name": "__version_relatedWorkV2_connection",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "concreteType": "JiraVersionRelatedWorkV2Edge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    v0 /*: any*/ ,
                                    {
                                        "kind": "FragmentSpread",
                                        "name": "relatedWorkList_softwareReleasesVersionRelatedWork_relatedWorkEdges"
                                    },
                                    {
                                        "kind": "FragmentSpread",
                                        "name": "categoryFilter_softwareReleasesVersionRelatedWork"
                                    },
                                    {
                                        "kind": "FragmentSpread",
                                        "name": "async_softwareReleasesAddRelatedWorkToVersion_AddRelatedWorkPopup_relatedWorkEdges"
                                    },
                                    {
                                        "kind": "FragmentSpread",
                                        "name": "emptyState_softwareReleasesVersionRelatedWork_RelatedWorkEmptyState_relatedWorkEdges"
                                    },
                                    {
                                        "kind": "FragmentSpread",
                                        "name": "analyticsContext_softwareReleasesVersionRelatedWork_RelatedWorkAnalyticsContext"
                                    },
                                    {
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "async_softwareReleasesAddRelatedWorkToVersion_EditRelatedWorkPopup_jiraVersionRelatedWork"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "category"
                                            },
                                            v0 /*: any*/ 
                                        ]
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "cursor"
                                    }
                                ]
                            },
                            "action": "THROW",
                            "path": "relatedWorkV2.edges"
                        },
                        {
                            "concreteType": "PageInfo",
                            "kind": "LinkedField",
                            "name": "pageInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "endCursor"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "hasNextPage"
                                }
                            ]
                        }
                    ]
                },
                "action": "THROW",
                "path": "relatedWorkV2"
            },
            {
                "kind": "ScalarField",
                "name": "status"
            },
            {
                "kind": "FragmentSpread",
                "name": "async_softwareReleasesAddRelatedWorkToVersion_AddRelatedWorkPopup_jiraVersion"
            },
            {
                "kind": "FragmentSpread",
                "name": "async_softwareReleasesAddRelatedWorkToVersion_EditRelatedWorkPopup_jiraVersion"
            },
            {
                "kind": "FragmentSpread",
                "name": "emptyState_softwareReleasesVersionRelatedWork_RelatedWorkEmptyState_jiraVersion"
            },
            {
                "kind": "FragmentSpread",
                "name": "relatedWorkList_softwareReleasesVersionRelatedWork_jiraVersion"
            },
            {
                "kind": "FragmentSpread",
                "name": "ui_softwareReleasesCollapsibleUiToggle_CollapsibleSection"
            }
        ],
        "type": "JiraVersion"
    };
}();
$dfe60ad54cf5ec55$var$node.hash = "ee870a351f61b9ac907790203ed00950";
var $dfe60ad54cf5ec55$export$2e2bcd8739ae039 = $dfe60ad54cf5ec55$var$node;

});

parcelRegister("SWGaF", function(module, exports) {
$parcel$export(module.exports, "default", () => $2521318dcd50e613$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9675730f6f3a5344ac7a44fad40a564f>>
 * @relayHash b86ff13b09f7eb5a0f8fabff1e5ee762
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9db46cbf2997d3ea44fe2ed14a797a64a0c1e3fb3cc94655c212c7e3245cef16
const $2521318dcd50e613$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isDevopsFeatureDisabledInFedRamp"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "versionAri"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "versionAri"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 100
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "kind": "ScalarField",
        "name": "url"
    }, v7 = {
        "kind": "ScalarField",
        "name": "relatedWorkId"
    }, v8 = {
        "kind": "ScalarField",
        "name": "title"
    }, v9 = {
        "kind": "ScalarField",
        "name": "fieldId"
    }, v10 = {
        "kind": "ScalarField",
        "name": "name"
    }, v11 = {
        "concreteType": "JiraIssue",
        "kind": "LinkedField",
        "name": "issue",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "key"
            },
            {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "ids",
                        "value": [
                            "assignee",
                            "status"
                        ]
                    }
                ],
                "concreteType": "JiraIssueFieldConnection",
                "kind": "LinkedField",
                "name": "fieldsById",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraIssueFieldEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v3 /*: any*/ ,
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            v9 /*: any*/ ,
                                            {
                                                "concreteType": "JiraStatus",
                                                "kind": "LinkedField",
                                                "name": "status",
                                                "plural": false,
                                                "selections": [
                                                    v10 /*: any*/ ,
                                                    {
                                                        "concreteType": "JiraStatusCategory",
                                                        "kind": "LinkedField",
                                                        "name": "statusCategory",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "statusCategoryId"
                                                            },
                                                            v5 /*: any*/ 
                                                        ]
                                                    },
                                                    v5 /*: any*/ 
                                                ]
                                            }
                                        ],
                                        "type": "JiraStatusField"
                                    },
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            v9 /*: any*/ ,
                                            {
                                                "kind": "LinkedField",
                                                "name": "user",
                                                "plural": false,
                                                "selections": [
                                                    v3 /*: any*/ ,
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "picture"
                                                    },
                                                    v10 /*: any*/ ,
                                                    v5 /*: any*/ 
                                                ]
                                            }
                                        ],
                                        "type": "JiraSingleSelectUserPickerField"
                                    },
                                    v5 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ],
                "storageKey": "fieldsById(ids:[\"assignee\",\"status\"])"
            }
        ]
    }, v12 = {
        "kind": "ScalarField",
        "name": "__id"
    }, v13 = {
        "kind": "ClientExtension",
        "selections": [
            v12 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "isSaving"
            }
        ]
    }, v14 = {
        "kind": "ClientExtension",
        "selections": [
            v12 /*: any*/ 
        ]
    }, v15 = {
        "kind": "InlineFragment",
        "selections": [
            v14 /*: any*/ 
        ],
        "type": "JiraVersionRelatedWorkConfluenceReleaseNotes"
    }, v16 = {
        "kind": "InlineFragment",
        "selections": [
            v11 /*: any*/ ,
            v15 /*: any*/ ,
            v13 /*: any*/ 
        ],
        "type": "JiraVersionRelatedWorkV2",
        "abstractKey": "__isJiraVersionRelatedWorkV2"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "ui_softwareReleasesVersionRelatedWork_RelatedWorkQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v2 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "condition": "isDevopsFeatureDisabledInFedRamp",
                                            "kind": "Condition",
                                            "passingValue": false,
                                            "selections": [
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "ui_softwareReleasesVersionRelatedWork_RelatedWork"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.version"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "ui_softwareReleasesVersionRelatedWork_RelatedWorkQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "version",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "condition": "isDevopsFeatureDisabledInFedRamp",
                                    "kind": "Condition",
                                    "passingValue": false,
                                    "selections": [
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "args": v4 /*: any*/ ,
                                                    "concreteType": "JiraVersionRelatedWorkV2Connection",
                                                    "kind": "LinkedField",
                                                    "name": "relatedWorkV2",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraVersionRelatedWorkV2Edge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                v3 /*: any*/ ,
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v3 /*: any*/ ,
                                                                        {
                                                                            "kind": "TypeDiscriminator",
                                                                            "abstractKey": "__isJiraVersionRelatedWorkV2"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "category"
                                                                        },
                                                                        {
                                                                            "concreteType": "JiraIssue",
                                                                            "kind": "LinkedField",
                                                                            "name": "issue",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v3 /*: any*/ ,
                                                                                v5 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v6 /*: any*/ ,
                                                                                v7 /*: any*/ ,
                                                                                v8 /*: any*/ ,
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v11 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v13 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraVersionRelatedWorkV2",
                                                                                                    "abstractKey": "__isJiraVersionRelatedWorkV2"
                                                                                                },
                                                                                                v14 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraVersionRelatedWorkGenericLink"
                                                                                        },
                                                                                        v15 /*: any*/ ,
                                                                                        v13 /*: any*/ 
                                                                                    ],
                                                                                    "type": "JiraVersionRelatedWorkV2",
                                                                                    "abstractKey": "__isJiraVersionRelatedWorkV2"
                                                                                },
                                                                                v14 /*: any*/ 
                                                                            ],
                                                                            "type": "JiraVersionRelatedWorkGenericLink"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v7 /*: any*/ ,
                                                                                v6 /*: any*/ ,
                                                                                v8 /*: any*/ ,
                                                                                v16 /*: any*/ 
                                                                            ],
                                                                            "type": "JiraVersionRelatedWorkConfluenceReleaseNotes"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v8 /*: any*/ ,
                                                                                v16 /*: any*/ 
                                                                            ],
                                                                            "type": "JiraVersionRelatedWorkNativeReleaseNotes"
                                                                        },
                                                                        v14 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "cursor"
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "PageInfo",
                                                            "kind": "LinkedField",
                                                            "name": "pageInfo",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "endCursor"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "hasNextPage"
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "storageKey": "relatedWorkV2(first:100)"
                                                },
                                                {
                                                    "args": v4 /*: any*/ ,
                                                    "handle": "connection",
                                                    "key": "version_relatedWorkV2",
                                                    "kind": "LinkedHandle",
                                                    "name": "relatedWorkV2"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "status"
                                                },
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "canEditRelatedWork"
                                                },
                                                {
                                                    "alias": "allIssues",
                                                    "args": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "filter",
                                                            "value": "ALL"
                                                        }
                                                    ],
                                                    "concreteType": "JiraIssueConnection",
                                                    "kind": "LinkedField",
                                                    "name": "issues",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "totalCount"
                                                        }
                                                    ],
                                                    "storageKey": "issues(filter:\"ALL\")"
                                                },
                                                {
                                                    "concreteType": "JiraProject",
                                                    "kind": "LinkedField",
                                                    "name": "project",
                                                    "plural": false,
                                                    "selections": [
                                                        v5 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "projectId"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "versionId"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "collapsedUis"
                                                },
                                                v14 /*: any*/ 
                                            ],
                                            "type": "JiraVersion"
                                        }
                                    ]
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v5 /*: any*/ 
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "9db46cbf2997d3ea44fe2ed14a797a64a0c1e3fb3cc94655c212c7e3245cef16",
            "metadata": {},
            "name": "ui_softwareReleasesVersionRelatedWork_RelatedWorkQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$2521318dcd50e613$var$node.hash = "d8d66158505126260b0811b2a2af5336";
var $2521318dcd50e613$export$2e2bcd8739ae039 = $2521318dcd50e613$var$node;

});

parcelRegister("b6bYe", function(module, exports) {
$parcel$export(module.exports, "useAddRelatedWorkExperienceStart", () => $c8bb2d2fb2d945af$export$2a84c09279dbc41e);
$parcel$export(module.exports, "useAddRelatedWorkExperienceFail", () => $c8bb2d2fb2d945af$export$b2970d2d64ed7236);
$parcel$export(module.exports, "useAddRelatedWorkExperienceSuccess", () => $c8bb2d2fb2d945af$export$f01728e86602e7e0);

var $aqnJa = parcelRequire("aqnJa");

var $8Uqf3 = parcelRequire("8Uqf3");

var $4ctwv = parcelRequire("4ctwv");

var $lBYgs = parcelRequire("lBYgs");

var $1BZ8a = parcelRequire("1BZ8a");
const $c8bb2d2fb2d945af$var$EXPERIENCE_NAME = 'addRelatedWork';
const $c8bb2d2fb2d945af$var$ANALYTICS_SOURCE = 'versionDetails';
const $c8bb2d2fb2d945af$export$2a84c09279dbc41e = ()=>{
    const appEditions = (0, $1BZ8a.useAppEditions)();
    return (0, $8Uqf3.useExperienceStart)({
        experience: $c8bb2d2fb2d945af$var$EXPERIENCE_NAME,
        experienceId: `${Date.now()}`,
        analyticsSource: $c8bb2d2fb2d945af$var$ANALYTICS_SOURCE,
        application: (0, $lBYgs.JIRA_SOFTWARE),
        edition: appEditions.software
    });
};
const $c8bb2d2fb2d945af$export$b2970d2d64ed7236 = ()=>(0, $aqnJa.useExperienceFail)({
        experience: $c8bb2d2fb2d945af$var$EXPERIENCE_NAME
    });
const $c8bb2d2fb2d945af$export$f01728e86602e7e0 = ()=>(0, $4ctwv.useExperienceSuccess)({
        experience: $c8bb2d2fb2d945af$var$EXPERIENCE_NAME
    });

});

parcelRegister("8wUxx", function(module, exports) {
$parcel$export(module.exports, "RelatedWorkMutationLoadingProvider", () => $a211b38298060022$export$ac3e39856f27f7d8);
$parcel$export(module.exports, "useRelatedWorkMutationLoading", () => $a211b38298060022$export$47b0c1e65eda8964);

var $eJOHy = parcelRequire("eJOHy");
const $a211b38298060022$var$RelatedWorkMutationLoadingContext = /*#__PURE__*/ (0, $eJOHy.createContext)(null);
const $a211b38298060022$export$ac3e39856f27f7d8 = ({ children: children })=>{
    const [isAddingRelatedWork, setIsAddingRelatedWork] = (0, $eJOHy.useState)(false);
    const contextValue = (0, $eJOHy.useMemo)(()=>({
            isAddingRelatedWork: isAddingRelatedWork,
            setIsAddingRelatedWork: setIsAddingRelatedWork
        }), [
        isAddingRelatedWork,
        setIsAddingRelatedWork
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a211b38298060022$var$RelatedWorkMutationLoadingContext.Provider, {
        value: contextValue
    }, children);
};
const $a211b38298060022$export$47b0c1e65eda8964 = ()=>{
    const context = (0, $eJOHy.useContext)($a211b38298060022$var$RelatedWorkMutationLoadingContext);
    if (context === null) return {
        isAddingRelatedWork: false,
        setIsAddingRelatedWork: ()=>{
        // do nothing
        }
    };
    return context;
};

});

parcelRegister("l5MKM", function(module, exports) {
$parcel$export(module.exports, "AddRelatedWorkPopup", () => $a8a876b39c020cb0$export$7c8948b134dbfa2e);

var $cmT11 = parcelRequire("cmT11");

var $d2JfS = parcelRequire("d2JfS");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $2imLM = parcelRequire("2imLM");

var $bQWwW = parcelRequire("bQWwW");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $a8a876b39c020cb0$var$LazyAddRelatedWorkPopup = (0, $bQWwW.lazy)(()=>(parcelRequire("34R9p")).then((module)=>module.AddRelatedWorkPopup), {
    moduleId: "./src/packages/releases/add-related-work-to-version/src/ui/add-related-work-popup/index.tsx"
});
const $a8a876b39c020cb0$export$7c8948b134dbfa2e = ({ jiraVersion: jiraVersion, renderTrigger: renderTrigger, relatedWorkEdges: relatedWorkEdges })=>{
    const version = (0, $j4oe4.useFragment)((0, $d2JfS.default), jiraVersion);
    const edges = (0, $j4oe4.useFragment)((0, $cmT11.default), relatedWorkEdges);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "add-related-work-popup",
        fallback: renderTrigger({
            triggerProps: {},
            onClick: ()=>undefined,
            onMouseOver: ()=>undefined,
            isLoading: true
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a8a876b39c020cb0$var$LazyAddRelatedWorkPopup, {
        jiraVersion: version,
        renderTrigger: renderTrigger,
        relatedWorkEdges: edges
    }));
};

});
parcelRegister("cmT11", function(module, exports) {
$parcel$export(module.exports, "default", () => $67cedd49a8be7cc2$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c1093bcdbe8a0213bfff539dbd23c487>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $67cedd49a8be7cc2$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": {
        "plural": true
    },
    "name": "async_softwareReleasesAddRelatedWorkToVersion_AddRelatedWorkPopup_relatedWorkEdges",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "addRelatedWorkPopup_softwareReleasesAddRelatedWorkToVersion_relatedWorkEdges"
        }
    ],
    "type": "JiraVersionRelatedWorkV2Edge"
};
$67cedd49a8be7cc2$var$node.hash = "a1ee6f3b568b757ef42ae7c9484cb878";
var $67cedd49a8be7cc2$export$2e2bcd8739ae039 = $67cedd49a8be7cc2$var$node;

});

parcelRegister("d2JfS", function(module, exports) {
$parcel$export(module.exports, "default", () => $6b6ffc1a7fa9fb8a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2ae5b22d33923ae62c0eb9c486b2bf3c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $6b6ffc1a7fa9fb8a$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "async_softwareReleasesAddRelatedWorkToVersion_AddRelatedWorkPopup_jiraVersion",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "addRelatedWorkPopup_softwareReleasesAddRelatedWorkToVersion_jiraVersion"
        }
    ],
    "type": "JiraVersion"
};
$6b6ffc1a7fa9fb8a$var$node.hash = "61023dc51339302e0390200141db5335";
var $6b6ffc1a7fa9fb8a$export$2e2bcd8739ae039 = $6b6ffc1a7fa9fb8a$var$node;

});

parcelRegister("34R9p", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("9A19y").then(()=>parcelRequire('2qxWk'));

});


parcelRegister("fi1AK", function(module, exports) {
$parcel$export(module.exports, "ErrorBoundary", () => $ca9abb95f0a11b8e$export$e926676385687eaf);

var $eJOHy = parcelRequire("eJOHy");

var $5vQ2T = parcelRequire("5vQ2T");
const $ca9abb95f0a11b8e$export$e926676385687eaf = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        fallback: "flag",
        ...props,
        packageName: "jiraSoftwareReleasesVersionRelatedWork",
        teamName: "jolt"
    });

});

parcelRegister("4bUJ2", function(module, exports) {
$parcel$export(module.exports, "default", () => $5c1226af942dcede$export$2e2bcd8739ae039);

var $9MhLC = parcelRequire("9MhLC");

var $eJOHy = parcelRequire("eJOHy");

var $6Abnv = parcelRequire("6Abnv");

var $j4oe4 = parcelRequire("j4oe4");

var $kGj4V = parcelRequire("kGj4V");

var $aoxXe = parcelRequire("aoxXe");
const $5c1226af942dcede$var$isFirstPartyLink = (url)=>// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    new URL(url).hostname === window.location.hostname;
const $5c1226af942dcede$var$useAnalyticsAttributes = (relatedWorkItems)=>{
    const numberOfRelatedWorkItems = relatedWorkItems.length;
    const relatedWorkTypes = (0, (/*@__PURE__*/$parcel$interopDefault($6Abnv)))(relatedWorkItems, (item)=>item.node?.__typename);
    const hasNativeReleaseNotes = relatedWorkTypes.JiraVersionRelatedWorkNativeReleaseNotes?.length > 0;
    const numConfluenceReleaseNotes = relatedWorkTypes.JiraVersionRelatedWorkConfluenceReleaseNotes?.length ?? 0;
    const getIssueLinkingAttributes = ()=>{
        const numOfLinkedIssues = relatedWorkItems.filter((item)=>item.node?.issue !== null).length;
        return {
            numOfLinkedIssues: numOfLinkedIssues
        };
    };
    const formatCategoryName = (0, $aoxXe.useFormatCategoryName)();
    const getPlaceholderStateAttributes = ()=>{
        const genericLinks = relatedWorkTypes.JiraVersionRelatedWorkGenericLink ?? [];
        const numPlaceholderItems = genericLinks.filter((item)=>item.node?.url === null).length;
        const numNonPlaceholderItems = genericLinks.length - numPlaceholderItems;
        const numFirstPartyLinks = genericLinks.filter((item)=>item.node?.url != null && $5c1226af942dcede$var$isFirstPartyLink(item.node.url)).length;
        const numThirdPartyLinks = numNonPlaceholderItems - numFirstPartyLinks;
        const itemsByCategories = (0, (/*@__PURE__*/$parcel$interopDefault($6Abnv)))(relatedWorkItems, (item)=>item.node?.category);
        // This is a temporary approach that won't properly recognise categories if the item was created in a different
        // locale from the one it's being viewed in. A more robust enum-based approach should be used once related work
        // items are migrated out of Data Depot and into ERS.
        const countItemsInCategory = (category)=>itemsByCategories[formatCategoryName(category)]?.length ?? 0;
        const defaultCategoryUsageCounts = (0, $aoxXe.DEFAULT_CATEGORIES).map((category)=>[
                category.analyticsAttributeName,
                countItemsInCategory(category)
            ]);
        const numItemsInDefaultCategories = defaultCategoryUsageCounts.reduce((runningTotal, [, itemsInCategory])=>runningTotal + itemsInCategory, 0);
        const numItemsInOtherCategories = numberOfRelatedWorkItems - numItemsInDefaultCategories;
        const numCategories = Object.keys(itemsByCategories).length;
        return {
            numPlaceholderItems: numPlaceholderItems,
            numNonPlaceholderItems: numNonPlaceholderItems,
            numFirstPartyLinks: numFirstPartyLinks,
            numThirdPartyLinks: numThirdPartyLinks,
            numItemsInOtherCategories: numItemsInOtherCategories,
            numCategories: numCategories,
            ...Object.fromEntries(defaultCategoryUsageCounts)
        };
    };
    return {
        // The `numLinks` name is slightly misleading, but we're keeping it for historical reasons
        numLinks: numberOfRelatedWorkItems,
        hasNativeReleaseNotes: hasNativeReleaseNotes,
        numConfluenceReleaseNotes: numConfluenceReleaseNotes,
        // Note: when you clean up these flags, make the relevant fields in `AnalyticsAttributes`
        // required rather than optional.
        ...getPlaceholderStateAttributes(),
        ...getIssueLinkingAttributes()
    };
};
const $5c1226af942dcede$export$e6de70608562a971 = ({ relatedWorkEdges: relatedWorkEdges, children: children })=>{
    const data = (0, $j4oe4.useFragment)((0, $9MhLC.default), relatedWorkEdges);
    const attributes = $5c1226af942dcede$var$useAnalyticsAttributes(data);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kGj4V.ContextualAnalyticsData), {
        sourceName: "versionRelatedWork",
        sourceType: (0, $aa42ce8e355d58fa$export$f636b5b56f1d624a),
        attributes: attributes
    }, children);
};
var $5c1226af942dcede$export$2e2bcd8739ae039 = $5c1226af942dcede$export$e6de70608562a971;

});
parcelRegister("9MhLC", function(module, exports) {
$parcel$export(module.exports, "default", () => $85bf033d3ce03c99$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b00338198aa2a5443fe90e410f9e4c7a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $85bf033d3ce03c99$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "metadata": {
            "plural": true
        },
        "name": "analyticsContext_softwareReleasesVersionRelatedWork_RelatedWorkAnalyticsContext",
        "selections": [
            {
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                    v0 /*: any*/ ,
                    {
                        "concreteType": "JiraIssue",
                        "kind": "LinkedField",
                        "name": "issue",
                        "plural": false,
                        "selections": [
                            v0 /*: any*/ 
                        ]
                    },
                    {
                        "kind": "ScalarField",
                        "name": "category"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "url"
                            }
                        ],
                        "type": "JiraVersionRelatedWorkGenericLink"
                    }
                ]
            }
        ],
        "type": "JiraVersionRelatedWorkV2Edge"
    };
}();
$85bf033d3ce03c99$var$node.hash = "aa20d10ea14c3261013e36223676a0c8";
var $85bf033d3ce03c99$export$2e2bcd8739ae039 = $85bf033d3ce03c99$var$node;

});

parcelRegister("aoxXe", function(module, exports) {
$parcel$export(module.exports, "CommunicationCategory", () => $fb28f2d21f03975f$export$4c00bbfcc0ecf975);
$parcel$export(module.exports, "RolloutCategory", () => $fb28f2d21f03975f$export$f4e280770913e10f);
$parcel$export(module.exports, "TestingCategory", () => $fb28f2d21f03975f$export$a6d4661a542d168f);
$parcel$export(module.exports, "AnalyticsCategory", () => $fb28f2d21f03975f$export$257af46c9923adf8);
$parcel$export(module.exports, "DevelopmentCategory", () => $fb28f2d21f03975f$export$d3d779bdc5757c39);
$parcel$export(module.exports, "SupportCategory", () => $fb28f2d21f03975f$export$1909a2cc48b27b53);
$parcel$export(module.exports, "DEFAULT_CATEGORIES", () => $fb28f2d21f03975f$export$b101d8f25cc16679);
$parcel$export(module.exports, "useFormatCategoryName", () => $fb28f2d21f03975f$export$890bc5a26a499c1d);
$parcel$export(module.exports, "usePlaceholderIcon", () => $fb28f2d21f03975f$export$ec6234b435e23f80);

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $1UTIx = parcelRequire("1UTIx");

var $9Hnkr = parcelRequire("9Hnkr");

var $9Nt5j = parcelRequire("9Nt5j");

var $hrRds = parcelRequire("hrRds");
const $fb28f2d21f03975f$export$4c00bbfcc0ecf975 = {
    i18nMessage: (0, $hrRds.default).communicationCategory,
    placeholderIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1UTIx.DocumentPlusGlyph), null),
    analyticsAttributeName: 'numLinksInCommunicationCategory'
};
const $fb28f2d21f03975f$export$f4e280770913e10f = {
    i18nMessage: (0, $hrRds.default).rolloutCategory,
    placeholderIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9Hnkr.GenericPlusGlyph), null),
    analyticsAttributeName: 'numLinksInRolloutCategory'
};
const $fb28f2d21f03975f$export$a6d4661a542d168f = {
    i18nMessage: (0, $hrRds.default).testingCategory,
    placeholderIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1UTIx.DocumentPlusGlyph), null),
    analyticsAttributeName: 'numLinksInTestingCategory'
};
const $fb28f2d21f03975f$export$257af46c9923adf8 = {
    i18nMessage: (0, $hrRds.default).analyticsCategory,
    placeholderIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9Nt5j.PresentationPlusGlyph), null),
    analyticsAttributeName: 'numLinksInAnalyticsCategory'
};
const $fb28f2d21f03975f$export$d3d779bdc5757c39 = {
    i18nMessage: (0, $hrRds.default).developmentCategory,
    placeholderIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9Hnkr.GenericPlusGlyph), null),
    analyticsAttributeName: 'numLinksInDevelopmentCategory'
};
const $fb28f2d21f03975f$export$1909a2cc48b27b53 = {
    i18nMessage: (0, $hrRds.default).supportCategory,
    placeholderIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9Hnkr.GenericPlusGlyph), null),
    analyticsAttributeName: 'numLinksInSupportCategory'
};
const $fb28f2d21f03975f$export$b101d8f25cc16679 = [
    $fb28f2d21f03975f$export$4c00bbfcc0ecf975,
    $fb28f2d21f03975f$export$f4e280770913e10f,
    $fb28f2d21f03975f$export$a6d4661a542d168f,
    $fb28f2d21f03975f$export$257af46c9923adf8,
    $fb28f2d21f03975f$export$d3d779bdc5757c39,
    $fb28f2d21f03975f$export$1909a2cc48b27b53
];
const $fb28f2d21f03975f$export$890bc5a26a499c1d = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return (defaultCategoryInfo)=>formatMessage(defaultCategoryInfo.i18nMessage);
};
const $fb28f2d21f03975f$export$ec6234b435e23f80 = (categoryName)=>{
    const formatCategoryName = $fb28f2d21f03975f$export$890bc5a26a499c1d();
    // This is a temporary approach that will fall back to a generic icon if the placeholder was created in a different
    // locale from the one it's being viewed in. A more robust enum-based approach should be used once related work items
    // are migrated out of Data Depot and into ERS.
    const defaultCategory = $fb28f2d21f03975f$export$b101d8f25cc16679.find((category)=>formatCategoryName(category) === categoryName);
    return defaultCategory?.placeholderIcon ? defaultCategory.placeholderIcon : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9Hnkr.GenericPlusGlyph), null);
};

});
parcelRegister("1UTIx", function(module, exports) {
$parcel$export(module.exports, "DocumentPlusGlyph", () => $b1c174b82e288444$export$95d5a31c5e54a0d2);
// eslint-disable-next-line jira/restricted/react-component-props

var $eJOHy = parcelRequire("eJOHy");
const $b1c174b82e288444$export$95d5a31c5e54a0d2 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24px",
        height: "24px",
        viewBox: "7.5 0.5 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("g", {
        clipPath: "url(#clip0_10645_15672)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("rect", {
        width: "16",
        height: "16",
        transform: "translate(8 8)",
        fill: "white",
        fillOpacity: "0.01"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M17.0619 8H10C9.46957 8 8.96086 8.21071 8.58579 8.58579C8.21071 8.96086 8 9.46957 8 10V22C8 22.5304 8.21071 23.0391 8.58579 23.4142C8.96086 23.7893 9.46957 24 10 24H22C22.5304 24 23.0391 23.7893 23.4142 23.4142C23.7893 23.0391 24 22.5304 24 22V14.9381C22.365 14.7342 20.8832 14.037 19.7084 13H12C11.7348 13 11.4804 12.8946 11.2929 12.7071C11.1054 12.5196 11 12.2652 11 12C11 11.7348 11.1054 11.4804 11.2929 11.2929C11.4804 11.1054 11.7348 11 12 11H18.0703C17.5478 10.0968 17.1968 9.08194 17.0619 8ZM11.2929 15.2929C11.4804 15.1054 11.7348 15 12 15H20C20.2652 15 20.5196 15.1054 20.7071 15.2929C20.8946 15.4804 21 15.7348 21 16C21 16.2652 20.8946 16.5196 20.7071 16.7071C20.5196 16.8946 20.2652 17 20 17H12C11.7348 17 11.4804 16.8946 11.2929 16.7071C11.1054 16.5196 11 16.2652 11 16C11 15.7348 11.1054 15.4804 11.2929 15.2929ZM11.2929 19.2929C11.4804 19.1054 11.7348 19 12 19H16C16.2652 19 16.5196 19.1054 16.7071 19.2929C16.8946 19.4804 17 19.7348 17 20C17 20.2652 16.8946 20.5196 16.7071 20.7071C16.5196 20.8946 16.2652 21 16 21H12C11.7348 21 11.4804 20.8946 11.2929 20.7071C11.1054 20.5196 11 20.2652 11 20C11 19.7348 11.1054 19.4804 11.2929 19.2929Z",
        fill: "#0C66E4"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("rect", {
        x: "19",
        y: "1",
        width: "12",
        height: "12",
        rx: "6",
        fill: "#22A06B"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M25.5 6.5V4.5C25.5 4.36739 25.4473 4.24021 25.3536 4.14645C25.2598 4.05268 25.1326 4 25 4C24.8674 4 24.7402 4.05268 24.6464 4.14645C24.5527 4.24021 24.5 4.36739 24.5 4.5V6.5H22.5C22.3674 6.5 22.2402 6.55268 22.1464 6.64645C22.0527 6.74021 22 6.86739 22 7C22 7.13261 22.0527 7.25979 22.1464 7.35355C22.2402 7.44732 22.3674 7.5 22.5 7.5H24.5V9.5C24.5 9.63261 24.5527 9.75979 24.6464 9.85355C24.7402 9.94732 24.8674 10 25 10C25.1326 10 25.2598 9.94732 25.3536 9.85355C25.4473 9.75979 25.5 9.63261 25.5 9.5V7.5H27.5C27.6326 7.5 27.7598 7.44732 27.8536 7.35355C27.9473 7.25979 28 7.13261 28 7C28 6.86739 27.9473 6.74021 27.8536 6.64645C27.7598 6.55268 27.6326 6.5 27.5 6.5H25.5Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("clipPath", {
        id: "clip0_10645_15672"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("rect", {
        width: "16",
        height: "16",
        fill: "white",
        transform: "translate(8 8)"
    }))));

});

parcelRegister("9Hnkr", function(module, exports) {
$parcel$export(module.exports, "GenericPlusGlyph", () => $2d2140e0d74845e5$export$e68c0551132b814f);
// eslint-disable-next-line jira/restricted/react-component-props

var $eJOHy = parcelRequire("eJOHy");
const $2d2140e0d74845e5$export$e68c0551132b814f = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24px",
        height: "24px",
        viewBox: "7.5 0.5 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("g", {
        clipPath: "url(#clip0_10645_15679)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("rect", {
        width: "16",
        height: "16",
        transform: "translate(8 8)",
        fill: "white",
        fillOpacity: "0.01"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M17.0619 8H9.994C8.895 8 8 8.893 8 9.994V22.006C8.00026 22.5348 8.21043 23.0418 8.58432 23.4157C8.95821 23.7896 9.46524 23.9997 9.994 24H22.006C22.5348 23.9997 23.0418 23.7896 23.4157 23.4157C23.7896 23.0418 23.9997 22.5348 24 22.006V14.9381C20.3813 14.4869 17.5131 11.6187 17.0619 8ZM13.333 11H16H16.782C16.9614 10.9998 17.139 11.0359 17.3041 11.106C17.4692 11.1761 17.6185 11.2788 17.743 11.408L19.907 13.658C19.9667 13.7201 20 13.8029 20 13.889V14.792C20 14.975 19.851 15.125 19.667 15.125H17.333C16.597 15.125 16 14.528 16 13.792V12.378H13.333V19.622H18.667V16H20V19.622C20 20.383 19.403 21 18.667 21H13.333C12.597 21 12 20.382 12 19.622V12.378C12 11.617 12.597 11 13.333 11Z",
        fill: "#5E6C84"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("rect", {
        x: "19",
        y: "1",
        width: "12",
        height: "12",
        rx: "6",
        fill: "#22A06B"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M25.5 6.5V4.5C25.5 4.36739 25.4473 4.24021 25.3536 4.14645C25.2598 4.05268 25.1326 4 25 4C24.8674 4 24.7402 4.05268 24.6464 4.14645C24.5527 4.24021 24.5 4.36739 24.5 4.5V6.5H22.5C22.3674 6.5 22.2402 6.55268 22.1464 6.64645C22.0527 6.74021 22 6.86739 22 7C22 7.13261 22.0527 7.25979 22.1464 7.35355C22.2402 7.44732 22.3674 7.5 22.5 7.5H24.5V9.5C24.5 9.63261 24.5527 9.75979 24.6464 9.85355C24.7402 9.94732 24.8674 10 25 10C25.1326 10 25.2598 9.94732 25.3536 9.85355C25.4473 9.75979 25.5 9.63261 25.5 9.5V7.5H27.5C27.6326 7.5 27.7598 7.44732 27.8536 7.35355C27.9473 7.25979 28 7.13261 28 7C28 6.86739 27.9473 6.74021 27.8536 6.64645C27.7598 6.55268 27.6326 6.5 27.5 6.5H25.5Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("clipPath", {
        id: "clip0_10645_15679"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("rect", {
        width: "16",
        height: "16",
        fill: "white",
        transform: "translate(8 8)"
    }))));

});

parcelRegister("9Nt5j", function(module, exports) {
$parcel$export(module.exports, "PresentationPlusGlyph", () => $af0b5bb4b0020c63$export$4026a3889e667c70);
// eslint-disable-next-line jira/restricted/react-component-props

var $eJOHy = parcelRequire("eJOHy");
const $af0b5bb4b0020c63$export$4026a3889e667c70 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24px",
        height: "24px",
        viewBox: "7.5 0.5 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("g", {
        clipPath: "url(#clip0_10645_15686)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("rect", {
        width: "16",
        height: "16",
        transform: "translate(8 8)",
        fill: "white",
        fillOpacity: "0.01"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M17.0619 8H10C9.46957 8 8.96086 8.21071 8.58579 8.58579C8.21071 8.96086 8 9.46957 8 10V22C8 22.5304 8.21071 23.0391 8.58579 23.4142C8.96086 23.7893 9.46957 24 10 24H22C22.5304 24 23.0391 23.7893 23.4142 23.4142C23.7893 23.0391 24 22.5304 24 22V14.9381C22.9181 14.8032 21.9032 14.4522 21 13.9297V20C21 20.2652 20.8946 20.5196 20.7071 20.7071C20.5196 20.8946 20.2652 21 20 21C19.7348 21 19.4804 20.8946 19.2929 20.7071C19.1054 20.5196 19 20.2652 19 20V12.2916C17.963 11.1168 17.2658 9.635 17.0619 8ZM15.2929 14.2929C15.4804 14.1054 15.7348 14 16 14C16.2652 14 16.5196 14.1054 16.7071 14.2929C16.8946 14.4804 17 14.7348 17 15V20C17 20.2652 16.8946 20.5196 16.7071 20.7071C16.5196 20.8946 16.2652 21 16 21C15.7348 21 15.4804 20.8946 15.2929 20.7071C15.1054 20.5196 15 20.2652 15 20V15C15 14.7348 15.1054 14.4804 15.2929 14.2929ZM11.2929 17.2929C11.4804 17.1054 11.7348 17 12 17C12.2652 17 12.5196 17.1054 12.7071 17.2929C12.8946 17.4804 13 17.7348 13 18V20C13 20.2652 12.8946 20.5196 12.7071 20.7071C12.5196 20.8946 12.2652 21 12 21C11.7348 21 11.4804 20.8946 11.2929 20.7071C11.1054 20.5196 11 20.2652 11 20V18C11 17.7348 11.1054 17.4804 11.2929 17.2929Z",
        fill: "#8270DB"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("rect", {
        x: "19",
        y: "1",
        width: "12",
        height: "12",
        rx: "6",
        fill: "#22A06B"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M25.5 6.5V4.5C25.5 4.36739 25.4473 4.24021 25.3536 4.14645C25.2598 4.05268 25.1326 4 25 4C24.8674 4 24.7402 4.05268 24.6464 4.14645C24.5527 4.24021 24.5 4.36739 24.5 4.5V6.5H22.5C22.3674 6.5 22.2402 6.55268 22.1464 6.64645C22.0527 6.74021 22 6.86739 22 7C22 7.13261 22.0527 7.25979 22.1464 7.35355C22.2402 7.44732 22.3674 7.5 22.5 7.5H24.5V9.5C24.5 9.63261 24.5527 9.75979 24.6464 9.85355C24.7402 9.94732 24.8674 10 25 10C25.1326 10 25.2598 9.94732 25.3536 9.85355C25.4473 9.75979 25.5 9.63261 25.5 9.5V7.5H27.5C27.6326 7.5 27.7598 7.44732 27.8536 7.35355C27.9473 7.25979 28 7.13261 28 7C28 6.86739 27.9473 6.74021 27.8536 6.64645C27.7598 6.55268 27.6326 6.5 27.5 6.5H25.5Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("clipPath", {
        id: "clip0_10645_15686"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("rect", {
        width: "16",
        height: "16",
        fill: "white",
        transform: "translate(8 8)"
    }))));

});

parcelRegister("hrRds", function(module, exports) {
$parcel$export(module.exports, "default", () => $a2b488bfec1dee4a$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $a2b488bfec1dee4a$var$messages = (0, $7qGN1.defineMessages)({
    testingCategory: {
        "id": "software-releases-version-related-work-categories.common.default-categories.testing-category",
        "defaultMessage": "Testing"
    },
    rolloutCategory: {
        "id": "software-releases-version-related-work-categories.common.default-categories.rollout-category",
        "defaultMessage": "Rollout"
    },
    analyticsCategory: {
        "id": "software-releases-version-related-work-categories.common.default-categories.analytics-category",
        "defaultMessage": "Analytics"
    },
    communicationCategory: {
        "id": "software-releases-version-related-work-categories.common.default-categories.communication-category",
        "defaultMessage": "Communication"
    },
    developmentCategory: {
        "id": "software-releases-version-related-work-categories.common.default-categories.development-category",
        "defaultMessage": "Development"
    },
    supportCategory: {
        "id": "software-releases-version-related-work-categories.common.default-categories.support-category",
        "defaultMessage": "Support"
    }
});
var $a2b488bfec1dee4a$export$2e2bcd8739ae039 = $a2b488bfec1dee4a$var$messages;

});



parcelRegister("abMBH", function(module, exports) {
$parcel$export(module.exports, "CategoryFilter", () => $7bca9e49ad4c0fc5$export$cb2cc3e02411c0f4);

var $g4Xdd = parcelRequire("g4Xdd");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $6Abnv = parcelRequire("6Abnv");

var $j4oe4 = parcelRequire("j4oe4");

var $lRq8t = parcelRequire("lRq8t");

var $iHSda = parcelRequire("iHSda");

var $aHo7h = parcelRequire("aHo7h");

var $f7ahm = parcelRequire("f7ahm");
const $7bca9e49ad4c0fc5$export$c50c7c4a5ff445b1 = 5;
const $7bca9e49ad4c0fc5$export$cb2cc3e02411c0f4 = ({ relatedWorkEdges: relatedWorkEdges, selectedCategory: selectedCategory, onCategorySelected: onCategorySelected })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const tabRefs = (0, $eJOHy.useRef)([]); // State to keep track of which tab has keyboard focus
    const [focusedIndex, setFocusedIndex] = (0, $eJOHy.useState)(-1);
    const edges = (0, $j4oe4.useFragment)((0, $g4Xdd.default), relatedWorkEdges);
    const edgesByCategory = (0, (/*@__PURE__*/$parcel$interopDefault($6Abnv)))(edges, (edge)=>edge?.node.category);
    const sortedCategoriesWithCounts = Object.keys(edgesByCategory).map((category)=>[
            category,
            edgesByCategory[category].length
        ]).sort(([categoryA], [categoryB])=>categoryA.localeCompare(categoryB));
    const isknownCategory = selectedCategory === undefined || sortedCategoriesWithCounts.some(([category])=>category === selectedCategory); // If the selected category is unknown, un-select it (the selected category comes from
    // a query param, so we can't trust it will always be valid).
    (0, $eJOHy.useEffect)(()=>{
        if (!isknownCategory) // eslint-disable-next-line react-you-might-not-need-an-effect/no-pass-data-to-parent
        onCategorySelected(undefined);
    }, [
        isknownCategory,
        onCategorySelected
    ]);
    const categoriesWithCountWithinThreshold = sortedCategoriesWithCounts.slice(0, $7bca9e49ad4c0fc5$export$c50c7c4a5ff445b1);
    const categoriesWithCountAfterThreshold = sortedCategoriesWithCounts.slice($7bca9e49ad4c0fc5$export$c50c7c4a5ff445b1);
    const allCategoryOptions = (0, $eJOHy.useMemo)(()=>[
            {
                label: formatMessage((0, $aHo7h.default).all),
                category: undefined
            },
            ...categoriesWithCountWithinThreshold.map(([category])=>({
                    label: category,
                    category: category
                }))
        ], [
        formatMessage,
        categoriesWithCountWithinThreshold
    ]); // Find the index of the selected category
    const selectedIndex = allCategoryOptions.findIndex((option)=>option.category === selectedCategory); // Handle keyboard navigation. Tabs should be navigable with arrow keys
    const handleKeyDown = (0, $eJOHy.useCallback)((e)=>{
        const tabCount = allCategoryOptions.length;
        let newIndex = focusedIndex;
        switch(e.key){
            case 'ArrowRight':
            case 'ArrowDown':
                e.preventDefault();
                newIndex = (focusedIndex + 1) % tabCount;
                break;
            case 'ArrowLeft':
            case 'ArrowUp':
                e.preventDefault();
                newIndex = (focusedIndex - 1 + tabCount) % tabCount;
                break;
            case 'Home':
                e.preventDefault();
                newIndex = 0;
                break;
            case 'End':
                e.preventDefault();
                newIndex = tabCount - 1;
                break;
            case 'Enter':
            case ' ':
                e.preventDefault();
                if (focusedIndex >= 0 && focusedIndex < tabCount) onCategorySelected(allCategoryOptions[focusedIndex].category);
                return;
            default:
                return;
        }
        // Update focused index and set focus
        setFocusedIndex(newIndex);
        tabRefs.current[newIndex]?.focus(); // Select the tab when navigating with arrow keys
        if (newIndex >= 0 && newIndex < tabCount) onCategorySelected(allCategoryOptions[newIndex].category);
    }, [
        allCategoryOptions,
        focusedIndex,
        onCategorySelected
    ]);
    // Update refs array when categories change
    (0, $eJOHy.useEffect)(()=>{
        tabRefs.current = tabRefs.current.slice(0, allCategoryOptions.length);
    }, [
        allCategoryOptions.length
    ]); // Set initial focus to the selected tab when the component mounts
    (0, $eJOHy.useEffect)(()=>{
        if (selectedIndex >= 0) setFocusedIndex(selectedIndex);
    }, [
        selectedIndex
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($7bca9e49ad4c0fc5$var$Container, {
        onKeyDown: handleKeyDown,
        "aria-label": formatMessage((0, $aHo7h.default).ariaFilterLabel)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($7bca9e49ad4c0fc5$var$Container, {
        role: "tablist"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iHSda.Lozenge), {
        label: formatMessage((0, $aHo7h.default).all),
        count: edges.length ?? 0,
        isSelected: selectedCategory === undefined,
        onClick: ()=>onCategorySelected(undefined),
        tabIndex: selectedCategory === undefined ? 0 : -1,
        "aria-selected": selectedCategory === undefined,
        role: "tab",
        ref: (el)=>{
            tabRefs.current[0] = el;
        }
    }), categoriesWithCountWithinThreshold.map(([category, count], index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iHSda.Lozenge), {
            key: category,
            label: category,
            count: count,
            isSelected: category === selectedCategory,
            onClick: ()=>onCategorySelected(category),
            tabIndex: category === selectedCategory ? 0 : -1,
            "aria-selected": category === selectedCategory,
            ref: (el)=>{
                tabRefs.current[index + 1] = el;
            },
            role: "tab"
        }))), categoriesWithCountAfterThreshold.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $f7ahm.MoreLozengeAsync), {
        categories: categoriesWithCountAfterThreshold.map(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        ([category, count])=>({
                label: category,
                count: count,
                isSelected: category === selectedCategory,
                onClick: ()=>onCategorySelected(category),
                tabIndex: category === selectedCategory ? 0 : -1,
                'aria-selected': category === selectedCategory
            }))
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7bca9e49ad4c0fc5$var$Container = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_zulpu2gc _1e0c1txw _1n261g80",
            __cmplp.className
        ])
    });
});

});
parcelRegister("g4Xdd", function(module, exports) {
$parcel$export(module.exports, "default", () => $934c9a719bcd7cc1$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<37fd70250cf323faed8eaab1c7b77e6a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $934c9a719bcd7cc1$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": {
        "plural": true
    },
    "name": "categoryFilter_softwareReleasesVersionRelatedWork",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "kind": "ScalarField",
                            "name": "category"
                        },
                        "action": "NONE",
                        "path": "node.category"
                    }
                ]
            },
            "action": "NONE",
            "path": "node"
        }
    ],
    "type": "JiraVersionRelatedWorkV2Edge"
};
$934c9a719bcd7cc1$var$node.hash = "26b1d568eba141b6bfe3000d32fec7e5";
var $934c9a719bcd7cc1$export$2e2bcd8739ae039 = $934c9a719bcd7cc1$var$node;

});

parcelRegister("iHSda", function(module, exports) {
$parcel$export(module.exports, "Lozenge", () => $98a9023cd06a9d9d$export$a31cbe1bf5463979);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $ftN6c = parcelRequire("ftN6c");

var $lRq8t = parcelRequire("lRq8t");

var $kRgKj = parcelRequire("kRgKj");
const $98a9023cd06a9d9d$export$a31cbe1bf5463979 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ label: label, count: count, isSelected: isSelected, onClick: onClick, tabIndex: tabIndex = 0, role: role, 'aria-selected': ariaSelected }, ref)=>{
    const { formatNumber: formatNumber } = (0, $lRq8t.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($98a9023cd06a9d9d$var$Button, {
        ref: ref,
        role: role,
        title: label,
        "aria-selected": ariaSelected,
        "aria-controls": `related-work-tab-${label.replaceAll(' ', '-')}`,
        id: `related-work-tab-${label.replaceAll(' ', '-')}`,
        isSelected: isSelected,
        tabIndex: tabIndex,
        onKeyDown: (e)=>{
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                onClick();
            }
        },
        onClick: ()=>{
            onClick();
            (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'lozenge'
            }), 'relatedWorkCategory');
        },
        "data-testid": "software-releases-version-related-work.ui.category-filter.lozenge.button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($98a9023cd06a9d9d$var$Label, null, label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($98a9023cd06a9d9d$var$Count, null, formatNumber(count)));
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $98a9023cd06a9d9d$var$Button = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isSelected: isSelected, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rko1rr0 _11c8dcr7 _1dqoglyw _1e0c1txw _ca0q1b66 _u5f3u2gc _n3td1b66 _19bvu2gc _80omtlke _vwz4f6fq",
            __cmplp.isSelected ? "_bfhk15s3" : "_bfhki8nm",
            __cmplp.isSelected ? "_syazu3tg" : "_syazazsu",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $98a9023cd06a9d9d$var$Label = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _1e0c1o8l _p12f1kdj _o5721q9c _1bto1l2s",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $98a9023cd06a9d9d$var$Count = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_k48pmoej _19bv12x7",
            __cmplp.className
        ])
    });
});

});

parcelRegister("aHo7h", function(module, exports) {
$parcel$export(module.exports, "default", () => $119b7b148ff8b32e$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $119b7b148ff8b32e$var$messages = (0, $7qGN1.defineMessages)({
    all: {
        "id": "software-releases-version-related-work.category-filter.all",
        "defaultMessage": "All"
    },
    ariaFilterLabel: {
        "id": "software-releases-version-related-work.category-filter.aria-filter-label",
        "defaultMessage": "Filter related work by category"
    }
});
var $119b7b148ff8b32e$export$2e2bcd8739ae039 = $119b7b148ff8b32e$var$messages;

});

parcelRegister("f7ahm", function(module, exports) {
$parcel$export(module.exports, "MoreLozengeAsync", () => $d55b214520cf96c3$export$1e468fbbda90a7b4);

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $2imLM = parcelRequire("2imLM");

var $bQWwW = parcelRequire("bQWwW");

var $i8fNc = parcelRequire("i8fNc");

var $6L7NK = parcelRequire("6L7NK");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $d55b214520cf96c3$var$LazyMoreLozenge = (0, $bQWwW.lazy)(()=>Promise.resolve((parcelRequire("i8fNc"))).then((mod)=>mod.MoreLozenge), {
    moduleId: "./src/packages/releases/version-related-work/src/ui/category-filter/more-lozenge/MoreLozenge.tsx"
});
const $d55b214520cf96c3$export$1e468fbbda90a7b4 = (props)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { categories: categories } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "jira-software-releases-version-detail-related-work-more-lozenge",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i8fNc.LozengeButton), {
            isSelected: categories.some((category)=>category.isSelected)
        }, formatMessage((0, $6L7NK.default).moreButtonLabel, {
            count: categories.length
        }))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d55b214520cf96c3$var$LazyMoreLozenge, props));
};

});
parcelRegister("i8fNc", function(module, exports) {
$parcel$export(module.exports, "MoreLozenge", () => $3da92a60ee564738$export$394f480a87f8efa7);
$parcel$export(module.exports, "LozengeButton", () => $3da92a60ee564738$export$2c8fc3c10740b2a5);
/* MoreLozenge.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $ftN6c = parcelRequire("ftN6c");

var $7rjYb = parcelRequire("7rjYb");
var $1pKTL = parcelRequire("1pKTL");
var $6TtH3 = parcelRequire("6TtH3");

var $4cTDP = parcelRequire("4cTDP");

var $lRq8t = parcelRequire("lRq8t");

var $kRgKj = parcelRequire("kRgKj");

var $6L7NK = parcelRequire("6L7NK");
const $3da92a60ee564738$export$394f480a87f8efa7 = ({ categories: categories, defaultOpen: defaultOpen = false })=>{
    const { formatNumber: formatNumber, formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7rjYb.default), {
        defaultOpen: defaultOpen,
        trigger: ({ triggerRef: triggerRef, ...otherProps })=>{
            const { isSelected: isDropdownOpen } = otherProps;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3da92a60ee564738$export$2c8fc3c10740b2a5, {
                ...otherProps,
                onKeyDown: (e)=>{
                    if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        otherProps.onClick?.(e);
                    }
                },
                "aria-haspopup": "true",
                isDropdownOpen: isDropdownOpen ?? false,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                ref: triggerRef,
                isSelected: categories.some((category)=>category.isSelected),
                "data-testid": "software-releases-version-related-work.ui.category-filter.more-lozenge.dropdown-trigger"
            }, formatMessage((0, $6L7NK.default).moreButtonLabel, {
                count: categories.length
            }));
        },
        shouldRenderToParent: (0, $4cTDP.fg)('should-render-to-parent-should-be-true-nova')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6TtH3.default), {
        id: "categories"
    }, categories.map(({ label: label, count: count, onClick: onClick, isSelected: isSelected })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1pKTL.default), {
            isSelected: isSelected,
            onClick: ()=>{
                onClick();
                (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({
                    action: 'clicked',
                    actionSubject: 'lozenge'
                }), 'relatedWorkCategory');
            },
            id: label,
            key: label,
            testId: "software-releases-version-related-work.ui.category-filter.more-lozenge.dropdown-item-button"
        }, label, " (", formatNumber(count), ")"))));
};
const $3da92a60ee564738$export$2c8fc3c10740b2a5 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isDropdownOpen: isDropdownOpen, isSelected: isSelected, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_qaiddo": (0, $awdRS.default)((()=>{
                // Nested ternary operator is needed, otherwise there's a bug that the first token is applied regardless of condition
                // eslint-disable-next-line no-nested-ternary
                return __cmplp.isDropdownOpen ? "var(--ds-background-neutral-bold, #292A2E)" : __cmplp.isSelected ? "var(--ds-background-selected, #E9F2FE)" // RLSS-2812 Replace color.background.neutral to color.background.accent.gray.subtlest
                 : "var(--ds-background-neutral, #0515240F)";
            })()),
            "--_xo2mew": (0, $awdRS.default)((()=>{
                // Nested ternary operator is needed, otherwise there's a bug that the first token is applied regardless of condition
                // eslint-disable-next-line no-nested-ternary
                return __cmplp.isDropdownOpen ? "var(--ds-text-inverse, #FFFFFF)" : __cmplp.isSelected ? "var(--ds-text-information, #1558BC)" : "var(--ds-text-subtlest, #6B6E76)";
            })())
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rko1rr0 _11c8dcr7 _1dqoglyw _1e0c1txw _ca0q1b66 _u5f3u2gc _n3td1b66 _19bvu2gc _80omtlke _bfhkyjay _syaz18v4 _vwz4f6fq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("6L7NK", function(module, exports) {
$parcel$export(module.exports, "default", () => $e0055ff04b5425e2$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $e0055ff04b5425e2$var$messages = (0, $7qGN1.defineMessages)({
    moreButtonLabel: {
        "id": "software-releases-version-related-work.category-filter.more-lozenge.more-button-label",
        "defaultMessage": "+{count} more"
    }
});
var $e0055ff04b5425e2$export$2e2bcd8739ae039 = $e0055ff04b5425e2$var$messages;

});




parcelRegister("YdBAX", function(module, exports) {
$parcel$export(module.exports, "RelatedWorkEmptyState", () => $2bbbcd1a38a8567a$export$eeabb037f6ceac15);

var $iCul3 = parcelRequire("iCul3");

var $i5mGf = parcelRequire("i5mGf");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $j4oe4 = parcelRequire("j4oe4");

var $goZPP = parcelRequire("goZPP");

var $806LH = parcelRequire("806LH");

var $lRq8t = parcelRequire("lRq8t");

var $b6bYe = parcelRequire("b6bYe");

var $l5MKM = parcelRequire("l5MKM");

var $fi1AK = parcelRequire("fi1AK");

var $1dvMC = parcelRequire("1dvMC");

var $9A9Mu = parcelRequire("9A9Mu");

var $j1Y8F = parcelRequire("j1Y8F");
const $2bbbcd1a38a8567a$export$eeabb037f6ceac15 = ({ jiraVersion: jiraVersion, relatedWorkEdges: relatedWorkEdges })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const addRelatedWorkExpFailed = (0, $b6bYe.useAddRelatedWorkExperienceFail)();
    const version = (0, $j4oe4.useFragment)((0, $i5mGf.default), jiraVersion);
    const edges = (0, $j4oe4.useFragment)((0, $iCul3.default), relatedWorkEdges);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2bbbcd1a38a8567a$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1dvMC.VersionRelatedWorkExperienceSuccessTracker), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("img", {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($9A9Mu))),
        width: 80,
        height: 71.45,
        alt: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("section", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $806LH.default), {
        as: "h3",
        size: "xsmall"
    }, formatMessage((0, $j1Y8F.default).emptyStateHeading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2bbbcd1a38a8567a$var$Description, null, formatMessage((0, $j1Y8F.default).emptyStateDescription))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fi1AK.ErrorBoundary), {
        id: "addRelatedPopupInEmptyState",
        fallback: "unmount",
        onError: (location, error)=>{
            addRelatedWorkExpFailed(location, error);
        }
    }, version.status != null && version.status !== 'ARCHIVED' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $l5MKM.AddRelatedWorkPopup), {
        jiraVersion: version,
        relatedWorkEdges: edges,
        renderTrigger: ({ triggerProps: triggerProps, onClick: onClick, isLoading: isLoading, onMouseOver: onMouseOver })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
                ...triggerProps,
                onClick: onClick,
                testId: isLoading ? undefined : 'software-releases-version-related-work.ui.empty-state.button',
                onMouseOver: onMouseOver
            }, formatMessage((0, $j1Y8F.default).add))
    })));
};
// RLSS-2812 color.border.bold might look better than color.border. Personally I feel that color.border is too subtle in Dark mode
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2bbbcd1a38a8567a$var$Container = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rko1mok _189e1dm9 _1dqogq9o _1h6d1l7x _1e0c1txw _4cvr1h6o _gy1p1ejb _19pkpxbi _ca0q1ejb _u5f31ejb _n3td1ejb _19bv1ejb",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2bbbcd1a38a8567a$var$Description = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_syaz1rpy _p12f1ffr",
            __cmplp.className
        ])
    });
});

});
parcelRegister("iCul3", function(module, exports) {
$parcel$export(module.exports, "default", () => $0c55f2de9eb39f2e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3933bc99277dd3082f972f5de4a18d40>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $0c55f2de9eb39f2e$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": {
        "plural": true
    },
    "name": "emptyState_softwareReleasesVersionRelatedWork_RelatedWorkEmptyState_relatedWorkEdges",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "async_softwareReleasesAddRelatedWorkToVersion_AddRelatedWorkPopup_relatedWorkEdges"
        }
    ],
    "type": "JiraVersionRelatedWorkV2Edge"
};
$0c55f2de9eb39f2e$var$node.hash = "93018a8cf1d1d8516c9bb5d6c022ae78";
var $0c55f2de9eb39f2e$export$2e2bcd8739ae039 = $0c55f2de9eb39f2e$var$node;

});

parcelRegister("i5mGf", function(module, exports) {
$parcel$export(module.exports, "default", () => $fcf3138585529e86$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2798bc7e1de0fb498b8952176e0d5284>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $fcf3138585529e86$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "emptyState_softwareReleasesVersionRelatedWork_RelatedWorkEmptyState_jiraVersion",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "async_softwareReleasesAddRelatedWorkToVersion_AddRelatedWorkPopup_jiraVersion"
        },
        {
            "kind": "ScalarField",
            "name": "status"
        }
    ],
    "type": "JiraVersion"
};
$fcf3138585529e86$var$node.hash = "8330954195b2fe0fa1d89b6b61b53975";
var $fcf3138585529e86$export$2e2bcd8739ae039 = $fcf3138585529e86$var$node;

});

parcelRegister("9A9Mu", function(module, exports) {
module.exports = new URL("documents-illustration.37d481a2.svg", import.meta.url).toString();

});

parcelRegister("j1Y8F", function(module, exports) {
$parcel$export(module.exports, "default", () => $cf11b8919d9f4427$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $cf11b8919d9f4427$var$messages = (0, $7qGN1.defineMessages)({
    emptyStateHeading: {
        "id": "software-releases-version-related-work.empty-state.empty-state-heading",
        "defaultMessage": "Start adding some related work"
    },
    emptyStateDescription: {
        "id": "software-releases-version-related-work.empty-state.empty-state-description",
        "defaultMessage": "Add the work that's needed to get ready for your release like designs, release notes, analytics dashboards, and more!"
    },
    add: {
        "id": "software-releases-version-related-work.empty-state.add",
        "defaultMessage": "Add related work"
    }
});
var $cf11b8919d9f4427$export$2e2bcd8739ae039 = $cf11b8919d9f4427$var$messages;

});


parcelRegister("3VMbq", function(module, exports) {
$parcel$export(module.exports, "default", () => $e24bc4ef65c2dc35$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $e24bc4ef65c2dc35$var$messages = (0, $7qGN1.defineMessages)({
    relatedWorkHeading: {
        "id": "software-releases-version-related-work.related-work-heading",
        "defaultMessage": "Related work"
    },
    addRelatedWork: {
        "id": "software-releases-version-related-work.add-related-work",
        "defaultMessage": "Add links, release notes, and more\u2026"
    },
    showMore: {
        "id": "software-releases-version-related-work.show-more",
        "defaultMessage": "Show {moreItemsCount} more"
    },
    showLess: {
        "id": "software-releases-version-related-work.show-less",
        "defaultMessage": "Show {moreItemsCount} less"
    }
});
var $e24bc4ef65c2dc35$export$2e2bcd8739ae039 = $e24bc4ef65c2dc35$var$messages;

});

parcelRegister("g4whS", function(module, exports) {
$parcel$export(module.exports, "RelatedWorkList", () => $5ec41f990d4f7f28$export$25137fc5a267c4a9);

var $eJOHy = parcelRequire("eJOHy");

var $2imLM = parcelRequire("2imLM");

var $bQWwW = parcelRequire("bQWwW");

var $7s8wN = parcelRequire("7s8wN");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $5ec41f990d4f7f28$var$LazyRelatedWorkList = (0, $bQWwW.lazy)(()=>(parcelRequire("id2As")).then((module)=>module.RelatedWorkList), {
    moduleId: "./src/packages/releases/version-related-work/src/ui/related-work-list/index.tsx"
});
const $5ec41f990d4f7f28$export$25137fc5a267c4a9 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "related-work-list",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7s8wN.SkeletonRelatedWorkList), {
            numLinks: props.relatedWorkEdges.length
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($5ec41f990d4f7f28$var$LazyRelatedWorkList, props));

});
parcelRegister("7s8wN", function(module, exports) {
$parcel$export(module.exports, "SkeletonRelatedWorkList", () => $94a701855eee9cb0$export$98236437a8dbfc1c);
/* SkeletonRelatedWorkList.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");
const $94a701855eee9cb0$export$98236437a8dbfc1c = ({ numLinks: numLinks })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($94a701855eee9cb0$var$TableWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($94a701855eee9cb0$var$RelatedWorkItemWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($94a701855eee9cb0$var$SkeletonRelatedWorkRowWrapper, null, [
        ...Array(numLinks)
    ].map((_, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($94a701855eee9cb0$var$RelatedWorkItemWrapper, {
            key: i
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($94a701855eee9cb0$var$SkeletonRelatedWorkIcon, {
            opacity: 1 - i * 0.2
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($94a701855eee9cb0$var$SkeletonRelatedWorkItemLarge, {
            opacity: 1 - i * 0.2
        })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($94a701855eee9cb0$var$SkeletonRelatedWorkRowWrapper, null, [
        ...Array(numLinks)
    ].map((_, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($94a701855eee9cb0$var$SkeletonRelatedWorkItemSmall, {
            key: i,
            opacity: 1 - i * 0.2
        })))));
const $94a701855eee9cb0$var$shimmer = null;
const $94a701855eee9cb0$var$SkeletonRelatedWorkItemStyles = null;
const $94a701855eee9cb0$var$verticalMargin = 15;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $94a701855eee9cb0$var$SkeletonRelatedWorkIcon = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_kn3dj": (0, $awdRS.default)(__cmplp.opacity)
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rko12b0 _18s81vn1 _ju258bk0 _5sagymdr _1o51q7pw _tip812c5 _1pglp3kn _1itk1pxg _12vemgnk _4t3iqslr _bfhkizff _j7hqw3o4 _1bsbqslr",
            __cmplp.opacity ? "_tzy41p15" : "_tzy4kb7n",
            __cmplp.className
        ])
    });
});
const $94a701855eee9cb0$var$SkeletonRelatedWorkItemLarge = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_kn3dj": (0, $awdRS.default)(__cmplp.opacity)
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rko12b0 _19pko7ao _2hwxidpf _otyro7ao _18u0idpf _ju258bk0 _5sagymdr _1o51q7pw _tip812c5 _1pglp3kn _1itk1pxg _12vemgnk _4t3iqslr _bfhkizff _j7hqw3o4 _1bsbpo3b",
            __cmplp.opacity ? "_tzy41p15" : "_tzy4kb7n",
            __cmplp.className
        ])
    });
});
const $94a701855eee9cb0$var$SkeletonRelatedWorkItemSmall = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_kn3dj": (0, $awdRS.default)(__cmplp.opacity)
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rko12b0 _18s81w5s _ju258bk0 _5sagymdr _1o51q7pw _tip812c5 _1pglp3kn _1itk1pxg _12vemgnk _4t3iqslr _bfhkizff _j7hqw3o4 _1bsb1ex1",
            __cmplp.opacity ? "_tzy41p15" : "_tzy4kb7n",
            __cmplp.className
        ])
    });
});
const $94a701855eee9cb0$var$TableWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1bsb1osq _1e0c1txw _kqswh2mm _2lx21bp4 _ca0qutpp",
            __cmplp.className
        ])
    });
});
const $94a701855eee9cb0$var$SkeletonRelatedWorkRowWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _2lx21bp4 _1bah1yb4 _19bv1b66 _1p571b66",
            __cmplp.className
        ])
    });
});
const $94a701855eee9cb0$var$RelatedWorkItemWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _1bah1yb4",
            __cmplp.className
        ])
    });
});

});

parcelRegister("id2As", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("fliVL"),
    $ewTvA("3iNiV")
]).then(()=>parcelRequire('7pxIK'));

});



parcelRegister("jRFpu", function(module, exports) {
$parcel$export(module.exports, "RelatedWorkLoadingSkeleton", () => $d9b8167d134a0695$export$d1ea41fcd84767c8);

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $3Wh6p = parcelRequire("3Wh6p");
var $dW738 = parcelRequire("dW738");
var $1DXK0 = parcelRequire("1DXK0");

var $jjS5D = parcelRequire("jjS5D");
const $d9b8167d134a0695$var$RelatedWorkItemSkeleton = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        xcss: $d9b8167d134a0695$var$relatedWorkWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dW738.default), {
        xcss: $d9b8167d134a0695$var$relatedWorkLeftWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jjS5D.default), {
        width: "24px",
        height: "24px",
        isShimmering: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dW738.default), {
        xcss: $d9b8167d134a0695$var$relatedWorkRightWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jjS5D.default), {
        width: "350px",
        height: "24px",
        isShimmering: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jjS5D.default), {
        width: "220px",
        height: "18px",
        isShimmering: true
    })));
const $d9b8167d134a0695$export$d1ea41fcd84767c8 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dW738.default), {
        xcss: $d9b8167d134a0695$var$headerSkeletonStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jjS5D.default), {
        width: "220px",
        height: "24px",
        isShimmering: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        xcss: $d9b8167d134a0695$var$categoryFilterRowStlyes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jjS5D.default), {
        isShimmering: true,
        borderRadius: 14,
        width: "52px",
        height: "26px"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jjS5D.default), {
        isShimmering: true,
        borderRadius: 14,
        width: "85px",
        height: "26px"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jjS5D.default), {
        isShimmering: true,
        borderRadius: 14,
        width: "125px",
        height: "26px"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jjS5D.default), {
        isShimmering: true,
        borderRadius: 14,
        width: "110px",
        height: "26px"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jjS5D.default), {
        isShimmering: true,
        borderRadius: 14,
        width: "110",
        height: "26px"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jjS5D.default), {
        isShimmering: true,
        borderRadius: 14,
        width: "70px",
        height: "26px"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dW738.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d9b8167d134a0695$var$RelatedWorkItemSkeleton, null)));
const $d9b8167d134a0695$var$headerSkeletonStyles = (0, $1DXK0.xcss)({
    marginTop: 'space.500',
    marginBottom: 'space.250'
});
const $d9b8167d134a0695$var$categoryFilterRowStlyes = (0, $1DXK0.xcss)({
    gap: 'space.100',
    marginBottom: 'space.150'
});
const $d9b8167d134a0695$var$relatedWorkWrapperStyles = (0, $1DXK0.xcss)({
    height: 'space.800'
});
const $d9b8167d134a0695$var$relatedWorkRightWrapperStyles = (0, $1DXK0.xcss)({
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    gap: 'space.150'
});
const $d9b8167d134a0695$var$relatedWorkLeftWrapperStyles = (0, $1DXK0.xcss)({
    width: '64px',
    height: '64px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
});

});

parcelRegister("iT6q7", function(module, exports) {
$parcel$export(module.exports, "AsyncVersionRichTextSection", () => $fc217104e1e43eb1$export$6803497461260cfa);

var $wTP8C = parcelRequire("wTP8C");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $j4oe4 = parcelRequire("j4oe4");

var $2imLM = parcelRequire("2imLM");

var $bQWwW = parcelRequire("bQWwW");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $fc217104e1e43eb1$var$LazyVersionRichTextSection = (0, $bQWwW.lazy)(()=>(parcelRequire("cnj9X")).then((module)=>module.VersionRichTextSection), {
    moduleId: "./src/packages/releases/version-rich-text-section/src/ui/index.tsx"
});
const $fc217104e1e43eb1$export$6803497461260cfa = ({ jiraVersion: jiraVersion })=>{
    const version = (0, $j4oe4.useFragment)((0, $wTP8C.default), jiraVersion);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "rich-text-section",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fc217104e1e43eb1$var$SkeletonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fc217104e1e43eb1$var$SkeletonItem, {
            width: "15%"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fc217104e1e43eb1$var$SkeletonItem, {
            width: "45%"
        }))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fc217104e1e43eb1$var$LazyVersionRichTextSection, {
        jiraVersion: version
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $fc217104e1e43eb1$var$SkeletonItem = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1gljcou": (0, $awdRS.default)(__cmplp.width)
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rkofajl _bfhkizff _4t3idlk8 _1bsb1rkg _19pkutpp",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $fc217104e1e43eb1$var$SkeletonWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _2lx21bp4 _1bah1y6m _19pk1ejb",
            __cmplp.className
        ])
    });
});

});
parcelRegister("wTP8C", function(module, exports) {
$parcel$export(module.exports, "default", () => $80236af785914d1b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f6be8816f0e078a42b8f843748f38b46>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $80236af785914d1b$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "async_softwareReleasesVersionRichTextSection_AsyncVersionRichTextSection",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "ui_softwareReleasesVersionRichTextSection_VersionRichTextSection"
        }
    ],
    "type": "JiraVersion"
};
$80236af785914d1b$var$node.hash = "d5a19fe58067365a8d3ea1743ac2c96d";
var $80236af785914d1b$export$2e2bcd8739ae039 = $80236af785914d1b$var$node;

});

parcelRegister("cnj9X", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("fliVL"),
    $ewTvA("4P0B3")
]).then(()=>parcelRequire('7iMXE'));

});


parcelRegister("7vBTU", function(module, exports) {
$parcel$export(module.exports, "IssueAssociatedDesignsExperienceStart", () => $0ce184bcee8f4d3c$export$81d77c7d61cbddef);
$parcel$export(module.exports, "IssueAssociatedDesignsExperienceSuccess", () => $0ce184bcee8f4d3c$export$709f489a7a70c461);
$parcel$export(module.exports, "useIssueAssociatedDesignsExperienceFail", () => $0ce184bcee8f4d3c$export$715c37bd4d0b2cba);

var $eJOHy = parcelRequire("eJOHy");

var $aqnJa = parcelRequire("aqnJa");

var $8Uqf3 = parcelRequire("8Uqf3");

var $4ctwv = parcelRequire("4ctwv");

var $lBYgs = parcelRequire("lBYgs");

var $1BZ8a = parcelRequire("1BZ8a");
const $0ce184bcee8f4d3c$var$EXPERIENCE_NAME = 'issueAssociatedDesigns';
const $0ce184bcee8f4d3c$var$ANALYTICS_SOURCE = 'versionDetails';
const $0ce184bcee8f4d3c$export$81d77c7d61cbddef = ()=>{
    const appEditions = (0, $1BZ8a.useAppEditions)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8Uqf3.ExperienceStart), {
        experienceId: "jiraVersionDetailsIssueAssociatedDesigns",
        experience: $0ce184bcee8f4d3c$var$EXPERIENCE_NAME,
        analyticsSource: $0ce184bcee8f4d3c$var$ANALYTICS_SOURCE,
        edition: appEditions.software,
        application: (0, $lBYgs.JIRA_SOFTWARE)
    });
};
const $0ce184bcee8f4d3c$export$709f489a7a70c461 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4ctwv.ExperienceSuccess), {
        experience: $0ce184bcee8f4d3c$var$EXPERIENCE_NAME
    });
const $0ce184bcee8f4d3c$export$715c37bd4d0b2cba = ()=>(0, $aqnJa.useExperienceFail)({
        experience: $0ce184bcee8f4d3c$var$EXPERIENCE_NAME
    });

});

parcelRegister("jcg48", function(module, exports) {
$parcel$export(module.exports, "IssueAssociatedDesigns", () => $724784ede7c9c6c2$export$891b244b5d2793aa);
$parcel$export(module.exports, "DesignSectionSkeleton", () => $724784ede7c9c6c2$export$b6a2d0e3927c95cf);

var $bwxkU = parcelRequire("bwxkU");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $j4oe4 = parcelRequire("j4oe4");

var $7q9BG = parcelRequire("7q9BG");

var $806LH = parcelRequire("806LH");

var $8nu6j = parcelRequire("8nu6j");
var $3Wh6p = parcelRequire("3Wh6p");
var $1DXK0 = parcelRequire("1DXK0");

var $lRq8t = parcelRequire("lRq8t");

var $kGj4V = parcelRequire("kGj4V");
var $eS29z = parcelRequire("eS29z");

var $7ZUH2 = parcelRequire("7ZUH2");

var $5KcEP = parcelRequire("5KcEP");

var $7vBTU = parcelRequire("7vBTU");

var $fOvtn = parcelRequire("fOvtn");

var $ipAgV = parcelRequire("ipAgV");

var $lyVNz = parcelRequire("lyVNz");
const $724784ede7c9c6c2$export$891b244b5d2793aa = ({ queryRef: queryRef })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { jira: { version: version } } = (0, $j4oe4.usePreloadedQuery)((0, $bwxkU.default), queryRef);
    // In real world this shouldn't happen, since this query won't be even executed when this happen by version detail's page main query
    if (version.__typename !== 'JiraVersion') throw new Error('Version query result is not VersionResult');
    const { totalCount: totalCount } = version.issueAssociatedDesigns;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kGj4V.ContextualAnalyticsData), {
        sourceName: "versionIssueAssociatedDesigns",
        sourceType: (0, $aa42ce8e355d58fa$export$f636b5b56f1d624a),
        attributes: {
            designsCount: totalCount
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7ZUH2.CollapsibleSection), {
        jiraVersion: version,
        renderBody: ()=>{
            if (totalCount === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ipAgV.EmptyState), null);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fOvtn.DesignCarousel), {
                jiraVersion: version
            });
        },
        renderHeader: (isCollapsed, onToggleClicked)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($724784ede7c9c6c2$var$HeaderWrapper, {
                onClick: onToggleClicked
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $806LH.default), {
                size: "small",
                as: "h2"
            }, formatMessage((0, $lyVNz.default).designSectionLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7q9BG.default), null, totalCount), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7ZUH2.CollapsibleToggleButton), {
                isCollapsed: isCollapsed,
                onClick: onToggleClicked
            })),
        uiType: "ISSUE_ASSOCIATED_DESIGNS"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7vBTU.IssueAssociatedDesignsExperienceSuccess), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eS29z.FireScreenAnalytics), null));
};
const $724784ede7c9c6c2$export$b6a2d0e3927c95cf = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($724784ede7c9c6c2$var$SkeletonItem, {
        width: "220px",
        height: "24px",
        margin: "44px 0 20px 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        xcss: $724784ede7c9c6c2$var$designCardsSkeletonWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5KcEP.DesignCardSkeleton), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5KcEP.DesignCardSkeleton), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5KcEP.DesignCardSkeleton), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5KcEP.DesignCardSkeleton), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5KcEP.DesignCardSkeleton), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5KcEP.DesignCardSkeleton), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        xcss: $724784ede7c9c6c2$var$crouselCounterStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($724784ede7c9c6c2$var$SkeletonItem, {
        width: "100px",
        height: "20px",
        margin: "20px 0 0 0"
    })));
const $724784ede7c9c6c2$var$designCardsSkeletonWrapperStyles = (0, $1DXK0.xcss)({
    gap: 'space.200',
    width: '100%',
    overflow: 'hidden',
    padding: 'space.050',
    marginTop: 'space.100'
});
const $724784ede7c9c6c2$var$crouselCounterStyles = (0, $1DXK0.xcss)({
    justifyContent: 'center',
    alignItems: 'center',
    height: '20px'
});
const $724784ede7c9c6c2$var$animationOptionStyles = null;
const $724784ede7c9c6c2$var$shimmer = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $724784ede7c9c6c2$var$SkeletonItem = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { margin: margin, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_8jvb0j": (0, $awdRS.default)(__cmplp.height),
            "--_1gljcou": (0, $awdRS.default)(__cmplp.width),
            "--_146ducd": (0, $awdRS.default)(`${__cmplp.margin}`)
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rko12b0 _18s8j3fp _ju258bk0 _5sagymdr _1o51q7pw _tip812c5 _1pglp3kn _1itk1pxg _12vemgnk _j7hqw3o4 _bfhkizff _4t3i1474 _1bsb1rkg",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $724784ede7c9c6c2$var$HeaderWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_zulpu2gc _1e0c1txw _2lx2vrvc _4cvr1h6o _1bah1y6m _80omtlke _19pk1jfw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("bwxkU", function(module, exports) {
$parcel$export(module.exports, "default", () => $8162161e3d540bfe$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3ae3efdf5ff1633f61a5fb1f56aa7df2>>
 * @relayHash b89922858b2af773f5745e807572963f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ad0719c42dbb9679eb14945f0da1b989acf96db76cad39643540ecdce4c84b0c
const $8162161e3d540bfe$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudAri"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "versionAri"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "versionAri"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v3 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 6
        },
        {
            "kind": "Literal",
            "name": "sort",
            "value": {
                "createdAt": {
                    "direction": "DESC",
                    "priority": 1
                }
            }
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "kind": "InlineFragment",
        "selections": [
            v5 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ui_versionIssueAssociatedDesigns_IssueAssociatedDesignsQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v1 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "ui_softwareReleasesCollapsibleUiToggle_CollapsibleSection"
                                                },
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "designCarousel_versionIssueAssociatedDesigns"
                                                },
                                                {
                                                    "kind": "RequiredField",
                                                    "field": {
                                                        "args": v3 /*: any*/ ,
                                                        "concreteType": "GraphStoreSimplifiedVersionAssociatedDesignConnection",
                                                        "kind": "LinkedField",
                                                        "name": "issueAssociatedDesigns",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v4 /*: any*/ ,
                                                                "action": "THROW",
                                                                "path": "jira.version.issueAssociatedDesigns.totalCount"
                                                            }
                                                        ],
                                                        "storageKey": "issueAssociatedDesigns(first:6,sort:{\"createdAt\":{\"direction\":\"DESC\",\"priority\":1}})"
                                                    },
                                                    "action": "THROW",
                                                    "path": "jira.version.issueAssociatedDesigns"
                                                }
                                            ],
                                            "type": "JiraVersion"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.version"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ui_versionIssueAssociatedDesigns_IssueAssociatedDesignsQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "version",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "collapsedUis"
                                        },
                                        v5 /*: any*/ ,
                                        {
                                            "args": v3 /*: any*/ ,
                                            "concreteType": "GraphStoreSimplifiedVersionAssociatedDesignConnection",
                                            "kind": "LinkedField",
                                            "name": "issueAssociatedDesigns",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "GraphStoreSimplifiedVersionAssociatedDesignEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v2 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v5 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "url"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "displayName"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "lastUpdated"
                                                                        },
                                                                        {
                                                                            "args": [
                                                                                {
                                                                                    "kind": "Variable",
                                                                                    "name": "id",
                                                                                    "variableName": "cloudAri"
                                                                                }
                                                                            ],
                                                                            "kind": "LinkedField",
                                                                            "name": "provider",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v2 /*: any*/ ,
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "logoUrl"
                                                                                },
                                                                                v5 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        {
                                                                            "args": [
                                                                                {
                                                                                    "kind": "Literal",
                                                                                    "name": "first",
                                                                                    "value": 2
                                                                                }
                                                                            ],
                                                                            "concreteType": "GraphStoreSimplifiedIssueAssociatedDesignInverseConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "associatedIssues",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "GraphStoreSimplifiedIssueAssociatedDesignInverseEdge",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "edges",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "node",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v5 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "key"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "webUrl"
                                                                                                        },
                                                                                                        {
                                                                                                            "args": [
                                                                                                                {
                                                                                                                    "kind": "Literal",
                                                                                                                    "name": "idsOrAliases",
                                                                                                                    "value": [
                                                                                                                        "issuetype",
                                                                                                                        "summary"
                                                                                                                    ]
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "Literal",
                                                                                                                    "name": "ignoreMissingFields",
                                                                                                                    "value": true
                                                                                                                }
                                                                                                            ],
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "fieldsByIdOrAlias",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                v2 /*: any*/ ,
                                                                                                                {
                                                                                                                    "kind": "InlineFragment",
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraIssueType",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "issueType",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "name"
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraAvatar",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "avatar",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "xsmall"
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                },
                                                                                                                                v5 /*: any*/ 
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ],
                                                                                                                    "type": "JiraIssueTypeField"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "InlineFragment",
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "text"
                                                                                                                        }
                                                                                                                    ],
                                                                                                                    "type": "JiraSingleLineTextField"
                                                                                                                },
                                                                                                                v5 /*: any*/ 
                                                                                                            ],
                                                                                                            "storageKey": "fieldsByIdOrAlias(idsOrAliases:[\"issuetype\",\"summary\"],ignoreMissingFields:true)"
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraIssue"
                                                                                                },
                                                                                                v2 /*: any*/ ,
                                                                                                v6 /*: any*/ 
                                                                                            ]
                                                                                        },
                                                                                        v5 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "storageKey": "associatedIssues(first:2)"
                                                                        }
                                                                    ],
                                                                    "type": "DevOpsDesign"
                                                                },
                                                                v6 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "cursor"
                                                        },
                                                        v5 /*: any*/ 
                                                    ]
                                                },
                                                v4 /*: any*/ ,
                                                {
                                                    "concreteType": "PageInfo",
                                                    "kind": "LinkedField",
                                                    "name": "pageInfo",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "endCursor"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "hasNextPage"
                                                        }
                                                    ]
                                                }
                                            ],
                                            "storageKey": "issueAssociatedDesigns(first:6,sort:{\"createdAt\":{\"direction\":\"DESC\",\"priority\":1}})"
                                        },
                                        {
                                            "args": v3 /*: any*/ ,
                                            "filters": [
                                                "sort"
                                            ],
                                            "handle": "connection",
                                            "key": "DesignSlider_issueAssociatedDesigns",
                                            "kind": "LinkedHandle",
                                            "name": "issueAssociatedDesigns"
                                        },
                                        {
                                            "args": v3 /*: any*/ ,
                                            "concreteType": "GraphStoreSimplifiedVersionAssociatedDesignConnection",
                                            "kind": "LinkedField",
                                            "name": "issueAssociatedDesigns",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ 
                                            ],
                                            "storageKey": "issueAssociatedDesigns(first:6,sort:{\"createdAt\":{\"direction\":\"DESC\",\"priority\":1}})"
                                        }
                                    ],
                                    "type": "JiraVersion"
                                },
                                v6 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "ad0719c42dbb9679eb14945f0da1b989acf96db76cad39643540ecdce4c84b0c",
            "metadata": {},
            "name": "ui_versionIssueAssociatedDesigns_IssueAssociatedDesignsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$8162161e3d540bfe$var$node.hash = "6385dc34956a666103b9e7e3b549a2e3";
var $8162161e3d540bfe$export$2e2bcd8739ae039 = $8162161e3d540bfe$var$node;

});

parcelRegister("5KcEP", function(module, exports) {
$parcel$export(module.exports, "DesignCardSkeleton", () => $19bdfb9d073d9f21$export$1743685a5725b0ae);
/* DesignCardSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $8nu6j = parcelRequire("8nu6j");
var $dW738 = parcelRequire("dW738");
var $1DXK0 = parcelRequire("1DXK0");

var $1R4YX = parcelRequire("1R4YX");
const $19bdfb9d073d9f21$export$1743685a5725b0ae = ({ onVisible: onVisible })=>{
    const onSetElementRef = (0, $1R4YX.useIntersectionObserver)({
        margin: 0,
        onIntersection: ()=>onVisible?.()
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $19bdfb9d073d9f21$var$cardContainerStyles,
        ref: onSetElementRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($19bdfb9d073d9f21$var$SkeletonItem, {
        width: "24px",
        height: "24px",
        margin: "0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dW738.default), {
        xcss: $19bdfb9d073d9f21$var$titleStackStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($19bdfb9d073d9f21$var$SkeletonItem, {
        width: "220px",
        height: "16px",
        margin: "2px 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($19bdfb9d073d9f21$var$SkeletonItem, {
        width: "80px",
        height: "12px",
        margin: "2px 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($19bdfb9d073d9f21$var$SkeletonItem, {
        width: "120px",
        height: "24px",
        margin: "12px 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($19bdfb9d073d9f21$var$SkeletonItem, {
        width: "50px",
        height: "12px",
        margin: "2px 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($19bdfb9d073d9f21$var$SkeletonItem, {
        width: "240px",
        height: "26px",
        margin: "5px 0"
    })));
};
const $19bdfb9d073d9f21$var$animationOptionStyles = null;
const $19bdfb9d073d9f21$var$shimmer = null;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $19bdfb9d073d9f21$var$SkeletonItem = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { margin: margin, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_8jvb0j": (0, $awdRS.default)(__cmplp.height),
            "--_1gljcou": (0, $awdRS.default)(__cmplp.width),
            "--_146ducd": (0, $awdRS.default)(`${__cmplp.margin}`)
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rko12b0 _18s8j3fp _ju258bk0 _5sagymdr _1o51q7pw _tip812c5 _1pglp3kn _1itk1pxg _12vemgnk _j7hqw3o4 _bfhkizff _4t3i1474 _1bsb1rkg",
            __cmplp.className
        ])
    });
});
const $19bdfb9d073d9f21$var$cardContainerStyles = (0, $1DXK0.xcss)({
    display: 'flex',
    border: '3px',
    paddingTop: 'space.100',
    paddingBottom: 'space.100',
    paddingLeft: 'space.150',
    paddingRight: 'space.150',
    boxShadow: 'elevation.shadow.raised'
});
const $19bdfb9d073d9f21$var$titleStackStyles = (0, $1DXK0.xcss)({
    flex: 1,
    marginLeft: 'space.100',
    overflow: 'hidden'
});

});
parcelRegister("1R4YX", function(module, exports) {
$parcel$export(module.exports, "useIntersectionObserver", () => $01379305a4b54492$export$a7395f9832c00176);

var $eJOHy = parcelRequire("eJOHy");
const $01379305a4b54492$export$a7395f9832c00176 = ({ margin: margin, threshold: threshold = 0, onIntersection: onIntersection })=>{
    const [observedElement, setObservedElement] = (0, $eJOHy.useState)(null);
    (0, $eJOHy.useEffect)(()=>{
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        if (observedElement === null || window.IntersectionObserver === undefined) return undefined;
        const observerCallback = (entries)=>entries.forEach(({ isIntersecting: isIntersecting, time: time })=>{
                if (isIntersecting) onIntersection(time);
            });
        const observer = new IntersectionObserver(observerCallback, {
            rootMargin: `${margin}px`,
            threshold: threshold
        });
        observer.observe(observedElement);
        return ()=>{
            observer.disconnect();
        };
    }, [
        observedElement,
        onIntersection,
        margin,
        threshold
    ]);
    return setObservedElement;
};

});


parcelRegister("fOvtn", function(module, exports) {
$parcel$export(module.exports, "DesignCarousel", () => $2881af12cd673580$export$f1038593ff0bfc1e);

var $k9Nan = parcelRequire("k9Nan");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $tGEEK = parcelRequire("tGEEK");

var $j4oe4 = parcelRequire("j4oe4");

var $ftN6c = parcelRequire("ftN6c");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $gMRLG = parcelRequire("gMRLG");

var $lRq8t = parcelRequire("lRq8t");

var $kRgKj = parcelRequire("kRgKj");


var $5KcEP = parcelRequire("5KcEP");

var $hdYLR = parcelRequire("hdYLR");

var $2Cc8I = parcelRequire("2Cc8I");

var $98t0G = parcelRequire("98t0G");
const $2881af12cd673580$var$getNumFullyRenderedCards = (carouselWidth)=>Math.floor(carouselWidth / (0, $bfc4c7a2a9799602$export$2796973bb2f51929)); // curPageNum: 0-based, returned number: 1-based(displayed to user)
const $2881af12cd673580$var$getCurPageStartEndNum = (fullyRenderedCardNum, curPageNum, totalCount)=>({
        currentStart: curPageNum * fullyRenderedCardNum + 1,
        currentEnd: totalCount >= (curPageNum + 1) * fullyRenderedCardNum ? (curPageNum + 1) * fullyRenderedCardNum : totalCount,
        lastPageNum: Math.ceil(totalCount / fullyRenderedCardNum) - 1
    });
const $2881af12cd673580$export$f1038593ff0bfc1e = ({ jiraVersion: jiraVersion })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const [carouselWidth, setCarouselWidth] = (0, $eJOHy.useState)(0);
    const [curPageNum, setCurPageNum] = (0, $eJOHy.useState)(0);
    const { data: data, hasNext: hasNext, loadNext: loadNext, isLoadingNext: isLoadingNext } = (0, $j4oe4.usePaginationFragment)((0, $k9Nan.default), jiraVersion);
    const designEdges = data.issueAssociatedDesigns?.edges ?? [];
    const designNodes = designEdges.filter(Boolean).map((edge)=>edge.node).filter(Boolean); // We only need to use the potentially inaccurate/outdated `totalCount` value from
    // the API if we don't have all the edges loaded.
    const totalCount = hasNext ? data.issueAssociatedDesigns.totalCount : designNodes?.length ?? 0;
    const numFullyRenderedCards = $2881af12cd673580$var$getNumFullyRenderedCards(carouselWidth);
    const carouselPageInfo = $2881af12cd673580$var$getCurPageStartEndNum(numFullyRenderedCards, curPageNum, totalCount);
    (0, $eJOHy.useEffect)(()=>{
        // This is for resize event, and due to resize carousel page becomes over the last page when width grows.
        if (carouselPageInfo.lastPageNum < curPageNum) setCurPageNum(carouselPageInfo.lastPageNum);
    }, [
        carouselPageInfo.lastPageNum,
        curPageNum
    ]);
    if (totalCount === 0) return null;
    const numCardSkeleton = totalCount - designNodes.length;
    const firePaginationAnalytics = (direction)=>(0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'designsPagination', {
            direction: direction
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $2881af12cd673580$var$wrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gMRLG.WidthObserver), {
        setWidth: setCarouselWidth
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2881af12cd673580$var$CarouselWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2881af12cd673580$var$CarouselSlider, {
        widthOffset: curPageNum * numFullyRenderedCards * ((0, $bfc4c7a2a9799602$export$2796973bb2f51929) + (0, $bfc4c7a2a9799602$export$c73e9b0a14b3993b))
    }, designNodes.map((designNode)=>// id shouldn't be null in real world. https://atlassian.slack.com/archives/C01E2MPPLE4/p1709250064060249
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2Cc8I.DesignCard), {
            key: designNode.id ?? '',
            devOpsDesign: designNode,
            jiraVersion: data
        })), hasNext && (0, (/*@__PURE__*/$parcel$interopDefault($tGEEK)))(numCardSkeleton).map((n)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5KcEP.DesignCardSkeleton), {
            key: n,
            onVisible: ()=>{
                if (!hasNext || isLoadingNext) return null;
                loadNext(6);
            }
        })))), numFullyRenderedCards < Math.max(totalCount, designNodes.length) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2881af12cd673580$var$ArrowWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hdYLR.Arrow), {
        direction: "LEFT",
        onClick: ()=>{
            if (curPageNum === 0) return;
            setCurPageNum(curPageNum - 1);
            firePaginationAnalytics('left');
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hdYLR.Arrow), {
        direction: "RIGHT",
        onClick: ()=>{
            if (carouselPageInfo.currentEnd >= totalCount) return;
            setCurPageNum(curPageNum + 1);
            firePaginationAnalytics('right');
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("p", {
        className: (0, $hcewu.default)([
            "_1e0c1txw _1bah1h6o _4cvr1h6o"
        ])
    }, formatMessage((0, $98t0G.default).carouselPageCount, {
        ...carouselPageInfo,
        totalCount: totalCount
    })));
};
const $2881af12cd673580$var$wrapperStyles = (0, $1DXK0.xcss)({
    width: '100%',
    position: 'relative',
    marginTop: 'space.300'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2881af12cd673580$var$ArrowWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_kqswstnw _154iidpf _1ltvidpf _1xi2idpf _94n5idpf _lcxvglyw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2881af12cd673580$var$CarouselWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _1e0c1txw _1bsb1osq _4cvr1fhb _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66 _vchhusvi",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2881af12cd673580$var$CarouselSlider = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { widthOffset: widthOffset, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_z0ie8w": (0, $awdRS.default)(`translateX(-${__cmplp.widthOffset}px)`)
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _zulppxbi _v5641cdp _1e0c1txw _1bsb1osq _4cvr1fhb _t9ec1jj4",
            __cmplp.className
        ])
    });
});
const $2881af12cd673580$var$pageCounterStyles = null;

});
parcelRegister("k9Nan", function(module, exports) {
$parcel$export(module.exports, "default", () => $7e5438840f73a2d9$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<044f2a1b50736a083aa773821be0554d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck

var $3WdIq = parcelRequire("3WdIq");
const $7e5438840f73a2d9$var$node = function() {
    var v0 = [
        "issueAssociatedDesigns"
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "argumentDefinitions": [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "after"
            },
            {
                "kind": "RootArgument",
                "name": "cloudAri"
            },
            {
                "defaultValue": 6,
                "kind": "LocalArgument",
                "name": "first"
            }
        ],
        "kind": "Fragment",
        "metadata": {
            "connection": [
                {
                    "count": "first",
                    "cursor": "after",
                    "direction": "forward",
                    "path": v0 /*: any*/ 
                }
            ],
            "refetch": {
                "connection": {
                    "forward": {
                        "count": "first",
                        "cursor": "after"
                    },
                    "backward": null,
                    "path": v0 /*: any*/ 
                },
                "fragmentPathInResult": [
                    "node"
                ],
                "operation": (0, $3WdIq.default),
                "identifierInfo": {
                    "identifierField": "id",
                    "identifierQueryVariableName": "id"
                }
            }
        },
        "name": "designCarousel_versionIssueAssociatedDesigns",
        "selections": [
            {
                "kind": "FragmentSpread",
                "name": "designCard_versionIssueAssociatedDesigns_jiraVersion"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "alias": "issueAssociatedDesigns",
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "sort",
                            "value": {
                                "createdAt": {
                                    "direction": "DESC",
                                    "priority": 1
                                }
                            }
                        }
                    ],
                    "concreteType": "GraphStoreSimplifiedVersionAssociatedDesignConnection",
                    "kind": "LinkedField",
                    "name": "__DesignSlider_issueAssociatedDesigns_connection",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "GraphStoreSimplifiedVersionAssociatedDesignEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v1 /*: any*/ ,
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "designCard_versionIssueAssociatedDesigns_devOpsDesign"
                                                }
                                            ],
                                            "type": "DevOpsDesign"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "cursor"
                                }
                            ]
                        },
                        {
                            "kind": "RequiredField",
                            "field": {
                                "kind": "ScalarField",
                                "name": "totalCount"
                            },
                            "action": "THROW",
                            "path": "issueAssociatedDesigns.totalCount"
                        },
                        {
                            "concreteType": "PageInfo",
                            "kind": "LinkedField",
                            "name": "pageInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "endCursor"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "hasNextPage"
                                }
                            ]
                        }
                    ],
                    "storageKey": "__DesignSlider_issueAssociatedDesigns_connection(sort:{\"createdAt\":{\"direction\":\"DESC\",\"priority\":1}})"
                },
                "action": "THROW",
                "path": "issueAssociatedDesigns"
            },
            v1 /*: any*/ 
        ],
        "type": "JiraVersion"
    };
}();
$7e5438840f73a2d9$var$node.hash = "7979312fd2183c859bc266fe0defac6d";
var $7e5438840f73a2d9$export$2e2bcd8739ae039 = $7e5438840f73a2d9$var$node;

});
parcelRegister("3WdIq", function(module, exports) {
$parcel$export(module.exports, "default", () => $8052321478a19745$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5cb0f9e844b8ed49be36f20a1c3e29ea>>
 * @relayHash f15bd8b5d1ef27139fdf753918230146
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3a775f0e0846c095fe7a545909336633e32a40abe3dbd41661e439df37e5d672
const $8052321478a19745$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "after"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudAri"
        },
        {
            "defaultValue": 6,
            "kind": "LocalArgument",
            "name": "first"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "id"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "id"
        }
    ], v2 = {
        "kind": "Variable",
        "name": "after",
        "variableName": "after"
    }, v3 = {
        "kind": "Variable",
        "name": "first",
        "variableName": "first"
    }, v4 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = [
        v2 /*: any*/ ,
        v3 /*: any*/ ,
        {
            "kind": "Literal",
            "name": "sort",
            "value": {
                "createdAt": {
                    "direction": "DESC",
                    "priority": 1
                }
            }
        }
    ], v7 = {
        "kind": "InlineFragment",
        "selections": [
            v5 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "versionDetailsDesignRefetchableQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ 
                            ],
                            "kind": "FragmentSpread",
                            "name": "designCarousel_versionIssueAssociatedDesigns"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "versionDetailsDesignRefetchableQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v4 /*: any*/ ,
                        v5 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "args": v6 /*: any*/ ,
                                    "concreteType": "GraphStoreSimplifiedVersionAssociatedDesignConnection",
                                    "kind": "LinkedField",
                                    "name": "issueAssociatedDesigns",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "GraphStoreSimplifiedVersionAssociatedDesignEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v4 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v5 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "url"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "displayName"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "lastUpdated"
                                                                },
                                                                {
                                                                    "args": [
                                                                        {
                                                                            "kind": "Variable",
                                                                            "name": "id",
                                                                            "variableName": "cloudAri"
                                                                        }
                                                                    ],
                                                                    "kind": "LinkedField",
                                                                    "name": "provider",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v4 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "logoUrl"
                                                                        },
                                                                        v5 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "args": [
                                                                        {
                                                                            "kind": "Literal",
                                                                            "name": "first",
                                                                            "value": 2
                                                                        }
                                                                    ],
                                                                    "concreteType": "GraphStoreSimplifiedIssueAssociatedDesignInverseConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "associatedIssues",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "GraphStoreSimplifiedIssueAssociatedDesignInverseEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v5 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "key"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "webUrl"
                                                                                                },
                                                                                                {
                                                                                                    "args": [
                                                                                                        {
                                                                                                            "kind": "Literal",
                                                                                                            "name": "idsOrAliases",
                                                                                                            "value": [
                                                                                                                "issuetype",
                                                                                                                "summary"
                                                                                                            ]
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "Literal",
                                                                                                            "name": "ignoreMissingFields",
                                                                                                            "value": true
                                                                                                        }
                                                                                                    ],
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "fieldsByIdOrAlias",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        v4 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraIssueType",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "issueType",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "name"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "concreteType": "JiraAvatar",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "avatar",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "xsmall"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        },
                                                                                                                        v5 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "type": "JiraIssueTypeField"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "text"
                                                                                                                }
                                                                                                            ],
                                                                                                            "type": "JiraSingleLineTextField"
                                                                                                        },
                                                                                                        v5 /*: any*/ 
                                                                                                    ],
                                                                                                    "storageKey": "fieldsByIdOrAlias(idsOrAliases:[\"issuetype\",\"summary\"],ignoreMissingFields:true)"
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraIssue"
                                                                                        },
                                                                                        v4 /*: any*/ ,
                                                                                        v7 /*: any*/ 
                                                                                    ]
                                                                                },
                                                                                v5 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "storageKey": "associatedIssues(first:2)"
                                                                }
                                                            ],
                                                            "type": "DevOpsDesign"
                                                        },
                                                        v7 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "cursor"
                                                },
                                                v5 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "totalCount"
                                        },
                                        {
                                            "concreteType": "PageInfo",
                                            "kind": "LinkedField",
                                            "name": "pageInfo",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "endCursor"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasNextPage"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "args": v6 /*: any*/ ,
                                    "filters": [
                                        "sort"
                                    ],
                                    "handle": "connection",
                                    "key": "DesignSlider_issueAssociatedDesigns",
                                    "kind": "LinkedHandle",
                                    "name": "issueAssociatedDesigns"
                                }
                            ],
                            "type": "JiraVersion"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "3a775f0e0846c095fe7a545909336633e32a40abe3dbd41661e439df37e5d672",
            "metadata": {},
            "name": "versionDetailsDesignRefetchableQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$8052321478a19745$var$node.hash = "7979312fd2183c859bc266fe0defac6d";
var $8052321478a19745$export$2e2bcd8739ae039 = $8052321478a19745$var$node;

});


parcelRegister("gMRLG", function(module, exports) {
$parcel$export(module.exports, "WidthObserver", () => $fc07c79ce5b93db8$export$b2ad68b9bc407b80);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $ghv3t = parcelRequire("ghv3t");
const $fc07c79ce5b93db8$export$b2ad68b9bc407b80 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).memo((props)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ghv3t.WidthDetectorObserver), {
        setWidth: props.setWidth,
        offscreen: props.offscreen
    });
});
var $fc07c79ce5b93db8$export$2e2bcd8739ae039 = $fc07c79ce5b93db8$export$b2ad68b9bc407b80;

});
parcelRegister("ghv3t", function(module, exports) {
$parcel$export(module.exports, "WidthDetectorObserver", () => $8fd70c84fe96dcaa$export$ff983d2a2b6112ea);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $fecNP = parcelRequire("fecNP");
const $8fd70c84fe96dcaa$export$ff983d2a2b6112ea = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).memo(({ setWidth: setWidth, offscreen: offscreen })=>{
    const [inViewRef, inView, target] = (0, $fecNP.useInView)({
        /* Optional options */ threshold: 0
    });
    const observer = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useRef(()=>{
        if (typeof window === 'undefined') return null;
        // https://github.com/DefinitelyTyped/DefinitelyTyped/pull/40909
        // @ts-ignore
        return new ResizeObserver((entries)=>{
            if (!Array.isArray(entries) || !entries.length) return;
            const { width: width } = entries[0].contentRect;
            setWidth(Math.round(width));
        });
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useEffect(()=>{
        const { current: currentObserver } = observer;
        const resizeObserver = currentObserver();
        if (resizeObserver === null) return;
        if (target) {
            if (inView || offscreen) resizeObserver.observe(target);
            else resizeObserver.unobserve(target);
        }
        return ()=>{
            resizeObserver.disconnect();
        };
    }, [
        target,
        inView,
        offscreen
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            display: 'block',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            width: '100%',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'absolute'
        },
        ref: inViewRef
    });
});

});
parcelRegister("fecNP", function(module, exports) {
$parcel$export(module.exports, "useInView", () => $838e57da8fce74d2$export$2f62ee6831462844);

var $eJOHy = parcelRequire("eJOHy");
function $838e57da8fce74d2$export$2f62ee6831462844(options = {}) {
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useRef();
    const observerInstance = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useRef();
    const [state, setState] = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useState({
        inView: false,
        entry: undefined,
        target: undefined
    });
    const { threshold: threshold, root: root, rootMargin: rootMargin } = options;
    const setRef = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback((node)=>{
        observerInstance.current = new IntersectionObserver((entries)=>{
            if (entries && entries.length) {
                const intersection = entries[0];
                const { isIntersecting: isIntersecting, intersectionRatio: intersectionRatio } = intersection;
                if (intersectionRatio >= 0) {
                    // Note: `0` will be used here when an array of numbers is passed as the threshold, which doesn't feel right
                    const numericThreshold = typeof threshold === 'number' ? threshold : 0;
                    let inView = intersectionRatio >= numericThreshold;
                    if (isIntersecting !== undefined) inView = inView && isIntersecting;
                    setState({
                        inView: inView,
                        entry: intersection,
                        target: node
                    });
                }
            }
        }, {
            threshold: threshold,
            root: root,
            rootMargin: rootMargin
        });
        if (ref.current) observerInstance.current.unobserve(ref.current);
        if (node) observerInstance.current.observe(node);
        // Store a reference to the node
        ref.current = node;
    }, [
        threshold,
        root,
        rootMargin
    ]);
    /**
	 * Unsubscribe IntersectionObserver before unmounting a component.
	 */ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useEffect(()=>{
        return ()=>{
            if (observerInstance.current && ref.current) observerInstance.current.unobserve(ref.current);
        };
    }, []);
    return [
        setRef,
        state.inView,
        state.target,
        state.entry
    ];
}

});



// in px
const $bfc4c7a2a9799602$export$2796973bb2f51929 = 360;
const $bfc4c7a2a9799602$export$c73e9b0a14b3993b = 16;

parcelRegister("hdYLR", function(module, exports) {
$parcel$export(module.exports, "Arrow", () => $b8aa6eeafa580482$export$21b07c8f274aebd5);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $aqu01 = parcelRequire("aqu01");

var $ePxSL = parcelRequire("ePxSL");

var $lRq8t = parcelRequire("lRq8t");

var $fImzJ = parcelRequire("fImzJ");
const $b8aa6eeafa580482$export$21b07c8f274aebd5 = ({ direction: direction, onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b8aa6eeafa580482$var$Wrapper, {
        onClick: onClick,
        direction: direction
    }, direction === 'LEFT' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aqu01))), {
        spacing: "spacious",
        label: formatMessage((0, $fImzJ.default).leftArrowlabel)
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ePxSL))), {
        spacing: "spacious",
        label: formatMessage((0, $fImzJ.default).rightArrowlabel)
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b8aa6eeafa580482$var$Wrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rkopb1k _19itglyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _11c81kw7 _12ji1r31 _1qu21kw7 _12y31o36 _lcxv1rj4 _kqswstnw _154ixncg _1bsb1ejb _4t3i1ejb _bfhk1j9a _syazi7uo _80omtlke _16qs130s _jomr19i6 _irr313ro",
            __cmplp.direction === 'LEFT' ? "_1ltvxmi2" : "_1ltv1wug",
            __cmplp.direction === 'RIGHT' ? "_1xi2xmi2" : "_1xi21wug",
            __cmplp.className
        ])
    });
});

});
parcelRegister("fImzJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $8101e38be260867c$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $8101e38be260867c$var$messages = (0, $7qGN1.defineMessages)({
    leftArrowlabel: {
        "id": "version-issue-associated-designs.design-carousel.arrow.left-arrowlabel",
        "defaultMessage": "To next page"
    },
    rightArrowlabel: {
        "id": "version-issue-associated-designs.design-carousel.arrow.right-arrowlabel",
        "defaultMessage": "To previous page"
    }
});
var $8101e38be260867c$export$2e2bcd8739ae039 = $8101e38be260867c$var$messages;

});


parcelRegister("2Cc8I", function(module, exports) {
$parcel$export(module.exports, "DesignCard", () => $cc5f0453769cc55f$export$a0f819c247fd2165);

var $620WX = parcelRequire("620WX");

var $lcfQW = parcelRequire("lcfQW");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $ftN6c = parcelRequire("ftN6c");

var $goZPP = parcelRequire("goZPP");

var $9AYOJ = parcelRequire("9AYOJ");

var $8nu6j = parcelRequire("8nu6j");
var $dW738 = parcelRequire("dW738");
var $1DXK0 = parcelRequire("1DXK0");

var $k71qx = parcelRequire("k71qx");

var $4cTDP = parcelRequire("4cTDP");

var $48lPN = parcelRequire("48lPN");

var $dZ3jN = parcelRequire("dZ3jN");

var $kdtFw = parcelRequire("kdtFw");

var $iWvkh = parcelRequire("iWvkh");

var $lRq8t = parcelRequire("lRq8t");

var $irfiw = parcelRequire("irfiw");

var $2imLM = parcelRequire("2imLM");

var $kGj4V = parcelRequire("kGj4V");
var $eS29z = parcelRequire("eS29z");
var $kRgKj = parcelRequire("kRgKj");

var $cHtIB = parcelRequire("cHtIB");


var $3S14y = parcelRequire("3S14y");

var $ihZzL = parcelRequire("ihZzL");

var $ewF13 = parcelRequire("ewF13");

var $02gwu = parcelRequire("02gwu");

var $4DTDN = parcelRequire("4DTDN");
const $cc5f0453769cc55f$var$DATE_FORMAT = {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric'
};
const $cc5f0453769cc55f$var$runtimeProps = {};
const $cc5f0453769cc55f$export$a0f819c247fd2165 = ({ devOpsDesign: devOpsDesign, jiraVersion: jiraVersion })=>{
    const { formatDate: formatDate, formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [isModalOpen, setIsModalOpen] = (0, $eJOHy.useState)(false);
    const [designIssuesModalQueryRef, loadDesignIssuesModalQuery] = (0, $j4oe4.useQueryLoader)((0, $ihZzL.default));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const cloudId = (0, $cHtIB.useCloudId)();
    const siteAri = (0, $48lPN.JiraSiteAri).create({
        siteId: cloudId
    }).toString();
    const data = (0, $j4oe4.useFragment)((0, $lcfQW.default), devOpsDesign);
    const version = (0, $j4oe4.useFragment)((0, $620WX.default), jiraVersion);
    const onLoadDesignIssuesModalQuery = ()=>{
        if (designIssuesModalQueryRef == null) loadDesignIssuesModalQuery({
            cloudAri: siteAri,
            designAris: [
                data.id
            ],
            versionId: version.id
        });
    };
    const associatedIssuesNodes = (data.associatedIssues?.edges ?? []).filter(Boolean).map((edge)=>edge.node).filter((node)=>node?.__typename === 'JiraIssue').filter(Boolean);
    const issues = associatedIssuesNodes.length === 1 && associatedIssuesNodes[0].__typename === 'JiraIssue' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3S14y.SimpleIssueCard), {
        jiraIssue: associatedIssuesNodes[0],
        openIssueInSidebar: true
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("span", {
        onMouseEnter: onLoadDesignIssuesModalQuery,
        onFocus: onLoadDesignIssuesModalQuery,
        className: (0, $hcewu.default)([
            "_19pku2gc _n3td1b66 _18u0xmi2"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        spacing: "compact",
        appearance: "subtle",
        onClick: (_, analyticsEvent)=>{
            onLoadDesignIssuesModalQuery();
            setIsModalOpen(true);
            (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'designLinkedIssuesSeeAllModal');
        },
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9AYOJ))), {
            color: "var(--ds-icon-accent-blue, #357DE8)",
            label: formatMessage((0, $4cTDP.fg)('jira-issue-terminology-update-m4') ? (0, $02gwu.default).issueIconLabelIssueTerminologyRefreshM4 : (0, $02gwu.default).issueIconLabel)
        })
    }, formatMessage((0, $4cTDP.fg)('jira-issue-terminology-update-m4') ? (0, $02gwu.default).manyIssuesIssueTerminologyRefreshM4 : (0, $02gwu.default).manyIssues))), designIssuesModalQueryRef != null && isModalOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "version-detaiols-design-issues-modal",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ewF13.IssueModalLoading), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ewF13.IssuesModal), {
        queryRef: designIssuesModalQueryRef,
        onClose: ()=>setIsModalOpen(false)
    })));
    /**
   * Implementation wise DesignModal component is issue-centric. Hence we need an issue that is linked to this design to be able to
   * open the DesignModal preview. It doens't matter which issue we pick as all of them are linked to the current deisng, hence is the
   * term `representativeIssueAri`.
   */ const representativeIssueAri = associatedIssuesNodes.length > 0 && associatedIssuesNodes[0].__typename === 'JiraIssue' ? associatedIssuesNodes[0].id : '';
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $iWvkh.useEntryPoint)((0, $irfiw.designModalEntryPoint), {
        siteAri: siteAri,
        issueAri: representativeIssueAri,
        designAri: data.id,
        cloudId: cloudId
    });
    const modalTriggerRef = (0, $dZ3jN.useEntryPointButtonTrigger)(entryPointActions);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kGj4V.ContextualAnalyticsData), {
        sourceName: "versionAssociatedDesignCard",
        sourceType: (0, $aa42ce8e355d58fa$export$f636b5b56f1d624a),
        attributes: {
            hasMultipleIssues: associatedIssuesNodes.length > 1
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $cc5f0453769cc55f$var$cardContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("img", {
        src: data.provider.logoUrl,
        alt: "",
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _4t3i1tcg _1ul91tcg _19pk12x7"
        ])
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dW738.default), {
        xcss: $cc5f0453769cc55f$var$titleStackStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("a", {
        href: data.url,
        target: "_blank",
        onClick: ()=>(0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), 'link clicked', 'designTitleLink'),
        className: (0, $hcewu.default)([
            "_4bfu18uv _1hmsglyw _ajmmnqa1 _1reo15vq _18m915vq _syaz1kw7 _k48p1pd9 _o5721q9c _1bto1l2s _9oik18uv _1bnx8stv _jf4cnqa1 _30l31kw7"
        ])
    }, data.displayName), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: formatDate(data.lastUpdated, $cc5f0453769cc55f$var$DATE_FORMAT),
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("p", {
        className: (0, $hcewu.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _11c81o8v _k48pi7a9 _syaz1rpy"
        ])
    }, (0, $4DTDN.formatRelativeDate)(new Date(data.lastUpdated)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        className: (0, $hcewu.default)([
            "_1bsb68cl _19pkutpp _otyrutpp"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        ref: modalTriggerRef,
        shouldFitContainer: true,
        spacing: "compact",
        onClick: (_, analyticsEvent)=>(0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'openDesignPreviewButton')
    }, formatMessage((0, $02gwu.default).openPreview))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("p", {
        className: (0, $hcewu.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _11c81o8v _k48pi7a9 _syaz1rpy"
        ])
    }, formatMessage((0, $02gwu.default).linkedTo)), issues), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kdtFw.ModalEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        id: "jiraDesignModalInVersionDetailsPage",
        packageName: "design-modal",
        entryPointActions: entryPointActions,
        runtimeProps: $cc5f0453769cc55f$var$runtimeProps
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eS29z.FireScreenAnalytics), null));
};
const $cc5f0453769cc55f$var$cardContainerStyles = (0, $1DXK0.xcss)({
    display: 'flex',
    border: '3px',
    paddingTop: 'space.100',
    paddingBottom: 'space.100',
    paddingLeft: 'space.150',
    paddingRight: 'space.150',
    boxShadow: 'elevation.shadow.raised',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    minWidth: `${(0, $bfc4c7a2a9799602$export$2796973bb2f51929)}px`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    maxWidth: `${(0, $bfc4c7a2a9799602$export$2796973bb2f51929)}px`
});
const $cc5f0453769cc55f$var$iconStyles = null;
const $cc5f0453769cc55f$var$titleStackStyles = (0, $1DXK0.xcss)({
    flex: 1,
    marginLeft: 'space.100',
    maxWidth: '312px' // CARD_WIDTH - paddings - icon width
});
const $cc5f0453769cc55f$var$lastUpdatedStyles = null;
const $cc5f0453769cc55f$var$openPreviewStyles = null;
const $cc5f0453769cc55f$var$linkedToStyles = null;
const $cc5f0453769cc55f$var$titleStyles = null;
const $cc5f0453769cc55f$var$manyIssuesButtonStyles = null;

});
parcelRegister("620WX", function(module, exports) {
$parcel$export(module.exports, "default", () => $d463562f3a77dc86$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e89d02b9a20fcaff4cda1b4ccb9afdcb>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $d463562f3a77dc86$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "designCard_versionIssueAssociatedDesigns_jiraVersion",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "id"
            },
            "action": "THROW",
            "path": "id"
        }
    ],
    "type": "JiraVersion"
};
$d463562f3a77dc86$var$node.hash = "574075efd4cf2b2db85cdf409e87e841";
var $d463562f3a77dc86$export$2e2bcd8739ae039 = $d463562f3a77dc86$var$node;

});

parcelRegister("lcfQW", function(module, exports) {
$parcel$export(module.exports, "default", () => $afecf993b3ffae68$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<8314031cb72b2628e29a5a3038f05a2d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $afecf993b3ffae68$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "cloudAri"
            }
        ],
        "kind": "Fragment",
        "name": "designCard_versionIssueAssociatedDesigns_devOpsDesign",
        "selections": [
            v0 /*: any*/ ,
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "ScalarField",
                    "name": "url"
                },
                "action": "THROW",
                "path": "url"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "ScalarField",
                    "name": "displayName"
                },
                "action": "THROW",
                "path": "displayName"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "ScalarField",
                    "name": "lastUpdated"
                },
                "action": "THROW",
                "path": "lastUpdated"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "id",
                            "variableName": "cloudAri"
                        }
                    ],
                    "kind": "LinkedField",
                    "name": "provider",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "kind": "ScalarField",
                                "name": "logoUrl"
                            },
                            "action": "THROW",
                            "path": "provider.logoUrl"
                        }
                    ]
                },
                "action": "THROW",
                "path": "provider"
            },
            {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "first",
                        "value": 2
                    }
                ],
                "concreteType": "GraphStoreSimplifiedIssueAssociatedDesignInverseConnection",
                "kind": "LinkedField",
                "name": "associatedIssues",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "GraphStoreSimplifiedIssueAssociatedDesignInverseEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            v0 /*: any*/ ,
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "simpleIssueCard_versionIssueAssociatedDesigns"
                                            }
                                        ],
                                        "type": "JiraIssue"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "__typename"
                                    }
                                ]
                            }
                        ]
                    }
                ],
                "storageKey": "associatedIssues(first:2)"
            }
        ],
        "type": "DevOpsDesign"
    };
}();
$afecf993b3ffae68$var$node.hash = "bb9498fa38fb746e3897ed942c1b67ca";
var $afecf993b3ffae68$export$2e2bcd8739ae039 = $afecf993b3ffae68$var$node;

});

parcelRegister("3S14y", function(module, exports) {
$parcel$export(module.exports, "SimpleIssueCard", () => $0523ff195a3d1b5c$export$a6b6cb5c242d7ead);

var $f0PGw = parcelRequire("f0PGw");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $ftN6c = parcelRequire("ftN6c");

var $lL4G9 = parcelRequire("lL4G9");
var $3Wh6p = parcelRequire("3Wh6p");
var $1DXK0 = parcelRequire("1DXK0");

var $kRgKj = parcelRequire("kRgKj");

var $i6OEF = parcelRequire("i6OEF");

var $lOXOb = parcelRequire("lOXOb");
const $0523ff195a3d1b5c$export$a6b6cb5c242d7ead = ({ jiraIssue: jiraIssue, openIssueInSidebar: openIssueInSidebar })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const [, sidebarActions] = (0, $i6OEF.useSidebarStore)();
    const data = (0, $j4oe4.useFragment)((0, $f0PGw.default), jiraIssue);
    const fieldsData = data.fieldsByIdOrAlias.filter(Boolean);
    const issueTypeFieldData = fieldsData.reduce((acc, fieldData)=>{
        if (fieldData.__typename === 'JiraIssueTypeField') return {
            icon: fieldData.issueType.avatar?.xsmall ?? (0, (/*@__PURE__*/$parcel$interopDefault($lOXOb))),
            name: fieldData.issueType.name
        };
        return acc;
    }, {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lOXOb))),
        name: ''
    });
    const summaryText = fieldsData.reduce((acc, fieldData)=>{
        if (fieldData.__typename === 'JiraSingleLineTextField') return fieldData.text;
        return acc;
    }, null);
    if (issueTypeFieldData == null) throw new Error(`issue data did not contain issuetype data(${issueTypeFieldData})`);
    if (summaryText === null) throw new Error('issue data did not contain summary data');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lL4G9.default), {
        href: data.webUrl,
        target: "_blank",
        xcss: $0523ff195a3d1b5c$var$wrapperStyles,
        onClick: (e)=>{
            const modifiersPressed = e.shiftKey || e.metaKey || e.ctrlKey; // Open the issue in the sidebar if (a) the prop says we should and (b) the user
            // didn't *explicitly* try to open in a new tab, e.g. by control-clicking.
            if (openIssueInSidebar && !modifiersPressed) {
                e.preventDefault();
                sidebarActions.showIssue(data.key);
            }
            (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), 'link clicked', 'designLinkedIssue');
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        xcss: $0523ff195a3d1b5c$var$inlineStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("img", {
        src: issueTypeFieldData.icon,
        alt: issueTypeFieldData.name,
        title: issueTypeFieldData.name,
        className: (0, $hcewu.default)([
            "_16jlidpf _1o9zidpf _i0dl1wug _4t3i7vkz _1bsb7vkz _19pkidpf _2hwxu2gc _otyridpf _18u0idpf _1e0c1txw _1bah1h6o _4cvr1h6o"
        ])
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("span", {
        className: (0, $hcewu.default)([
            "_1o9zidpf _syaz1rpy _u5f31ejb _9oik18uv _1bnxglyw _jf4cnqa1"
        ])
    }, data.key), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("span", {
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _1bto1l2s _o5721q9c _syazi7uo _9oik18uv _1bnx8stv _jf4cnqa1"
        ])
    }, summaryText)));
};
const $0523ff195a3d1b5c$var$wrapperStyles = (0, $1DXK0.xcss)({
    textDecoration: 'none',
    boxSizing: 'content-box',
    display: 'block',
    height: '20px',
    paddingTop: 'space.100',
    paddingBottom: 'space.100',
    ':hover': {
        textDecoration: 'none'
    }
});
const $0523ff195a3d1b5c$var$inlineStyles = (0, $1DXK0.xcss)({
    alignItems: 'center'
});
const $0523ff195a3d1b5c$var$issueTypeStyles = null;
const $0523ff195a3d1b5c$var$issueKeyStyles = null;
const $0523ff195a3d1b5c$var$issueSummaryStyles = null;

});
parcelRegister("f0PGw", function(module, exports) {
$parcel$export(module.exports, "default", () => $32aa979e8901e963$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<548492858d45f5fbafbb71f1a08a7c7b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $32aa979e8901e963$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "simpleIssueCard_versionIssueAssociatedDesigns",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "key"
            },
            "action": "THROW",
            "path": "key"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "webUrl"
            },
            "action": "THROW",
            "path": "webUrl"
        },
        {
            "kind": "RequiredField",
            "field": {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "idsOrAliases",
                        "value": [
                            "issuetype",
                            "summary"
                        ]
                    },
                    {
                        "kind": "Literal",
                        "name": "ignoreMissingFields",
                        "value": true
                    }
                ],
                "kind": "LinkedField",
                "name": "fieldsByIdOrAlias",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "__typename"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "concreteType": "JiraIssueType",
                                    "kind": "LinkedField",
                                    "name": "issueType",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "kind": "ScalarField",
                                                "name": "name"
                                            },
                                            "action": "THROW",
                                            "path": "fieldsByIdOrAlias.issueType.name"
                                        },
                                        {
                                            "concreteType": "JiraAvatar",
                                            "kind": "LinkedField",
                                            "name": "avatar",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "xsmall"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "fieldsByIdOrAlias.issueType"
                            }
                        ],
                        "type": "JiraIssueTypeField"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "kind": "ScalarField",
                                    "name": "text"
                                },
                                "action": "THROW",
                                "path": "fieldsByIdOrAlias.text"
                            }
                        ],
                        "type": "JiraSingleLineTextField"
                    }
                ],
                "storageKey": "fieldsByIdOrAlias(idsOrAliases:[\"issuetype\",\"summary\"],ignoreMissingFields:true)"
            },
            "action": "THROW",
            "path": "fieldsByIdOrAlias"
        }
    ],
    "type": "JiraIssue"
};
$32aa979e8901e963$var$node.hash = "293ef6f7a36c1d615e6dc27559c1d40e";
var $32aa979e8901e963$export$2e2bcd8739ae039 = $32aa979e8901e963$var$node;

});

parcelRegister("lOXOb", function(module, exports) {
module.exports = new URL("issue-type-avatar-fallback.a9f6df1b.svg", import.meta.url).toString();

});


parcelRegister("ihZzL", function(module, exports) {
$parcel$export(module.exports, "default", () => $293178c8c6eeacd8$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<0c2ad0601128319e084fe547d3d8d145>>
 * @relayHash ae335ccbbdafd28c0b60d5176236e1a0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 24c11f2af60eb7a3e378df4c9e585d36a069016d8981c6f13ade2b717e96e9bf
const $293178c8c6eeacd8$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudAri"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "designAris"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "versionId"
    }, v3 = [
        {
            "kind": "Variable",
            "name": "ids",
            "variableName": "designAris"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "url"
    }, v5 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v6 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "cloudAri"
        }
    ], v7 = {
        "kind": "ScalarField",
        "name": "logoUrl"
    }, v8 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v9 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "issuesModal_designIssueQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "DevOps",
                        "kind": "LinkedField",
                        "name": "devOps",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v3 /*: any*/ ,
                                    "concreteType": "DevOpsDesign",
                                    "kind": "LinkedField",
                                    "name": "designEntityDetails",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": v4 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "devOps.designEntityDetails.url"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": v5 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "devOps.designEntityDetails.displayName"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "args": v6 /*: any*/ ,
                                                "kind": "LinkedField",
                                                "name": "provider",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v7 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "devOps.designEntityDetails.provider.logoUrl"
                                                    }
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "devOps.designEntityDetails.provider"
                                        },
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "body_versionIssueAssociatedDesigns_IssuesModalBody"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "devOps.designEntityDetails"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "devOps"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "issuesModal_designIssueQuery",
            "selections": [
                {
                    "concreteType": "DevOps",
                    "kind": "LinkedField",
                    "name": "devOps",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "DevOpsDesign",
                            "kind": "LinkedField",
                            "name": "designEntityDetails",
                            "plural": true,
                            "selections": [
                                v4 /*: any*/ ,
                                v5 /*: any*/ ,
                                {
                                    "args": v6 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "provider",
                                    "plural": false,
                                    "selections": [
                                        v8 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v9 /*: any*/ 
                                    ]
                                },
                                {
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "first",
                                            "value": 100
                                        }
                                    ],
                                    "concreteType": "GraphStoreSimplifiedIssueAssociatedDesignInverseConnection",
                                    "kind": "LinkedField",
                                    "name": "associatedIssues",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "GraphStoreSimplifiedIssueAssociatedDesignInverseEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v8 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "key"
                                                                },
                                                                {
                                                                    "args": [
                                                                        {
                                                                            "kind": "Variable",
                                                                            "name": "versionId",
                                                                            "variableName": "versionId"
                                                                        }
                                                                    ],
                                                                    "kind": "ScalarField",
                                                                    "name": "hasRelationshipToVersion"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "webUrl"
                                                                },
                                                                {
                                                                    "args": [
                                                                        {
                                                                            "kind": "Literal",
                                                                            "name": "idsOrAliases",
                                                                            "value": [
                                                                                "issuetype",
                                                                                "summary"
                                                                            ]
                                                                        },
                                                                        {
                                                                            "kind": "Literal",
                                                                            "name": "ignoreMissingFields",
                                                                            "value": true
                                                                        }
                                                                    ],
                                                                    "kind": "LinkedField",
                                                                    "name": "fieldsByIdOrAlias",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        v8 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueType",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "issueType",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "name"
                                                                                        },
                                                                                        {
                                                                                            "concreteType": "JiraAvatar",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "avatar",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "xsmall"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        v9 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "type": "JiraIssueTypeField"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "text"
                                                                                }
                                                                            ],
                                                                            "type": "JiraSingleLineTextField"
                                                                        },
                                                                        v9 /*: any*/ 
                                                                    ],
                                                                    "storageKey": "fieldsByIdOrAlias(idsOrAliases:[\"issuetype\",\"summary\"],ignoreMissingFields:true)"
                                                                }
                                                            ],
                                                            "type": "JiraIssue"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v9 /*: any*/ 
                                                            ],
                                                            "type": "Node",
                                                            "abstractKey": "__isNode"
                                                        }
                                                    ]
                                                },
                                                v9 /*: any*/ 
                                            ]
                                        }
                                    ],
                                    "storageKey": "associatedIssues(first:100)"
                                },
                                v9 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "24c11f2af60eb7a3e378df4c9e585d36a069016d8981c6f13ade2b717e96e9bf",
            "metadata": {},
            "name": "issuesModal_designIssueQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$293178c8c6eeacd8$var$node.hash = "7de65187f74a740f22e361ae3bf58899";
var $293178c8c6eeacd8$export$2e2bcd8739ae039 = $293178c8c6eeacd8$var$node;

});

parcelRegister("ewF13", function(module, exports) {
$parcel$export(module.exports, "IssueModalLoading", () => $3577e19b3b13bae9$export$30d178fad6e7652a);
$parcel$export(module.exports, "IssuesModal", () => $3577e19b3b13bae9$export$62000b4a046396b3);

var $ihZzL = parcelRequire("ihZzL");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $goZPP = parcelRequire("goZPP");

var $9AYOJ = parcelRequire("9AYOJ");

var $ik0CA = parcelRequire("ik0CA");
var $kseeK = parcelRequire("kseeK");
var $5a9Ro = parcelRequire("5a9Ro");

var $3Wh6p = parcelRequire("3Wh6p");
var $dW738 = parcelRequire("dW738");
var $1DXK0 = parcelRequire("1DXK0");

var $7ep4S = parcelRequire("7ep4S");

var $4cTDP = parcelRequire("4cTDP");

var $cSXp8 = parcelRequire("cSXp8");

var $lRq8t = parcelRequire("lRq8t");

var $lJKII = parcelRequire("lJKII");

var $4rA7W = parcelRequire("4rA7W");

var $3fNZG = parcelRequire("3fNZG");
const $3577e19b3b13bae9$export$30d178fad6e7652a = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lJKII.JiraModal), {
        messageId: "version-issue-associated-designs.ui.design-carousel.design-card.issues-modal.modal",
        messageType: "transactional"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ik0CA.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dW738.default), {
        xcss: $3577e19b3b13bae9$var$modalBodyLoadingStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7ep4S.default), {
        size: "large"
    }))));
const $3577e19b3b13bae9$export$62000b4a046396b3 = ({ queryRef: queryRef, onClose: onClose })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { showFlag: showFlag } = (0, $cSXp8.useFlagsService)();
    const data = (0, $j4oe4.usePreloadedQuery)((0, $ihZzL.default), queryRef);
    const designEntity = data.devOps.designEntityDetails[0]; // This shouldn't happen much in real world, but can happen when the target design is deleted while the user is looking at the page.
    (0, $eJOHy.useEffect)(()=>{
        if (designEntity == null) showFlag({
            messageId: 'version-issue-associated-designs.ui.design-carousel.design-card.issues-modal.show-flag.error',
            messageType: 'transactional',
            type: 'error',
            title: formatMessage((0, $3fNZG.default).errorFlagTitle),
            description: formatMessage((0, $3fNZG.default).errorFlagDescription)
        });
    }, [
        designEntity,
        formatMessage,
        showFlag
    ]);
    (0, $eJOHy.useEffect)(()=>{
        // Why? suggested here: https://hello.atlassian.net/wiki/spaces/A11YKB/pages/3021481389/Modal+Dialog+Focus#General-Focus
        setTimeout(()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            const modalElement = document.querySelector("[role='dialog']");
            modalElement?.focus();
        }, 50);
    }, []);
    if (designEntity == null) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lJKII.JiraModal), {
        width: "small",
        onClose: ()=>onClose(),
        autoFocus: false,
        messageId: "version-issue-associated-designs.ui.design-carousel.design-card.issues-modal.modal.1",
        messageType: "transactional"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5a9Ro.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dW738.default), {
        space: "space.150",
        xcss: $3577e19b3b13bae9$var$modalTitleStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("img", {
        src: designEntity?.provider.logoUrl,
        alt: "",
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _4t3i1tcg _1ul97vkz _2hwxu2gc"
        ])
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("a", {
        href: designEntity?.url,
        target: "_blank",
        className: (0, $hcewu.default)([
            "_4bfu18uv _1hmsglyw _ajmmnqa1 _syaz1kw7 _k48p1pd9 _9oik18uv _1bnx8stv _jf4cnqa1 _30l31kw7"
        ])
    }, designEntity?.displayName)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dW738.default), {
        space: "space.075"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("p", {
        className: (0, $hcewu.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _11c81o8v _k48pi7a9 _syaz1rpy"
        ])
    }, formatMessage((0, $3fNZG.default).linkedTo)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        alignBlock: "center",
        space: "space.050",
        xcss: $3577e19b3b13bae9$var$multipleIssuesStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9AYOJ))), {
        color: "var(--ds-icon-accent-blue, #357DE8)",
        label: ""
    }), formatMessage((0, $4cTDP.fg)('jira-issue-terminology-update-m4') ? (0, $3fNZG.default).manyIssuesIssueTerminologyRefreshM4 : (0, $3fNZG.default).manyIssues))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ik0CA.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4rA7W.IssuesModalBody), {
        devOpsDesign: designEntity
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kseeK.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        appearance: "primary",
        onClick: ()=>onClose()
    }, formatMessage((0, $3fNZG.default).modalCloseButtonLabel))));
};
const $3577e19b3b13bae9$var$modalIconStyles = null;
const $3577e19b3b13bae9$var$titleStyles = null;
const $3577e19b3b13bae9$var$modalTitleStyles = (0, $1DXK0.xcss)({
    paddingTop: 'space.300',
    paddingBottom: 'space.200',
    paddingLeft: 'space.300',
    paddingRight: 'space.300'
});
const $3577e19b3b13bae9$var$modalBodyLoadingStyles = (0, $1DXK0.xcss)({
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '300px',
    height: '300px'
});
const $3577e19b3b13bae9$var$linkedToStyles = null;
const $3577e19b3b13bae9$var$multipleIssuesStyles = (0, $1DXK0.xcss)({
    font: 'font.body'
});

});
parcelRegister("4rA7W", function(module, exports) {
$parcel$export(module.exports, "IssuesModalBody", () => $d4e26d0e683e6f47$export$fed5c8d395452c20);

var $eXeoB = parcelRequire("eXeoB");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $806LH = parcelRequire("806LH");

var $3Wh6p = parcelRequire("3Wh6p");
var $dW738 = parcelRequire("dW738");
var $1DXK0 = parcelRequire("1DXK0");

var $lRq8t = parcelRequire("lRq8t");

var $kGj4V = parcelRequire("kGj4V");
var $eS29z = parcelRequire("eS29z");

var $3S14y = parcelRequire("3S14y");

var $4ugGo = parcelRequire("4ugGo");

var $aThZu = parcelRequire("aThZu");
const $d4e26d0e683e6f47$export$fed5c8d395452c20 = ({ devOpsDesign: devOpsDesign })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const designEntity = (0, $j4oe4.useFragment)((0, $eXeoB.default), devOpsDesign);
    const associatedIssuesNodes = (designEntity?.associatedIssues?.edges ?? []).filter(Boolean).map((edge)=>edge.node).filter(Boolean);
    const issuesAssociatedToThisVersion = associatedIssuesNodes.filter((node)=>node.hasRelationshipToVersion);
    const issuesNotAssociatedToThisVersion = associatedIssuesNodes.filter((node)=>!node.hasRelationshipToVersion);
    (0, $aThZu.useFireManyIssueTrackingAnalaytics)(associatedIssuesNodes.length);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kGj4V.ContextualAnalyticsData), {
        sourceName: "versionDesignAssociatedIssues",
        sourceType: (0, $aa42ce8e355d58fa$export$f636b5b56f1d624a),
        attributes: {
            issuesAssociatedTotalCount: associatedIssuesNodes.length,
            issuesAssociatedToVersionCount: issuesAssociatedToThisVersion.length,
            issuesNotAssociatedToVersionCount: issuesAssociatedToThisVersion.length
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dW738.default), {
        space: "space.300",
        xcss: $d4e26d0e683e6f47$var$modalBodyStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dW738.default), null, issuesAssociatedToThisVersion.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $806LH.default), {
        size: "xsmall"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        xcss: $d4e26d0e683e6f47$var$subTitleStyles
    }, formatMessage((0, $4ugGo.default).issuesInVersion), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        xcss: $d4e26d0e683e6f47$var$issueCountStyles
    }, "\xa0 (", issuesAssociatedToThisVersion.length, ")"))), issuesAssociatedToThisVersion.map((issueNode)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3S14y.SimpleIssueCard), {
            key: issueNode.key,
            jiraIssue: issueNode
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dW738.default), null, issuesNotAssociatedToThisVersion.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $806LH.default), {
        size: "xsmall"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        xcss: $d4e26d0e683e6f47$var$subTitleStyles
    }, formatMessage((0, $4ugGo.default).otherIssues), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        xcss: $d4e26d0e683e6f47$var$issueCountStyles
    }, "\xa0 (", issuesNotAssociatedToThisVersion.length, ")"))), issuesNotAssociatedToThisVersion.map((issueNode)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3S14y.SimpleIssueCard), {
            key: issueNode.key,
            jiraIssue: issueNode
        })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eS29z.FireScreenAnalytics), null));
};
const $d4e26d0e683e6f47$var$modalBodyStyles = (0, $1DXK0.xcss)({
    paddingTop: 'space.025',
    paddingBottom: 'space.025'
});
const $d4e26d0e683e6f47$var$subTitleStyles = (0, $1DXK0.xcss)({
    marginBottom: 'space.100'
});
const $d4e26d0e683e6f47$var$issueCountStyles = (0, $1DXK0.xcss)({
    color: 'color.text.subtlest',
    fontWeight: "var(--ds-font-weight-regular, 400)"
});

});
parcelRegister("eXeoB", function(module, exports) {
$parcel$export(module.exports, "default", () => $c4d3414a25f70234$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3e261db26d1d024b6da239237bbfbcea>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $c4d3414a25f70234$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "versionId"
        }
    ],
    "kind": "Fragment",
    "name": "body_versionIssueAssociatedDesigns_IssuesModalBody",
    "selections": [
        {
            "args": [
                {
                    "kind": "Literal",
                    "name": "first",
                    "value": 100
                }
            ],
            "concreteType": "GraphStoreSimplifiedIssueAssociatedDesignInverseConnection",
            "kind": "LinkedField",
            "name": "associatedIssues",
            "plural": false,
            "selections": [
                {
                    "concreteType": "GraphStoreSimplifiedIssueAssociatedDesignInverseEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "kind": "ScalarField",
                                                "name": "key"
                                            },
                                            "action": "THROW",
                                            "path": "associatedIssues.edges.node.key"
                                        },
                                        {
                                            "args": [
                                                {
                                                    "kind": "Variable",
                                                    "name": "versionId",
                                                    "variableName": "versionId"
                                                }
                                            ],
                                            "kind": "ScalarField",
                                            "name": "hasRelationshipToVersion"
                                        },
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "simpleIssueCard_versionIssueAssociatedDesigns"
                                        }
                                    ],
                                    "type": "JiraIssue"
                                }
                            ]
                        }
                    ]
                }
            ],
            "storageKey": "associatedIssues(first:100)"
        }
    ],
    "type": "DevOpsDesign"
};
$c4d3414a25f70234$var$node.hash = "145e33a9a0a82742e3ace6aa6c154644";
var $c4d3414a25f70234$export$2e2bcd8739ae039 = $c4d3414a25f70234$var$node;

});

parcelRegister("4ugGo", function(module, exports) {
$parcel$export(module.exports, "default", () => $a0ccbc12584ebf67$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $a0ccbc12584ebf67$var$messages = (0, $7qGN1.defineMessages)({
    issuesInVersion: {
        "id": "version-issue-associated-designs.design-carousel.design-card.issues-modal.body.issues-in-version",
        "defaultMessage": "Current version"
    },
    otherIssues: {
        "id": "version-issue-associated-designs.design-carousel.design-card.issues-modal.body.other-issues",
        "defaultMessage": "Other"
    }
});
var $a0ccbc12584ebf67$export$2e2bcd8739ae039 = $a0ccbc12584ebf67$var$messages;

});

parcelRegister("aThZu", function(module, exports) {
$parcel$export(module.exports, "useFireManyIssueTrackingAnalaytics", () => $18c0d989f264a066$export$3ca4c107f1eff13e);

var $eJOHy = parcelRequire("eJOHy");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");
const $18c0d989f264a066$export$3ca4c107f1eff13e = (numIssues)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    (0, $eJOHy.useEffect)(()=>{
        if (numIssues > 100) (0, $kRgKj.fireTrackAnalytics)(createAnalyticsEvent({}), 'designAssociatedIssues exceeded', {
            numIssues: numIssues
        });
    }, [
        createAnalyticsEvent,
        numIssues
    ]);
};

});


parcelRegister("3fNZG", function(module, exports) {
$parcel$export(module.exports, "default", () => $6f1a74b7138d77e9$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $6f1a74b7138d77e9$var$messages = (0, $7qGN1.defineMessages)({
    modalCloseButtonLabel: {
        "id": "version-issue-associated-designs.design-carousel.design-card.issues-modal.modal-close-button-label",
        "defaultMessage": "Close"
    },
    errorFlagTitle: {
        "id": "version-issue-associated-designs.design-carousel.design-card.issues-modal.error-flag-title",
        "defaultMessage": "Something went wrong"
    },
    errorFlagDescription: {
        "id": "version-issue-associated-designs.design-carousel.design-card.issues-modal.error-flag-description",
        "defaultMessage": "Please refresh the page."
    },
    linkedTo: {
        "id": "version-issue-associated-designs.design-carousel.design-card.issues-modal.linked-to",
        "defaultMessage": "Linked to"
    },
    manyIssues: {
        "id": "version-issue-associated-designs.design-carousel.design-card.issues-modal.many-issues",
        "defaultMessage": "Multiple issues"
    },
    manyIssuesIssueTerminologyRefreshM4: {
        "id": "version-issue-associated-designs.design-carousel.design-card.issues-modal.many-issues-issue-terminology-refresh-m4",
        "defaultMessage": "Multiple work items"
    }
});
var $6f1a74b7138d77e9$export$2e2bcd8739ae039 = $6f1a74b7138d77e9$var$messages;

});


parcelRegister("02gwu", function(module, exports) {
$parcel$export(module.exports, "default", () => $8dbfaf39a1a7a7c3$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $8dbfaf39a1a7a7c3$var$messages = (0, $7qGN1.defineMessages)({
    openPreview: {
        "id": "version-issue-associated-designs.design-carousel.design-card.open-preview",
        "defaultMessage": "Open preview"
    },
    seeAll: {
        "id": "version-issue-associated-designs.design-carousel.design-card.see-all",
        "defaultMessage": "See all"
    },
    linkedTo: {
        "id": "version-issue-associated-designs.design-carousel.design-card.linked-to",
        "defaultMessage": "Linked to"
    },
    issueIconLabel: {
        "id": "version-issue-associated-designs.design-carousel.design-card.issue-icon-label",
        "defaultMessage": "Issue icon"
    },
    manyIssues: {
        "id": "version-issue-associated-designs.design-carousel.design-card.many-issues",
        "defaultMessage": "Multiple issues"
    },
    issueIconLabelIssueTerminologyRefreshM4: {
        "id": "version-issue-associated-designs.design-carousel.design-card.issue-icon-label-issue-terminology-refresh-m4",
        "defaultMessage": "Work item icon"
    },
    manyIssuesIssueTerminologyRefreshM4: {
        "id": "version-issue-associated-designs.design-carousel.design-card.many-issues-issue-terminology-refresh-m4",
        "defaultMessage": "Multiple work items"
    }
});
var $8dbfaf39a1a7a7c3$export$2e2bcd8739ae039 = $8dbfaf39a1a7a7c3$var$messages;

});

parcelRegister("4DTDN", function(module, exports) {
$parcel$export(module.exports, "formatRelativeDate", () => $b05e6e4d990172a9$export$10da3a44394af1a6);

var $bLQy1 = parcelRequire("bLQy1");
var $57raR = parcelRequire("57raR");
var $5fuQp = parcelRequire("5fuQp");
const $b05e6e4d990172a9$var$SECONDS_IN_A_DAY = 86400;
const $b05e6e4d990172a9$export$10da3a44394af1a6 = (lastUpdatedDate)=>{
    const currentDate = new Date();
    const isDateFormatRelative = (0, $bLQy1.default)(currentDate, lastUpdatedDate) <= $b05e6e4d990172a9$var$SECONDS_IN_A_DAY;
    return isDateFormatRelative ? (0, $5fuQp.default)(lastUpdatedDate, currentDate, {
        addSuffix: true,
        roundingMethod: 'floor'
    }) : (0, $57raR.default)(lastUpdatedDate, 'd MMM, HH:mm');
};

});


parcelRegister("98t0G", function(module, exports) {
$parcel$export(module.exports, "default", () => $2b4abe5f11fd27a1$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $2b4abe5f11fd27a1$var$messages = (0, $7qGN1.defineMessages)({
    carouselPageCount: {
        "id": "version-issue-associated-designs.design-carousel.carousel-page-count",
        "defaultMessage": "{currentStart}-{currentEnd} of {totalCount}"
    }
});
var $2b4abe5f11fd27a1$export$2e2bcd8739ae039 = $2b4abe5f11fd27a1$var$messages;

});


parcelRegister("ipAgV", function(module, exports) {
$parcel$export(module.exports, "EmptyState", () => $ec237d8665bbc13c$export$fddf379e22a74b00);
/* EmptyState.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $eJ9f5 = parcelRequire("eJ9f5");

var $806LH = parcelRequire("806LH");

var $4cTDP = parcelRequire("4cTDP");

var $lRq8t = parcelRequire("lRq8t");

var $6P7sP = parcelRequire("6P7sP");

var $bayMf = parcelRequire("bayMf");
const $ec237d8665bbc13c$export$fddf379e22a74b00 = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const learnMoreLabelMessage = (0, $4cTDP.fg)('jira-issue-terminology-update-m4') ? (0, $bayMf.default).learnMoreLabelIssueTerminologyRefreshM4 : (0, $bayMf.default).learnMoreLabel;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ec237d8665bbc13c$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("img", {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($6P7sP))),
        width: 80,
        alt: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("section", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $806LH.default), {
        as: "h3",
        size: "xsmall"
    }, formatMessage((0, $bayMf.default).title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ec237d8665bbc13c$var$Description, null, formatMessage((0, $bayMf.default).desciption)), (0, $4cTDP.fg)('replace-anchor-with-link__fusion-solaris') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJ9f5.default), {
        href: "https://support.atlassian.com/jira-cloud-administration/docs/integrate-figma-with-jira/",
        target: "_blank"
    }, formatMessage(learnMoreLabelMessage)) : // eslint-disable-next-line @atlaskit/design-system/no-html-anchor
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("a", {
        href: "https://support.atlassian.com/jira-cloud-administration/docs/integrate-figma-with-jira/",
        target: "_blank"
    }, formatMessage(learnMoreLabelMessage))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ec237d8665bbc13c$var$Container = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rko1mok _189e1dm9 _1dqogq9o _1h6d1l7x _1e0c1txw _4cvr1h6o _gy1p1ejb _19pkpxbi _ca0q1ejb _u5f31ejb _n3td1ejb _19bv1ejb",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ec237d8665bbc13c$var$Description = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_syaz1rpy",
            __cmplp.className
        ])
    });
});

});
parcelRegister("6P7sP", function(module, exports) {
module.exports = new URL("empty-icon.ef7b6c4a.svg", import.meta.url).toString();

});

parcelRegister("bayMf", function(module, exports) {
$parcel$export(module.exports, "default", () => $e42912c06468d865$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $e42912c06468d865$var$messages = (0, $7qGN1.defineMessages)({
    title: {
        "id": "version-issue-associated-designs.empty-state.title",
        "defaultMessage": "You\u2019ll see your linked designs here"
    },
    desciption: {
        "id": "version-issue-associated-designs.empty-state.desciption",
        "defaultMessage": "Get live updates and greater visibility of your team\u2019s design work."
    },
    learnMoreLabel: {
        "id": "version-issue-associated-designs.empty-state.learn-more-label",
        "defaultMessage": "Read more about linking designs to Jira issues"
    },
    learnMoreLabelIssueTerminologyRefreshM4: {
        "id": "version-issue-associated-designs.empty-state.learn-more-label-issue-terminology-refresh-m4",
        "defaultMessage": "Read more about linking designs to Jira work items"
    }
});
var $e42912c06468d865$export$2e2bcd8739ae039 = $e42912c06468d865$var$messages;

});


parcelRegister("lyVNz", function(module, exports) {
$parcel$export(module.exports, "default", () => $126edb0c49217748$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $126edb0c49217748$var$messages = (0, $7qGN1.defineMessages)({
    designSectionLabel: {
        "id": "version-issue-associated-designs.design-section-label",
        "defaultMessage": "Designs"
    }
});
var $126edb0c49217748$export$2e2bcd8739ae039 = $126edb0c49217748$var$messages;

});


parcelRegister("k5ghM", function(module, exports) {
$parcel$export(module.exports, "VersionProgress", () => $bf9ce304765951df$export$f9ad2300f8258368);

var $gL1Gj = parcelRequire("gL1Gj");

var $2UzA9 = parcelRequire("2UzA9");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $806LH = parcelRequire("806LH");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $lRq8t = parcelRequire("lRq8t");

var $jom8W = parcelRequire("jom8W");

var $7ZUH2 = parcelRequire("7ZUH2");

var $4R5AJ = parcelRequire("4R5AJ");

var $2qcZN = parcelRequire("2qcZN");

var $byPmj = parcelRequire("byPmj");

var $a8hS9 = parcelRequire("a8hS9");

var $hoc8q = parcelRequire("hoc8q");

var $9dhsB = parcelRequire("9dhsB");
const $bf9ce304765951df$export$f9ad2300f8258368 = ({ queryRef: queryRef })=>{
    const { jira: jira } = (0, $j4oe4.usePreloadedQuery)((0, $2UzA9.default), queryRef);
    const versionFrag = jira.version;
    const version = (0, $j4oe4.useFragment)((0, $gL1Gj.default), versionFrag);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const edges = version.relatedWorkV2 ? version.relatedWorkV2.edges.filter(Boolean) : [];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $bf9ce304765951df$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $bf9ce304765951df$var$mainHeadingStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $806LH.default), {
        size: "xsmall",
        as: "h2"
    }, formatMessage((0, $a8hS9.messages).progressHeading))), !(0, $jom8W.isDevopsFeatureDisabledInFedRamp)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hoc8q.RelatedWorkHeading), {
        relatedWorkEdges: edges
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9dhsB.RelatedWorkProgressBar), {
        relatedWorkEdges: edges
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7ZUH2.CollapsibleSection), {
        jiraVersion: version,
        uiType: "PROGRESS_CARD",
        renderHeader: (isCollapsed, onToggleClicked)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $byPmj.IssuesHeading), {
                jiraVersion: version,
                isCollapsed: isCollapsed,
                onToggleClicked: onToggleClicked
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4R5AJ.IssuesProgressBar), {
                jiraVersion: version
            })),
        renderBody: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2qcZN.IssueProgressDetails), {
                jiraVersion: version
            })
    })));
};
const $bf9ce304765951df$var$containerStyles = (0, $1DXK0.xcss)({
    paddingTop: 'space.200',
    paddingRight: 'space.300',
    paddingBottom: 'space.300',
    paddingLeft: 'space.300',
    display: 'flex',
    flexDirection: 'column',
    gap: 'space.200'
});
const $bf9ce304765951df$var$mainHeadingStyles = (0, $1DXK0.xcss)({
    paddingTop: 'space.100',
    paddingRight: 'space.0',
    paddingBottom: 'space.100',
    paddingLeft: 'space.0'
});

});
parcelRegister("gL1Gj", function(module, exports) {
$parcel$export(module.exports, "default", () => $41c9a6d1d0217262$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a07bf9ea4bd202e1b85a34f170936052>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $41c9a6d1d0217262$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "isDevopsFeatureDisabledInFedRamp"
        }
    ],
    "kind": "Fragment",
    "metadata": {
        "connection": [
            {
                "count": null,
                "cursor": null,
                "direction": "forward",
                "path": [
                    "relatedWorkV2"
                ]
            }
        ]
    },
    "name": "ui_versionProgress_VersionProgress",
    "selections": [
        {
            "condition": "isDevopsFeatureDisabledInFedRamp",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "alias": "relatedWorkV2",
                        "concreteType": "JiraVersionRelatedWorkV2Connection",
                        "kind": "LinkedField",
                        "name": "__version_relatedWorkV2_connection",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "concreteType": "JiraVersionRelatedWorkV2Edge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "relatedWorkHeading_versionProgress"
                                        },
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "relatedWorkProgressBar_versionProgress"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "cursor"
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "relatedWorkV2.edges"
                            },
                            {
                                "concreteType": "PageInfo",
                                "kind": "LinkedField",
                                "name": "pageInfo",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "endCursor"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "hasNextPage"
                                    }
                                ]
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "relatedWorkV2"
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "issuesHeading_versionProgress"
        },
        {
            "kind": "FragmentSpread",
            "name": "issueProgressBar_versionProgress_IssuesProgressBar"
        },
        {
            "kind": "FragmentSpread",
            "name": "issueProgressDetails_versionProgress"
        },
        {
            "kind": "FragmentSpread",
            "name": "ui_softwareReleasesCollapsibleUiToggle_CollapsibleSection"
        }
    ],
    "type": "JiraVersion"
};
$41c9a6d1d0217262$var$node.hash = "adad2bb30e02991a2dcfd9cb2046e4c9";
var $41c9a6d1d0217262$export$2e2bcd8739ae039 = $41c9a6d1d0217262$var$node;

});

parcelRegister("2UzA9", function(module, exports) {
$parcel$export(module.exports, "default", () => $9eb5d177fb88913a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7d21dec31d2b5e4e7378c4ddf12f3680>>
 * @relayHash b4bb4da349d8fe7b41a55b67a641db72
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 913fbb0382cf9cf095f853f6b818d4e8a47f615cd232275e0519fc5ae4eb57f1
const $9eb5d177fb88913a$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isDevopsFeatureDisabledInFedRamp"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "versionAri"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "versionAri"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = [
        {
            "kind": "ScalarField",
            "name": "totalCount"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 100
        }
    ], v7 = [
        {
            "kind": "ScalarField",
            "name": "url"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "ui_softwareReleasesVersionProgressQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v2 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "ui_versionProgress_VersionProgress"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.version"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "ui_softwareReleasesVersionProgressQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "version",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "alias": "doneIssuesRedesignTemp",
                                            "args": [
                                                {
                                                    "kind": "Literal",
                                                    "name": "filters",
                                                    "value": {
                                                        "statusCategories": [
                                                            "DONE"
                                                        ]
                                                    }
                                                }
                                            ],
                                            "concreteType": "JiraIssueConnection",
                                            "kind": "LinkedField",
                                            "name": "issues",
                                            "plural": false,
                                            "selections": v4 /*: any*/ ,
                                            "storageKey": "issues(filters:{\"statusCategories\":[\"DONE\"]})"
                                        },
                                        {
                                            "alias": "inProgressIssuesRedesignTemp",
                                            "args": [
                                                {
                                                    "kind": "Literal",
                                                    "name": "filters",
                                                    "value": {
                                                        "statusCategories": [
                                                            "IN_PROGRESS"
                                                        ]
                                                    }
                                                }
                                            ],
                                            "concreteType": "JiraIssueConnection",
                                            "kind": "LinkedField",
                                            "name": "issues",
                                            "plural": false,
                                            "selections": v4 /*: any*/ ,
                                            "storageKey": "issues(filters:{\"statusCategories\":[\"IN_PROGRESS\"]})"
                                        },
                                        {
                                            "alias": "todoIssuesRedesignTemp",
                                            "args": [
                                                {
                                                    "kind": "Literal",
                                                    "name": "filters",
                                                    "value": {
                                                        "statusCategories": [
                                                            "TODO"
                                                        ]
                                                    }
                                                }
                                            ],
                                            "concreteType": "JiraIssueConnection",
                                            "kind": "LinkedField",
                                            "name": "issues",
                                            "plural": false,
                                            "selections": v4 /*: any*/ ,
                                            "storageKey": "issues(filters:{\"statusCategories\":[\"TODO\"]})"
                                        },
                                        {
                                            "concreteType": "JiraVersionWarningConfig",
                                            "kind": "LinkedField",
                                            "name": "warningConfig",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "failingBuild"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "openPullRequest"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "openReview"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "unreviewedCode"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "warningsCount"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "collapsedUis"
                                        },
                                        v5 /*: any*/ ,
                                        {
                                            "condition": "isDevopsFeatureDisabledInFedRamp",
                                            "kind": "Condition",
                                            "passingValue": false,
                                            "selections": [
                                                {
                                                    "args": v6 /*: any*/ ,
                                                    "concreteType": "JiraVersionRelatedWorkV2Connection",
                                                    "kind": "LinkedField",
                                                    "name": "relatedWorkV2",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraVersionRelatedWorkV2Edge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v3 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v7 /*: any*/ ,
                                                                            "type": "JiraVersionRelatedWorkGenericLink"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v7 /*: any*/ ,
                                                                            "type": "JiraVersionRelatedWorkConfluenceReleaseNotes"
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "cursor"
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "PageInfo",
                                                            "kind": "LinkedField",
                                                            "name": "pageInfo",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "endCursor"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "hasNextPage"
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "storageKey": "relatedWorkV2(first:100)"
                                                },
                                                {
                                                    "args": v6 /*: any*/ ,
                                                    "handle": "connection",
                                                    "key": "version_relatedWorkV2",
                                                    "kind": "LinkedHandle",
                                                    "name": "relatedWorkV2"
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "JiraVersion"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v5 /*: any*/ 
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "913fbb0382cf9cf095f853f6b818d4e8a47f615cd232275e0519fc5ae4eb57f1",
            "metadata": {},
            "name": "ui_softwareReleasesVersionProgressQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$9eb5d177fb88913a$var$node.hash = "67f2e201e7debdeea53f08cb0f8bb7b1";
var $9eb5d177fb88913a$export$2e2bcd8739ae039 = $9eb5d177fb88913a$var$node;

});

parcelRegister("4R5AJ", function(module, exports) {
$parcel$export(module.exports, "IssuesProgressBar", () => $b6c3eaf7bbe7dfc8$export$80217ccba75d7c95);

var $2hf5H = parcelRequire("2hf5H");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $jx0Vw = parcelRequire("jx0Vw");

var $k71qx = parcelRequire("k71qx");

var $4cTDP = parcelRequire("4cTDP");

var $lRq8t = parcelRequire("lRq8t");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $amEKX = parcelRequire("amEKX");


var $9wa10 = parcelRequire("9wa10");

var $2VNpm = parcelRequire("2VNpm");
const $b6c3eaf7bbe7dfc8$export$80217ccba75d7c95 = ({ jiraVersion: jiraVersion })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { showStatusCategoryIssues: showStatusCategoryIssues } = (0, $amEKX.useFilterSortingQueryParams)();
    const version = (0, $j4oe4.useFragment)((0, $2hf5H.default), jiraVersion);
    const inProgressIssueCount = version.inProgressIssuesRedesignTemp.totalCount;
    const doneIssueCount = version.doneIssuesRedesignTemp.totalCount;
    const todoIssueCount = version.todoIssuesRedesignTemp.totalCount;
    const totalIssueCount = inProgressIssueCount + doneIssueCount + todoIssueCount;
    const createStatusClickHandler = (category)=>()=>{
            (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'button'
            }), 'progressBarShortcutFilter', {
                filter: category
            });
            const categoryId = String((0, $jx0Vw.categoryIdForStatusCategory)(category));
            showStatusCategoryIssues([
                categoryId
            ]);
        };
    if (totalIssueCount === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9wa10.Container), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9wa10.ProgressBarContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9wa10.ProgressBarElementContainer), {
        totalCount: 1,
        portionCount: 1,
        isClickable: true,
        isLast: true,
        "aria-label": formatMessage((0, $2VNpm.default).noIssuesText)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9wa10.Bar), {
        color: (0, $8d1e7283a0ef46e0$export$9a2ce699a8e88c00),
        isFirst: true,
        isLast: true
    }))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9wa10.Container), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9wa10.ProgressBarContainer), null, doneIssueCount > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9wa10.ProgressBarElementContainer), {
        onClick: createStatusClickHandler((0, $jx0Vw.DONE)),
        totalCount: totalIssueCount,
        portionCount: doneIssueCount,
        isClickable: true,
        isLast: totalIssueCount === doneIssueCount,
        "aria-label": formatMessage((0, $4cTDP.fg)('jira-issue-terminology-update-m4') ? (0, $2VNpm.default).doneIssuesTooltipTextIssueTerminologyRefreshM4 : (0, $2VNpm.default).doneIssuesTooltipText, {
            completedIssueCount: doneIssueCount,
            totalIssueCount: totalIssueCount
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        position: "top",
        content: formatMessage((0, $4cTDP.fg)('jira-issue-terminology-update-m4') ? (0, $2VNpm.default).doneIssuesTooltipTextIssueTerminologyRefreshM4 : (0, $2VNpm.default).doneIssuesTooltipText, {
            completedIssueCount: doneIssueCount,
            totalIssueCount: totalIssueCount
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9wa10.Bar), {
        color: (0, $8d1e7283a0ef46e0$export$f2a648c26a91297f),
        isFirst: true,
        isLast: totalIssueCount === doneIssueCount
    }))), inProgressIssueCount > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9wa10.ProgressBarElementContainer), {
        totalCount: totalIssueCount,
        portionCount: inProgressIssueCount,
        onClick: createStatusClickHandler((0, $jx0Vw.IN_PROGRESS)),
        isClickable: true,
        isLast: todoIssueCount === 0,
        "aria-label": formatMessage((0, $4cTDP.fg)('jira-issue-terminology-update-m4') ? (0, $2VNpm.default).inProgressIssuesTooltipTextIssueTerminologyRefreshM4 : (0, $2VNpm.default).inProgressIssuesTooltipText, {
            inProgressIssueCount: inProgressIssueCount,
            totalIssueCount: totalIssueCount
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        position: "top",
        content: formatMessage((0, $4cTDP.fg)('jira-issue-terminology-update-m4') ? (0, $2VNpm.default).inProgressIssuesTooltipTextIssueTerminologyRefreshM4 : (0, $2VNpm.default).inProgressIssuesTooltipText, {
            inProgressIssueCount: inProgressIssueCount,
            totalIssueCount: totalIssueCount
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9wa10.Bar), {
        color: (0, $8d1e7283a0ef46e0$export$dc4e31a90347554e),
        isFirst: doneIssueCount === 0,
        isLast: todoIssueCount === 0
    }))), todoIssueCount > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9wa10.ProgressBarElementContainer), {
        isLast: true,
        totalCount: totalIssueCount,
        portionCount: todoIssueCount,
        onClick: createStatusClickHandler((0, $jx0Vw.TODO)),
        isClickable: true,
        "aria-label": formatMessage((0, $4cTDP.fg)('jira-issue-terminology-update-m4') ? (0, $2VNpm.default).todoIssuesTooltipTextIssueTerminologyRefreshM4 : (0, $2VNpm.default).todoIssuesTooltipText, {
            todoIssueCount: todoIssueCount,
            totalIssueCount: totalIssueCount
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        position: "top",
        content: formatMessage((0, $4cTDP.fg)('jira-issue-terminology-update-m4') ? (0, $2VNpm.default).todoIssuesTooltipTextIssueTerminologyRefreshM4 : (0, $2VNpm.default).todoIssuesTooltipText, {
            todoIssueCount: todoIssueCount,
            totalIssueCount: totalIssueCount
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9wa10.Bar), {
        color: (0, $8d1e7283a0ef46e0$export$9a2ce699a8e88c00),
        isFirst: totalIssueCount === todoIssueCount,
        isLast: true
    })))));
};

});
parcelRegister("2hf5H", function(module, exports) {
$parcel$export(module.exports, "default", () => $34dfbef3183a6ef5$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<022ae572fe079cb167c3d37f775431c9>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $34dfbef3183a6ef5$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "totalCount"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "issueProgressBar_versionProgress_IssuesProgressBar",
        "selections": [
            {
                "kind": "RequiredField",
                "field": {
                    "alias": "doneIssuesRedesignTemp",
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "filters",
                            "value": {
                                "statusCategories": [
                                    "DONE"
                                ]
                            }
                        }
                    ],
                    "concreteType": "JiraIssueConnection",
                    "kind": "LinkedField",
                    "name": "issues",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": v0 /*: any*/ ,
                            "action": "THROW",
                            "path": "doneIssuesRedesignTemp.totalCount"
                        }
                    ],
                    "storageKey": "issues(filters:{\"statusCategories\":[\"DONE\"]})"
                },
                "action": "THROW",
                "path": "doneIssuesRedesignTemp"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "alias": "inProgressIssuesRedesignTemp",
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "filters",
                            "value": {
                                "statusCategories": [
                                    "IN_PROGRESS"
                                ]
                            }
                        }
                    ],
                    "concreteType": "JiraIssueConnection",
                    "kind": "LinkedField",
                    "name": "issues",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": v0 /*: any*/ ,
                            "action": "THROW",
                            "path": "inProgressIssuesRedesignTemp.totalCount"
                        }
                    ],
                    "storageKey": "issues(filters:{\"statusCategories\":[\"IN_PROGRESS\"]})"
                },
                "action": "THROW",
                "path": "inProgressIssuesRedesignTemp"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "alias": "todoIssuesRedesignTemp",
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "filters",
                            "value": {
                                "statusCategories": [
                                    "TODO"
                                ]
                            }
                        }
                    ],
                    "concreteType": "JiraIssueConnection",
                    "kind": "LinkedField",
                    "name": "issues",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": v0 /*: any*/ ,
                            "action": "THROW",
                            "path": "todoIssuesRedesignTemp.totalCount"
                        }
                    ],
                    "storageKey": "issues(filters:{\"statusCategories\":[\"TODO\"]})"
                },
                "action": "THROW",
                "path": "todoIssuesRedesignTemp"
            }
        ],
        "type": "JiraVersion"
    };
}();
$34dfbef3183a6ef5$var$node.hash = "9d79a458e2fb5db8bb37fec8334b2eed";
var $34dfbef3183a6ef5$export$2e2bcd8739ae039 = $34dfbef3183a6ef5$var$node;

});

const $8d1e7283a0ef46e0$export$9a2ce699a8e88c00 = "var(--ds-border, #0B120E24)";
const $8d1e7283a0ef46e0$export$dc4e31a90347554e = "var(--ds-border-information, #357DE8)";
const $8d1e7283a0ef46e0$export$f2a648c26a91297f = "var(--ds-border-success, #6A9A23)";
const $8d1e7283a0ef46e0$export$2d5e5bd76a1e6a66 = "var(--ds-background-warning-bold-hovered, #FCA700)";

parcelRegister("9wa10", function(module, exports) {
$parcel$export(module.exports, "Section", () => $f3a2f4fb247b69a4$export$6e2c8f0811a474ce);
$parcel$export(module.exports, "Summary", () => $f3a2f4fb247b69a4$export$46453a0401d6cd1a);
$parcel$export(module.exports, "Container", () => $f3a2f4fb247b69a4$export$42a852a2b6b56249);
$parcel$export(module.exports, "ProgressBarContainer", () => $f3a2f4fb247b69a4$export$91fd6e064cf0bcf3);
$parcel$export(module.exports, "ProgressBarElementContainer", () => $f3a2f4fb247b69a4$export$9148ffcd7ea9778);
$parcel$export(module.exports, "Bar", () => $f3a2f4fb247b69a4$export$bbc6c6369b38e3d1);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");
const $f3a2f4fb247b69a4$export$6e2c8f0811a474ce = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isCollapsible: isCollapsible, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _1bah1yb4 _4cvr1h6o",
            __cmplp.isCollapsible ? "_80omtlke" : "_80om73ad",
            __cmplp.className
        ])
    });
});
const $f3a2f4fb247b69a4$export$46453a0401d6cd1a = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1h6o _syaz1rpy",
            __cmplp.className
        ])
    });
});
const $f3a2f4fb247b69a4$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1bsb1osq _1e0c1txw _ca0qu2gc _u5f3idpf _n3tdu2gc _19bvidpf",
            __cmplp.className
        ])
    });
});
const $f3a2f4fb247b69a4$export$91fd6e064cf0bcf3 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1ul91tcg _2hwxv77o _1e0c1txw _4cvr1fhb",
            __cmplp.className
        ])
    });
});
const $f3a2f4fb247b69a4$export$9148ffcd7ea9778 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isLast: isLast, totalCount: totalCount, portionCount: portionCount, isClickable: isClickable, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1wknkfl": (0, $awdRS.default)(__cmplp.portionCount / __cmplp.totalCount * 100)
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_11q7glyw _19itglyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _11c81kw7 _12ji1r31 _1qu21kw7 _12y31o36 _1ul91ejb _1e0c1txw _2lx21bp4 _4cvr1fhb _7cca15wb _syaz1kw7 _x2qs15x0 _qe84exuw",
            __cmplp.isLast ? "_2hwxze3t" : "_2hwxv77o",
            __cmplp.totalCount === 0 ? "_16jlkb7n" : "_16jl1hqj",
            __cmplp.isClickable ? "_80omtlke" : "_80om73ad",
            __cmplp.className
        ])
    });
});
const $f3a2f4fb247b69a4$export$bbc6c6369b38e3d1 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isFirst: isFirst, isLast: isLast, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_xexnhp": (0, $awdRS.default)(__cmplp.color)
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_4t3iftgi _bfhk1cj8",
            __cmplp.isFirst && __cmplp.isLast ? "_2rko1mok" : __cmplp.isFirst ? "_2rkos4am" : __cmplp.isLast ? "_2rkoxugg" : "_2rkoidpf",
            __cmplp.className
        ])
    });
});

});

parcelRegister("2VNpm", function(module, exports) {
$parcel$export(module.exports, "default", () => $877c5155b5c3a418$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $877c5155b5c3a418$var$messages = (0, $7qGN1.defineMessages)({
    inProgressIssuesTooltipText: {
        "id": "version-progress.issue-progress-bar.in-progress-issues-tooltip-text",
        "defaultMessage": "In Progress: {inProgressIssueCount} of {totalIssueCount} {totalIssueCount, plural, one {issue} other {issues}}"
    },
    doneIssuesTooltipText: {
        "id": "version-progress.issue-progress-bar.done-issues-tooltip-text",
        "defaultMessage": "Done: {completedIssueCount} of {totalIssueCount} {totalIssueCount, plural, one {issue} other {issues}}"
    },
    todoIssuesTooltipText: {
        "id": "version-progress.issue-progress-bar.todo-issues-tooltip-text",
        "defaultMessage": "To Do: {todoIssueCount} of {totalIssueCount} {totalIssueCount, plural, one {issue} other {issues}}"
    },
    inProgressIssuesTooltipTextIssueTerminologyRefreshM4: {
        "id": "version-progress.issue-progress-bar.in-progress-issues-tooltip-text-issue-terminology-refresh-m4",
        "defaultMessage": "In Progress: {inProgressIssueCount} of {totalIssueCount} {totalIssueCount, plural, one {work item} other {work items}}"
    },
    doneIssuesTooltipTextIssueTerminologyRefreshM4: {
        "id": "version-progress.issue-progress-bar.done-issues-tooltip-text-issue-terminology-refresh-m4",
        "defaultMessage": "Done: {completedIssueCount} of {totalIssueCount} {totalIssueCount, plural, one {work item} other {work items}}"
    },
    todoIssuesTooltipTextIssueTerminologyRefreshM4: {
        "id": "version-progress.issue-progress-bar.todo-issues-tooltip-text-issue-terminology-refresh-m4",
        "defaultMessage": "To Do: {todoIssueCount} of {totalIssueCount} {totalIssueCount, plural, one {work item} other {work items}}"
    },
    noIssuesText: {
        "id": "version-progress.issue-progress-bar.no-issues-text",
        "defaultMessage": "No work items"
    }
});
var $877c5155b5c3a418$export$2e2bcd8739ae039 = $877c5155b5c3a418$var$messages;

});


parcelRegister("2qcZN", function(module, exports) {
$parcel$export(module.exports, "IssueProgressDetails", () => $acbf06ba1a756b2a$export$d0720399ba8e473e);

var $19Wqc = parcelRequire("19Wqc");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $j4oe4 = parcelRequire("j4oe4");

var $jx0Vw = parcelRequire("jx0Vw");

var $4cTDP = parcelRequire("4cTDP");

var $lRq8t = parcelRequire("lRq8t");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $amEKX = parcelRequire("amEKX");


var $98LUw = parcelRequire("98LUw");
const $acbf06ba1a756b2a$export$d0720399ba8e473e = ({ jiraVersion: jiraVersion })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { showStatusCategoryIssues: showStatusCategoryIssues, showIssuesWithWarnings: showIssuesWithWarnings } = (0, $amEKX.useFilterSortingQueryParams)();
    const version = (0, $j4oe4.useFragment)((0, $19Wqc.default), jiraVersion);
    const { doneIssuesRedesignTemp: doneIssues, inProgressIssuesRedesignTemp: inProgressIssues, todoIssuesRedesignTemp: todoIssues } = version;
    const { warningConfig: warningConfig } = version;
    const enabledWarningCategories = [];
    if (warningConfig?.failingBuild === 'ENABLED') enabledWarningCategories.push('FAILING_BUILD');
    if (warningConfig?.openPullRequest === 'ENABLED') enabledWarningCategories.push('OPEN_PULL_REQUEST');
    if (warningConfig?.openReview === 'ENABLED') enabledWarningCategories.push('OPEN_REVIEW');
    if (warningConfig?.unreviewedCode === 'ENABLED') enabledWarningCategories.push('UNREVIEWED_CODE');
    const messageFormatter = {
        b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($acbf06ba1a756b2a$var$StatusCategoryName, null, chunks),
        s: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($acbf06ba1a756b2a$var$IssueCount, null, chunks)
    };
    const createStatusClickHandler = (category)=>()=>{
            (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'button'
            }), 'progressDetailsShortcutFilter', {
                filter: category
            });
            const categoryId = String((0, $jx0Vw.categoryIdForStatusCategory)(category));
            showStatusCategoryIssues([
                categoryId
            ]);
        };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($acbf06ba1a756b2a$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($acbf06ba1a756b2a$var$Row, {
        onClick: createStatusClickHandler((0, $jx0Vw.DONE))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($acbf06ba1a756b2a$var$StatusCategoryColorIndicator, {
        color: (0, $8d1e7283a0ef46e0$export$f2a648c26a91297f)
    }), formatMessage((0, $4cTDP.fg)('jira-issue-terminology-update-m4') ? (0, $98LUw.messages).doneIssuesIssueTerminologyRefreshM4 : (0, $98LUw.messages).doneIssues, {
        ...messageFormatter,
        count: doneIssues.totalCount
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($acbf06ba1a756b2a$var$Row, {
        onClick: createStatusClickHandler((0, $jx0Vw.IN_PROGRESS))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($acbf06ba1a756b2a$var$StatusCategoryColorIndicator, {
        color: (0, $8d1e7283a0ef46e0$export$dc4e31a90347554e)
    }), formatMessage((0, $4cTDP.fg)('jira-issue-terminology-update-m4') ? (0, $98LUw.messages).inProgressIssuesIssueTerminologyRefreshM4 : (0, $98LUw.messages).inProgressIssues, {
        ...messageFormatter,
        count: inProgressIssues.totalCount
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($acbf06ba1a756b2a$var$Row, {
        onClick: createStatusClickHandler((0, $jx0Vw.TODO))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($acbf06ba1a756b2a$var$StatusCategoryColorIndicator, {
        color: (0, $8d1e7283a0ef46e0$export$9a2ce699a8e88c00)
    }), formatMessage((0, $4cTDP.fg)('jira-issue-terminology-update-m4') ? (0, $98LUw.messages).toDoIssuesIssueTerminologyRefreshM4 : (0, $98LUw.messages).toDoIssues, {
        ...messageFormatter,
        count: todoIssues.totalCount
    })), enabledWarningCategories.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($acbf06ba1a756b2a$var$Row // Warning: this test ID is used by a Pollintor check
    , {
        // eslint-disable-next-line jira/integration/test-id-by-folder-structure
        "data-testid": "software-releases-version-detail-issue-list.ui.warning-filter-button",
        onClick: ()=>{
            showIssuesWithWarnings(enabledWarningCategories);
            (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'button'
            }), 'progressBarShortcutFilter', {
                filter: 'warnings'
            });
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($acbf06ba1a756b2a$var$StatusCategoryColorIndicator, {
        color: (0, $8d1e7283a0ef46e0$export$2d5e5bd76a1e6a66)
    }), formatMessage((0, $4cTDP.fg)('jira-issue-terminology-update-m4') ? (0, $98LUw.messages).warningIssuesIssueTerminologyRefreshM4 : (0, $98LUw.messages).warningIssues, {
        ...messageFormatter,
        count: version.warningsCount
    })));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $acbf06ba1a756b2a$var$Container = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _2lx21bp4 _19pku2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $acbf06ba1a756b2a$var$StatusCategoryColorIndicator = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_xexnhp": (0, $awdRS.default)(__cmplp.color)
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rko1rr0 _1bsb19bv _4t3i19bv _bfhk1cj8 _2hwxv47k _18u0u2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $acbf06ba1a756b2a$var$Row = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rkofajl _1e0c1txw _4cvr1h6o _80omtlke _ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvu2gc _irr31dpa",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $acbf06ba1a756b2a$var$StatusCategoryName = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_k48p1pd9 _o572qvpr",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $acbf06ba1a756b2a$var$IssueCount = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_syaz1rpy",
            __cmplp.className
        ])
    });
});

});
parcelRegister("19Wqc", function(module, exports) {
$parcel$export(module.exports, "default", () => $9203500bb6557a5c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4824f62437604ac53e42b2828a4d1182>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $9203500bb6557a5c$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "totalCount"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "issueProgressDetails_versionProgress",
        "selections": [
            {
                "concreteType": "JiraVersionWarningConfig",
                "kind": "LinkedField",
                "name": "warningConfig",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "failingBuild"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "openPullRequest"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "openReview"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "unreviewedCode"
                    }
                ]
            },
            {
                "kind": "RequiredField",
                "field": {
                    "alias": "doneIssuesRedesignTemp",
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "filters",
                            "value": {
                                "statusCategories": [
                                    "DONE"
                                ]
                            }
                        }
                    ],
                    "concreteType": "JiraIssueConnection",
                    "kind": "LinkedField",
                    "name": "issues",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": v0 /*: any*/ ,
                            "action": "THROW",
                            "path": "doneIssuesRedesignTemp.totalCount"
                        }
                    ],
                    "storageKey": "issues(filters:{\"statusCategories\":[\"DONE\"]})"
                },
                "action": "THROW",
                "path": "doneIssuesRedesignTemp"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "alias": "inProgressIssuesRedesignTemp",
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "filters",
                            "value": {
                                "statusCategories": [
                                    "IN_PROGRESS"
                                ]
                            }
                        }
                    ],
                    "concreteType": "JiraIssueConnection",
                    "kind": "LinkedField",
                    "name": "issues",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": v0 /*: any*/ ,
                            "action": "THROW",
                            "path": "inProgressIssuesRedesignTemp.totalCount"
                        }
                    ],
                    "storageKey": "issues(filters:{\"statusCategories\":[\"IN_PROGRESS\"]})"
                },
                "action": "THROW",
                "path": "inProgressIssuesRedesignTemp"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "alias": "todoIssuesRedesignTemp",
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "filters",
                            "value": {
                                "statusCategories": [
                                    "TODO"
                                ]
                            }
                        }
                    ],
                    "concreteType": "JiraIssueConnection",
                    "kind": "LinkedField",
                    "name": "issues",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": v0 /*: any*/ ,
                            "action": "THROW",
                            "path": "todoIssuesRedesignTemp.totalCount"
                        }
                    ],
                    "storageKey": "issues(filters:{\"statusCategories\":[\"TODO\"]})"
                },
                "action": "THROW",
                "path": "todoIssuesRedesignTemp"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "ScalarField",
                    "name": "warningsCount"
                },
                "action": "THROW",
                "path": "warningsCount"
            }
        ],
        "type": "JiraVersion"
    };
}();
$9203500bb6557a5c$var$node.hash = "d8f802ed4e1d73fb8f14bafb9265439b";
var $9203500bb6557a5c$export$2e2bcd8739ae039 = $9203500bb6557a5c$var$node;

});

parcelRegister("98LUw", function(module, exports) {
$parcel$export(module.exports, "messages", () => $3e5a0637cad5e0f7$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $3e5a0637cad5e0f7$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    doneIssues: {
        "id": "version-progress.issue-progress-details.done-issues",
        "defaultMessage": "<b>Done: </b><s>{count} {count, plural, one {issue} other {issues}}</s>"
    },
    inProgressIssues: {
        "id": "version-progress.issue-progress-details.in-progress-issues",
        "defaultMessage": "<b>In progress: </b><s>{count} {count, plural, one {issue} other {issues}}</s>"
    },
    toDoIssues: {
        "id": "version-progress.issue-progress-details.to-do-issues",
        "defaultMessage": "<b>To do: </b><s>{count} {count, plural, one {issue} other {issues}}</s>"
    },
    warningIssues: {
        "id": "version-progress.issue-progress-details.warning-issues",
        "defaultMessage": "<b>Warning: </b><s>{count} {count, plural, one {issue} other {issues}}</s>"
    },
    doneIssuesIssueTerminologyRefreshM4: {
        "id": "version-progress.issue-progress-details.done-issues-issue-terminology-refresh-m4",
        "defaultMessage": "<b>Done: </b><s>{count} {count, plural, one {work item} other {work items}}</s>"
    },
    inProgressIssuesIssueTerminologyRefreshM4: {
        "id": "version-progress.issue-progress-details.in-progress-issues-issue-terminology-refresh-m4",
        "defaultMessage": "<b>In progress: </b><s>{count} {count, plural, one {work item} other {work items}}</s>"
    },
    toDoIssuesIssueTerminologyRefreshM4: {
        "id": "version-progress.issue-progress-details.to-do-issues-issue-terminology-refresh-m4",
        "defaultMessage": "<b>To do: </b><s>{count} {count, plural, one {work item} other {work items}}</s>"
    },
    warningIssuesIssueTerminologyRefreshM4: {
        "id": "version-progress.issue-progress-details.warning-issues-issue-terminology-refresh-m4",
        "defaultMessage": "<b>Warning: </b><s>{count} {count, plural, one {work item} other {work items}}</s>"
    }
});

});


parcelRegister("byPmj", function(module, exports) {
$parcel$export(module.exports, "IssuesHeading", () => $620690a086296e90$export$d7aca75aff5e9fe3);

var $5cqYs = parcelRequire("5cqYs");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $806LH = parcelRequire("806LH");

var $4cTDP = parcelRequire("4cTDP");

var $lRq8t = parcelRequire("lRq8t");

var $7ZUH2 = parcelRequire("7ZUH2");

var $9wa10 = parcelRequire("9wa10");

var $6qKMi = parcelRequire("6qKMi");
const $620690a086296e90$export$d7aca75aff5e9fe3 = ({ jiraVersion: jiraVersion, isCollapsed: isCollapsed, onToggleClicked: onToggleClicked })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const version = (0, $j4oe4.useFragment)((0, $5cqYs.default), jiraVersion);
    const inProgressIssueCount = version.inProgressIssuesRedesignTemp.totalCount;
    const doneIssueCount = version.doneIssuesRedesignTemp.totalCount;
    const todoIssueCount = version.todoIssuesRedesignTemp.totalCount;
    const totalIssueCount = inProgressIssueCount + doneIssueCount + todoIssueCount;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9wa10.Section), {
        onClick: onToggleClicked,
        isCollapsible: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $806LH.default), {
        size: "xsmall",
        as: "h3"
    }, formatMessage((0, $4cTDP.fg)('jira-issue-terminology-update-m4') ? (0, $6qKMi.default).issuesHeadingIssueTerminologyRefreshM4 : (0, $6qKMi.default).issuesHeading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9wa10.Summary), null, totalIssueCount === 0 ? formatMessage((0, $4cTDP.fg)('jira-issue-terminology-update-m4') ? (0, $6qKMi.default).noIssuesIssueTerminologyRefreshM4 : (0, $6qKMi.default).noIssues) : formatMessage((0, $6qKMi.default).doneIssues, {
        doneCount: doneIssueCount,
        totalCount: totalIssueCount
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7ZUH2.CollapsibleToggleButton), {
        isCollapsed: isCollapsed
    })));
};

});
parcelRegister("5cqYs", function(module, exports) {
$parcel$export(module.exports, "default", () => $86a7a02c16bcfe31$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<94a2e4b89a893c947458d602dad1156f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $86a7a02c16bcfe31$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "totalCount"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "issuesHeading_versionProgress",
        "selections": [
            {
                "kind": "RequiredField",
                "field": {
                    "alias": "doneIssuesRedesignTemp",
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "filters",
                            "value": {
                                "statusCategories": [
                                    "DONE"
                                ]
                            }
                        }
                    ],
                    "concreteType": "JiraIssueConnection",
                    "kind": "LinkedField",
                    "name": "issues",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": v0 /*: any*/ ,
                            "action": "THROW",
                            "path": "doneIssuesRedesignTemp.totalCount"
                        }
                    ],
                    "storageKey": "issues(filters:{\"statusCategories\":[\"DONE\"]})"
                },
                "action": "THROW",
                "path": "doneIssuesRedesignTemp"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "alias": "inProgressIssuesRedesignTemp",
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "filters",
                            "value": {
                                "statusCategories": [
                                    "IN_PROGRESS"
                                ]
                            }
                        }
                    ],
                    "concreteType": "JiraIssueConnection",
                    "kind": "LinkedField",
                    "name": "issues",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": v0 /*: any*/ ,
                            "action": "THROW",
                            "path": "inProgressIssuesRedesignTemp.totalCount"
                        }
                    ],
                    "storageKey": "issues(filters:{\"statusCategories\":[\"IN_PROGRESS\"]})"
                },
                "action": "THROW",
                "path": "inProgressIssuesRedesignTemp"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "alias": "todoIssuesRedesignTemp",
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "filters",
                            "value": {
                                "statusCategories": [
                                    "TODO"
                                ]
                            }
                        }
                    ],
                    "concreteType": "JiraIssueConnection",
                    "kind": "LinkedField",
                    "name": "issues",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": v0 /*: any*/ ,
                            "action": "THROW",
                            "path": "todoIssuesRedesignTemp.totalCount"
                        }
                    ],
                    "storageKey": "issues(filters:{\"statusCategories\":[\"TODO\"]})"
                },
                "action": "THROW",
                "path": "todoIssuesRedesignTemp"
            }
        ],
        "type": "JiraVersion"
    };
}();
$86a7a02c16bcfe31$var$node.hash = "1894f7adb956d41d80dd7d309152870c";
var $86a7a02c16bcfe31$export$2e2bcd8739ae039 = $86a7a02c16bcfe31$var$node;

});

parcelRegister("6qKMi", function(module, exports) {
$parcel$export(module.exports, "default", () => $60b5e74d45b30c77$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $60b5e74d45b30c77$var$messages = (0, $7qGN1.defineMessages)({
    issuesHeading: {
        "id": "version-progress.issues-heading.issues-heading",
        "defaultMessage": "Issues"
    },
    doneIssues: {
        "id": "version-progress.issues-heading.done-issues",
        "defaultMessage": "{doneCount} of {totalCount} {totalCount, plural, one {done} other {done}}"
    },
    noIssues: {
        "id": "version-progress.issues-heading.no-issues",
        "defaultMessage": "No issues added"
    },
    issuesHeadingIssueTerminologyRefreshM4: {
        "id": "version-progress.issues-heading.issues-heading-issue-terminology-refresh-m4",
        "defaultMessage": "Work items"
    },
    noIssuesIssueTerminologyRefreshM4: {
        "id": "version-progress.issues-heading.no-issues-issue-terminology-refresh-m4",
        "defaultMessage": "No work items added"
    }
});
var $60b5e74d45b30c77$export$2e2bcd8739ae039 = $60b5e74d45b30c77$var$messages;

});


parcelRegister("a8hS9", function(module, exports) {
$parcel$export(module.exports, "messages", () => $21dcb9689ab5990f$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $21dcb9689ab5990f$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    progressHeading: {
        "id": "version-progress.progress-heading",
        "defaultMessage": "Progress"
    }
});

});

parcelRegister("hoc8q", function(module, exports) {
$parcel$export(module.exports, "RelatedWorkHeading", () => $da056aec7cf6038d$export$7705e89d52d14851);

var $fjybi = parcelRequire("fjybi");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $806LH = parcelRequire("806LH");

var $lRq8t = parcelRequire("lRq8t");

var $9wa10 = parcelRequire("9wa10");

var $cICRO = parcelRequire("cICRO");
const $da056aec7cf6038d$export$7705e89d52d14851 = ({ relatedWorkEdges: relatedWorkEdges })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const edges = (0, $j4oe4.useFragment)((0, $fjybi.default), relatedWorkEdges);
    const totalCount = edges.length;
    const numNonPlaceholders = totalCount ? edges.filter((edge)=>{
        switch(edge?.node.__typename){
            case 'JiraVersionRelatedWorkNativeReleaseNotes':
                return true;
            case 'JiraVersionRelatedWorkGenericLink':
            case 'JiraVersionRelatedWorkConfluenceReleaseNotes':
                return edge.node.url !== null;
            default:
                return false;
        }
    }).length : 0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9wa10.Section), {
        isCollapsible: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $806LH.default), {
        size: "xsmall",
        as: "h3"
    }, formatMessage((0, $cICRO.default).relatedWorkHeading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9wa10.Summary), null, totalCount === 0 ? formatMessage((0, $cICRO.default).noItems) : formatMessage((0, $cICRO.default).summaryText, {
        numNonPlaceholders: numNonPlaceholders,
        totalCount: totalCount
    })));
};

});
parcelRegister("fjybi", function(module, exports) {
$parcel$export(module.exports, "default", () => $e0c9e245c2acf489$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<da12abafadbeeeb286bba016228ab38c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $e0c9e245c2acf489$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v1 = [
        v0 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "url"
        }
    ];
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "metadata": {
            "plural": true
        },
        "name": "relatedWorkHeading_versionProgress",
        "selections": [
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "InlineFragment",
                            "selections": v1 /*: any*/ ,
                            "type": "JiraVersionRelatedWorkGenericLink"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": v1 /*: any*/ ,
                            "type": "JiraVersionRelatedWorkConfluenceReleaseNotes"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                v0 /*: any*/ 
                            ],
                            "type": "JiraVersionRelatedWorkNativeReleaseNotes"
                        }
                    ]
                },
                "action": "NONE",
                "path": "node"
            }
        ],
        "type": "JiraVersionRelatedWorkV2Edge"
    };
}();
$e0c9e245c2acf489$var$node.hash = "211a6665d1a1915d987787889e12cca6";
var $e0c9e245c2acf489$export$2e2bcd8739ae039 = $e0c9e245c2acf489$var$node;

});

parcelRegister("cICRO", function(module, exports) {
$parcel$export(module.exports, "default", () => $e21d61f8ff9a3149$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $e21d61f8ff9a3149$var$messages = (0, $7qGN1.defineMessages)({
    relatedWorkHeading: {
        "id": "version-progress.related-work-heading.related-work-heading",
        "defaultMessage": "Related work"
    },
    summaryText: {
        "id": "version-progress.related-work-heading.summary-text",
        "defaultMessage": "{numNonPlaceholders} of {totalCount} added"
    },
    noItems: {
        "id": "version-progress.related-work-heading.no-items",
        "defaultMessage": "None added"
    }
});
var $e21d61f8ff9a3149$export$2e2bcd8739ae039 = $e21d61f8ff9a3149$var$messages;

});


parcelRegister("9dhsB", function(module, exports) {
$parcel$export(module.exports, "RelatedWorkProgressBar", () => $7cdfea0f8e93abd6$export$34d7439de9413789);

var $7ZdCK = parcelRequire("7ZdCK");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $k71qx = parcelRequire("k71qx");

var $lRq8t = parcelRequire("lRq8t");

var $kRgKj = parcelRequire("kRgKj");


var $9wa10 = parcelRequire("9wa10");

var $a6uh3 = parcelRequire("a6uh3");
const $7cdfea0f8e93abd6$export$34d7439de9413789 = ({ relatedWorkEdges: relatedWorkEdges })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const edges = (0, $j4oe4.useFragment)((0, $7ZdCK.default), relatedWorkEdges);
    const totalCount = edges.length;
    const numNonPlaceholders = totalCount ? edges.filter((edge)=>{
        switch(edge?.node.__typename){
            case 'JiraVersionRelatedWorkNativeReleaseNotes':
                return true;
            case 'JiraVersionRelatedWorkGenericLink':
            case 'JiraVersionRelatedWorkConfluenceReleaseNotes':
                return edge.node.url !== null;
            default:
                return false;
        }
    }).length : 0;
    const numPlaceholders = totalCount - numNonPlaceholders;
    const fireAnalyticsEvent = (analyticsEvent)=>{
        (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'relatedWorkProgressTooltip', {
            numOfItems: totalCount,
            numPlaceholders: numPlaceholders,
            numNonPlaceholders: numNonPlaceholders
        });
    };
    if (totalCount === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9wa10.Container), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9wa10.ProgressBarContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9wa10.ProgressBarElementContainer), {
        totalCount: 1,
        portionCount: 1,
        isLast: true,
        "aria-label": formatMessage((0, $a6uh3.default).noRelatedWorkText)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9wa10.Bar), {
        color: (0, $8d1e7283a0ef46e0$export$9a2ce699a8e88c00),
        isFirst: true,
        isLast: true
    }))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9wa10.Container), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9wa10.ProgressBarContainer), null, numNonPlaceholders > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9wa10.ProgressBarElementContainer), {
        totalCount: totalCount,
        portionCount: numNonPlaceholders,
        "aria-label": formatMessage((0, $a6uh3.default).nonPlaceholdersSegmentTooltipText, {
            numNonPlaceholders: numNonPlaceholders
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        position: "top",
        content: formatMessage((0, $a6uh3.default).nonPlaceholdersSegmentTooltipText, {
            numNonPlaceholders: numNonPlaceholders
        }),
        onShow: (analyticsEvent)=>fireAnalyticsEvent(analyticsEvent)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9wa10.Bar), {
        color: (0, $8d1e7283a0ef46e0$export$f2a648c26a91297f),
        isFirst: true,
        isLast: numPlaceholders === 0
    }))), numPlaceholders > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9wa10.ProgressBarElementContainer), {
        isLast: true,
        totalCount: totalCount,
        portionCount: numPlaceholders,
        "aria-label": formatMessage((0, $a6uh3.default).placeholdersSegmentTooltipText, {
            numPlaceholders: numPlaceholders
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        position: "top",
        content: formatMessage((0, $a6uh3.default).placeholdersSegmentTooltipText, {
            numPlaceholders: numPlaceholders
        }),
        onShow: (analyticsEvent)=>fireAnalyticsEvent(analyticsEvent)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9wa10.Bar), {
        color: (0, $8d1e7283a0ef46e0$export$9a2ce699a8e88c00),
        isFirst: numNonPlaceholders === 0,
        isLast: true
    })))));
};

});
parcelRegister("7ZdCK", function(module, exports) {
$parcel$export(module.exports, "default", () => $624331618b62ea29$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<391fa37bd82e7c8c0612c5be399d9087>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $624331618b62ea29$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v1 = [
        v0 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "url"
        }
    ];
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "metadata": {
            "plural": true
        },
        "name": "relatedWorkProgressBar_versionProgress",
        "selections": [
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "InlineFragment",
                            "selections": v1 /*: any*/ ,
                            "type": "JiraVersionRelatedWorkGenericLink"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": v1 /*: any*/ ,
                            "type": "JiraVersionRelatedWorkConfluenceReleaseNotes"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                v0 /*: any*/ 
                            ],
                            "type": "JiraVersionRelatedWorkNativeReleaseNotes"
                        }
                    ]
                },
                "action": "NONE",
                "path": "node"
            }
        ],
        "type": "JiraVersionRelatedWorkV2Edge"
    };
}();
$624331618b62ea29$var$node.hash = "c40509aabe2c6731ba0d792fff68b169";
var $624331618b62ea29$export$2e2bcd8739ae039 = $624331618b62ea29$var$node;

});

parcelRegister("a6uh3", function(module, exports) {
$parcel$export(module.exports, "default", () => $01df3d0df71b4be6$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $01df3d0df71b4be6$var$messages = (0, $7qGN1.defineMessages)({
    nonPlaceholdersSegmentTooltipText: {
        "id": "version-progress.related-work-progress-bar.non-placeholders-segment-tooltip-text",
        "defaultMessage": "{numNonPlaceholders} added"
    },
    placeholdersSegmentTooltipText: {
        "id": "version-progress.related-work-progress-bar.placeholders-segment-tooltip-text",
        "defaultMessage": "{numPlaceholders} {numPlaceholders, plural, one {placeholder} other {placeholders}}"
    },
    noRelatedWorkText: {
        "id": "version-progress.related-work-progress-bar.no-related-work-text",
        "defaultMessage": "No related work"
    }
});
var $01df3d0df71b4be6$export$2e2bcd8739ae039 = $01df3d0df71b4be6$var$messages;

});



parcelRegister("b70fx", function(module, exports) {
$parcel$export(module.exports, "NonCriticalErrorBoundary", () => $f910cbdabaa1874d$export$1625b7ea4c7a5a23);

var $eJOHy = parcelRequire("eJOHy");

var $5vQ2T = parcelRequire("5vQ2T");
const $f910cbdabaa1874d$export$1625b7ea4c7a5a23 = ({ fallback: fallback, eventLocation: eventLocation, children: children, onError: onError })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        fallback: fallback,
        packageName: "jiraSoftwareReleasesVersionDetail",
        teamName: "jolt",
        id: eventLocation,
        onError: onError
    }, children);

});

parcelRegister("jCfjG", function(module, exports) {
$parcel$export(module.exports, "convertTabToQueryVariables", () => $e34f1f070250a566$export$4fc138bc768eeef1);
const $e34f1f070250a566$export$4fc138bc768eeef1 = (tab)=>{
    switch(tab){
        case 'release-report-warnings':
            return {
                filter: 'OPEN_PULL_REQUEST',
                isShowWarnings: true
            };
        case 'release-report-all-issues':
            return {
                filter: 'ALL',
                isShowWarnings: false
            };
        case 'release-report-done':
            return {
                filter: 'DONE',
                isShowWarnings: false
            };
        case 'release-report-in-progress':
            return {
                filter: 'IN_PROGRESS',
                isShowWarnings: false
            };
        case 'release-report-todo':
            return {
                filter: 'TODO',
                isShowWarnings: false
            };
        default:
            // default to all issues column
            return {
                filter: 'ALL',
                isShowWarnings: false
            };
    }
};

});

parcelRegister("baLOk", function(module, exports) {
$parcel$export(module.exports, "useCurrentTab", () => $45318892b78c9275$export$49b7d3cc5222d699);

var $2FqDG = parcelRequire("2FqDG");

const $45318892b78c9275$var$toVersionTabId = (selectedTabId)=>{
    if (selectedTabId === undefined) return 0, $0a6d1a994d48f778$export$88979a530e0a9348;
    switch(selectedTabId){
        case 0, $0a6d1a994d48f778$export$53105de2008705e2:
            return 0, $0a6d1a994d48f778$export$53105de2008705e2;
        case 0, $0a6d1a994d48f778$export$88979a530e0a9348:
            return 0, $0a6d1a994d48f778$export$88979a530e0a9348;
        case 0, $0a6d1a994d48f778$export$d669607531cb7a9a:
            return 0, $0a6d1a994d48f778$export$d669607531cb7a9a;
        case 0, $0a6d1a994d48f778$export$d9e751b9469f77b3:
            return 0, $0a6d1a994d48f778$export$d9e751b9469f77b3;
        case 0, $0a6d1a994d48f778$export$5e552e58a93a50a5:
            return 0, $0a6d1a994d48f778$export$5e552e58a93a50a5;
        default:
            return 0, $0a6d1a994d48f778$export$88979a530e0a9348;
    }
};
const $45318892b78c9275$export$49b7d3cc5222d699 = ()=>{
    const [selectedTabId, setSelectedTab] = (0, $2FqDG.usePathParam)('tab');
    const setCurrentTab = (tabId)=>{
        setSelectedTab(tabId);
    };
    return {
        currentTabId: $45318892b78c9275$var$toVersionTabId(selectedTabId),
        setCurrentTab: setCurrentTab
    };
};

});
const $0a6d1a994d48f778$export$53105de2008705e2 = 'release-report-warnings';
const $0a6d1a994d48f778$export$88979a530e0a9348 = 'release-report-all-issues';
const $0a6d1a994d48f778$export$d669607531cb7a9a = 'release-report-done';
const $0a6d1a994d48f778$export$d9e751b9469f77b3 = 'release-report-in-progress';
const $0a6d1a994d48f778$export$5e552e58a93a50a5 = 'release-report-todo';


parcelRegister("liQFv", function(module, exports) {
$parcel$export(module.exports, "PerformanceTracker", () => $207bcdfd55a0c3f2$export$57a2c9a4973f6a35);

var $eJOHy = parcelRequire("eJOHy");

var $hqYEY = parcelRequire("hqYEY");

var $jUHqr = parcelRequire("jUHqr");

var $b70fx = parcelRequire("b70fx");
const $207bcdfd55a0c3f2$var$versionDetailsPagePageLoad = (0, $hqYEY.metrics).pageLoad({
    key: 'software.version-details-page',
    ssr: {
        doneAsFmp: true
    },
    slo: {
        fmp: {
            initial: {
                threshold: 1000
            },
            transition: {
                threshold: 1000
            }
        },
        tti: {
            initial: {
                threshold: 4000
            },
            transition: {
                threshold: 4000
            }
        }
    }
});
const $207bcdfd55a0c3f2$export$57a2c9a4973f6a35 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $b70fx.NonCriticalErrorBoundary), {
        fallback: "unmount",
        eventLocation: "performanceTracker"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jUHqr.default), {
        appName: "jira-software-version-details-page",
        // @ts-expect-error - TS2769 - No overload matches this call.
        metric: $207bcdfd55a0c3f2$var$versionDetailsPagePageLoad
    }));

});
parcelRegister("jUHqr", function(module, exports) {
$parcel$export(module.exports, "checkAndEmitApdexSignal", () => $0aba41a6ca8ce346$export$3082c88b693a5230);
$parcel$export(module.exports, "default", () => $0aba41a6ca8ce346$export$2e2bcd8739ae039);
$parcel$export(module.exports, "baseDefaultProps", () => $0aba41a6ca8ce346$export$9b3029ee6188a41f);

var $eJOHy = parcelRequire("eJOHy");

var $2gvG4 = parcelRequire("2gvG4");

var $6whQo = parcelRequire("6whQo");

var $kVpZx = parcelRequire("kVpZx");

var $ioEQd = parcelRequire("ioEQd");

var $fRC66 = parcelRequire("fRC66");

var $CkF8u = parcelRequire("CkF8u");

var $iAPDN = parcelRequire("iAPDN");

var $4WwFo = parcelRequire("4WwFo");

var $cllya = parcelRequire("cllya");
const $0aba41a6ca8ce346$export$3082c88b693a5230 = (appName, metricKey)=>{
    var emitSignal;
};
class $0aba41a6ca8ce346$export$2e2bcd8739ae039 extends (0, $eJOHy.Component) {
    static{
        this.defaultProps = {
            isExpectedToHaveSsr: false,
            withMarks: [],
            extra: {},
            emitOnAnimationFrame: false
        };
    }
    render() {
        const { appName: appName, metricKey: metricKey, extra: extra, metric: metric, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
        $0aba41a6ca8ce346$export$3082c88b693a5230(appName, metricKey);
        const isUFODefined = (0, $ioEQd.GlobalPageLoadExperience).loadingPageLoadId !== 'UNKNOWN';
        if (isUFODefined) (0, $4WwFo.addUFOSSRDoneAsFMPToInteraction)();
        if (metric) {
            // https://product-fabric.atlassian.net/browse/UFO-323
            (0, $iAPDN.addBM3SSRDoneAsFMPToInteraction)(metric);
            (0, $cllya.trackBM3FeatureFlagsAccessed)(metric);
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2gvG4.default), {
            data: extra
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6whQo.UFOBM3TimingsToUFO), {
            marks: metric?.getData()?.marks,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            timings: metric?.getData()?.config?.timings
        }), isUFODefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $CkF8u.StopUfo), {
            appName: appName,
            customData: extra,
            key: (0, $kVpZx.getInteractionId)().current
        }) : metric && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fRC66.StopBrowserMetrics3), {
            metric: metric,
            customData: extra,
            emitOnAnimationFrame: emitOnAnimationFrame
        }));
    }
}
const $0aba41a6ca8ce346$export$9b3029ee6188a41f = $0aba41a6ca8ce346$export$2e2bcd8739ae039.defaultProps;

});
parcelRegister("6whQo", function(module, exports) {
$parcel$export(module.exports, "getBm3Timings", () => $3708d872c36dd1bb$export$f02972da195a43bb);
$parcel$export(module.exports, "UFOBM3TimingsToUFO", () => $3708d872c36dd1bb$export$30f0b5e5acd268bf);
$parcel$export(module.exports, "addBM3TimingsToUFO", () => $3708d872c36dd1bb$export$d93d677ef2f33c5c);

var $eJOHy = parcelRequire("eJOHy");

var $7aoMz = parcelRequire("7aoMz");

var $kVpZx = parcelRequire("kVpZx");

var $2QO3b = parcelRequire("2QO3b");
function $3708d872c36dd1bb$export$f02972da195a43bb(marks, timingConfigs) {
    const bm3Timings = {};
    if (!marks || !timingConfigs) return bm3Timings;
    timingConfigs.forEach((item)=>{
        if (!item.startMark || !item.endMark) return;
        const startTime = marks[item.startMark];
        if (!startTime) return;
        const endTime = marks[item.endMark];
        if (!endTime) return;
        bm3Timings[item.key] = {
            startTime: startTime,
            endTime: endTime
        };
    });
    return bm3Timings;
}
function $3708d872c36dd1bb$export$30f0b5e5acd268bf({ marks: marks, timings: timings }) {
    const interactionContext = (0, $eJOHy.useContext)((0, $7aoMz.default));
    const interactionId = (0, $kVpZx.getInteractionId)().current;
    (0, $eJOHy.useMemo)(()=>{
        if (interactionContext != null && interactionId != null && marks != null && timings != null) {
            const interactionType = (0, $2QO3b.getCurrentInteractionType)(interactionId);
            if (interactionType === 'press') return;
            const bm3Timings = $3708d872c36dd1bb$export$f02972da195a43bb(marks, timings);
            interactionContext.addCustomTimings(bm3Timings);
        }
    }, [
        interactionContext,
        interactionId,
        marks,
        timings
    ]);
    return null;
}
function $3708d872c36dd1bb$export$d93d677ef2f33c5c(marks, timingsConfig) {
    const interactionId = (0, $kVpZx.getInteractionId)().current;
    if (interactionId) {
        const interactionType = (0, $2QO3b.getCurrentInteractionType)(interactionId);
        if (interactionType === 'press') return;
        const bm3Timings = $3708d872c36dd1bb$export$f02972da195a43bb(marks, timingsConfig);
        (0, $2QO3b.addCustomTiming)(interactionId, [], bm3Timings);
    }
}

});

parcelRegister("fRC66", function(module, exports) {
$parcel$export(module.exports, "StopBrowserMetrics3", () => $7986e193b27b5912$export$575e93c0f9905999);

var $eJOHy = parcelRequire("eJOHy");

var $7aoMz = parcelRequire("7aoMz");

var $k04JP = parcelRequire("k04JP");

var $6uWhG = parcelRequire("6uWhG");

var $2HxHL = parcelRequire("2HxHL");

var $iEXnd = parcelRequire("iEXnd");

var $lOI8W = parcelRequire("lOI8W");

var $9DwQv = parcelRequire("9DwQv");

const $7986e193b27b5912$var$emitMetrics = (metric, customData, stopTime)=>{
    (0, $lOI8W.setInitialPageLoadTimingFromPerformanceMarks)('batch-js-heritage.eval', 'jira.heritage_batch_file_eval:start', 'jira.heritage_batch_file_eval:end');
    if (stopTime !== undefined) metric.stop({
        customData: customData,
        stopTime: stopTime
    });
    else metric.stop({
        customData: customData
    });
    if ((0, $9DwQv.isAutomaticExposureCollectionEnabled)()) (0, $2HxHL.stopLowPriorityEventDelay)();
};
class $7986e193b27b5912$export$575e93c0f9905999 extends (0, $eJOHy.Component) {
    componentDidMount() {
        const { metric: metric, customData: customData, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
        if (!metric) return;
        const start = (0, $k04JP.browserMetrics).getPageLoadMetric()?.getData()?.start || 0;
        (0, $6uWhG.setMark)('BROWSER_METRICS_TTI_START', {
            startTime: start
        });
        (0, $6uWhG.setMark)('BROWSER_METRICS_TTI_END');
        (0, $6uWhG.setMeasure)('BROWSER_METRICS_TTI', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_END');
        const bm3Data = metric.getData();
        if (emitOnAnimationFrame) {
            const stopTime = performance.now();
            (0, $lOI8W.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $iEXnd.PRODUCT_START_MARK), true);
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: stopTime
            });
            if (typeof queueMicrotask !== 'undefined') queueMicrotask(()=>{
                (0, $6uWhG.setMark)('BROWSER_METRICS_TTI_TASK_END');
                (0, $6uWhG.setMeasure)('BROWSER_METRICS_TTI_TASK', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_TASK_END');
            });
            requestAnimationFrame(()=>{
                metric.mark((0, $fcc2379b1f384e36$export$99c08ec92759c71c));
                (0, $6uWhG.setMark)((0, $fcc2379b1f384e36$export$99c08ec92759c71c));
                (0, $6uWhG.setMeasure)('BROWSER_METRICS_TTI_RAF', 'BROWSER_METRICS_TTI_START', (0, $fcc2379b1f384e36$export$99c08ec92759c71c));
                setTimeout(()=>{
                    $7986e193b27b5912$var$emitMetrics(metric, customData, stopTime);
                }, 500);
            });
        } else {
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: performance.now()
            });
            (0, $lOI8W.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $iEXnd.PRODUCT_START_MARK), true);
            $7986e193b27b5912$var$emitMetrics(metric, customData);
        }
    }
    static{
        this.contextType = (0, $7aoMz.default);
    }
    render() {
        return null;
    }
}

});
parcelRegister("iEXnd", function(module, exports) {
$parcel$export(module.exports, "PRODUCT_START_MARK", () => $528da7e985f30ee4$export$8e54fca0a680fdfd);
$parcel$export(module.exports, "MarkProductStart", () => $528da7e985f30ee4$export$2a999c5f84501025);

var $6uWhG = parcelRequire("6uWhG");
const $528da7e985f30ee4$export$8e54fca0a680fdfd = 'PRODUCT_START';
const $528da7e985f30ee4$export$2a999c5f84501025 = ()=>{
    if (!false) {
        performance.clearMarks($528da7e985f30ee4$export$8e54fca0a680fdfd);
        (0, $6uWhG.setMark)($528da7e985f30ee4$export$8e54fca0a680fdfd);
    }
    return null;
};

});

const $fcc2379b1f384e36$export$56940a9488e85199 = 'jira.fe.spa-';
const $fcc2379b1f384e36$export$45c4b6bf7935c69a = `${$fcc2379b1f384e36$export$56940a9488e85199}start`;
const $fcc2379b1f384e36$export$135c96ab5afee429 = 'ssr.spa.rendered';
const $fcc2379b1f384e36$export$ff834eccc35b9089 = 'appBundleReady';
const $fcc2379b1f384e36$export$86b05e34d462ead8 = 'prefetchApiReady';
const $fcc2379b1f384e36$export$d6a604a7d9a390fb = 'prefetchApiStart';
const $fcc2379b1f384e36$export$3ae43cc1782d058f = 'jswRenderStart';
const $fcc2379b1f384e36$export$363f6703ffa600be = 'jswCreateReduxStoreStart';
const $fcc2379b1f384e36$export$e87b74567b79c8 = 'jswCreateReduxStoreEnd';
const $fcc2379b1f384e36$export$99fe642459a8b02 = 'jswTransformCriticalDataStart';
const $fcc2379b1f384e36$export$ab1f5705fc8e0571 = 'jswTransformCriticalDataEnd';
const $fcc2379b1f384e36$export$8c3a9046da692c35 = 'jswReduxSoftwareAppLoadedStart';
const $fcc2379b1f384e36$export$5aa497d1efdcc5bf = 'jswReduxSoftwareAppLoadedEnd';
const $fcc2379b1f384e36$export$99c08ec92759c71c = 'tti-raf-mark';
const $fcc2379b1f384e36$export$48552baa9db8ce1d = 'tti-raf';


parcelRegister("CkF8u", function(module, exports) {
$parcel$export(module.exports, "StopUfo", () => $f04c01c7c6bf4310$export$d91154f099475c5);

var $eJOHy = parcelRequire("eJOHy");

var $7aoMz = parcelRequire("7aoMz");

var $ioEQd = parcelRequire("ioEQd");
class $f04c01c7c6bf4310$export$d91154f099475c5 extends (0, $eJOHy.Component) {
    componentDidMount() {
        const { customData: customData, appName: appName } = this.props;
        (0, $ioEQd.GlobalPageLoadExperience).success({
            force: true,
            metadata: customData
        });
        const name = appName || (0, $ioEQd.GlobalPageLoadExperience).loadingPageLoadId;
        if (name) this.context?.addApdex({
            key: name,
            stopTime: performance.now()
        });
    }
    static{
        this.contextType = (0, $7aoMz.default);
    }
    render() {
        return null;
    }
}

});

parcelRegister("iAPDN", function(module, exports) {
$parcel$export(module.exports, "addBM3SSRDoneAsFMPToInteraction", () => $4d28fc5eaea80e10$export$bf239ac2bfb04967);

var $kVpZx = parcelRequire("kVpZx");

var $2QO3b = parcelRequire("2QO3b");
function $4d28fc5eaea80e10$export$bf239ac2bfb04967(metric) {
    const interactionId = (0, $kVpZx.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const data = metric.getData();
    // Use BM3 SSR mark as FMP config for UFO if it exists, temporarily.
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const config = data?.config;
    if (config && data?.isInitial) (0, $2QO3b.addMetadata)(currentInteractionId, {
        __legacy__bm3ConfigSSRDoneAsFmp: config.ssr?.doneAsFmp || false
    });
}

});

parcelRegister("4WwFo", function(module, exports) {
$parcel$export(module.exports, "addUFOSSRDoneAsFMPToInteraction", () => $3d02e80116d345ab$export$e63862cd888fe05a);

var $kVpZx = parcelRequire("kVpZx");

var $2QO3b = parcelRequire("2QO3b");

var $ioEQd = parcelRequire("ioEQd");
var $8tVkR = parcelRequire("8tVkR");
async function $3d02e80116d345ab$export$e63862cd888fe05a() {
    const interactionId = (0, $kVpZx.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    // Use UFO SSR mark as FMP config for rUFO if it exists, temporarily.
    const data = await (0, $ioEQd.GlobalPageLoadExperience).exportData();
    const fmpMark = data.metrics.marks.find((mark)=>mark.name === 'fmp') || (0, $8tVkR.payloadPublisher).ssr?.getDoneMark();
    if (data.initial && fmpMark) (0, $2QO3b.addMetadata)(currentInteractionId, {
        __legacy__ufoConfigSSRDoneAsFmp: true
    });
}

});

parcelRegister("cllya", function(module, exports) {
$parcel$export(module.exports, "trackBM3FeatureFlagsAccessed", () => $eaa2e9e24133f900$export$f00f1e874ce869e9);

var $kVpZx = parcelRequire("kVpZx");

var $j500r = parcelRequire("j500r");

var $4cTDP = parcelRequire("4cTDP");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $eaa2e9e24133f900$var$startsAsObject = (value)=>{
    try {
        if (value.charAt(0) === '{') return true;
    } catch (e) {
        return false;
    }
    return false;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $eaa2e9e24133f900$var$isObject = (value)=>value && typeof value === 'object' && value.constructor === Object;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $eaa2e9e24133f900$var$isString = (input)=>{
    let result;
    try {
        result = typeof input === 'string' || input instanceof String;
    } catch (err) {
        // swallow any errors
        result = false;
    }
    return result;
};
const $eaa2e9e24133f900$export$7b4abba432e57989 = (value)=>$eaa2e9e24133f900$var$isString(value) && $eaa2e9e24133f900$var$startsAsObject(value) || $eaa2e9e24133f900$var$isObject(value);
const $eaa2e9e24133f900$export$fcc03ee4c944962f = (featureFlagValue)=>$eaa2e9e24133f900$export$7b4abba432e57989(featureFlagValue) ? 'non_boolean' : featureFlagValue;
const $eaa2e9e24133f900$export$d2818866b4acbea4 = new Map();
const $eaa2e9e24133f900$export$f00f1e874ce869e9 = (metric)=>{
    if ((0, $4cTDP.fg)('jfp-magma-remove-ld-client')) return;
    const interactionId = (0, $kVpZx.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const data = metric.getData();
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const config = data?.config;
    if (config && config?.featureFlags?.length) {
        const allFeatureFlags = (0, $j500r.default)();
        config.featureFlags.forEach((featureFlagName)=>{
            const value = allFeatureFlags[featureFlagName];
            if (value === undefined) return;
            const featureFlagValue = $eaa2e9e24133f900$export$fcc03ee4c944962f(value);
            $eaa2e9e24133f900$export$d2818866b4acbea4.set(featureFlagName, featureFlagValue);
        });
    }
};

});



parcelRegister("jNw3G", function(module, exports) {
$parcel$export(module.exports, "AccessCheck", () => $4bdba1178c6ab13c$export$ad057184bf4c4ff2);

var $eYTt2 = parcelRequire("eYTt2");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $bnIBr = parcelRequire("bnIBr");

var $2mHfh = parcelRequire("2mHfh");
const $4bdba1178c6ab13c$var$getVersionIssuesUrl = (versionName, projectKey)=>{
    const jql = `project = ${(0, $bnIBr.toQuotedString)(projectKey)} AND fixVersion = ${(0, $bnIBr.toQuotedString)(versionName)}`;
    return (0, $bnIBr.createAllWorkUrl)(jql);
};
const $4bdba1178c6ab13c$export$ad057184bf4c4ff2 = ({ jiraVersion: jiraVersion, children: children })=>{
    const version = (0, $j4oe4.useFragment)((0, $eYTt2.default), jiraVersion);
    if (version != null && !version.canViewVersionDetailsPage) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mHfh.Redirect), {
        to: $4bdba1178c6ab13c$var$getVersionIssuesUrl(version.name, version.project.key)
    });
    return children;
};

});
parcelRegister("eYTt2", function(module, exports) {
$parcel$export(module.exports, "default", () => $d9eaa5f9b5ac6daa$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f4a1d76106d11af339bfdb2ce2d272cd>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $d9eaa5f9b5ac6daa$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "accessCheck_softwareReleasesVersionDetail",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "name"
            },
            "action": "NONE",
            "path": "name"
        },
        {
            "kind": "RequiredField",
            "field": {
                "concreteType": "JiraProject",
                "kind": "LinkedField",
                "name": "project",
                "plural": false,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "kind": "ScalarField",
                            "name": "key"
                        },
                        "action": "NONE",
                        "path": "project.key"
                    }
                ]
            },
            "action": "NONE",
            "path": "project"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "canViewVersionDetailsPage"
            },
            "action": "NONE",
            "path": "canViewVersionDetailsPage"
        }
    ],
    "type": "JiraVersion"
};
$d9eaa5f9b5ac6daa$var$node.hash = "9b2c4488974a4d13577b85807b03079a";
var $d9eaa5f9b5ac6daa$export$2e2bcd8739ae039 = $d9eaa5f9b5ac6daa$var$node;

});


parcelRegister("94bM3", function(module, exports) {
$parcel$export(module.exports, "Header", () => $6a214a5a5ef48197$export$8b251419efc915eb);

var $efJ52 = parcelRequire("efJ52");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $j4oe4 = parcelRequire("j4oe4");

var $48q59 = parcelRequire("48q59");

var $956it = parcelRequire("956it");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $h6slU = parcelRequire("h6slU");

var $gHI4w = parcelRequire("gHI4w");

var $aqnJa = parcelRequire("aqnJa");

var $2PjnU = parcelRequire("2PjnU");

var $jom8W = parcelRequire("jom8W");

var $klrth = parcelRequire("klrth");

var $9o4iM = parcelRequire("9o4iM");

var $b70fx = parcelRequire("b70fx");


var $488uu = parcelRequire("488uu");

var $jI8iD = parcelRequire("jI8iD");

var $ixtC2 = parcelRequire("ixtC2");

var $7jCAm = parcelRequire("7jCAm");
/**
 * This component is wraps header of the version detail page.
 *
 * When the gate is enabled, it applies a negative top margin to the header.
 */ const $6a214a5a5ef48197$var$VersionPageHeaderWrapper = ({ breadcrumbs: breadcrumbs, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $6a214a5a5ef48197$var$headerWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gHI4w.default), {
        breadcrumbs: breadcrumbs,
        truncateTitle: true,
        disableTitleStyles: true
    }, children));
};
const $6a214a5a5ef48197$export$8b251419efc915eb = ({ jiraVersion: jiraVersion, shouldShowBreadcrumbs: shouldShowBreadcrumbs = true, shouldShowFeedbackButton: shouldShowFeedbackButton = true, shouldShowAutomationButton: shouldShowAutomationButton = true, shouldShowGraphButton: shouldShowGraphButton = true })=>{
    const breadcrumbs = shouldShowBreadcrumbs ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h6slU.default), null) : null;
    const onConnectAppExpFail = (0, $aqnJa.useExperienceFail)({
        experience: (0, $5e35924307df60cd$export$af5e668651a80140)
    });
    const [warningsModalOpen, setWarningsModalOpen] = (0, $eJOHy.useState)(false);
    const [isEditing, setIsEditing] = (0, $eJOHy.useState)(false);
    const version = (0, $j4oe4.useFragment)((0, $efJ52.default), jiraVersion);
    const issues = version.allIssues.totalCount;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($6a214a5a5ef48197$var$VersionPageHeaderWrapper, {
        breadcrumbs: breadcrumbs
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($6a214a5a5ef48197$var$HeaderTitleLane, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($6a214a5a5ef48197$var$LeftContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($6a214a5a5ef48197$var$HeaderTitle, {
        "data-testid": "software-releases-version-detail.ui.header.title"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($6a214a5a5ef48197$var$PageTitleContainer, {
        isOverflowEnabled: isEditing
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jI8iD.AsyncEditableName), {
        isEditing: isEditing,
        setIsEditing: setIsEditing,
        jiraVersion: version
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($6a214a5a5ef48197$var$RightContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $48q59.default), null, shouldShowGraphButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2PjnU.default), {
        from: version.id
    }), shouldShowFeedbackButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $b70fx.NonCriticalErrorBoundary), {
        fallback: "flag",
        eventLocation: "feedbackButton"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ixtC2.FeedbackButton), null)), shouldShowAutomationButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $b70fx.NonCriticalErrorBoundary), {
        fallback: "unmount",
        eventLocation: "releaseAutomationMenu"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $klrth.default), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $956it.default), null, warningsModalOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $b70fx.NonCriticalErrorBoundary), {
        fallback: "flag",
        eventLocation: "warningConfigModal"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9o4iM.ManageWarningsModal), {
        jiraVersion: version,
        setModalClosed: ()=>{
            setWarningsModalOpen(false);
        }
    }))), !(0, $jom8W.isDevopsFeatureDisabledInFedRamp)() && issues > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7jCAm.ReleaseNotesButton), {
        jiraVersion: version
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $b70fx.NonCriticalErrorBoundary), {
        fallback: "flag",
        eventLocation: "headerConnectApps",
        onError: onConnectAppExpFail
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($6a214a5a5ef48197$var$MarketPlaceAddonLane, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $488uu.ConnectApps), {
        jiraVersion: version
    }))));
};
const $6a214a5a5ef48197$var$headerWrapperStyles = (0, $1DXK0.xcss)({
    marginBlockStart: 'space.negative.150'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6a214a5a5ef48197$var$HeaderTitleLane = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1h6o _1bah1yb4 _1p57pxbi",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6a214a5a5ef48197$var$LeftContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_16jlkb7n _18u0x0bf _1ul9idpf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6a214a5a5ef48197$var$RightContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_16jlkb7n _1e0c1txw _1bahesu3 _1ul91mjv",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6a214a5a5ef48197$var$MarketPlaceAddonLane = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _2lx21bp4 _4cvresu3",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6a214a5a5ef48197$var$HeaderTitle = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1h6o _1ul9idpf _4t3ior1b",
            __cmplp.className
        ])
    });
});
const $6a214a5a5ef48197$var$PageTitleContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isOverflowEnabled: isOverflowEnabled, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19pkx0bf _1ul9idpf",
            __cmplp.isOverflowEnabled ? "_1reoewfl _18m9ewfl" : "_1reo15vq _18m915vq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("efJ52", function(module, exports) {
$parcel$export(module.exports, "default", () => $6694a0d2c5bc2f93$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<edd2d889f15c331ccb875f58c8834595>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $6694a0d2c5bc2f93$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "header_softwareReleasesVersionDetail",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "id"
            },
            "action": "THROW",
            "path": "id"
        },
        {
            "kind": "RequiredField",
            "field": {
                "alias": "allIssues",
                "args": [
                    {
                        "kind": "Literal",
                        "name": "filter",
                        "value": "ALL"
                    }
                ],
                "concreteType": "JiraIssueConnection",
                "kind": "LinkedField",
                "name": "issues",
                "plural": false,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "kind": "ScalarField",
                            "name": "totalCount"
                        },
                        "action": "THROW",
                        "path": "allIssues.totalCount"
                    }
                ],
                "storageKey": "issues(filter:\"ALL\")"
            },
            "action": "THROW",
            "path": "allIssues"
        },
        {
            "kind": "FragmentSpread",
            "name": "async_softwareReleasesVersionDetail_AsyncEditableName"
        },
        {
            "kind": "FragmentSpread",
            "name": "ui_softwareReleasesManageWarnings_ManageWarningsModal"
        },
        {
            "kind": "FragmentSpread",
            "name": "connectApps_softwareReleasesVersionDetail"
        },
        {
            "kind": "FragmentSpread",
            "name": "releaseNotesButton_softwareReleasesVersionDetail"
        }
    ],
    "type": "JiraVersion"
};
$6694a0d2c5bc2f93$var$node.hash = "f18c07820c274d0155b6bcd5afb8be06";
var $6694a0d2c5bc2f93$export$2e2bcd8739ae039 = $6694a0d2c5bc2f93$var$node;

});

parcelRegister("2PjnU", function(module, exports) {
$parcel$export(module.exports, "default", () => $f62e1e8847911931$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $goZPP = parcelRequire("goZPP");

var $f2JN3 = parcelRequire("f2JN3");

var $4cTDP = parcelRequire("4cTDP");

var $lRq8t = parcelRequire("lRq8t");

var $jom8W = parcelRequire("jom8W");

var $koAZ4 = parcelRequire("koAZ4");


var $chNpc = parcelRequire("chNpc");

var $4vdPy = parcelRequire("4vdPy");
function $f62e1e8847911931$var$Graph({ from: from }) {
    const { environment: environment } = (0, $koAZ4.useTenantContext)();
    const graphURL = `${environment === 'staging' ? (0, $46bd8a0acba248e4$export$b1c73a3711ffd2e1) : (0, $46bd8a0acba248e4$export$b105bca7736ab247)}?ari=${from}`;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        href: graphURL,
        "aria-label": formatMessage((0, $4vdPy.default).graphButtonLabelNonFinal),
        target: "_blank",
        appearance: "subtle",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $chNpc.GraphIcon), null)
    });
}
// eslint-disable-next-line camelcase
const $f62e1e8847911931$var$_default_1 = (0, $f2JN3.componentWithCondition)(()=>!(0, $jom8W.isDevopsFeatureDisabledInFedRamp)() && (0, $4cTDP.fg)('otc-show-me-the-graph'), $f62e1e8847911931$var$Graph, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
()=>null);
var // eslint-disable-next-line camelcase
$f62e1e8847911931$export$2e2bcd8739ae039 = $f62e1e8847911931$var$_default_1;

});
const $46bd8a0acba248e4$export$b105bca7736ab247 = 'https://atlassian-graph.prod-east.frontend.public.atl-paas.net/';
const $46bd8a0acba248e4$export$b1c73a3711ffd2e1 = 'https://atlassian-graph.stg-east.frontend.public.atl-paas.net/';

parcelRegister("chNpc", function(module, exports) {
$parcel$export(module.exports, "GraphIcon", () => $bc9c4256071ef714$export$717a5ffb6a14ac74);

var $eJOHy = parcelRequire("eJOHy");
const $bc9c4256071ef714$export$717a5ffb6a14ac74 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        fill: "var(--ds-icon-discovery, #AF59E1)",
        viewBox: "0 0 256 256"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M200,152a31.84,31.84,0,0,0-19.53,6.68l-23.11-18A31.65,31.65,0,0,0,160,128c0-.74,0-1.48-.08-2.21l13.23-4.41A32,32,0,1,0,168,104c0,.74,0,1.48.08,2.21l-13.23,4.41A32,32,0,0,0,128,96a32.59,32.59,0,0,0-5.27.44L115.89,81A32,32,0,1,0,96,88a32.59,32.59,0,0,0,5.27-.44l6.84,15.4a31.92,31.92,0,0,0-8.57,39.64L73.83,165.44a32.06,32.06,0,1,0,10.63,12l25.71-22.84a31.91,31.91,0,0,0,37.36-1.24l23.11,18A31.65,31.65,0,0,0,168,184a32,32,0,1,0,32-32Zm0-64a16,16,0,1,1-16,16A16,16,0,0,1,200,88ZM80,56A16,16,0,1,1,96,72,16,16,0,0,1,80,56ZM56,208a16,16,0,1,1,16-16A16,16,0,0,1,56,208Zm144-8a16,16,0,1,1,16-16A16,16,0,0,1,200,200Z"
    }));

});

parcelRegister("4vdPy", function(module, exports) {
$parcel$export(module.exports, "default", () => $ae37dbcf4f5e3a58$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $ae37dbcf4f5e3a58$var$messages = (0, $7qGN1.defineMessages)({
    graphButtonLabelNonFinal: {
        "id": "graph.graph-button-label-non-final",
        "defaultMessage": "Open the graph"
    }
});
var $ae37dbcf4f5e3a58$export$2e2bcd8739ae039 = $ae37dbcf4f5e3a58$var$messages;

});


parcelRegister("klrth", function(module, exports) {
$parcel$export(module.exports, "default", () => $f033c70c7ada1993$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $fL0In = parcelRequire("fL0In");

var $c3rOS = parcelRequire("c3rOS");

var $2imLM = parcelRequire("2imLM");

var $bQWwW = parcelRequire("bQWwW");

var $6ltVs = parcelRequire("6ltVs");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $f033c70c7ada1993$var$AutomationMenu = (0, $bQWwW.lazy)(()=>(parcelRequire("jvEp3")), {
    moduleId: "./src/packages/releases/automation-menu/src/ContextAwareAutomationMenu.tsx"
});
const $f033c70c7ada1993$var$fallback = // eslint-disable-next-line jira/integration/test-id-by-folder-structure
/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6ltVs.IconWrapper), {
    "data-testid": "jira-releases-automation-menu.ui.automation-button.disabled"
}, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fL0In.default), {
    glyph: (0, $c3rOS.AutomationGlyph),
    label: ""
}));
const $f033c70c7ada1993$var$AsyncReleaseAutomationMenu = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "releases-automation-menu",
        fallback: $f033c70c7ada1993$var$fallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f033c70c7ada1993$var$AutomationMenu, null));
var $f033c70c7ada1993$export$2e2bcd8739ae039 = $f033c70c7ada1993$var$AsyncReleaseAutomationMenu;

});
parcelRegister("c3rOS", function(module, exports) {
$parcel$export(module.exports, "AutomationGlyph", () => $ca1b0bbb2612bc73$export$3b6023946faff8bc);
$parcel$export(module.exports, "default", () => $ca1b0bbb2612bc73$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react-component-props

var $eJOHy = parcelRequire("eJOHy");

var $fL0In = parcelRequire("fL0In");

var $dtpha = parcelRequire("dtpha");

var $bJscI = parcelRequire("bJscI");
const $ca1b0bbb2612bc73$export$3b6023946faff8bc = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M14 5L10 19",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M14 5L7 12H17L10 19",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }));
const $ca1b0bbb2612bc73$var$AutomationLegacyIcon = ()=>// eslint-disable-next-line @atlaskit/design-system/no-custom-icons
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fL0In.default), {
        glyph: $ca1b0bbb2612bc73$export$3b6023946faff8bc,
        label: "",
        primaryColor: "var(--ds-icon-brand, #1868DB)"
    });
var $ca1b0bbb2612bc73$export$2e2bcd8739ae039 = (0, $bJscI.componentWithFG)('enghealth-custom-icon-migration', (0, (/*@__PURE__*/$parcel$interopDefault($dtpha))), $ca1b0bbb2612bc73$var$AutomationLegacyIcon);

});
parcelRegister("dtpha", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3ee248cff197501222c434364c4f923a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9cf1970ee03bcd13$var$_react = $9cf1970ee03bcd13$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $9cf1970ee03bcd13$var$_baseNew = $9cf1970ee03bcd13$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $9cf1970ee03bcd13$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Automation".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved to represent an Automation.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9cf1970ee03bcd13$var$AutomationIcon = (props)=>/*#__PURE__*/ $9cf1970ee03bcd13$var$_react.default.createElement($9cf1970ee03bcd13$var$_baseNew.default, Object.assign({
        name: "AutomationIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M10.377.102a.75.75 0 0 1 .346.847L8.985 7.25h4.265a.75.75 0 0 1 .53 1.28l-7.25 7.25a.75.75 0 0 1-1.253-.73l1.738-6.3H2.75a.75.75 0 0 1-.53-1.28L9.47.22a.75.75 0 0 1 .907-.118M7.43 7.25l1.093-3.96L4.56 7.25zm1.142 1.5-1.093 3.96 3.961-3.96z" clip-rule="evenodd"/>`
    }, props));
$9cf1970ee03bcd13$var$AutomationIcon.displayName = 'AutomationIcon';
var $9cf1970ee03bcd13$var$_default = module.exports.default = $9cf1970ee03bcd13$var$AutomationIcon;

});


parcelRegister("6ltVs", function(module, exports) {
$parcel$export(module.exports, "IconWrapper", () => $564e34119c0d4425$export$be58b4326e23250f);
$parcel$export(module.exports, "default", () => $564e34119c0d4425$export$2e2bcd8739ae039);
/* AutomationMenu.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable jira/integration/test-id-by-folder-structure */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $lT9x0 = parcelRequire("lT9x0");

var $FhXEJ = parcelRequire("FhXEJ");

var $806LH = parcelRequire("806LH");

var $fL0In = parcelRequire("fL0In");

var $jUgeq = parcelRequire("jUgeq");
var $6YEko = parcelRequire("6YEko");

var $54CI2 = parcelRequire("54CI2");
var $guChT = parcelRequire("guChT");

var $k71qx = parcelRequire("k71qx");

var $cxKOj = parcelRequire("cxKOj");

var $4cTDP = parcelRequire("4cTDP");

var $c3rOS = parcelRequire("c3rOS");

var $gPZN1 = parcelRequire("gPZN1");

var $lRq8t = parcelRequire("lRq8t");

var $8nMzv = parcelRequire("8nMzv");

var $bs3wd = parcelRequire("bs3wd");

var $iCv9u = parcelRequire("iCv9u");

var $hPfix = parcelRequire("hPfix");
// eslint-disable-next-line @atlaskit/design-system/no-custom-icons
const $564e34119c0d4425$var$automationIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fL0In.default), {
    glyph: (0, $c3rOS.AutomationGlyph),
    label: ""
});
const $564e34119c0d4425$var$AutomationMenuContent = (props)=>{
    const { projectType: projectType } = props;
    const intl = (0, $lRq8t.default)();
    return projectType === (0, $FhXEJ.SOFTWARE_PROJECT) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($564e34119c0d4425$var$MenuContentWrapper, {
        "data-testid": "jira-releases-automation-menu.ui.automation-menu-content"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($564e34119c0d4425$var$MenuTitle, null, intl.formatMessage((0, $hPfix.default).automationMenuTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($564e34119c0d4425$var$MenuSubTitle, null, intl.formatMessage((0, $hPfix.default).automationMenuSubTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jUgeq.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iCv9u.AutomationMenuTemplateRules), props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6YEko.default), {
        hasSeparator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bs3wd.AutomationMenuDeepLinks), {
        includeDiscoverAutomation: false,
        ...props
    })))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bs3wd.AutomationMenuDeepLinks), {
        includeDiscoverAutomation: true,
        ...props
    });
};
const $564e34119c0d4425$export$bf60e24e2fb3b05d = ({ isMenuEnabled: isMenuEnabled, projectProps: projectProps, isOpenByDefault: isOpenByDefault })=>{
    const disabledAutomationMenuButtonTooltipMessageGalaxia = (0, $cxKOj.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $hPfix.default).disabledAutomationMenuButtonTooltipMessageGalaxia : (0, $hPfix.default).disabledAutomationMenuButtonTooltipMessage;
    const [isOpen, setIsOpen] = (0, $eJOHy.useState)(isOpenByDefault ?? false);
    const intl = (0, $lRq8t.default)();
    return isMenuEnabled && projectProps ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $54CI2.default), {
        blanketIsTinted: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $guChT.default), {
        name: "fusionReleaseAutomationMenu"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nMzv.JiraPopup), {
        isOpen: isOpen,
        onClose: ()=>setIsOpen(false),
        placement: "bottom-end",
        messageId: "software-releases-automation-menu.ui.popup",
        messageType: "transactional",
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($564e34119c0d4425$var$AutomationMenuContent, {
                projectKey: projectProps.projectKey,
                projectType: projectProps.projectType,
                isSimplifiedProject: projectProps.isSimplifiedProject
            }),
        trigger: ({ ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
                "data-testid": "jira-releases-automation-menu.ui.automation-button.enabled"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gPZN1.default), {
                ...triggerProps,
                onClick: ()=>setIsOpen(!isOpen),
                isSelected: isOpen
            }))
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lT9x0.EngagementSpotlight), {
        name: "fusionReleaseAutomationMenu"
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($564e34119c0d4425$export$be58b4326e23250f, {
        "data-testid": "jira-releases-automation-menu.ui.automation-button.disabled"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        position: "top",
        content: intl.formatMessage(disabledAutomationMenuButtonTooltipMessageGalaxia)
    }, $564e34119c0d4425$var$automationIcon));
};
var $564e34119c0d4425$export$2e2bcd8739ae039 = $564e34119c0d4425$export$bf60e24e2fb3b05d;
const $564e34119c0d4425$var$MenuTitle = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $806LH.default), {
        as: (0, $4cTDP.fg)('jfp_a11y_autodev_fix_releases_automation_heading') ? 'h2' : 'h4',
        size: "small"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($564e34119c0d4425$var$MenuTitleComponent, props)); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $564e34119c0d4425$var$MenuContentWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1bsb1kdj",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $564e34119c0d4425$var$MenuSubTitle = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_syaz1rpy _ca0qidpf _u5f38vuz _n3tdpxbi _19bv1ejb",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $564e34119c0d4425$export$be58b4326e23250f = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1h6o _4t3i1f4h _1bsb1f4h _1bah1h6o _syaz2sac _ca0q1b66 _d0al13gf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $564e34119c0d4425$var$MenuTitleComponent = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_ca0q1ejb _u5f3idpf _n3tdu2gc _19bv1ejb",
            __cmplp.className
        ])
    });
});

});
parcelRegister("gPZN1", function(module, exports) {
$parcel$export(module.exports, "default", () => $496834f22af921da$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $dtpha = parcelRequire("dtpha");

var $k71qx = parcelRequire("k71qx");

var $lRq8t = parcelRequire("lRq8t");

var $kRgKj = parcelRequire("kRgKj");

var $cJEMq = parcelRequire("cJEMq");

var $cfUHE = parcelRequire("cfUHE");
const $496834f22af921da$var$MenuButton = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ isSelected: isSelected, onClick: onClick }, ref)=>{
    const automationIconTestId = 'automation-menu.ui.button.icon';
    const onClickWithAnalytics = (0, $eJOHy.useCallback)((event, analytics)=>{
        (0, $kRgKj.fireUIAnalytics)(analytics, 'automationMenuButton');
        onClick();
    }, [
        onClick
    ]);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: formatMessage((0, $cfUHE.default).menuButtonTooltip),
        position: "top",
        isScreenReaderAnnouncementDisabled: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cJEMq.ThemedButton), {
        ref: ref,
        appearance: "default",
        onClick: onClickWithAnalytics,
        isSelected: isSelected,
        testId: "automation-menu.ui.button.menu-button",
        id: "automation-menu.ui.popup",
        "data-vc": "automation-menu-button",
        // @ts-expect-error - externalId does not exist on Button types
        externalId: "automation-menu.ui.button.menu-button",
        "aria-label": formatMessage((0, $cfUHE.default).menuButtonTooltip),
        "aria-expanded": isSelected,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dtpha))), {
            label: "",
            color: "currentColor",
            spacing: "spacious",
            testId: automationIconTestId
        })
    }));
});
var $496834f22af921da$export$2e2bcd8739ae039 = $496834f22af921da$var$MenuButton;

});
parcelRegister("cfUHE", function(module, exports) {
$parcel$export(module.exports, "default", () => $cd89adf9379e4d41$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $cd89adf9379e4d41$var$messages = (0, $7qGN1.defineMessages)({
    menuButtonTooltip: {
        "id": "automation-menu.button.menu-button-tooltip",
        "defaultMessage": "Automation"
    },
    automationsMenuButtonIcon: {
        "id": "automation-menu.button.automations-menu-button-icon",
        "defaultMessage": "automations-menu-button-icon"
    }
});
var $cd89adf9379e4d41$export$2e2bcd8739ae039 = $cd89adf9379e4d41$var$messages;

});


parcelRegister("bs3wd", function(module, exports) {
$parcel$export(module.exports, "AutomationMenuDeepLinks", () => $c5140facf63ab2e3$export$fd3c4b1ddf70f790);

var $eJOHy = parcelRequire("eJOHy");

var $fL0In = parcelRequire("fL0In");

var $hotVs = parcelRequire("hotVs");

var $dcLzM = parcelRequire("dcLzM");

var $i5stJ = parcelRequire("i5stJ");

var $f58rc = parcelRequire("f58rc");
var $jUgeq = parcelRequire("jUgeq");

var $c3rOS = parcelRequire("c3rOS");

var $lRq8t = parcelRequire("lRq8t");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $7ueGY = parcelRequire("7ueGY");

var $kslWz = parcelRequire("kslWz");
// eslint-disable-next-line @atlaskit/design-system/no-custom-icons
const $c5140facf63ab2e3$var$automationIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fL0In.default), {
    glyph: (0, $c3rOS.AutomationGlyph),
    label: ""
});
const $c5140facf63ab2e3$export$fd3c4b1ddf70f790 = ({ isSimplifiedProject: isSimplifiedProject, projectKey: projectKey, projectType: projectType, includeDiscoverAutomation: includeDiscoverAutomation })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const analyticsEvent = createAnalyticsEvent({
        action: 'clicked',
        actionSubject: 'link'
    });
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return(// eslint-disable-next-line jira/integration/test-id-by-folder-structure
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        "data-testid": "jira-releases-automation-menu.ui.automation-menu-content"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jUgeq.default), null, includeDiscoverAutomation ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $f58rc.default), {
        href: (0, $7ueGY.buildDiscoverAutomationUrl)({
            projectKey: projectKey,
            projectType: projectType,
            isSimplified: isSimplifiedProject
        }),
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hotVs))), {
            spacing: "spacious",
            label: ""
        }),
        onClick: ()=>(0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'discoverAutomationLink'),
        UNSAFE_shouldDisableRouterLink: true
    }, formatMessage((0, $kslWz.default).discoverAutomationMenuItemLabel)) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $f58rc.default), {
        href: (0, $7ueGY.buildManageRulesAutomationUrl)({
            projectKey: projectKey,
            projectType: projectType,
            isSimplified: isSimplifiedProject
        }),
        iconBefore: $c5140facf63ab2e3$var$automationIcon,
        onClick: ()=>(0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'manageRulesAutomationLink'),
        UNSAFE_shouldDisableRouterLink: true
    }, formatMessage((0, $kslWz.default).manageAutomationMenuItemLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $f58rc.default), {
        href: (0, $7ueGY.buildNewRuleAutomationUrl)({
            projectKey: projectKey,
            projectType: projectType,
            isSimplified: isSimplifiedProject
        }),
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dcLzM))), {
            spacing: "spacious",
            label: ""
        }),
        onClick: ()=>(0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'newRuleAutomationLink'),
        UNSAFE_shouldDisableRouterLink: true
    }, formatMessage((0, $kslWz.default).createAutomationMenuItemLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $f58rc.default), {
        href: (0, $7ueGY.buildAuditLogAutomationUrl)({
            projectKey: projectKey,
            projectType: projectType,
            isSimplified: isSimplifiedProject
        }),
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($i5stJ))), {
            spacing: "spacious",
            label: ""
        }),
        onClick: ()=>(0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'auditLogAutomationLink'),
        UNSAFE_shouldDisableRouterLink: true
    }, formatMessage((0, $kslWz.default).auditLogAutomationMenuItemLabel)))));
};

});
parcelRegister("hotVs", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7c8995740853ab97fe18084a5e408e13>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ca9be42b139d01c6$var$_react = $ca9be42b139d01c6$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $ca9be42b139d01c6$var$_baseNew = $ca9be42b139d01c6$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $ca9be42b139d01c6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Compass".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: templates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ca9be42b139d01c6$var$CompassIcon = (props)=>/*#__PURE__*/ $ca9be42b139d01c6$var$_react.default.createElement($ca9be42b139d01c6$var$_baseNew.default, Object.assign({
        name: "CompassIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m11.78-3.78a.75.75 0 0 1 .155.834l-2 4.5a.75.75 0 0 1-.38.381l-4.5 2a.75.75 0 0 1-.99-.99l2-4.5a.75.75 0 0 1 .38-.38l4.5-2a.75.75 0 0 1 .835.154M6.992 8.051l.955.956-1.72.764zm2.016-.105-.956-.955 1.72-.765z" clip-rule="evenodd"/>`
    }, props));
$ca9be42b139d01c6$var$CompassIcon.displayName = 'CompassIcon';
var $ca9be42b139d01c6$var$_default = module.exports.default = $ca9be42b139d01c6$var$CompassIcon;

});

parcelRegister("7ueGY", function(module, exports) {
$parcel$export(module.exports, "buildNewRuleAutomationUrl", () => $b9fafa22ec337a46$export$d6be0a6034032add);
$parcel$export(module.exports, "buildManageRulesAutomationUrl", () => $b9fafa22ec337a46$export$fb714f787469e8b0);
$parcel$export(module.exports, "buildAuditLogAutomationUrl", () => $b9fafa22ec337a46$export$7d1590b2fb4dd741);
$parcel$export(module.exports, "buildDiscoverAutomationUrl", () => $b9fafa22ec337a46$export$51ac1eeac37070f8);
$parcel$export(module.exports, "buildTemplateRuleAutomationUrl", () => $b9fafa22ec337a46$export$82ce8540ef209720);

var $4ECjj = parcelRequire("4ECjj");
const $b9fafa22ec337a46$export$d6be0a6034032add = (projectProps)=>`${(0, $4ECjj.getBaseAutomationUrl)(projectProps)}#rule/new?componentFilterCriteria=RELEASE_MANAGEMENT_TRIGGERS`;
const $b9fafa22ec337a46$export$fb714f787469e8b0 = (projectProps)=>`${(0, $4ECjj.getBaseAutomationUrl)(projectProps)}#/rule-list`;
const $b9fafa22ec337a46$export$7d1590b2fb4dd741 = (projectProps)=>`${(0, $4ECjj.getBaseAutomationUrl)(projectProps)}#tab/audit-log`;
const $b9fafa22ec337a46$export$51ac1eeac37070f8 = (projectProps)=>`${(0, $4ECjj.getBaseAutomationUrl)(projectProps)}#/tab/rule-library`;
const $b9fafa22ec337a46$export$82ce8540ef209720 = (projectProps, templateId)=>`${(0, $4ECjj.getBaseAutomationUrl)(projectProps)}#/rule/template?templateId=${templateId}`;

});

parcelRegister("kslWz", function(module, exports) {
$parcel$export(module.exports, "default", () => $ca755e38da9d1b91$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $ca755e38da9d1b91$var$messages = (0, $7qGN1.defineMessages)({
    discoverAutomationMenuItemLabel: {
        "id": "software-releases-automation-menu.menu-contents.deep-links.discover-automation-menu-item-label",
        "defaultMessage": "Discover automation"
    },
    manageAutomationMenuItemLabel: {
        "id": "software-releases-automation-menu.menu-contents.deep-links.manage-automation-menu-item-label",
        "defaultMessage": "Manage automation"
    },
    createAutomationMenuItemLabel: {
        "id": "software-releases-automation-menu.menu-contents.deep-links.create-automation-menu-item-label",
        "defaultMessage": "Create automation"
    },
    auditLogAutomationMenuItemLabel: {
        "id": "software-releases-automation-menu.menu-contents.deep-links.audit-log-automation-menu-item-label",
        "defaultMessage": "Audit log"
    }
});
var $ca755e38da9d1b91$export$2e2bcd8739ae039 = $ca755e38da9d1b91$var$messages;

});


parcelRegister("iCv9u", function(module, exports) {
$parcel$export(module.exports, "AutomationMenuTemplateRules", () => $aa3634e9b5d95d3a$export$35643f531510af9e);
/* AutomationMenuTemplateRules.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $ePxSL = parcelRequire("ePxSL");

var $9AYOJ = parcelRequire("9AYOJ");

var $lgMTT = parcelRequire("lgMTT");

var $f58rc = parcelRequire("f58rc");

var $4cTDP = parcelRequire("4cTDP");

var $lRq8t = parcelRequire("lRq8t");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $g3SgD = parcelRequire("g3SgD");

var $ii9KA = parcelRequire("ii9KA");

var $7ueGY = parcelRequire("7ueGY");

var $kTLX4 = parcelRequire("kTLX4");
const $aa3634e9b5d95d3a$var$jiraIssuesIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9AYOJ))), {
    spacing: "spacious",
    label: ""
});
const $aa3634e9b5d95d3a$var$slackIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ii9KA.SlackGlyph), null);
const $aa3634e9b5d95d3a$var$launchDarklyGliph = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $g3SgD.LaunchDarklyGlyph), null);
const $aa3634e9b5d95d3a$var$ActionAndTriggerIcons = ({ trigger: trigger })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($aa3634e9b5d95d3a$var$IconShadow, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lgMTT.JiraIcon), {
        size: "small",
        appearance: "brand",
        testId: "software-releases-automation-menu.ui.menu-contents.template-rules.jira-icon",
        label: ""
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ePxSL))), {
        spacing: "spacious",
        label: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($aa3634e9b5d95d3a$var$IconShadow, null, trigger));
const $aa3634e9b5d95d3a$export$35643f531510af9e = (props)=>{
    const { isSimplifiedProject: isSimplifiedProject, projectKey: projectKey, projectType: projectType } = props;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const analyticsEvent = createAnalyticsEvent({
        action: 'clicked',
        actionSubject: 'link'
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $f58rc.default), {
        shouldTitleWrap: true,
        href: (0, $7ueGY.buildTemplateRuleAutomationUrl)({
            projectKey: projectKey,
            projectType: projectType,
            isSimplified: isSimplifiedProject
        }, 'software_template_14'),
        target: "_blank",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($aa3634e9b5d95d3a$var$ActionAndTriggerIcons, {
            trigger: $aa3634e9b5d95d3a$var$jiraIssuesIcon
        }),
        onClick: ()=>(0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'templateRuleAddVersionToInProgressIssue')
    }, formatMessage((0, $4cTDP.fg)('jira-issue-terminology-update-m4') ? (0, $kTLX4.default).templateRuleAddIssueToVersionOnVersionCreateIssueTerminologyRefreshM4 : (0, $kTLX4.default).templateRuleAddIssueToVersionOnVersionCreate)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $f58rc.default), {
        shouldTitleWrap: true,
        href: (0, $7ueGY.buildTemplateRuleAutomationUrl)({
            projectKey: projectKey,
            projectType: projectType,
            isSimplified: isSimplifiedProject
        }, 'devops_template_6'),
        target: "_blank",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($aa3634e9b5d95d3a$var$ActionAndTriggerIcons, {
            trigger: $aa3634e9b5d95d3a$var$launchDarklyGliph
        }),
        onClick: ()=>(0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'templateRuleCreateLaunchDarklyFlag')
    }, formatMessage((0, $kTLX4.default).templateRuleCreateLaunchDarklyFlagOnVersionCreate)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $f58rc.default), {
        shouldTitleWrap: true,
        href: (0, $7ueGY.buildTemplateRuleAutomationUrl)({
            projectKey: projectKey,
            projectType: projectType,
            isSimplified: isSimplifiedProject
        }, 'software_template_12'),
        target: "_blank",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($aa3634e9b5d95d3a$var$ActionAndTriggerIcons, {
            trigger: $aa3634e9b5d95d3a$var$slackIcon
        }),
        onClick: ()=>(0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'templateSendSlackMessageOnVersionRelease')
    }, formatMessage((0, $kTLX4.default).templateRuleSendSlackMessageOnVersionRelease)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $f58rc.default), {
        shouldTitleWrap: true,
        href: (0, $7ueGY.buildTemplateRuleAutomationUrl)({
            projectKey: projectKey,
            projectType: projectType,
            isSimplified: isSimplifiedProject
        }, 'software_template_13'),
        target: "_blank",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($aa3634e9b5d95d3a$var$ActionAndTriggerIcons, {
            trigger: $aa3634e9b5d95d3a$var$slackIcon
        }),
        onClick: ()=>(0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'templateSendSlackMessageOnVersionUnRelease')
    }, formatMessage((0, $kTLX4.default).templateRuleSendSlackMessageOnVersionUnRelease)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($aa3634e9b5d95d3a$var$DiscoverAutomationLink, {
        href: (0, $7ueGY.buildDiscoverAutomationUrl)({
            projectKey: projectKey,
            projectType: projectType,
            isSimplified: isSimplifiedProject
        }),
        onClick: ()=>(0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'discoverAutomationLink')
    }, formatMessage((0, $kTLX4.default).discoverMoreAutomationMenuItemLabel)));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $aa3634e9b5d95d3a$var$IconShadow = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rko12b0 _4t3izwfg _1bsbzwfg _16qst7xp _1e0c1txw _4cvr1h6o _1bah1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $aa3634e9b5d95d3a$var$DiscoverAutomationLink = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_ca0qpxbi _u5f3idpf _n3tdpxbi _19bv1ejb",
            __cmplp.className
        ])
    });
});

});
parcelRegister("g3SgD", function(module, exports) {
$parcel$export(module.exports, "LaunchDarklyGlyph", () => $56391f2bc3f882c4$export$f1f691d73572fca1);
// eslint-disable-next-line jira/restricted/react-component-props

var $eJOHy = parcelRequire("eJOHy");
const $56391f2bc3f882c4$export$f1f691d73572fca1 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("g", {
        transform: "matrix(0.11111112 0 0 0.11111112 -0 0.058888756)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M109.8 214.94C 107.997055 214.91039 106.35804 213.88696 105.54 212.28C 104.73658 210.72453 104.908226 208.84428 105.98 207.45999L105.98 207.45999L156.47 137.93L68 174.11C 67.40301 174.38016 66.75528 174.51993 66.1 174.52C 64.01144 174.4985 62.179775 173.12071 61.579998 171.12001C 60.985783 169.13066 61.80725 166.99075 63.579998 165.91L63.579998 165.91L141.33 120L4.41 112.13C 1.9438841 111.9687 0.026099205 109.92138 0.026099205 107.45C 0.026099205 104.978615 1.9438841 102.9313 4.41 102.77L4.41 102.77L141.41 94.899994L63.61 49C 61.861492 47.905083 61.065918 45.772614 61.670002 43.8C 62.260277 41.79695 64.09185 40.41616 66.18 40.399998C 66.83458 40.396626 67.482346 40.532997 68.08 40.8L68.08 40.8L156.5 77L106 7.48C 104.93831 6.087954 104.76732 4.210975 105.56 2.65C 106.37893 1.0358694 108.03006 0.013560295 109.84 0C 111.078804 0.0081067085 112.26174 0.516624 113.119995 1.41L113.119995 1.41L213.77 102.05C 216.74506 105.03536 216.74506 109.86465 213.77 112.850006L213.77 112.850006L113.08 213.53C 112.22175 214.42337 111.03882 214.93188 109.8 214.94z",
        stroke: "none",
        fill: "#282828",
        fillRule: "nonzero"
    })));

});

parcelRegister("ii9KA", function(module, exports) {
$parcel$export(module.exports, "SlackGlyph", () => $e591a3e0faa7b638$export$cbfabcc4325ad3ff);
// It doesn't make sense to convert Slack icon into our token, as Slack icon is a unique brand. Confirmed that it looks great in DarkMode without tokens.
// eslint-disable-next-line jira/restricted/react-component-props

var $eJOHy = parcelRequire("eJOHy");
const $e591a3e0faa7b638$export$cbfabcc4325ad3ff = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M0 3C0 1.34315 1.34315 0 3 0H21C22.6569 0 24 1.34315 24 3V21C24 22.6569 22.6569 24 21 24H3C1.34315 24 0 22.6569 0 21V3Z",
        fill: "white",
        fillOpacity: "0.01"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M6.78559 14.3429C6.78559 15.3857 5.94273 16.2286 4.89987 16.2286C3.85702 16.2286 3.01416 15.3857 3.01416 14.3429C3.01416 13.3 3.85702 12.4572 4.89987 12.4572H6.78559V14.3429ZM7.72845 14.3429C7.72845 13.3 8.5713 12.4572 9.61416 12.4572C10.657 12.4572 11.4999 13.3 11.4999 14.3429V19.0572C11.4999 20.1 10.657 20.9429 9.61416 20.9429C8.5713 20.9429 7.72845 20.1 7.72845 19.0572V14.3429Z",
        fill: "#E01E5A"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M9.61429 6.77143C8.57143 6.77143 7.72857 5.92857 7.72857 4.88571C7.72857 3.84286 8.57143 3 9.61429 3C10.6571 3 11.5 3.84286 11.5 4.88571V6.77143H9.61429ZM9.61429 7.72857C10.6571 7.72857 11.5 8.57143 11.5 9.61429C11.5 10.6571 10.6571 11.5 9.61429 11.5H4.88571C3.84286 11.5 3 10.6571 3 9.61429C3 8.57143 3.84286 7.72857 4.88571 7.72857H9.61429Z",
        fill: "#36C5F0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M17.1713 9.61429C17.1713 8.57143 18.0142 7.72857 19.057 7.72857C20.0999 7.72857 20.9427 8.57143 20.9427 9.61429C20.9427 10.6571 20.0999 11.5 19.057 11.5H17.1713V9.61429ZM16.2285 9.61429C16.2285 10.6571 15.3856 11.5 14.3427 11.5C13.2999 11.5 12.457 10.6571 12.457 9.61429V4.88571C12.457 3.84286 13.2999 3 14.3427 3C15.3856 3 16.2285 3.84286 16.2285 4.88571V9.61429Z",
        fill: "#2EB67D"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M14.3427 17.1714C15.3856 17.1714 16.2285 18.0143 16.2285 19.0572C16.2285 20.1 15.3856 20.9429 14.3427 20.9429C13.2999 20.9429 12.457 20.1 12.457 19.0572V17.1714H14.3427ZM14.3427 16.2286C13.2999 16.2286 12.457 15.3857 12.457 14.3429C12.457 13.3 13.2999 12.4572 14.3427 12.4572H19.0713C20.1142 12.4572 20.957 13.3 20.957 14.3429C20.957 15.3857 20.1142 16.2286 19.0713 16.2286H14.3427Z",
        fill: "#ECB22E"
    }));

});

parcelRegister("kTLX4", function(module, exports) {
$parcel$export(module.exports, "default", () => $3ff6685214f18725$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $3ff6685214f18725$var$messages = (0, $7qGN1.defineMessages)({
    discoverMoreAutomationMenuItemLabel: {
        "id": "software-releases-automation-menu.menu-contents.template-rules.discover-more-automation-menu-item-label",
        "defaultMessage": "Discover more automation"
    },
    templateRuleAddIssueToVersionOnVersionCreate: {
        "id": "software-releases-automation-menu.menu-contents.template-rules.template-rule-add-issue-to-version-on-version-create",
        "defaultMessage": "When a version is created \u2192 then add all In Progress issues without a fix version"
    },
    templateRuleCreateLaunchDarklyFlagOnVersionCreate: {
        "id": "software-releases-automation-menu.menu-contents.template-rules.template-rule-create-launch-darkly-flag-on-version-create",
        "defaultMessage": "When a version is created \u2192 then create a LaunchDarkly flag"
    },
    templateRuleSendSlackMessageOnVersionRelease: {
        "id": "software-releases-automation-menu.menu-contents.template-rules.template-rule-send-slack-message-on-version-release",
        "defaultMessage": "When a version is released \u2192 then send a Slack message"
    },
    templateRuleSendSlackMessageOnVersionUnRelease: {
        "id": "software-releases-automation-menu.menu-contents.template-rules.template-rule-send-slack-message-on-version-un-release",
        "defaultMessage": "When a version is unreleased \u2192 then send a Slack message"
    },
    templateRuleAddIssueToVersionOnVersionCreateIssueTerminologyRefreshM4: {
        "id": "software-releases-automation-menu.menu-contents.template-rules.template-rule-add-issue-to-version-on-version-create-issue-terminology-refresh-m4",
        "defaultMessage": "When a version is created \u2192 then add all In Progress work items without a fix version"
    }
});
var $3ff6685214f18725$export$2e2bcd8739ae039 = $3ff6685214f18725$var$messages;

});


parcelRegister("hPfix", function(module, exports) {
$parcel$export(module.exports, "default", () => $80ea3f4a5b8b0d4c$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $80ea3f4a5b8b0d4c$var$messages = (0, $7qGN1.defineMessages)({
    disabledAutomationMenuButtonTooltipMessage: {
        "id": "software-releases-automation-menu.disabled-automation-menu-button-tooltip-message",
        "defaultMessage": "You need to be a project admin to configure automation"
    },
    automationMenuTitle: {
        "id": "software-releases-automation-menu.automation-menu-title",
        "defaultMessage": "Automation"
    },
    automationMenuSubTitle: {
        "id": "software-releases-automation-menu.automation-menu-sub-title",
        "defaultMessage": "Setup your release automations from these templates, or create a new one of your own."
    },
    disabledAutomationMenuButtonTooltipMessageGalaxia: {
        "id": "software-releases-automation-menu.disabled-automation-menu-button-tooltip-message-galaxia",
        "defaultMessage": "You need to be a space admin to configure automation"
    }
});
var $80ea3f4a5b8b0d4c$export$2e2bcd8739ae039 = $80ea3f4a5b8b0d4c$var$messages;

});


parcelRegister("jvEp3", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("eNLLJ").then(()=>parcelRequire('40FP2'));

});


parcelRegister("9o4iM", function(module, exports) {
$parcel$export(module.exports, "ManageWarningsModal", () => $976f389557dc9dec$export$6e3078b1666e4828);

var $f4H2H = parcelRequire("f4H2H");

var $46cdy = parcelRequire("46cdy");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $j4oe4 = parcelRequire("j4oe4");

var $cA0Y2 = parcelRequire("cA0Y2");

var $goZPP = parcelRequire("goZPP");

var $ik0CA = parcelRequire("ik0CA");
var $kseeK = parcelRequire("kseeK");
var $2qG7I = parcelRequire("2qG7I");
var $5a9Ro = parcelRequire("5a9Ro");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $iHPvF = parcelRequire("iHPvF");

var $cxKOj = parcelRequire("cxKOj");

var $4cTDP = parcelRequire("4cTDP");

var $lJKII = parcelRequire("lJKII");

var $4B7rn = parcelRequire("4B7rn");

var $lRq8t = parcelRequire("lRq8t");

var $kRgKj = parcelRequire("kRgKj");

var $ciQZ5 = parcelRequire("ciQZ5");

var $lSVGS = parcelRequire("lSVGS");

var $l5Hz4 = parcelRequire("l5Hz4");
const $976f389557dc9dec$export$6e3078b1666e4828 = ({ setModalClosed: setModalClosed, jiraVersion: jiraVersion })=>{
    const warningsSetForAllVersionsInThisProjectGalaxia = (0, $cxKOj.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $ciQZ5.default).warningsSetForAllVersionsInThisProjectGalaxia : (0, $ciQZ5.default).warningsSetForAllVersionsInThisProject;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const version = (0, $j4oe4.useFragment)((0, $46cdy.default), jiraVersion);
    const { warningConfig: warningConfig, __id: versionRecordId } = version;
    const { openPullRequest: openPullRequest, failingBuild: failingBuild, unreviewedCode: unreviewedCode, openReview: openReview } = warningConfig;
    const [updatedVersionWarningConfig, setUpdatedVersionWarningConfig] = (0, $eJOHy.useState)((0, $l5Hz4.convertStatusToBoolean)(warningConfig));
    const removeDisabledWarningFilters = (0, $l5Hz4.useRemoveDisabledWarningFilters)(updatedVersionWarningConfig);
    const [isSaveFailed, setIsSaveFailed] = (0, $eJOHy.useState)(false); // eslint-disable-next-line jira/graphql/restrict-graphql-in-unnamed-files
    const [updateVersionWarningConfig, isWarningConfigUpdating] = (0, $j4oe4.useMutation)((0, $f4H2H.default));
    const jiraProjectId = version.project.id;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4B7rn.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lJKII.JiraModal), {
        messageId: "software-releases-manage-warnings.ui.modal-dialog",
        messageType: "transactional",
        testId: "software-releases-manage-warnings.ui.modal-dialog"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2qG7I.default), {
        hasCloseButton: (0, $4cTDP.fg)('enghealth-41206-modal-header-close-button')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5a9Ro.default), null, formatMessage((0, $ciQZ5.default).manageWarnings))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ik0CA.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($976f389557dc9dec$var$WarningDescription, null, formatMessage((0, $4cTDP.fg)('jira-issue-terminology-update-m4') ? (0, $ciQZ5.default).warningDescriptionIssueTerminologyRefreshM4 : (0, $ciQZ5.default).warningDescription)), isSaveFailed && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $976f389557dc9dec$var$errorSectionMessageContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iHPvF.default), {
        appearance: "error"
    }, formatMessage((0, $ciQZ5.default).updateWarningConfigFailed))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iHPvF.default), {
        appearance: "warning"
    }, formatMessage(warningsSetForAllVersionsInThisProjectGalaxia)), openPullRequest !== 'NOT_APPLICABLE' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lSVGS.Toggle), {
        testId: "software-releases-manage-warnings.ui.open-pull-request",
        isDisabled: isWarningConfigUpdating,
        initialValue: openPullRequest === 'ENABLED',
        onChange: (_, analyticsEvent)=>setUpdatedVersionWarningConfig((prev)=>{
                (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'versionWarningsConfig', {
                    warningType: 'openPullRequest',
                    isEnabled: !prev.isOpenPullRequestEnabled
                });
                return {
                    ...prev,
                    isOpenPullRequestEnabled: !prev.isOpenPullRequestEnabled
                };
            }),
        headingTranslated: formatMessage((0, $ciQZ5.default).openPullRequests),
        descriptionTranslated: formatMessage((0, $4cTDP.fg)('jira-issue-terminology-update-m4') ? (0, $ciQZ5.default).openPullRequestsDescriptionIssueTerminologyRefreshM4 : (0, $ciQZ5.default).openPullRequestsDescription)
    }), openReview !== 'NOT_APPLICABLE' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lSVGS.Toggle), {
        testId: "software-releases-manage-warnings.ui.open-review",
        isDisabled: isWarningConfigUpdating,
        initialValue: openReview === 'ENABLED',
        onChange: (_, analyticsEvent)=>setUpdatedVersionWarningConfig((prev)=>{
                (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'versionWarningsConfig', {
                    warningType: 'openReview',
                    isEnabled: !prev.isOpenReviewEnabled
                });
                return {
                    ...prev,
                    isOpenReviewEnabled: !prev.isOpenReviewEnabled
                };
            }),
        headingTranslated: formatMessage((0, $ciQZ5.default).openReviews),
        descriptionTranslated: formatMessage((0, $4cTDP.fg)('jira-issue-terminology-update-m4') ? (0, $ciQZ5.default).openReviewsDescriptionIssueTerminologyRefreshM4 : (0, $ciQZ5.default).openReviewsDescription)
    }), unreviewedCode !== 'NOT_APPLICABLE' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lSVGS.Toggle), {
        testId: "software-releases-manage-warnings.ui.unreviewed-code",
        isDisabled: isWarningConfigUpdating,
        initialValue: unreviewedCode === 'ENABLED',
        onChange: (_, analyticsEvent)=>{
            setUpdatedVersionWarningConfig((prev)=>{
                (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'versionWarningsConfig', {
                    warningType: 'unreviewedCode',
                    isEnabled: !prev.isUnreviewedCodeEnabled
                });
                return {
                    ...prev,
                    isUnreviewedCodeEnabled: !prev.isUnreviewedCodeEnabled
                };
            });
        },
        headingTranslated: formatMessage((0, $ciQZ5.default).unreviewedCode),
        descriptionTranslated: formatMessage((0, $4cTDP.fg)('jira-issue-terminology-update-m4') ? (0, $ciQZ5.default).unreviewedCodeDescriptionIssueTerminologyRefreshM4 : (0, $ciQZ5.default).unreviewedCodeDescription)
    }), failingBuild !== 'NOT_APPLICABLE' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lSVGS.Toggle), {
        testId: "software-releases-manage-warnings.ui.failing-build",
        isDisabled: isWarningConfigUpdating,
        initialValue: failingBuild === 'ENABLED',
        onChange: (_, analyticsEvent)=>{
            setUpdatedVersionWarningConfig((prev)=>{
                (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'versionWarningsConfig', {
                    warningType: 'failingBuild',
                    isEnabled: !prev.isFailingBuildEnabled
                });
                return {
                    ...prev,
                    isFailingBuildEnabled: !prev.isFailingBuildEnabled
                };
            });
        },
        headingTranslated: formatMessage((0, $ciQZ5.default).failingBuilds),
        descriptionTranslated: formatMessage((0, $4cTDP.fg)('jira-issue-terminology-update-m4') ? (0, $ciQZ5.default).failingBuildsDescriptionIssueTerminologyRefreshM4 : (0, $ciQZ5.default).failingBuildsDescription)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kseeK.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cA0Y2.default), {
        appearance: "primary",
        onClick: ()=>{
            updateVersionWarningConfig({
                variables: {
                    input: {
                        jiraProjectId: jiraProjectId,
                        updatedVersionWarningConfig: updatedVersionWarningConfig
                    },
                    versionId: version.id
                },
                // @ts-expect-error - TS2322 - Type '({ jira: { updateVersionWarningConfig: { success }, }, }: MutationResponse) => void' is not assignable to type '(response: {}, errors: PayloadError[] | null) => void | null'.
                onCompleted: ({ jira: { // @ts-expect-error(Suppressed for relay bump) - Property 'updateVersionWarningConfig' does not exist on type '{ readonly updateVersionWarningConfig: { readonly success: boolean; readonly version: { readonly " $fragmentSpreads": FragmentRefs<"issueProgressDetails_versionProgress">; } | null | undefined; } | null | undefined; } | null | undefined'.
                updateVersionWarningConfig: { success: success } } })=>{
                    if (success) {
                        removeDisabledWarningFilters();
                        setModalClosed();
                        return;
                    }
                    setIsSaveFailed(true);
                },
                onError: ()=>{
                    setIsSaveFailed(true);
                },
                updater: (store)=>{
                    const versionRecord = store.get(versionRecordId);
                    if (versionRecord == null) return;
                    const existingWarningConfigRecord = versionRecord.getLinkedRecord('warningConfig');
                    if (existingWarningConfigRecord == null) return;
                    const newValues = (0, $l5Hz4.getNewWarningConfigValues)(updatedVersionWarningConfig, {
                        openPullRequest: openPullRequest,
                        openReview: openReview,
                        failingBuild: failingBuild,
                        unreviewedCode: unreviewedCode
                    });
                    existingWarningConfigRecord.setValue(newValues.openPullRequest, 'openPullRequest');
                    existingWarningConfigRecord.setValue(newValues.openReview, 'openReview');
                    existingWarningConfigRecord.setValue(newValues.unreviewedCode, 'unreviewedCode');
                    existingWarningConfigRecord.setValue(newValues.failingBuild, 'failingBuild');
                    versionRecord.setLinkedRecord(existingWarningConfigRecord, 'warningConfig');
                }
            });
        },
        isLoading: isWarningConfigUpdating
    }, formatMessage((0, $ciQZ5.default).modalSave)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        testId: "software-releases-manage-warnings.ui.cancel-manage-warnings",
        onClick: ()=>setModalClosed(),
        isDisabled: isWarningConfigUpdating
    }, formatMessage((0, $ciQZ5.default).modalCancel)))));
};
const $976f389557dc9dec$var$errorSectionMessageContainerStyles = (0, $1DXK0.xcss)({
    marginBottom: 'space.100'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $976f389557dc9dec$var$WarningDescription = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_otyr1ejb _syazi7uo",
            __cmplp.className
        ])
    });
});

});
parcelRegister("f4H2H", function(module, exports) {
$parcel$export(module.exports, "default", () => $23c34b093f135452$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<aec7c7d15a68e9ccfb10cf6d3c93e5e1>>
 * @relayHash f80615342bea07d18fe9b588ee9c8938
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID bb3640928c5b9aa6b7fe35b78c841cf3c2e853010ab4e47e56966cc8e62de2ce
const $23c34b093f135452$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "versionId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "versionId"
        }
    ], v4 = [
        {
            "kind": "ScalarField",
            "name": "totalCount"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ui_ManageWarningsModalVersionWarningConfigMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraUpdateVersionWarningConfigPayload",
                            "kind": "LinkedField",
                            "name": "updateVersionWarningConfig",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "args": v3 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "issueProgressDetails_versionProgress"
                                                }
                                            ],
                                            "type": "JiraVersion"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ui_ManageWarningsModalVersionWarningConfigMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraUpdateVersionWarningConfigPayload",
                            "kind": "LinkedField",
                            "name": "updateVersionWarningConfig",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "args": v3 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "concreteType": "JiraVersionWarningConfig",
                                                    "kind": "LinkedField",
                                                    "name": "warningConfig",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "failingBuild"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "openPullRequest"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "openReview"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "unreviewedCode"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "alias": "doneIssuesRedesignTemp",
                                                    "args": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "filters",
                                                            "value": {
                                                                "statusCategories": [
                                                                    "DONE"
                                                                ]
                                                            }
                                                        }
                                                    ],
                                                    "concreteType": "JiraIssueConnection",
                                                    "kind": "LinkedField",
                                                    "name": "issues",
                                                    "plural": false,
                                                    "selections": v4 /*: any*/ ,
                                                    "storageKey": "issues(filters:{\"statusCategories\":[\"DONE\"]})"
                                                },
                                                {
                                                    "alias": "inProgressIssuesRedesignTemp",
                                                    "args": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "filters",
                                                            "value": {
                                                                "statusCategories": [
                                                                    "IN_PROGRESS"
                                                                ]
                                                            }
                                                        }
                                                    ],
                                                    "concreteType": "JiraIssueConnection",
                                                    "kind": "LinkedField",
                                                    "name": "issues",
                                                    "plural": false,
                                                    "selections": v4 /*: any*/ ,
                                                    "storageKey": "issues(filters:{\"statusCategories\":[\"IN_PROGRESS\"]})"
                                                },
                                                {
                                                    "alias": "todoIssuesRedesignTemp",
                                                    "args": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "filters",
                                                            "value": {
                                                                "statusCategories": [
                                                                    "TODO"
                                                                ]
                                                            }
                                                        }
                                                    ],
                                                    "concreteType": "JiraIssueConnection",
                                                    "kind": "LinkedField",
                                                    "name": "issues",
                                                    "plural": false,
                                                    "selections": v4 /*: any*/ ,
                                                    "storageKey": "issues(filters:{\"statusCategories\":[\"TODO\"]})"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "warningsCount"
                                                }
                                            ],
                                            "type": "JiraVersion"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                }
                                            ],
                                            "type": "Node",
                                            "abstractKey": "__isNode"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "bb3640928c5b9aa6b7fe35b78c841cf3c2e853010ab4e47e56966cc8e62de2ce",
            "metadata": {},
            "name": "ui_ManageWarningsModalVersionWarningConfigMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$23c34b093f135452$var$node.hash = "c4e2323c95f8ee01a7aae0a690ba4f89";
var $23c34b093f135452$export$2e2bcd8739ae039 = $23c34b093f135452$var$node;

});

parcelRegister("46cdy", function(module, exports) {
$parcel$export(module.exports, "default", () => $d7ca915f43e6cede$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2db5e521c6a905015346df1d2ff4cfe7>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $d7ca915f43e6cede$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "ui_softwareReleasesManageWarnings_ManageWarningsModal",
        "selections": [
            {
                "kind": "RequiredField",
                "field": {
                    "concreteType": "JiraProject",
                    "kind": "LinkedField",
                    "name": "project",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": v0 /*: any*/ ,
                            "action": "THROW",
                            "path": "project.id"
                        }
                    ]
                },
                "action": "THROW",
                "path": "project"
            },
            v0 /*: any*/ ,
            {
                "kind": "RequiredField",
                "field": {
                    "concreteType": "JiraVersionWarningConfig",
                    "kind": "LinkedField",
                    "name": "warningConfig",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "kind": "ScalarField",
                                "name": "openPullRequest"
                            },
                            "action": "THROW",
                            "path": "warningConfig.openPullRequest"
                        },
                        {
                            "kind": "RequiredField",
                            "field": {
                                "kind": "ScalarField",
                                "name": "openReview"
                            },
                            "action": "THROW",
                            "path": "warningConfig.openReview"
                        },
                        {
                            "kind": "RequiredField",
                            "field": {
                                "kind": "ScalarField",
                                "name": "unreviewedCode"
                            },
                            "action": "THROW",
                            "path": "warningConfig.unreviewedCode"
                        },
                        {
                            "kind": "RequiredField",
                            "field": {
                                "kind": "ScalarField",
                                "name": "failingBuild"
                            },
                            "action": "THROW",
                            "path": "warningConfig.failingBuild"
                        }
                    ]
                },
                "action": "THROW",
                "path": "warningConfig"
            },
            {
                "kind": "ClientExtension",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "__id"
                    }
                ]
            }
        ],
        "type": "JiraVersion"
    };
}();
$d7ca915f43e6cede$var$node.hash = "e5eb838f9801c770bc5137a984a02776";
var $d7ca915f43e6cede$export$2e2bcd8739ae039 = $d7ca915f43e6cede$var$node;

});

parcelRegister("ciQZ5", function(module, exports) {
$parcel$export(module.exports, "default", () => $c181b4bdec22cc09$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $c181b4bdec22cc09$var$messages = (0, $7qGN1.defineMessages)({
    manageWarnings: {
        "id": "software-releases-manage-warnings.manage-warnings",
        "defaultMessage": "Manage warnings"
    },
    modalSave: {
        "id": "software-releases-manage-warnings.modal-save",
        "defaultMessage": "Save"
    },
    modalCancel: {
        "id": "software-releases-manage-warnings.modal-cancel",
        "defaultMessage": "Cancel"
    },
    warningsSetForAllVersionsInThisProject: {
        "id": "software-releases-manage-warnings.warnings-set-for-all-versions-in-this-project",
        "defaultMessage": "These warning settings affect all existing and future versions in this project."
    },
    updateWarningConfigFailed: {
        "id": "software-releases-manage-warnings.update-warning-config-failed",
        "defaultMessage": "Something went wrong. Please try to save again."
    },
    openPullRequests: {
        "id": "software-releases-manage-warnings.open-pull-requests",
        "defaultMessage": "Open pull requests"
    },
    openPullRequestsDescription: {
        "id": "software-releases-manage-warnings.open-pull-requests-description",
        "defaultMessage": "These issues have been marked complete but have open pull requests."
    },
    openReviews: {
        "id": "software-releases-manage-warnings.open-reviews",
        "defaultMessage": "Open reviews"
    },
    openReviewsDescription: {
        "id": "software-releases-manage-warnings.open-reviews-description",
        "defaultMessage": "These issues have been marked complete but have open reviews."
    },
    unreviewedCode: {
        "id": "software-releases-manage-warnings.unreviewed-code",
        "defaultMessage": "Unreviewed code"
    },
    unreviewedCodeDescription: {
        "id": "software-releases-manage-warnings.unreviewed-code-description",
        "defaultMessage": "These issues have been marked complete but the commits are not part of a pull request or review."
    },
    failingBuilds: {
        "id": "software-releases-manage-warnings.failing-builds",
        "defaultMessage": "Failing builds"
    },
    failingBuildsDescription: {
        "id": "software-releases-manage-warnings.failing-builds-description",
        "defaultMessage": "These issues have been marked complete but have failing builds."
    },
    warningDescription: {
        "id": "software-releases-manage-warnings.warning-description",
        "defaultMessage": "Warnings will be displayed when the status of a Jira issue doesn't accurately reflect related development activity."
    },
    openPullRequestsDescriptionIssueTerminologyRefreshM4: {
        "id": "software-releases-manage-warnings.open-pull-requests-description-issue-terminology-refresh-m4",
        "defaultMessage": "These work items have been marked complete but have open pull requests."
    },
    openReviewsDescriptionIssueTerminologyRefreshM4: {
        "id": "software-releases-manage-warnings.open-reviews-description-issue-terminology-refresh-m4",
        "defaultMessage": "These work items have been marked complete but have open reviews."
    },
    unreviewedCodeDescriptionIssueTerminologyRefreshM4: {
        "id": "software-releases-manage-warnings.unreviewed-code-description-issue-terminology-refresh-m4",
        "defaultMessage": "These work items have been marked complete but the commits are not part of a pull request or review."
    },
    failingBuildsDescriptionIssueTerminologyRefreshM4: {
        "id": "software-releases-manage-warnings.failing-builds-description-issue-terminology-refresh-m4",
        "defaultMessage": "These work items have been marked complete but have failing builds."
    },
    warningDescriptionIssueTerminologyRefreshM4: {
        "id": "software-releases-manage-warnings.warning-description-issue-terminology-refresh-m4",
        "defaultMessage": "Warnings will be displayed when the status of a Jira work item doesn't accurately reflect related development activity."
    },
    warningsSetForAllVersionsInThisProjectGalaxia: {
        "id": "software-releases-manage-warnings.warnings-set-for-all-versions-in-this-project-galaxia",
        "defaultMessage": "These warning settings affect all existing and future versions in this space."
    }
});
var $c181b4bdec22cc09$export$2e2bcd8739ae039 = $c181b4bdec22cc09$var$messages;

});

parcelRegister("lSVGS", function(module, exports) {
$parcel$export(module.exports, "Toggle", () => $377e8b1c6889dee1$export$bea8ebba691c5813);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $806LH = parcelRequire("806LH");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $8CBYv = parcelRequire("8CBYv");
const $377e8b1c6889dee1$export$bea8ebba691c5813 = ({ initialValue: initialValue, headingTranslated: headingTranslated, descriptionTranslated: descriptionTranslated, onChange: onChange, testId: testId, isDisabled: isDisabled })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($377e8b1c6889dee1$var$WarningCategoryContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $806LH.default), {
        size: "xsmall"
    }, headingTranslated), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($377e8b1c6889dee1$var$Description, null, descriptionTranslated)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $377e8b1c6889dee1$var$toggleContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8CBYv.default), {
        testId: testId,
        defaultChecked: initialValue,
        onChange: onChange,
        isDisabled: isDisabled
    })));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $377e8b1c6889dee1$var$WarningCategoryContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _1bsb1osq _1bah1yb4 _19pkpxbi",
            __cmplp.className
        ])
    });
});
const $377e8b1c6889dee1$var$toggleContainerStyles = (0, $1DXK0.xcss)({
    paddingLeft: 'space.200'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $377e8b1c6889dee1$var$Description = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_syazi7uo",
            __cmplp.className
        ])
    });
});

});
parcelRegister("8CBYv", function(module, exports) {
$parcel$export(module.exports, "default", () => $8b71259385cf6352$export$2e2bcd8739ae039);
/* toggle.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $jrFnt = parcelRequire("jrFnt");

var $3Vuhz = parcelRequire("3Vuhz");

var $gl2vi = parcelRequire("gl2vi");

var $6XkOW = parcelRequire("6XkOW");

var $5wxTT = parcelRequire("5wxTT");

var $eGOwo = parcelRequire("eGOwo");

var $7ep4S = parcelRequire("7ep4S");

var $6fs4r = parcelRequire("6fs4r");

var $hqCmO = parcelRequire("hqCmO");
const $8b71259385cf6352$var$LOADING_LABEL = ', Loading';
const $8b71259385cf6352$var$basicStyles = null;
const $8b71259385cf6352$var$iconStyles = null;
const $8b71259385cf6352$var$sizeStyles = {
    regular: "_2rkopxbi _4t3ipxbi _1bsbxy5q _kfgtutpp _1mp41crf _p9c41fbe",
    large: "_2rkov47k _4t3iv47k _1bsb1jfw _kfgtpxbi _1mp47vkz _p9c4w12q"
};
const $8b71259385cf6352$var$noop = (0, $3Vuhz.default);
const $8b71259385cf6352$var$analyticsAttributes = {
    componentName: 'toggle',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $8b71259385cf6352$var$iconSizeMap = {
    regular: 'small',
    large: 'medium'
}; /**
    * __Toggle__
    *
    * A toggle is used to view or switch between enabled or disabled states.
    *
    * - [Examples](https://atlassian.design/components/toggle/examples)
    * - [Code](https://atlassian.design/components/toggle/code)
    * - [Usage](https://atlassian.design/components/toggle/usage)
    */ 
const $8b71259385cf6352$var$Toggle = /*#__PURE__*/ (0, $eJOHy.memo)(/*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>{
    const { defaultChecked: defaultChecked = false, isDisabled: isDisabled = false, onBlur: providedOnBlur = $8b71259385cf6352$var$noop, onChange: providedChange = $8b71259385cf6352$var$noop, onFocus: providedFocus = $8b71259385cf6352$var$noop, size: size = 'regular', name: name = '', value: value = '', isChecked: isChecked, isLoading: isLoading, analyticsContext: analyticsContext, id: id, testId: testId, label: label, descriptionId: descriptionId } = props;
    const isControlled = typeof isChecked === 'undefined';
    const [checked, setChecked] = (0, $eJOHy.useState)(defaultChecked);
    const loadingLabelId = (0, $gl2vi.useId)();
    const handleBlur = (0, $jrFnt.usePlatformLeafEventHandler)({
        fn: providedOnBlur,
        action: 'blur',
        analyticsData: analyticsContext,
        ...$8b71259385cf6352$var$analyticsAttributes
    });
    const handleFocus = (0, $jrFnt.usePlatformLeafEventHandler)({
        fn: providedFocus,
        action: 'focus',
        analyticsData: analyticsContext,
        ...$8b71259385cf6352$var$analyticsAttributes
    });
    const handleChange = (0, $jrFnt.usePlatformLeafEventHandler)({
        fn: (event, analyticsEvent)=>{
            if (isControlled) setChecked((checked)=>!checked);
            return providedChange(event, analyticsEvent);
        },
        action: 'change',
        analyticsData: analyticsContext,
        ...$8b71259385cf6352$var$analyticsAttributes
    });
    const shouldChecked = isControlled ? checked : isChecked;
    const controlProps = {
        'data-checked': shouldChecked ? shouldChecked : undefined,
        'data-disabled': isDisabled ? isDisabled : undefined,
        'data-size': size,
        'data-testid': testId ? testId : undefined
    };
    const legacyIconSize = $8b71259385cf6352$var$iconSizeMap[size];
    const labelId = (0, $gl2vi.useId)();
    return /*#__PURE__*/ (0, $gt9Am.jsxs)("label", {
        ...controlProps,
        className: (0, $hcewu.default)([
            "_v564kete _1h6d3acm _1dqonqa1 _189e1dm9 _1e0c1o8l _vchh18uv _kqswh2mm _1y1m1ntv _bfhk76s1 _syaz5w2r _6rthv77o _1pfhv77o _12l2v77o _ahbqv77o _85i5v77o _1q51v77o _y4tiv77o _bozgv77o _1i2uidpf _1i3tidpf _se28idpf _3tunidpf _1423idpf _1hrtidpf _1bz2idpf _rqfvidpf _1yc0glyw _onsr1snc _1vgmagmp _1av610yn _1ulhidpf _rfx31qll _pdykkete _1cs8stnw _1rus5w2r _1kt9b3bt _1fkr1y44 _z5wt1y44 _7dwzglyw _1ys4194a _krlfnqa1 _ju3ddkaa _1bki1y1w _1flt1y1w _3xv21y1w _9471g4a2 _ucab5w2r _mqf815t7 _3dj215t7 _1dl915t7 _1div5w2r _1il8kb7n _y54d5w2r _irr353wy _d0altlke _19ja13gf _8muf13gf _1k1q13gf _1plud4ly _1uo853wy _178c1y1w _16rslghj _i5ec1w7i",
            size === 'large' && !(0, $eGOwo.fg)('platform-visual-refresh-icons') && "_1n82gktf _19vpgktf",
            $8b71259385cf6352$var$sizeStyles[size]
        ]),
        children: [
            label ? /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
                id: labelId,
                hidden: true,
                children: isLoading ? `${label}${$8b71259385cf6352$var$LOADING_LABEL}` : label
            }) : null,
            /*#__PURE__*/ (0, $gt9Am.jsx)("input", {
                ref: ref,
                checked: shouldChecked,
                disabled: isDisabled,
                id: id,
                name: name,
                onBlur: handleBlur,
                onChange: handleChange,
                onFocus: handleFocus,
                type: "checkbox",
                value: value,
                "data-testid": testId && `${testId}--input`,
                "aria-labelledby": isLoading && label ? `${labelId} ${loadingLabelId}` : label ? labelId : undefined,
                "aria-describedby": descriptionId
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hqCmO.default), {
                size: size,
                isHidden: !shouldChecked,
                position: "left",
                children: isLoading && shouldChecked ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7ep4S.default), {
                    size: "xsmall",
                    appearance: "invert"
                }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6XkOW))), {
                    label: "",
                    color: "currentColor",
                    LEGACY_size: legacyIconSize,
                    testId: testId && `${testId}--toggle-check-icon`,
                    size: "small"
                })
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hqCmO.default), {
                size: size,
                isHidden: shouldChecked,
                position: "right",
                children: isLoading && !shouldChecked ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7ep4S.default), {
                    size: "xsmall",
                    appearance: "invert"
                }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5wxTT))), {
                    label: "",
                    color: "currentColor",
                    LEGACY_size: legacyIconSize,
                    testId: testId && `${testId}--toggle-cross-icon`,
                    size: "small"
                })
            }),
            isLoading && !label && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6fs4r.default), {
                id: loadingLabelId,
                children: $8b71259385cf6352$var$LOADING_LABEL
            })
        ]
    });
}));
$8b71259385cf6352$var$Toggle.displayName = 'Toggle';
var $8b71259385cf6352$export$2e2bcd8739ae039 = $8b71259385cf6352$var$Toggle;

});
parcelRegister("6XkOW", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::600b8f5df6a73844cbfa316238c6d2e9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5108674e45de2f8c$var$_react = $5108674e45de2f8c$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $5108674e45de2f8c$var$_checkMark = $5108674e45de2f8c$var$_interopRequireDefault((parcelRequire("lwpci")));

var $5108674e45de2f8c$var$_done = $5108674e45de2f8c$var$_interopRequireDefault((parcelRequire("37Ug4")));
function $5108674e45de2f8c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CheckMarkIcon.
 * This component is CheckMarkIcon, with `UNSAFE_fallbackIcon` set to "EditorDoneIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: table cells, checkboxes.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5108674e45de2f8c$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $5108674e45de2f8c$var$_react.default.createElement($5108674e45de2f8c$var$_checkMark.default, Object.assign({
        name: "CheckMarkIcon",
        LEGACY_fallbackIcon: $5108674e45de2f8c$var$_done.default
    }, props));
$5108674e45de2f8c$var$CheckMarkIcon.displayName = 'CheckMarkIconMigration';
var $5108674e45de2f8c$var$_default = module.exports.default = $5108674e45de2f8c$var$CheckMarkIcon;

});
parcelRegister("37Ug4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $246daa468c067835$var$_react = $246daa468c067835$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $246daa468c067835$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $246daa468c067835$var$EditorDoneIcon = (props)=>/*#__PURE__*/ $246daa468c067835$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M7.356 10.942a.497.497 0 0 0-.713 0l-.7.701a.5.5 0 0 0-.003.71l3.706 3.707a.5.5 0 0 0 .705.003l7.712-7.712a.493.493 0 0 0-.006-.708l-.7-.7a.504.504 0 0 0-.714 0l-6.286 6.286a.506.506 0 0 1-.713 0z"/></svg>`
    }, props));
$246daa468c067835$var$EditorDoneIcon.displayName = 'EditorDoneIcon';
var $246daa468c067835$var$_default = module.exports.default = $246daa468c067835$var$EditorDoneIcon;

});


parcelRegister("5wxTT", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::18cd44b40ff8809efea24ae850576bc8>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $405a3cd7d6c6872a$var$_react = $405a3cd7d6c6872a$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $405a3cd7d6c6872a$var$_cross = $405a3cd7d6c6872a$var$_interopRequireDefault((parcelRequire("6zhpo")));

var $405a3cd7d6c6872a$var$_close = $405a3cd7d6c6872a$var$_interopRequireDefault((parcelRequire("6OLN4")));
function $405a3cd7d6c6872a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CrossIcon.
 * This component is CrossIcon, with `UNSAFE_fallbackIcon` set to "EditorCloseIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: closing modals, panels, and transient views; removing tags
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $405a3cd7d6c6872a$var$CrossIcon = (props)=>/*#__PURE__*/ $405a3cd7d6c6872a$var$_react.default.createElement($405a3cd7d6c6872a$var$_cross.default, Object.assign({
        name: "CrossIcon",
        LEGACY_fallbackIcon: $405a3cd7d6c6872a$var$_close.default
    }, props));
$405a3cd7d6c6872a$var$CrossIcon.displayName = 'CrossIconMigration';
var $405a3cd7d6c6872a$var$_default = module.exports.default = $405a3cd7d6c6872a$var$CrossIcon;

});
parcelRegister("6OLN4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4f6c7bc606f2d15e$var$_react = $4f6c7bc606f2d15e$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $4f6c7bc606f2d15e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $4f6c7bc606f2d15e$var$EditorCloseIcon = (props)=>/*#__PURE__*/ $4f6c7bc606f2d15e$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m15.185 7.4-3.184 3.185-3.186-3.186a.507.507 0 0 0-.712.003l-.7.701a.496.496 0 0 0-.004.712l3.185 3.184L7.4 15.185a.507.507 0 0 0 .004.712l.7.7c.206.207.516.2.712.004l3.186-3.185 3.184 3.185a.507.507 0 0 0 .712-.004l.701-.7a.496.496 0 0 0 .003-.712l-3.186-3.186 3.186-3.184a.507.507 0 0 0-.003-.712l-.7-.7a.5.5 0 0 0-.36-.153.5.5 0 0 0-.353.15"/></svg>`
    }, props));
$4f6c7bc606f2d15e$var$EditorCloseIcon.displayName = 'EditorCloseIcon';
var $4f6c7bc606f2d15e$var$_default = module.exports.default = $4f6c7bc606f2d15e$var$EditorCloseIcon;

});


parcelRegister("hqCmO", function(module, exports) {
$parcel$export(module.exports, "default", () => $d938694e808b84dc$export$2e2bcd8739ae039);
/* icon-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $6qaBj = parcelRequire("6qaBj");

var $eGOwo = parcelRequire("eGOwo");

var $8IeH1 = parcelRequire("8IeH1");
const $d938694e808b84dc$var$styles = {
    iconContainer: "_v5641hrg _1e0c116y _4cvr1h6o _1bah1h6o _kqswstnw _152tv77o",
    iconContainerRegular: "_1bsb7vkz _4t3i7vkz",
    iconContainerLarge: "_1bsbgktf _4t3igktf",
    hidden: "_tzy4idpf",
    left: "_1e021l7b",
    right: "_rjxp1l7b"
};
/**
 * __Icon container__
 *
 * Positions a toggle's check and close icons.
 */ const $d938694e808b84dc$var$IconContainer = ({ children: children, size: size, isHidden: isHidden, position: position })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        as: "span",
        xcss: (0, $6qaBj.cx)($d938694e808b84dc$var$styles.iconContainer, isHidden && (0, $eGOwo.fg)('platform-visual-refresh-icons') && $d938694e808b84dc$var$styles.hidden, size === 'regular' && $d938694e808b84dc$var$styles.iconContainerRegular, size === 'large' && $d938694e808b84dc$var$styles.iconContainerLarge, position === 'left' && $d938694e808b84dc$var$styles.left, position === 'right' && $d938694e808b84dc$var$styles.right),
        children: children
    });
};
var $d938694e808b84dc$export$2e2bcd8739ae039 = $d938694e808b84dc$var$IconContainer;

});



parcelRegister("l5Hz4", function(module, exports) {
$parcel$export(module.exports, "convertStatusToBoolean", () => $ae0eaf455b1d53c0$export$6a8a12d4b311feca);
$parcel$export(module.exports, "getNewWarningConfigValues", () => $ae0eaf455b1d53c0$export$12511548bf3cb9c8);
$parcel$export(module.exports, "useRemoveDisabledWarningFilters", () => $ae0eaf455b1d53c0$export$dfbaab0bbdd97fab);


var $amEKX = parcelRequire("amEKX");

var $lFI9l = parcelRequire("lFI9l");
const $ae0eaf455b1d53c0$var$booleanToState = (value)=>value ? 'ENABLED' : 'DISABLED';
const $ae0eaf455b1d53c0$export$6a8a12d4b311feca = ({ openPullRequest: openPullRequest, openReview: openReview, unreviewedCode: unreviewedCode, failingBuild: failingBuild })=>({
        isOpenPullRequestEnabled: openPullRequest !== 'DISABLED',
        isOpenReviewEnabled: openReview !== 'DISABLED',
        isUnreviewedCodeEnabled: unreviewedCode !== 'DISABLED',
        isFailingBuildEnabled: failingBuild !== 'DISABLED'
    });
const $ae0eaf455b1d53c0$export$12511548bf3cb9c8 = (updatedBooleanValues, originalValues)=>({
        openPullRequest: originalValues.openPullRequest === 'NOT_APPLICABLE' ? 'NOT_APPLICABLE' : $ae0eaf455b1d53c0$var$booleanToState(updatedBooleanValues.isOpenPullRequestEnabled ?? true),
        openReview: originalValues.openReview === 'NOT_APPLICABLE' ? 'NOT_APPLICABLE' : $ae0eaf455b1d53c0$var$booleanToState(updatedBooleanValues.isOpenReviewEnabled ?? true),
        unreviewedCode: originalValues.unreviewedCode === 'NOT_APPLICABLE' ? 'NOT_APPLICABLE' : $ae0eaf455b1d53c0$var$booleanToState(updatedBooleanValues.isUnreviewedCodeEnabled ?? true),
        failingBuild: originalValues.failingBuild === 'NOT_APPLICABLE' ? 'NOT_APPLICABLE' : $ae0eaf455b1d53c0$var$booleanToState(updatedBooleanValues.isFailingBuildEnabled ?? true)
    });
const $ae0eaf455b1d53c0$export$dfbaab0bbdd97fab = ({ isFailingBuildEnabled: isFailingBuildEnabled, isOpenPullRequestEnabled: isOpenPullRequestEnabled, isOpenReviewEnabled: isOpenReviewEnabled, isUnreviewedCodeEnabled: isUnreviewedCodeEnabled })=>{
    const { parsedQueryParams: parsedQueryParams, setWarningsFilterParam: setWarningsFilterParam } = (0, $amEKX.useFilterSortingQueryParams)();
    return ()=>{
        const currentlySelectedWarningFilters = parsedQueryParams[0, $3b2c8cea68e59ddc$export$2552faed9df6a2cd] ?? [];
        const result = [];
        if (isFailingBuildEnabled && currentlySelectedWarningFilters.includes('FAILING_BUILD')) result.push('FAILING_BUILD');
        if (isOpenPullRequestEnabled && currentlySelectedWarningFilters.includes('OPEN_PULL_REQUEST')) result.push('OPEN_PULL_REQUEST');
        if (isUnreviewedCodeEnabled && currentlySelectedWarningFilters.includes('UNREVIEWED_CODE')) result.push('UNREVIEWED_CODE');
        if (isOpenReviewEnabled && currentlySelectedWarningFilters.includes('OPEN_REVIEW')) result.push('OPEN_REVIEW');
        setWarningsFilterParam(result.filter((0, $lFI9l.isWarningsFilterValue)));
    };
};

});


const $5e35924307df60cd$export$af5e668651a80140 = 'viewVersionDetailsConnectAppExtension';

parcelRegister("488uu", function(module, exports) {
$parcel$export(module.exports, "ConnectApps", () => $a5f89d8534625e86$export$4fff5b46ac23b268);

var $jxm8w = parcelRequire("jxm8w");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $kuQCd = parcelRequire("kuQCd");

var $aqnJa = parcelRequire("aqnJa");

var $4ctwv = parcelRequire("4ctwv");

var $8aJaL = parcelRequire("8aJaL");

var $lRq8t = parcelRequire("lRq8t");


var $j4foZ = parcelRequire("j4foZ");

var $82tdT = parcelRequire("82tdT");
const $a5f89d8534625e86$export$4fff5b46ac23b268 = ({ jiraVersion: jiraVersion })=>{
    const { connectAddonIframeData: connectAddonIframeData } = (0, $j4oe4.useFragment)((0, $jxm8w.default), jiraVersion);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const hasConnectApps = connectAddonIframeData.length > 0;
    (0, $82tdT.useConnectAppExtensionExperienceStart)(hasConnectApps);
    const { loading: loading, error: error } = (0, $82tdT.useLoadConnectJs)(hasConnectApps);
    const onExpFail = (0, $aqnJa.useExperienceFail)({
        experience: (0, $5e35924307df60cd$export$af5e668651a80140),
        attributes: {
            errorMessage: error?.message ?? null,
            numConnectApps: connectAddonIframeData.length
        }
    });
    if (!hasConnectApps || loading) return null;
    if (error) {
        onExpFail('versionDetailsHeader', error);
        // This should be caught by the nearest NonCriticalErrorBoundary
        throw error;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4ctwv.ExperienceSuccess), {
        experience: (0, $5e35924307df60cd$export$af5e668651a80140)
    }), connectAddonIframeData.filter((iframeData)=>iframeData != null && iframeData.options === null).map((iframeData)=>{
        if (iframeData == null) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8aJaL.FlagRenderer), {
            key: `error-flag-${iframeData.appName}`,
            flag: {
                type: 'error',
                title: formatMessage((0, $j4foZ.default).errorTitle, {
                    appName: iframeData.appName
                }),
                description: (0, $j4foZ.default).errorDescription,
                messageId: 'software-releases-version-detail.ui.header.connect-apps.flag.error.flag-renderer.error',
                messageType: 'transactional'
            }
        });
    }), connectAddonIframeData.filter((iframeData)=>iframeData != null && iframeData.options !== null).map((iframeData)=>{
        if (iframeData == null || iframeData.options == null) return null;
        const { appKey: appKey, moduleKey: moduleKey, options: options, appName: appName, location: location } = iframeData;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kuQCd.EcosystemModuleAsync), {
            appKey: appKey,
            moduleKey: moduleKey,
            // Temp code to validate if hostOrigin is the problem. In the legacy page, hostOrigin was the public URL, but broken version had internal URL
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            options: {
                ...options,
                hostOrigin: window.location.origin
            },
            appName: appName,
            key: `${appKey}-${moduleKey}`,
            location: location
        });
    }));
};

});
parcelRegister("jxm8w", function(module, exports) {
$parcel$export(module.exports, "default", () => $d1f46ee8857cab72$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6d2ae5269ae2695b400dba5dc9770afa>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $d1f46ee8857cab72$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "connectApps_softwareReleasesVersionDetail",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "concreteType": "JiraVersionConnectAddonIframeData",
                "kind": "LinkedField",
                "name": "connectAddonIframeData",
                "plural": true,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "kind": "ScalarField",
                            "name": "appKey"
                        },
                        "action": "THROW",
                        "path": "connectAddonIframeData.appKey"
                    },
                    {
                        "kind": "RequiredField",
                        "field": {
                            "kind": "ScalarField",
                            "name": "moduleKey"
                        },
                        "action": "THROW",
                        "path": "connectAddonIframeData.moduleKey"
                    },
                    {
                        "kind": "RequiredField",
                        "field": {
                            "kind": "ScalarField",
                            "name": "appName"
                        },
                        "action": "THROW",
                        "path": "connectAddonIframeData.appName"
                    },
                    {
                        "kind": "RequiredField",
                        "field": {
                            "kind": "ScalarField",
                            "name": "location"
                        },
                        "action": "THROW",
                        "path": "connectAddonIframeData.location"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "options"
                    }
                ]
            },
            "action": "THROW",
            "path": "connectAddonIframeData"
        }
    ],
    "type": "JiraVersion"
};
$d1f46ee8857cab72$var$node.hash = "5b5aa6740e6a7342f336e876f3dce998";
var $d1f46ee8857cab72$export$2e2bcd8739ae039 = $d1f46ee8857cab72$var$node;

});

parcelRegister("kuQCd", function(module, exports) {
$parcel$export(module.exports, "EcosystemModuleAsync", () => $3fc31811d72aa125$export$75ae776ec6b96bba);
$parcel$export(module.exports, "EcosystemTimeoutViewAsync", () => $3fc31811d72aa125$export$c800b42cc8eabb03);

var $eJOHy = parcelRequire("eJOHy");

var $4EKqI = parcelRequire("4EKqI");

var $2imLM = parcelRequire("2imLM");

var $bQWwW = parcelRequire("bQWwW");

var $bJscI = parcelRequire("bJscI");
const $3fc31811d72aa125$var$EcosystemModuleSegment = (0, $bJscI.componentWithFG)('issue_add_third_party_ufo_segments', (0, $4EKqI.UFOThirdPartySegment), (0, $eJOHy.Fragment));

const $3fc31811d72aa125$var$EcosystemModule = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("lIMGl")), {
    ssr: true,
    moduleId: "./src/packages/connect-utils/connect-utils-async/src/index.tsx"
});

const $3fc31811d72aa125$var$EcosystemTimeoutView = (0, $bQWwW.lazyAfterPaint)(()=>(parcelRequire("gtbrp")), {
    ssr: true,
    moduleId: "./src/packages/connect-utils/connect-utils-async/src/common/ui/ecosystem-timeout-view/index.tsx"
});
const $3fc31811d72aa125$export$75ae776ec6b96bba = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3fc31811d72aa125$var$EcosystemModuleSegment, {
        name: "ecosystem-module-async-wrapper",
        mode: "list"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "ecosystem-module-async",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3fc31811d72aa125$var$EcosystemModule, props)));
const $3fc31811d72aa125$export$c800b42cc8eabb03 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3fc31811d72aa125$var$EcosystemModuleSegment, {
        name: "ecosystem-module-timeout-view-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "ecosystem-timeout-view-async",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3fc31811d72aa125$var$EcosystemTimeoutView, props)));

});
parcelRegister("lIMGl", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("83ZKS").then(()=>parcelRequire('6h5im'));

});

parcelRegister("gtbrp", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("7S6qn").then(()=>parcelRequire('lmbDy'));

});


parcelRegister("8aJaL", function(module, exports) {
$parcel$export(module.exports, "FlagRenderer", () => $d515553fc0772849$export$7c38ebd1f7ca6a5a);

var $CHBf3 = parcelRequire("CHBf3");

var $jchga = parcelRequire("jchga");
const $d515553fc0772849$export$7c38ebd1f7ca6a5a = (0, $jchga.default)((0, $CHBf3.default));

});
parcelRegister("CHBf3", function(module, exports) {
$parcel$export(module.exports, "default", () => $39b296e7f05658c7$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $fyI8g = parcelRequire("fyI8g");
class $39b296e7f05658c7$export$2e2bcd8739ae039 extends (0, $eJOHy.Component) {
    componentDidMount() {
        const { flagService: flagService, flag: flag } = this.props;
        if (flagService) this.flagId = flagService.showFlag(flag);
    }
    componentWillUnmount() {
        const { flagService: flagService } = this.props;
        if (flagService && this.flagId) flagService.dismissFlag((0, $fyI8g.dismissFlag)(this.flagId));
    }
    render() {
        return null;
    }
}

});


parcelRegister("j4foZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $0b8af5dfa51e0177$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $0b8af5dfa51e0177$var$messages = (0, $7qGN1.defineMessages)({
    errorTitle: {
        "id": "software-releases-version-detail.header.connect-apps.error-title",
        "defaultMessage": "We weren't able to load {appName}."
    },
    errorDescription: {
        "id": "software-releases-version-detail.header.connect-apps.error-description",
        "defaultMessage": "Please refresh the page to try again."
    }
});
var $0b8af5dfa51e0177$export$2e2bcd8739ae039 = $0b8af5dfa51e0177$var$messages;

});

parcelRegister("82tdT", function(module, exports) {
$parcel$export(module.exports, "useLoadConnectJs", () => $20031a3e9eedcb90$export$ea4f866a08ef15ea);
$parcel$export(module.exports, "useConnectAppExtensionExperienceStart", () => $20031a3e9eedcb90$export$491da84e1e953d53);

var $eJOHy = parcelRequire("eJOHy");

var $cGvTS = parcelRequire("cGvTS");

var $8Uqf3 = parcelRequire("8Uqf3");

var $cHtIB = parcelRequire("cHtIB");

const $20031a3e9eedcb90$export$ea4f866a08ef15ea = (shouldLoad)=>{
    const [isLoading, setIsLoading] = (0, $eJOHy.useState)(true);
    const [error, setError] = (0, $eJOHy.useState)(undefined);
    (0, $eJOHy.useEffect)(()=>{
        if (shouldLoad) (0, $cGvTS.withConnectHost)(()=>{
            setIsLoading(false);
        }).catch((e)=>{
            setIsLoading(false);
            setError(e);
        });
    }, [
        shouldLoad
    ]);
    return {
        loading: isLoading,
        error: // @ts-expect-error - TS2322 - Type 'unknown' is not assignable to type 'Error | undefined'.
        error
    };
};
const $20031a3e9eedcb90$export$491da84e1e953d53 = (hasConnectApps)=>{
    const cloudId = (0, $cHtIB.useCloudId)();
    const onStart = (0, $8Uqf3.useExperienceStart)({
        experience: (0, $5e35924307df60cd$export$af5e668651a80140),
        experienceId: cloudId,
        analyticsSource: 'versionDetails'
    });
    (0, $eJOHy.useEffect)(()=>{
        if (hasConnectApps) onStart();
    }, [
        onStart,
        hasConnectApps
    ]);
};

});


parcelRegister("jI8iD", function(module, exports) {
$parcel$export(module.exports, "AsyncEditableName", () => $660ef64f24173887$export$9fb8a15f1e2c2f6f);

var $kTSR5 = parcelRequire("kTSR5");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $2imLM = parcelRequire("2imLM");

var $bQWwW = parcelRequire("bQWwW");

var $d6k3x = parcelRequire("d6k3x");

var $dL4zI = parcelRequire("dL4zI");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $660ef64f24173887$var$LazyEditableName = (0, $bQWwW.lazy)(()=>(parcelRequire("7SrqQ")).then((module)=>module.EditableName), {
    moduleId: "./src/packages/releases/version-detail/src/ui/header/editable-name/index.tsx"
});
const $660ef64f24173887$export$9fb8a15f1e2c2f6f = ({ jiraVersion: jiraVersion, isEditing: isEditing, setIsEditing: setIsEditing })=>{
    const version = (0, $j4oe4.useFragment)((0, $kTSR5.default), jiraVersion);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "editable-name",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dL4zI.InlineEditReadViewContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d6k3x.PageTitle), {
            size: "large",
            as: "h1"
        }, version.name))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($660ef64f24173887$var$LazyEditableName, {
        jiraVersion: version,
        isEditing: isEditing,
        setIsEditing: setIsEditing
    }));
};

});
parcelRegister("kTSR5", function(module, exports) {
$parcel$export(module.exports, "default", () => $0a527b42c687c772$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<20a6f51f522d15758d6a81ed1c455dfa>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $0a527b42c687c772$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "async_softwareReleasesVersionDetail_AsyncEditableName",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "kind": "FragmentSpread",
            "name": "editableName_softwareReleasesVersionDetail"
        }
    ],
    "type": "JiraVersion"
};
$0a527b42c687c772$var$node.hash = "72635c9ff5ceeb9dc0fc3b0d03ba28e8";
var $0a527b42c687c772$export$2e2bcd8739ae039 = $0a527b42c687c772$var$node;

});

parcelRegister("d6k3x", function(module, exports) {
$parcel$export(module.exports, "PageTitle", () => $399631fd3c3360f2$export$155581e8dc02007a);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $806LH = parcelRequire("806LH");
const $399631fd3c3360f2$export$155581e8dc02007a = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = (0, $806LH.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _1bto1l2s _o5721q9c _19pkidpf _ca0q1b66 _u5f312x7 _n3td1b66 _19bv12x7",
            __cmplp.className
        ])
    });
});

});

parcelRegister("dL4zI", function(module, exports) {
$parcel$export(module.exports, "InlineEditReadViewContainer", () => $6b233fa4cd068943$export$408cb7913975dc96);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ /*
 * This component replicates margin/padding/border styles the @atlaskit/inline-edit component adds around
 * its "read view". The goal is to avoid styling inconsistencies in places where we *conditionally* render
 * an inline edit, e.g. as a suspense placeholde or a read-only mode. Example usage:
 *
 * return canEdit
 *      ? <InlineEdit readView={() => <ReadView />} {...otherProps} />
 *      : <InlineEditReadViewContainer><ReadView /></InlineEditReadViewContainer>
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $6b233fa4cd068943$export$408cb7913975dc96 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_189e1dm9 _1dqonqa1 _1h6d3acm _19pku2gc _vwz4kb7n",
            __cmplp.className
        ])
    });
});

});

parcelRegister("7SrqQ", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("jPNH0").then(()=>parcelRequire('dsTJM'));

});


parcelRegister("ixtC2", function(module, exports) {
$parcel$export(module.exports, "FeedbackButton", () => $f23bc07e7db69770$export$116fedbe5e2e2bd8);

var $eJOHy = parcelRequire("eJOHy");

var $gdeTc = parcelRequire("gdeTc");

var $lhWt4 = parcelRequire("lhWt4");

var $kX3ON = parcelRequire("kX3ON");
const $f23bc07e7db69770$var$FEEDBACK_COLLECTOR_LOCATION = 'releases.version.detail';
const $f23bc07e7db69770$export$116fedbe5e2e2bd8 = ()=>{
    const { simplified: simplified, isProjectAdmin: isProjectAdmin } = (0, $kX3ON.useProjectContext)();
    const additionalFeedbackEntries = [
        {
            id: (0, $gdeTc.EntryKeys).FEEDBACK_COLLECTOR_LOCATION,
            value: $f23bc07e7db69770$var$FEEDBACK_COLLECTOR_LOCATION
        },
        {
            id: (0, $gdeTc.EntryKeys).IS_SIMPLIFIED_PROJECT,
            value: simplified.toString()
        },
        {
            id: (0, $gdeTc.EntryKeys).IS_ADMIN,
            value: isProjectAdmin == null ? 'unknown' : isProjectAdmin.toString()
        }
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lhWt4.FeedbackCollectorButton), {
        entrypointId: (0, $gdeTc.ENTRYPOINT_ID_JIRA_SOFTWARE_PROJECT),
        feedbackContext: additionalFeedbackEntries
    });
};

});
parcelRegister("lhWt4", function(module, exports) {
$parcel$export(module.exports, "FeedbackCollectorButton", () => $2d44d3cbf65fe67a$export$b39479f42d974760);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $goZPP = parcelRequire("goZPP");

var $8c712 = parcelRequire("8c712");

var $k71qx = parcelRequire("k71qx");

var $lRq8t = parcelRequire("lRq8t");

var $cHtIB = parcelRequire("cHtIB");

var $gdeTc = parcelRequire("gdeTc");

var $4Qvpr = parcelRequire("4Qvpr");

var $3xTe8 = parcelRequire("3xTe8");
const $2d44d3cbf65fe67a$var$TooltipWrapper = ({ children: children, appearance: appearance, customLabel: customLabel })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    if (appearance === 'icon') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: customLabel || formatMessage((0, $3xTe8.messages).leaveFeedback),
        position: "top"
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children);
};
const $2d44d3cbf65fe67a$export$b39479f42d974760 = ({ buttonAppearance: buttonAppearance = 'normal', testId: testId, icon: Icon = (0, (/*@__PURE__*/$parcel$interopDefault($8c712))), feedbackButtonCustomLabel: feedbackButtonCustomLabel, ...feedbackCollectorProps })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const cloudId = (0, $cHtIB.useCloudId)();
    const { openFeedbackCollector: openFeedbackCollector } = (0, $4Qvpr.useFeedbackCollectorActions)();
    const buttonRef = (0, $eJOHy.useRef)(null);
    const onOpen = (0, $eJOHy.useCallback)(()=>{
        // Check if feedbackContext already contains the cloud ID entry
        const hasCloudId = feedbackCollectorProps?.feedbackContext?.some((entry)=>entry.id === (0, $gdeTc.EntryKeys).CLOUD_ID);
        // If not, add cloud id to feedback context
        const updatedFeedbackContext = hasCloudId ? feedbackCollectorProps.feedbackContext : [
            ...feedbackCollectorProps.feedbackContext || [],
            {
                id: (0, $gdeTc.EntryKeys).CLOUD_ID,
                value: cloudId
            }
        ];
        openFeedbackCollector({
            ...feedbackCollectorProps,
            feedbackContext: updatedFeedbackContext,
            triggerRef: buttonRef
        });
    }, [
        cloudId,
        feedbackCollectorProps,
        openFeedbackCollector
    ]);
    const displayAsLink = buttonAppearance === 'link';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2d44d3cbf65fe67a$var$TooltipWrapper, {
        appearance: buttonAppearance,
        customLabel: feedbackButtonCustomLabel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2d44d3cbf65fe67a$var$StyledButton, {
        testId: testId,
        ref: buttonRef,
        appearance: displayAsLink ? 'link' : 'subtle',
        isHighlight: buttonAppearance === 'highlight',
        spacing: displayAsLink ? 'none' : 'default',
        onClick: onOpen,
        iconBefore: displayAsLink ? undefined : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Icon, {
            color: buttonAppearance === 'highlight' ? "var(--ds-text-discovery, #803FA5)" : "var(--ds-text, #292A2E)",
            label: ""
        }),
        "aria-label": // Only add aria-label if this is an icon button
        buttonAppearance === 'icon' && (feedbackButtonCustomLabel || formatMessage((0, $3xTe8.messages).leaveFeedback)) || '',
        "aria-haspopup": "dialog"
    }, buttonAppearance !== 'icon' && (feedbackButtonCustomLabel || formatMessage((0, $3xTe8.messages).leaveFeedback))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $2d44d3cbf65fe67a$var$StyledButton = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = (0, $goZPP.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "",
            __cmplp.isHighlight && "_1w90dqil _16hgp2ly _1fh1dqil _u1mb1nm4 _r7sm18ah _1l5a1gfe",
            __cmplp.className
        ])
    });
});

});
parcelRegister("8c712", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e0442f8372c8ab0b117b1651de731ee9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5f74e2e78935ad1f$var$_react = $5f74e2e78935ad1f$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $5f74e2e78935ad1f$var$_baseNew = $5f74e2e78935ad1f$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $5f74e2e78935ad1f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Feedback".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: customer feedback.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5f74e2e78935ad1f$var$FeedbackIcon = (props)=>/*#__PURE__*/ $5f74e2e78935ad1f$var$_react.default.createElement($5f74e2e78935ad1f$var$_baseNew.default, Object.assign({
        name: "FeedbackIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6.221l-4.064 2.63A.75.75 0 0 1 1 15V9.5h1.5v4.121l3.093-2A.75.75 0 0 1 6 11.5h7a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5H3a.5.5 0 0 0-.5.5v2.75a.5.5 0 0 0 .5.5h5.44L7.22 5.03l1.06-1.06 2.5 2.5a.75.75 0 0 1 0 1.06l-2.5 2.5-1.06-1.06 1.22-1.22H3a2 2 0 0 1-2-2z" clip-rule="evenodd"/>`
    }, props));
$5f74e2e78935ad1f$var$FeedbackIcon.displayName = 'FeedbackIcon';
var $5f74e2e78935ad1f$var$_default = module.exports.default = $5f74e2e78935ad1f$var$FeedbackIcon;

});

parcelRegister("3xTe8", function(module, exports) {
$parcel$export(module.exports, "messages", () => $3ab49be821ee4a1d$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $3ab49be821ee4a1d$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    leaveFeedback: {
        "id": "platform.feedback.feedback-collector.button.leave-feedback",
        "defaultMessage": "Give feedback"
    }
});

});



parcelRegister("7jCAm", function(module, exports) {
$parcel$export(module.exports, "ReleaseNotesButton", () => $587c0b91e8f5cfb6$export$760b84d5e0ebb5da);

var $jxEpB = parcelRequire("jxEpB");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $goZPP = parcelRequire("goZPP");

var $956it = parcelRequire("956it");

var $lRq8t = parcelRequire("lRq8t");

var $2imLM = parcelRequire("2imLM");

var $kRgKj = parcelRequire("kRgKj");

var $jaIdG = parcelRequire("jaIdG");

var $bQWwW = parcelRequire("bQWwW");

var $gVv7l = parcelRequire("gVv7l");

var $b70fx = parcelRequire("b70fx");

var $f0SyN = parcelRequire("f0SyN");

var $jMJVh = parcelRequire("jMJVh");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $587c0b91e8f5cfb6$var$LazyReleaseNotesModal = (0, $bQWwW.lazy)(()=>Promise.resolve((parcelRequire("e8cgA"))).then((module)=>module.ReleaseNotesModal), {
    moduleId: "./src/packages/releases/release-notes-modal/src/ui/async.tsx"
});
const $587c0b91e8f5cfb6$export$760b84d5e0ebb5da = ({ jiraVersion: jiraVersion })=>{
    const [isOpen, setIsOpen] = (0, $eJOHy.useState)(false);
    const version = (0, $j4oe4.useFragment)((0, $jxEpB.default), jiraVersion);
    const [releaseNotesQueryReference, loadReleaseNotesQuery] = (0, $j4oe4.useQueryLoader)((0, $gVv7l.default));
    const loadReleaseNoteModalResource = ()=>{
        loadReleaseNotesQuery({
            versionAri: version.id
        }, {
            fetchPolicy: 'store-and-network'
        });
        $587c0b91e8f5cfb6$var$LazyReleaseNotesModal.preload();
    };
    (0, $jMJVh.useRedirectAutoOpenReleaseModal)(()=>setIsOpen(true), loadReleaseNoteModalResource);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const experienceStart = (0, $jaIdG.useCreateReleaseNotesExperienceStart)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $b70fx.NonCriticalErrorBoundary), {
        eventLocation: "releaseNotesModal",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "release-note-modal",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $956it.default), null, releaseNotesQueryReference && isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($587c0b91e8f5cfb6$var$LazyReleaseNotesModal, {
        queryReference: releaseNotesQueryReference,
        onClose: ()=>setIsOpen(false)
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        onMouseEnter: loadReleaseNoteModalResource,
        onClick: (_, analyticsEvent)=>{
            setIsOpen(true);
            (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'versionReleaseNotesModal');
            experienceStart();
        }
    }, formatMessage((0, $f0SyN.default).releaseNotesButton)));
};

});
parcelRegister("jxEpB", function(module, exports) {
$parcel$export(module.exports, "default", () => $3ff975342addb090$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<0079ec0a17b0f8593b69119b804c8bed>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $3ff975342addb090$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "releaseNotesButton_softwareReleasesVersionDetail",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "id"
            },
            "action": "THROW",
            "path": "id"
        }
    ],
    "type": "JiraVersion"
};
$3ff975342addb090$var$node.hash = "05a2c1a8fb9ea7ab5acb19f863afe1aa";
var $3ff975342addb090$export$2e2bcd8739ae039 = $3ff975342addb090$var$node;

});

parcelRegister("jaIdG", function(module, exports) {
$parcel$export(module.exports, "useCreateReleaseNotesExperienceStart", () => $50f9fc13e815e79a$export$dbc8ab93f701ba27);
$parcel$export(module.exports, "useCreateReleaseNotesExperienceFail", () => $50f9fc13e815e79a$export$66c9cef2c6cdd99d);
$parcel$export(module.exports, "useCreateReleaseNotesExperienceSuccess", () => $50f9fc13e815e79a$export$fe155a48cbacc64a);

var $aqnJa = parcelRequire("aqnJa");

var $8Uqf3 = parcelRequire("8Uqf3");

var $4ctwv = parcelRequire("4ctwv");

var $lBYgs = parcelRequire("lBYgs");

var $1BZ8a = parcelRequire("1BZ8a");
const $50f9fc13e815e79a$export$52919046b94109dc = 'createReleaseNotes';
const $50f9fc13e815e79a$var$ANALYTICS_SOURCE = 'versionDetails';
const $50f9fc13e815e79a$export$dbc8ab93f701ba27 = ()=>{
    const appEditions = (0, $1BZ8a.useAppEditions)();
    return (0, $8Uqf3.useExperienceStart)({
        experience: $50f9fc13e815e79a$export$52919046b94109dc,
        experienceId: `${Date.now()}`,
        analyticsSource: $50f9fc13e815e79a$var$ANALYTICS_SOURCE,
        application: (0, $lBYgs.JIRA_SOFTWARE),
        edition: appEditions.software
    });
};
const $50f9fc13e815e79a$export$66c9cef2c6cdd99d = ()=>(0, $aqnJa.useExperienceFail)({
        experience: $50f9fc13e815e79a$export$52919046b94109dc
    });
const $50f9fc13e815e79a$export$fe155a48cbacc64a = ()=>(0, $4ctwv.useExperienceSuccess)({
        experience: $50f9fc13e815e79a$export$52919046b94109dc
    });

});

parcelRegister("f0SyN", function(module, exports) {
$parcel$export(module.exports, "default", () => $d23003fee35f8b46$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $d23003fee35f8b46$var$messages = (0, $7qGN1.defineMessages)({
    releaseNotesButton: {
        "id": "software-releases-version-detail.header.release-notes-button.release-notes-button",
        "defaultMessage": "Release notes"
    }
});
var $d23003fee35f8b46$export$2e2bcd8739ae039 = $d23003fee35f8b46$var$messages;

});

parcelRegister("jMJVh", function(module, exports) {
$parcel$export(module.exports, "useRedirectAutoOpenReleaseModal", () => $1ccc5fa748823094$export$83b5462c8aa5c10f);

var $eJOHy = parcelRequire("eJOHy");

var $gCY1z = parcelRequire("gCY1z");
const $1ccc5fa748823094$export$83b5462c8aa5c10f = (openModal, loadReleaseNoteModal)=>{
    const [{ query: query }] = (0, $gCY1z.useRouter)();
    const hasModalBeenOpened = (0, $eJOHy.useRef)(false);
    if (hasModalBeenOpened.current === false && query.isReleaseNoteModalOpen === 'true') {
        loadReleaseNoteModal();
        openModal();
        hasModalBeenOpened.current = true;
    }
};

});



parcelRegister("8Qifh", function(module, exports) {
$parcel$export(module.exports, "default", () => $88cf04e05be44c7c$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $88cf04e05be44c7c$var$messages = (0, $7qGN1.defineMessages)({
    browserTitle: {
        "id": "software-releases-version-detail.browser-title",
        "defaultMessage": "{projectName}: {versionName}"
    },
    issues: {
        "id": "software-releases-version-detail.issues",
        "defaultMessage": "Issues"
    },
    issuesIssueTerminologyRefreshM4: {
        "id": "software-releases-version-detail.issues-issue-terminology-refresh-m4",
        "defaultMessage": "Work items"
    }
});
var $88cf04e05be44c7c$export$2e2bcd8739ae039 = $88cf04e05be44c7c$var$messages;

});

parcelRegister("82maw", function(module, exports) {
$parcel$export(module.exports, "RightSidebar", () => $1c4efdcda1cabedb$export$84d58c19c21f637f);

var $ccXRe = parcelRequire("ccXRe");

var $jqMKS = parcelRequire("jqMKS");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $j4oe4 = parcelRequire("j4oe4");

var $1aLTh = parcelRequire("1aLTh");

var $1aLTh = parcelRequire("1aLTh");

var $fo3wk = parcelRequire("fo3wk");

var $kDaaB = parcelRequire("kDaaB");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $i6OEF = parcelRequire("i6OEF");

var $1Ck3K = parcelRequire("1Ck3K");

var $jUXjl = parcelRequire("jUXjl");

var $g8i7y = parcelRequire("g8i7y");
const $1c4efdcda1cabedb$var$getNewCollapsedUis = (currentState, isCurrentlyCollapsed)=>isCurrentlyCollapsed ? currentState.filter((value)=>value !== 'RIGHT_SIDEBAR') : [
        ...currentState,
        'RIGHT_SIDEBAR'
    ];
const $1c4efdcda1cabedb$export$84d58c19c21f637f = ({ jiraVersion: jiraVersion, children: children })=>{
    const [state] = (0, $i6OEF.useSidebarStore)();
    const sidebarActions = (0, $i6OEF.useSidebarActions)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const version = (0, $j4oe4.useFragment)((0, $jqMKS.default), jiraVersion);
    const [updateCollapsedUis] = // eslint-disable-next-line jira/graphql/restrict-graphql-in-unnamed-files
    (0, $j4oe4.useMutation)((0, $ccXRe.default));
    const onError = ()=>{
        (0, $kRgKj.fireUIAnalytics)({
            // @ts-expect-error - Argument of type '{ meta: { id: string; packageName: string; teamName: string; }; error: Error; sendToPrivacyUnsafeSplunk: boolean; }' is not assignable to parameter of type 'UIAnalyticsEvent'.
            meta: {
                id: 'jira.releases.version.detail.collapsed-uis.user-preference.mutation.error.id',
                packageName: 'jiraSoftwareReleasesVersionDetail',
                teamName: 'jolt'
            },
            error: Error('Unable to update collapsed ui state'),
            sendToPrivacyUnsafeSplunk: true
        });
    };
    const saveUserPreference = (newCollapsedUis)=>{
        updateCollapsedUis({
            variables: {
                input: {
                    collapsedUis: newCollapsedUis,
                    versionId: version.id
                }
            },
            onCompleted: (data)=>{
                if (!data.jira?.saveVersionDetailsCollapsedUis?.success) onError();
            },
            onError: onError,
            optimisticResponse: {
                jira: {
                    saveVersionDetailsCollapsedUis: {
                        success: true,
                        version: {
                            collapsedUis: newCollapsedUis,
                            id: version.id
                        }
                    }
                }
            }
        });
    };
    const collapsedUis = (version.collapsedUis ?? []).filter(Boolean);
    const isIssueClosed = state.status === 'CLOSED';
    const isSidebarExpanded = !collapsedUis.includes('RIGHT_SIDEBAR') || !isIssueClosed;
    const keyboardShortcutPressedEvent = createAnalyticsEvent({
        action: 'pressed',
        actionSubject: 'keyboardShortcut'
    });
    const buttonClickedEvent = createAnalyticsEvent({
        action: 'clicked',
        actionSubject: 'button'
    });
    const handleChange = (analyticsEvent)=>{
        (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'versionDetailsCollapsibleRightSidebar', {
            targetState: isSidebarExpanded ? 'collapsed' : 'expanded'
        });
        if (!isIssueClosed) sidebarActions.close();
        saveUserPreference($1c4efdcda1cabedb$var$getNewCollapsedUis(collapsedUis, !isSidebarExpanded));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1aLTh.default), {
        in: isSidebarExpanded,
        timeout: 100
    }, (transitionState)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($1c4efdcda1cabedb$var$SidebarContainer, {
            isIssueClosed: isIssueClosed,
            transitionState: transitionState
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fo3wk.default), {
            keyMap: {
                ']': {
                    callback: ()=>handleChange(keyboardShortcutPressedEvent),
                    label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kDaaB.default), (0, $jUXjl.messages).resizeKeyboardShortcutLabel)
                }
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $g8i7y.ResizeBoundary), {
            isSidebarCollapsed: !isSidebarExpanded,
            onClick: ()=>handleChange(buttonClickedEvent)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $g8i7y.ResizeButton), {
            isSidebarCollapsed: !isSidebarExpanded,
            onClick: ()=>handleChange(buttonClickedEvent)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($1c4efdcda1cabedb$var$SidebarContent, {
            isIssueClosed: isIssueClosed,
            transitionState: transitionState
        }, children)));
};
const $1c4efdcda1cabedb$var$enteredTransitionContainerStyle = {
    flex: `0 0 ${(0, $1Ck3K.RIGHT_SIDEBAR_WIDTH)}px`,
    width: `${(0, $1Ck3K.RIGHT_SIDEBAR_WIDTH)}px`
};
const $1c4efdcda1cabedb$var$exitedTransitionContainerStyle = {
    flex: '0 0 0',
    width: `${(0, $1Ck3K.VERSION_DETAIL_PADDING)}px`
};
const $1c4efdcda1cabedb$var$enteredTransitionContentStyle = {
    opacity: 1
};
const $1c4efdcda1cabedb$var$exitedTransitionContentStyle = {
    opacity: 0
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1c4efdcda1cabedb$var$SidebarContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isIssueClosed: isIssueClosed, transitionState: transitionState, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_16jlidpf _1o9zidpf _i0dl94b1 _v5645o7y _ankwewfl _kqswh2mm _1g3qkb7n",
            __cmplp.isIssueClosed ? "_1bsblti4" : "_1bsb1dft",
            __cmplp.transitionState === (0, $1aLTh.ENTERED) && "_16jlidpf _1o9zidpf _i0dl94b1 _1bsblti4",
            __cmplp.transitionState === (0, $1aLTh.EXITED) && "_16jlidpf _1o9zidpf _i0dlf1ug _1bsb1tcg",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1c4efdcda1cabedb$var$SidebarContent = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isIssueClosed: isIssueClosed, transitionState: transitionState, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_zulppxbi _v564g17y _1e0c1txw _2lx21bp4 _ca0q1tcg _n3td1tcg _c71l1osq _4t3i1osq _vchhusvi _18m91wug",
            __cmplp.isIssueClosed ? "_19bv1tcg" : "_19bvidpf",
            __cmplp.isIssueClosed ? "_u5f31tcg" : "_u5f3idpf",
            __cmplp.transitionState === (0, $1aLTh.ENTERED) && "_tzy4kb7n",
            __cmplp.transitionState === (0, $1aLTh.EXITED) && "_tzy4idpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("ccXRe", function(module, exports) {
$parcel$export(module.exports, "default", () => $78f9bc71b34d72fa$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<bf6797bcc455e5b9b21455cbbfbfb54c>>
 * @relayHash c2b98978082788d4d50aace3a2030149
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 480e364865776dcd2811bc8565bcdbccd9b13a24e85ea6c62e923fb2209d69bf
const $78f9bc71b34d72fa$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "kind": "ScalarField",
        "name": "collapsedUis"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "rightSidebar_softwareReleasesVersionDetail_updateCollapsedUisMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraVersionDetailsCollapsedUisPayload",
                            "kind": "LinkedField",
                            "name": "saveVersionDetailsCollapsedUis",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "concreteType": "JiraVersion",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "rightSidebar_softwareReleasesVersionDetail_updateCollapsedUisMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraVersionDetailsCollapsedUisPayload",
                            "kind": "LinkedField",
                            "name": "saveVersionDetailsCollapsedUis",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "concreteType": "JiraVersion",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "480e364865776dcd2811bc8565bcdbccd9b13a24e85ea6c62e923fb2209d69bf",
            "metadata": {},
            "name": "rightSidebar_softwareReleasesVersionDetail_updateCollapsedUisMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$78f9bc71b34d72fa$var$node.hash = "eae188b16f12cd7a08081363e9d8ba79";
var $78f9bc71b34d72fa$export$2e2bcd8739ae039 = $78f9bc71b34d72fa$var$node;

});

parcelRegister("jqMKS", function(module, exports) {
$parcel$export(module.exports, "default", () => $2a0fdf70f522a63c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<060507cc19c856be16a6c851e122e50d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $2a0fdf70f522a63c$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "rightSidebar_softwareReleasesVersionDetail",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "collapsedUis"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "id"
            },
            "action": "THROW",
            "path": "id"
        }
    ],
    "type": "JiraVersion"
};
$2a0fdf70f522a63c$var$node.hash = "f6b47df507b4f1c932a991a3cdcfb952";
var $2a0fdf70f522a63c$export$2e2bcd8739ae039 = $2a0fdf70f522a63c$var$node;

});

parcelRegister("fo3wk", function(module, exports) {
$parcel$export(module.exports, "default", () => $4454c8bb14df47ef$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $ftN6c = parcelRequire("ftN6c");

var $hrKgE = parcelRequire("hrKgE");

var $9ltuT = parcelRequire("9ltuT");

var $lObif = parcelRequire("lObif");

var $5R5jr = parcelRequire("5R5jr");

var $d94A4 = parcelRequire("d94A4");

var $4B7rn = parcelRequire("4B7rn");

var $8gJRB = parcelRequire("8gJRB");
let $4454c8bb14df47ef$var$shortcutsCount = 0;
let $4454c8bb14df47ef$var$subscription = null;
const $4454c8bb14df47ef$var$ShortcutsSubscriber = false ? ()=>null : ({ keyMap: keyMap, label: label, location: location })=>{
    const parentRegistry = (0, $eJOHy.useContext)((0, $4B7rn.ShortcutRegistryContext)) || (0, $d94A4.rootRegistry);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const addKeyMap = (0, $eJOHy.useCallback)(()=>parentRegistry.addKeyMap(()=>({
                keyMap: (0, $8gJRB.bindKeyMapWithErrorHandling)(keyMap, location, createAnalyticsEvent({
                    action: 'pressed',
                    actionSubject: 'keyboardShortcut'
                })),
                label: label
            })), [
        parentRegistry,
        keyMap,
        location,
        createAnalyticsEvent,
        label
    ]);
    (0, $eJOHy.useEffect)(()=>{
        $4454c8bb14df47ef$var$shortcutsCount += 1;
        const removeKeyMap = addKeyMap();
        return ()=>{
            removeKeyMap();
            $4454c8bb14df47ef$var$shortcutsCount -= 1;
            if ($4454c8bb14df47ef$var$subscription && $4454c8bb14df47ef$var$shortcutsCount === 0) {
                $4454c8bb14df47ef$var$subscription.unsubscribe();
                $4454c8bb14df47ef$var$subscription = null;
            }
        };
    }, [
        addKeyMap
    ]);
    (0, $eJOHy.useEffect)(()=>{
        $4454c8bb14df47ef$var$subscription = $4454c8bb14df47ef$var$subscription || // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $5R5jr.default)().subscribe((0, $lObif.default));
    }, [
        parentRegistry,
        keyMap
    ]);
    return null;
};
const $4454c8bb14df47ef$var$Shortcuts = ({ useKeyboardShortcutsToggle: // eslint-disable-next-line react-hooks/react-compiler
useKeyboardShortcutsToggle = (0, $9ltuT.useKeyboardShortcutsToggle), ...unstableProps })=>{
    // eslint-disable-next-line react-hooks/react-compiler
    const [{ isEnabled: isEnabled }] = useKeyboardShortcutsToggle();
    const props = (0, $hrKgE.useShallowStableReference)(unstableProps, true);
    return isEnabled && !false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($4454c8bb14df47ef$var$ShortcutsSubscriber, props) : null;
};
var $4454c8bb14df47ef$export$2e2bcd8739ae039 = $4454c8bb14df47ef$var$Shortcuts;

});
parcelRegister("9ltuT", function(module, exports) {
$parcel$export(module.exports, "useKeyboardShortcutsToggle", () => $08e42e851d357ae1$export$a33a81f1fc5458ad);

var $9pTd3 = parcelRequire("9pTd3");

var $3ugTQ = parcelRequire("3ugTQ");

var $hWeHP = parcelRequire("hWeHP");

var $kRgKj = parcelRequire("kRgKj");

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");
const $08e42e851d357ae1$var$URL_FRAGMENT = '/rest/internal/latest/user/preferences/keyboardShortcuts?turn=';
const $08e42e851d357ae1$export$b62f67be35e65859 = (analyticsEvent)=>async ({ setState: setState, getState: getState })=>{
        const currentState = getState().isEnabled;
        const status = currentState ? 'off' : 'on';
        const url = `${$08e42e851d357ae1$var$URL_FRAGMENT}${status}`;
        try {
            await (0, $3ugTQ.performPutRequest)(url);
            setState({
                isEnabled: !currentState,
                error: null
            });
            (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'keyboardShortcutsToggle', {
                isEnabled: !currentState
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            setState({
                error: err
            });
            (0, $9pTd3.fireErrorAnalytics)({
                meta: {
                    id: 'keyboardShortcutToggleFailure',
                    packageName: 'jiraCommonLegacyDoNotAddAnythingNew'
                },
                error: err
            });
        }
    };
const $08e42e851d357ae1$var$Store = (0, $GtRbT.createStore)({
    initialState: {
        isEnabled: false ? false : !((0, $hWeHP.default)('ajs-keyboard-shortcuts-enabled') === 'false'),
        error: null
    },
    actions: {
        // @ts-expect-error - TS2322 - Type '( analyticsEvent: UIAnalyticsEventInterface) => ({ setState, getState }: StoreActionApi<State>) => Promise<void>' is not assignable to type 'ActionThunk<{ isEnabled: boolean; error: null; }, { toggle: ( analyticsEvent: UIAnalyticsEventInterface) => ({ setState, getState }: StoreActionApi<State>) => Promise<void>; }>'.
        toggle: $08e42e851d357ae1$export$b62f67be35e65859
    }
});
const $08e42e851d357ae1$export$a33a81f1fc5458ad = (0, $iJq0l.createHook)($08e42e851d357ae1$var$Store);

});

parcelRegister("lObif", function(module, exports) {
$parcel$export(module.exports, "default", () => $f6eea6b4ddedc8b9$export$2e2bcd8739ae039);

var $5R5jr = parcelRequire("5R5jr");

var $d94A4 = parcelRequire("d94A4");
const $f6eea6b4ddedc8b9$var$matches = (prefix)=>(definedSequence)=>definedSequence.startsWith(`${prefix} `);
/**
 * Manages key sequence inputs to execute predefined actions or clear unmatched sequences. This function ensures efficient handling of user inputs by checking against existing sequences and preparing for potential future matches.
 */ const $f6eea6b4ddedc8b9$var$handler = (keySequence)=>{
    const { sequence: sequence, e: e } = keySequence || {};
    const activeKeyMap = (0, $d94A4.rootRegistry).getActiveKeyMap();
    if (sequence !== undefined && activeKeyMap[sequence]) {
        activeKeyMap[sequence].callback(e);
        (0, $5R5jr.flush)();
    } else {
        // Are there any sequences that might be activated with more key presses?
        const isFutureMatchPossible = sequence !== undefined && Object.keys(activeKeyMap).some($f6eea6b4ddedc8b9$var$matches(sequence));
        if (!isFutureMatchPossible) (0, $5R5jr.flush)();
    }
};
var $f6eea6b4ddedc8b9$export$2e2bcd8739ae039 = $f6eea6b4ddedc8b9$var$handler;

});
parcelRegister("5R5jr", function(module, exports) {
$parcel$export(module.exports, "flush", () => $6bc56ab68fad194d$export$4909b86c8034bf73);
$parcel$export(module.exports, "default", () => $6bc56ab68fad194d$export$2e2bcd8739ae039);
/**
 * An observable that emits key sequences as a string representation
 *
 * Examples:
 *
 * g i
 * shift+enter
 */ 
var $7kixv = parcelRequire("7kixv");

var $6WhQS = parcelRequire("6WhQS");
parcelRequire("7SsGX");
parcelRequire("hnYRz");
parcelRequire("llumX");
parcelRequire("lVRem");
parcelRequire("1o2WJ");
parcelRequire("8rm0O");
parcelRequire("9Zsih");
parcelRequire("lf3vd");

var $gPrdS = parcelRequire("gPrdS");

var $6ju76 = parcelRequire("6ju76");
const $6bc56ab68fad194d$var$ignoredKeys = {
    Control: true,
    Meta: true,
    Shift: true,
    Alt: true,
    AltGraph: true,
    CapsLock: true,
    Fn: true,
    FnLock: true,
    Hyper: true,
    NumLock: true,
    OS: true,
    ScrollLock: true,
    Super: true,
    Symbol: true,
    SymbolLock: true
};
/**
 * Skipping few input types to allow keydown event propagation to it's parent element
 * inputMode - react-select or select or combo
 * type - skipping these inputtypes (checkbox, radio) to support shortcuts like
 *        e(EPIC panel) or v(VERSION panel) or n(board card selection) in board and backlog
 * This condition added as a part of https://a11y.atlassian.net/browse/JCA11Y-1317
 */ const $6bc56ab68fad194d$var$isNonTextInput = ({ inputMode: inputMode = '', type: type })=>inputMode === 'none' || type === 'checkbox';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $6bc56ab68fad194d$var$isEditable = (node)=>node.nodeName === 'INPUT' && !$6bc56ab68fad194d$var$isNonTextInput(node) || node.nodeName === 'TEXTAREA' || node.isContentEditable === true;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $6bc56ab68fad194d$var$isRelevantKeyEvent = (e)=>typeof e.key === 'string' && // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '{ readonly Control: true; readonly Meta: true; readonly Shift: true; readonly Alt: true; readonly AltGraph: true; readonly CapsLock: true; readonly Fn: true; readonly FnLock: true; readonly Hyper: true; ... 5 more ...; readonly SymbolLock: true; }'.
    (e.key === 'Escape' || !$6bc56ab68fad194d$var$isEditable(e.target) && !$6bc56ab68fad194d$var$ignoredKeys[e.key]);
let $6bc56ab68fad194d$var$key$;
const $6bc56ab68fad194d$var$flush$ = new (0, $6WhQS.Subject)();
const $6bc56ab68fad194d$var$createSequences = ()=>{
    if (!$6bc56ab68fad194d$var$key$) {
        $6bc56ab68fad194d$var$key$ = false ? new (0, $6WhQS.Subject)() : (0, $7kixv.Observable).fromEvent(document, 'keydown').filter($6bc56ab68fad194d$var$isRelevantKeyEvent).filter((0, $6ju76.isLegacyAuiBlanketClosed)).map((0, $gPrdS.toKeyWithModifiers));
        const sequence$ = $6bc56ab68fad194d$var$key$.scan((seq, key)=>{
            if (!key || !seq) return undefined;
            return {
                sequence: `${String(seq.sequence)} ${String(key.sequence)}`,
                e: key.e
            };
        });
        $6bc56ab68fad194d$var$key$ = $6bc56ab68fad194d$var$key$.debounceTime(1000).startWith(null).merge($6bc56ab68fad194d$var$flush$).switchMapTo(sequence$);
    }
    return $6bc56ab68fad194d$var$key$;
};
const $6bc56ab68fad194d$export$4909b86c8034bf73 = ()=>{
    $6bc56ab68fad194d$var$flush$.next();
};
var $6bc56ab68fad194d$export$2e2bcd8739ae039 = $6bc56ab68fad194d$var$createSequences;

});


parcelRegister("8gJRB", function(module, exports) {
$parcel$export(module.exports, "bindKeyMapWithErrorHandling", () => $91e416a701a8c178$export$77477772a9b904da);

var $eSnSE = parcelRequire("eSnSE");

var $kRgKj = parcelRequire("kRgKj");

var $4cTDP = parcelRequire("4cTDP");
const $91e416a701a8c178$var$wrapCallbackWithErrorHandling = (key, callback, location = 'keyboard-shortcuts.common', analyticsEvent)=>(e)=>{
        try {
            if (analyticsEvent && (0, $4cTDP.fg)('log-hotkey-analytics')) (0, $kRgKj.fireTrackAnalytics)(analyticsEvent, 'keyboardShortcut pressed', {
                key: key
            });
            callback(e);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $eSnSE.default).safeErrorWithoutCustomerData(location, `Error firing shortcut '${key}': ${error.message} (commandPaletteBlockNativeShortcutFF=true)`, error);
        }
    };
const $91e416a701a8c178$export$77477772a9b904da = (keyMap, location, analyticsEvent)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.keys(keyMap).reduce((map, key)=>({
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            ...map,
            [key]: {
                ...keyMap[key],
                callback: $91e416a701a8c178$var$wrapCallbackWithErrorHandling(key, keyMap[key].callback, location, analyticsEvent)
            }
        }), {});

});


parcelRegister("1Ck3K", function(module, exports) {
$parcel$export(module.exports, "VERSION_DETAIL_PADDING", () => $dd461f35329f6ced$export$d5ba377dea81dc7b);
$parcel$export(module.exports, "RIGHT_SIDEBAR_WIDTH", () => $dd461f35329f6ced$export$b44ab66843c05a69);
$parcel$export(module.exports, "VERSION_DESCRIPTION_MAX_NUM_BYTES", () => $dd461f35329f6ced$export$4d8870de173841bc);
// Used to manage the layout of the version details page with the right side bar component enabled
// with new Progressive Delivery features e.g. launch card, approvers, progress tracking
const $dd461f35329f6ced$export$d5ba377dea81dc7b = 24;
const $dd461f35329f6ced$export$b44ab66843c05a69 = 400 + $dd461f35329f6ced$export$d5ba377dea81dc7b * 2;
const $dd461f35329f6ced$export$4d8870de173841bc = 16384;

});

parcelRegister("jUXjl", function(module, exports) {
$parcel$export(module.exports, "messages", () => $cc195c308a849cd3$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $cc195c308a849cd3$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    resizeKeyboardShortcutLabel: {
        "id": "software-releases-version-detail.right-sidebar.resize-keyboard-shortcut-label",
        "defaultMessage": "Keyboard shortcut \"]\" which used to expand and collapse version details right sidebar"
    }
});

});

parcelRegister("g8i7y", function(module, exports) {
$parcel$export(module.exports, "ResizeButton", () => $ce4b31c6165eea5e$export$11aa56de814afc15);
$parcel$export(module.exports, "ResizeBoundary", () => $ce4b31c6165eea5e$export$e1ead9bf8a6df70f);

var $eJOHy = parcelRequire("eJOHy");

var $cQxBL = parcelRequire("cQxBL");

var $8PCRQ = parcelRequire("8PCRQ");

var $k71qx = parcelRequire("k71qx");

var $lRq8t = parcelRequire("lRq8t");


var $8zYgy = parcelRequire("8zYgy");

var $dzKGR = parcelRequire("dzKGR");
const $ce4b31c6165eea5e$export$680dc7b2ca125eea = ({ isSidebarCollapsed: isSidebarCollapsed, children: children })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const text = isSidebarCollapsed ? formatMessage((0, $8zYgy.messages).expand) : formatMessage((0, $8zYgy.messages).collapse);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dzKGR.TooltipNode), {
            text: text,
            char: "]"
        }),
        hideTooltipOnClick: true,
        position: "left"
    }, children);
};
const $ce4b31c6165eea5e$export$11aa56de814afc15 = ({ isSidebarCollapsed: isSidebarCollapsed, onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ce4b31c6165eea5e$export$680dc7b2ca125eea, {
        isSidebarCollapsed: isSidebarCollapsed
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dzKGR.StyledResizeButton), {
        "aria-expanded": isSidebarCollapsed,
        "aria-label": formatMessage((0, $8zYgy.messages).resizeButtonLabel),
        "data-component-selector": (0, $987bc9d6b3baf3fc$export$95fb8edad0b1f6f3),
        isSidebarCollapsed: isSidebarCollapsed,
        onClick: onClick,
        onMouseDown: (event)=>event.preventDefault()
    }, isSidebarCollapsed ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8PCRQ))), {
        spacing: "spacious",
        label: "",
        size: "small"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cQxBL))), {
        spacing: "spacious",
        label: "",
        size: "small"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dzKGR.ExpandedHitArea), null)));
};
const $ce4b31c6165eea5e$export$e1ead9bf8a6df70f = ({ isSidebarCollapsed: isSidebarCollapsed, onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dzKGR.ResizeBoundaryButton), {
        "aria-expanded": isSidebarCollapsed,
        "aria-label": formatMessage((0, $8zYgy.messages).resizeBoundaryLabel),
        onClick: onClick,
        onMouseDown: (event)=>event.preventDefault()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dzKGR.ResizeBoundaryGrabArea), null));
};

});
const $987bc9d6b3baf3fc$export$d44734fdf1fc9e2d = 800;
const $987bc9d6b3baf3fc$export$9542bc50a2f9f44a = 96;
const $987bc9d6b3baf3fc$export$95fb8edad0b1f6f3 = 'VersionDetailsRightSidebarResizeButton';

parcelRegister("8zYgy", function(module, exports) {
$parcel$export(module.exports, "messages", () => $96b316aad393a465$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $96b316aad393a465$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    expand: {
        "id": "software-releases-version-detail.right-sidebar.resize-control.expand",
        "defaultMessage": "Expand"
    },
    collapse: {
        "id": "software-releases-version-detail.right-sidebar.resize-control.collapse",
        "defaultMessage": "Collapse"
    },
    resizeButtonLabel: {
        "id": "software-releases-version-detail.right-sidebar.resize-control.resize-button-label",
        "defaultMessage": "Button which can be clicked to expand and collapse the version details right sidebar"
    },
    resizeBoundaryLabel: {
        "id": "software-releases-version-detail.right-sidebar.resize-control.resize-boundary-label",
        "defaultMessage": "Boundary line which can be clicked to expand and collapse the version details right sidebar"
    }
});

});

parcelRegister("dzKGR", function(module, exports) {
$parcel$export(module.exports, "TooltipNode", () => $7aed31e0596637ec$export$650cc9b24ce3a5c9);
$parcel$export(module.exports, "StyledResizeButton", () => $7aed31e0596637ec$export$eaf8b2262a594734);
$parcel$export(module.exports, "ExpandedHitArea", () => $7aed31e0596637ec$export$d1ffaae3f3b6a138);
$parcel$export(module.exports, "ResizeBoundaryButton", () => $7aed31e0596637ec$export$9d71cd59238427a7);
$parcel$export(module.exports, "ResizeBoundaryGrabArea", () => $7aed31e0596637ec$export$f4eedb955e46ab7);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $1jVV7 = parcelRequire("1jVV7");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7aed31e0596637ec$var$TooltipWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_4cvr1q9y _1e0c1txw _vwz4nqt0 _n3td1b66 _ca0q1b66",
            __cmplp.className
        ])
    });
});
const $7aed31e0596637ec$var$ShortcutWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rkolb4i _bfhk1ibz _vwz4cjiy _18u01b66 _ca0qt94y _u5f3u2gc _n3tdt94y _19bvu2gc",
            __cmplp.className
        ])
    });
});
const $7aed31e0596637ec$export$650cc9b24ce3a5c9 = ({ text: text, char: char })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($7aed31e0596637ec$var$TooltipWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("span", null, text), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($7aed31e0596637ec$var$ShortcutWrapper, null, char));
const $7aed31e0596637ec$var$buttonInteractionStyles = {
    ':hover': {
        backgroundColor: "var(--ds-background-selected-bold, #1868DB)",
        color: "var(--ds-text-inverse, #FFFFFF)",
        opacity: 1
    },
    ':active, :focus': {
        backgroundColor: "var(--ds-background-selected-bold-hovered, #1558BC)",
        color: "var(--ds-text-inverse, #FFFFFF)",
        opacity: 1,
        outline: 'none'
    }
};
const $7aed31e0596637ec$export$eaf8b2262a594734 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isSidebarCollapsed: isSidebarCollapsed, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_wim4ke": (0, $awdRS.default)((0, $1jVV7.layers).rightSidebar)
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19itidpf _2rko1rr0 _12ji1r31 _1qu2glyw _12y3idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _v564u1xf _bfhk1bhr _16qs1nax _syazazsu _80omtlke _kqswstnw _1bsb1tcg _4t3i1tcg _154ioahv _1ltvxmi2 _t9ec1i34 _1pbyader _irr3jmqp _30l315cr _16l4kb7n _1q5t1r31 _nt751r31 _1ohyglyw _49pcglyw _1r9x1o36 _1hvw1o36 _1di61q28 _jomr1q28 _9h8h15cr _f8pj15cr _1y2zkb7n _1h7hkb7n",
            __cmplp.isSidebarCollapsed ? "_tzy4kb7n" : "_tzy4idpf",
            __cmplp.className
        ])
    });
});
const $7aed31e0596637ec$export$d1ffaae3f3b6a138 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_kqswstnw _154ix0bf _1xi2xmi2 _94n5x0bf _1ltvxmi2",
            __cmplp.className
        ])
    });
});
const $7aed31e0596637ec$export$9d71cd59238427a7 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19itidpf _12ji1r31 _1qu2glyw _12y3idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _v5646cel _bfhk1l7x _80omtlke _kqswstnw _4t3i1osq _1bsbyh40 _irr3jmqp _30l315cr _16l4kb7n _1q5t1r31 _nt751r31 _1ohyglyw _49pcglyw _1r9x1o36 _1hvw1o36 _1di61q28 _jomr1q28 _9h8h15cr _f8pj15cr _1y2zkb7n _1h7hkb7n",
            __cmplp.className
        ])
    });
});
const $7aed31e0596637ec$export$f4eedb955e46ab7 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_wim4ke": (0, $awdRS.default)((0, $1jVV7.layers).rightSidebar)
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_kqswstnw _154ix0bf _1xi210v4 _94n5idpf _1ltvidpf _1pbyader",
            __cmplp.className
        ])
    });
});

});




parcelRegister("gXdnw", function(module, exports) {
$parcel$export(module.exports, "default", () => $cf30ca976d494ab0$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $cf30ca976d494ab0$var$messages = (0, $7qGN1.defineMessages)({
    releases: {
        "id": "spa-apps-software-releases-version-detail.releases",
        "defaultMessage": "Releases"
    }
});
var $cf30ca976d494ab0$export$2e2bcd8739ae039 = $cf30ca976d494ab0$var$messages;

});

parcelRegister("ggyTU", function(module, exports) {
$parcel$export(module.exports, "isNetworkError", () => $e35f7bbc1a3c8ae1$export$476aa014e2fd89d5);
const $e35f7bbc1a3c8ae1$var$ERROR_MESSAGE_CHROME = 'Failed to fetch';
const $e35f7bbc1a3c8ae1$var$ERROR_MESSAGE_FIREFOX = 'NetworkError when attempting to fetch resource.';
const $e35f7bbc1a3c8ae1$var$ERROR_MESSAGE_OTHER = 'Network request failed';
const $e35f7bbc1a3c8ae1$var$NetworkErrorMessages = new Set([
    $e35f7bbc1a3c8ae1$var$ERROR_MESSAGE_CHROME,
    $e35f7bbc1a3c8ae1$var$ERROR_MESSAGE_FIREFOX,
    $e35f7bbc1a3c8ae1$var$ERROR_MESSAGE_OTHER
]);
const $e35f7bbc1a3c8ae1$export$476aa014e2fd89d5 = (error)=>typeof error === 'object' && $e35f7bbc1a3c8ae1$var$NetworkErrorMessages.has(error.message.replace(/^Network error: (.*)/, '$1'));

});




//# sourceMappingURL=async-jira-software-version-detail.a45d2557.js.map
